
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    /*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $cc4ed71c4f27adbc$exports = {};

$parcel$export($cc4ed71c4f27adbc$exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);
$parcel$export($cc4ed71c4f27adbc$exports, "detectOverflow", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperBase", () => $60bdf67e43f5dfcb$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperLite", () => $ef991c361ca719ad$export$8f7491d57c8f97a9);
var $1472b89a65155de2$exports = {};

$parcel$export($1472b89a65155de2$exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export($1472b89a65155de2$exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export($1472b89a65155de2$exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export($1472b89a65155de2$exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export($1472b89a65155de2$exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export($1472b89a65155de2$exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export($1472b89a65155de2$exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export($1472b89a65155de2$exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export($1472b89a65155de2$exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export($1472b89a65155de2$exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export($1472b89a65155de2$exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export($1472b89a65155de2$exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export($1472b89a65155de2$exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export($1472b89a65155de2$exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export($1472b89a65155de2$exports, "beforeRead", () => $1472b89a65155de2$export$421679a7c3d56e);
$parcel$export($1472b89a65155de2$exports, "read", () => $1472b89a65155de2$export$aafa59e2e03f2942);
$parcel$export($1472b89a65155de2$exports, "afterRead", () => $1472b89a65155de2$export$6964f6c886723980);
$parcel$export($1472b89a65155de2$exports, "beforeMain", () => $1472b89a65155de2$export$c65e99957a05207c);
$parcel$export($1472b89a65155de2$exports, "main", () => $1472b89a65155de2$export$f22da7240b7add18);
$parcel$export($1472b89a65155de2$exports, "afterMain", () => $1472b89a65155de2$export$bab79516f2d662fe);
$parcel$export($1472b89a65155de2$exports, "beforeWrite", () => $1472b89a65155de2$export$8d4d2d70e7d46032);
$parcel$export($1472b89a65155de2$exports, "write", () => $1472b89a65155de2$export$68d8715fc104d294);
$parcel$export($1472b89a65155de2$exports, "afterWrite", () => $1472b89a65155de2$export$70a6e5159acce2e6);
$parcel$export($1472b89a65155de2$exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $a3382052de3d061b$exports = {};

$parcel$export($a3382052de3d061b$exports, "applyStyles", () => $7deefb3680d4558f$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "arrow", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "computeStyles", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "eventListeners", () => $e7d7845625089588$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "flip", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "hide", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "offset", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "popperOffsets", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "preventOverflow", () => $865d356b2ca960a5$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $ef991c361ca719ad$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039)
];
var $ef991c361ca719ad$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $ef991c361ca719ad$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $1472b89a65155de2$exports);
$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $a3382052de3d061b$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$elementMap = new Map();
const $e9dd36436aec3b21$var$Data = {
    set (element, key, instance) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) $e9dd36436aec3b21$var$elementMap.set(element, new Map());
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e9dd36436aec3b21$var$elementMap.has(element)) return $e9dd36436aec3b21$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) return;
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e9dd36436aec3b21$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$MAX_UID = 1000000;
const $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER = 1000;
const $e9dd36436aec3b21$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $e9dd36436aec3b21$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e9dd36436aec3b21$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e9dd36436aec3b21$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e9dd36436aec3b21$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e9dd36436aec3b21$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER;
};
const $e9dd36436aec3b21$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e9dd36436aec3b21$var$TRANSITION_END));
};
const $e9dd36436aec3b21$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $e9dd36436aec3b21$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e9dd36436aec3b21$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($e9dd36436aec3b21$var$parseSelector(object));
    return null;
};
const $e9dd36436aec3b21$var$isVisible = (element)=>{
    if (!$e9dd36436aec3b21$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e9dd36436aec3b21$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $e9dd36436aec3b21$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e9dd36436aec3b21$var$findShadowRoot(element.parentNode);
};
const $e9dd36436aec3b21$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e9dd36436aec3b21$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e9dd36436aec3b21$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $e9dd36436aec3b21$var$DOMContentLoadedCallbacks = [];
const $e9dd36436aec3b21$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$e9dd36436aec3b21$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $e9dd36436aec3b21$var$DOMContentLoadedCallbacks)callback();
        });
        $e9dd36436aec3b21$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e9dd36436aec3b21$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $e9dd36436aec3b21$var$defineJQueryPlugin = (plugin)=>{
    $e9dd36436aec3b21$var$onDOMContentLoaded(()=>{
        const $ = $e9dd36436aec3b21$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e9dd36436aec3b21$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $e9dd36436aec3b21$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e9dd36436aec3b21$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e9dd36436aec3b21$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
        $e9dd36436aec3b21$var$execute(callback);
    };
    transitionElement.addEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e9dd36436aec3b21$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e9dd36436aec3b21$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e9dd36436aec3b21$var$stripNameRegex = /\..*/;
const $e9dd36436aec3b21$var$stripUidRegex = /::\d+$/;
const $e9dd36436aec3b21$var$eventRegistry = {}; // Events storage
let $e9dd36436aec3b21$var$uidEvent = 1;
const $e9dd36436aec3b21$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $e9dd36436aec3b21$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $e9dd36436aec3b21$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e9dd36436aec3b21$var$uidEvent++}` || element.uidEvent || $e9dd36436aec3b21$var$uidEvent++;
}
function $e9dd36436aec3b21$var$getElementEvents(element) {
    const uid = $e9dd36436aec3b21$var$makeEventUid(element);
    element.uidEvent = uid;
    $e9dd36436aec3b21$var$eventRegistry[uid] = $e9dd36436aec3b21$var$eventRegistry[uid] || {};
    return $e9dd36436aec3b21$var$eventRegistry[uid];
}
function $e9dd36436aec3b21$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e9dd36436aec3b21$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e9dd36436aec3b21$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e9dd36436aec3b21$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e9dd36436aec3b21$var$getTypeEvent(originalTypeEvent);
    if (!$e9dd36436aec3b21$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e9dd36436aec3b21$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e9dd36436aec3b21$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e9dd36436aec3b21$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e9dd36436aec3b21$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e9dd36436aec3b21$var$makeEventUid(callable, originalTypeEvent.replace($e9dd36436aec3b21$var$namespaceRegex, ''));
    const fn = isDelegated ? $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, handler, callable) : $e9dd36436aec3b21$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e9dd36436aec3b21$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $e9dd36436aec3b21$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e9dd36436aec3b21$var$stripNameRegex, '');
    return $e9dd36436aec3b21$var$customEvents[event] || event;
}
const $e9dd36436aec3b21$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e9dd36436aec3b21$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e9dd36436aec3b21$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $e9dd36436aec3b21$var$getjQuery();
        const typeEvent = $e9dd36436aec3b21$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $e9dd36436aec3b21$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e9dd36436aec3b21$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e9dd36436aec3b21$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e9dd36436aec3b21$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e9dd36436aec3b21$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $e9dd36436aec3b21$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e9dd36436aec3b21$var$normalizeData(element.getAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e9dd36436aec3b21$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $e9dd36436aec3b21$var$isElement(value) ? 'element' : $e9dd36436aec3b21$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$BaseComponent extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        element = $e9dd36436aec3b21$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e9dd36436aec3b21$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e9dd36436aec3b21$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $e9dd36436aec3b21$var$Data.get($e9dd36436aec3b21$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $e9dd36436aec3b21$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$e9dd36436aec3b21$var$parseSelector(sel)).join(',') : null;
};
const $e9dd36436aec3b21$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$e9dd36436aec3b21$var$isDisabled(el) && $e9dd36436aec3b21$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        if (selector) return $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e9dd36436aec3b21$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($e9dd36436aec3b21$var$isDisabled(this)) return;
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$f = 'alert';
const $e9dd36436aec3b21$var$DATA_KEY$a = 'bs.alert';
const $e9dd36436aec3b21$var$EVENT_KEY$b = `.${$e9dd36436aec3b21$var$DATA_KEY$a}`;
const $e9dd36436aec3b21$var$EVENT_CLOSE = `close${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$EVENT_CLOSED = `closed${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$5 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$caec2af78bcc877f extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$e = 'button';
const $e9dd36436aec3b21$var$DATA_KEY$9 = 'bs.button';
const $e9dd36436aec3b21$var$EVENT_KEY$a = `.${$e9dd36436aec3b21$var$DATA_KEY$9}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$6 = '.data-api';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3 = 'active';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6 = `click${$e9dd36436aec3b21$var$EVENT_KEY$a}${$e9dd36436aec3b21$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$353f5b6fc5456de1 extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$d = 'swipe';
const $e9dd36436aec3b21$var$EVENT_KEY$9 = '.bs.swipe';
const $e9dd36436aec3b21$var$EVENT_TOUCHSTART = `touchstart${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHMOVE = `touchmove${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHEND = `touchend${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERDOWN = `pointerdown${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERUP = `pointerup${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH = 'touch';
const $e9dd36436aec3b21$var$POINTER_TYPE_PEN = 'pen';
const $e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $e9dd36436aec3b21$var$SWIPE_THRESHOLD = 40;
const $e9dd36436aec3b21$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e9dd36436aec3b21$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Swipe extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e9dd36436aec3b21$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$c;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$c;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$d;
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e9dd36436aec3b21$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e9dd36436aec3b21$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e9dd36436aec3b21$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_PEN || event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$c = 'carousel';
const $e9dd36436aec3b21$var$DATA_KEY$8 = 'bs.carousel';
const $e9dd36436aec3b21$var$EVENT_KEY$8 = `.${$e9dd36436aec3b21$var$DATA_KEY$8}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$5 = '.data-api';
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e9dd36436aec3b21$var$ORDER_NEXT = 'next';
const $e9dd36436aec3b21$var$ORDER_PREV = 'prev';
const $e9dd36436aec3b21$var$DIRECTION_LEFT = 'left';
const $e9dd36436aec3b21$var$DIRECTION_RIGHT = 'right';
const $e9dd36436aec3b21$var$EVENT_SLIDE = `slide${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_SLID = `slid${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN$1 = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1 = `mouseenter${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_DRAG_START = `dragstart${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3 = `load${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5 = `click${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL = 'carousel';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2 = 'active';
const $e9dd36436aec3b21$var$CLASS_NAME_SLIDE = 'slide';
const $e9dd36436aec3b21$var$CLASS_NAME_END = 'carousel-item-end';
const $e9dd36436aec3b21$var$CLASS_NAME_START = 'carousel-item-start';
const $e9dd36436aec3b21$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $e9dd36436aec3b21$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE = '.active';
const $e9dd36436aec3b21$var$SELECTOR_ITEM = '.carousel-item';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM = $e9dd36436aec3b21$var$SELECTOR_ACTIVE + $e9dd36436aec3b21$var$SELECTOR_ITEM;
const $e9dd36436aec3b21$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $e9dd36436aec3b21$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $e9dd36436aec3b21$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e9dd36436aec3b21$var$KEY_TO_DIRECTION = {
    [$e9dd36436aec3b21$var$ARROW_LEFT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_RIGHT,
    [$e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_LEFT
};
const $e9dd36436aec3b21$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $e9dd36436aec3b21$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$144901db2ea8e967 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$b;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$b;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$c;
    }
    // Public
    next() {
        this._slide($e9dd36436aec3b21$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e9dd36436aec3b21$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e9dd36436aec3b21$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e9dd36436aec3b21$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e9dd36436aec3b21$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM_IMG, this._element))$e9dd36436aec3b21$var$EventHandler.on(img, $e9dd36436aec3b21$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e9dd36436aec3b21$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e9dd36436aec3b21$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e9dd36436aec3b21$var$ORDER_NEXT;
        const nextElement = element || $e9dd36436aec3b21$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e9dd36436aec3b21$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e9dd36436aec3b21$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_START : $e9dd36436aec3b21$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_NEXT : $e9dd36436aec3b21$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e9dd36436aec3b21$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e9dd36436aec3b21$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e9dd36436aec3b21$var$isRTL()) return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_PREV : $e9dd36436aec3b21$var$ORDER_NEXT;
        return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e9dd36436aec3b21$var$isRTL()) return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_LEFT : $e9dd36436aec3b21$var$DIRECTION_RIGHT;
        return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_RIGHT : $e9dd36436aec3b21$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5, $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e9dd36436aec3b21$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$b = 'collapse';
const $e9dd36436aec3b21$var$DATA_KEY$7 = 'bs.collapse';
const $e9dd36436aec3b21$var$EVENT_KEY$7 = `.${$e9dd36436aec3b21$var$DATA_KEY$7}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$4 = '.data-api';
const $e9dd36436aec3b21$var$EVENT_SHOW$6 = `show${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$6 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$6 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$6 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4 = `click${$e9dd36436aec3b21$var$EVENT_KEY$7}${$e9dd36436aec3b21$var$DATA_API_KEY$4}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE = 'collapse';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE} .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE}`;
const $e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $e9dd36436aec3b21$var$WIDTH = 'width';
const $e9dd36436aec3b21$var$HEIGHT = 'height';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e9dd36436aec3b21$var$Default$a = {
    parent: null,
    toggle: true
};
const $e9dd36436aec3b21$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$78768a9af065a7b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e9dd36436aec3b21$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $e9dd36436aec3b21$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$a;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$a;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e9dd36436aec3b21$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL) ? $e9dd36436aec3b21$var$WIDTH : $e9dd36436aec3b21$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.getMultipleElementsFromSelector(this))$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$a = 'dropdown';
const $e9dd36436aec3b21$var$DATA_KEY$6 = 'bs.dropdown';
const $e9dd36436aec3b21$var$EVENT_KEY$6 = `.${$e9dd36436aec3b21$var$DATA_KEY$6}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$3 = '.data-api';
const $e9dd36436aec3b21$var$ESCAPE_KEY$2 = 'Escape';
const $e9dd36436aec3b21$var$TAB_KEY$1 = 'Tab';
const $e9dd36436aec3b21$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e9dd36436aec3b21$var$EVENT_HIDE$5 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$5 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$5 = `show${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$5 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3 = `click${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API = `keyup${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$6 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP = 'dropup';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPEND = 'dropend';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPSTART = 'dropstart';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3}.${$e9dd36436aec3b21$var$CLASS_NAME_SHOW$6}`;
const $e9dd36436aec3b21$var$SELECTOR_MENU = '.dropdown-menu';
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR = '.navbar';
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$PLACEMENT_TOP = $e9dd36436aec3b21$var$isRTL() ? 'top-end' : 'top-start';
const $e9dd36436aec3b21$var$PLACEMENT_TOPEND = $e9dd36436aec3b21$var$isRTL() ? 'top-start' : 'top-end';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOM = $e9dd36436aec3b21$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND = $e9dd36436aec3b21$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $e9dd36436aec3b21$var$PLACEMENT_RIGHT = $e9dd36436aec3b21$var$isRTL() ? 'left-start' : 'right-start';
const $e9dd36436aec3b21$var$PLACEMENT_LEFT = $e9dd36436aec3b21$var$isRTL() ? 'right-start' : 'left-start';
const $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER = 'top';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $e9dd36436aec3b21$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $e9dd36436aec3b21$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$931cbfb6bfb85fc extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $e9dd36436aec3b21$var$SelectorEngine.next(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.prev(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$9;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$9;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$e9dd36436aec3b21$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e9dd36436aec3b21$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $cc4ed71c4f27adbc$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($e9dd36436aec3b21$var$isElement(this._config.reference)) referenceElement = $e9dd36436aec3b21$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $cc4ed71c4f27adbc$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPEND)) return $e9dd36436aec3b21$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPSTART)) return $e9dd36436aec3b21$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP)) return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_TOPEND : $e9dd36436aec3b21$var$PLACEMENT_TOP;
        return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND : $e9dd36436aec3b21$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $e9dd36436aec3b21$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e9dd36436aec3b21$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e9dd36436aec3b21$var$getNextActiveElement(items, target, key === $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $e9dd36436aec3b21$var$TAB_KEY$1) return;
        const openToggles = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $e9dd36436aec3b21$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e9dd36436aec3b21$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e9dd36436aec3b21$var$ARROW_UP_KEY$1,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3) ? this : $e9dd36436aec3b21$var$SelectorEngine.prev(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.next(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_MENU, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$9 = 'backdrop';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$4 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$5 = 'show';
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e9dd36436aec3b21$var$NAME$9}`;
const $e9dd36436aec3b21$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $e9dd36436aec3b21$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Backdrop extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$8;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$8;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e9dd36436aec3b21$var$reflow(element);
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e9dd36436aec3b21$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e9dd36436aec3b21$var$EventHandler.on(element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN, ()=>{
            $e9dd36436aec3b21$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$8 = 'focustrap';
const $e9dd36436aec3b21$var$DATA_KEY$5 = 'bs.focustrap';
const $e9dd36436aec3b21$var$EVENT_KEY$5 = `.${$e9dd36436aec3b21$var$DATA_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$2 = `focusin${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$TAB_KEY = 'Tab';
const $e9dd36436aec3b21$var$TAB_NAV_FORWARD = 'forward';
const $e9dd36436aec3b21$var$TAB_NAV_BACKWARD = 'backward';
const $e9dd36436aec3b21$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e9dd36436aec3b21$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$FocusTrap extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$7;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$7;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5); // guard against infinite focus loop
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e9dd36436aec3b21$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e9dd36436aec3b21$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e9dd36436aec3b21$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e9dd36436aec3b21$var$TAB_NAV_BACKWARD : $e9dd36436aec3b21$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $e9dd36436aec3b21$var$PROPERTY_PADDING = 'padding-right';
const $e9dd36436aec3b21$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e9dd36436aec3b21$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e9dd36436aec3b21$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$7 = 'modal';
const $e9dd36436aec3b21$var$DATA_KEY$4 = 'bs.modal';
const $e9dd36436aec3b21$var$EVENT_KEY$4 = `.${$e9dd36436aec3b21$var$DATA_KEY$4}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$2 = '.data-api';
const $e9dd36436aec3b21$var$ESCAPE_KEY$1 = 'Escape';
const $e9dd36436aec3b21$var$EVENT_HIDE$4 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$4 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$4 = `show${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$4 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE$1 = `resize${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS = `click.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2 = `click${$e9dd36436aec3b21$var$EVENT_KEY$4}${$e9dd36436aec3b21$var$DATA_API_KEY$2}`;
const $e9dd36436aec3b21$var$CLASS_NAME_OPEN = 'modal-open';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$3 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$4 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_STATIC = 'modal-static';
const $e9dd36436aec3b21$var$OPEN_SELECTOR$1 = '.modal.show';
const $e9dd36436aec3b21$var$SELECTOR_DIALOG = '.modal-dialog';
const $e9dd36436aec3b21$var$SELECTOR_MODAL_BODY = '.modal-body';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e9dd36436aec3b21$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e9dd36436aec3b21$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$2b77a92f1a5ad772 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e9dd36436aec3b21$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$6;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$6;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(window, $e9dd36436aec3b21$var$EVENT_KEY$4);
        $e9dd36436aec3b21$var$EventHandler.off(this._dialog, $e9dd36436aec3b21$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $e9dd36436aec3b21$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$4, ()=>{
            if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$6 = 'offcanvas';
const $e9dd36436aec3b21$var$DATA_KEY$3 = 'bs.offcanvas';
const $e9dd36436aec3b21$var$EVENT_KEY$3 = `.${$e9dd36436aec3b21$var$DATA_KEY$3}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$1 = '.data-api';
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2 = `load${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$ESCAPE_KEY = 'Escape';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$3 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1 = 'showing';
const $e9dd36436aec3b21$var$CLASS_NAME_HIDING = 'hiding';
const $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $e9dd36436aec3b21$var$OPEN_SELECTOR = '.offcanvas.show';
const $e9dd36436aec3b21$var$EVENT_SHOW$3 = `show${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$3 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$3 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$3 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE = `resize${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1 = `click${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e9dd36436aec3b21$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e9dd36436aec3b21$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$591ca0244c9dfcd4 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$5;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$5;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3, $e9dd36436aec3b21$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e9dd36436aec3b21$var$Backdrop({
            className: $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e9dd36436aec3b21$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$OPEN_SELECTOR))$e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $e9dd36436aec3b21$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $e9dd36436aec3b21$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $e9dd36436aec3b21$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $e9dd36436aec3b21$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e9dd36436aec3b21$var$uriAttributes.has(attributeName)) return Boolean($e9dd36436aec3b21$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $e9dd36436aec3b21$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e9dd36436aec3b21$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$5 = 'TemplateFactory';
const $e9dd36436aec3b21$var$Default$4 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $e9dd36436aec3b21$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $e9dd36436aec3b21$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$TemplateFactory extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$4;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$4;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e9dd36436aec3b21$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e9dd36436aec3b21$var$isElement(content)) {
            this._putElementInTemplate($e9dd36436aec3b21$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e9dd36436aec3b21$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$4 = 'tooltip';
const $e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$2 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_MODAL = 'modal';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2 = 'show';
const $e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $e9dd36436aec3b21$var$SELECTOR_MODAL = `.${$e9dd36436aec3b21$var$CLASS_NAME_MODAL}`;
const $e9dd36436aec3b21$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $e9dd36436aec3b21$var$TRIGGER_HOVER = 'hover';
const $e9dd36436aec3b21$var$TRIGGER_FOCUS = 'focus';
const $e9dd36436aec3b21$var$TRIGGER_CLICK = 'click';
const $e9dd36436aec3b21$var$TRIGGER_MANUAL = 'manual';
const $e9dd36436aec3b21$var$EVENT_HIDE$2 = 'hide';
const $e9dd36436aec3b21$var$EVENT_HIDDEN$2 = 'hidden';
const $e9dd36436aec3b21$var$EVENT_SHOW$2 = 'show';
const $e9dd36436aec3b21$var$EVENT_SHOWN$2 = 'shown';
const $e9dd36436aec3b21$var$EVENT_INSERTED = 'inserted';
const $e9dd36436aec3b21$var$EVENT_CLICK$1 = 'click';
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$1 = 'focusin';
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT$1 = 'focusout';
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER = 'mouseenter';
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE = 'mouseleave';
const $e9dd36436aec3b21$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $e9dd36436aec3b21$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $e9dd36436aec3b21$var$isRTL() ? 'right' : 'left'
};
const $e9dd36436aec3b21$var$Default$3 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $e9dd36436aec3b21$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$28c660c63b792dea extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        if (typeof $cc4ed71c4f27adbc$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$3;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$3;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e9dd36436aec3b21$var$EventHandler.off(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOW$2));
        const shadowRoot = $e9dd36436aec3b21$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        const complete = ()=>{
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_FADE$2, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e9dd36436aec3b21$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e9dd36436aec3b21$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $e9dd36436aec3b21$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $e9dd36436aec3b21$var$AttachmentMap[placement.toUpperCase()];
        return $cc4ed71c4f27adbc$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $e9dd36436aec3b21$var$EventHandler.on(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $e9dd36436aec3b21$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSEENTER) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSOUT$1);
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e9dd36436aec3b21$var$EventHandler.on(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e9dd36436aec3b21$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e9dd36436aec3b21$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$3 = 'popover';
const $e9dd36436aec3b21$var$SELECTOR_TITLE = '.popover-header';
const $e9dd36436aec3b21$var$SELECTOR_CONTENT = '.popover-body';
const $e9dd36436aec3b21$var$Default$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $e9dd36436aec3b21$var$DefaultType$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$5b6b19405a83ff9d extends $e9dd36436aec3b21$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$2;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$2;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TITLE]: this._getTitle(),
            [$e9dd36436aec3b21$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$2 = 'scrollspy';
const $e9dd36436aec3b21$var$DATA_KEY$2 = 'bs.scrollspy';
const $e9dd36436aec3b21$var$EVENT_KEY$2 = `.${$e9dd36436aec3b21$var$DATA_KEY$2}`;
const $e9dd36436aec3b21$var$DATA_API_KEY = '.data-api';
const $e9dd36436aec3b21$var$EVENT_ACTIVATE = `activate${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_CLICK = `click${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1 = `load${$e9dd36436aec3b21$var$EVENT_KEY$2}${$e9dd36436aec3b21$var$DATA_API_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1 = 'active';
const $e9dd36436aec3b21$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS = '[href]';
const $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $e9dd36436aec3b21$var$SELECTOR_NAV_LINKS = '.nav-link';
const $e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS = `${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS} > ${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS}`;
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN = '.dropdown';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $e9dd36436aec3b21$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e9dd36436aec3b21$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$a6472a5298a374be extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$1;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$1;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e9dd36436aec3b21$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $e9dd36436aec3b21$var$EventHandler.off(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK);
        $e9dd36436aec3b21$var$EventHandler.on(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK, $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e9dd36436aec3b21$var$isDisabled(anchor)) continue;
            const observableSection = $e9dd36436aec3b21$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($e9dd36436aec3b21$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e9dd36436aec3b21$var$SELECTOR_DROPDOWN)).classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e9dd36436aec3b21$var$SelectorEngine.parents(target, $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e9dd36436aec3b21$var$SelectorEngine.prev(listGroup, $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS))item.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e9dd36436aec3b21$var$SelectorEngine.find(`${$e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS}.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_SPY))$e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$1 = 'tab';
const $e9dd36436aec3b21$var$DATA_KEY$1 = 'bs.tab';
const $e9dd36436aec3b21$var$EVENT_KEY$1 = `.${$e9dd36436aec3b21$var$DATA_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$1 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$1 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$1 = `show${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$1 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API = `click${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API = `load${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $e9dd36436aec3b21$var$ARROW_UP_KEY = 'ArrowUp';
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY = 'ArrowDown';
const $e9dd36436aec3b21$var$HOME_KEY = 'Home';
const $e9dd36436aec3b21$var$END_KEY = 'End';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE = 'active';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$1 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1 = 'show';
const $e9dd36436aec3b21$var$CLASS_DROPDOWN = 'dropdown';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $e9dd36436aec3b21$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e9dd36436aec3b21$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $e9dd36436aec3b21$var$SELECTOR_INNER = `.nav-link${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $e9dd36436aec3b21$var$SELECTOR_INNER_ELEM = `${$e9dd36436aec3b21$var$SELECTOR_INNER}, ${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$3e41faf802a29e71 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e9dd36436aec3b21$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e9dd36436aec3b21$var$EventHandler.trigger(active, $e9dd36436aec3b21$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(innerElem, $e9dd36436aec3b21$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        this._activate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e9dd36436aec3b21$var$ARROW_LEFT_KEY,
            $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
            $e9dd36436aec3b21$var$ARROW_UP_KEY,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY,
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$e9dd36436aec3b21$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $e9dd36436aec3b21$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
                $e9dd36436aec3b21$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $e9dd36436aec3b21$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e9dd36436aec3b21$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE, $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM) ? elem : $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($e9dd36436aec3b21$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME = 'toast';
const $e9dd36436aec3b21$var$DATA_KEY = 'bs.toast';
const $e9dd36436aec3b21$var$EVENT_KEY = `.${$e9dd36436aec3b21$var$DATA_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOVER = `mouseover${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOUT = `mouseout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN = `focusin${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT = `focusout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDE = `hide${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN = `hidden${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOW = `show${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN = `shown${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING = 'showing';
const $e9dd36436aec3b21$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $e9dd36436aec3b21$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$8d8dc7d5f743331b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME;
    }
    // Public
    show() {
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW, $e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING, $e9dd36436aec3b21$var$CLASS_NAME_SHOW);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$8d8dc7d5f743331b);


function $aec35899a3c9695e$var$tb(t) {
    return Object.keys(t).reduce((r, i)=>{
        const a = t[i];
        return r[i] = Object.assign({}, a), $aec35899a3c9695e$var$Uf(a.value) && !$aec35899a3c9695e$var$ab(a.value) && !Array.isArray(a.value) && (r[i].value = Object.assign({}, a.value)), Array.isArray(a.value) && (r[i].value = a.value.slice(0)), r;
    }, {});
}
function $aec35899a3c9695e$var$rb(t) {
    return t ? Object.keys(t).reduce((r, i)=>{
        const a = t[i];
        return r[i] = $aec35899a3c9695e$var$Uf(a) && "value" in a ? a : {
            value: a
        }, r[i].attribute || (r[i].attribute = $aec35899a3c9695e$var$sb(i)), r[i].parse = "parse" in r[i] ? r[i].parse : typeof r[i].value != "string", r;
    }, {}) : {};
}
function $aec35899a3c9695e$var$ib(t) {
    return Object.keys(t).reduce((r, i)=>(r[i] = t[i].value, r), {});
}
function $aec35899a3c9695e$var$nb(t, e) {
    const r = $aec35899a3c9695e$var$tb(e);
    return Object.keys(e).forEach((a)=>{
        const c = r[a], h = t.getAttribute(c.attribute), m = t[a];
        h != null && (c.value = c.parse ? $aec35899a3c9695e$var$If(h) : h), m != null && (c.value = Array.isArray(m) ? m.slice(0) : m), c.reflect && $aec35899a3c9695e$var$_d(t, c.attribute, c.value, !!c.parse), Object.defineProperty(t, a, {
            get () {
                return c.value;
            },
            set (p) {
                const y = c.value;
                c.value = p, c.reflect && $aec35899a3c9695e$var$_d(this, c.attribute, c.value, !!c.parse);
                for(let d = 0, v = this.__propertyChangedCallbacks.length; d < v; d++)this.__propertyChangedCallbacks[d](a, p, y);
            },
            enumerable: !0,
            configurable: !0
        });
    }), r;
}
function $aec35899a3c9695e$var$If(t) {
    if (t) try {
        return JSON.parse(t);
    } catch  {
        return t;
    }
}
function $aec35899a3c9695e$var$_d(t, e, r, i) {
    if (r == null || r === !1) return t.removeAttribute(e);
    let a = i ? JSON.stringify(r) : r;
    t.__updating[e] = !0, a === "true" && (a = ""), t.setAttribute(e, a), Promise.resolve().then(()=>delete t.__updating[e]);
}
function $aec35899a3c9695e$var$sb(t) {
    return t.replace(/\.?([A-Z]+)/g, (e, r)=>"-" + r.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function $aec35899a3c9695e$var$Uf(t) {
    return t != null && (typeof t == "object" || typeof t == "function");
}
function $aec35899a3c9695e$var$ab(t) {
    return Object.prototype.toString.call(t) === "[object Function]";
}
function $aec35899a3c9695e$var$ob(t) {
    return typeof t == "function" && t.toString().indexOf("class") === 0;
}
let $aec35899a3c9695e$var$ac;
function $aec35899a3c9695e$var$lb(t, e) {
    const r = Object.keys(e);
    return class extends t {
        static get observedAttributes() {
            return r.map((a)=>e[a].attribute);
        }
        constructor(){
            super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
        }
        connectedCallback() {
            if (this.__initialized) return;
            this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = $aec35899a3c9695e$var$nb(this, e);
            const a = $aec35899a3c9695e$var$ib(this.props), c = this.Component, h = $aec35899a3c9695e$var$ac;
            try {
                $aec35899a3c9695e$var$ac = this, this.__initialized = !0, $aec35899a3c9695e$var$ob(c) ? new c(a, {
                    element: this
                }) : c(a, {
                    element: this
                });
            } finally{
                $aec35899a3c9695e$var$ac = h;
            }
        }
        async disconnectedCallback() {
            if (await Promise.resolve(), this.isConnected) return;
            this.__propertyChangedCallbacks.length = 0;
            let a = null;
            for(; a = this.__releaseCallbacks.pop();)a(this);
            delete this.__initialized, this.__released = !0;
        }
        attributeChangedCallback(a, c, h) {
            if (this.__initialized && !this.__updating[a] && (a = this.lookupProp(a), a in e)) {
                if (h == null && !this[a]) return;
                this[a] = e[a].parse ? $aec35899a3c9695e$var$If(h) : h;
            }
        }
        lookupProp(a) {
            if (e) return r.find((c)=>a === c || a === e[c].attribute);
        }
        get renderRoot() {
            return this.shadowRoot || this.attachShadow({
                mode: "open"
            });
        }
        addReleaseCallback(a) {
            this.__releaseCallbacks.push(a);
        }
        addPropertyChangedCallback(a) {
            this.__propertyChangedCallbacks.push(a);
        }
    };
}
function $aec35899a3c9695e$var$ub(t, e = {}, r = {}) {
    const { BaseElement: i = HTMLElement, extension: a, customElements: c = window.customElements } = r;
    return (h)=>{
        let m = c.get(t);
        return m ? (m.prototype.Component = h, m) : (m = $aec35899a3c9695e$var$lb(i, $aec35899a3c9695e$var$rb(e)), m.prototype.Component = h, m.prototype.registeredTag = t, c.define(t, m, a), m);
    };
}
const $aec35899a3c9695e$var$cb = (t, e)=>t === e, $aec35899a3c9695e$var$Rc = Symbol("solid-proxy"), $aec35899a3c9695e$var$db = typeof Proxy == "function", $aec35899a3c9695e$var$ou = {
    equals: $aec35899a3c9695e$var$cb
};
let $aec35899a3c9695e$var$Of = $aec35899a3c9695e$var$jf;
const $aec35899a3c9695e$var$vn = 1, $aec35899a3c9695e$var$lu = 2, $aec35899a3c9695e$var$Kf = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
var $aec35899a3c9695e$var$sr = null;
let $aec35899a3c9695e$var$oc = null, $aec35899a3c9695e$var$fb = null, $aec35899a3c9695e$var$Tt = null, $aec35899a3c9695e$var$Qt = null, $aec35899a3c9695e$var$Oi = null, $aec35899a3c9695e$var$Lu = 0;
function $aec35899a3c9695e$var$pb(t, e) {
    const r = $aec35899a3c9695e$var$Tt, i = $aec35899a3c9695e$var$sr, a = t.length === 0, c = e === void 0 ? i : e, h = a ? $aec35899a3c9695e$var$Kf : {
        owned: null,
        cleanups: null,
        context: c ? c.context : null,
        owner: c
    }, m = a ? t : ()=>t(()=>$aec35899a3c9695e$var$Ra(()=>$aec35899a3c9695e$var$oa(h)));
    $aec35899a3c9695e$var$sr = h, $aec35899a3c9695e$var$Tt = null;
    try {
        return $aec35899a3c9695e$var$_a(m, !0);
    } finally{
        $aec35899a3c9695e$var$Tt = r, $aec35899a3c9695e$var$sr = i;
    }
}
function $aec35899a3c9695e$var$ia(t, e) {
    e = e ? Object.assign({}, $aec35899a3c9695e$var$ou, e) : $aec35899a3c9695e$var$ou;
    const r = {
        value: t,
        observers: null,
        observerSlots: null,
        comparator: e.equals || void 0
    }, i = (a)=>(typeof a == "function" && (a = a(r.value)), $aec35899a3c9695e$var$Vf(r, a));
    return [
        $aec35899a3c9695e$var$Nf.bind(r),
        i
    ];
}
function $aec35899a3c9695e$var$Er(t, e, r) {
    const i = $aec35899a3c9695e$var$Pc(t, e, !1, $aec35899a3c9695e$var$vn);
    $aec35899a3c9695e$var$Aa(i);
}
function $aec35899a3c9695e$var$Mf(t, e, r) {
    $aec35899a3c9695e$var$Of = $aec35899a3c9695e$var$bb;
    const i = $aec35899a3c9695e$var$Pc(t, e, !1, $aec35899a3c9695e$var$vn);
    i.user = !0, $aec35899a3c9695e$var$Oi ? $aec35899a3c9695e$var$Oi.push(i) : $aec35899a3c9695e$var$Aa(i);
}
function $aec35899a3c9695e$var$Kr(t, e, r) {
    r = r ? Object.assign({}, $aec35899a3c9695e$var$ou, r) : $aec35899a3c9695e$var$ou;
    const i = $aec35899a3c9695e$var$Pc(t, e, !0, 0);
    return i.observers = null, i.observerSlots = null, i.comparator = r.equals || void 0, $aec35899a3c9695e$var$Aa(i), $aec35899a3c9695e$var$Nf.bind(i);
}
function $aec35899a3c9695e$var$Ra(t) {
    if ($aec35899a3c9695e$var$Tt === null) return t();
    const e = $aec35899a3c9695e$var$Tt;
    $aec35899a3c9695e$var$Tt = null;
    try {
        return t();
    } finally{
        $aec35899a3c9695e$var$Tt = e;
    }
}
function $aec35899a3c9695e$var$hb(t) {
    $aec35899a3c9695e$var$Mf(()=>$aec35899a3c9695e$var$Ra(t));
}
function $aec35899a3c9695e$var$Nf() {
    if (this.sources && this.state) {
        if (this.state === $aec35899a3c9695e$var$vn) $aec35899a3c9695e$var$Aa(this);
        else {
            const t = $aec35899a3c9695e$var$Qt;
            $aec35899a3c9695e$var$Qt = null, $aec35899a3c9695e$var$_a(()=>$aec35899a3c9695e$var$cu(this), !1), $aec35899a3c9695e$var$Qt = t;
        }
    }
    if ($aec35899a3c9695e$var$Tt) {
        const t = this.observers ? this.observers.length : 0;
        $aec35899a3c9695e$var$Tt.sources ? ($aec35899a3c9695e$var$Tt.sources.push(this), $aec35899a3c9695e$var$Tt.sourceSlots.push(t)) : ($aec35899a3c9695e$var$Tt.sources = [
            this
        ], $aec35899a3c9695e$var$Tt.sourceSlots = [
            t
        ]), this.observers ? (this.observers.push($aec35899a3c9695e$var$Tt), this.observerSlots.push($aec35899a3c9695e$var$Tt.sources.length - 1)) : (this.observers = [
            $aec35899a3c9695e$var$Tt
        ], this.observerSlots = [
            $aec35899a3c9695e$var$Tt.sources.length - 1
        ]);
    }
    return this.value;
}
function $aec35899a3c9695e$var$Vf(t, e, r) {
    let i = t.value;
    return (!t.comparator || !t.comparator(i, e)) && (t.value = e, t.observers && t.observers.length && $aec35899a3c9695e$var$_a(()=>{
        for(let a = 0; a < t.observers.length; a += 1){
            const c = t.observers[a], h = $aec35899a3c9695e$var$oc && $aec35899a3c9695e$var$oc.running;
            h && $aec35899a3c9695e$var$oc.disposed.has(c), (h ? !c.tState : !c.state) && (c.pure ? $aec35899a3c9695e$var$Qt.push(c) : $aec35899a3c9695e$var$Oi.push(c), c.observers && $aec35899a3c9695e$var$Ff(c)), h || (c.state = $aec35899a3c9695e$var$vn);
        }
        if ($aec35899a3c9695e$var$Qt.length > 1e6) throw $aec35899a3c9695e$var$Qt = [], new Error();
    }, !1)), e;
}
function $aec35899a3c9695e$var$Aa(t) {
    if (!t.fn) return;
    $aec35899a3c9695e$var$oa(t);
    const e = $aec35899a3c9695e$var$Lu;
    $aec35899a3c9695e$var$mb(t, t.value, e);
}
function $aec35899a3c9695e$var$mb(t, e, r) {
    let i;
    const a = $aec35899a3c9695e$var$sr, c = $aec35899a3c9695e$var$Tt;
    $aec35899a3c9695e$var$Tt = $aec35899a3c9695e$var$sr = t;
    try {
        i = t.fn(e);
    } catch (h) {
        return t.pure && (t.state = $aec35899a3c9695e$var$vn, t.owned && t.owned.forEach($aec35899a3c9695e$var$oa), t.owned = null), t.updatedAt = r + 1, $aec35899a3c9695e$var$$f(h);
    } finally{
        $aec35899a3c9695e$var$Tt = c, $aec35899a3c9695e$var$sr = a;
    }
    (!t.updatedAt || t.updatedAt <= r) && (t.updatedAt != null && "observers" in t ? $aec35899a3c9695e$var$Vf(t, i) : t.value = i, t.updatedAt = r);
}
function $aec35899a3c9695e$var$Pc(t, e, r, i = $aec35899a3c9695e$var$vn, a) {
    const c = {
        fn: t,
        state: i,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: e,
        owner: $aec35899a3c9695e$var$sr,
        context: $aec35899a3c9695e$var$sr ? $aec35899a3c9695e$var$sr.context : null,
        pure: r
    };
    return $aec35899a3c9695e$var$sr === null || $aec35899a3c9695e$var$sr !== $aec35899a3c9695e$var$Kf && ($aec35899a3c9695e$var$sr.owned ? $aec35899a3c9695e$var$sr.owned.push(c) : $aec35899a3c9695e$var$sr.owned = [
        c
    ]), c;
}
function $aec35899a3c9695e$var$uu(t) {
    if (t.state === 0) return;
    if (t.state === $aec35899a3c9695e$var$lu) return $aec35899a3c9695e$var$cu(t);
    if (t.suspense && $aec35899a3c9695e$var$Ra(t.suspense.inFallback)) return t.suspense.effects.push(t);
    const e = [
        t
    ];
    for(; (t = t.owner) && (!t.updatedAt || t.updatedAt < $aec35899a3c9695e$var$Lu);)t.state && e.push(t);
    for(let r = e.length - 1; r >= 0; r--)if (t = e[r], t.state === $aec35899a3c9695e$var$vn) $aec35899a3c9695e$var$Aa(t);
    else if (t.state === $aec35899a3c9695e$var$lu) {
        const i = $aec35899a3c9695e$var$Qt;
        $aec35899a3c9695e$var$Qt = null, $aec35899a3c9695e$var$_a(()=>$aec35899a3c9695e$var$cu(t, e[0]), !1), $aec35899a3c9695e$var$Qt = i;
    }
}
function $aec35899a3c9695e$var$_a(t, e) {
    if ($aec35899a3c9695e$var$Qt) return t();
    let r = !1;
    e || ($aec35899a3c9695e$var$Qt = []), $aec35899a3c9695e$var$Oi ? r = !0 : $aec35899a3c9695e$var$Oi = [], $aec35899a3c9695e$var$Lu++;
    try {
        const i = t();
        return $aec35899a3c9695e$var$yb(r), i;
    } catch (i) {
        r || ($aec35899a3c9695e$var$Oi = null), $aec35899a3c9695e$var$Qt = null, $aec35899a3c9695e$var$$f(i);
    }
}
function $aec35899a3c9695e$var$yb(t) {
    if ($aec35899a3c9695e$var$Qt && ($aec35899a3c9695e$var$jf($aec35899a3c9695e$var$Qt), $aec35899a3c9695e$var$Qt = null), t) return;
    const e = $aec35899a3c9695e$var$Oi;
    $aec35899a3c9695e$var$Oi = null, e.length && $aec35899a3c9695e$var$_a(()=>$aec35899a3c9695e$var$Of(e), !1);
}
function $aec35899a3c9695e$var$jf(t) {
    for(let e = 0; e < t.length; e++)$aec35899a3c9695e$var$uu(t[e]);
}
function $aec35899a3c9695e$var$bb(t) {
    let e, r = 0;
    for(e = 0; e < t.length; e++){
        const i = t[e];
        i.user ? t[r++] = i : $aec35899a3c9695e$var$uu(i);
    }
    for(e = 0; e < r; e++)$aec35899a3c9695e$var$uu(t[e]);
}
function $aec35899a3c9695e$var$cu(t, e) {
    t.state = 0;
    for(let r = 0; r < t.sources.length; r += 1){
        const i = t.sources[r];
        if (i.sources) {
            const a = i.state;
            a === $aec35899a3c9695e$var$vn ? i !== e && (!i.updatedAt || i.updatedAt < $aec35899a3c9695e$var$Lu) && $aec35899a3c9695e$var$uu(i) : a === $aec35899a3c9695e$var$lu && $aec35899a3c9695e$var$cu(i, e);
        }
    }
}
function $aec35899a3c9695e$var$Ff(t) {
    for(let e = 0; e < t.observers.length; e += 1){
        const r = t.observers[e];
        r.state || (r.state = $aec35899a3c9695e$var$lu, r.pure ? $aec35899a3c9695e$var$Qt.push(r) : $aec35899a3c9695e$var$Oi.push(r), r.observers && $aec35899a3c9695e$var$Ff(r));
    }
}
function $aec35899a3c9695e$var$oa(t) {
    let e;
    if (t.sources) for(; t.sources.length;){
        const r = t.sources.pop(), i = t.sourceSlots.pop(), a = r.observers;
        if (a && a.length) {
            const c = a.pop(), h = r.observerSlots.pop();
            i < a.length && (c.sourceSlots[h] = i, a[i] = c, r.observerSlots[i] = h);
        }
    }
    if (t.tOwned) {
        for(e = t.tOwned.length - 1; e >= 0; e--)$aec35899a3c9695e$var$oa(t.tOwned[e]);
        delete t.tOwned;
    }
    if (t.owned) {
        for(e = t.owned.length - 1; e >= 0; e--)$aec35899a3c9695e$var$oa(t.owned[e]);
        t.owned = null;
    }
    if (t.cleanups) {
        for(e = t.cleanups.length - 1; e >= 0; e--)t.cleanups[e]();
        t.cleanups = null;
    }
    t.state = 0;
}
function $aec35899a3c9695e$var$gb(t) {
    return t instanceof Error ? t : new Error(typeof t == "string" ? t : "Unknown error", {
        cause: t
    });
}
function $aec35899a3c9695e$var$$f(t, e = $aec35899a3c9695e$var$sr) {
    throw $aec35899a3c9695e$var$gb(t);
}
function $aec35899a3c9695e$var$Gf(t, e) {
    return $aec35899a3c9695e$var$Ra(()=>t(e || {}));
}
function $aec35899a3c9695e$var$Yl() {
    return !0;
}
const $aec35899a3c9695e$var$xb = {
    get (t, e, r) {
        return e === $aec35899a3c9695e$var$Rc ? r : t.get(e);
    },
    has (t, e) {
        return e === $aec35899a3c9695e$var$Rc ? !0 : t.has(e);
    },
    set: $aec35899a3c9695e$var$Yl,
    deleteProperty: $aec35899a3c9695e$var$Yl,
    getOwnPropertyDescriptor (t, e) {
        return {
            configurable: !0,
            enumerable: !0,
            get () {
                return t.get(e);
            },
            set: $aec35899a3c9695e$var$Yl,
            deleteProperty: $aec35899a3c9695e$var$Yl
        };
    },
    ownKeys (t) {
        return t.keys();
    }
};
function $aec35899a3c9695e$var$lc(t) {
    return (t = typeof t == "function" ? t() : t) ? t : {};
}
function $aec35899a3c9695e$var$Eb() {
    for(let t = 0, e = this.length; t < e; ++t){
        const r = this[t]();
        if (r !== void 0) return r;
    }
}
function $aec35899a3c9695e$var$vb(...t) {
    let e = !1;
    for(let h = 0; h < t.length; h++){
        const m = t[h];
        e = e || !!m && $aec35899a3c9695e$var$Rc in m, t[h] = typeof m == "function" ? (e = !0, $aec35899a3c9695e$var$Kr(m)) : m;
    }
    if ($aec35899a3c9695e$var$db && e) return new Proxy({
        get (h) {
            for(let m = t.length - 1; m >= 0; m--){
                const p = $aec35899a3c9695e$var$lc(t[m])[h];
                if (p !== void 0) return p;
            }
        },
        has (h) {
            for(let m = t.length - 1; m >= 0; m--)if (h in $aec35899a3c9695e$var$lc(t[m])) return !0;
            return !1;
        },
        keys () {
            const h = [];
            for(let m = 0; m < t.length; m++)h.push(...Object.keys($aec35899a3c9695e$var$lc(t[m])));
            return [
                ...new Set(h)
            ];
        }
    }, $aec35899a3c9695e$var$xb);
    const r = {}, i = /* @__PURE__ */ Object.create(null);
    for(let h = t.length - 1; h >= 0; h--){
        const m = t[h];
        if (!m) continue;
        const p = Object.getOwnPropertyNames(m);
        for(let y = p.length - 1; y >= 0; y--){
            const d = p[y];
            if (d === "__proto__" || d === "constructor") continue;
            const v = Object.getOwnPropertyDescriptor(m, d);
            if (!i[d]) i[d] = v.get ? {
                enumerable: !0,
                configurable: !0,
                get: $aec35899a3c9695e$var$Eb.bind(r[d] = [
                    v.get.bind(m)
                ])
            } : v.value !== void 0 ? v : void 0;
            else {
                const P = r[d];
                P && (v.get ? P.push(v.get.bind(m)) : v.value !== void 0 && P.push(()=>v.value));
            }
        }
    }
    const a = {}, c = Object.keys(i);
    for(let h = c.length - 1; h >= 0; h--){
        const m = c[h], p = i[m];
        p && p.get ? Object.defineProperty(a, m, p) : a[m] = p ? p.value : void 0;
    }
    return a;
}
function $aec35899a3c9695e$var$Rb(t, e, r) {
    let i = r.length, a = e.length, c = i, h = 0, m = 0, p = e[a - 1].nextSibling, y = null;
    for(; h < a || m < c;){
        if (e[h] === r[m]) {
            h++, m++;
            continue;
        }
        for(; e[a - 1] === r[c - 1];)a--, c--;
        if (a === h) {
            const d = c < i ? m ? r[m - 1].nextSibling : r[c - m] : p;
            for(; m < c;)t.insertBefore(r[m++], d);
        } else if (c === m) for(; h < a;)(!y || !y.has(e[h])) && e[h].remove(), h++;
        else if (e[h] === r[c - 1] && r[m] === e[a - 1]) {
            const d = e[--a].nextSibling;
            t.insertBefore(r[m++], e[h++].nextSibling), t.insertBefore(r[--c], d), e[a] = r[c];
        } else {
            if (!y) {
                y = /* @__PURE__ */ new Map();
                let v = m;
                for(; v < c;)y.set(r[v], v++);
            }
            const d = y.get(e[h]);
            if (d != null) {
                if (m < d && d < c) {
                    let v = h, P = 1, K;
                    for(; ++v < a && v < c && !((K = y.get(e[v])) == null || K !== d + P);)P++;
                    if (P > d - m) {
                        const O = e[h];
                        for(; m < d;)t.insertBefore(r[m++], O);
                    } else t.replaceChild(r[m++], e[h++]);
                } else h++;
            } else e[h++].remove();
        }
    }
}
const $aec35899a3c9695e$var$wd = "_$DX_DELEGATE";
function $aec35899a3c9695e$var$qt(t, e, r) {
    let i;
    const a = ()=>{
        const h = document.createElement("template");
        return h.innerHTML = t, h.content.firstChild;
    }, c = ()=>(i || (i = a())).cloneNode(!0);
    return c.cloneNode = c, c;
}
function $aec35899a3c9695e$var$qf(t, e = window.document) {
    const r = e[$aec35899a3c9695e$var$wd] || (e[$aec35899a3c9695e$var$wd] = /* @__PURE__ */ new Set());
    for(let i = 0, a = t.length; i < a; i++){
        const c = t[i];
        r.has(c) || (r.add(c), e.addEventListener(c, $aec35899a3c9695e$var$Ab));
    }
}
function $aec35899a3c9695e$var$kt(t, e, r) {
    r == null ? t.removeAttribute(e) : t.setAttribute(e, r);
}
function $aec35899a3c9695e$var$zf(t, e) {
    e == null ? t.removeAttribute("class") : t.className = e;
}
function $aec35899a3c9695e$var$Ac(t, e, r) {
    return $aec35899a3c9695e$var$Ra(()=>t(e, r));
}
function $aec35899a3c9695e$var$st(t, e, r, i) {
    if (r !== void 0 && !i && (i = []), typeof e != "function") return $aec35899a3c9695e$var$du(t, e, i, r);
    $aec35899a3c9695e$var$Er((a)=>$aec35899a3c9695e$var$du(t, e(), a, r), i);
}
function $aec35899a3c9695e$var$Ab(t) {
    let e = t.target;
    const r = `$$${t.type}`, i = t.target, a = t.currentTarget, c = (p)=>Object.defineProperty(t, "target", {
            configurable: !0,
            value: p
        }), h = ()=>{
        const p = e[r];
        if (p && !e.disabled) {
            const y = e[`${r}Data`];
            if (y !== void 0 ? p.call(e, y, t) : p.call(e, t), t.cancelBubble) return;
        }
        return e.host && typeof e.host != "string" && !e.host._$host && e.contains(t.target) && c(e.host), !0;
    }, m = ()=>{
        for(; h() && (e = e._$host || e.parentNode || e.host););
    };
    if (Object.defineProperty(t, "currentTarget", {
        configurable: !0,
        get () {
            return e || document;
        }
    }), t.composedPath) {
        const p = t.composedPath();
        c(p[0]);
        for(let y = 0; y < p.length - 2 && (e = p[y], !!h()); y++){
            if (e._$host) {
                e = e._$host, m();
                break;
            }
            if (e.parentNode === a) break;
        }
    } else m();
    c(i);
}
function $aec35899a3c9695e$var$du(t, e, r, i, a) {
    for(; typeof r == "function";)r = r();
    if (e === r) return r;
    const c = typeof e, h = i !== void 0;
    if (t = h && r[0] && r[0].parentNode || t, c === "string" || c === "number") {
        if (c === "number" && (e = e.toString(), e === r)) return r;
        if (h) {
            let m = r[0];
            m && m.nodeType === 3 ? m.data !== e && (m.data = e) : m = document.createTextNode(e), r = $aec35899a3c9695e$var$ps(t, r, i, m);
        } else r !== "" && typeof r == "string" ? r = t.firstChild.data = e : r = t.textContent = e;
    } else if (e == null || c === "boolean") r = $aec35899a3c9695e$var$ps(t, r, i);
    else {
        if (c === "function") return $aec35899a3c9695e$var$Er(()=>{
            let m = e();
            for(; typeof m == "function";)m = m();
            r = $aec35899a3c9695e$var$du(t, m, r, i);
        }), ()=>r;
        if (Array.isArray(e)) {
            const m = [], p = r && Array.isArray(r);
            if ($aec35899a3c9695e$var$_c(m, e, r, a)) return $aec35899a3c9695e$var$Er(()=>r = $aec35899a3c9695e$var$du(t, m, r, i, !0)), ()=>r;
            if (m.length === 0) {
                if (r = $aec35899a3c9695e$var$ps(t, r, i), h) return r;
            } else p ? r.length === 0 ? $aec35899a3c9695e$var$Td(t, m, i) : $aec35899a3c9695e$var$Rb(t, r, m) : (r && $aec35899a3c9695e$var$ps(t), $aec35899a3c9695e$var$Td(t, m));
            r = m;
        } else if (e.nodeType) {
            if (Array.isArray(r)) {
                if (h) return r = $aec35899a3c9695e$var$ps(t, r, i, e);
                $aec35899a3c9695e$var$ps(t, r, null, e);
            } else r == null || r === "" || !t.firstChild ? t.appendChild(e) : t.replaceChild(e, t.firstChild);
            r = e;
        }
    }
    return r;
}
function $aec35899a3c9695e$var$_c(t, e, r, i) {
    let a = !1;
    for(let c = 0, h = e.length; c < h; c++){
        let m = e[c], p = r && r[t.length], y;
        if (!(m == null || m === !0 || m === !1)) {
            if ((y = typeof m) == "object" && m.nodeType) t.push(m);
            else if (Array.isArray(m)) a = $aec35899a3c9695e$var$_c(t, m, p) || a;
            else if (y === "function") {
                if (i) {
                    for(; typeof m == "function";)m = m();
                    a = $aec35899a3c9695e$var$_c(t, Array.isArray(m) ? m : [
                        m
                    ], Array.isArray(p) ? p : [
                        p
                    ]) || a;
                } else t.push(m), a = !0;
            } else {
                const d = String(m);
                p && p.nodeType === 3 && p.data === d ? t.push(p) : t.push(document.createTextNode(d));
            }
        }
    }
    return a;
}
function $aec35899a3c9695e$var$Td(t, e, r = null) {
    for(let i = 0, a = e.length; i < a; i++)t.insertBefore(e[i], r);
}
function $aec35899a3c9695e$var$ps(t, e, r, i) {
    if (r === void 0) return t.textContent = "";
    const a = i || document.createTextNode("");
    if (e.length) {
        let c = !1;
        for(let h = e.length - 1; h >= 0; h--){
            const m = e[h];
            if (a !== m) {
                const p = m.parentNode === t;
                !c && !h ? p ? t.replaceChild(a, m) : t.insertBefore(a, r) : p && m.remove();
            } else c = !0;
        }
    } else t.insertBefore(a, r);
    return [
        a
    ];
}
function $aec35899a3c9695e$var$_b(t) {
    const e = Object.keys(t), r = {};
    for(let i = 0; i < e.length; i++){
        const [a, c] = $aec35899a3c9695e$var$ia(t[e[i]]);
        Object.defineProperty(r, e[i], {
            get: a,
            set (h) {
                c(()=>h);
            }
        });
    }
    return r;
}
function $aec35899a3c9695e$var$wb(t) {
    if (t.assignedSlot && t.assignedSlot._$owner) return t.assignedSlot._$owner;
    let e = t.parentNode;
    for(; e && !e._$owner && !(e.assignedSlot && e.assignedSlot._$owner);)e = e.parentNode;
    return e && e.assignedSlot ? e.assignedSlot._$owner : t._$owner;
}
function $aec35899a3c9695e$var$Tb(t) {
    return (e, r)=>{
        const { element: i } = r;
        return $aec35899a3c9695e$var$pb((a)=>{
            const c = $aec35899a3c9695e$var$_b(e);
            i.addPropertyChangedCallback((m, p)=>c[m] = p), i.addReleaseCallback(()=>{
                i.renderRoot.textContent = "", a();
            });
            const h = t(c, r);
            return $aec35899a3c9695e$var$st(i.renderRoot, h);
        }, $aec35899a3c9695e$var$wb(i));
    };
}
function $aec35899a3c9695e$var$Sb(t, e, r) {
    return arguments.length === 2 && (r = e, e = {}), $aec35899a3c9695e$var$ub(t, e)($aec35899a3c9695e$var$Tb(r));
}
const $aec35899a3c9695e$var$Cb = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.right-5{right:1.25rem}.top-5{top:1.25rem}.col-span-2{grid-column:span 2 / span 2}.mx-1{margin-left:.25rem;margin-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}.mb-1{margin-bottom:.25rem}.mb-16{margin-bottom:4rem}.ml-10{margin-left:2.5rem}.mr-1{margin-right:.25rem}.mt-4{margin-top:1rem}.mt-8{margin-top:2rem}.block{display:block}.inline{display:inline}.flex{display:flex}.grid{display:grid}.h-10{height:2.5rem}.h-14{height:3.5rem}.h-2{height:.5rem}.h-4{height:1rem}.h-full{height:100%}.max-h-\\[90vh\\]{max-height:90vh}.w-10{width:2.5rem}.w-14{width:3.5rem}.w-4{width:1rem}.w-full{width:100%}.max-w-\\[calc\\(100\\%-70px\\)\\]{max-width:calc(100% - 70px)}.max-w-screen-sm{max-width:640px}.flex-1{flex:1 1 0%}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.flex-col{flex-direction:column}.items-center{align-items:center}.justify-center{justify-content:center}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-4{gap:1rem}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.overflow-hidden{overflow:hidden}.text-ellipsis{text-overflow:ellipsis}.whitespace-nowrap{white-space:nowrap}.whitespace-pre-wrap{white-space:pre-wrap}.rounded{border-radius:.25rem}.rounded-full{border-radius:9999px}.rounded-md{border-radius:.375rem}.rounded-t-md{border-top-left-radius:.375rem;border-top-right-radius:.375rem}.border{border-width:1px}.border-b{border-bottom-width:1px}.border-slate-300{--tw-border-opacity: 1;border-color:rgb(203 213 225 / var(--tw-border-opacity, 1))}.bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(59 130 246 / var(--tw-bg-opacity, 1))}.bg-gray-900{--tw-bg-opacity: 1;background-color:rgb(17 24 39 / var(--tw-bg-opacity, 1))}.bg-slate-100{--tw-bg-opacity: 1;background-color:rgb(241 245 249 / var(--tw-bg-opacity, 1))}.bg-slate-200{--tw-bg-opacity: 1;background-color:rgb(226 232 240 / var(--tw-bg-opacity, 1))}.bg-slate-900{--tw-bg-opacity: 1;background-color:rgb(15 23 42 / var(--tw-bg-opacity, 1))}.object-cover{-o-object-fit:cover;object-fit:cover}.p-3{padding:.75rem}.p-4{padding:1rem}.px-4{padding-left:1rem;padding-right:1rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.text-sm{font-size:.875rem;line-height:1.25rem}.font-bold{font-weight:700}.font-semibold{font-weight:600}.text-blue-500{--tw-text-opacity: 1;color:rgb(59 130 246 / var(--tw-text-opacity, 1))}.text-slate-500{--tw-text-opacity: 1;color:rgb(100 116 139 / var(--tw-text-opacity, 1))}.text-slate-600{--tw-text-opacity: 1;color:rgb(71 85 105 / var(--tw-text-opacity, 1))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.underline{text-decoration-line:underline}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop\\:bg-gray-800::backdrop{--tw-bg-opacity: 1;background-color:rgb(31 41 55 / var(--tw-bg-opacity, 1))}.backdrop\\:opacity-90::backdrop{opacity:.9}.hover\\:bg-blue-700:hover{--tw-bg-opacity: 1;background-color:rgb(29 78 216 / var(--tw-bg-opacity, 1))}.hover\\:underline:hover{text-decoration-line:underline}.dark\\:border-slate-800:where(.dark,.dark *){--tw-border-opacity: 1;border-color:rgb(30 41 59 / var(--tw-border-opacity, 1))}.dark\\:bg-slate-800:where(.dark,.dark *){--tw-bg-opacity: 1;background-color:rgb(30 41 59 / var(--tw-bg-opacity, 1))}.dark\\:text-slate-400:where(.dark,.dark *){--tw-text-opacity: 1;color:rgb(148 163 184 / var(--tw-text-opacity, 1))}.dark\\:text-white:where(.dark,.dark *){--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}';
var $aec35899a3c9695e$var$se = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $aec35899a3c9695e$var$Lb(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function $aec35899a3c9695e$var$Xf(t) {
    if (t.__esModule) return t;
    var e = t.default;
    if (typeof e == "function") {
        var r = function i() {
            return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        r.prototype = e.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", {
        value: !0
    }), Object.keys(t).forEach(function(i) {
        var a = Object.getOwnPropertyDescriptor(t, i);
        Object.defineProperty(r, i, a.get ? a : {
            enumerable: !0,
            get: function() {
                return t[i];
            }
        });
    }), r;
}
var $aec35899a3c9695e$var$Bc = {}, $aec35899a3c9695e$var$as = {}, $aec35899a3c9695e$var$Ic = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.DisallowedDomainError = t.UnsupportedDomainError = t.ReservedHandleError = t.InvalidHandleError = t.isValidTld = t.isValidHandle = t.normalizeAndEnsureValidHandle = t.normalizeHandle = t.ensureValidHandleRegex = t.ensureValidHandle = t.DISALLOWED_TLDS = t.INVALID_HANDLE = void 0, t.INVALID_HANDLE = "handle.invalid", t.DISALLOWED_TLDS = [
        ".local",
        ".arpa",
        ".invalid",
        ".localhost",
        ".internal",
        ".example",
        ".alt",
        // policy could concievably change on ".onion" some day
        ".onion"
    ];
    const e = (v)=>{
        if (!/^[a-zA-Z0-9.-]*$/.test(v)) throw new m("Disallowed characters in handle (ASCII letters, digits, dashes, periods only)");
        if (v.length > 253) throw new m("Handle is too long (253 chars max)");
        const P = v.split(".");
        if (P.length < 2) throw new m("Handle domain needs at least two parts");
        for(let K = 0; K < P.length; K++){
            const O = P[K];
            if (O.length < 1) throw new m("Handle parts can not be empty");
            if (O.length > 63) throw new m("Handle part too long (max 63 chars)");
            if (O.endsWith("-") || O.startsWith("-")) throw new m("Handle parts can not start or end with hyphens");
            if (K + 1 === P.length && !/^[a-zA-Z]/.test(O)) throw new m("Handle final component (TLD) must start with ASCII letter");
        }
    };
    t.ensureValidHandle = e;
    const r = (v)=>{
        if (!/^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/.test(v)) throw new m("Handle didn't validate via regex");
        if (v.length > 253) throw new m("Handle is too long (253 chars max)");
    };
    t.ensureValidHandleRegex = r;
    const i = (v)=>v.toLowerCase();
    t.normalizeHandle = i;
    const a = (v)=>{
        const P = (0, t.normalizeHandle)(v);
        return (0, t.ensureValidHandle)(P), P;
    };
    t.normalizeAndEnsureValidHandle = a;
    const c = (v)=>{
        try {
            (0, t.ensureValidHandle)(v);
        } catch (P) {
            if (P instanceof m) return !1;
            throw P;
        }
        return !0;
    };
    t.isValidHandle = c;
    const h = (v)=>!t.DISALLOWED_TLDS.some((P)=>v.endsWith(P));
    t.isValidTld = h;
    class m extends Error {
    }
    t.InvalidHandleError = m;
    class p extends Error {
    }
    t.ReservedHandleError = p;
    class y extends Error {
    }
    t.UnsupportedDomainError = y;
    class d extends Error {
    }
    t.DisallowedDomainError = d;
})($aec35899a3c9695e$var$Ic);
var $aec35899a3c9695e$var$Ki = {};
Object.defineProperty($aec35899a3c9695e$var$Ki, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ki.InvalidDidError = $aec35899a3c9695e$var$Ki.ensureValidDidRegex = $aec35899a3c9695e$var$Ki.ensureValidDid = void 0;
const $aec35899a3c9695e$var$kb = (t)=>{
    if (!t.startsWith("did:")) throw new $aec35899a3c9695e$var$Bi('DID requires "did:" prefix');
    if (!/^[a-zA-Z0-9._:%-]*$/.test(t)) throw new $aec35899a3c9695e$var$Bi("Disallowed characters in DID (ASCII letters, digits, and a couple other characters only)");
    const { length: e, 1: r } = t.split(":");
    if (e < 3) throw new $aec35899a3c9695e$var$Bi("DID requires prefix, method, and method-specific content");
    if (!/^[a-z]+$/.test(r)) throw new $aec35899a3c9695e$var$Bi("DID method must be lower-case letters");
    if (t.endsWith(":") || t.endsWith("%")) throw new $aec35899a3c9695e$var$Bi('DID can not end with ":" or "%"');
    if (t.length > 2048) throw new $aec35899a3c9695e$var$Bi("DID is too long (2048 chars max)");
};
$aec35899a3c9695e$var$Ki.ensureValidDid = $aec35899a3c9695e$var$kb;
const $aec35899a3c9695e$var$Db = (t)=>{
    if (!/^did:[a-z]+:[a-zA-Z0-9._:%-]*[a-zA-Z0-9._-]$/.test(t)) throw new $aec35899a3c9695e$var$Bi("DID didn't validate via regex");
    if (t.length > 2048) throw new $aec35899a3c9695e$var$Bi("DID is too long (2048 chars max)");
};
$aec35899a3c9695e$var$Ki.ensureValidDidRegex = $aec35899a3c9695e$var$Db;
class $aec35899a3c9695e$var$Bi extends Error {
}
$aec35899a3c9695e$var$Ki.InvalidDidError = $aec35899a3c9695e$var$Bi;
var $aec35899a3c9695e$var$Uc = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.InvalidNsidError = t.ensureValidNsidRegex = t.ensureValidNsid = t.NSID = void 0;
    class e {
        static parse(h) {
            return new e(h);
        }
        static create(h, m) {
            const p = [
                ...h.split(".").reverse(),
                m
            ].join(".");
            return new e(p);
        }
        static isValid(h) {
            try {
                return e.parse(h), !0;
            } catch  {
                return !1;
            }
        }
        constructor(h){
            Object.defineProperty(this, "segments", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: []
            }), (0, t.ensureValidNsid)(h), this.segments = h.split(".");
        }
        get authority() {
            return this.segments.slice(0, this.segments.length - 1).reverse().join(".");
        }
        get name() {
            return this.segments.at(this.segments.length - 1);
        }
        toString() {
            return this.segments.join(".");
        }
    }
    t.NSID = e;
    const r = (c)=>{
        const h = c;
        if (!/^[a-zA-Z0-9.-]*$/.test(h)) throw new a("Disallowed characters in NSID (ASCII letters, digits, dashes, periods only)");
        if (h.length > 317) throw new a("NSID is too long (317 chars max)");
        const m = h.split(".");
        if (m.length < 3) throw new a("NSID needs at least three parts");
        for(let p = 0; p < m.length; p++){
            const y = m[p];
            if (y.length < 1) throw new a("NSID parts can not be empty");
            if (y.length > 63) throw new a("NSID part too long (max 63 chars)");
            if (y.endsWith("-") || y.startsWith("-")) throw new a("NSID parts can not start or end with hyphen");
            if (/^[0-9]/.test(y) && p === 0) throw new a("NSID first part may not start with a digit");
            if (!/^[a-zA-Z]+$/.test(y) && p + 1 === m.length) throw new a("NSID name part must be only letters");
        }
    };
    t.ensureValidNsid = r;
    const i = (c)=>{
        if (!/^[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(\.[a-zA-Z]([a-zA-Z]{0,61}[a-zA-Z])?)$/.test(c)) throw new a("NSID didn't validate via regex");
        if (c.length > 317) throw new a("NSID is too long (317 chars max)");
    };
    t.ensureValidNsidRegex = i;
    class a extends Error {
    }
    t.InvalidNsidError = a;
})($aec35899a3c9695e$var$Uc);
var $aec35899a3c9695e$var$Hf = {}, $aec35899a3c9695e$var$Es = {};
Object.defineProperty($aec35899a3c9695e$var$Es, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Es.ensureValidAtUriRegex = $aec35899a3c9695e$var$Es.ensureValidAtUri = void 0;
const $aec35899a3c9695e$var$Zf = $aec35899a3c9695e$var$Ic, $aec35899a3c9695e$var$Wf = $aec35899a3c9695e$var$Ki, $aec35899a3c9695e$var$Yf = $aec35899a3c9695e$var$Uc, $aec35899a3c9695e$var$Pb = (t)=>{
    const e = t.split("#");
    if (e.length > 2) throw new Error('ATURI can have at most one "#", separating fragment out');
    const r = e[1] || null;
    if (t = e[0], !/^[a-zA-Z0-9._~:@!$&')(*+,;=%/-]*$/.test(t)) throw new Error("Disallowed characters in ATURI (ASCII)");
    const i = t.split("/");
    if (i.length >= 3 && (i[0] !== "at:" || i[1].length !== 0)) throw new Error('ATURI must start with "at://"');
    if (i.length < 3) throw new Error("ATURI requires at least method and authority sections");
    try {
        i[2].startsWith("did:") ? (0, $aec35899a3c9695e$var$Wf.ensureValidDid)(i[2]) : (0, $aec35899a3c9695e$var$Zf.ensureValidHandle)(i[2]);
    } catch  {
        throw new Error("ATURI authority must be a valid handle or DID");
    }
    if (i.length >= 4) {
        if (i[3].length === 0) throw new Error("ATURI can not have a slash after authority without a path segment");
        try {
            (0, $aec35899a3c9695e$var$Yf.ensureValidNsid)(i[3]);
        } catch  {
            throw new Error("ATURI requires first path segment (if supplied) to be valid NSID");
        }
    }
    if (i.length >= 5 && i[4].length === 0) throw new Error("ATURI can not have a slash after collection, unless record key is provided");
    if (i.length >= 6) throw new Error("ATURI path can have at most two parts, and no trailing slash");
    if (e.length >= 2 && r == null) throw new Error("ATURI fragment must be non-empty and start with slash");
    if (r != null) {
        if (r.length === 0 || r[0] !== "/") throw new Error("ATURI fragment must be non-empty and start with slash");
        if (!/^\/[a-zA-Z0-9._~:@!$&')(*+,;=%[\]/-]*$/.test(r)) throw new Error("Disallowed characters in ATURI fragment (ASCII)");
    }
    if (t.length > 8192) throw new Error("ATURI is far too long");
};
$aec35899a3c9695e$var$Es.ensureValidAtUri = $aec35899a3c9695e$var$Pb;
const $aec35899a3c9695e$var$Bb = (t)=>{
    const e = /^at:\/\/(?<authority>[a-zA-Z0-9._:%-]+)(\/(?<collection>[a-zA-Z0-9-.]+)(\/(?<rkey>[a-zA-Z0-9._~:@!$&%')(*+,;=-]+))?)?(#(?<fragment>\/[a-zA-Z0-9._~:@!$&%')(*+,;=\-[\]/\\]*))?$/, r = t.match(e);
    if (!r || !r.groups) throw new Error("ATURI didn't validate via regex");
    const i = r.groups;
    try {
        (0, $aec35899a3c9695e$var$Zf.ensureValidHandleRegex)(i.authority);
    } catch  {
        try {
            (0, $aec35899a3c9695e$var$Wf.ensureValidDidRegex)(i.authority);
        } catch  {
            throw new Error("ATURI authority must be a valid handle or DID");
        }
    }
    if (i.collection) try {
        (0, $aec35899a3c9695e$var$Yf.ensureValidNsidRegex)(i.collection);
    } catch  {
        throw new Error("ATURI collection path segment must be a valid NSID");
    }
    if (t.length > 8192) throw new Error("ATURI is far too long");
};
$aec35899a3c9695e$var$Es.ensureValidAtUriRegex = $aec35899a3c9695e$var$Bb;
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(m, p, y, d) {
        d === void 0 && (d = y);
        var v = Object.getOwnPropertyDescriptor(p, y);
        (!v || ("get" in v ? !p.__esModule : v.writable || v.configurable)) && (v = {
            enumerable: !0,
            get: function() {
                return p[y];
            }
        }), Object.defineProperty(m, d, v);
    } : function(m, p, y, d) {
        d === void 0 && (d = y), m[d] = p[y];
    }), r = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__exportStar || function(m, p) {
        for(var y in m)y !== "default" && !Object.prototype.hasOwnProperty.call(p, y) && e(p, m, y);
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.AtUri = t.ATP_URI_REGEX = void 0, r($aec35899a3c9695e$var$Es, t), t.ATP_URI_REGEX = /^(at:\/\/)?((?:did:[a-z0-9:%-]+)|(?:[a-z0-9][a-z0-9.:-]*))(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
    const i = /^(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
    class a {
        constructor(p, y){
            Object.defineProperty(this, "hash", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), Object.defineProperty(this, "host", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), Object.defineProperty(this, "pathname", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), Object.defineProperty(this, "searchParams", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            });
            let d;
            if (y) {
                if (d = c(y), !d) throw new Error(`Invalid at uri: ${y}`);
                const v = h(p);
                if (!v) throw new Error(`Invalid path: ${p}`);
                Object.assign(d, v);
            } else if (d = c(p), !d) throw new Error(`Invalid at uri: ${p}`);
            this.hash = d.hash, this.host = d.host, this.pathname = d.pathname, this.searchParams = d.searchParams;
        }
        static make(p, y, d) {
            let v = p;
            return y && (v += "/" + y), d && (v += "/" + d), new a(v);
        }
        get protocol() {
            return "at:";
        }
        get origin() {
            return `at://${this.host}`;
        }
        get hostname() {
            return this.host;
        }
        set hostname(p) {
            this.host = p;
        }
        get search() {
            return this.searchParams.toString();
        }
        set search(p) {
            this.searchParams = new URLSearchParams(p);
        }
        get collection() {
            return this.pathname.split("/").filter(Boolean)[0] || "";
        }
        set collection(p) {
            const y = this.pathname.split("/").filter(Boolean);
            y[0] = p, this.pathname = y.join("/");
        }
        get rkey() {
            return this.pathname.split("/").filter(Boolean)[1] || "";
        }
        set rkey(p) {
            const y = this.pathname.split("/").filter(Boolean);
            y[0] || (y[0] = "undefined"), y[1] = p, this.pathname = y.join("/");
        }
        get href() {
            return this.toString();
        }
        toString() {
            let p = this.pathname || "/";
            p.startsWith("/") || (p = `/${p}`);
            let y = this.searchParams.toString();
            y && !y.startsWith("?") && (y = `?${y}`);
            let d = this.hash;
            return d && !d.startsWith("#") && (d = `#${d}`), `at://${this.host}${p}${y}${d}`;
        }
    }
    t.AtUri = a;
    function c(m) {
        const p = t.ATP_URI_REGEX.exec(m);
        if (p) return {
            hash: p[5] || "",
            host: p[2] || "",
            pathname: p[3] || "",
            searchParams: new URLSearchParams(p[4] || "")
        };
    }
    function h(m) {
        const p = i.exec(m);
        if (p) return {
            hash: p[3] || "",
            pathname: p[1] || "",
            searchParams: new URLSearchParams(p[2] || "")
        };
    }
})($aec35899a3c9695e$var$Hf);
var $aec35899a3c9695e$var$Jf = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.InvalidTidError = t.isValidTid = t.ensureValidTid = void 0;
    const e = (a)=>{
        if (a.length !== 13) throw new i("TID must be 13 characters");
        if (!/^[234567abcdefghij][234567abcdefghijklmnopqrstuvwxyz]{12}$/.test(a)) throw new i("TID syntax not valid (regex)");
    };
    t.ensureValidTid = e;
    const r = (a)=>{
        try {
            (0, t.ensureValidTid)(a);
        } catch (c) {
            if (c instanceof i) return !1;
            throw c;
        }
        return !0;
    };
    t.isValidTid = r;
    class i extends Error {
    }
    t.InvalidTidError = i;
})($aec35899a3c9695e$var$Jf);
var $aec35899a3c9695e$var$Qf = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.InvalidRecordKeyError = t.isValidRecordKey = t.ensureValidRecordKey = void 0;
    const e = (a)=>{
        if (a.length > 512 || a.length < 1) throw new i("record key must be 1 to 512 characters");
        if (!/^[a-zA-Z0-9_~.:-]{1,512}$/.test(a)) throw new i("record key syntax not valid (regex)");
        if (a === "." || a === "..") throw new i('record key can not be "." or ".."');
    };
    t.ensureValidRecordKey = e;
    const r = (a)=>{
        try {
            (0, t.ensureValidRecordKey)(a);
        } catch (c) {
            if (c instanceof i) return !1;
            throw c;
        }
        return !0;
    };
    t.isValidRecordKey = r;
    class i extends Error {
    }
    t.InvalidRecordKeyError = i;
})($aec35899a3c9695e$var$Qf);
var $aec35899a3c9695e$var$ep = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.InvalidDatetimeError = t.normalizeDatetimeAlways = t.normalizeDatetime = t.isValidDatetime = t.ensureValidDatetime = void 0;
    const e = (h)=>{
        const m = new Date(h);
        if (isNaN(m.getTime())) throw new c("datetime did not parse as ISO 8601");
        if (m.toISOString().startsWith("-")) throw new c("datetime normalized to a negative time");
        if (!/^[0-9]{4}-[01][0-9]-[0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9](.[0-9]{1,20})?(Z|([+-][0-2][0-9]:[0-5][0-9]))$/.test(h)) throw new c("datetime didn't validate via regex");
        if (h.length > 64) throw new c("datetime is too long (64 chars max)");
        if (h.endsWith("-00:00")) throw new c('datetime can not use "-00:00" for UTC timezone');
        if (h.startsWith("000")) throw new c("datetime so close to year zero not allowed");
    };
    t.ensureValidDatetime = e;
    const r = (h)=>{
        try {
            (0, t.ensureValidDatetime)(h);
        } catch (m) {
            if (m instanceof c) return !1;
            throw m;
        }
        return !0;
    };
    t.isValidDatetime = r;
    const i = (h)=>{
        if ((0, t.isValidDatetime)(h)) {
            const y = new Date(h).toISOString();
            if ((0, t.isValidDatetime)(y)) return y;
        }
        if (!/.*(([+-]\d\d:?\d\d)|[a-zA-Z])$/.test(h)) {
            const y = /* @__PURE__ */ new Date(h + "Z");
            if (!isNaN(y.getTime())) {
                const d = y.toISOString();
                if ((0, t.isValidDatetime)(d)) return d;
            }
        }
        const m = new Date(h);
        if (isNaN(m.getTime())) throw new c("datetime did not parse as any timestamp format");
        const p = m.toISOString();
        if ((0, t.isValidDatetime)(p)) return p;
        throw new c("datetime normalized to invalid timestamp string");
    };
    t.normalizeDatetime = i;
    const a = (h)=>{
        try {
            return (0, t.normalizeDatetime)(h);
        } catch (m) {
            if (m instanceof c) return /* @__PURE__ */ new Date(0).toISOString();
            throw m;
        }
    };
    t.normalizeDatetimeAlways = a;
    class c extends Error {
    }
    t.InvalidDatetimeError = c;
})($aec35899a3c9695e$var$ep);
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(i, a, c, h) {
        h === void 0 && (h = c);
        var m = Object.getOwnPropertyDescriptor(a, c);
        (!m || ("get" in m ? !a.__esModule : m.writable || m.configurable)) && (m = {
            enumerable: !0,
            get: function() {
                return a[c];
            }
        }), Object.defineProperty(i, h, m);
    } : function(i, a, c, h) {
        h === void 0 && (h = c), i[h] = a[c];
    }), r = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__exportStar || function(i, a) {
        for(var c in i)c !== "default" && !Object.prototype.hasOwnProperty.call(a, c) && e(a, i, c);
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), r($aec35899a3c9695e$var$Ic, t), r($aec35899a3c9695e$var$Ki, t), r($aec35899a3c9695e$var$Uc, t), r($aec35899a3c9695e$var$Hf, t), r($aec35899a3c9695e$var$Jf, t), r($aec35899a3c9695e$var$Qf, t), r($aec35899a3c9695e$var$ep, t);
})($aec35899a3c9695e$var$as);
var $aec35899a3c9695e$var$wa = {}, $aec35899a3c9695e$var$Rn = {}, $aec35899a3c9695e$var$os = {}, $aec35899a3c9695e$var$wc = {}, $aec35899a3c9695e$var$ci = {}, $aec35899a3c9695e$var$ku = {}, $aec35899a3c9695e$var$Ta = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getParsedType = t.ZodParsedType = t.objectUtil = t.util = void 0;
    var e;
    (function(a) {
        a.assertEqual = (p)=>p;
        function c(p) {}
        a.assertIs = c;
        function h(p) {
            throw new Error();
        }
        a.assertNever = h, a.arrayToEnum = (p)=>{
            const y = {};
            for (const d of p)y[d] = d;
            return y;
        }, a.getValidEnumValues = (p)=>{
            const y = a.objectKeys(p).filter((v)=>typeof p[p[v]] != "number"), d = {};
            for (const v of y)d[v] = p[v];
            return a.objectValues(d);
        }, a.objectValues = (p)=>a.objectKeys(p).map(function(y) {
                return p[y];
            }), a.objectKeys = typeof Object.keys == "function" ? (p)=>Object.keys(p) : (p)=>{
            const y = [];
            for(const d in p)Object.prototype.hasOwnProperty.call(p, d) && y.push(d);
            return y;
        }, a.find = (p, y)=>{
            for (const d of p)if (y(d)) return d;
        }, a.isInteger = typeof Number.isInteger == "function" ? (p)=>Number.isInteger(p) : (p)=>typeof p == "number" && isFinite(p) && Math.floor(p) === p;
        function m(p, y = " | ") {
            return p.map((d)=>typeof d == "string" ? `'${d}'` : d).join(y);
        }
        a.joinValues = m, a.jsonStringifyReplacer = (p, y)=>typeof y == "bigint" ? y.toString() : y;
    })(e || (t.util = e = {}));
    var r;
    (function(a) {
        a.mergeShapes = (c, h)=>({
                ...c,
                ...h
            });
    })(r || (t.objectUtil = r = {})), t.ZodParsedType = e.arrayToEnum([
        "string",
        "nan",
        "number",
        "integer",
        "float",
        "boolean",
        "date",
        "bigint",
        "symbol",
        "function",
        "undefined",
        "null",
        "array",
        "object",
        "unknown",
        "promise",
        "void",
        "never",
        "map",
        "set"
    ]);
    const i = (a)=>{
        switch(typeof a){
            case "undefined":
                return t.ZodParsedType.undefined;
            case "string":
                return t.ZodParsedType.string;
            case "number":
                return isNaN(a) ? t.ZodParsedType.nan : t.ZodParsedType.number;
            case "boolean":
                return t.ZodParsedType.boolean;
            case "function":
                return t.ZodParsedType.function;
            case "bigint":
                return t.ZodParsedType.bigint;
            case "symbol":
                return t.ZodParsedType.symbol;
            case "object":
                return Array.isArray(a) ? t.ZodParsedType.array : a === null ? t.ZodParsedType.null : a.then && typeof a.then == "function" && a.catch && typeof a.catch == "function" ? t.ZodParsedType.promise : typeof Map < "u" && a instanceof Map ? t.ZodParsedType.map : typeof Set < "u" && a instanceof Set ? t.ZodParsedType.set : typeof Date < "u" && a instanceof Date ? t.ZodParsedType.date : t.ZodParsedType.object;
            default:
                return t.ZodParsedType.unknown;
        }
    };
    t.getParsedType = i;
})($aec35899a3c9695e$var$Ta);
var $aec35899a3c9695e$var$di = {};
Object.defineProperty($aec35899a3c9695e$var$di, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$di.ZodError = $aec35899a3c9695e$var$di.quotelessJson = $aec35899a3c9695e$var$di.ZodIssueCode = void 0;
const $aec35899a3c9695e$var$tp = $aec35899a3c9695e$var$Ta;
$aec35899a3c9695e$var$di.ZodIssueCode = $aec35899a3c9695e$var$tp.util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $aec35899a3c9695e$var$Ib = (t)=>JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
$aec35899a3c9695e$var$di.quotelessJson = $aec35899a3c9695e$var$Ib;
class $aec35899a3c9695e$var$la extends Error {
    get errors() {
        return this.issues;
    }
    constructor(e){
        super(), this.issues = [], this.addIssue = (i)=>{
            this.issues = [
                ...this.issues,
                i
            ];
        }, this.addIssues = (i = [])=>{
            this.issues = [
                ...this.issues,
                ...i
            ];
        };
        const r = new.target.prototype;
        Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
    }
    format(e) {
        const r = e || function(c) {
            return c.message;
        }, i = {
            _errors: []
        }, a = (c)=>{
            for (const h of c.issues)if (h.code === "invalid_union") h.unionErrors.map(a);
            else if (h.code === "invalid_return_type") a(h.returnTypeError);
            else if (h.code === "invalid_arguments") a(h.argumentsError);
            else if (h.path.length === 0) i._errors.push(r(h));
            else {
                let m = i, p = 0;
                for(; p < h.path.length;){
                    const y = h.path[p];
                    p === h.path.length - 1 ? (m[y] = m[y] || {
                        _errors: []
                    }, m[y]._errors.push(r(h))) : m[y] = m[y] || {
                        _errors: []
                    }, m = m[y], p++;
                }
            }
        };
        return a(this), i;
    }
    static assert(e) {
        if (!(e instanceof $aec35899a3c9695e$var$la)) throw new Error(`Not a ZodError: ${e}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $aec35899a3c9695e$var$tp.util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(e = (r)=>r.message) {
        const r = {}, i = [];
        for (const a of this.issues)a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : i.push(e(a));
        return {
            formErrors: i,
            fieldErrors: r
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$aec35899a3c9695e$var$di.ZodError = $aec35899a3c9695e$var$la;
$aec35899a3c9695e$var$la.create = (t)=>new $aec35899a3c9695e$var$la(t);
Object.defineProperty($aec35899a3c9695e$var$ku, "__esModule", {
    value: !0
});
const $aec35899a3c9695e$var$Bn = $aec35899a3c9695e$var$Ta, $aec35899a3c9695e$var$Zt = $aec35899a3c9695e$var$di, $aec35899a3c9695e$var$Ub = (t, e)=>{
    let r;
    switch(t.code){
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_type:
            t.received === $aec35899a3c9695e$var$Bn.ZodParsedType.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_literal:
            r = `Invalid literal value, expected ${JSON.stringify(t.expected, $aec35899a3c9695e$var$Bn.util.jsonStringifyReplacer)}`;
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.unrecognized_keys:
            r = `Unrecognized key(s) in object: ${$aec35899a3c9695e$var$Bn.util.joinValues(t.keys, ", ")}`;
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_union:
            r = "Invalid input";
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_union_discriminator:
            r = `Invalid discriminator value. Expected ${$aec35899a3c9695e$var$Bn.util.joinValues(t.options)}`;
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_enum_value:
            r = `Invalid enum value. Expected ${$aec35899a3c9695e$var$Bn.util.joinValues(t.options)}, received '${t.received}'`;
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_arguments:
            r = "Invalid function arguments";
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_return_type:
            r = "Invalid function return type";
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_date:
            r = "Invalid date";
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_string:
            typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : $aec35899a3c9695e$var$Bn.util.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.too_small:
            t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.too_big:
            t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.custom:
            r = "Invalid input";
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.invalid_intersection_types:
            r = "Intersection results could not be merged";
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.not_multiple_of:
            r = `Number must be a multiple of ${t.multipleOf}`;
            break;
        case $aec35899a3c9695e$var$Zt.ZodIssueCode.not_finite:
            r = "Number must be finite";
            break;
        default:
            r = e.defaultError, $aec35899a3c9695e$var$Bn.util.assertNever(t);
    }
    return {
        message: r
    };
};
$aec35899a3c9695e$var$ku.default = $aec35899a3c9695e$var$Ub;
var $aec35899a3c9695e$var$Ob = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importDefault || function(t) {
    return t && t.__esModule ? t : {
        default: t
    };
};
Object.defineProperty($aec35899a3c9695e$var$ci, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ci.getErrorMap = $aec35899a3c9695e$var$ci.setErrorMap = $aec35899a3c9695e$var$ci.defaultErrorMap = void 0;
const $aec35899a3c9695e$var$rp = $aec35899a3c9695e$var$Ob($aec35899a3c9695e$var$ku);
$aec35899a3c9695e$var$ci.defaultErrorMap = $aec35899a3c9695e$var$rp.default;
let $aec35899a3c9695e$var$ip = $aec35899a3c9695e$var$rp.default;
function $aec35899a3c9695e$var$Kb(t) {
    $aec35899a3c9695e$var$ip = t;
}
$aec35899a3c9695e$var$ci.setErrorMap = $aec35899a3c9695e$var$Kb;
function $aec35899a3c9695e$var$Mb() {
    return $aec35899a3c9695e$var$ip;
}
$aec35899a3c9695e$var$ci.getErrorMap = $aec35899a3c9695e$var$Mb;
var $aec35899a3c9695e$var$Oc = {};
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importDefault || function(K) {
        return K && K.__esModule ? K : {
            default: K
        };
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isAsync = t.isValid = t.isDirty = t.isAborted = t.OK = t.DIRTY = t.INVALID = t.ParseStatus = t.addIssueToContext = t.EMPTY_PATH = t.makeIssue = void 0;
    const r = $aec35899a3c9695e$var$ci, i = e($aec35899a3c9695e$var$ku), a = (K)=>{
        const { data: O, path: Z, errorMaps: Y, issueData: X } = K, V = [
            ...Z,
            ...X.path || []
        ], q = {
            ...X,
            path: V
        };
        if (X.message !== void 0) return {
            ...X,
            path: V,
            message: X.message
        };
        let re = "";
        const ne = Y.filter((fe)=>!!fe).slice().reverse();
        for (const fe of ne)re = fe(q, {
            data: O,
            defaultError: re
        }).message;
        return {
            ...X,
            path: V,
            message: re
        };
    };
    t.makeIssue = a, t.EMPTY_PATH = [];
    function c(K, O) {
        const Z = (0, r.getErrorMap)(), Y = (0, t.makeIssue)({
            issueData: O,
            data: K.data,
            path: K.path,
            errorMaps: [
                K.common.contextualErrorMap,
                // contextual error map is first priority
                K.schemaErrorMap,
                // then schema-bound map if available
                Z,
                // then global override map
                Z === i.default ? void 0 : i.default
            ].filter((X)=>!!X)
        });
        K.common.issues.push(Y);
    }
    t.addIssueToContext = c;
    class h {
        constructor(){
            this.value = "valid";
        }
        dirty() {
            this.value === "valid" && (this.value = "dirty");
        }
        abort() {
            this.value !== "aborted" && (this.value = "aborted");
        }
        static mergeArray(O, Z) {
            const Y = [];
            for (const X of Z){
                if (X.status === "aborted") return t.INVALID;
                X.status === "dirty" && O.dirty(), Y.push(X.value);
            }
            return {
                status: O.value,
                value: Y
            };
        }
        static async mergeObjectAsync(O, Z) {
            const Y = [];
            for (const X of Z){
                const V = await X.key, q = await X.value;
                Y.push({
                    key: V,
                    value: q
                });
            }
            return h.mergeObjectSync(O, Y);
        }
        static mergeObjectSync(O, Z) {
            const Y = {};
            for (const X of Z){
                const { key: V, value: q } = X;
                if (V.status === "aborted" || q.status === "aborted") return t.INVALID;
                V.status === "dirty" && O.dirty(), q.status === "dirty" && O.dirty(), V.value !== "__proto__" && (typeof q.value < "u" || X.alwaysSet) && (Y[V.value] = q.value);
            }
            return {
                status: O.value,
                value: Y
            };
        }
    }
    t.ParseStatus = h, t.INVALID = Object.freeze({
        status: "aborted"
    });
    const m = (K)=>({
            status: "dirty",
            value: K
        });
    t.DIRTY = m;
    const p = (K)=>({
            status: "valid",
            value: K
        });
    t.OK = p;
    const y = (K)=>K.status === "aborted";
    t.isAborted = y;
    const d = (K)=>K.status === "dirty";
    t.isDirty = d;
    const v = (K)=>K.status === "valid";
    t.isValid = v;
    const P = (K)=>typeof Promise < "u" && K instanceof Promise;
    t.isAsync = P;
})($aec35899a3c9695e$var$Oc);
var $aec35899a3c9695e$var$np = {};
Object.defineProperty($aec35899a3c9695e$var$np, "__esModule", {
    value: !0
});
var $aec35899a3c9695e$var$j = {}, $aec35899a3c9695e$var$Du = {};
Object.defineProperty($aec35899a3c9695e$var$Du, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Du.errorUtil = void 0;
var $aec35899a3c9695e$var$Sd;
(function(t) {
    t.errToObj = (e)=>typeof e == "string" ? {
            message: e
        } : e || {}, t.toString = (e)=>typeof e == "string" ? e : e?.message;
})($aec35899a3c9695e$var$Sd || ($aec35899a3c9695e$var$Du.errorUtil = $aec35899a3c9695e$var$Sd = {}));
var $aec35899a3c9695e$var$fu = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__classPrivateFieldGet || function(t, e, r, i) {
    if (r === "a" && !i) throw new TypeError("Private accessor was defined without a getter");
    if (typeof e == "function" ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return r === "m" ? i : r === "a" ? i.call(t) : i ? i.value : e.get(t);
}, $aec35899a3c9695e$var$sp = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__classPrivateFieldSet || function(t, e, r, i, a) {
    if (i === "m") throw new TypeError("Private method is not writable");
    if (i === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
    if (typeof e == "function" ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return i === "a" ? a.call(t, r) : a ? a.value = r : e.set(t, r), r;
}, $aec35899a3c9695e$var$na, $aec35899a3c9695e$var$sa;
Object.defineProperty($aec35899a3c9695e$var$j, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$j.boolean = $aec35899a3c9695e$var$j.bigint = $aec35899a3c9695e$var$j.array = $aec35899a3c9695e$var$j.any = $aec35899a3c9695e$var$j.coerce = $aec35899a3c9695e$var$j.ZodFirstPartyTypeKind = $aec35899a3c9695e$var$j.late = $aec35899a3c9695e$var$j.ZodSchema = $aec35899a3c9695e$var$j.Schema = $aec35899a3c9695e$var$j.custom = $aec35899a3c9695e$var$j.ZodReadonly = $aec35899a3c9695e$var$j.ZodPipeline = $aec35899a3c9695e$var$j.ZodBranded = $aec35899a3c9695e$var$j.BRAND = $aec35899a3c9695e$var$j.ZodNaN = $aec35899a3c9695e$var$j.ZodCatch = $aec35899a3c9695e$var$j.ZodDefault = $aec35899a3c9695e$var$j.ZodNullable = $aec35899a3c9695e$var$j.ZodOptional = $aec35899a3c9695e$var$j.ZodTransformer = $aec35899a3c9695e$var$j.ZodEffects = $aec35899a3c9695e$var$j.ZodPromise = $aec35899a3c9695e$var$j.ZodNativeEnum = $aec35899a3c9695e$var$j.ZodEnum = $aec35899a3c9695e$var$j.ZodLiteral = $aec35899a3c9695e$var$j.ZodLazy = $aec35899a3c9695e$var$j.ZodFunction = $aec35899a3c9695e$var$j.ZodSet = $aec35899a3c9695e$var$j.ZodMap = $aec35899a3c9695e$var$j.ZodRecord = $aec35899a3c9695e$var$j.ZodTuple = $aec35899a3c9695e$var$j.ZodIntersection = $aec35899a3c9695e$var$j.ZodDiscriminatedUnion = $aec35899a3c9695e$var$j.ZodUnion = $aec35899a3c9695e$var$j.ZodObject = $aec35899a3c9695e$var$j.ZodArray = $aec35899a3c9695e$var$j.ZodVoid = $aec35899a3c9695e$var$j.ZodNever = $aec35899a3c9695e$var$j.ZodUnknown = $aec35899a3c9695e$var$j.ZodAny = $aec35899a3c9695e$var$j.ZodNull = $aec35899a3c9695e$var$j.ZodUndefined = $aec35899a3c9695e$var$j.ZodSymbol = $aec35899a3c9695e$var$j.ZodDate = $aec35899a3c9695e$var$j.ZodBoolean = $aec35899a3c9695e$var$j.ZodBigInt = $aec35899a3c9695e$var$j.ZodNumber = $aec35899a3c9695e$var$j.ZodString = $aec35899a3c9695e$var$j.datetimeRegex = $aec35899a3c9695e$var$j.ZodType = void 0;
$aec35899a3c9695e$var$j.NEVER = $aec35899a3c9695e$var$j.void = $aec35899a3c9695e$var$j.unknown = $aec35899a3c9695e$var$j.union = $aec35899a3c9695e$var$j.undefined = $aec35899a3c9695e$var$j.tuple = $aec35899a3c9695e$var$j.transformer = $aec35899a3c9695e$var$j.symbol = $aec35899a3c9695e$var$j.string = $aec35899a3c9695e$var$j.strictObject = $aec35899a3c9695e$var$j.set = $aec35899a3c9695e$var$j.record = $aec35899a3c9695e$var$j.promise = $aec35899a3c9695e$var$j.preprocess = $aec35899a3c9695e$var$j.pipeline = $aec35899a3c9695e$var$j.ostring = $aec35899a3c9695e$var$j.optional = $aec35899a3c9695e$var$j.onumber = $aec35899a3c9695e$var$j.oboolean = $aec35899a3c9695e$var$j.object = $aec35899a3c9695e$var$j.number = $aec35899a3c9695e$var$j.nullable = $aec35899a3c9695e$var$j.null = $aec35899a3c9695e$var$j.never = $aec35899a3c9695e$var$j.nativeEnum = $aec35899a3c9695e$var$j.nan = $aec35899a3c9695e$var$j.map = $aec35899a3c9695e$var$j.literal = $aec35899a3c9695e$var$j.lazy = $aec35899a3c9695e$var$j.intersection = $aec35899a3c9695e$var$j.instanceof = $aec35899a3c9695e$var$j.function = $aec35899a3c9695e$var$j.enum = $aec35899a3c9695e$var$j.effect = $aec35899a3c9695e$var$j.discriminatedUnion = $aec35899a3c9695e$var$j.date = void 0;
const $aec35899a3c9695e$var$Jl = $aec35899a3c9695e$var$ci, $aec35899a3c9695e$var$ve = $aec35899a3c9695e$var$Du, $aec35899a3c9695e$var$$ = $aec35899a3c9695e$var$Oc, $aec35899a3c9695e$var$me = $aec35899a3c9695e$var$Ta, $aec35899a3c9695e$var$de = $aec35899a3c9695e$var$di;
class $aec35899a3c9695e$var$pi {
    constructor(e, r, i, a){
        this._cachedPath = [], this.parent = e, this.data = r, this._path = i, this._key = a;
    }
    get path() {
        return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
    }
}
const $aec35899a3c9695e$var$Cd = (t, e)=>{
    if ((0, $aec35899a3c9695e$var$$.isValid)(e)) return {
        success: !0,
        data: e.value
    };
    if (!t.common.issues.length) throw new Error("Validation failed but no issues detected.");
    return {
        success: !1,
        get error () {
            if (this._error) return this._error;
            const r = new $aec35899a3c9695e$var$de.ZodError(t.common.issues);
            return this._error = r, this._error;
        }
    };
};
function $aec35899a3c9695e$var$Me(t) {
    if (!t) return {};
    const { errorMap: e, invalid_type_error: r, required_error: i, description: a } = t;
    if (e && (r || i)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    return e ? {
        errorMap: e,
        description: a
    } : {
        errorMap: (h, m)=>{
            var p, y;
            const { message: d } = t;
            return h.code === "invalid_enum_value" ? {
                message: d ?? m.defaultError
            } : typeof m.data > "u" ? {
                message: (p = d ?? i) !== null && p !== void 0 ? p : m.defaultError
            } : h.code !== "invalid_type" ? {
                message: m.defaultError
            } : {
                message: (y = d ?? r) !== null && y !== void 0 ? y : m.defaultError
            };
        },
        description: a
    };
}
class $aec35899a3c9695e$var$je {
    get description() {
        return this._def.description;
    }
    _getType(e) {
        return (0, $aec35899a3c9695e$var$me.getParsedType)(e.data);
    }
    _getOrReturnCtx(e, r) {
        return r || {
            common: e.parent.common,
            data: e.data,
            parsedType: (0, $aec35899a3c9695e$var$me.getParsedType)(e.data),
            schemaErrorMap: this._def.errorMap,
            path: e.path,
            parent: e.parent
        };
    }
    _processInputParams(e) {
        return {
            status: new $aec35899a3c9695e$var$$.ParseStatus(),
            ctx: {
                common: e.parent.common,
                data: e.data,
                parsedType: (0, $aec35899a3c9695e$var$me.getParsedType)(e.data),
                schemaErrorMap: this._def.errorMap,
                path: e.path,
                parent: e.parent
            }
        };
    }
    _parseSync(e) {
        const r = this._parse(e);
        if ((0, $aec35899a3c9695e$var$$.isAsync)(r)) throw new Error("Synchronous parse encountered promise.");
        return r;
    }
    _parseAsync(e) {
        const r = this._parse(e);
        return Promise.resolve(r);
    }
    parse(e, r) {
        const i = this.safeParse(e, r);
        if (i.success) return i.data;
        throw i.error;
    }
    safeParse(e, r) {
        var i;
        const a = {
            common: {
                issues: [],
                async: (i = r?.async) !== null && i !== void 0 ? i : !1,
                contextualErrorMap: r?.errorMap
            },
            path: r?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: e,
            parsedType: (0, $aec35899a3c9695e$var$me.getParsedType)(e)
        }, c = this._parseSync({
            data: e,
            path: a.path,
            parent: a
        });
        return $aec35899a3c9695e$var$Cd(a, c);
    }
    "~validate"(e) {
        var r, i;
        const a = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: e,
            parsedType: (0, $aec35899a3c9695e$var$me.getParsedType)(e)
        };
        if (!this["~standard"].async) try {
            const c = this._parseSync({
                data: e,
                path: [],
                parent: a
            });
            return (0, $aec35899a3c9695e$var$$.isValid)(c) ? {
                value: c.value
            } : {
                issues: a.common.issues
            };
        } catch (c) {
            !((i = (r = c?.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || i === void 0) && i.includes("encountered") && (this["~standard"].async = !0), a.common = {
                issues: [],
                async: !0
            };
        }
        return this._parseAsync({
            data: e,
            path: [],
            parent: a
        }).then((c)=>(0, $aec35899a3c9695e$var$$.isValid)(c) ? {
                value: c.value
            } : {
                issues: a.common.issues
            });
    }
    async parseAsync(e, r) {
        const i = await this.safeParseAsync(e, r);
        if (i.success) return i.data;
        throw i.error;
    }
    async safeParseAsync(e, r) {
        const i = {
            common: {
                issues: [],
                contextualErrorMap: r?.errorMap,
                async: !0
            },
            path: r?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: e,
            parsedType: (0, $aec35899a3c9695e$var$me.getParsedType)(e)
        }, a = this._parse({
            data: e,
            path: i.path,
            parent: i
        }), c = await ((0, $aec35899a3c9695e$var$$.isAsync)(a) ? a : Promise.resolve(a));
        return $aec35899a3c9695e$var$Cd(i, c);
    }
    refine(e, r) {
        const i = (a)=>typeof r == "string" || typeof r > "u" ? {
                message: r
            } : typeof r == "function" ? r(a) : r;
        return this._refinement((a, c)=>{
            const h = e(a), m = ()=>c.addIssue({
                    code: $aec35899a3c9695e$var$de.ZodIssueCode.custom,
                    ...i(a)
                });
            return typeof Promise < "u" && h instanceof Promise ? h.then((p)=>p ? !0 : (m(), !1)) : h ? !0 : (m(), !1);
        });
    }
    refinement(e, r) {
        return this._refinement((i, a)=>e(i) ? !0 : (a.addIssue(typeof r == "function" ? r(i, a) : r), !1));
    }
    _refinement(e) {
        return new $aec35899a3c9695e$var$qr({
            schema: this,
            typeName: $aec35899a3c9695e$var$ke.ZodEffects,
            effect: {
                type: "refinement",
                refinement: e
            }
        });
    }
    superRefine(e) {
        return this._refinement(e);
    }
    constructor(e){
        this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (r)=>this["~validate"](r)
        };
    }
    optional() {
        return $aec35899a3c9695e$var$fi.create(this, this._def);
    }
    nullable() {
        return $aec35899a3c9695e$var$hn.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $aec35899a3c9695e$var$Gr.create(this);
    }
    promise() {
        return $aec35899a3c9695e$var$Rs.create(this, this._def);
    }
    or(e) {
        return $aec35899a3c9695e$var$fa.create([
            this,
            e
        ], this._def);
    }
    and(e) {
        return $aec35899a3c9695e$var$pa.create(this, e, this._def);
    }
    transform(e) {
        return new $aec35899a3c9695e$var$qr({
            ...$aec35899a3c9695e$var$Me(this._def),
            schema: this,
            typeName: $aec35899a3c9695e$var$ke.ZodEffects,
            effect: {
                type: "transform",
                transform: e
            }
        });
    }
    default(e) {
        const r = typeof e == "function" ? e : ()=>e;
        return new $aec35899a3c9695e$var$ga({
            ...$aec35899a3c9695e$var$Me(this._def),
            innerType: this,
            defaultValue: r,
            typeName: $aec35899a3c9695e$var$ke.ZodDefault
        });
    }
    brand() {
        return new $aec35899a3c9695e$var$Kc({
            typeName: $aec35899a3c9695e$var$ke.ZodBranded,
            type: this,
            ...$aec35899a3c9695e$var$Me(this._def)
        });
    }
    catch(e) {
        const r = typeof e == "function" ? e : ()=>e;
        return new $aec35899a3c9695e$var$xa({
            ...$aec35899a3c9695e$var$Me(this._def),
            innerType: this,
            catchValue: r,
            typeName: $aec35899a3c9695e$var$ke.ZodCatch
        });
    }
    describe(e) {
        const r = this.constructor;
        return new r({
            ...this._def,
            description: e
        });
    }
    pipe(e) {
        return $aec35899a3c9695e$var$Sa.create(this, e);
    }
    readonly() {
        return $aec35899a3c9695e$var$Ea.create(this);
    }
    isOptional() {
        return this.safeParse(void 0).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
$aec35899a3c9695e$var$j.ZodType = $aec35899a3c9695e$var$je;
$aec35899a3c9695e$var$j.Schema = $aec35899a3c9695e$var$je;
$aec35899a3c9695e$var$j.ZodSchema = $aec35899a3c9695e$var$je;
const $aec35899a3c9695e$var$Nb = /^c[^\s-]{8,}$/i, $aec35899a3c9695e$var$Vb = /^[0-9a-z]+$/, $aec35899a3c9695e$var$jb = /^[0-9A-HJKMNP-TV-Z]{26}$/i, $aec35899a3c9695e$var$Fb = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, $aec35899a3c9695e$var$$b = /^[a-z0-9_-]{21}$/i, $aec35899a3c9695e$var$Gb = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, $aec35899a3c9695e$var$qb = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, $aec35899a3c9695e$var$zb = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, $aec35899a3c9695e$var$Xb = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let $aec35899a3c9695e$var$uc;
const $aec35899a3c9695e$var$Hb = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, $aec35899a3c9695e$var$Zb = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, $aec35899a3c9695e$var$Wb = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, $aec35899a3c9695e$var$Yb = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, $aec35899a3c9695e$var$Jb = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, $aec35899a3c9695e$var$Qb = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, $aec35899a3c9695e$var$ap = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", $aec35899a3c9695e$var$eg = new RegExp(`^${$aec35899a3c9695e$var$ap}$`);
function $aec35899a3c9695e$var$op(t) {
    let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
    return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function $aec35899a3c9695e$var$tg(t) {
    return new RegExp(`^${$aec35899a3c9695e$var$op(t)}$`);
}
function $aec35899a3c9695e$var$lp(t) {
    let e = `${$aec35899a3c9695e$var$ap}T${$aec35899a3c9695e$var$op(t)}`;
    const r = [];
    return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
$aec35899a3c9695e$var$j.datetimeRegex = $aec35899a3c9695e$var$lp;
function $aec35899a3c9695e$var$rg(t, e) {
    return !!((e === "v4" || !e) && $aec35899a3c9695e$var$Hb.test(t) || (e === "v6" || !e) && $aec35899a3c9695e$var$Wb.test(t));
}
function $aec35899a3c9695e$var$ig(t, e) {
    if (!$aec35899a3c9695e$var$Gb.test(t)) return !1;
    try {
        const [r] = t.split("."), i = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(i));
        return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
    } catch  {
        return !1;
    }
}
function $aec35899a3c9695e$var$ng(t, e) {
    return !!((e === "v4" || !e) && $aec35899a3c9695e$var$Zb.test(t) || (e === "v6" || !e) && $aec35899a3c9695e$var$Yb.test(t));
}
class $aec35899a3c9695e$var$Mr extends $aec35899a3c9695e$var$je {
    _parse(e) {
        if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.string) {
            const c = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(c, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.string,
                received: c.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        const i = new $aec35899a3c9695e$var$$.ParseStatus();
        let a;
        for (const c of this._def.checks)if (c.kind === "min") e.data.length < c.value && (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_small,
            minimum: c.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: c.message
        }), i.dirty());
        else if (c.kind === "max") e.data.length > c.value && (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_big,
            maximum: c.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: c.message
        }), i.dirty());
        else if (c.kind === "length") {
            const h = e.data.length > c.value, m = e.data.length < c.value;
            (h || m) && (a = this._getOrReturnCtx(e, a), h ? (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.too_big,
                maximum: c.value,
                type: "string",
                inclusive: !0,
                exact: !0,
                message: c.message
            }) : m && (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.too_small,
                minimum: c.value,
                type: "string",
                inclusive: !0,
                exact: !0,
                message: c.message
            }), i.dirty());
        } else if (c.kind === "email") $aec35899a3c9695e$var$zb.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "email",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty());
        else if (c.kind === "emoji") $aec35899a3c9695e$var$uc || ($aec35899a3c9695e$var$uc = new RegExp($aec35899a3c9695e$var$Xb, "u")), $aec35899a3c9695e$var$uc.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "emoji",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty());
        else if (c.kind === "uuid") $aec35899a3c9695e$var$Fb.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "uuid",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty());
        else if (c.kind === "nanoid") $aec35899a3c9695e$var$$b.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "nanoid",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty());
        else if (c.kind === "cuid") $aec35899a3c9695e$var$Nb.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "cuid",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty());
        else if (c.kind === "cuid2") $aec35899a3c9695e$var$Vb.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "cuid2",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty());
        else if (c.kind === "ulid") $aec35899a3c9695e$var$jb.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "ulid",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty());
        else if (c.kind === "url") try {
            new URL(e.data);
        } catch  {
            a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
                validation: "url",
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
                message: c.message
            }), i.dirty();
        }
        else c.kind === "regex" ? (c.regex.lastIndex = 0, c.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "regex",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty())) : c.kind === "trim" ? e.data = e.data.trim() : c.kind === "includes" ? e.data.includes(c.value, c.position) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            validation: {
                includes: c.value,
                position: c.position
            },
            message: c.message
        }), i.dirty()) : c.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : c.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : c.kind === "startsWith" ? e.data.startsWith(c.value) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            validation: {
                startsWith: c.value
            },
            message: c.message
        }), i.dirty()) : c.kind === "endsWith" ? e.data.endsWith(c.value) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            validation: {
                endsWith: c.value
            },
            message: c.message
        }), i.dirty()) : c.kind === "datetime" ? $aec35899a3c9695e$var$lp(c).test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            validation: "datetime",
            message: c.message
        }), i.dirty()) : c.kind === "date" ? $aec35899a3c9695e$var$eg.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            validation: "date",
            message: c.message
        }), i.dirty()) : c.kind === "time" ? $aec35899a3c9695e$var$tg(c).test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            validation: "time",
            message: c.message
        }), i.dirty()) : c.kind === "duration" ? $aec35899a3c9695e$var$qb.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "duration",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty()) : c.kind === "ip" ? $aec35899a3c9695e$var$rg(e.data, c.version) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "ip",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty()) : c.kind === "jwt" ? $aec35899a3c9695e$var$ig(e.data, c.alg) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "jwt",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty()) : c.kind === "cidr" ? $aec35899a3c9695e$var$ng(e.data, c.version) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "cidr",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty()) : c.kind === "base64" ? $aec35899a3c9695e$var$Jb.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "base64",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty()) : c.kind === "base64url" ? $aec35899a3c9695e$var$Qb.test(e.data) || (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            validation: "base64url",
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            message: c.message
        }), i.dirty()) : $aec35899a3c9695e$var$me.util.assertNever(c);
        return {
            status: i.value,
            value: e.data
        };
    }
    _regex(e, r, i) {
        return this.refinement((a)=>e.test(a), {
            validation: r,
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_string,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(i)
        });
    }
    _addCheck(e) {
        return new $aec35899a3c9695e$var$Mr({
            ...this._def,
            checks: [
                ...this._def.checks,
                e
            ]
        });
    }
    email(e) {
        return this._addCheck({
            kind: "email",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    url(e) {
        return this._addCheck({
            kind: "url",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    emoji(e) {
        return this._addCheck({
            kind: "emoji",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    uuid(e) {
        return this._addCheck({
            kind: "uuid",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    nanoid(e) {
        return this._addCheck({
            kind: "nanoid",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    cuid(e) {
        return this._addCheck({
            kind: "cuid",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    cuid2(e) {
        return this._addCheck({
            kind: "cuid2",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    ulid(e) {
        return this._addCheck({
            kind: "ulid",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    base64(e) {
        return this._addCheck({
            kind: "base64",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    base64url(e) {
        return this._addCheck({
            kind: "base64url",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    jwt(e) {
        return this._addCheck({
            kind: "jwt",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    ip(e) {
        return this._addCheck({
            kind: "ip",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    cidr(e) {
        return this._addCheck({
            kind: "cidr",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    datetime(e) {
        var r, i;
        return typeof e == "string" ? this._addCheck({
            kind: "datetime",
            precision: null,
            offset: !1,
            local: !1,
            message: e
        }) : this._addCheck({
            kind: "datetime",
            precision: typeof e?.precision > "u" ? null : e?.precision,
            offset: (r = e?.offset) !== null && r !== void 0 ? r : !1,
            local: (i = e?.local) !== null && i !== void 0 ? i : !1,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e?.message)
        });
    }
    date(e) {
        return this._addCheck({
            kind: "date",
            message: e
        });
    }
    time(e) {
        return typeof e == "string" ? this._addCheck({
            kind: "time",
            precision: null,
            message: e
        }) : this._addCheck({
            kind: "time",
            precision: typeof e?.precision > "u" ? null : e?.precision,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e?.message)
        });
    }
    duration(e) {
        return this._addCheck({
            kind: "duration",
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(e)
        });
    }
    regex(e, r) {
        return this._addCheck({
            kind: "regex",
            regex: e,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(r)
        });
    }
    includes(e, r) {
        return this._addCheck({
            kind: "includes",
            value: e,
            position: r?.position,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(r?.message)
        });
    }
    startsWith(e, r) {
        return this._addCheck({
            kind: "startsWith",
            value: e,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(r)
        });
    }
    endsWith(e, r) {
        return this._addCheck({
            kind: "endsWith",
            value: e,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(r)
        });
    }
    min(e, r) {
        return this._addCheck({
            kind: "min",
            value: e,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(r)
        });
    }
    max(e, r) {
        return this._addCheck({
            kind: "max",
            value: e,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(r)
        });
    }
    length(e, r) {
        return this._addCheck({
            kind: "length",
            value: e,
            ...$aec35899a3c9695e$var$ve.errorUtil.errToObj(r)
        });
    }
    /**
   * Equivalent to `.min(1)`
   */ nonempty(e) {
        return this.min(1, $aec35899a3c9695e$var$ve.errorUtil.errToObj(e));
    }
    trim() {
        return new $aec35899a3c9695e$var$Mr({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $aec35899a3c9695e$var$Mr({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $aec35899a3c9695e$var$Mr({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((e)=>e.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((e)=>e.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((e)=>e.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((e)=>e.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((e)=>e.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((e)=>e.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((e)=>e.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((e)=>e.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((e)=>e.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((e)=>e.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((e)=>e.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((e)=>e.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((e)=>e.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((e)=>e.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((e)=>e.kind === "base64");
    }
    get isBase64url() {
        return !!this._def.checks.find((e)=>e.kind === "base64url");
    }
    get minLength() {
        let e = null;
        for (const r of this._def.checks)r.kind === "min" && (e === null || r.value > e) && (e = r.value);
        return e;
    }
    get maxLength() {
        let e = null;
        for (const r of this._def.checks)r.kind === "max" && (e === null || r.value < e) && (e = r.value);
        return e;
    }
}
$aec35899a3c9695e$var$j.ZodString = $aec35899a3c9695e$var$Mr;
$aec35899a3c9695e$var$Mr.create = (t)=>{
    var e;
    return new $aec35899a3c9695e$var$Mr({
        checks: [],
        typeName: $aec35899a3c9695e$var$ke.ZodString,
        coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
        ...$aec35899a3c9695e$var$Me(t)
    });
};
function $aec35899a3c9695e$var$sg(t, e) {
    const r = (t.toString().split(".")[1] || "").length, i = (e.toString().split(".")[1] || "").length, a = r > i ? r : i, c = parseInt(t.toFixed(a).replace(".", "")), h = parseInt(e.toFixed(a).replace(".", ""));
    return c % h / Math.pow(10, a);
}
class $aec35899a3c9695e$var$dn extends $aec35899a3c9695e$var$je {
    constructor(){
        super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
    }
    _parse(e) {
        if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.number) {
            const c = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(c, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.number,
                received: c.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        let i;
        const a = new $aec35899a3c9695e$var$$.ParseStatus();
        for (const c of this._def.checks)c.kind === "int" ? $aec35899a3c9695e$var$me.util.isInteger(e.data) || (i = this._getOrReturnCtx(e, i), (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: c.message
        }), a.dirty()) : c.kind === "min" ? (c.inclusive ? e.data < c.value : e.data <= c.value) && (i = this._getOrReturnCtx(e, i), (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_small,
            minimum: c.value,
            type: "number",
            inclusive: c.inclusive,
            exact: !1,
            message: c.message
        }), a.dirty()) : c.kind === "max" ? (c.inclusive ? e.data > c.value : e.data >= c.value) && (i = this._getOrReturnCtx(e, i), (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_big,
            maximum: c.value,
            type: "number",
            inclusive: c.inclusive,
            exact: !1,
            message: c.message
        }), a.dirty()) : c.kind === "multipleOf" ? $aec35899a3c9695e$var$sg(e.data, c.value) !== 0 && (i = this._getOrReturnCtx(e, i), (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.not_multiple_of,
            multipleOf: c.value,
            message: c.message
        }), a.dirty()) : c.kind === "finite" ? Number.isFinite(e.data) || (i = this._getOrReturnCtx(e, i), (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.not_finite,
            message: c.message
        }), a.dirty()) : $aec35899a3c9695e$var$me.util.assertNever(c);
        return {
            status: a.value,
            value: e.data
        };
    }
    gte(e, r) {
        return this.setLimit("min", e, !0, $aec35899a3c9695e$var$ve.errorUtil.toString(r));
    }
    gt(e, r) {
        return this.setLimit("min", e, !1, $aec35899a3c9695e$var$ve.errorUtil.toString(r));
    }
    lte(e, r) {
        return this.setLimit("max", e, !0, $aec35899a3c9695e$var$ve.errorUtil.toString(r));
    }
    lt(e, r) {
        return this.setLimit("max", e, !1, $aec35899a3c9695e$var$ve.errorUtil.toString(r));
    }
    setLimit(e, r, i, a) {
        return new $aec35899a3c9695e$var$dn({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: e,
                    value: r,
                    inclusive: i,
                    message: $aec35899a3c9695e$var$ve.errorUtil.toString(a)
                }
            ]
        });
    }
    _addCheck(e) {
        return new $aec35899a3c9695e$var$dn({
            ...this._def,
            checks: [
                ...this._def.checks,
                e
            ]
        });
    }
    int(e) {
        return this._addCheck({
            kind: "int",
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    positive(e) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: !1,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    negative(e) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: !1,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    nonpositive(e) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: !0,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    nonnegative(e) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: !0,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    multipleOf(e, r) {
        return this._addCheck({
            kind: "multipleOf",
            value: e,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(r)
        });
    }
    finite(e) {
        return this._addCheck({
            kind: "finite",
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    safe(e) {
        return this._addCheck({
            kind: "min",
            inclusive: !0,
            value: Number.MIN_SAFE_INTEGER,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        })._addCheck({
            kind: "max",
            inclusive: !0,
            value: Number.MAX_SAFE_INTEGER,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    get minValue() {
        let e = null;
        for (const r of this._def.checks)r.kind === "min" && (e === null || r.value > e) && (e = r.value);
        return e;
    }
    get maxValue() {
        let e = null;
        for (const r of this._def.checks)r.kind === "max" && (e === null || r.value < e) && (e = r.value);
        return e;
    }
    get isInt() {
        return !!this._def.checks.find((e)=>e.kind === "int" || e.kind === "multipleOf" && $aec35899a3c9695e$var$me.util.isInteger(e.value));
    }
    get isFinite() {
        let e = null, r = null;
        for (const i of this._def.checks){
            if (i.kind === "finite" || i.kind === "int" || i.kind === "multipleOf") return !0;
            i.kind === "min" ? (r === null || i.value > r) && (r = i.value) : i.kind === "max" && (e === null || i.value < e) && (e = i.value);
        }
        return Number.isFinite(r) && Number.isFinite(e);
    }
}
$aec35899a3c9695e$var$j.ZodNumber = $aec35899a3c9695e$var$dn;
$aec35899a3c9695e$var$dn.create = (t)=>new $aec35899a3c9695e$var$dn({
        checks: [],
        typeName: $aec35899a3c9695e$var$ke.ZodNumber,
        coerce: t?.coerce || !1,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$fn extends $aec35899a3c9695e$var$je {
    constructor(){
        super(...arguments), this.min = this.gte, this.max = this.lte;
    }
    _parse(e) {
        if (this._def.coerce) try {
            e.data = BigInt(e.data);
        } catch  {
            return this._getInvalidInput(e);
        }
        if (this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.bigint) return this._getInvalidInput(e);
        let i;
        const a = new $aec35899a3c9695e$var$$.ParseStatus();
        for (const c of this._def.checks)c.kind === "min" ? (c.inclusive ? e.data < c.value : e.data <= c.value) && (i = this._getOrReturnCtx(e, i), (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_small,
            type: "bigint",
            minimum: c.value,
            inclusive: c.inclusive,
            message: c.message
        }), a.dirty()) : c.kind === "max" ? (c.inclusive ? e.data > c.value : e.data >= c.value) && (i = this._getOrReturnCtx(e, i), (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_big,
            type: "bigint",
            maximum: c.value,
            inclusive: c.inclusive,
            message: c.message
        }), a.dirty()) : c.kind === "multipleOf" ? e.data % c.value !== BigInt(0) && (i = this._getOrReturnCtx(e, i), (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.not_multiple_of,
            multipleOf: c.value,
            message: c.message
        }), a.dirty()) : $aec35899a3c9695e$var$me.util.assertNever(c);
        return {
            status: a.value,
            value: e.data
        };
    }
    _getInvalidInput(e) {
        const r = this._getOrReturnCtx(e);
        return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.bigint,
            received: r.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
    }
    gte(e, r) {
        return this.setLimit("min", e, !0, $aec35899a3c9695e$var$ve.errorUtil.toString(r));
    }
    gt(e, r) {
        return this.setLimit("min", e, !1, $aec35899a3c9695e$var$ve.errorUtil.toString(r));
    }
    lte(e, r) {
        return this.setLimit("max", e, !0, $aec35899a3c9695e$var$ve.errorUtil.toString(r));
    }
    lt(e, r) {
        return this.setLimit("max", e, !1, $aec35899a3c9695e$var$ve.errorUtil.toString(r));
    }
    setLimit(e, r, i, a) {
        return new $aec35899a3c9695e$var$fn({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: e,
                    value: r,
                    inclusive: i,
                    message: $aec35899a3c9695e$var$ve.errorUtil.toString(a)
                }
            ]
        });
    }
    _addCheck(e) {
        return new $aec35899a3c9695e$var$fn({
            ...this._def,
            checks: [
                ...this._def.checks,
                e
            ]
        });
    }
    positive(e) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: !1,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    negative(e) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: !1,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    nonpositive(e) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: !0,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    nonnegative(e) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: !0,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(e)
        });
    }
    multipleOf(e, r) {
        return this._addCheck({
            kind: "multipleOf",
            value: e,
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(r)
        });
    }
    get minValue() {
        let e = null;
        for (const r of this._def.checks)r.kind === "min" && (e === null || r.value > e) && (e = r.value);
        return e;
    }
    get maxValue() {
        let e = null;
        for (const r of this._def.checks)r.kind === "max" && (e === null || r.value < e) && (e = r.value);
        return e;
    }
}
$aec35899a3c9695e$var$j.ZodBigInt = $aec35899a3c9695e$var$fn;
$aec35899a3c9695e$var$fn.create = (t)=>{
    var e;
    return new $aec35899a3c9695e$var$fn({
        checks: [],
        typeName: $aec35899a3c9695e$var$ke.ZodBigInt,
        coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
        ...$aec35899a3c9695e$var$Me(t)
    });
};
class $aec35899a3c9695e$var$ua extends $aec35899a3c9695e$var$je {
    _parse(e) {
        if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.boolean) {
            const i = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.boolean,
                received: i.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        return (0, $aec35899a3c9695e$var$$.OK)(e.data);
    }
}
$aec35899a3c9695e$var$j.ZodBoolean = $aec35899a3c9695e$var$ua;
$aec35899a3c9695e$var$ua.create = (t)=>new $aec35899a3c9695e$var$ua({
        typeName: $aec35899a3c9695e$var$ke.ZodBoolean,
        coerce: t?.coerce || !1,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$Kn extends $aec35899a3c9695e$var$je {
    _parse(e) {
        if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.date) {
            const c = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(c, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.date,
                received: c.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        if (isNaN(e.data.getTime())) {
            const c = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(c, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_date
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        const i = new $aec35899a3c9695e$var$$.ParseStatus();
        let a;
        for (const c of this._def.checks)c.kind === "min" ? e.data.getTime() < c.value && (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_small,
            message: c.message,
            inclusive: !0,
            exact: !1,
            minimum: c.value,
            type: "date"
        }), i.dirty()) : c.kind === "max" ? e.data.getTime() > c.value && (a = this._getOrReturnCtx(e, a), (0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_big,
            message: c.message,
            inclusive: !0,
            exact: !1,
            maximum: c.value,
            type: "date"
        }), i.dirty()) : $aec35899a3c9695e$var$me.util.assertNever(c);
        return {
            status: i.value,
            value: new Date(e.data.getTime())
        };
    }
    _addCheck(e) {
        return new $aec35899a3c9695e$var$Kn({
            ...this._def,
            checks: [
                ...this._def.checks,
                e
            ]
        });
    }
    min(e, r) {
        return this._addCheck({
            kind: "min",
            value: e.getTime(),
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(r)
        });
    }
    max(e, r) {
        return this._addCheck({
            kind: "max",
            value: e.getTime(),
            message: $aec35899a3c9695e$var$ve.errorUtil.toString(r)
        });
    }
    get minDate() {
        let e = null;
        for (const r of this._def.checks)r.kind === "min" && (e === null || r.value > e) && (e = r.value);
        return e != null ? new Date(e) : null;
    }
    get maxDate() {
        let e = null;
        for (const r of this._def.checks)r.kind === "max" && (e === null || r.value < e) && (e = r.value);
        return e != null ? new Date(e) : null;
    }
}
$aec35899a3c9695e$var$j.ZodDate = $aec35899a3c9695e$var$Kn;
$aec35899a3c9695e$var$Kn.create = (t)=>new $aec35899a3c9695e$var$Kn({
        checks: [],
        coerce: t?.coerce || !1,
        typeName: $aec35899a3c9695e$var$ke.ZodDate,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$pu extends $aec35899a3c9695e$var$je {
    _parse(e) {
        if (this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.symbol) {
            const i = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.symbol,
                received: i.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        return (0, $aec35899a3c9695e$var$$.OK)(e.data);
    }
}
$aec35899a3c9695e$var$j.ZodSymbol = $aec35899a3c9695e$var$pu;
$aec35899a3c9695e$var$pu.create = (t)=>new $aec35899a3c9695e$var$pu({
        typeName: $aec35899a3c9695e$var$ke.ZodSymbol,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$ca extends $aec35899a3c9695e$var$je {
    _parse(e) {
        if (this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.undefined) {
            const i = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.undefined,
                received: i.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        return (0, $aec35899a3c9695e$var$$.OK)(e.data);
    }
}
$aec35899a3c9695e$var$j.ZodUndefined = $aec35899a3c9695e$var$ca;
$aec35899a3c9695e$var$ca.create = (t)=>new $aec35899a3c9695e$var$ca({
        typeName: $aec35899a3c9695e$var$ke.ZodUndefined,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$da extends $aec35899a3c9695e$var$je {
    _parse(e) {
        if (this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.null) {
            const i = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.null,
                received: i.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        return (0, $aec35899a3c9695e$var$$.OK)(e.data);
    }
}
$aec35899a3c9695e$var$j.ZodNull = $aec35899a3c9695e$var$da;
$aec35899a3c9695e$var$da.create = (t)=>new $aec35899a3c9695e$var$da({
        typeName: $aec35899a3c9695e$var$ke.ZodNull,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$vs extends $aec35899a3c9695e$var$je {
    constructor(){
        super(...arguments), this._any = !0;
    }
    _parse(e) {
        return (0, $aec35899a3c9695e$var$$.OK)(e.data);
    }
}
$aec35899a3c9695e$var$j.ZodAny = $aec35899a3c9695e$var$vs;
$aec35899a3c9695e$var$vs.create = (t)=>new $aec35899a3c9695e$var$vs({
        typeName: $aec35899a3c9695e$var$ke.ZodAny,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$On extends $aec35899a3c9695e$var$je {
    constructor(){
        super(...arguments), this._unknown = !0;
    }
    _parse(e) {
        return (0, $aec35899a3c9695e$var$$.OK)(e.data);
    }
}
$aec35899a3c9695e$var$j.ZodUnknown = $aec35899a3c9695e$var$On;
$aec35899a3c9695e$var$On.create = (t)=>new $aec35899a3c9695e$var$On({
        typeName: $aec35899a3c9695e$var$ke.ZodUnknown,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$en extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const r = this._getOrReturnCtx(e);
        return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.never,
            received: r.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
    }
}
$aec35899a3c9695e$var$j.ZodNever = $aec35899a3c9695e$var$en;
$aec35899a3c9695e$var$en.create = (t)=>new $aec35899a3c9695e$var$en({
        typeName: $aec35899a3c9695e$var$ke.ZodNever,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$hu extends $aec35899a3c9695e$var$je {
    _parse(e) {
        if (this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.undefined) {
            const i = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.void,
                received: i.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        return (0, $aec35899a3c9695e$var$$.OK)(e.data);
    }
}
$aec35899a3c9695e$var$j.ZodVoid = $aec35899a3c9695e$var$hu;
$aec35899a3c9695e$var$hu.create = (t)=>new $aec35899a3c9695e$var$hu({
        typeName: $aec35899a3c9695e$var$ke.ZodVoid,
        ...$aec35899a3c9695e$var$Me(t)
    });
class $aec35899a3c9695e$var$Gr extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { ctx: r, status: i } = this._processInputParams(e), a = this._def;
        if (r.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.array) return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.array,
            received: r.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
        if (a.exactLength !== null) {
            const h = r.data.length > a.exactLength.value, m = r.data.length < a.exactLength.value;
            (h || m) && ((0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
                code: h ? $aec35899a3c9695e$var$de.ZodIssueCode.too_big : $aec35899a3c9695e$var$de.ZodIssueCode.too_small,
                minimum: m ? a.exactLength.value : void 0,
                maximum: h ? a.exactLength.value : void 0,
                type: "array",
                inclusive: !0,
                exact: !0,
                message: a.exactLength.message
            }), i.dirty());
        }
        if (a.minLength !== null && r.data.length < a.minLength.value && ((0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_small,
            minimum: a.minLength.value,
            type: "array",
            inclusive: !0,
            exact: !1,
            message: a.minLength.message
        }), i.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && ((0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_big,
            maximum: a.maxLength.value,
            type: "array",
            inclusive: !0,
            exact: !1,
            message: a.maxLength.message
        }), i.dirty()), r.common.async) return Promise.all([
            ...r.data
        ].map((h, m)=>a.type._parseAsync(new $aec35899a3c9695e$var$pi(r, h, r.path, m)))).then((h)=>$aec35899a3c9695e$var$$.ParseStatus.mergeArray(i, h));
        const c = [
            ...r.data
        ].map((h, m)=>a.type._parseSync(new $aec35899a3c9695e$var$pi(r, h, r.path, m)));
        return $aec35899a3c9695e$var$$.ParseStatus.mergeArray(i, c);
    }
    get element() {
        return this._def.type;
    }
    min(e, r) {
        return new $aec35899a3c9695e$var$Gr({
            ...this._def,
            minLength: {
                value: e,
                message: $aec35899a3c9695e$var$ve.errorUtil.toString(r)
            }
        });
    }
    max(e, r) {
        return new $aec35899a3c9695e$var$Gr({
            ...this._def,
            maxLength: {
                value: e,
                message: $aec35899a3c9695e$var$ve.errorUtil.toString(r)
            }
        });
    }
    length(e, r) {
        return new $aec35899a3c9695e$var$Gr({
            ...this._def,
            exactLength: {
                value: e,
                message: $aec35899a3c9695e$var$ve.errorUtil.toString(r)
            }
        });
    }
    nonempty(e) {
        return this.min(1, e);
    }
}
$aec35899a3c9695e$var$j.ZodArray = $aec35899a3c9695e$var$Gr;
$aec35899a3c9695e$var$Gr.create = (t, e)=>new $aec35899a3c9695e$var$Gr({
        type: t,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $aec35899a3c9695e$var$ke.ZodArray,
        ...$aec35899a3c9695e$var$Me(e)
    });
function $aec35899a3c9695e$var$ys(t) {
    if (t instanceof $aec35899a3c9695e$var$yt) {
        const e = {};
        for(const r in t.shape){
            const i = t.shape[r];
            e[r] = $aec35899a3c9695e$var$fi.create($aec35899a3c9695e$var$ys(i));
        }
        return new $aec35899a3c9695e$var$yt({
            ...t._def,
            shape: ()=>e
        });
    } else return t instanceof $aec35899a3c9695e$var$Gr ? new $aec35899a3c9695e$var$Gr({
        ...t._def,
        type: $aec35899a3c9695e$var$ys(t.element)
    }) : t instanceof $aec35899a3c9695e$var$fi ? $aec35899a3c9695e$var$fi.create($aec35899a3c9695e$var$ys(t.unwrap())) : t instanceof $aec35899a3c9695e$var$hn ? $aec35899a3c9695e$var$hn.create($aec35899a3c9695e$var$ys(t.unwrap())) : t instanceof $aec35899a3c9695e$var$hi ? $aec35899a3c9695e$var$hi.create(t.items.map((e)=>$aec35899a3c9695e$var$ys(e))) : t;
}
class $aec35899a3c9695e$var$yt extends $aec35899a3c9695e$var$je {
    constructor(){
        super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const e = this._def.shape(), r = $aec35899a3c9695e$var$me.util.objectKeys(e);
        return this._cached = {
            shape: e,
            keys: r
        };
    }
    _parse(e) {
        if (this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.object) {
            const y = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(y, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.object,
                received: y.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        const { status: i, ctx: a } = this._processInputParams(e), { shape: c, keys: h } = this._getCached(), m = [];
        if (!(this._def.catchall instanceof $aec35899a3c9695e$var$en && this._def.unknownKeys === "strip")) for(const y in a.data)h.includes(y) || m.push(y);
        const p = [];
        for (const y of h){
            const d = c[y], v = a.data[y];
            p.push({
                key: {
                    status: "valid",
                    value: y
                },
                value: d._parse(new $aec35899a3c9695e$var$pi(a, v, a.path, y)),
                alwaysSet: y in a.data
            });
        }
        if (this._def.catchall instanceof $aec35899a3c9695e$var$en) {
            const y = this._def.unknownKeys;
            if (y === "passthrough") for (const d of m)p.push({
                key: {
                    status: "valid",
                    value: d
                },
                value: {
                    status: "valid",
                    value: a.data[d]
                }
            });
            else if (y === "strict") m.length > 0 && ((0, $aec35899a3c9695e$var$$.addIssueToContext)(a, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.unrecognized_keys,
                keys: m
            }), i.dirty());
            else if (y !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
        } else {
            const y = this._def.catchall;
            for (const d of m){
                const v = a.data[d];
                p.push({
                    key: {
                        status: "valid",
                        value: d
                    },
                    value: y._parse(new $aec35899a3c9695e$var$pi(a, v, a.path, d)),
                    alwaysSet: d in a.data
                });
            }
        }
        return a.common.async ? Promise.resolve().then(async ()=>{
            const y = [];
            for (const d of p){
                const v = await d.key, P = await d.value;
                y.push({
                    key: v,
                    value: P,
                    alwaysSet: d.alwaysSet
                });
            }
            return y;
        }).then((y)=>$aec35899a3c9695e$var$$.ParseStatus.mergeObjectSync(i, y)) : $aec35899a3c9695e$var$$.ParseStatus.mergeObjectSync(i, p);
    }
    get shape() {
        return this._def.shape();
    }
    strict(e) {
        return $aec35899a3c9695e$var$ve.errorUtil.errToObj, new $aec35899a3c9695e$var$yt({
            ...this._def,
            unknownKeys: "strict",
            ...e !== void 0 ? {
                errorMap: (r, i)=>{
                    var a, c, h, m;
                    const p = (h = (c = (a = this._def).errorMap) === null || c === void 0 ? void 0 : c.call(a, r, i).message) !== null && h !== void 0 ? h : i.defaultError;
                    return r.code === "unrecognized_keys" ? {
                        message: (m = $aec35899a3c9695e$var$ve.errorUtil.errToObj(e).message) !== null && m !== void 0 ? m : p
                    } : {
                        message: p
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $aec35899a3c9695e$var$yt({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $aec35899a3c9695e$var$yt({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(e) {
        return new $aec35899a3c9695e$var$yt({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...e
                })
        });
    }
    /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */ merge(e) {
        return new $aec35899a3c9695e$var$yt({
            unknownKeys: e._def.unknownKeys,
            catchall: e._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...e._def.shape()
                }),
            typeName: $aec35899a3c9695e$var$ke.ZodObject
        });
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(e, r) {
        return this.augment({
            [e]: r
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(e) {
        return new $aec35899a3c9695e$var$yt({
            ...this._def,
            catchall: e
        });
    }
    pick(e) {
        const r = {};
        return $aec35899a3c9695e$var$me.util.objectKeys(e).forEach((i)=>{
            e[i] && this.shape[i] && (r[i] = this.shape[i]);
        }), new $aec35899a3c9695e$var$yt({
            ...this._def,
            shape: ()=>r
        });
    }
    omit(e) {
        const r = {};
        return $aec35899a3c9695e$var$me.util.objectKeys(this.shape).forEach((i)=>{
            e[i] || (r[i] = this.shape[i]);
        }), new $aec35899a3c9695e$var$yt({
            ...this._def,
            shape: ()=>r
        });
    }
    /**
   * @deprecated
   */ deepPartial() {
        return $aec35899a3c9695e$var$ys(this);
    }
    partial(e) {
        const r = {};
        return $aec35899a3c9695e$var$me.util.objectKeys(this.shape).forEach((i)=>{
            const a = this.shape[i];
            e && !e[i] ? r[i] = a : r[i] = a.optional();
        }), new $aec35899a3c9695e$var$yt({
            ...this._def,
            shape: ()=>r
        });
    }
    required(e) {
        const r = {};
        return $aec35899a3c9695e$var$me.util.objectKeys(this.shape).forEach((i)=>{
            if (e && !e[i]) r[i] = this.shape[i];
            else {
                let c = this.shape[i];
                for(; c instanceof $aec35899a3c9695e$var$fi;)c = c._def.innerType;
                r[i] = c;
            }
        }), new $aec35899a3c9695e$var$yt({
            ...this._def,
            shape: ()=>r
        });
    }
    keyof() {
        return $aec35899a3c9695e$var$up($aec35899a3c9695e$var$me.util.objectKeys(this.shape));
    }
}
$aec35899a3c9695e$var$j.ZodObject = $aec35899a3c9695e$var$yt;
$aec35899a3c9695e$var$yt.create = (t, e)=>new $aec35899a3c9695e$var$yt({
        shape: ()=>t,
        unknownKeys: "strip",
        catchall: $aec35899a3c9695e$var$en.create(),
        typeName: $aec35899a3c9695e$var$ke.ZodObject,
        ...$aec35899a3c9695e$var$Me(e)
    });
$aec35899a3c9695e$var$yt.strictCreate = (t, e)=>new $aec35899a3c9695e$var$yt({
        shape: ()=>t,
        unknownKeys: "strict",
        catchall: $aec35899a3c9695e$var$en.create(),
        typeName: $aec35899a3c9695e$var$ke.ZodObject,
        ...$aec35899a3c9695e$var$Me(e)
    });
$aec35899a3c9695e$var$yt.lazycreate = (t, e)=>new $aec35899a3c9695e$var$yt({
        shape: t,
        unknownKeys: "strip",
        catchall: $aec35899a3c9695e$var$en.create(),
        typeName: $aec35899a3c9695e$var$ke.ZodObject,
        ...$aec35899a3c9695e$var$Me(e)
    });
class $aec35899a3c9695e$var$fa extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { ctx: r } = this._processInputParams(e), i = this._def.options;
        function a(c) {
            for (const m of c)if (m.result.status === "valid") return m.result;
            for (const m of c)if (m.result.status === "dirty") return r.common.issues.push(...m.ctx.common.issues), m.result;
            const h = c.map((m)=>new $aec35899a3c9695e$var$de.ZodError(m.ctx.common.issues));
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_union,
                unionErrors: h
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        if (r.common.async) return Promise.all(i.map(async (c)=>{
            const h = {
                ...r,
                common: {
                    ...r.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await c._parseAsync({
                    data: r.data,
                    path: r.path,
                    parent: h
                }),
                ctx: h
            };
        })).then(a);
        {
            let c;
            const h = [];
            for (const p of i){
                const y = {
                    ...r,
                    common: {
                        ...r.common,
                        issues: []
                    },
                    parent: null
                }, d = p._parseSync({
                    data: r.data,
                    path: r.path,
                    parent: y
                });
                if (d.status === "valid") return d;
                d.status === "dirty" && !c && (c = {
                    result: d,
                    ctx: y
                }), y.common.issues.length && h.push(y.common.issues);
            }
            if (c) return r.common.issues.push(...c.ctx.common.issues), c.result;
            const m = h.map((p)=>new $aec35899a3c9695e$var$de.ZodError(p));
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_union,
                unionErrors: m
            }), $aec35899a3c9695e$var$$.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
$aec35899a3c9695e$var$j.ZodUnion = $aec35899a3c9695e$var$fa;
$aec35899a3c9695e$var$fa.create = (t, e)=>new $aec35899a3c9695e$var$fa({
        options: t,
        typeName: $aec35899a3c9695e$var$ke.ZodUnion,
        ...$aec35899a3c9695e$var$Me(e)
    });
const $aec35899a3c9695e$var$ki = (t)=>t instanceof $aec35899a3c9695e$var$ma ? $aec35899a3c9695e$var$ki(t.schema) : t instanceof $aec35899a3c9695e$var$qr ? $aec35899a3c9695e$var$ki(t.innerType()) : t instanceof $aec35899a3c9695e$var$ya ? [
        t.value
    ] : t instanceof $aec35899a3c9695e$var$pn ? t.options : t instanceof $aec35899a3c9695e$var$ba ? $aec35899a3c9695e$var$me.util.objectValues(t.enum) : t instanceof $aec35899a3c9695e$var$ga ? $aec35899a3c9695e$var$ki(t._def.innerType) : t instanceof $aec35899a3c9695e$var$ca ? [
        void 0
    ] : t instanceof $aec35899a3c9695e$var$da ? [
        null
    ] : t instanceof $aec35899a3c9695e$var$fi ? [
        void 0,
        ...$aec35899a3c9695e$var$ki(t.unwrap())
    ] : t instanceof $aec35899a3c9695e$var$hn ? [
        null,
        ...$aec35899a3c9695e$var$ki(t.unwrap())
    ] : t instanceof $aec35899a3c9695e$var$Kc || t instanceof $aec35899a3c9695e$var$Ea ? $aec35899a3c9695e$var$ki(t.unwrap()) : t instanceof $aec35899a3c9695e$var$xa ? $aec35899a3c9695e$var$ki(t._def.innerType) : [];
class $aec35899a3c9695e$var$Pu extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { ctx: r } = this._processInputParams(e);
        if (r.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.object) return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.object,
            received: r.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
        const i = this.discriminator, a = r.data[i], c = this.optionsMap.get(a);
        return c ? r.common.async ? c._parseAsync({
            data: r.data,
            path: r.path,
            parent: r
        }) : c._parseSync({
            data: r.data,
            path: r.path,
            parent: r
        }) : ((0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_union_discriminator,
            options: Array.from(this.optionsMap.keys()),
            path: [
                i
            ]
        }), $aec35899a3c9695e$var$$.INVALID);
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */ static create(e, r, i) {
        const a = /* @__PURE__ */ new Map();
        for (const c of r){
            const h = $aec35899a3c9695e$var$ki(c.shape[e]);
            if (!h.length) throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
            for (const m of h){
                if (a.has(m)) throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(m)}`);
                a.set(m, c);
            }
        }
        return new $aec35899a3c9695e$var$Pu({
            typeName: $aec35899a3c9695e$var$ke.ZodDiscriminatedUnion,
            discriminator: e,
            options: r,
            optionsMap: a,
            ...$aec35899a3c9695e$var$Me(i)
        });
    }
}
$aec35899a3c9695e$var$j.ZodDiscriminatedUnion = $aec35899a3c9695e$var$Pu;
function $aec35899a3c9695e$var$Tc(t, e) {
    const r = (0, $aec35899a3c9695e$var$me.getParsedType)(t), i = (0, $aec35899a3c9695e$var$me.getParsedType)(e);
    if (t === e) return {
        valid: !0,
        data: t
    };
    if (r === $aec35899a3c9695e$var$me.ZodParsedType.object && i === $aec35899a3c9695e$var$me.ZodParsedType.object) {
        const a = $aec35899a3c9695e$var$me.util.objectKeys(e), c = $aec35899a3c9695e$var$me.util.objectKeys(t).filter((m)=>a.indexOf(m) !== -1), h = {
            ...t,
            ...e
        };
        for (const m of c){
            const p = $aec35899a3c9695e$var$Tc(t[m], e[m]);
            if (!p.valid) return {
                valid: !1
            };
            h[m] = p.data;
        }
        return {
            valid: !0,
            data: h
        };
    } else if (r === $aec35899a3c9695e$var$me.ZodParsedType.array && i === $aec35899a3c9695e$var$me.ZodParsedType.array) {
        if (t.length !== e.length) return {
            valid: !1
        };
        const a = [];
        for(let c = 0; c < t.length; c++){
            const h = t[c], m = e[c], p = $aec35899a3c9695e$var$Tc(h, m);
            if (!p.valid) return {
                valid: !1
            };
            a.push(p.data);
        }
        return {
            valid: !0,
            data: a
        };
    } else return r === $aec35899a3c9695e$var$me.ZodParsedType.date && i === $aec35899a3c9695e$var$me.ZodParsedType.date && +t == +e ? {
        valid: !0,
        data: t
    } : {
        valid: !1
    };
}
class $aec35899a3c9695e$var$pa extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { status: r, ctx: i } = this._processInputParams(e), a = (c, h)=>{
            if ((0, $aec35899a3c9695e$var$$.isAborted)(c) || (0, $aec35899a3c9695e$var$$.isAborted)(h)) return $aec35899a3c9695e$var$$.INVALID;
            const m = $aec35899a3c9695e$var$Tc(c.value, h.value);
            return m.valid ? (((0, $aec35899a3c9695e$var$$.isDirty)(c) || (0, $aec35899a3c9695e$var$$.isDirty)(h)) && r.dirty(), {
                status: r.value,
                value: m.data
            }) : ((0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_intersection_types
            }), $aec35899a3c9695e$var$$.INVALID);
        };
        return i.common.async ? Promise.all([
            this._def.left._parseAsync({
                data: i.data,
                path: i.path,
                parent: i
            }),
            this._def.right._parseAsync({
                data: i.data,
                path: i.path,
                parent: i
            })
        ]).then(([c, h])=>a(c, h)) : a(this._def.left._parseSync({
            data: i.data,
            path: i.path,
            parent: i
        }), this._def.right._parseSync({
            data: i.data,
            path: i.path,
            parent: i
        }));
    }
}
$aec35899a3c9695e$var$j.ZodIntersection = $aec35899a3c9695e$var$pa;
$aec35899a3c9695e$var$pa.create = (t, e, r)=>new $aec35899a3c9695e$var$pa({
        left: t,
        right: e,
        typeName: $aec35899a3c9695e$var$ke.ZodIntersection,
        ...$aec35899a3c9695e$var$Me(r)
    });
class $aec35899a3c9695e$var$hi extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { status: r, ctx: i } = this._processInputParams(e);
        if (i.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.array) return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.array,
            received: i.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
        if (i.data.length < this._def.items.length) return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_small,
            minimum: this._def.items.length,
            inclusive: !0,
            exact: !1,
            type: "array"
        }), $aec35899a3c9695e$var$$.INVALID;
        !this._def.rest && i.data.length > this._def.items.length && ((0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_big,
            maximum: this._def.items.length,
            inclusive: !0,
            exact: !1,
            type: "array"
        }), r.dirty());
        const c = [
            ...i.data
        ].map((h, m)=>{
            const p = this._def.items[m] || this._def.rest;
            return p ? p._parse(new $aec35899a3c9695e$var$pi(i, h, i.path, m)) : null;
        }).filter((h)=>!!h);
        return i.common.async ? Promise.all(c).then((h)=>$aec35899a3c9695e$var$$.ParseStatus.mergeArray(r, h)) : $aec35899a3c9695e$var$$.ParseStatus.mergeArray(r, c);
    }
    get items() {
        return this._def.items;
    }
    rest(e) {
        return new $aec35899a3c9695e$var$hi({
            ...this._def,
            rest: e
        });
    }
}
$aec35899a3c9695e$var$j.ZodTuple = $aec35899a3c9695e$var$hi;
$aec35899a3c9695e$var$hi.create = (t, e)=>{
    if (!Array.isArray(t)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $aec35899a3c9695e$var$hi({
        items: t,
        typeName: $aec35899a3c9695e$var$ke.ZodTuple,
        rest: null,
        ...$aec35899a3c9695e$var$Me(e)
    });
};
class $aec35899a3c9695e$var$ha extends $aec35899a3c9695e$var$je {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(e) {
        const { status: r, ctx: i } = this._processInputParams(e);
        if (i.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.object) return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.object,
            received: i.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
        const a = [], c = this._def.keyType, h = this._def.valueType;
        for(const m in i.data)a.push({
            key: c._parse(new $aec35899a3c9695e$var$pi(i, m, i.path, m)),
            value: h._parse(new $aec35899a3c9695e$var$pi(i, i.data[m], i.path, m)),
            alwaysSet: m in i.data
        });
        return i.common.async ? $aec35899a3c9695e$var$$.ParseStatus.mergeObjectAsync(r, a) : $aec35899a3c9695e$var$$.ParseStatus.mergeObjectSync(r, a);
    }
    get element() {
        return this._def.valueType;
    }
    static create(e, r, i) {
        return r instanceof $aec35899a3c9695e$var$je ? new $aec35899a3c9695e$var$ha({
            keyType: e,
            valueType: r,
            typeName: $aec35899a3c9695e$var$ke.ZodRecord,
            ...$aec35899a3c9695e$var$Me(i)
        }) : new $aec35899a3c9695e$var$ha({
            keyType: $aec35899a3c9695e$var$Mr.create(),
            valueType: e,
            typeName: $aec35899a3c9695e$var$ke.ZodRecord,
            ...$aec35899a3c9695e$var$Me(r)
        });
    }
}
$aec35899a3c9695e$var$j.ZodRecord = $aec35899a3c9695e$var$ha;
class $aec35899a3c9695e$var$mu extends $aec35899a3c9695e$var$je {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(e) {
        const { status: r, ctx: i } = this._processInputParams(e);
        if (i.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.map) return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.map,
            received: i.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
        const a = this._def.keyType, c = this._def.valueType, h = [
            ...i.data.entries()
        ].map(([m, p], y)=>({
                key: a._parse(new $aec35899a3c9695e$var$pi(i, m, i.path, [
                    y,
                    "key"
                ])),
                value: c._parse(new $aec35899a3c9695e$var$pi(i, p, i.path, [
                    y,
                    "value"
                ]))
            }));
        if (i.common.async) {
            const m = /* @__PURE__ */ new Map();
            return Promise.resolve().then(async ()=>{
                for (const p of h){
                    const y = await p.key, d = await p.value;
                    if (y.status === "aborted" || d.status === "aborted") return $aec35899a3c9695e$var$$.INVALID;
                    (y.status === "dirty" || d.status === "dirty") && r.dirty(), m.set(y.value, d.value);
                }
                return {
                    status: r.value,
                    value: m
                };
            });
        } else {
            const m = /* @__PURE__ */ new Map();
            for (const p of h){
                const y = p.key, d = p.value;
                if (y.status === "aborted" || d.status === "aborted") return $aec35899a3c9695e$var$$.INVALID;
                (y.status === "dirty" || d.status === "dirty") && r.dirty(), m.set(y.value, d.value);
            }
            return {
                status: r.value,
                value: m
            };
        }
    }
}
$aec35899a3c9695e$var$j.ZodMap = $aec35899a3c9695e$var$mu;
$aec35899a3c9695e$var$mu.create = (t, e, r)=>new $aec35899a3c9695e$var$mu({
        valueType: e,
        keyType: t,
        typeName: $aec35899a3c9695e$var$ke.ZodMap,
        ...$aec35899a3c9695e$var$Me(r)
    });
class $aec35899a3c9695e$var$Mn extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { status: r, ctx: i } = this._processInputParams(e);
        if (i.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.set) return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.set,
            received: i.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
        const a = this._def;
        a.minSize !== null && i.data.size < a.minSize.value && ((0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_small,
            minimum: a.minSize.value,
            type: "set",
            inclusive: !0,
            exact: !1,
            message: a.minSize.message
        }), r.dirty()), a.maxSize !== null && i.data.size > a.maxSize.value && ((0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.too_big,
            maximum: a.maxSize.value,
            type: "set",
            inclusive: !0,
            exact: !1,
            message: a.maxSize.message
        }), r.dirty());
        const c = this._def.valueType;
        function h(p) {
            const y = /* @__PURE__ */ new Set();
            for (const d of p){
                if (d.status === "aborted") return $aec35899a3c9695e$var$$.INVALID;
                d.status === "dirty" && r.dirty(), y.add(d.value);
            }
            return {
                status: r.value,
                value: y
            };
        }
        const m = [
            ...i.data.values()
        ].map((p, y)=>c._parse(new $aec35899a3c9695e$var$pi(i, p, i.path, y)));
        return i.common.async ? Promise.all(m).then((p)=>h(p)) : h(m);
    }
    min(e, r) {
        return new $aec35899a3c9695e$var$Mn({
            ...this._def,
            minSize: {
                value: e,
                message: $aec35899a3c9695e$var$ve.errorUtil.toString(r)
            }
        });
    }
    max(e, r) {
        return new $aec35899a3c9695e$var$Mn({
            ...this._def,
            maxSize: {
                value: e,
                message: $aec35899a3c9695e$var$ve.errorUtil.toString(r)
            }
        });
    }
    size(e, r) {
        return this.min(e, r).max(e, r);
    }
    nonempty(e) {
        return this.min(1, e);
    }
}
$aec35899a3c9695e$var$j.ZodSet = $aec35899a3c9695e$var$Mn;
$aec35899a3c9695e$var$Mn.create = (t, e)=>new $aec35899a3c9695e$var$Mn({
        valueType: t,
        minSize: null,
        maxSize: null,
        typeName: $aec35899a3c9695e$var$ke.ZodSet,
        ...$aec35899a3c9695e$var$Me(e)
    });
class $aec35899a3c9695e$var$xs extends $aec35899a3c9695e$var$je {
    constructor(){
        super(...arguments), this.validate = this.implement;
    }
    _parse(e) {
        const { ctx: r } = this._processInputParams(e);
        if (r.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.function) return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.function,
            received: r.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
        function i(m, p) {
            return (0, $aec35899a3c9695e$var$$.makeIssue)({
                data: m,
                path: r.path,
                errorMaps: [
                    r.common.contextualErrorMap,
                    r.schemaErrorMap,
                    (0, $aec35899a3c9695e$var$Jl.getErrorMap)(),
                    $aec35899a3c9695e$var$Jl.defaultErrorMap
                ].filter((y)=>!!y),
                issueData: {
                    code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_arguments,
                    argumentsError: p
                }
            });
        }
        function a(m, p) {
            return (0, $aec35899a3c9695e$var$$.makeIssue)({
                data: m,
                path: r.path,
                errorMaps: [
                    r.common.contextualErrorMap,
                    r.schemaErrorMap,
                    (0, $aec35899a3c9695e$var$Jl.getErrorMap)(),
                    $aec35899a3c9695e$var$Jl.defaultErrorMap
                ].filter((y)=>!!y),
                issueData: {
                    code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_return_type,
                    returnTypeError: p
                }
            });
        }
        const c = {
            errorMap: r.common.contextualErrorMap
        }, h = r.data;
        if (this._def.returns instanceof $aec35899a3c9695e$var$Rs) {
            const m = this;
            return (0, $aec35899a3c9695e$var$$.OK)(async function(...p) {
                const y = new $aec35899a3c9695e$var$de.ZodError([]), d = await m._def.args.parseAsync(p, c).catch((K)=>{
                    throw y.addIssue(i(p, K)), y;
                }), v = await Reflect.apply(h, this, d);
                return await m._def.returns._def.type.parseAsync(v, c).catch((K)=>{
                    throw y.addIssue(a(v, K)), y;
                });
            });
        } else {
            const m = this;
            return (0, $aec35899a3c9695e$var$$.OK)(function(...p) {
                const y = m._def.args.safeParse(p, c);
                if (!y.success) throw new $aec35899a3c9695e$var$de.ZodError([
                    i(p, y.error)
                ]);
                const d = Reflect.apply(h, this, y.data), v = m._def.returns.safeParse(d, c);
                if (!v.success) throw new $aec35899a3c9695e$var$de.ZodError([
                    a(d, v.error)
                ]);
                return v.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...e) {
        return new $aec35899a3c9695e$var$xs({
            ...this._def,
            args: $aec35899a3c9695e$var$hi.create(e).rest($aec35899a3c9695e$var$On.create())
        });
    }
    returns(e) {
        return new $aec35899a3c9695e$var$xs({
            ...this._def,
            returns: e
        });
    }
    implement(e) {
        return this.parse(e);
    }
    strictImplement(e) {
        return this.parse(e);
    }
    static create(e, r, i) {
        return new $aec35899a3c9695e$var$xs({
            args: e || $aec35899a3c9695e$var$hi.create([]).rest($aec35899a3c9695e$var$On.create()),
            returns: r || $aec35899a3c9695e$var$On.create(),
            typeName: $aec35899a3c9695e$var$ke.ZodFunction,
            ...$aec35899a3c9695e$var$Me(i)
        });
    }
}
$aec35899a3c9695e$var$j.ZodFunction = $aec35899a3c9695e$var$xs;
class $aec35899a3c9695e$var$ma extends $aec35899a3c9695e$var$je {
    get schema() {
        return this._def.getter();
    }
    _parse(e) {
        const { ctx: r } = this._processInputParams(e);
        return this._def.getter()._parse({
            data: r.data,
            path: r.path,
            parent: r
        });
    }
}
$aec35899a3c9695e$var$j.ZodLazy = $aec35899a3c9695e$var$ma;
$aec35899a3c9695e$var$ma.create = (t, e)=>new $aec35899a3c9695e$var$ma({
        getter: t,
        typeName: $aec35899a3c9695e$var$ke.ZodLazy,
        ...$aec35899a3c9695e$var$Me(e)
    });
class $aec35899a3c9695e$var$ya extends $aec35899a3c9695e$var$je {
    _parse(e) {
        if (e.data !== this._def.value) {
            const r = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
                received: r.data,
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_literal,
                expected: this._def.value
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        return {
            status: "valid",
            value: e.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$aec35899a3c9695e$var$j.ZodLiteral = $aec35899a3c9695e$var$ya;
$aec35899a3c9695e$var$ya.create = (t, e)=>new $aec35899a3c9695e$var$ya({
        value: t,
        typeName: $aec35899a3c9695e$var$ke.ZodLiteral,
        ...$aec35899a3c9695e$var$Me(e)
    });
function $aec35899a3c9695e$var$up(t, e) {
    return new $aec35899a3c9695e$var$pn({
        values: t,
        typeName: $aec35899a3c9695e$var$ke.ZodEnum,
        ...$aec35899a3c9695e$var$Me(e)
    });
}
class $aec35899a3c9695e$var$pn extends $aec35899a3c9695e$var$je {
    constructor(){
        super(...arguments), $aec35899a3c9695e$var$na.set(this, void 0);
    }
    _parse(e) {
        if (typeof e.data != "string") {
            const r = this._getOrReturnCtx(e), i = this._def.values;
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
                expected: $aec35899a3c9695e$var$me.util.joinValues(i),
                received: r.parsedType,
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        if ($aec35899a3c9695e$var$fu(this, $aec35899a3c9695e$var$na, "f") || $aec35899a3c9695e$var$sp(this, $aec35899a3c9695e$var$na, new Set(this._def.values), "f"), !$aec35899a3c9695e$var$fu(this, $aec35899a3c9695e$var$na, "f").has(e.data)) {
            const r = this._getOrReturnCtx(e), i = this._def.values;
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
                received: r.data,
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_enum_value,
                options: i
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        return (0, $aec35899a3c9695e$var$$.OK)(e.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const e = {};
        for (const r of this._def.values)e[r] = r;
        return e;
    }
    get Values() {
        const e = {};
        for (const r of this._def.values)e[r] = r;
        return e;
    }
    get Enum() {
        const e = {};
        for (const r of this._def.values)e[r] = r;
        return e;
    }
    extract(e, r = this._def) {
        return $aec35899a3c9695e$var$pn.create(e, {
            ...this._def,
            ...r
        });
    }
    exclude(e, r = this._def) {
        return $aec35899a3c9695e$var$pn.create(this.options.filter((i)=>!e.includes(i)), {
            ...this._def,
            ...r
        });
    }
}
$aec35899a3c9695e$var$j.ZodEnum = $aec35899a3c9695e$var$pn;
$aec35899a3c9695e$var$na = /* @__PURE__ */ new WeakMap();
$aec35899a3c9695e$var$pn.create = $aec35899a3c9695e$var$up;
class $aec35899a3c9695e$var$ba extends $aec35899a3c9695e$var$je {
    constructor(){
        super(...arguments), $aec35899a3c9695e$var$sa.set(this, void 0);
    }
    _parse(e) {
        const r = $aec35899a3c9695e$var$me.util.getValidEnumValues(this._def.values), i = this._getOrReturnCtx(e);
        if (i.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.string && i.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.number) {
            const a = $aec35899a3c9695e$var$me.util.objectValues(r);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
                expected: $aec35899a3c9695e$var$me.util.joinValues(a),
                received: i.parsedType,
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        if ($aec35899a3c9695e$var$fu(this, $aec35899a3c9695e$var$sa, "f") || $aec35899a3c9695e$var$sp(this, $aec35899a3c9695e$var$sa, new Set($aec35899a3c9695e$var$me.util.getValidEnumValues(this._def.values)), "f"), !$aec35899a3c9695e$var$fu(this, $aec35899a3c9695e$var$sa, "f").has(e.data)) {
            const a = $aec35899a3c9695e$var$me.util.objectValues(r);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
                received: i.data,
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_enum_value,
                options: a
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        return (0, $aec35899a3c9695e$var$$.OK)(e.data);
    }
    get enum() {
        return this._def.values;
    }
}
$aec35899a3c9695e$var$j.ZodNativeEnum = $aec35899a3c9695e$var$ba;
$aec35899a3c9695e$var$sa = /* @__PURE__ */ new WeakMap();
$aec35899a3c9695e$var$ba.create = (t, e)=>new $aec35899a3c9695e$var$ba({
        values: t,
        typeName: $aec35899a3c9695e$var$ke.ZodNativeEnum,
        ...$aec35899a3c9695e$var$Me(e)
    });
class $aec35899a3c9695e$var$Rs extends $aec35899a3c9695e$var$je {
    unwrap() {
        return this._def.type;
    }
    _parse(e) {
        const { ctx: r } = this._processInputParams(e);
        if (r.parsedType !== $aec35899a3c9695e$var$me.ZodParsedType.promise && r.common.async === !1) return (0, $aec35899a3c9695e$var$$.addIssueToContext)(r, {
            code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
            expected: $aec35899a3c9695e$var$me.ZodParsedType.promise,
            received: r.parsedType
        }), $aec35899a3c9695e$var$$.INVALID;
        const i = r.parsedType === $aec35899a3c9695e$var$me.ZodParsedType.promise ? r.data : Promise.resolve(r.data);
        return (0, $aec35899a3c9695e$var$$.OK)(i.then((a)=>this._def.type.parseAsync(a, {
                path: r.path,
                errorMap: r.common.contextualErrorMap
            })));
    }
}
$aec35899a3c9695e$var$j.ZodPromise = $aec35899a3c9695e$var$Rs;
$aec35899a3c9695e$var$Rs.create = (t, e)=>new $aec35899a3c9695e$var$Rs({
        type: t,
        typeName: $aec35899a3c9695e$var$ke.ZodPromise,
        ...$aec35899a3c9695e$var$Me(e)
    });
class $aec35899a3c9695e$var$qr extends $aec35899a3c9695e$var$je {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $aec35899a3c9695e$var$ke.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(e) {
        const { status: r, ctx: i } = this._processInputParams(e), a = this._def.effect || null, c = {
            addIssue: (h)=>{
                (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, h), h.fatal ? r.abort() : r.dirty();
            },
            get path () {
                return i.path;
            }
        };
        if (c.addIssue = c.addIssue.bind(c), a.type === "preprocess") {
            const h = a.transform(i.data, c);
            if (i.common.async) return Promise.resolve(h).then(async (m)=>{
                if (r.value === "aborted") return $aec35899a3c9695e$var$$.INVALID;
                const p = await this._def.schema._parseAsync({
                    data: m,
                    path: i.path,
                    parent: i
                });
                return p.status === "aborted" ? $aec35899a3c9695e$var$$.INVALID : p.status === "dirty" || r.value === "dirty" ? (0, $aec35899a3c9695e$var$$.DIRTY)(p.value) : p;
            });
            {
                if (r.value === "aborted") return $aec35899a3c9695e$var$$.INVALID;
                const m = this._def.schema._parseSync({
                    data: h,
                    path: i.path,
                    parent: i
                });
                return m.status === "aborted" ? $aec35899a3c9695e$var$$.INVALID : m.status === "dirty" || r.value === "dirty" ? (0, $aec35899a3c9695e$var$$.DIRTY)(m.value) : m;
            }
        }
        if (a.type === "refinement") {
            const h = (m)=>{
                const p = a.refinement(m, c);
                if (i.common.async) return Promise.resolve(p);
                if (p instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return m;
            };
            if (i.common.async === !1) {
                const m = this._def.schema._parseSync({
                    data: i.data,
                    path: i.path,
                    parent: i
                });
                return m.status === "aborted" ? $aec35899a3c9695e$var$$.INVALID : (m.status === "dirty" && r.dirty(), h(m.value), {
                    status: r.value,
                    value: m.value
                });
            } else return this._def.schema._parseAsync({
                data: i.data,
                path: i.path,
                parent: i
            }).then((m)=>m.status === "aborted" ? $aec35899a3c9695e$var$$.INVALID : (m.status === "dirty" && r.dirty(), h(m.value).then(()=>({
                        status: r.value,
                        value: m.value
                    }))));
        }
        if (a.type === "transform") {
            if (i.common.async === !1) {
                const h = this._def.schema._parseSync({
                    data: i.data,
                    path: i.path,
                    parent: i
                });
                if (!(0, $aec35899a3c9695e$var$$.isValid)(h)) return h;
                const m = a.transform(h.value, c);
                if (m instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
                return {
                    status: r.value,
                    value: m
                };
            } else return this._def.schema._parseAsync({
                data: i.data,
                path: i.path,
                parent: i
            }).then((h)=>(0, $aec35899a3c9695e$var$$.isValid)(h) ? Promise.resolve(a.transform(h.value, c)).then((m)=>({
                        status: r.value,
                        value: m
                    })) : h);
        }
        $aec35899a3c9695e$var$me.util.assertNever(a);
    }
}
$aec35899a3c9695e$var$j.ZodEffects = $aec35899a3c9695e$var$qr;
$aec35899a3c9695e$var$j.ZodTransformer = $aec35899a3c9695e$var$qr;
$aec35899a3c9695e$var$qr.create = (t, e, r)=>new $aec35899a3c9695e$var$qr({
        schema: t,
        typeName: $aec35899a3c9695e$var$ke.ZodEffects,
        effect: e,
        ...$aec35899a3c9695e$var$Me(r)
    });
$aec35899a3c9695e$var$qr.createWithPreprocess = (t, e, r)=>new $aec35899a3c9695e$var$qr({
        schema: e,
        effect: {
            type: "preprocess",
            transform: t
        },
        typeName: $aec35899a3c9695e$var$ke.ZodEffects,
        ...$aec35899a3c9695e$var$Me(r)
    });
class $aec35899a3c9695e$var$fi extends $aec35899a3c9695e$var$je {
    _parse(e) {
        return this._getType(e) === $aec35899a3c9695e$var$me.ZodParsedType.undefined ? (0, $aec35899a3c9695e$var$$.OK)(void 0) : this._def.innerType._parse(e);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$aec35899a3c9695e$var$j.ZodOptional = $aec35899a3c9695e$var$fi;
$aec35899a3c9695e$var$fi.create = (t, e)=>new $aec35899a3c9695e$var$fi({
        innerType: t,
        typeName: $aec35899a3c9695e$var$ke.ZodOptional,
        ...$aec35899a3c9695e$var$Me(e)
    });
class $aec35899a3c9695e$var$hn extends $aec35899a3c9695e$var$je {
    _parse(e) {
        return this._getType(e) === $aec35899a3c9695e$var$me.ZodParsedType.null ? (0, $aec35899a3c9695e$var$$.OK)(null) : this._def.innerType._parse(e);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$aec35899a3c9695e$var$j.ZodNullable = $aec35899a3c9695e$var$hn;
$aec35899a3c9695e$var$hn.create = (t, e)=>new $aec35899a3c9695e$var$hn({
        innerType: t,
        typeName: $aec35899a3c9695e$var$ke.ZodNullable,
        ...$aec35899a3c9695e$var$Me(e)
    });
class $aec35899a3c9695e$var$ga extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { ctx: r } = this._processInputParams(e);
        let i = r.data;
        return r.parsedType === $aec35899a3c9695e$var$me.ZodParsedType.undefined && (i = this._def.defaultValue()), this._def.innerType._parse({
            data: i,
            path: r.path,
            parent: r
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$aec35899a3c9695e$var$j.ZodDefault = $aec35899a3c9695e$var$ga;
$aec35899a3c9695e$var$ga.create = (t, e)=>new $aec35899a3c9695e$var$ga({
        innerType: t,
        typeName: $aec35899a3c9695e$var$ke.ZodDefault,
        defaultValue: typeof e.default == "function" ? e.default : ()=>e.default,
        ...$aec35899a3c9695e$var$Me(e)
    });
class $aec35899a3c9695e$var$xa extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { ctx: r } = this._processInputParams(e), i = {
            ...r,
            common: {
                ...r.common,
                issues: []
            }
        }, a = this._def.innerType._parse({
            data: i.data,
            path: i.path,
            parent: {
                ...i
            }
        });
        return (0, $aec35899a3c9695e$var$$.isAsync)(a) ? a.then((c)=>({
                status: "valid",
                value: c.status === "valid" ? c.value : this._def.catchValue({
                    get error () {
                        return new $aec35899a3c9695e$var$de.ZodError(i.common.issues);
                    },
                    input: i.data
                })
            })) : {
            status: "valid",
            value: a.status === "valid" ? a.value : this._def.catchValue({
                get error () {
                    return new $aec35899a3c9695e$var$de.ZodError(i.common.issues);
                },
                input: i.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$aec35899a3c9695e$var$j.ZodCatch = $aec35899a3c9695e$var$xa;
$aec35899a3c9695e$var$xa.create = (t, e)=>new $aec35899a3c9695e$var$xa({
        innerType: t,
        typeName: $aec35899a3c9695e$var$ke.ZodCatch,
        catchValue: typeof e.catch == "function" ? e.catch : ()=>e.catch,
        ...$aec35899a3c9695e$var$Me(e)
    });
class $aec35899a3c9695e$var$yu extends $aec35899a3c9695e$var$je {
    _parse(e) {
        if (this._getType(e) !== $aec35899a3c9695e$var$me.ZodParsedType.nan) {
            const i = this._getOrReturnCtx(e);
            return (0, $aec35899a3c9695e$var$$.addIssueToContext)(i, {
                code: $aec35899a3c9695e$var$de.ZodIssueCode.invalid_type,
                expected: $aec35899a3c9695e$var$me.ZodParsedType.nan,
                received: i.parsedType
            }), $aec35899a3c9695e$var$$.INVALID;
        }
        return {
            status: "valid",
            value: e.data
        };
    }
}
$aec35899a3c9695e$var$j.ZodNaN = $aec35899a3c9695e$var$yu;
$aec35899a3c9695e$var$yu.create = (t)=>new $aec35899a3c9695e$var$yu({
        typeName: $aec35899a3c9695e$var$ke.ZodNaN,
        ...$aec35899a3c9695e$var$Me(t)
    });
$aec35899a3c9695e$var$j.BRAND = Symbol("zod_brand");
class $aec35899a3c9695e$var$Kc extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { ctx: r } = this._processInputParams(e), i = r.data;
        return this._def.type._parse({
            data: i,
            path: r.path,
            parent: r
        });
    }
    unwrap() {
        return this._def.type;
    }
}
$aec35899a3c9695e$var$j.ZodBranded = $aec35899a3c9695e$var$Kc;
class $aec35899a3c9695e$var$Sa extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const { status: r, ctx: i } = this._processInputParams(e);
        if (i.common.async) return (async ()=>{
            const c = await this._def.in._parseAsync({
                data: i.data,
                path: i.path,
                parent: i
            });
            return c.status === "aborted" ? $aec35899a3c9695e$var$$.INVALID : c.status === "dirty" ? (r.dirty(), (0, $aec35899a3c9695e$var$$.DIRTY)(c.value)) : this._def.out._parseAsync({
                data: c.value,
                path: i.path,
                parent: i
            });
        })();
        {
            const a = this._def.in._parseSync({
                data: i.data,
                path: i.path,
                parent: i
            });
            return a.status === "aborted" ? $aec35899a3c9695e$var$$.INVALID : a.status === "dirty" ? (r.dirty(), {
                status: "dirty",
                value: a.value
            }) : this._def.out._parseSync({
                data: a.value,
                path: i.path,
                parent: i
            });
        }
    }
    static create(e, r) {
        return new $aec35899a3c9695e$var$Sa({
            in: e,
            out: r,
            typeName: $aec35899a3c9695e$var$ke.ZodPipeline
        });
    }
}
$aec35899a3c9695e$var$j.ZodPipeline = $aec35899a3c9695e$var$Sa;
class $aec35899a3c9695e$var$Ea extends $aec35899a3c9695e$var$je {
    _parse(e) {
        const r = this._def.innerType._parse(e), i = (a)=>((0, $aec35899a3c9695e$var$$.isValid)(a) && (a.value = Object.freeze(a.value)), a);
        return (0, $aec35899a3c9695e$var$$.isAsync)(r) ? r.then((a)=>i(a)) : i(r);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$aec35899a3c9695e$var$j.ZodReadonly = $aec35899a3c9695e$var$Ea;
$aec35899a3c9695e$var$Ea.create = (t, e)=>new $aec35899a3c9695e$var$Ea({
        innerType: t,
        typeName: $aec35899a3c9695e$var$ke.ZodReadonly,
        ...$aec35899a3c9695e$var$Me(e)
    });
function $aec35899a3c9695e$var$cp(t, e = {}, r) {
    return t ? $aec35899a3c9695e$var$vs.create().superRefine((i, a)=>{
        var c, h;
        if (!t(i)) {
            const m = typeof e == "function" ? e(i) : typeof e == "string" ? {
                message: e
            } : e, p = (h = (c = m.fatal) !== null && c !== void 0 ? c : r) !== null && h !== void 0 ? h : !0, y = typeof m == "string" ? {
                message: m
            } : m;
            a.addIssue({
                code: "custom",
                ...y,
                fatal: p
            });
        }
    }) : $aec35899a3c9695e$var$vs.create();
}
$aec35899a3c9695e$var$j.custom = $aec35899a3c9695e$var$cp;
$aec35899a3c9695e$var$j.late = {
    object: $aec35899a3c9695e$var$yt.lazycreate
};
var $aec35899a3c9695e$var$ke;
(function(t) {
    t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})($aec35899a3c9695e$var$ke || ($aec35899a3c9695e$var$j.ZodFirstPartyTypeKind = $aec35899a3c9695e$var$ke = {}));
const $aec35899a3c9695e$var$ag = (t, e = {
    message: `Input not instance of ${t.name}`
})=>$aec35899a3c9695e$var$cp((r)=>r instanceof t, e);
$aec35899a3c9695e$var$j.instanceof = $aec35899a3c9695e$var$ag;
const $aec35899a3c9695e$var$dp = $aec35899a3c9695e$var$Mr.create;
$aec35899a3c9695e$var$j.string = $aec35899a3c9695e$var$dp;
const $aec35899a3c9695e$var$fp = $aec35899a3c9695e$var$dn.create;
$aec35899a3c9695e$var$j.number = $aec35899a3c9695e$var$fp;
const $aec35899a3c9695e$var$og = $aec35899a3c9695e$var$yu.create;
$aec35899a3c9695e$var$j.nan = $aec35899a3c9695e$var$og;
const $aec35899a3c9695e$var$lg = $aec35899a3c9695e$var$fn.create;
$aec35899a3c9695e$var$j.bigint = $aec35899a3c9695e$var$lg;
const $aec35899a3c9695e$var$pp = $aec35899a3c9695e$var$ua.create;
$aec35899a3c9695e$var$j.boolean = $aec35899a3c9695e$var$pp;
const $aec35899a3c9695e$var$ug = $aec35899a3c9695e$var$Kn.create;
$aec35899a3c9695e$var$j.date = $aec35899a3c9695e$var$ug;
const $aec35899a3c9695e$var$cg = $aec35899a3c9695e$var$pu.create;
$aec35899a3c9695e$var$j.symbol = $aec35899a3c9695e$var$cg;
const $aec35899a3c9695e$var$dg = $aec35899a3c9695e$var$ca.create;
$aec35899a3c9695e$var$j.undefined = $aec35899a3c9695e$var$dg;
const $aec35899a3c9695e$var$fg = $aec35899a3c9695e$var$da.create;
$aec35899a3c9695e$var$j.null = $aec35899a3c9695e$var$fg;
const $aec35899a3c9695e$var$pg = $aec35899a3c9695e$var$vs.create;
$aec35899a3c9695e$var$j.any = $aec35899a3c9695e$var$pg;
const $aec35899a3c9695e$var$hg = $aec35899a3c9695e$var$On.create;
$aec35899a3c9695e$var$j.unknown = $aec35899a3c9695e$var$hg;
const $aec35899a3c9695e$var$mg = $aec35899a3c9695e$var$en.create;
$aec35899a3c9695e$var$j.never = $aec35899a3c9695e$var$mg;
const $aec35899a3c9695e$var$yg = $aec35899a3c9695e$var$hu.create;
$aec35899a3c9695e$var$j.void = $aec35899a3c9695e$var$yg;
const $aec35899a3c9695e$var$bg = $aec35899a3c9695e$var$Gr.create;
$aec35899a3c9695e$var$j.array = $aec35899a3c9695e$var$bg;
const $aec35899a3c9695e$var$gg = $aec35899a3c9695e$var$yt.create;
$aec35899a3c9695e$var$j.object = $aec35899a3c9695e$var$gg;
const $aec35899a3c9695e$var$xg = $aec35899a3c9695e$var$yt.strictCreate;
$aec35899a3c9695e$var$j.strictObject = $aec35899a3c9695e$var$xg;
const $aec35899a3c9695e$var$Eg = $aec35899a3c9695e$var$fa.create;
$aec35899a3c9695e$var$j.union = $aec35899a3c9695e$var$Eg;
const $aec35899a3c9695e$var$vg = $aec35899a3c9695e$var$Pu.create;
$aec35899a3c9695e$var$j.discriminatedUnion = $aec35899a3c9695e$var$vg;
const $aec35899a3c9695e$var$Rg = $aec35899a3c9695e$var$pa.create;
$aec35899a3c9695e$var$j.intersection = $aec35899a3c9695e$var$Rg;
const $aec35899a3c9695e$var$Ag = $aec35899a3c9695e$var$hi.create;
$aec35899a3c9695e$var$j.tuple = $aec35899a3c9695e$var$Ag;
const $aec35899a3c9695e$var$_g = $aec35899a3c9695e$var$ha.create;
$aec35899a3c9695e$var$j.record = $aec35899a3c9695e$var$_g;
const $aec35899a3c9695e$var$wg = $aec35899a3c9695e$var$mu.create;
$aec35899a3c9695e$var$j.map = $aec35899a3c9695e$var$wg;
const $aec35899a3c9695e$var$Tg = $aec35899a3c9695e$var$Mn.create;
$aec35899a3c9695e$var$j.set = $aec35899a3c9695e$var$Tg;
const $aec35899a3c9695e$var$Sg = $aec35899a3c9695e$var$xs.create;
$aec35899a3c9695e$var$j.function = $aec35899a3c9695e$var$Sg;
const $aec35899a3c9695e$var$Cg = $aec35899a3c9695e$var$ma.create;
$aec35899a3c9695e$var$j.lazy = $aec35899a3c9695e$var$Cg;
const $aec35899a3c9695e$var$Lg = $aec35899a3c9695e$var$ya.create;
$aec35899a3c9695e$var$j.literal = $aec35899a3c9695e$var$Lg;
const $aec35899a3c9695e$var$kg = $aec35899a3c9695e$var$pn.create;
$aec35899a3c9695e$var$j.enum = $aec35899a3c9695e$var$kg;
const $aec35899a3c9695e$var$Dg = $aec35899a3c9695e$var$ba.create;
$aec35899a3c9695e$var$j.nativeEnum = $aec35899a3c9695e$var$Dg;
const $aec35899a3c9695e$var$Pg = $aec35899a3c9695e$var$Rs.create;
$aec35899a3c9695e$var$j.promise = $aec35899a3c9695e$var$Pg;
const $aec35899a3c9695e$var$hp = $aec35899a3c9695e$var$qr.create;
$aec35899a3c9695e$var$j.effect = $aec35899a3c9695e$var$hp;
$aec35899a3c9695e$var$j.transformer = $aec35899a3c9695e$var$hp;
const $aec35899a3c9695e$var$Bg = $aec35899a3c9695e$var$fi.create;
$aec35899a3c9695e$var$j.optional = $aec35899a3c9695e$var$Bg;
const $aec35899a3c9695e$var$Ig = $aec35899a3c9695e$var$hn.create;
$aec35899a3c9695e$var$j.nullable = $aec35899a3c9695e$var$Ig;
const $aec35899a3c9695e$var$Ug = $aec35899a3c9695e$var$qr.createWithPreprocess;
$aec35899a3c9695e$var$j.preprocess = $aec35899a3c9695e$var$Ug;
const $aec35899a3c9695e$var$Og = $aec35899a3c9695e$var$Sa.create;
$aec35899a3c9695e$var$j.pipeline = $aec35899a3c9695e$var$Og;
const $aec35899a3c9695e$var$Kg = ()=>$aec35899a3c9695e$var$dp().optional();
$aec35899a3c9695e$var$j.ostring = $aec35899a3c9695e$var$Kg;
const $aec35899a3c9695e$var$Mg = ()=>$aec35899a3c9695e$var$fp().optional();
$aec35899a3c9695e$var$j.onumber = $aec35899a3c9695e$var$Mg;
const $aec35899a3c9695e$var$Ng = ()=>$aec35899a3c9695e$var$pp().optional();
$aec35899a3c9695e$var$j.oboolean = $aec35899a3c9695e$var$Ng;
$aec35899a3c9695e$var$j.coerce = {
    string: (t)=>$aec35899a3c9695e$var$Mr.create({
            ...t,
            coerce: !0
        }),
    number: (t)=>$aec35899a3c9695e$var$dn.create({
            ...t,
            coerce: !0
        }),
    boolean: (t)=>$aec35899a3c9695e$var$ua.create({
            ...t,
            coerce: !0
        }),
    bigint: (t)=>$aec35899a3c9695e$var$fn.create({
            ...t,
            coerce: !0
        }),
    date: (t)=>$aec35899a3c9695e$var$Kn.create({
            ...t,
            coerce: !0
        })
};
$aec35899a3c9695e$var$j.NEVER = $aec35899a3c9695e$var$$.INVALID;
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(i, a, c, h) {
        h === void 0 && (h = c);
        var m = Object.getOwnPropertyDescriptor(a, c);
        (!m || ("get" in m ? !a.__esModule : m.writable || m.configurable)) && (m = {
            enumerable: !0,
            get: function() {
                return a[c];
            }
        }), Object.defineProperty(i, h, m);
    } : function(i, a, c, h) {
        h === void 0 && (h = c), i[h] = a[c];
    }), r = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__exportStar || function(i, a) {
        for(var c in i)c !== "default" && !Object.prototype.hasOwnProperty.call(a, c) && e(a, i, c);
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), r($aec35899a3c9695e$var$ci, t), r($aec35899a3c9695e$var$Oc, t), r($aec35899a3c9695e$var$np, t), r($aec35899a3c9695e$var$Ta, t), r($aec35899a3c9695e$var$j, t), r($aec35899a3c9695e$var$di, t);
})($aec35899a3c9695e$var$wc);
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(h, m, p, y) {
        y === void 0 && (y = p);
        var d = Object.getOwnPropertyDescriptor(m, p);
        (!d || ("get" in d ? !m.__esModule : d.writable || d.configurable)) && (d = {
            enumerable: !0,
            get: function() {
                return m[p];
            }
        }), Object.defineProperty(h, y, d);
    } : function(h, m, p, y) {
        y === void 0 && (y = p), h[y] = m[p];
    }), r = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__setModuleDefault || (Object.create ? function(h, m) {
        Object.defineProperty(h, "default", {
            enumerable: !0,
            value: m
        });
    } : function(h, m) {
        h.default = m;
    }), i = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importStar || function(h) {
        if (h && h.__esModule) return h;
        var m = {};
        if (h != null) for(var p in h)p !== "default" && Object.prototype.hasOwnProperty.call(h, p) && e(m, h, p);
        return r(m, h), m;
    }, a = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__exportStar || function(h, m) {
        for(var p in h)p !== "default" && !Object.prototype.hasOwnProperty.call(m, p) && e(m, h, p);
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.z = void 0;
    const c = i($aec35899a3c9695e$var$wc);
    t.z = c, a($aec35899a3c9695e$var$wc, t), t.default = c;
})($aec35899a3c9695e$var$os);
var $aec35899a3c9695e$var$ls = {};
Object.defineProperty($aec35899a3c9695e$var$ls, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ls.toLexUri = $aec35899a3c9695e$var$Vg;
$aec35899a3c9695e$var$ls.toConcreteTypes = $aec35899a3c9695e$var$jg;
$aec35899a3c9695e$var$ls.requiredPropertiesRefinement = $aec35899a3c9695e$var$Fg;
const $aec35899a3c9695e$var$cc = $aec35899a3c9695e$var$os;
function $aec35899a3c9695e$var$Vg(t, e) {
    if (t.split("#").length > 2) throw new Error("Uri can only have one hash segment");
    if (t.startsWith("lex:")) return t;
    if (t.startsWith("#")) {
        if (!e) throw new Error(`Unable to resolve uri without anchor: ${t}`);
        return `${e}${t}`;
    }
    return `lex:${t}`;
}
function $aec35899a3c9695e$var$jg(t, e) {
    return e.type === "ref" ? [
        t.getDefOrThrow(e.ref)
    ] : e.type === "union" ? e.refs.map((r)=>t.getDefOrThrow(r)).flat() : [
        e
    ];
}
function $aec35899a3c9695e$var$Fg(t, e) {
    if (t.required !== void 0) {
        if (!Array.isArray(t.required)) {
            e.addIssue({
                code: $aec35899a3c9695e$var$cc.z.ZodIssueCode.invalid_type,
                received: typeof t.required,
                expected: "array"
            });
            return;
        }
        if (t.properties === void 0) {
            t.required.length > 0 && e.addIssue({
                code: $aec35899a3c9695e$var$cc.z.ZodIssueCode.custom,
                message: "Required fields defined but no properties defined"
            });
            return;
        }
        for (const r of t.required)t.properties[r] === void 0 && e.addIssue({
            code: $aec35899a3c9695e$var$cc.z.ZodIssueCode.custom,
            message: `Required field "${r}" not defined`
        });
    }
}
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.LexiconDefNotFoundError = t.InvalidLexiconError = t.ValidationError = t.discriminatedObject = t.lexiconDoc = t.lexUserType = t.lexRecord = t.lexXrpcSubscription = t.lexXrpcProcedure = t.lexXrpcQuery = t.lexXrpcError = t.lexXrpcSubscriptionMessage = t.lexXrpcBody = t.lexXrpcParameters = t.lexObject = t.lexToken = t.lexPrimitiveArray = t.lexArray = t.lexBlob = t.lexRefVariant = t.lexRefUnion = t.lexRef = t.lexIpldType = t.lexCidLink = t.lexBytes = t.lexPrimitive = t.lexUnknown = t.lexString = t.lexStringFormat = t.lexInteger = t.lexBoolean = void 0, t.isValidLexiconDoc = a, t.isObj = c, t.hasProp = h, t.isDiscriminatedObject = m, t.parseLexiconDoc = p;
    const e = $aec35899a3c9695e$var$os, r = $aec35899a3c9695e$var$as, i = $aec35899a3c9695e$var$ls;
    t.lexBoolean = e.z.object({
        type: e.z.literal("boolean"),
        description: e.z.string().optional(),
        default: e.z.boolean().optional(),
        const: e.z.boolean().optional()
    }).strict(), t.lexInteger = e.z.object({
        type: e.z.literal("integer"),
        description: e.z.string().optional(),
        default: e.z.number().int().optional(),
        minimum: e.z.number().int().optional(),
        maximum: e.z.number().int().optional(),
        enum: e.z.number().int().array().optional(),
        const: e.z.number().int().optional()
    }).strict(), t.lexStringFormat = e.z.enum([
        "datetime",
        "uri",
        "at-uri",
        "did",
        "handle",
        "at-identifier",
        "nsid",
        "cid",
        "language",
        "tid",
        "record-key"
    ]), t.lexString = e.z.object({
        type: e.z.literal("string"),
        format: t.lexStringFormat.optional(),
        description: e.z.string().optional(),
        default: e.z.string().optional(),
        minLength: e.z.number().int().optional(),
        maxLength: e.z.number().int().optional(),
        minGraphemes: e.z.number().int().optional(),
        maxGraphemes: e.z.number().int().optional(),
        enum: e.z.string().array().optional(),
        const: e.z.string().optional(),
        knownValues: e.z.string().array().optional()
    }).strict(), t.lexUnknown = e.z.object({
        type: e.z.literal("unknown"),
        description: e.z.string().optional()
    }).strict(), t.lexPrimitive = e.z.discriminatedUnion("type", [
        t.lexBoolean,
        t.lexInteger,
        t.lexString,
        t.lexUnknown
    ]), t.lexBytes = e.z.object({
        type: e.z.literal("bytes"),
        description: e.z.string().optional(),
        maxLength: e.z.number().optional(),
        minLength: e.z.number().optional()
    }).strict(), t.lexCidLink = e.z.object({
        type: e.z.literal("cid-link"),
        description: e.z.string().optional()
    }).strict(), t.lexIpldType = e.z.discriminatedUnion("type", [
        t.lexBytes,
        t.lexCidLink
    ]), t.lexRef = e.z.object({
        type: e.z.literal("ref"),
        description: e.z.string().optional(),
        ref: e.z.string()
    }).strict(), t.lexRefUnion = e.z.object({
        type: e.z.literal("union"),
        description: e.z.string().optional(),
        refs: e.z.string().array(),
        closed: e.z.boolean().optional()
    }).strict(), t.lexRefVariant = e.z.discriminatedUnion("type", [
        t.lexRef,
        t.lexRefUnion
    ]), t.lexBlob = e.z.object({
        type: e.z.literal("blob"),
        description: e.z.string().optional(),
        accept: e.z.string().array().optional(),
        maxSize: e.z.number().optional()
    }).strict(), t.lexArray = e.z.object({
        type: e.z.literal("array"),
        description: e.z.string().optional(),
        items: e.z.discriminatedUnion("type", [
            // lexPrimitive
            t.lexBoolean,
            t.lexInteger,
            t.lexString,
            t.lexUnknown,
            // lexIpldType
            t.lexBytes,
            t.lexCidLink,
            // lexRefVariant
            t.lexRef,
            t.lexRefUnion,
            // other
            t.lexBlob
        ]),
        minLength: e.z.number().int().optional(),
        maxLength: e.z.number().int().optional()
    }).strict(), t.lexPrimitiveArray = t.lexArray.merge(e.z.object({
        items: t.lexPrimitive
    }).strict()), t.lexToken = e.z.object({
        type: e.z.literal("token"),
        description: e.z.string().optional()
    }).strict(), t.lexObject = e.z.object({
        type: e.z.literal("object"),
        description: e.z.string().optional(),
        required: e.z.string().array().optional(),
        nullable: e.z.string().array().optional(),
        properties: e.z.record(e.z.discriminatedUnion("type", [
            t.lexArray,
            // lexPrimitive
            t.lexBoolean,
            t.lexInteger,
            t.lexString,
            t.lexUnknown,
            // lexIpldType
            t.lexBytes,
            t.lexCidLink,
            // lexRefVariant
            t.lexRef,
            t.lexRefUnion,
            // other
            t.lexBlob
        ]))
    }).strict().superRefine(i.requiredPropertiesRefinement), t.lexXrpcParameters = e.z.object({
        type: e.z.literal("params"),
        description: e.z.string().optional(),
        required: e.z.string().array().optional(),
        properties: e.z.record(e.z.discriminatedUnion("type", [
            t.lexPrimitiveArray,
            // lexPrimitive
            t.lexBoolean,
            t.lexInteger,
            t.lexString,
            t.lexUnknown
        ]))
    }).strict().superRefine(i.requiredPropertiesRefinement), t.lexXrpcBody = e.z.object({
        description: e.z.string().optional(),
        encoding: e.z.string(),
        // @NOTE using discriminatedUnion with a refined schema requires zod >= 4
        schema: e.z.union([
            t.lexRefVariant,
            t.lexObject
        ]).optional()
    }).strict(), t.lexXrpcSubscriptionMessage = e.z.object({
        description: e.z.string().optional(),
        // @NOTE using discriminatedUnion with a refined schema requires zod >= 4
        schema: e.z.union([
            t.lexRefVariant,
            t.lexObject
        ]).optional()
    }).strict(), t.lexXrpcError = e.z.object({
        name: e.z.string(),
        description: e.z.string().optional()
    }).strict(), t.lexXrpcQuery = e.z.object({
        type: e.z.literal("query"),
        description: e.z.string().optional(),
        parameters: t.lexXrpcParameters.optional(),
        output: t.lexXrpcBody.optional(),
        errors: t.lexXrpcError.array().optional()
    }).strict(), t.lexXrpcProcedure = e.z.object({
        type: e.z.literal("procedure"),
        description: e.z.string().optional(),
        parameters: t.lexXrpcParameters.optional(),
        input: t.lexXrpcBody.optional(),
        output: t.lexXrpcBody.optional(),
        errors: t.lexXrpcError.array().optional()
    }).strict(), t.lexXrpcSubscription = e.z.object({
        type: e.z.literal("subscription"),
        description: e.z.string().optional(),
        parameters: t.lexXrpcParameters.optional(),
        message: t.lexXrpcSubscriptionMessage.optional(),
        errors: t.lexXrpcError.array().optional()
    }).strict(), t.lexRecord = e.z.object({
        type: e.z.literal("record"),
        description: e.z.string().optional(),
        key: e.z.string().optional(),
        record: t.lexObject
    }).strict(), t.lexUserType = e.z.custom((P)=>{
        if (!(!P || typeof P != "object") && P.type !== void 0) switch(P.type){
            case "record":
                return t.lexRecord.parse(P);
            case "query":
                return t.lexXrpcQuery.parse(P);
            case "procedure":
                return t.lexXrpcProcedure.parse(P);
            case "subscription":
                return t.lexXrpcSubscription.parse(P);
            case "blob":
                return t.lexBlob.parse(P);
            case "array":
                return t.lexArray.parse(P);
            case "token":
                return t.lexToken.parse(P);
            case "object":
                return t.lexObject.parse(P);
            case "boolean":
                return t.lexBoolean.parse(P);
            case "integer":
                return t.lexInteger.parse(P);
            case "string":
                return t.lexString.parse(P);
            case "bytes":
                return t.lexBytes.parse(P);
            case "cid-link":
                return t.lexCidLink.parse(P);
            case "unknown":
                return t.lexUnknown.parse(P);
        }
    }, (P)=>!P || typeof P != "object" ? {
            message: "Must be an object",
            fatal: !0
        } : P.type === void 0 ? {
            message: "Must have a type",
            fatal: !0
        } : typeof P.type != "string" ? {
            message: "Type property must be a string",
            fatal: !0
        } : {
            message: `Invalid type: ${P.type} must be one of: record, query, procedure, subscription, blob, array, token, object, boolean, integer, string, bytes, cid-link, unknown`,
            fatal: !0
        }), t.lexiconDoc = e.z.object({
        lexicon: e.z.literal(1),
        id: e.z.string().refine((P)=>r.NSID.isValid(P), {
            message: "Must be a valid NSID"
        }),
        revision: e.z.number().optional(),
        description: e.z.string().optional(),
        defs: e.z.record(t.lexUserType)
    }).strict().superRefine((P, K)=>{
        for(const O in P.defs){
            const Z = P.defs[O];
            O !== "main" && (Z.type === "record" || Z.type === "procedure" || Z.type === "query" || Z.type === "subscription") && K.addIssue({
                code: e.z.ZodIssueCode.custom,
                message: "Records, procedures, queries, and subscriptions must be the main definition."
            });
        }
    });
    function a(P) {
        return t.lexiconDoc.safeParse(P).success;
    }
    function c(P) {
        return P !== null && typeof P == "object";
    }
    function h(P, K) {
        return K in P;
    }
    t.discriminatedObject = e.z.object({
        $type: e.z.string()
    });
    function m(P) {
        return t.discriminatedObject.safeParse(P).success;
    }
    function p(P) {
        return t.lexiconDoc.parse(P), P;
    }
    class y extends Error {
    }
    t.ValidationError = y;
    class d extends Error {
    }
    t.InvalidLexiconError = d;
    class v extends Error {
    }
    t.LexiconDefNotFoundError = v;
})($aec35899a3c9695e$var$Rn);
var $aec35899a3c9695e$var$Bu = {}, $aec35899a3c9695e$var$us = {}, $aec35899a3c9695e$var$An = {}, $aec35899a3c9695e$var$Mc = {}, $aec35899a3c9695e$var$Iu = {}, $aec35899a3c9695e$var$vi = {}, $aec35899a3c9695e$var$ri = {};
Object.defineProperty($aec35899a3c9695e$var$ri, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ri.isObject = $aec35899a3c9695e$var$ri.assure = $aec35899a3c9695e$var$ri.create = $aec35899a3c9695e$var$ri.is = void 0;
const $aec35899a3c9695e$var$$g = (t, e)=>e.safeParse(t).success;
$aec35899a3c9695e$var$ri.is = $aec35899a3c9695e$var$$g;
const $aec35899a3c9695e$var$Gg = (t)=>(e)=>t.safeParse(e).success;
$aec35899a3c9695e$var$ri.create = $aec35899a3c9695e$var$Gg;
const $aec35899a3c9695e$var$qg = (t, e)=>t.parse(e);
$aec35899a3c9695e$var$ri.assure = $aec35899a3c9695e$var$qg;
const $aec35899a3c9695e$var$zg = (t)=>typeof t == "object" && t !== null;
$aec35899a3c9695e$var$ri.isObject = $aec35899a3c9695e$var$zg;
var $aec35899a3c9695e$var$As = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.parseIntWithFallback = t.dedupeStrs = t.range = t.chunkArray = t.errHasMsg = t.isErrnoException = t.asyncFilter = t.s32decode = t.s32encode = t.streamToBuffer = t.flattenUint8Arrays = t.bailableWait = t.wait = t.jitter = t.omit = t.noUndefinedVals = void 0;
    const e = (V)=>(Object.keys(V).forEach((q)=>{
            V[q] === void 0 && delete V[q];
        }), V);
    t.noUndefinedVals = e;
    function r(V, q) {
        return V && Object.fromEntries(Object.entries(V).filter((re)=>!q.includes(re[0])));
    }
    t.omit = r;
    const i = (V)=>Math.round((Math.random() - 0.5) * V * 2);
    t.jitter = i;
    const a = (V)=>new Promise((q)=>setTimeout(q, V));
    t.wait = a;
    const c = (V)=>{
        let q;
        const re = new Promise((ne)=>{
            const fe = setTimeout(ne, V);
            q = ()=>{
                clearTimeout(fe), ne();
            };
        });
        return {
            bail: q,
            wait: ()=>re
        };
    };
    t.bailableWait = c;
    const h = (V)=>{
        const q = V.reduce((fe, ye)=>fe + ye.length, 0), re = new Uint8Array(q);
        let ne = 0;
        return V.forEach((fe)=>{
            re.set(fe, ne), ne += fe.length;
        }), re;
    };
    t.flattenUint8Arrays = h;
    const m = async (V)=>{
        const q = [];
        for await (const re of V)q.push(re);
        return (0, t.flattenUint8Arrays)(q);
    };
    t.streamToBuffer = m;
    const p = "234567abcdefghijklmnopqrstuvwxyz", y = (V)=>{
        let q = "";
        for(; V;){
            const re = V % 32;
            V = Math.floor(V / 32), q = p.charAt(re) + q;
        }
        return q;
    };
    t.s32encode = y;
    const d = (V)=>{
        let q = 0;
        for (const re of V)q = q * 32 + p.indexOf(re);
        return q;
    };
    t.s32decode = d;
    const v = async (V, q)=>{
        const re = await Promise.all(V.map((ne)=>q(ne)));
        return V.filter((ne, fe)=>re[fe]);
    };
    t.asyncFilter = v;
    const P = (V)=>!!V && V.code;
    t.isErrnoException = P;
    const K = (V, q)=>!!V && typeof V == "object" && V.message === q;
    t.errHasMsg = K;
    const O = (V, q)=>V.reduce((re, ne, fe)=>{
            const ye = Math.floor(fe / q);
            return re[ye] || (re[ye] = []), re[ye].push(ne), re;
        }, []);
    t.chunkArray = O;
    const Z = (V)=>{
        const q = [];
        for(let re = 0; re < V; re++)q.push(re);
        return q;
    };
    t.range = Z;
    const Y = (V)=>[
            ...new Set(V)
        ];
    t.dedupeStrs = Y;
    const X = (V, q)=>{
        const re = parseInt(V || "", 10);
        return isNaN(re) ? q : re;
    };
    t.parseIntWithFallback = X;
})($aec35899a3c9695e$var$As);
var $aec35899a3c9695e$var$_s = {};
Object.defineProperty($aec35899a3c9695e$var$_s, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$_s.mapDefined = $aec35899a3c9695e$var$_s.keyBy = void 0;
const $aec35899a3c9695e$var$Xg = (t, e)=>t.reduce((r, i)=>(r[i[e]] = i, r), {});
$aec35899a3c9695e$var$_s.keyBy = $aec35899a3c9695e$var$Xg;
const $aec35899a3c9695e$var$Hg = (t, e)=>{
    const r = [];
    for (const i of t){
        const a = e(i);
        a !== void 0 && r.push(a);
    }
    return r;
};
$aec35899a3c9695e$var$_s.mapDefined = $aec35899a3c9695e$var$Hg;
var $aec35899a3c9695e$var$mp = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.handleAllSettledErrors = t.AsyncBufferFullError = t.AsyncBuffer = t.allComplete = t.createDeferrables = t.createDeferrable = t.readFromGenerator = void 0;
    const e = $aec35899a3c9695e$var$As, r = async (d, v, P = Promise.resolve(), K = Number.MAX_SAFE_INTEGER)=>{
        const O = [];
        let Z, Y = !1;
        const X = async ()=>{
            if (await v(O.at(-1))) return !0;
            const q = (0, e.bailableWait)(20);
            return await q.wait(), Z = q.bail, Y ? !1 : await X();
        }, V = new Promise((q)=>{
            P.then(()=>{
                X().then(()=>q());
            });
        });
        try {
            for(; O.length < K;){
                const q = await Promise.race([
                    d.next(),
                    V
                ]);
                if (!q) break;
                const re = q;
                if (re.done) break;
                O.push(re.value);
            }
        } finally{
            Y = !0, Z && Z();
        }
        return O;
    };
    t.readFromGenerator = r;
    const i = ()=>{
        let d;
        const v = new Promise((P)=>{
            d = ()=>P();
        });
        return {
            resolve: d,
            complete: v
        };
    };
    t.createDeferrable = i;
    const a = (d)=>{
        const v = [];
        for(let P = 0; P < d; P++)v.push((0, t.createDeferrable)());
        return v;
    };
    t.createDeferrables = a;
    const c = async (d)=>{
        await Promise.all(d.map((v)=>v.complete));
    };
    t.allComplete = c;
    class h {
        constructor(v){
            Object.defineProperty(this, "maxSize", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: v
            }), Object.defineProperty(this, "buffer", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: []
            }), Object.defineProperty(this, "promise", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), Object.defineProperty(this, "resolve", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), Object.defineProperty(this, "closed", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: !1
            }), Object.defineProperty(this, "toThrow", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), this.promise = Promise.resolve(), this.resolve = ()=>null, this.resetPromise();
        }
        get curr() {
            return this.buffer;
        }
        get size() {
            return this.buffer.length;
        }
        get isClosed() {
            return this.closed;
        }
        resetPromise() {
            this.promise = new Promise((v)=>this.resolve = v);
        }
        push(v) {
            this.buffer.push(v), this.resolve();
        }
        pushMany(v) {
            v.forEach((P)=>this.buffer.push(P)), this.resolve();
        }
        async *events() {
            for(;;){
                if (this.closed && this.buffer.length === 0) {
                    if (this.toThrow) throw this.toThrow;
                    return;
                }
                if (await this.promise, this.toThrow) throw this.toThrow;
                if (this.maxSize && this.size > this.maxSize) throw new m(this.maxSize);
                const [v, ...P] = this.buffer;
                v ? (this.buffer = P, yield v) : this.resetPromise();
            }
        }
        throw(v) {
            this.toThrow = v, this.closed = !0, this.resolve();
        }
        close() {
            this.closed = !0, this.resolve();
        }
    }
    t.AsyncBuffer = h;
    class m extends Error {
        constructor(v){
            super(`ReachedMaxBufferSize: ${v}`);
        }
    }
    t.AsyncBufferFullError = m;
    const p = (d)=>{
        const v = d.filter(y).map((P)=>P.reason);
        if (v.length !== 0) throw v.length === 1 ? v[0] : new AggregateError(v, "Multiple errors: " + v.map((P)=>P?.message).join(`
`));
    };
    t.handleAllSettledErrors = p;
    const y = (d)=>d.status === "rejected";
})($aec35899a3c9695e$var$mp);
var $aec35899a3c9695e$var$Ca = {};
Object.defineProperty($aec35899a3c9695e$var$Ca, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ca.TID = void 0;
const $aec35899a3c9695e$var$Ql = $aec35899a3c9695e$var$As, $aec35899a3c9695e$var$Ld = 13;
let $aec35899a3c9695e$var$dc = 0, $aec35899a3c9695e$var$kd = 0, $aec35899a3c9695e$var$eu = null;
function $aec35899a3c9695e$var$Dd(t) {
    return t.replaceAll("-", "");
}
class $aec35899a3c9695e$var$Ii {
    constructor(e){
        Object.defineProperty(this, "str", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        });
        const r = $aec35899a3c9695e$var$Dd(e);
        if (r.length !== $aec35899a3c9695e$var$Ld) throw new Error(`Poorly formatted TID: ${r.length} length`);
        this.str = r;
    }
    static next(e) {
        const r = Math.max(Date.now(), $aec35899a3c9695e$var$dc);
        r === $aec35899a3c9695e$var$dc && $aec35899a3c9695e$var$kd++, $aec35899a3c9695e$var$dc = r;
        const i = r * 1e3 + $aec35899a3c9695e$var$kd;
        $aec35899a3c9695e$var$eu === null && ($aec35899a3c9695e$var$eu = Math.floor(Math.random() * 32));
        const a = $aec35899a3c9695e$var$Ii.fromTime(i, $aec35899a3c9695e$var$eu);
        return !e || a.newerThan(e) ? a : $aec35899a3c9695e$var$Ii.fromTime(e.timestamp() + 1, $aec35899a3c9695e$var$eu);
    }
    static nextStr(e) {
        return $aec35899a3c9695e$var$Ii.next(e ? new $aec35899a3c9695e$var$Ii(e) : void 0).toString();
    }
    static fromTime(e, r) {
        const i = `${(0, $aec35899a3c9695e$var$Ql.s32encode)(e)}${(0, $aec35899a3c9695e$var$Ql.s32encode)(r).padStart(2, "2")}`;
        return new $aec35899a3c9695e$var$Ii(i);
    }
    static fromStr(e) {
        return new $aec35899a3c9695e$var$Ii(e);
    }
    static oldestFirst(e, r) {
        return e.compareTo(r);
    }
    static newestFirst(e, r) {
        return r.compareTo(e);
    }
    static is(e) {
        return $aec35899a3c9695e$var$Dd(e).length === $aec35899a3c9695e$var$Ld;
    }
    timestamp() {
        return (0, $aec35899a3c9695e$var$Ql.s32decode)(this.str.slice(0, 11));
    }
    clockid() {
        return (0, $aec35899a3c9695e$var$Ql.s32decode)(this.str.slice(11, 13));
    }
    formatted() {
        const e = this.toString();
        return `${e.slice(0, 4)}-${e.slice(4, 7)}-${e.slice(7, 11)}-${e.slice(11, 13)}`;
    }
    toString() {
        return this.str;
    }
    // newer > older
    compareTo(e) {
        return this.str > e.str ? 1 : this.str < e.str ? -1 : 0;
    }
    equals(e) {
        return this.str === e.str;
    }
    newerThan(e) {
        return this.compareTo(e) > 0;
    }
    olderThan(e) {
        return this.compareTo(e) < 0;
    }
}
$aec35899a3c9695e$var$Ca.TID = $aec35899a3c9695e$var$Ii;
$aec35899a3c9695e$var$Ca.default = $aec35899a3c9695e$var$Ii;
var $aec35899a3c9695e$var$yp = {}, $aec35899a3c9695e$var$Zg = $aec35899a3c9695e$var$bp, $aec35899a3c9695e$var$Pd = 128, $aec35899a3c9695e$var$Wg = 127, $aec35899a3c9695e$var$Yg = ~$aec35899a3c9695e$var$Wg, $aec35899a3c9695e$var$Jg = Math.pow(2, 31);
function $aec35899a3c9695e$var$bp(t, e, r) {
    e = e || [], r = r || 0;
    for(var i = r; t >= $aec35899a3c9695e$var$Jg;)e[r++] = t & 255 | $aec35899a3c9695e$var$Pd, t /= 128;
    for(; t & $aec35899a3c9695e$var$Yg;)e[r++] = t & 255 | $aec35899a3c9695e$var$Pd, t >>>= 7;
    return e[r] = t | 0, $aec35899a3c9695e$var$bp.bytes = r - i + 1, e;
}
var $aec35899a3c9695e$var$Qg = $aec35899a3c9695e$var$Sc, $aec35899a3c9695e$var$ex = 128, $aec35899a3c9695e$var$Bd = 127;
function $aec35899a3c9695e$var$Sc(t, i) {
    var r = 0, i = i || 0, a = 0, c = i, h, m = t.length;
    do {
        if (c >= m) throw $aec35899a3c9695e$var$Sc.bytes = 0, new RangeError("Could not decode varint");
        h = t[c++], r += a < 28 ? (h & $aec35899a3c9695e$var$Bd) << a : (h & $aec35899a3c9695e$var$Bd) * Math.pow(2, a), a += 7;
    }while (h >= $aec35899a3c9695e$var$ex);
    return $aec35899a3c9695e$var$Sc.bytes = c - i, r;
}
var $aec35899a3c9695e$var$tx = Math.pow(2, 7), $aec35899a3c9695e$var$rx = Math.pow(2, 14), $aec35899a3c9695e$var$ix = Math.pow(2, 21), $aec35899a3c9695e$var$nx = Math.pow(2, 28), $aec35899a3c9695e$var$sx = Math.pow(2, 35), $aec35899a3c9695e$var$ax = Math.pow(2, 42), $aec35899a3c9695e$var$ox = Math.pow(2, 49), $aec35899a3c9695e$var$lx = Math.pow(2, 56), $aec35899a3c9695e$var$ux = Math.pow(2, 63), $aec35899a3c9695e$var$cx = function(t) {
    return t < $aec35899a3c9695e$var$tx ? 1 : t < $aec35899a3c9695e$var$rx ? 2 : t < $aec35899a3c9695e$var$ix ? 3 : t < $aec35899a3c9695e$var$nx ? 4 : t < $aec35899a3c9695e$var$sx ? 5 : t < $aec35899a3c9695e$var$ax ? 6 : t < $aec35899a3c9695e$var$ox ? 7 : t < $aec35899a3c9695e$var$lx ? 8 : t < $aec35899a3c9695e$var$ux ? 9 : 10;
}, $aec35899a3c9695e$var$dx = {
    encode: $aec35899a3c9695e$var$Zg,
    decode: $aec35899a3c9695e$var$Qg,
    encodingLength: $aec35899a3c9695e$var$cx
}, $aec35899a3c9695e$var$bu = $aec35899a3c9695e$var$dx;
const $aec35899a3c9695e$var$Cc = (t, e = 0)=>[
        $aec35899a3c9695e$var$bu.decode(t, e),
        $aec35899a3c9695e$var$bu.decode.bytes
    ], $aec35899a3c9695e$var$gu = (t, e, r = 0)=>($aec35899a3c9695e$var$bu.encode(t, e, r), e), $aec35899a3c9695e$var$xu = (t)=>$aec35899a3c9695e$var$bu.encodingLength(t), $aec35899a3c9695e$var$fx = (t, e)=>{
    if (t === e) return !0;
    if (t.byteLength !== e.byteLength) return !1;
    for(let r = 0; r < t.byteLength; r++)if (t[r] !== e[r]) return !1;
    return !0;
}, $aec35899a3c9695e$var$Nc = (t)=>{
    if (t instanceof Uint8Array && t.constructor.name === "Uint8Array") return t;
    if (t instanceof ArrayBuffer) return new Uint8Array(t);
    if (ArrayBuffer.isView(t)) return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $aec35899a3c9695e$var$px = (t)=>new TextEncoder().encode(t), $aec35899a3c9695e$var$hx = (t)=>new TextDecoder().decode(t), $aec35899a3c9695e$var$mx = (t, e)=>{
    const r = e.byteLength, i = $aec35899a3c9695e$var$xu(t), a = i + $aec35899a3c9695e$var$xu(r), c = new Uint8Array(a + r);
    return $aec35899a3c9695e$var$gu(t, c, 0), $aec35899a3c9695e$var$gu(r, c, i), c.set(e, a), new $aec35899a3c9695e$var$Vc(t, r, e, c);
}, $aec35899a3c9695e$var$yx = (t)=>{
    const e = $aec35899a3c9695e$var$Nc(t), [r, i] = $aec35899a3c9695e$var$Cc(e), [a, c] = $aec35899a3c9695e$var$Cc(e.subarray(i)), h = e.subarray(i + c);
    if (h.byteLength !== a) throw new Error("Incorrect length");
    return new $aec35899a3c9695e$var$Vc(r, a, h, e);
}, $aec35899a3c9695e$var$bx = (t, e)=>t === e ? !0 : t.code === e.code && t.size === e.size && $aec35899a3c9695e$var$fx(t.bytes, e.bytes);
class $aec35899a3c9695e$var$Vc {
    constructor(e, r, i, a){
        this.code = e, this.size = r, this.digest = i, this.bytes = a;
    }
}
function $aec35899a3c9695e$var$gx(t, e) {
    if (t.length >= 255) throw new TypeError("Alphabet too long");
    for(var r = new Uint8Array(256), i = 0; i < r.length; i++)r[i] = 255;
    for(var a = 0; a < t.length; a++){
        var c = t.charAt(a), h = c.charCodeAt(0);
        if (r[h] !== 255) throw new TypeError(c + " is ambiguous");
        r[h] = a;
    }
    var m = t.length, p = t.charAt(0), y = Math.log(m) / Math.log(256), d = Math.log(256) / Math.log(m);
    function v(O) {
        if (O instanceof Uint8Array || (ArrayBuffer.isView(O) ? O = new Uint8Array(O.buffer, O.byteOffset, O.byteLength) : Array.isArray(O) && (O = Uint8Array.from(O))), !(O instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (O.length === 0) return "";
        for(var Z = 0, Y = 0, X = 0, V = O.length; X !== V && O[X] === 0;)X++, Z++;
        for(var q = (V - X) * d + 1 >>> 0, re = new Uint8Array(q); X !== V;){
            for(var ne = O[X], fe = 0, ye = q - 1; (ne !== 0 || fe < Y) && ye !== -1; ye--, fe++)ne += 256 * re[ye] >>> 0, re[ye] = ne % m >>> 0, ne = ne / m >>> 0;
            if (ne !== 0) throw new Error("Non-zero carry");
            Y = fe, X++;
        }
        for(var xe = q - Y; xe !== q && re[xe] === 0;)xe++;
        for(var De = p.repeat(Z); xe < q; ++xe)De += t.charAt(re[xe]);
        return De;
    }
    function P(O) {
        if (typeof O != "string") throw new TypeError("Expected String");
        if (O.length === 0) return new Uint8Array();
        var Z = 0;
        if (O[Z] !== " ") {
            for(var Y = 0, X = 0; O[Z] === p;)Y++, Z++;
            for(var V = (O.length - Z) * y + 1 >>> 0, q = new Uint8Array(V); O[Z];){
                var re = r[O.charCodeAt(Z)];
                if (re === 255) return;
                for(var ne = 0, fe = V - 1; (re !== 0 || ne < X) && fe !== -1; fe--, ne++)re += m * q[fe] >>> 0, q[fe] = re % 256 >>> 0, re = re / 256 >>> 0;
                if (re !== 0) throw new Error("Non-zero carry");
                X = ne, Z++;
            }
            if (O[Z] !== " ") {
                for(var ye = V - X; ye !== V && q[ye] === 0;)ye++;
                for(var xe = new Uint8Array(Y + (V - ye)), De = Y; ye !== V;)xe[De++] = q[ye++];
                return xe;
            }
        }
    }
    function K(O) {
        var Z = P(O);
        if (Z) return Z;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: v,
        decodeUnsafe: P,
        decode: K
    };
}
var $aec35899a3c9695e$var$xx = $aec35899a3c9695e$var$gx, $aec35899a3c9695e$var$Ex = $aec35899a3c9695e$var$xx;
class $aec35899a3c9695e$var$vx {
    constructor(e, r, i){
        this.name = e, this.prefix = r, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $aec35899a3c9695e$var$Rx {
    constructor(e, r, i){
        if (this.name = e, this.prefix = r, r.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = r.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $aec35899a3c9695e$var$gp(this, e);
    }
}
class $aec35899a3c9695e$var$Ax {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $aec35899a3c9695e$var$gp(this, e);
    }
    decode(e) {
        const r = e[0], i = this.decoders[r];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $aec35899a3c9695e$var$gp = (t, e)=>new $aec35899a3c9695e$var$Ax({
        ...t.decoders || {
            [t.prefix]: t
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $aec35899a3c9695e$var$_x {
    constructor(e, r, i, a){
        this.name = e, this.prefix = r, this.baseEncode = i, this.baseDecode = a, this.encoder = new $aec35899a3c9695e$var$vx(e, r, i), this.decoder = new $aec35899a3c9695e$var$Rx(e, r, a);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $aec35899a3c9695e$var$Uu = ({ name: t, prefix: e, encode: r, decode: i })=>new $aec35899a3c9695e$var$_x(t, e, r, i), $aec35899a3c9695e$var$La = ({ prefix: t, name: e, alphabet: r })=>{
    const { encode: i, decode: a } = $aec35899a3c9695e$var$Ex(r, e);
    return $aec35899a3c9695e$var$Uu({
        prefix: t,
        name: e,
        encode: i,
        decode: (c)=>$aec35899a3c9695e$var$Nc(a(c))
    });
}, $aec35899a3c9695e$var$wx = (t, e, r, i)=>{
    const a = {};
    for(let d = 0; d < e.length; ++d)a[e[d]] = d;
    let c = t.length;
    for(; t[c - 1] === "=";)--c;
    const h = new Uint8Array(c * r / 8 | 0);
    let m = 0, p = 0, y = 0;
    for(let d = 0; d < c; ++d){
        const v = a[t[d]];
        if (v === void 0) throw new SyntaxError(`Non-${i} character`);
        p = p << r | v, m += r, m >= 8 && (m -= 8, h[y++] = 255 & p >> m);
    }
    if (m >= r || 255 & p << 8 - m) throw new SyntaxError("Unexpected end of data");
    return h;
}, $aec35899a3c9695e$var$Tx = (t, e, r)=>{
    const i = e[e.length - 1] === "=", a = (1 << r) - 1;
    let c = "", h = 0, m = 0;
    for(let p = 0; p < t.length; ++p)for(m = m << 8 | t[p], h += 8; h > r;)h -= r, c += e[a & m >> h];
    if (h && (c += e[a & m << r - h]), i) for(; c.length * r & 7;)c += "=";
    return c;
}, $aec35899a3c9695e$var$zt = ({ name: t, prefix: e, bitsPerChar: r, alphabet: i })=>$aec35899a3c9695e$var$Uu({
        prefix: e,
        name: t,
        encode (a) {
            return $aec35899a3c9695e$var$Tx(a, i, r);
        },
        decode (a) {
            return $aec35899a3c9695e$var$wx(a, i, r, t);
        }
    }), $aec35899a3c9695e$var$Ui = $aec35899a3c9695e$var$La({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $aec35899a3c9695e$var$Sx = $aec35899a3c9695e$var$La({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
}), $aec35899a3c9695e$var$Cx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    base58btc: $aec35899a3c9695e$var$Ui,
    base58flickr: $aec35899a3c9695e$var$Sx
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$aa = $aec35899a3c9695e$var$zt({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $aec35899a3c9695e$var$Lx = $aec35899a3c9695e$var$zt({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $aec35899a3c9695e$var$kx = $aec35899a3c9695e$var$zt({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $aec35899a3c9695e$var$Dx = $aec35899a3c9695e$var$zt({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $aec35899a3c9695e$var$Px = $aec35899a3c9695e$var$zt({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $aec35899a3c9695e$var$Bx = $aec35899a3c9695e$var$zt({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $aec35899a3c9695e$var$Ix = $aec35899a3c9695e$var$zt({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $aec35899a3c9695e$var$Ux = $aec35899a3c9695e$var$zt({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $aec35899a3c9695e$var$Ox = $aec35899a3c9695e$var$zt({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
}), $aec35899a3c9695e$var$Kx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    base32: $aec35899a3c9695e$var$aa,
    base32hex: $aec35899a3c9695e$var$Px,
    base32hexpad: $aec35899a3c9695e$var$Ix,
    base32hexpadupper: $aec35899a3c9695e$var$Ux,
    base32hexupper: $aec35899a3c9695e$var$Bx,
    base32pad: $aec35899a3c9695e$var$kx,
    base32padupper: $aec35899a3c9695e$var$Dx,
    base32upper: $aec35899a3c9695e$var$Lx,
    base32z: $aec35899a3c9695e$var$Ox
}, Symbol.toStringTag, {
    value: "Module"
}));
class $aec35899a3c9695e$var$Wt {
    constructor(e, r, i, a){
        this.code = r, this.version = e, this.multihash = i, this.bytes = a, this.byteOffset = a.byteOffset, this.byteLength = a.byteLength, this.asCID = this, this._baseCache = /* @__PURE__ */ new Map(), Object.defineProperties(this, {
            byteOffset: $aec35899a3c9695e$var$ru,
            byteLength: $aec35899a3c9695e$var$ru,
            code: $aec35899a3c9695e$var$tu,
            version: $aec35899a3c9695e$var$tu,
            multihash: $aec35899a3c9695e$var$tu,
            bytes: $aec35899a3c9695e$var$tu,
            _baseCache: $aec35899a3c9695e$var$ru,
            asCID: $aec35899a3c9695e$var$ru
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: e, multihash: r } = this;
                    if (e !== $aec35899a3c9695e$var$Qs) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (r.code !== $aec35899a3c9695e$var$jx) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $aec35899a3c9695e$var$Wt.createV0(r);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: e, digest: r } = this.multihash, i = $aec35899a3c9695e$var$mx(e, r);
                    return $aec35899a3c9695e$var$Wt.createV1(this.code, i);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(e) {
        return e && this.code === e.code && this.version === e.version && $aec35899a3c9695e$var$bx(this.multihash, e.multihash);
    }
    toString(e) {
        const { bytes: r, version: i, _baseCache: a } = this;
        switch(i){
            case 0:
                return $aec35899a3c9695e$var$Nx(r, a, e || $aec35899a3c9695e$var$Ui.encoder);
            default:
                return $aec35899a3c9695e$var$Vx(r, a, e || $aec35899a3c9695e$var$aa.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(e) {
        return $aec35899a3c9695e$var$$x(/^0\.0/, $aec35899a3c9695e$var$Gx), !!(e && (e[$aec35899a3c9695e$var$Ud] || e.asCID === e));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(e) {
        if (e instanceof $aec35899a3c9695e$var$Wt) return e;
        if (e != null && e.asCID === e) {
            const { version: r, code: i, multihash: a, bytes: c } = e;
            return new $aec35899a3c9695e$var$Wt(r, i, a, c || $aec35899a3c9695e$var$Id(r, i, a.bytes));
        } else if (e != null && e[$aec35899a3c9695e$var$Ud] === !0) {
            const { version: r, multihash: i, code: a } = e, c = $aec35899a3c9695e$var$yx(i);
            return $aec35899a3c9695e$var$Wt.create(r, a, c);
        } else return null;
    }
    static create(e, r, i) {
        if (typeof r != "number") throw new Error("String codecs are no longer supported");
        switch(e){
            case 0:
                if (r !== $aec35899a3c9695e$var$Qs) throw new Error(`Version 0 CID must use dag-pb (code: ${$aec35899a3c9695e$var$Qs}) block encoding`);
                return new $aec35899a3c9695e$var$Wt(e, r, i, i.bytes);
            case 1:
                {
                    const a = $aec35899a3c9695e$var$Id(e, r, i.bytes);
                    return new $aec35899a3c9695e$var$Wt(e, r, i, a);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(e) {
        return $aec35899a3c9695e$var$Wt.create(0, $aec35899a3c9695e$var$Qs, e);
    }
    static createV1(e, r) {
        return $aec35899a3c9695e$var$Wt.create(1, e, r);
    }
    static decode(e) {
        const [r, i] = $aec35899a3c9695e$var$Wt.decodeFirst(e);
        if (i.length) throw new Error("Incorrect length");
        return r;
    }
    static decodeFirst(e) {
        const r = $aec35899a3c9695e$var$Wt.inspectBytes(e), i = r.size - r.multihashSize, a = $aec35899a3c9695e$var$Nc(e.subarray(i, i + r.multihashSize));
        if (a.byteLength !== r.multihashSize) throw new Error("Incorrect length");
        const c = a.subarray(r.multihashSize - r.digestSize), h = new $aec35899a3c9695e$var$Vc(r.multihashCode, r.digestSize, c, a);
        return [
            r.version === 0 ? $aec35899a3c9695e$var$Wt.createV0(h) : $aec35899a3c9695e$var$Wt.createV1(r.codec, h),
            e.subarray(r.size)
        ];
    }
    static inspectBytes(e) {
        let r = 0;
        const i = ()=>{
            const [v, P] = $aec35899a3c9695e$var$Cc(e.subarray(r));
            return r += P, v;
        };
        let a = i(), c = $aec35899a3c9695e$var$Qs;
        if (a === 18 ? (a = 0, r = 0) : a === 1 && (c = i()), a !== 0 && a !== 1) throw new RangeError(`Invalid CID version ${a}`);
        const h = r, m = i(), p = i(), y = r + p, d = y - h;
        return {
            version: a,
            codec: c,
            multihashCode: m,
            digestSize: p,
            multihashSize: d,
            size: y
        };
    }
    static parse(e, r) {
        const [i, a] = $aec35899a3c9695e$var$Mx(e, r), c = $aec35899a3c9695e$var$Wt.decode(a);
        return c._baseCache.set(i, e), c;
    }
}
const $aec35899a3c9695e$var$Mx = (t, e)=>{
    switch(t[0]){
        case "Q":
            {
                const r = e || $aec35899a3c9695e$var$Ui;
                return [
                    $aec35899a3c9695e$var$Ui.prefix,
                    r.decode(`${$aec35899a3c9695e$var$Ui.prefix}${t}`)
                ];
            }
        case $aec35899a3c9695e$var$Ui.prefix:
            {
                const r = e || $aec35899a3c9695e$var$Ui;
                return [
                    $aec35899a3c9695e$var$Ui.prefix,
                    r.decode(t)
                ];
            }
        case $aec35899a3c9695e$var$aa.prefix:
            {
                const r = e || $aec35899a3c9695e$var$aa;
                return [
                    $aec35899a3c9695e$var$aa.prefix,
                    r.decode(t)
                ];
            }
        default:
            if (e == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                t[0],
                e.decode(t)
            ];
    }
}, $aec35899a3c9695e$var$Nx = (t, e, r)=>{
    const { prefix: i } = r;
    if (i !== $aec35899a3c9695e$var$Ui.prefix) throw Error(`Cannot string encode V0 in ${r.name} encoding`);
    const a = e.get(i);
    if (a == null) {
        const c = r.encode(t).slice(1);
        return e.set(i, c), c;
    } else return a;
}, $aec35899a3c9695e$var$Vx = (t, e, r)=>{
    const { prefix: i } = r, a = e.get(i);
    if (a == null) {
        const c = r.encode(t);
        return e.set(i, c), c;
    } else return a;
}, $aec35899a3c9695e$var$Qs = 112, $aec35899a3c9695e$var$jx = 18, $aec35899a3c9695e$var$Id = (t, e, r)=>{
    const i = $aec35899a3c9695e$var$xu(t), a = i + $aec35899a3c9695e$var$xu(e), c = new Uint8Array(a + r.byteLength);
    return $aec35899a3c9695e$var$gu(t, c, 0), $aec35899a3c9695e$var$gu(e, c, i), c.set(r, a), c;
}, $aec35899a3c9695e$var$Ud = Symbol.for("@ipld/js-cid/CID"), $aec35899a3c9695e$var$tu = {
    writable: !1,
    configurable: !1,
    enumerable: !0
}, $aec35899a3c9695e$var$ru = {
    writable: !1,
    enumerable: !1,
    configurable: !1
}, $aec35899a3c9695e$var$Fx = "0.0.0-dev", $aec35899a3c9695e$var$$x = (t, e)=>{
    if (t.test($aec35899a3c9695e$var$Fx)) console.warn(e);
    else throw new Error(e);
}, $aec35899a3c9695e$var$Gx = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`, $aec35899a3c9695e$var$qx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    CID: $aec35899a3c9695e$var$Wt
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$$s = /* @__PURE__ */ $aec35899a3c9695e$var$Xf($aec35899a3c9695e$var$qx);
function $aec35899a3c9695e$var$zx(t, e) {
    for(let r = 0; r < t.byteLength; r++){
        if (t[r] < e[r]) return -1;
        if (t[r] > e[r]) return 1;
    }
    return t.byteLength > e.byteLength ? 1 : t.byteLength < e.byteLength ? -1 : 0;
}
function $aec35899a3c9695e$var$Xx(t, e) {
    e || (e = t.reduce((a, c)=>a + c.length, 0));
    const r = new Uint8Array(e);
    let i = 0;
    for (const a of t)r.set(a, i), i += a.length;
    return r;
}
function $aec35899a3c9695e$var$Hx(t, e) {
    if (t === e) return !0;
    if (t.byteLength !== e.byteLength) return !1;
    for(let r = 0; r < t.byteLength; r++)if (t[r] !== e[r]) return !1;
    return !0;
}
const $aec35899a3c9695e$var$Zx = $aec35899a3c9695e$var$Uu({
    prefix: "\0",
    name: "identity",
    encode: (t)=>$aec35899a3c9695e$var$hx(t),
    decode: (t)=>$aec35899a3c9695e$var$px(t)
}), $aec35899a3c9695e$var$Wx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    identity: $aec35899a3c9695e$var$Zx
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$Yx = $aec35899a3c9695e$var$zt({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
}), $aec35899a3c9695e$var$Jx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    base2: $aec35899a3c9695e$var$Yx
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$Qx = $aec35899a3c9695e$var$zt({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
}), $aec35899a3c9695e$var$eE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    base8: $aec35899a3c9695e$var$Qx
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$tE = $aec35899a3c9695e$var$La({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
}), $aec35899a3c9695e$var$rE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    base10: $aec35899a3c9695e$var$tE
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$iE = $aec35899a3c9695e$var$zt({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $aec35899a3c9695e$var$nE = $aec35899a3c9695e$var$zt({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
}), $aec35899a3c9695e$var$sE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    base16: $aec35899a3c9695e$var$iE,
    base16upper: $aec35899a3c9695e$var$nE
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$aE = $aec35899a3c9695e$var$La({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $aec35899a3c9695e$var$oE = $aec35899a3c9695e$var$La({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
}), $aec35899a3c9695e$var$lE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    base36: $aec35899a3c9695e$var$aE,
    base36upper: $aec35899a3c9695e$var$oE
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$uE = $aec35899a3c9695e$var$zt({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $aec35899a3c9695e$var$cE = $aec35899a3c9695e$var$zt({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $aec35899a3c9695e$var$dE = $aec35899a3c9695e$var$zt({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $aec35899a3c9695e$var$fE = $aec35899a3c9695e$var$zt({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
}), $aec35899a3c9695e$var$pE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    base64: $aec35899a3c9695e$var$uE,
    base64pad: $aec35899a3c9695e$var$cE,
    base64url: $aec35899a3c9695e$var$dE,
    base64urlpad: $aec35899a3c9695e$var$fE
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$xp = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $aec35899a3c9695e$var$hE = $aec35899a3c9695e$var$xp.reduce((t, e, r)=>(t[r] = e, t), []), $aec35899a3c9695e$var$mE = $aec35899a3c9695e$var$xp.reduce((t, e, r)=>(t[e.codePointAt(0)] = r, t), []);
function $aec35899a3c9695e$var$yE(t) {
    return t.reduce((e, r)=>(e += $aec35899a3c9695e$var$hE[r], e), "");
}
function $aec35899a3c9695e$var$bE(t) {
    const e = [];
    for (const r of t){
        const i = $aec35899a3c9695e$var$mE[r.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${r}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $aec35899a3c9695e$var$gE = $aec35899a3c9695e$var$Uu({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $aec35899a3c9695e$var$yE,
    decode: $aec35899a3c9695e$var$bE
}), $aec35899a3c9695e$var$xE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    base256emoji: $aec35899a3c9695e$var$gE
}, Symbol.toStringTag, {
    value: "Module"
}));
new TextEncoder();
new TextDecoder();
const $aec35899a3c9695e$var$Od = {
    ...$aec35899a3c9695e$var$Wx,
    ...$aec35899a3c9695e$var$Jx,
    ...$aec35899a3c9695e$var$eE,
    ...$aec35899a3c9695e$var$rE,
    ...$aec35899a3c9695e$var$sE,
    ...$aec35899a3c9695e$var$Kx,
    ...$aec35899a3c9695e$var$lE,
    ...$aec35899a3c9695e$var$Cx,
    ...$aec35899a3c9695e$var$pE,
    ...$aec35899a3c9695e$var$xE
};
function $aec35899a3c9695e$var$Ep(t, e, r, i) {
    return {
        name: t,
        prefix: e,
        encoder: {
            name: t,
            prefix: e,
            encode: r
        },
        decoder: {
            decode: i
        }
    };
}
const $aec35899a3c9695e$var$Kd = $aec35899a3c9695e$var$Ep("utf8", "u", (t)=>"u" + new TextDecoder("utf8").decode(t), (t)=>new TextEncoder().encode(t.substring(1))), $aec35899a3c9695e$var$fc = $aec35899a3c9695e$var$Ep("ascii", "a", (t)=>{
    let e = "a";
    for(let r = 0; r < t.length; r++)e += String.fromCharCode(t[r]);
    return e;
}, (t)=>{
    t = t.substring(1);
    const e = new Uint8Array(t.length);
    for(let r = 0; r < t.length; r++)e[r] = t.charCodeAt(r);
    return e;
}), $aec35899a3c9695e$var$vp = {
    utf8: $aec35899a3c9695e$var$Kd,
    "utf-8": $aec35899a3c9695e$var$Kd,
    hex: $aec35899a3c9695e$var$Od.base16,
    latin1: $aec35899a3c9695e$var$fc,
    ascii: $aec35899a3c9695e$var$fc,
    binary: $aec35899a3c9695e$var$fc,
    ...$aec35899a3c9695e$var$Od
};
function $aec35899a3c9695e$var$EE(t, e = "utf8") {
    const r = $aec35899a3c9695e$var$vp[e];
    if (!r) throw new Error(`Unsupported encoding "${e}"`);
    return r.decoder.decode(`${r.prefix}${t}`);
}
function $aec35899a3c9695e$var$vE(t, e = "utf8") {
    const r = $aec35899a3c9695e$var$vp[e];
    if (!r) throw new Error(`Unsupported encoding "${e}"`);
    return r.encoder.encode(t).substring(1);
}
function $aec35899a3c9695e$var$RE(t, e) {
    if (t.length !== e.length) throw new Error("Inputs should have the same length");
    const r = new Uint8Array(t.length);
    for(let i = 0; i < t.length; i++)r[i] = t[i] ^ e[i];
    return r;
}
const $aec35899a3c9695e$var$AE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    compare: $aec35899a3c9695e$var$zx,
    concat: $aec35899a3c9695e$var$Xx,
    equals: $aec35899a3c9695e$var$Hx,
    fromString: $aec35899a3c9695e$var$EE,
    toString: $aec35899a3c9695e$var$vE,
    xor: $aec35899a3c9695e$var$RE
}, Symbol.toStringTag, {
    value: "Module"
})), $aec35899a3c9695e$var$Rp = /* @__PURE__ */ $aec35899a3c9695e$var$Xf($aec35899a3c9695e$var$AE);
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(y, d, v, P) {
        P === void 0 && (P = v);
        var K = Object.getOwnPropertyDescriptor(d, v);
        (!K || ("get" in K ? !d.__esModule : K.writable || K.configurable)) && (K = {
            enumerable: !0,
            get: function() {
                return d[v];
            }
        }), Object.defineProperty(y, P, K);
    } : function(y, d, v, P) {
        P === void 0 && (P = v), y[P] = d[v];
    }), r = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__setModuleDefault || (Object.create ? function(y, d) {
        Object.defineProperty(y, "default", {
            enumerable: !0,
            value: d
        });
    } : function(y, d) {
        y.default = d;
    }), i = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importStar || function(y) {
        if (y && y.__esModule) return y;
        var d = {};
        if (y != null) for(var v in y)v !== "default" && Object.prototype.hasOwnProperty.call(y, v) && e(d, y, v);
        return r(d, y), d;
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.ipldEquals = t.ipldToJson = t.jsonToIpld = void 0;
    const a = $aec35899a3c9695e$var$$s, c = i($aec35899a3c9695e$var$Rp), h = (y)=>{
        if (Array.isArray(y)) return y.map((d)=>(0, t.jsonToIpld)(d));
        if (y && typeof y == "object") {
            if (typeof y.$link == "string" && Object.keys(y).length === 1) return a.CID.parse(y.$link);
            if (typeof y.$bytes == "string" && Object.keys(y).length === 1) return c.fromString(y.$bytes, "base64");
            const d = {};
            for (const v of Object.keys(y))d[v] = (0, t.jsonToIpld)(y[v]);
            return d;
        }
        return y;
    };
    t.jsonToIpld = h;
    const m = (y)=>{
        if (Array.isArray(y)) return y.map((d)=>(0, t.ipldToJson)(d));
        if (y && typeof y == "object") {
            if (y instanceof Uint8Array) return {
                $bytes: c.toString(y, "base64")
            };
            if (a.CID.asCID(y)) return {
                $link: y.toString()
            };
            const d = {};
            for (const v of Object.keys(y))d[v] = (0, t.ipldToJson)(y[v]);
            return d;
        }
        return y;
    };
    t.ipldToJson = m;
    const p = (y, d)=>{
        if (Array.isArray(y) && Array.isArray(d)) {
            if (y.length !== d.length) return !1;
            for(let v = 0; v < y.length; v++)if (!(0, t.ipldEquals)(y[v], d[v])) return !1;
            return !0;
        }
        if (y && d && typeof y == "object" && typeof d == "object") {
            if (y instanceof Uint8Array && d instanceof Uint8Array) return c.equals(y, d);
            if (a.CID.asCID(y) && a.CID.asCID(d)) return a.CID.asCID(y)?.equals(a.CID.asCID(d));
            if (Object.keys(y).length !== Object.keys(d).length) return !1;
            for (const v of Object.keys(y))if (!(0, t.ipldEquals)(y[v], d[v])) return !1;
            return !0;
        }
        return y === d;
    };
    t.ipldEquals = p;
})($aec35899a3c9695e$var$yp);
var $aec35899a3c9695e$var$ws = {};
Object.defineProperty($aec35899a3c9695e$var$ws, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ws.backoffMs = $aec35899a3c9695e$var$ws.retry = void 0;
const $aec35899a3c9695e$var$_E = $aec35899a3c9695e$var$As;
async function $aec35899a3c9695e$var$wE(t, e = {}) {
    const { maxRetries: r = 3, retryable: i = ()=>!0, getWaitMs: a = $aec35899a3c9695e$var$Ap } = e;
    let c = 0, h;
    for(; !h;)try {
        return await t();
    } catch (m) {
        const p = a(c);
        c < r && p !== null && i(m) ? (c += 1, p !== 0 && await (0, $aec35899a3c9695e$var$_E.wait)(p)) : h = m;
    }
    throw h;
}
$aec35899a3c9695e$var$ws.retry = $aec35899a3c9695e$var$wE;
function $aec35899a3c9695e$var$Ap(t, e = 100, r = 1e3) {
    const i = Math.pow(2, t) * e, a = Math.min(i, r);
    return $aec35899a3c9695e$var$TE(a);
}
$aec35899a3c9695e$var$ws.backoffMs = $aec35899a3c9695e$var$Ap;
function $aec35899a3c9695e$var$TE(t) {
    const e = t * 0.15;
    return t + $aec35899a3c9695e$var$SE(-e, e);
}
function $aec35899a3c9695e$var$SE(t, e) {
    return Math.random() * (e - t) + t;
}
var $aec35899a3c9695e$var$_p = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.def = t.schema = void 0;
    const e = $aec35899a3c9695e$var$$s, r = $aec35899a3c9695e$var$os, i = r.z.any().refine((a)=>e.CID.asCID(a) !== null, {
        message: "Not a CID"
    }).transform((a)=>e.CID.asCID(a));
    t.schema = {
        cid: i,
        bytes: r.z.instanceof(Uint8Array),
        string: r.z.string(),
        array: r.z.array(r.z.unknown()),
        map: r.z.record(r.z.string(), r.z.unknown()),
        unknown: r.z.unknown()
    }, t.def = {
        cid: {
            name: "cid",
            schema: t.schema.cid
        },
        bytes: {
            name: "bytes",
            schema: t.schema.bytes
        },
        string: {
            name: "string",
            schema: t.schema.string
        },
        map: {
            name: "map",
            schema: t.schema.map
        },
        unknown: {
            name: "unknown",
            schema: t.schema.unknown
        }
    };
})($aec35899a3c9695e$var$_p);
var $aec35899a3c9695e$var$wp = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.addHoursToDate = t.lessThanAgoMs = t.DAY = t.HOUR = t.MINUTE = t.SECOND = void 0, t.SECOND = 1e3, t.MINUTE = t.SECOND * 60, t.HOUR = t.MINUTE * 60, t.DAY = t.HOUR * 24;
    const e = (i, a)=>Date.now() < i.getTime() + a;
    t.lessThanAgoMs = e;
    const r = (i, a)=>{
        const c = a ? new Date(a) : /* @__PURE__ */ new Date();
        return c.setHours(c.getHours() + i), c;
    };
    t.addHoursToDate = r;
})($aec35899a3c9695e$var$wp);
var $aec35899a3c9695e$var$yr = {}, $aec35899a3c9695e$var$jc = {}, $aec35899a3c9695e$var$Fc = {}, $aec35899a3c9695e$var$$c = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.EXTENDED_PICTOGRAPHIC = t.CLUSTER_BREAK = void 0, function(e) {
        e[e.CR = 0] = "CR", e[e.LF = 1] = "LF", e[e.CONTROL = 2] = "CONTROL", e[e.EXTEND = 3] = "EXTEND", e[e.REGIONAL_INDICATOR = 4] = "REGIONAL_INDICATOR", e[e.SPACINGMARK = 5] = "SPACINGMARK", e[e.L = 6] = "L", e[e.V = 7] = "V", e[e.T = 8] = "T", e[e.LV = 9] = "LV", e[e.LVT = 10] = "LVT", e[e.OTHER = 11] = "OTHER", e[e.PREPEND = 12] = "PREPEND", e[e.E_BASE = 13] = "E_BASE", e[e.E_MODIFIER = 14] = "E_MODIFIER", e[e.ZWJ = 15] = "ZWJ", e[e.GLUE_AFTER_ZWJ = 16] = "GLUE_AFTER_ZWJ", e[e.E_BASE_GAZ = 17] = "E_BASE_GAZ";
    }(t.CLUSTER_BREAK || (t.CLUSTER_BREAK = {})), t.EXTENDED_PICTOGRAPHIC = 101;
})($aec35899a3c9695e$var$$c);
var $aec35899a3c9695e$var$Gc = {};
Object.defineProperty($aec35899a3c9695e$var$Gc, "__esModule", {
    value: !0
});
const $aec35899a3c9695e$var$ze = $aec35899a3c9695e$var$$c, $aec35899a3c9695e$var$Li = 0, $aec35899a3c9695e$var$pc = 1, $aec35899a3c9695e$var$CE = 2, $aec35899a3c9695e$var$LE = 3, $aec35899a3c9695e$var$kE = 4;
class $aec35899a3c9695e$var$DE {
    /**
   * Check if the the character at the position {pos} of the string is surrogate
   * @param str {string}
   * @param pos {number}
   * @returns {boolean}
   */ static isSurrogate(e, r) {
        return 55296 <= e.charCodeAt(r) && e.charCodeAt(r) <= 56319 && 56320 <= e.charCodeAt(r + 1) && e.charCodeAt(r + 1) <= 57343;
    }
    /**
   * The String.prototype.codePointAt polyfill
   * Private function, gets a Unicode code point from a JavaScript UTF-16 string
   * handling surrogate pairs appropriately
   * @param str {string}
   * @param idx {number}
   * @returns {number}
   */ static codePointAt(e, r) {
        r === void 0 && (r = 0);
        const i = e.charCodeAt(r);
        if (55296 <= i && i <= 56319 && r < e.length - 1) {
            const a = i, c = e.charCodeAt(r + 1);
            return 56320 <= c && c <= 57343 ? (a - 55296) * 1024 + (c - 56320) + 65536 : a;
        }
        if (56320 <= i && i <= 57343 && r >= 1) {
            const a = e.charCodeAt(r - 1), c = i;
            return 55296 <= a && a <= 56319 ? (a - 55296) * 1024 + (c - 56320) + 65536 : c;
        }
        return i;
    }
    //
    /**
   * Private function, returns whether a break is allowed between the two given grapheme breaking classes
   * Implemented the UAX #29 3.1.1 Grapheme Cluster Boundary Rules on extended grapheme clusters
   * @param start {number}
   * @param mid {Array<number>}
   * @param end {number}
   * @param startEmoji {number}
   * @param midEmoji {Array<number>}
   * @param endEmoji {number}
   * @returns {number}
   */ static shouldBreak(e, r, i, a, c, h) {
        const m = [
            e
        ].concat(r).concat([
            i
        ]), p = [
            a
        ].concat(c).concat([
            h
        ]), y = m[m.length - 2], d = i, v = h, P = m.lastIndexOf($aec35899a3c9695e$var$ze.CLUSTER_BREAK.REGIONAL_INDICATOR);
        if (P > 0 && m.slice(1, P).every(function(O) {
            return O === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.REGIONAL_INDICATOR;
        }) && [
            $aec35899a3c9695e$var$ze.CLUSTER_BREAK.PREPEND,
            $aec35899a3c9695e$var$ze.CLUSTER_BREAK.REGIONAL_INDICATOR
        ].indexOf(y) === -1) return m.filter(function(O) {
            return O === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.REGIONAL_INDICATOR;
        }).length % 2 === 1 ? $aec35899a3c9695e$var$LE : $aec35899a3c9695e$var$kE;
        if (y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.CR && d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.LF) return $aec35899a3c9695e$var$Li;
        if (y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.CONTROL || y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.CR || y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.LF) return $aec35899a3c9695e$var$pc;
        if (d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.CONTROL || d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.CR || d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.LF) return $aec35899a3c9695e$var$pc;
        if (y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.L && (d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.L || d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.V || d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.LV || d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.LVT)) return $aec35899a3c9695e$var$Li;
        if ((y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.LV || y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.V) && (d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.V || d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.T)) return $aec35899a3c9695e$var$Li;
        if ((y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.LVT || y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.T) && d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.T) return $aec35899a3c9695e$var$Li;
        if (d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.EXTEND || d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.ZWJ) return $aec35899a3c9695e$var$Li;
        if (d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.SPACINGMARK) return $aec35899a3c9695e$var$Li;
        if (y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.PREPEND) return $aec35899a3c9695e$var$Li;
        const K = p.slice(0, -1).lastIndexOf($aec35899a3c9695e$var$ze.EXTENDED_PICTOGRAPHIC);
        return K !== -1 && p[K] === $aec35899a3c9695e$var$ze.EXTENDED_PICTOGRAPHIC && m.slice(K + 1, -2).every(function(O) {
            return O === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.EXTEND;
        }) && y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.ZWJ && v === $aec35899a3c9695e$var$ze.EXTENDED_PICTOGRAPHIC ? $aec35899a3c9695e$var$Li : r.indexOf($aec35899a3c9695e$var$ze.CLUSTER_BREAK.REGIONAL_INDICATOR) !== -1 ? $aec35899a3c9695e$var$CE : y === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.REGIONAL_INDICATOR && d === $aec35899a3c9695e$var$ze.CLUSTER_BREAK.REGIONAL_INDICATOR ? $aec35899a3c9695e$var$Li : $aec35899a3c9695e$var$pc;
    }
}
$aec35899a3c9695e$var$Gc.default = $aec35899a3c9695e$var$DE;
var $aec35899a3c9695e$var$qc = {};
Object.defineProperty($aec35899a3c9695e$var$qc, "__esModule", {
    value: !0
});
class $aec35899a3c9695e$var$PE {
    constructor(e, r){
        this._index = 0, this._str = e, this._nextBreak = r;
    }
    [Symbol.iterator]() {
        return this;
    }
    next() {
        let e;
        if ((e = this._nextBreak(this._str, this._index)) < this._str.length) {
            const r = this._str.slice(this._index, e);
            return this._index = e, {
                value: r,
                done: !1
            };
        }
        if (this._index < this._str.length) {
            const r = this._str.slice(this._index);
            return this._index = this._str.length, {
                value: r,
                done: !1
            };
        }
        return {
            value: void 0,
            done: !0
        };
    }
}
$aec35899a3c9695e$var$qc.default = $aec35899a3c9695e$var$PE;
var $aec35899a3c9695e$var$Tp = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importDefault || function(t) {
    return t && t.__esModule ? t : {
        default: t
    };
};
Object.defineProperty($aec35899a3c9695e$var$Fc, "__esModule", {
    value: !0
});
const $aec35899a3c9695e$var$n = $aec35899a3c9695e$var$$c, $aec35899a3c9695e$var$iu = $aec35899a3c9695e$var$Tp($aec35899a3c9695e$var$Gc), $aec35899a3c9695e$var$BE = $aec35899a3c9695e$var$Tp($aec35899a3c9695e$var$qc);
class $aec35899a3c9695e$var$Pi {
    /**
   * Returns the next grapheme break in the string after the given index
   * @param string {string}
   * @param index {number}
   * @returns {number}
   */ static nextBreak(e, r) {
        if (r === void 0 && (r = 0), r < 0) return 0;
        if (r >= e.length - 1) return e.length;
        const i = $aec35899a3c9695e$var$iu.default.codePointAt(e, r), a = $aec35899a3c9695e$var$Pi.getGraphemeBreakProperty(i), c = $aec35899a3c9695e$var$Pi.getEmojiProperty(i), h = [], m = [];
        for(let p = r + 1; p < e.length; p++){
            if ($aec35899a3c9695e$var$iu.default.isSurrogate(e, p - 1)) continue;
            const y = $aec35899a3c9695e$var$iu.default.codePointAt(e, p), d = $aec35899a3c9695e$var$Pi.getGraphemeBreakProperty(y), v = $aec35899a3c9695e$var$Pi.getEmojiProperty(y);
            if ($aec35899a3c9695e$var$iu.default.shouldBreak(a, h, d, c, m, v)) return p;
            h.push(d), m.push(v);
        }
        return e.length;
    }
    /**
   * Breaks the given string into an array of grapheme clusters
   * @param str {string}
   * @returns {string[]}
   */ splitGraphemes(e) {
        const r = [];
        let i = 0, a;
        for(; (a = $aec35899a3c9695e$var$Pi.nextBreak(e, i)) < e.length;)r.push(e.slice(i, a)), i = a;
        return i < e.length && r.push(e.slice(i)), r;
    }
    /**
   * Returns an iterator of grapheme clusters in the given string
   * @param str {string}
   * @returns {GraphemerIterator}
   */ iterateGraphemes(e) {
        return new $aec35899a3c9695e$var$BE.default(e, $aec35899a3c9695e$var$Pi.nextBreak);
    }
    /**
   * Returns the number of grapheme clusters in the given string
   * @param str {string}
   * @returns {number}
   */ countGraphemes(e) {
        let r = 0, i = 0, a;
        for(; (a = $aec35899a3c9695e$var$Pi.nextBreak(e, i)) < e.length;)i = a, r++;
        return i < e.length && r++, r;
    }
    /**
   * Given a Unicode code point, determines this symbol's grapheme break property
   * @param code {number} Unicode code point
   * @returns {number}
   */ static getGraphemeBreakProperty(e) {
        if (e < 48905) {
            if (e < 44116) {
                if (e < 4141) {
                    if (e < 2818) {
                        if (e < 2363) {
                            if (e < 1759) {
                                if (e < 1471) {
                                    if (e < 127) {
                                        if (e < 11) {
                                            if (e < 10) {
                                                if (0 <= e && e <= 9) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                                            } else if (e === 10) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LF;
                                        } else if (e < 13) {
                                            if (11 <= e && e <= 12) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                                        } else if (e < 14) {
                                            if (e === 13) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CR;
                                        } else if (14 <= e && e <= 31) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                                    } else if (e < 768) {
                                        if (e < 173) {
                                            if (127 <= e && e <= 159) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                                        } else if (e === 173) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                                    } else if (e < 1155) {
                                        if (768 <= e && e <= 879) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e < 1425) {
                                        if (1155 <= e && e <= 1161) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (1425 <= e && e <= 1469) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 1552) {
                                    if (e < 1476) {
                                        if (e < 1473) {
                                            if (e === 1471) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                        } else if (1473 <= e && e <= 1474) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e < 1479) {
                                        if (1476 <= e && e <= 1477) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e < 1536) {
                                        if (e === 1479) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (1536 <= e && e <= 1541) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                                } else if (e < 1648) {
                                    if (e < 1564) {
                                        if (1552 <= e && e <= 1562) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e < 1611) {
                                        if (e === 1564) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                                    } else if (1611 <= e && e <= 1631) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 1750) {
                                    if (e === 1648) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 1757) {
                                    if (1750 <= e && e <= 1756) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 1757) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                            } else if (e < 2075) {
                                if (e < 1840) {
                                    if (e < 1770) {
                                        if (e < 1767) {
                                            if (1759 <= e && e <= 1764) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                        } else if (1767 <= e && e <= 1768) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e < 1807) {
                                        if (1770 <= e && e <= 1773) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (e === 1807) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                                        if (e === 1809) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (e < 2027) {
                                    if (e < 1958) {
                                        if (1840 <= e && e <= 1866) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (1958 <= e && e <= 1968) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2045) {
                                    if (2027 <= e && e <= 2035) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2070) {
                                    if (e === 2045) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (2070 <= e && e <= 2073) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 2200) {
                                if (e < 2089) {
                                    if (e < 2085) {
                                        if (2075 <= e && e <= 2083) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (2085 <= e && e <= 2087) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2137) {
                                    if (2089 <= e && e <= 2093) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2192) {
                                    if (2137 <= e && e <= 2139) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (2192 <= e && e <= 2193) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                            } else if (e < 2275) {
                                if (e < 2250) {
                                    if (2200 <= e && e <= 2207) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2274) {
                                    if (2250 <= e && e <= 2273) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 2274) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                            } else if (e < 2307) {
                                if (2275 <= e && e <= 2306) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else {
                                if (e === 2307) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                if (e === 2362) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (e < 2561) {
                            if (e < 2434) {
                                if (e < 2381) {
                                    if (e < 2366) {
                                        if (e === 2363) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                        if (e === 2364) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e < 2369) {
                                        if (2366 <= e && e <= 2368) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e < 2377) {
                                        if (2369 <= e && e <= 2376) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (2377 <= e && e <= 2380) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 2385) {
                                    if (e < 2382) {
                                        if (e === 2381) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (2382 <= e && e <= 2383) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 2402) {
                                    if (2385 <= e && e <= 2391) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2433) {
                                    if (2402 <= e && e <= 2403) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 2433) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 2503) {
                                if (e < 2494) {
                                    if (e < 2492) {
                                        if (2434 <= e && e <= 2435) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e === 2492) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2495) {
                                    if (e === 2494) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2497) {
                                    if (2495 <= e && e <= 2496) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (2497 <= e && e <= 2500) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 2519) {
                                if (e < 2507) {
                                    if (2503 <= e && e <= 2504) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 2509) {
                                    if (2507 <= e && e <= 2508) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e === 2509) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 2530) {
                                if (e === 2519) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 2558) {
                                if (2530 <= e && e <= 2531) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e === 2558) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 2691) {
                            if (e < 2631) {
                                if (e < 2620) {
                                    if (e < 2563) {
                                        if (2561 <= e && e <= 2562) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e === 2563) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 2622) {
                                    if (e === 2620) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2625) {
                                    if (2622 <= e && e <= 2624) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (2625 <= e && e <= 2626) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 2672) {
                                if (e < 2635) {
                                    if (2631 <= e && e <= 2632) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2641) {
                                    if (2635 <= e && e <= 2637) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 2641) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 2677) {
                                if (2672 <= e && e <= 2673) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 2689) {
                                if (e === 2677) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (2689 <= e && e <= 2690) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 2761) {
                            if (e < 2750) {
                                if (e === 2691) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                if (e === 2748) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 2753) {
                                if (2750 <= e && e <= 2752) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 2759) {
                                if (2753 <= e && e <= 2757) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (2759 <= e && e <= 2760) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 2786) {
                            if (e < 2763) {
                                if (e === 2761) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 2765) {
                                if (2763 <= e && e <= 2764) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e === 2765) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 2810) {
                            if (2786 <= e && e <= 2787) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 2817) {
                            if (2810 <= e && e <= 2815) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e === 2817) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 3315) {
                        if (e < 3076) {
                            if (e < 2946) {
                                if (e < 2887) {
                                    if (e < 2878) {
                                        if (e < 2876) {
                                            if (2818 <= e && e <= 2819) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e === 2876) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e < 2880) {
                                        if (2878 <= e && e <= 2879) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e < 2881) {
                                        if (e === 2880) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (2881 <= e && e <= 2884) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2893) {
                                    if (e < 2891) {
                                        if (2887 <= e && e <= 2888) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (2891 <= e && e <= 2892) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 2901) {
                                    if (e === 2893) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 2914) {
                                    if (2901 <= e && e <= 2903) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (2914 <= e && e <= 2915) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3014) {
                                if (e < 3007) {
                                    if (e === 2946 || e === 3006) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 3008) {
                                    if (e === 3007) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 3009) {
                                    if (e === 3008) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (3009 <= e && e <= 3010) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 3031) {
                                if (e < 3018) {
                                    if (3014 <= e && e <= 3016) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 3021) {
                                    if (3018 <= e && e <= 3020) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e === 3021) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3072) {
                                if (e === 3031) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3073) {
                                if (e === 3072) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (3073 <= e && e <= 3075) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 3262) {
                            if (e < 3146) {
                                if (e < 3134) {
                                    if (e === 3076 || e === 3132) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 3137) {
                                    if (3134 <= e && e <= 3136) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 3142) {
                                    if (3137 <= e && e <= 3140) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (3142 <= e && e <= 3144) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3201) {
                                if (e < 3157) {
                                    if (3146 <= e && e <= 3149) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 3170) {
                                    if (3157 <= e && e <= 3158) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (3170 <= e && e <= 3171) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3202) {
                                if (e === 3201) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3260) {
                                if (3202 <= e && e <= 3203) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e === 3260) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 3270) {
                            if (e < 3264) {
                                if (e === 3262) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                if (e === 3263) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3266) {
                                if (3264 <= e && e <= 3265) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 3267) {
                                if (e === 3266) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (3267 <= e && e <= 3268) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 3276) {
                            if (e < 3271) {
                                if (e === 3270) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3274) {
                                if (3271 <= e && e <= 3272) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (3274 <= e && e <= 3275) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 3285) {
                            if (3276 <= e && e <= 3277) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 3298) {
                            if (3285 <= e && e <= 3286) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (3298 <= e && e <= 3299) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 3551) {
                        if (e < 3406) {
                            if (e < 3391) {
                                if (e < 3330) {
                                    if (e < 3328) {
                                        if (e === 3315) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (3328 <= e && e <= 3329) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 3387) {
                                    if (3330 <= e && e <= 3331) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 3390) {
                                    if (3387 <= e && e <= 3388) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 3390) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3398) {
                                if (e < 3393) {
                                    if (3391 <= e && e <= 3392) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (3393 <= e && e <= 3396) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3402) {
                                if (3398 <= e && e <= 3400) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 3405) {
                                if (3402 <= e && e <= 3404) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e === 3405) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 3530) {
                            if (e < 3426) {
                                if (e === 3406) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                                if (e === 3415) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3457) {
                                if (3426 <= e && e <= 3427) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3458) {
                                if (e === 3457) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (3458 <= e && e <= 3459) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 3538) {
                            if (e < 3535) {
                                if (e === 3530) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3536) {
                                if (e === 3535) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (3536 <= e && e <= 3537) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 3542) {
                            if (3538 <= e && e <= 3540) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 3544) {
                            if (e === 3542) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (3544 <= e && e <= 3550) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 3893) {
                        if (e < 3655) {
                            if (e < 3633) {
                                if (e < 3570) {
                                    if (e === 3551) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (3570 <= e && e <= 3571) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 3635) {
                                if (e === 3633) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 3636) {
                                if (e === 3635) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (3636 <= e && e <= 3642) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 3764) {
                            if (e < 3761) {
                                if (3655 <= e && e <= 3662) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else {
                                if (e === 3761) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                if (e === 3763) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            }
                        } else if (e < 3784) {
                            if (3764 <= e && e <= 3772) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 3864) {
                            if (3784 <= e && e <= 3790) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (3864 <= e && e <= 3865) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 3967) {
                        if (e < 3897) {
                            if (e === 3893 || e === 3895) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 3902) {
                            if (e === 3897) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 3953) {
                            if (3902 <= e && e <= 3903) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (3953 <= e && e <= 3966) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 3981) {
                        if (e < 3968) {
                            if (e === 3967) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 3974) {
                            if (3968 <= e && e <= 3972) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (3974 <= e && e <= 3975) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 3993) {
                        if (3981 <= e && e <= 3991) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 4038) {
                        if (3993 <= e && e <= 4028) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e === 4038) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 7204) {
                    if (e < 6448) {
                        if (e < 5938) {
                            if (e < 4226) {
                                if (e < 4157) {
                                    if (e < 4146) {
                                        if (e < 4145) {
                                            if (4141 <= e && e <= 4144) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                        } else if (e === 4145) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e < 4153) {
                                        if (4146 <= e && e <= 4151) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e < 4155) {
                                        if (4153 <= e && e <= 4154) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (4155 <= e && e <= 4156) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 4184) {
                                    if (e < 4182) {
                                        if (4157 <= e && e <= 4158) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (4182 <= e && e <= 4183) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 4190) {
                                    if (4184 <= e && e <= 4185) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 4209) {
                                    if (4190 <= e && e <= 4192) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (4209 <= e && e <= 4212) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 4352) {
                                if (e < 4229) {
                                    if (e === 4226) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    if (e === 4228) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 4237) {
                                    if (4229 <= e && e <= 4230) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 4237 || e === 4253) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 4957) {
                                if (e < 4448) {
                                    if (4352 <= e && e <= 4447) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.L;
                                } else if (e < 4520) {
                                    if (4448 <= e && e <= 4519) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.V;
                                } else if (4520 <= e && e <= 4607) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.T;
                            } else if (e < 5906) {
                                if (4957 <= e && e <= 4959) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 5909) {
                                if (5906 <= e && e <= 5908) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e === 5909) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 6089) {
                            if (e < 6070) {
                                if (e < 5970) {
                                    if (e < 5940) {
                                        if (5938 <= e && e <= 5939) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                    } else if (e === 5940) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 6002) {
                                    if (5970 <= e && e <= 5971) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 6068) {
                                    if (6002 <= e && e <= 6003) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (6068 <= e && e <= 6069) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6078) {
                                if (e < 6071) {
                                    if (e === 6070) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (6071 <= e && e <= 6077) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6086) {
                                if (6078 <= e && e <= 6085) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 6087) {
                                if (e === 6086) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (6087 <= e && e <= 6088) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 6277) {
                            if (e < 6155) {
                                if (e < 6109) {
                                    if (6089 <= e && e <= 6099) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 6109) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6158) {
                                if (6155 <= e && e <= 6157) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else {
                                if (e === 6158) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                                if (e === 6159) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (e < 6435) {
                            if (e < 6313) {
                                if (6277 <= e && e <= 6278) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6432) {
                                if (e === 6313) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (6432 <= e && e <= 6434) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 6439) {
                            if (6435 <= e && e <= 6438) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 6441) {
                            if (6439 <= e && e <= 6440) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (6441 <= e && e <= 6443) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 6971) {
                        if (e < 6744) {
                            if (e < 6681) {
                                if (e < 6451) {
                                    if (e < 6450) {
                                        if (6448 <= e && e <= 6449) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e === 6450) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 6457) {
                                    if (6451 <= e && e <= 6456) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 6679) {
                                    if (6457 <= e && e <= 6459) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (6679 <= e && e <= 6680) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6741) {
                                if (e < 6683) {
                                    if (6681 <= e && e <= 6682) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e === 6683) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6742) {
                                if (e === 6741) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else {
                                if (e === 6742) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                if (e === 6743) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            }
                        } else if (e < 6771) {
                            if (e < 6754) {
                                if (e < 6752) {
                                    if (6744 <= e && e <= 6750) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 6752) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6757) {
                                if (e === 6754) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6765) {
                                if (6757 <= e && e <= 6764) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (6765 <= e && e <= 6770) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 6912) {
                            if (e < 6783) {
                                if (6771 <= e && e <= 6780) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6832) {
                                if (e === 6783) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (6832 <= e && e <= 6862) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 6916) {
                            if (6912 <= e && e <= 6915) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 6964) {
                            if (e === 6916) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (6964 <= e && e <= 6970) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 7080) {
                        if (e < 7019) {
                            if (e < 6973) {
                                if (e === 6971) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                if (e === 6972) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 6978) {
                                if (6973 <= e && e <= 6977) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 6979) {
                                if (e === 6978) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (6979 <= e && e <= 6980) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 7073) {
                            if (e < 7040) {
                                if (7019 <= e && e <= 7027) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 7042) {
                                if (7040 <= e && e <= 7041) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e === 7042) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 7074) {
                            if (e === 7073) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 7078) {
                            if (7074 <= e && e <= 7077) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (7078 <= e && e <= 7079) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 7144) {
                        if (e < 7083) {
                            if (e < 7082) {
                                if (7080 <= e && e <= 7081) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e === 7082) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 7142) {
                            if (7083 <= e && e <= 7085) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else {
                            if (e === 7142) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            if (e === 7143) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        }
                    } else if (e < 7150) {
                        if (e < 7146) {
                            if (7144 <= e && e <= 7145) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 7149) {
                            if (7146 <= e && e <= 7148) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e === 7149) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 7151) {
                        if (e === 7150) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 7154) {
                        if (7151 <= e && e <= 7153) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (7154 <= e && e <= 7155) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 43346) {
                    if (e < 11647) {
                        if (e < 7415) {
                            if (e < 7380) {
                                if (e < 7220) {
                                    if (e < 7212) {
                                        if (7204 <= e && e <= 7211) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (7212 <= e && e <= 7219) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e < 7222) {
                                    if (7220 <= e && e <= 7221) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e < 7376) {
                                    if (7222 <= e && e <= 7223) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (7376 <= e && e <= 7378) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 7394) {
                                if (e < 7393) {
                                    if (7380 <= e && e <= 7392) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 7393) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 7405) {
                                if (7394 <= e && e <= 7400) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e === 7405 || e === 7412) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 8205) {
                            if (e < 7616) {
                                if (e < 7416) {
                                    if (e === 7415) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (7416 <= e && e <= 7417) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 8203) {
                                if (7616 <= e && e <= 7679) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else {
                                if (e === 8203) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                                if (e === 8204) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (e < 8288) {
                            if (e < 8206) {
                                if (e === 8205) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.ZWJ;
                            } else if (e < 8232) {
                                if (8206 <= e && e <= 8207) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                            } else if (8232 <= e && e <= 8238) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                        } else if (e < 8400) {
                            if (8288 <= e && e <= 8303) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                        } else if (e < 11503) {
                            if (8400 <= e && e <= 8432) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (11503 <= e && e <= 11505) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 43043) {
                        if (e < 42612) {
                            if (e < 12330) {
                                if (e < 11744) {
                                    if (e === 11647) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (11744 <= e && e <= 11775) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 12441) {
                                if (12330 <= e && e <= 12335) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 42607) {
                                if (12441 <= e && e <= 12442) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (42607 <= e && e <= 42610) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 43010) {
                            if (e < 42654) {
                                if (42612 <= e && e <= 42621) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 42736) {
                                if (42654 <= e && e <= 42655) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (42736 <= e && e <= 42737) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 43014) {
                            if (e === 43010) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e === 43014 || e === 43019) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 43188) {
                        if (e < 43047) {
                            if (e < 43045) {
                                if (43043 <= e && e <= 43044) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (43045 <= e && e <= 43046) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 43052) {
                            if (e === 43047) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 43136) {
                            if (e === 43052) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (43136 <= e && e <= 43137) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 43263) {
                        if (e < 43204) {
                            if (43188 <= e && e <= 43203) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 43232) {
                            if (43204 <= e && e <= 43205) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (43232 <= e && e <= 43249) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 43302) {
                        if (e === 43263) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 43335) {
                        if (43302 <= e && e <= 43309) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (43335 <= e && e <= 43345) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 43698) {
                    if (e < 43493) {
                        if (e < 43444) {
                            if (e < 43392) {
                                if (e < 43360) {
                                    if (43346 <= e && e <= 43347) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                } else if (43360 <= e && e <= 43388) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.L;
                            } else if (e < 43395) {
                                if (43392 <= e && e <= 43394) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else {
                                if (e === 43395) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                                if (e === 43443) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (e < 43450) {
                            if (e < 43446) {
                                if (43444 <= e && e <= 43445) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (43446 <= e && e <= 43449) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 43452) {
                            if (43450 <= e && e <= 43451) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 43454) {
                            if (43452 <= e && e <= 43453) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (43454 <= e && e <= 43456) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 43573) {
                        if (e < 43567) {
                            if (e < 43561) {
                                if (e === 43493) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (43561 <= e && e <= 43566) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 43569) {
                            if (43567 <= e && e <= 43568) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 43571) {
                            if (43569 <= e && e <= 43570) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (43571 <= e && e <= 43572) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 43597) {
                        if (e < 43587) {
                            if (43573 <= e && e <= 43574) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e === 43587 || e === 43596) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 43644) {
                        if (e === 43597) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e === 43644 || e === 43696) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 44006) {
                    if (e < 43756) {
                        if (e < 43710) {
                            if (e < 43703) {
                                if (43698 <= e && e <= 43700) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (43703 <= e && e <= 43704) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 43713) {
                            if (43710 <= e && e <= 43711) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else {
                            if (e === 43713) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            if (e === 43755) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        }
                    } else if (e < 43766) {
                        if (e < 43758) {
                            if (43756 <= e && e <= 43757) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 43765) {
                            if (43758 <= e && e <= 43759) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e === 43765) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 44003) {
                        if (e === 43766) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 44005) {
                        if (44003 <= e && e <= 44004) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e === 44005) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 44032) {
                    if (e < 44009) {
                        if (e < 44008) {
                            if (44006 <= e && e <= 44007) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e === 44008) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 44012) {
                        if (44009 <= e && e <= 44010) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else {
                        if (e === 44012) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        if (e === 44013) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    }
                } else if (e < 44061) {
                    if (e < 44033) {
                        if (e === 44032) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 44060) {
                        if (44033 <= e && e <= 44059) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 44060) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 44088) {
                    if (44061 <= e && e <= 44087) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 44089) {
                    if (e === 44088) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (44089 <= e && e <= 44115) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e < 46497) {
                if (e < 45293) {
                    if (e < 44704) {
                        if (e < 44397) {
                            if (e < 44256) {
                                if (e < 44173) {
                                    if (e < 44144) {
                                        if (e < 44117) {
                                            if (e === 44116) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                        } else if (44117 <= e && e <= 44143) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                    } else if (e < 44145) {
                                        if (e === 44144) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (e < 44172) {
                                        if (44145 <= e && e <= 44171) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                    } else if (e === 44172) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 44201) {
                                    if (e < 44200) {
                                        if (44173 <= e && e <= 44199) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                    } else if (e === 44200) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 44228) {
                                    if (44201 <= e && e <= 44227) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 44229) {
                                    if (e === 44228) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (44229 <= e && e <= 44255) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 44313) {
                                if (e < 44284) {
                                    if (e < 44257) {
                                        if (e === 44256) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (44257 <= e && e <= 44283) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 44285) {
                                    if (e === 44284) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 44312) {
                                    if (44285 <= e && e <= 44311) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 44312) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 44368) {
                                if (e < 44340) {
                                    if (44313 <= e && e <= 44339) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 44341) {
                                    if (e === 44340) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (44341 <= e && e <= 44367) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 44369) {
                                if (e === 44368) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 44396) {
                                if (44369 <= e && e <= 44395) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 44396) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 44537) {
                            if (e < 44480) {
                                if (e < 44425) {
                                    if (e < 44424) {
                                        if (44397 <= e && e <= 44423) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                    } else if (e === 44424) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 44452) {
                                    if (44425 <= e && e <= 44451) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 44453) {
                                    if (e === 44452) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (44453 <= e && e <= 44479) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 44508) {
                                if (e < 44481) {
                                    if (e === 44480) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (44481 <= e && e <= 44507) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 44509) {
                                if (e === 44508) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 44536) {
                                if (44509 <= e && e <= 44535) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 44536) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 44620) {
                            if (e < 44565) {
                                if (e < 44564) {
                                    if (44537 <= e && e <= 44563) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 44564) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 44592) {
                                if (44565 <= e && e <= 44591) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 44593) {
                                if (e === 44592) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (44593 <= e && e <= 44619) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 44649) {
                            if (e < 44621) {
                                if (e === 44620) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 44648) {
                                if (44621 <= e && e <= 44647) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 44648) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 44676) {
                            if (44649 <= e && e <= 44675) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 44677) {
                            if (e === 44676) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (44677 <= e && e <= 44703) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 44985) {
                        if (e < 44844) {
                            if (e < 44761) {
                                if (e < 44732) {
                                    if (e < 44705) {
                                        if (e === 44704) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (44705 <= e && e <= 44731) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 44733) {
                                    if (e === 44732) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 44760) {
                                    if (44733 <= e && e <= 44759) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 44760) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 44789) {
                                if (e < 44788) {
                                    if (44761 <= e && e <= 44787) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 44788) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 44816) {
                                if (44789 <= e && e <= 44815) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 44817) {
                                if (e === 44816) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (44817 <= e && e <= 44843) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 44901) {
                            if (e < 44872) {
                                if (e < 44845) {
                                    if (e === 44844) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (44845 <= e && e <= 44871) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 44873) {
                                if (e === 44872) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 44900) {
                                if (44873 <= e && e <= 44899) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 44900) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 44956) {
                            if (e < 44928) {
                                if (44901 <= e && e <= 44927) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 44929) {
                                if (e === 44928) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (44929 <= e && e <= 44955) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 44957) {
                            if (e === 44956) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 44984) {
                            if (44957 <= e && e <= 44983) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 44984) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 45152) {
                        if (e < 45068) {
                            if (e < 45013) {
                                if (e < 45012) {
                                    if (44985 <= e && e <= 45011) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 45012) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 45040) {
                                if (45013 <= e && e <= 45039) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 45041) {
                                if (e === 45040) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (45041 <= e && e <= 45067) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 45097) {
                            if (e < 45069) {
                                if (e === 45068) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 45096) {
                                if (45069 <= e && e <= 45095) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 45096) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 45124) {
                            if (45097 <= e && e <= 45123) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 45125) {
                            if (e === 45124) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (45125 <= e && e <= 45151) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 45209) {
                        if (e < 45180) {
                            if (e < 45153) {
                                if (e === 45152) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (45153 <= e && e <= 45179) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 45181) {
                            if (e === 45180) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 45208) {
                            if (45181 <= e && e <= 45207) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 45208) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 45264) {
                        if (e < 45236) {
                            if (45209 <= e && e <= 45235) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 45237) {
                            if (e === 45236) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (45237 <= e && e <= 45263) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 45265) {
                        if (e === 45264) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 45292) {
                        if (45265 <= e && e <= 45291) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 45292) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 45908) {
                    if (e < 45600) {
                        if (e < 45433) {
                            if (e < 45376) {
                                if (e < 45321) {
                                    if (e < 45320) {
                                        if (45293 <= e && e <= 45319) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                    } else if (e === 45320) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 45348) {
                                    if (45321 <= e && e <= 45347) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 45349) {
                                    if (e === 45348) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (45349 <= e && e <= 45375) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 45404) {
                                if (e < 45377) {
                                    if (e === 45376) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (45377 <= e && e <= 45403) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 45405) {
                                if (e === 45404) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 45432) {
                                if (45405 <= e && e <= 45431) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 45432) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 45516) {
                            if (e < 45461) {
                                if (e < 45460) {
                                    if (45433 <= e && e <= 45459) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 45460) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 45488) {
                                if (45461 <= e && e <= 45487) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 45489) {
                                if (e === 45488) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (45489 <= e && e <= 45515) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 45545) {
                            if (e < 45517) {
                                if (e === 45516) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 45544) {
                                if (45517 <= e && e <= 45543) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 45544) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 45572) {
                            if (45545 <= e && e <= 45571) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 45573) {
                            if (e === 45572) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (45573 <= e && e <= 45599) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 45741) {
                        if (e < 45657) {
                            if (e < 45628) {
                                if (e < 45601) {
                                    if (e === 45600) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (45601 <= e && e <= 45627) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 45629) {
                                if (e === 45628) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 45656) {
                                if (45629 <= e && e <= 45655) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 45656) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 45712) {
                            if (e < 45684) {
                                if (45657 <= e && e <= 45683) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 45685) {
                                if (e === 45684) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (45685 <= e && e <= 45711) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 45713) {
                            if (e === 45712) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 45740) {
                            if (45713 <= e && e <= 45739) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 45740) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 45824) {
                        if (e < 45769) {
                            if (e < 45768) {
                                if (45741 <= e && e <= 45767) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 45768) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 45796) {
                            if (45769 <= e && e <= 45795) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 45797) {
                            if (e === 45796) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (45797 <= e && e <= 45823) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 45853) {
                        if (e < 45825) {
                            if (e === 45824) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 45852) {
                            if (45825 <= e && e <= 45851) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 45852) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 45880) {
                        if (45853 <= e && e <= 45879) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 45881) {
                        if (e === 45880) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (45881 <= e && e <= 45907) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 46189) {
                    if (e < 46048) {
                        if (e < 45965) {
                            if (e < 45936) {
                                if (e < 45909) {
                                    if (e === 45908) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (45909 <= e && e <= 45935) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 45937) {
                                if (e === 45936) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 45964) {
                                if (45937 <= e && e <= 45963) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 45964) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 45993) {
                            if (e < 45992) {
                                if (45965 <= e && e <= 45991) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 45992) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 46020) {
                            if (45993 <= e && e <= 46019) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 46021) {
                            if (e === 46020) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (46021 <= e && e <= 46047) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 46105) {
                        if (e < 46076) {
                            if (e < 46049) {
                                if (e === 46048) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (46049 <= e && e <= 46075) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 46077) {
                            if (e === 46076) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 46104) {
                            if (46077 <= e && e <= 46103) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 46104) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 46160) {
                        if (e < 46132) {
                            if (46105 <= e && e <= 46131) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 46133) {
                            if (e === 46132) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (46133 <= e && e <= 46159) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 46161) {
                        if (e === 46160) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 46188) {
                        if (46161 <= e && e <= 46187) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 46188) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 46356) {
                    if (e < 46272) {
                        if (e < 46217) {
                            if (e < 46216) {
                                if (46189 <= e && e <= 46215) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 46216) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 46244) {
                            if (46217 <= e && e <= 46243) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 46245) {
                            if (e === 46244) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (46245 <= e && e <= 46271) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 46301) {
                        if (e < 46273) {
                            if (e === 46272) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 46300) {
                            if (46273 <= e && e <= 46299) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 46300) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 46328) {
                        if (46301 <= e && e <= 46327) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 46329) {
                        if (e === 46328) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (46329 <= e && e <= 46355) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 46413) {
                    if (e < 46384) {
                        if (e < 46357) {
                            if (e === 46356) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (46357 <= e && e <= 46383) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 46385) {
                        if (e === 46384) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 46412) {
                        if (46385 <= e && e <= 46411) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 46412) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 46468) {
                    if (e < 46440) {
                        if (46413 <= e && e <= 46439) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 46441) {
                        if (e === 46440) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (46441 <= e && e <= 46467) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 46469) {
                    if (e === 46468) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 46496) {
                    if (46469 <= e && e <= 46495) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e === 46496) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (e < 47701) {
                if (e < 47112) {
                    if (e < 46804) {
                        if (e < 46637) {
                            if (e < 46580) {
                                if (e < 46525) {
                                    if (e < 46524) {
                                        if (46497 <= e && e <= 46523) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                    } else if (e === 46524) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 46552) {
                                    if (46525 <= e && e <= 46551) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 46553) {
                                    if (e === 46552) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (46553 <= e && e <= 46579) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 46608) {
                                if (e < 46581) {
                                    if (e === 46580) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (46581 <= e && e <= 46607) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 46609) {
                                if (e === 46608) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 46636) {
                                if (46609 <= e && e <= 46635) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 46636) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 46720) {
                            if (e < 46665) {
                                if (e < 46664) {
                                    if (46637 <= e && e <= 46663) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 46664) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 46692) {
                                if (46665 <= e && e <= 46691) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 46693) {
                                if (e === 46692) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (46693 <= e && e <= 46719) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 46749) {
                            if (e < 46721) {
                                if (e === 46720) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 46748) {
                                if (46721 <= e && e <= 46747) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 46748) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 46776) {
                            if (46749 <= e && e <= 46775) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 46777) {
                            if (e === 46776) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (46777 <= e && e <= 46803) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 46945) {
                        if (e < 46861) {
                            if (e < 46832) {
                                if (e < 46805) {
                                    if (e === 46804) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (46805 <= e && e <= 46831) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 46833) {
                                if (e === 46832) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 46860) {
                                if (46833 <= e && e <= 46859) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 46860) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 46916) {
                            if (e < 46888) {
                                if (46861 <= e && e <= 46887) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 46889) {
                                if (e === 46888) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (46889 <= e && e <= 46915) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 46917) {
                            if (e === 46916) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 46944) {
                            if (46917 <= e && e <= 46943) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 46944) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 47028) {
                        if (e < 46973) {
                            if (e < 46972) {
                                if (46945 <= e && e <= 46971) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 46972) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47e3) {
                            if (46973 <= e && e <= 46999) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 47001) {
                            if (e === 47e3) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (47001 <= e && e <= 47027) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47057) {
                        if (e < 47029) {
                            if (e === 47028) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47056) {
                            if (47029 <= e && e <= 47055) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 47056) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 47084) {
                        if (47057 <= e && e <= 47083) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47085) {
                        if (e === 47084) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (47085 <= e && e <= 47111) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 47393) {
                    if (e < 47252) {
                        if (e < 47169) {
                            if (e < 47140) {
                                if (e < 47113) {
                                    if (e === 47112) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (47113 <= e && e <= 47139) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 47141) {
                                if (e === 47140) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 47168) {
                                if (47141 <= e && e <= 47167) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 47168) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47197) {
                            if (e < 47196) {
                                if (47169 <= e && e <= 47195) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 47196) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47224) {
                            if (47197 <= e && e <= 47223) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 47225) {
                            if (e === 47224) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (47225 <= e && e <= 47251) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47309) {
                        if (e < 47280) {
                            if (e < 47253) {
                                if (e === 47252) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (47253 <= e && e <= 47279) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 47281) {
                            if (e === 47280) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47308) {
                            if (47281 <= e && e <= 47307) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 47308) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 47364) {
                        if (e < 47336) {
                            if (47309 <= e && e <= 47335) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 47337) {
                            if (e === 47336) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (47337 <= e && e <= 47363) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47365) {
                        if (e === 47364) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 47392) {
                        if (47365 <= e && e <= 47391) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 47392) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 47560) {
                    if (e < 47476) {
                        if (e < 47421) {
                            if (e < 47420) {
                                if (47393 <= e && e <= 47419) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 47420) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47448) {
                            if (47421 <= e && e <= 47447) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 47449) {
                            if (e === 47448) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (47449 <= e && e <= 47475) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47505) {
                        if (e < 47477) {
                            if (e === 47476) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47504) {
                            if (47477 <= e && e <= 47503) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 47504) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 47532) {
                        if (47505 <= e && e <= 47531) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47533) {
                        if (e === 47532) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (47533 <= e && e <= 47559) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 47617) {
                    if (e < 47588) {
                        if (e < 47561) {
                            if (e === 47560) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (47561 <= e && e <= 47587) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47589) {
                        if (e === 47588) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 47616) {
                        if (47589 <= e && e <= 47615) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 47616) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 47672) {
                    if (e < 47644) {
                        if (47617 <= e && e <= 47643) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47645) {
                        if (e === 47644) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (47645 <= e && e <= 47671) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 47673) {
                    if (e === 47672) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 47700) {
                    if (47673 <= e && e <= 47699) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e === 47700) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (e < 48316) {
                if (e < 48008) {
                    if (e < 47841) {
                        if (e < 47784) {
                            if (e < 47729) {
                                if (e < 47728) {
                                    if (47701 <= e && e <= 47727) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 47728) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 47756) {
                                if (47729 <= e && e <= 47755) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 47757) {
                                if (e === 47756) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (47757 <= e && e <= 47783) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 47812) {
                            if (e < 47785) {
                                if (e === 47784) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (47785 <= e && e <= 47811) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 47813) {
                            if (e === 47812) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47840) {
                            if (47813 <= e && e <= 47839) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 47840) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 47924) {
                        if (e < 47869) {
                            if (e < 47868) {
                                if (47841 <= e && e <= 47867) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 47868) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47896) {
                            if (47869 <= e && e <= 47895) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 47897) {
                            if (e === 47896) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (47897 <= e && e <= 47923) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47953) {
                        if (e < 47925) {
                            if (e === 47924) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 47952) {
                            if (47925 <= e && e <= 47951) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 47952) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 47980) {
                        if (47953 <= e && e <= 47979) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 47981) {
                        if (e === 47980) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (47981 <= e && e <= 48007) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 48149) {
                    if (e < 48065) {
                        if (e < 48036) {
                            if (e < 48009) {
                                if (e === 48008) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (48009 <= e && e <= 48035) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 48037) {
                            if (e === 48036) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 48064) {
                            if (48037 <= e && e <= 48063) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 48064) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 48120) {
                        if (e < 48092) {
                            if (48065 <= e && e <= 48091) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 48093) {
                            if (e === 48092) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (48093 <= e && e <= 48119) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 48121) {
                        if (e === 48120) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 48148) {
                        if (48121 <= e && e <= 48147) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 48148) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 48232) {
                    if (e < 48177) {
                        if (e < 48176) {
                            if (48149 <= e && e <= 48175) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 48176) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 48204) {
                        if (48177 <= e && e <= 48203) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 48205) {
                        if (e === 48204) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (48205 <= e && e <= 48231) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 48261) {
                    if (e < 48233) {
                        if (e === 48232) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 48260) {
                        if (48233 <= e && e <= 48259) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 48260) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 48288) {
                    if (48261 <= e && e <= 48287) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 48289) {
                    if (e === 48288) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (48289 <= e && e <= 48315) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e < 48597) {
                if (e < 48456) {
                    if (e < 48373) {
                        if (e < 48344) {
                            if (e < 48317) {
                                if (e === 48316) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (48317 <= e && e <= 48343) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 48345) {
                            if (e === 48344) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 48372) {
                            if (48345 <= e && e <= 48371) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 48372) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 48401) {
                        if (e < 48400) {
                            if (48373 <= e && e <= 48399) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 48400) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 48428) {
                        if (48401 <= e && e <= 48427) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 48429) {
                        if (e === 48428) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (48429 <= e && e <= 48455) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 48513) {
                    if (e < 48484) {
                        if (e < 48457) {
                            if (e === 48456) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (48457 <= e && e <= 48483) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 48485) {
                        if (e === 48484) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 48512) {
                        if (48485 <= e && e <= 48511) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 48512) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 48568) {
                    if (e < 48540) {
                        if (48513 <= e && e <= 48539) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 48541) {
                        if (e === 48540) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (48541 <= e && e <= 48567) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 48569) {
                    if (e === 48568) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 48596) {
                    if (48569 <= e && e <= 48595) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e === 48596) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (e < 48764) {
                if (e < 48680) {
                    if (e < 48625) {
                        if (e < 48624) {
                            if (48597 <= e && e <= 48623) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 48624) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 48652) {
                        if (48625 <= e && e <= 48651) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 48653) {
                        if (e === 48652) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (48653 <= e && e <= 48679) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 48709) {
                    if (e < 48681) {
                        if (e === 48680) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 48708) {
                        if (48681 <= e && e <= 48707) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 48708) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 48736) {
                    if (48709 <= e && e <= 48735) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 48737) {
                    if (e === 48736) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (48737 <= e && e <= 48763) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e < 48821) {
                if (e < 48792) {
                    if (e < 48765) {
                        if (e === 48764) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (48765 <= e && e <= 48791) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 48793) {
                    if (e === 48792) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 48820) {
                    if (48793 <= e && e <= 48819) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e === 48820) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (e < 48876) {
                if (e < 48848) {
                    if (48821 <= e && e <= 48847) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 48849) {
                    if (e === 48848) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (48849 <= e && e <= 48875) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e < 48877) {
                if (e === 48876) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (e < 48904) {
                if (48877 <= e && e <= 48903) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e === 48904) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
        } else if (e < 53720) {
            if (e < 51312) {
                if (e < 50108) {
                    if (e < 49493) {
                        if (e < 49212) {
                            if (e < 49045) {
                                if (e < 48988) {
                                    if (e < 48933) {
                                        if (e < 48932) {
                                            if (48905 <= e && e <= 48931) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                        } else if (e === 48932) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (e < 48960) {
                                        if (48933 <= e && e <= 48959) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                    } else if (e < 48961) {
                                        if (e === 48960) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (48961 <= e && e <= 48987) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 49016) {
                                    if (e < 48989) {
                                        if (e === 48988) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (48989 <= e && e <= 49015) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 49017) {
                                    if (e === 49016) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 49044) {
                                    if (49017 <= e && e <= 49043) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 49044) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 49128) {
                                if (e < 49073) {
                                    if (e < 49072) {
                                        if (49045 <= e && e <= 49071) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                    } else if (e === 49072) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 49100) {
                                    if (49073 <= e && e <= 49099) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 49101) {
                                    if (e === 49100) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (49101 <= e && e <= 49127) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49157) {
                                if (e < 49129) {
                                    if (e === 49128) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 49156) {
                                    if (49129 <= e && e <= 49155) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 49156) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 49184) {
                                if (49157 <= e && e <= 49183) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49185) {
                                if (e === 49184) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (49185 <= e && e <= 49211) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 49352) {
                            if (e < 49269) {
                                if (e < 49240) {
                                    if (e < 49213) {
                                        if (e === 49212) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (49213 <= e && e <= 49239) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 49241) {
                                    if (e === 49240) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 49268) {
                                    if (49241 <= e && e <= 49267) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 49268) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 49297) {
                                if (e < 49296) {
                                    if (49269 <= e && e <= 49295) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 49296) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 49324) {
                                if (49297 <= e && e <= 49323) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49325) {
                                if (e === 49324) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (49325 <= e && e <= 49351) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 49409) {
                            if (e < 49380) {
                                if (e < 49353) {
                                    if (e === 49352) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (49353 <= e && e <= 49379) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49381) {
                                if (e === 49380) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 49408) {
                                if (49381 <= e && e <= 49407) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 49408) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 49464) {
                            if (e < 49436) {
                                if (49409 <= e && e <= 49435) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49437) {
                                if (e === 49436) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (49437 <= e && e <= 49463) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 49465) {
                            if (e === 49464) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 49492) {
                            if (49465 <= e && e <= 49491) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 49492) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 49800) {
                        if (e < 49633) {
                            if (e < 49576) {
                                if (e < 49521) {
                                    if (e < 49520) {
                                        if (49493 <= e && e <= 49519) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                    } else if (e === 49520) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 49548) {
                                    if (49521 <= e && e <= 49547) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 49549) {
                                    if (e === 49548) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (49549 <= e && e <= 49575) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49604) {
                                if (e < 49577) {
                                    if (e === 49576) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (49577 <= e && e <= 49603) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49605) {
                                if (e === 49604) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 49632) {
                                if (49605 <= e && e <= 49631) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 49632) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 49716) {
                            if (e < 49661) {
                                if (e < 49660) {
                                    if (49633 <= e && e <= 49659) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 49660) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 49688) {
                                if (49661 <= e && e <= 49687) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49689) {
                                if (e === 49688) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (49689 <= e && e <= 49715) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 49745) {
                            if (e < 49717) {
                                if (e === 49716) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 49744) {
                                if (49717 <= e && e <= 49743) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 49744) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 49772) {
                            if (49745 <= e && e <= 49771) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 49773) {
                            if (e === 49772) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (49773 <= e && e <= 49799) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 49941) {
                        if (e < 49857) {
                            if (e < 49828) {
                                if (e < 49801) {
                                    if (e === 49800) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (49801 <= e && e <= 49827) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49829) {
                                if (e === 49828) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 49856) {
                                if (49829 <= e && e <= 49855) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 49856) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 49912) {
                            if (e < 49884) {
                                if (49857 <= e && e <= 49883) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 49885) {
                                if (e === 49884) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (49885 <= e && e <= 49911) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 49913) {
                            if (e === 49912) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 49940) {
                            if (49913 <= e && e <= 49939) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 49940) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 50024) {
                        if (e < 49969) {
                            if (e < 49968) {
                                if (49941 <= e && e <= 49967) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 49968) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 49996) {
                            if (49969 <= e && e <= 49995) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 49997) {
                            if (e === 49996) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (49997 <= e && e <= 50023) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 50053) {
                        if (e < 50025) {
                            if (e === 50024) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 50052) {
                            if (50025 <= e && e <= 50051) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 50052) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 50080) {
                        if (50053 <= e && e <= 50079) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 50081) {
                        if (e === 50080) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (50081 <= e && e <= 50107) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 50697) {
                    if (e < 50389) {
                        if (e < 50248) {
                            if (e < 50165) {
                                if (e < 50136) {
                                    if (e < 50109) {
                                        if (e === 50108) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (50109 <= e && e <= 50135) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 50137) {
                                    if (e === 50136) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 50164) {
                                    if (50137 <= e && e <= 50163) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 50164) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 50193) {
                                if (e < 50192) {
                                    if (50165 <= e && e <= 50191) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 50192) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 50220) {
                                if (50193 <= e && e <= 50219) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 50221) {
                                if (e === 50220) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (50221 <= e && e <= 50247) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 50305) {
                            if (e < 50276) {
                                if (e < 50249) {
                                    if (e === 50248) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (50249 <= e && e <= 50275) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 50277) {
                                if (e === 50276) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 50304) {
                                if (50277 <= e && e <= 50303) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 50304) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 50360) {
                            if (e < 50332) {
                                if (50305 <= e && e <= 50331) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 50333) {
                                if (e === 50332) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (50333 <= e && e <= 50359) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 50361) {
                            if (e === 50360) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 50388) {
                            if (50361 <= e && e <= 50387) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 50388) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 50556) {
                        if (e < 50472) {
                            if (e < 50417) {
                                if (e < 50416) {
                                    if (50389 <= e && e <= 50415) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 50416) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 50444) {
                                if (50417 <= e && e <= 50443) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 50445) {
                                if (e === 50444) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (50445 <= e && e <= 50471) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 50501) {
                            if (e < 50473) {
                                if (e === 50472) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 50500) {
                                if (50473 <= e && e <= 50499) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 50500) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 50528) {
                            if (50501 <= e && e <= 50527) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 50529) {
                            if (e === 50528) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (50529 <= e && e <= 50555) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 50613) {
                        if (e < 50584) {
                            if (e < 50557) {
                                if (e === 50556) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (50557 <= e && e <= 50583) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 50585) {
                            if (e === 50584) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 50612) {
                            if (50585 <= e && e <= 50611) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 50612) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 50668) {
                        if (e < 50640) {
                            if (50613 <= e && e <= 50639) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 50641) {
                            if (e === 50640) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (50641 <= e && e <= 50667) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 50669) {
                        if (e === 50668) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 50696) {
                        if (50669 <= e && e <= 50695) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 50696) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 51004) {
                    if (e < 50837) {
                        if (e < 50780) {
                            if (e < 50725) {
                                if (e < 50724) {
                                    if (50697 <= e && e <= 50723) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 50724) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 50752) {
                                if (50725 <= e && e <= 50751) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 50753) {
                                if (e === 50752) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (50753 <= e && e <= 50779) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 50808) {
                            if (e < 50781) {
                                if (e === 50780) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (50781 <= e && e <= 50807) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 50809) {
                            if (e === 50808) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 50836) {
                            if (50809 <= e && e <= 50835) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 50836) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 50920) {
                        if (e < 50865) {
                            if (e < 50864) {
                                if (50837 <= e && e <= 50863) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 50864) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 50892) {
                            if (50865 <= e && e <= 50891) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 50893) {
                            if (e === 50892) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (50893 <= e && e <= 50919) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 50949) {
                        if (e < 50921) {
                            if (e === 50920) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 50948) {
                            if (50921 <= e && e <= 50947) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 50948) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 50976) {
                        if (50949 <= e && e <= 50975) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 50977) {
                        if (e === 50976) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (50977 <= e && e <= 51003) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 51145) {
                    if (e < 51061) {
                        if (e < 51032) {
                            if (e < 51005) {
                                if (e === 51004) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (51005 <= e && e <= 51031) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 51033) {
                            if (e === 51032) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 51060) {
                            if (51033 <= e && e <= 51059) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 51060) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 51116) {
                        if (e < 51088) {
                            if (51061 <= e && e <= 51087) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 51089) {
                            if (e === 51088) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (51089 <= e && e <= 51115) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 51117) {
                        if (e === 51116) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 51144) {
                        if (51117 <= e && e <= 51143) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 51144) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 51228) {
                    if (e < 51173) {
                        if (e < 51172) {
                            if (51145 <= e && e <= 51171) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 51172) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 51200) {
                        if (51173 <= e && e <= 51199) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 51201) {
                        if (e === 51200) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (51201 <= e && e <= 51227) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 51257) {
                    if (e < 51229) {
                        if (e === 51228) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 51256) {
                        if (51229 <= e && e <= 51255) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 51256) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 51284) {
                    if (51257 <= e && e <= 51283) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 51285) {
                    if (e === 51284) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (51285 <= e && e <= 51311) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e < 52516) {
                if (e < 51901) {
                    if (e < 51593) {
                        if (e < 51452) {
                            if (e < 51369) {
                                if (e < 51340) {
                                    if (e < 51313) {
                                        if (e === 51312) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (51313 <= e && e <= 51339) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 51341) {
                                    if (e === 51340) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 51368) {
                                    if (51341 <= e && e <= 51367) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 51368) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 51397) {
                                if (e < 51396) {
                                    if (51369 <= e && e <= 51395) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 51396) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 51424) {
                                if (51397 <= e && e <= 51423) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 51425) {
                                if (e === 51424) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (51425 <= e && e <= 51451) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 51509) {
                            if (e < 51480) {
                                if (e < 51453) {
                                    if (e === 51452) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (51453 <= e && e <= 51479) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 51481) {
                                if (e === 51480) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 51508) {
                                if (51481 <= e && e <= 51507) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 51508) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 51564) {
                            if (e < 51536) {
                                if (51509 <= e && e <= 51535) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 51537) {
                                if (e === 51536) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (51537 <= e && e <= 51563) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 51565) {
                            if (e === 51564) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 51592) {
                            if (51565 <= e && e <= 51591) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 51592) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 51760) {
                        if (e < 51676) {
                            if (e < 51621) {
                                if (e < 51620) {
                                    if (51593 <= e && e <= 51619) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 51620) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 51648) {
                                if (51621 <= e && e <= 51647) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 51649) {
                                if (e === 51648) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (51649 <= e && e <= 51675) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 51705) {
                            if (e < 51677) {
                                if (e === 51676) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 51704) {
                                if (51677 <= e && e <= 51703) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 51704) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 51732) {
                            if (51705 <= e && e <= 51731) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 51733) {
                            if (e === 51732) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (51733 <= e && e <= 51759) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 51817) {
                        if (e < 51788) {
                            if (e < 51761) {
                                if (e === 51760) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (51761 <= e && e <= 51787) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 51789) {
                            if (e === 51788) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 51816) {
                            if (51789 <= e && e <= 51815) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 51816) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 51872) {
                        if (e < 51844) {
                            if (51817 <= e && e <= 51843) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 51845) {
                            if (e === 51844) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (51845 <= e && e <= 51871) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 51873) {
                        if (e === 51872) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 51900) {
                        if (51873 <= e && e <= 51899) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 51900) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 52208) {
                    if (e < 52041) {
                        if (e < 51984) {
                            if (e < 51929) {
                                if (e < 51928) {
                                    if (51901 <= e && e <= 51927) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 51928) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 51956) {
                                if (51929 <= e && e <= 51955) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 51957) {
                                if (e === 51956) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (51957 <= e && e <= 51983) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 52012) {
                            if (e < 51985) {
                                if (e === 51984) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (51985 <= e && e <= 52011) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 52013) {
                            if (e === 52012) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 52040) {
                            if (52013 <= e && e <= 52039) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 52040) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 52124) {
                        if (e < 52069) {
                            if (e < 52068) {
                                if (52041 <= e && e <= 52067) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 52068) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 52096) {
                            if (52069 <= e && e <= 52095) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 52097) {
                            if (e === 52096) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (52097 <= e && e <= 52123) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 52153) {
                        if (e < 52125) {
                            if (e === 52124) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 52152) {
                            if (52125 <= e && e <= 52151) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 52152) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 52180) {
                        if (52153 <= e && e <= 52179) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 52181) {
                        if (e === 52180) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (52181 <= e && e <= 52207) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 52349) {
                    if (e < 52265) {
                        if (e < 52236) {
                            if (e < 52209) {
                                if (e === 52208) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (52209 <= e && e <= 52235) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 52237) {
                            if (e === 52236) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 52264) {
                            if (52237 <= e && e <= 52263) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 52264) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 52320) {
                        if (e < 52292) {
                            if (52265 <= e && e <= 52291) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 52293) {
                            if (e === 52292) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (52293 <= e && e <= 52319) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 52321) {
                        if (e === 52320) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 52348) {
                        if (52321 <= e && e <= 52347) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 52348) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 52432) {
                    if (e < 52377) {
                        if (e < 52376) {
                            if (52349 <= e && e <= 52375) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 52376) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 52404) {
                        if (52377 <= e && e <= 52403) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 52405) {
                        if (e === 52404) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (52405 <= e && e <= 52431) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 52461) {
                    if (e < 52433) {
                        if (e === 52432) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 52460) {
                        if (52433 <= e && e <= 52459) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 52460) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 52488) {
                    if (52461 <= e && e <= 52487) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 52489) {
                    if (e === 52488) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (52489 <= e && e <= 52515) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e < 53105) {
                if (e < 52797) {
                    if (e < 52656) {
                        if (e < 52573) {
                            if (e < 52544) {
                                if (e < 52517) {
                                    if (e === 52516) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (52517 <= e && e <= 52543) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 52545) {
                                if (e === 52544) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 52572) {
                                if (52545 <= e && e <= 52571) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 52572) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 52601) {
                            if (e < 52600) {
                                if (52573 <= e && e <= 52599) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 52600) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 52628) {
                            if (52601 <= e && e <= 52627) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 52629) {
                            if (e === 52628) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (52629 <= e && e <= 52655) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 52713) {
                        if (e < 52684) {
                            if (e < 52657) {
                                if (e === 52656) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (52657 <= e && e <= 52683) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 52685) {
                            if (e === 52684) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 52712) {
                            if (52685 <= e && e <= 52711) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 52712) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 52768) {
                        if (e < 52740) {
                            if (52713 <= e && e <= 52739) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 52741) {
                            if (e === 52740) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (52741 <= e && e <= 52767) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 52769) {
                        if (e === 52768) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 52796) {
                        if (52769 <= e && e <= 52795) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 52796) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 52964) {
                    if (e < 52880) {
                        if (e < 52825) {
                            if (e < 52824) {
                                if (52797 <= e && e <= 52823) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 52824) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 52852) {
                            if (52825 <= e && e <= 52851) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 52853) {
                            if (e === 52852) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (52853 <= e && e <= 52879) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 52909) {
                        if (e < 52881) {
                            if (e === 52880) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 52908) {
                            if (52881 <= e && e <= 52907) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 52908) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 52936) {
                        if (52909 <= e && e <= 52935) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 52937) {
                        if (e === 52936) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (52937 <= e && e <= 52963) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 53021) {
                    if (e < 52992) {
                        if (e < 52965) {
                            if (e === 52964) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (52965 <= e && e <= 52991) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 52993) {
                        if (e === 52992) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 53020) {
                        if (52993 <= e && e <= 53019) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 53020) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 53076) {
                    if (e < 53048) {
                        if (53021 <= e && e <= 53047) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 53049) {
                        if (e === 53048) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (53049 <= e && e <= 53075) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 53077) {
                    if (e === 53076) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 53104) {
                    if (53077 <= e && e <= 53103) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e === 53104) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (e < 53412) {
                if (e < 53245) {
                    if (e < 53188) {
                        if (e < 53133) {
                            if (e < 53132) {
                                if (53105 <= e && e <= 53131) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 53132) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 53160) {
                            if (53133 <= e && e <= 53159) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 53161) {
                            if (e === 53160) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (53161 <= e && e <= 53187) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 53216) {
                        if (e < 53189) {
                            if (e === 53188) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (53189 <= e && e <= 53215) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 53217) {
                        if (e === 53216) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 53244) {
                        if (53217 <= e && e <= 53243) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 53244) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 53328) {
                    if (e < 53273) {
                        if (e < 53272) {
                            if (53245 <= e && e <= 53271) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 53272) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 53300) {
                        if (53273 <= e && e <= 53299) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 53301) {
                        if (e === 53300) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (53301 <= e && e <= 53327) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 53357) {
                    if (e < 53329) {
                        if (e === 53328) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 53356) {
                        if (53329 <= e && e <= 53355) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 53356) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 53384) {
                    if (53357 <= e && e <= 53383) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 53385) {
                    if (e === 53384) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (53385 <= e && e <= 53411) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e < 53553) {
                if (e < 53469) {
                    if (e < 53440) {
                        if (e < 53413) {
                            if (e === 53412) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (53413 <= e && e <= 53439) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 53441) {
                        if (e === 53440) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 53468) {
                        if (53441 <= e && e <= 53467) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 53468) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 53524) {
                    if (e < 53496) {
                        if (53469 <= e && e <= 53495) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 53497) {
                        if (e === 53496) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (53497 <= e && e <= 53523) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 53525) {
                    if (e === 53524) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 53552) {
                    if (53525 <= e && e <= 53551) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e === 53552) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (e < 53636) {
                if (e < 53581) {
                    if (e < 53580) {
                        if (53553 <= e && e <= 53579) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 53580) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 53608) {
                    if (53581 <= e && e <= 53607) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 53609) {
                    if (e === 53608) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (53609 <= e && e <= 53635) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e < 53665) {
                if (e < 53637) {
                    if (e === 53636) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 53664) {
                    if (53637 <= e && e <= 53663) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e === 53664) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (e < 53692) {
                if (53665 <= e && e <= 53691) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
            } else if (e < 53693) {
                if (e === 53692) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (53693 <= e && e <= 53719) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
        } else if (e < 70459) {
            if (e < 54897) {
                if (e < 54308) {
                    if (e < 54001) {
                        if (e < 53860) {
                            if (e < 53777) {
                                if (e < 53748) {
                                    if (e < 53721) {
                                        if (e === 53720) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                    } else if (53721 <= e && e <= 53747) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e < 53749) {
                                    if (e === 53748) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (e < 53776) {
                                    if (53749 <= e && e <= 53775) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 53776) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 53805) {
                                if (e < 53804) {
                                    if (53777 <= e && e <= 53803) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 53804) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 53832) {
                                if (53805 <= e && e <= 53831) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 53833) {
                                if (e === 53832) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (53833 <= e && e <= 53859) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 53917) {
                            if (e < 53888) {
                                if (e < 53861) {
                                    if (e === 53860) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (53861 <= e && e <= 53887) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 53889) {
                                if (e === 53888) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 53916) {
                                if (53889 <= e && e <= 53915) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 53916) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 53972) {
                            if (e < 53944) {
                                if (53917 <= e && e <= 53943) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 53945) {
                                if (e === 53944) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (53945 <= e && e <= 53971) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 53973) {
                            if (e === 53972) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 54e3) {
                            if (53973 <= e && e <= 53999) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 54e3) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 54141) {
                        if (e < 54084) {
                            if (e < 54029) {
                                if (e < 54028) {
                                    if (54001 <= e && e <= 54027) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 54028) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 54056) {
                                if (54029 <= e && e <= 54055) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 54057) {
                                if (e === 54056) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (54057 <= e && e <= 54083) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 54112) {
                            if (e < 54085) {
                                if (e === 54084) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (54085 <= e && e <= 54111) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 54113) {
                            if (e === 54112) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 54140) {
                            if (54113 <= e && e <= 54139) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 54140) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 54224) {
                        if (e < 54169) {
                            if (e < 54168) {
                                if (54141 <= e && e <= 54167) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 54168) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 54196) {
                            if (54169 <= e && e <= 54195) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 54197) {
                            if (e === 54196) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (54197 <= e && e <= 54223) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 54253) {
                        if (e < 54225) {
                            if (e === 54224) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 54252) {
                            if (54225 <= e && e <= 54251) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 54252) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 54280) {
                        if (54253 <= e && e <= 54279) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 54281) {
                        if (e === 54280) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (54281 <= e && e <= 54307) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 54589) {
                    if (e < 54448) {
                        if (e < 54365) {
                            if (e < 54336) {
                                if (e < 54309) {
                                    if (e === 54308) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                                } else if (54309 <= e && e <= 54335) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 54337) {
                                if (e === 54336) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 54364) {
                                if (54337 <= e && e <= 54363) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 54364) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 54393) {
                            if (e < 54392) {
                                if (54365 <= e && e <= 54391) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 54392) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 54420) {
                            if (54393 <= e && e <= 54419) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 54421) {
                            if (e === 54420) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (54421 <= e && e <= 54447) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 54505) {
                        if (e < 54476) {
                            if (e < 54449) {
                                if (e === 54448) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (54449 <= e && e <= 54475) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 54477) {
                            if (e === 54476) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 54504) {
                            if (54477 <= e && e <= 54503) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 54504) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 54560) {
                        if (e < 54532) {
                            if (54505 <= e && e <= 54531) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 54533) {
                            if (e === 54532) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (54533 <= e && e <= 54559) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 54561) {
                        if (e === 54560) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 54588) {
                        if (54561 <= e && e <= 54587) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 54588) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 54756) {
                    if (e < 54672) {
                        if (e < 54617) {
                            if (e < 54616) {
                                if (54589 <= e && e <= 54615) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 54616) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 54644) {
                            if (54617 <= e && e <= 54643) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 54645) {
                            if (e === 54644) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (54645 <= e && e <= 54671) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 54701) {
                        if (e < 54673) {
                            if (e === 54672) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 54700) {
                            if (54673 <= e && e <= 54699) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 54700) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 54728) {
                        if (54701 <= e && e <= 54727) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 54729) {
                        if (e === 54728) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (54729 <= e && e <= 54755) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 54813) {
                    if (e < 54784) {
                        if (e < 54757) {
                            if (e === 54756) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (54757 <= e && e <= 54783) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 54785) {
                        if (e === 54784) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 54812) {
                        if (54785 <= e && e <= 54811) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e === 54812) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 54868) {
                    if (e < 54840) {
                        if (54813 <= e && e <= 54839) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 54841) {
                        if (e === 54840) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (54841 <= e && e <= 54867) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 54869) {
                    if (e === 54868) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                } else if (e < 54896) {
                    if (54869 <= e && e <= 54895) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e === 54896) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
            } else if (e < 69632) {
                if (e < 55216) {
                    if (e < 55037) {
                        if (e < 54980) {
                            if (e < 54925) {
                                if (e < 54924) {
                                    if (54897 <= e && e <= 54923) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                                } else if (e === 54924) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (e < 54952) {
                                if (54925 <= e && e <= 54951) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e < 54953) {
                                if (e === 54952) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (54953 <= e && e <= 54979) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 55008) {
                            if (e < 54981) {
                                if (e === 54980) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                            } else if (54981 <= e && e <= 55007) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 55009) {
                            if (e === 55008) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 55036) {
                            if (55009 <= e && e <= 55035) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 55036) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 55120) {
                        if (e < 55065) {
                            if (e < 55064) {
                                if (55037 <= e && e <= 55063) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                            } else if (e === 55064) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 55092) {
                            if (55065 <= e && e <= 55091) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e < 55093) {
                            if (e === 55092) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (55093 <= e && e <= 55119) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 55149) {
                        if (e < 55121) {
                            if (e === 55120) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                        } else if (e < 55148) {
                            if (55121 <= e && e <= 55147) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                        } else if (e === 55148) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (e < 55176) {
                        if (55149 <= e && e <= 55175) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                    } else if (e < 55177) {
                        if (e === 55176) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LV;
                    } else if (55177 <= e && e <= 55203) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.LVT;
                } else if (e < 68097) {
                    if (e < 65279) {
                        if (e < 64286) {
                            if (e < 55243) {
                                if (55216 <= e && e <= 55238) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.V;
                            } else if (55243 <= e && e <= 55291) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.T;
                        } else if (e < 65024) {
                            if (e === 64286) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 65056) {
                            if (65024 <= e && e <= 65039) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (65056 <= e && e <= 65071) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 66045) {
                        if (e < 65438) {
                            if (e === 65279) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                        } else if (e < 65520) {
                            if (65438 <= e && e <= 65439) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (65520 <= e && e <= 65531) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                    } else if (e < 66272) {
                        if (e === 66045) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 66422) {
                        if (e === 66272) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (66422 <= e && e <= 66426) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 68325) {
                    if (e < 68108) {
                        if (e < 68101) {
                            if (68097 <= e && e <= 68099) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (68101 <= e && e <= 68102) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 68152) {
                        if (68108 <= e && e <= 68111) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 68159) {
                        if (68152 <= e && e <= 68154) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e === 68159) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 69373) {
                    if (e < 68900) {
                        if (68325 <= e && e <= 68326) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 69291) {
                        if (68900 <= e && e <= 68903) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (69291 <= e && e <= 69292) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 69446) {
                    if (69373 <= e && e <= 69375) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 69506) {
                    if (69446 <= e && e <= 69456) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (69506 <= e && e <= 69509) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 70016) {
                if (e < 69815) {
                    if (e < 69747) {
                        if (e < 69634) {
                            if (e === 69632) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            if (e === 69633) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 69688) {
                            if (e === 69634) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 69744) {
                            if (69688 <= e && e <= 69702) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e === 69744) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 69762) {
                        if (e < 69759) {
                            if (69747 <= e && e <= 69748) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (69759 <= e && e <= 69761) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 69808) {
                        if (e === 69762) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 69811) {
                        if (69808 <= e && e <= 69810) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (69811 <= e && e <= 69814) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 69888) {
                    if (e < 69821) {
                        if (e < 69817) {
                            if (69815 <= e && e <= 69816) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (69817 <= e && e <= 69818) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 69826) {
                        if (e === 69821) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                    } else {
                        if (e === 69826) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        if (e === 69837) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                    }
                } else if (e < 69933) {
                    if (e < 69927) {
                        if (69888 <= e && e <= 69890) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 69932) {
                        if (69927 <= e && e <= 69931) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e === 69932) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 69957) {
                    if (69933 <= e && e <= 69940) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 70003) {
                    if (69957 <= e && e <= 69958) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e === 70003) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 70194) {
                if (e < 70082) {
                    if (e < 70067) {
                        if (e < 70018) {
                            if (70016 <= e && e <= 70017) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e === 70018) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 70070) {
                        if (70067 <= e && e <= 70069) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 70079) {
                        if (70070 <= e && e <= 70078) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (70079 <= e && e <= 70080) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 70095) {
                    if (e < 70089) {
                        if (70082 <= e && e <= 70083) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                    } else if (e < 70094) {
                        if (70089 <= e && e <= 70092) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e === 70094) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 70188) {
                    if (e === 70095) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 70191) {
                    if (70188 <= e && e <= 70190) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (70191 <= e && e <= 70193) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 70209) {
                if (e < 70197) {
                    if (e < 70196) {
                        if (70194 <= e && e <= 70195) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e === 70196) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 70198) {
                    if (e === 70197) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 70206) {
                    if (70198 <= e && e <= 70199) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e === 70206) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 70371) {
                if (e < 70367) {
                    if (e === 70209) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 70368) {
                    if (e === 70367) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (70368 <= e && e <= 70370) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
            } else if (e < 70400) {
                if (70371 <= e && e <= 70378) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 70402) {
                if (70400 <= e && e <= 70401) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (70402 <= e && e <= 70403) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
        } else if (e < 72343) {
            if (e < 71339) {
                if (e < 70841) {
                    if (e < 70512) {
                        if (e < 70471) {
                            if (e < 70463) {
                                if (e < 70462) {
                                    if (70459 <= e && e <= 70460) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                                } else if (e === 70462) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (e < 70464) {
                                if (e === 70463) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e < 70465) {
                                if (e === 70464) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (70465 <= e && e <= 70468) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 70487) {
                            if (e < 70475) {
                                if (70471 <= e && e <= 70472) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (70475 <= e && e <= 70477) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 70498) {
                            if (e === 70487) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 70502) {
                            if (70498 <= e && e <= 70499) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (70502 <= e && e <= 70508) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 70725) {
                        if (e < 70712) {
                            if (e < 70709) {
                                if (70512 <= e && e <= 70516) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            } else if (70709 <= e && e <= 70711) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 70720) {
                            if (70712 <= e && e <= 70719) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 70722) {
                            if (70720 <= e && e <= 70721) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (70722 <= e && e <= 70724) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 70832) {
                        if (e < 70726) {
                            if (e === 70725) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e === 70726 || e === 70750) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 70833) {
                        if (e === 70832) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 70835) {
                        if (70833 <= e && e <= 70834) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (70835 <= e && e <= 70840) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 71096) {
                    if (e < 70847) {
                        if (e < 70843) {
                            if (e === 70841) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            if (e === 70842) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 70845) {
                            if (70843 <= e && e <= 70844) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else {
                            if (e === 70845) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            if (e === 70846) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        }
                    } else if (e < 71087) {
                        if (e < 70849) {
                            if (70847 <= e && e <= 70848) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 70850) {
                            if (e === 70849) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (70850 <= e && e <= 70851) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 71088) {
                        if (e === 71087) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 71090) {
                        if (71088 <= e && e <= 71089) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (71090 <= e && e <= 71093) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 71216) {
                    if (e < 71102) {
                        if (e < 71100) {
                            if (71096 <= e && e <= 71099) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (71100 <= e && e <= 71101) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 71103) {
                        if (e === 71102) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 71132) {
                        if (71103 <= e && e <= 71104) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (71132 <= e && e <= 71133) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 71229) {
                    if (e < 71219) {
                        if (71216 <= e && e <= 71218) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 71227) {
                        if (71219 <= e && e <= 71226) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (71227 <= e && e <= 71228) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 71230) {
                    if (e === 71229) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 71231) {
                    if (e === 71230) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (71231 <= e && e <= 71232) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 71999) {
                if (e < 71463) {
                    if (e < 71350) {
                        if (e < 71341) {
                            if (e === 71339) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                            if (e === 71340) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 71342) {
                            if (e === 71341) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 71344) {
                            if (71342 <= e && e <= 71343) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (71344 <= e && e <= 71349) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 71453) {
                        if (e === 71350) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        if (e === 71351) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 71458) {
                        if (71453 <= e && e <= 71455) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 71462) {
                        if (71458 <= e && e <= 71461) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e === 71462) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 71984) {
                    if (e < 71727) {
                        if (e < 71724) {
                            if (71463 <= e && e <= 71467) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (71724 <= e && e <= 71726) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 71736) {
                        if (71727 <= e && e <= 71735) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 71737) {
                        if (e === 71736) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (71737 <= e && e <= 71738) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 71995) {
                    if (e < 71985) {
                        if (e === 71984) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 71991) {
                        if (71985 <= e && e <= 71989) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (71991 <= e && e <= 71992) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 71997) {
                    if (71995 <= e && e <= 71996) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else {
                    if (e === 71997) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    if (e === 71998) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                }
            } else if (e < 72193) {
                if (e < 72145) {
                    if (e < 72001) {
                        if (e === 71999) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                        if (e === 72e3) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 72002) {
                        if (e === 72001) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                    } else {
                        if (e === 72002) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        if (e === 72003) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    }
                } else if (e < 72156) {
                    if (e < 72148) {
                        if (72145 <= e && e <= 72147) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 72154) {
                        if (72148 <= e && e <= 72151) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (72154 <= e && e <= 72155) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 72160) {
                    if (72156 <= e && e <= 72159) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else {
                    if (e === 72160) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    if (e === 72164) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                }
            } else if (e < 72263) {
                if (e < 72249) {
                    if (e < 72243) {
                        if (72193 <= e && e <= 72202) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (72243 <= e && e <= 72248) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 72250) {
                    if (e === 72249) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 72251) {
                    if (e === 72250) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                } else if (72251 <= e && e <= 72254) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 72281) {
                if (e < 72273) {
                    if (e === 72263) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 72279) {
                    if (72273 <= e && e <= 72278) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (72279 <= e && e <= 72280) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
            } else if (e < 72324) {
                if (72281 <= e && e <= 72283) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 72330) {
                if (72324 <= e && e <= 72329) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
            } else if (72330 <= e && e <= 72342) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
        } else if (e < 94033) {
            if (e < 73104) {
                if (e < 72881) {
                    if (e < 72766) {
                        if (e < 72751) {
                            if (e < 72344) {
                                if (e === 72343) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                            } else if (72344 <= e && e <= 72345) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (e < 72752) {
                            if (e === 72751) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e < 72760) {
                            if (72752 <= e && e <= 72758) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (72760 <= e && e <= 72765) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 72850) {
                        if (e === 72766) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        if (e === 72767) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 72873) {
                        if (72850 <= e && e <= 72871) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 72874) {
                        if (e === 72873) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (72874 <= e && e <= 72880) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 73018) {
                    if (e < 72884) {
                        if (e < 72882) {
                            if (e === 72881) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (72882 <= e && e <= 72883) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 72885) {
                        if (e === 72884) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 73009) {
                        if (72885 <= e && e <= 72886) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (73009 <= e && e <= 73014) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 73030) {
                    if (e < 73020) {
                        if (e === 73018) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 73023) {
                        if (73020 <= e && e <= 73021) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (73023 <= e && e <= 73029) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 73031) {
                    if (e === 73030) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                } else if (e < 73098) {
                    if (e === 73031) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (73098 <= e && e <= 73102) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
            } else if (e < 73526) {
                if (e < 73459) {
                    if (e < 73109) {
                        if (e < 73107) {
                            if (73104 <= e && e <= 73105) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                        } else if (73107 <= e && e <= 73108) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e < 73110) {
                        if (e === 73109) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else {
                        if (e === 73110) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        if (e === 73111) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    }
                } else if (e < 73474) {
                    if (e < 73461) {
                        if (73459 <= e && e <= 73460) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 73472) {
                        if (73461 <= e && e <= 73462) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (73472 <= e && e <= 73473) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 73475) {
                    if (e === 73474) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.PREPEND;
                } else if (e < 73524) {
                    if (e === 73475) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (73524 <= e && e <= 73525) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
            } else if (e < 78896) {
                if (e < 73536) {
                    if (e < 73534) {
                        if (73526 <= e && e <= 73530) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (73534 <= e && e <= 73535) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 73537) {
                    if (e === 73536) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else {
                    if (e === 73537) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    if (e === 73538) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                }
            } else if (e < 92912) {
                if (e < 78912) {
                    if (78896 <= e && e <= 78911) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                } else if (e < 78919) {
                    if (e === 78912) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (78919 <= e && e <= 78933) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 92976) {
                if (92912 <= e && e <= 92916) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 94031) {
                if (92976 <= e && e <= 92982) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e === 94031) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
        } else if (e < 121476) {
            if (e < 119143) {
                if (e < 113824) {
                    if (e < 94180) {
                        if (e < 94095) {
                            if (94033 <= e && e <= 94087) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                        } else if (94095 <= e && e <= 94098) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 94192) {
                        if (e === 94180) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e < 113821) {
                        if (94192 <= e && e <= 94193) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                    } else if (113821 <= e && e <= 113822) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 118576) {
                    if (e < 118528) {
                        if (113824 <= e && e <= 113827) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                    } else if (118528 <= e && e <= 118573) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 119141) {
                    if (118576 <= e && e <= 118598) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else {
                    if (e === 119141) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    if (e === 119142) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                }
            } else if (e < 119173) {
                if (e < 119150) {
                    if (e < 119149) {
                        if (119143 <= e && e <= 119145) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (e === 119149) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.SPACINGMARK;
                } else if (e < 119155) {
                    if (119150 <= e && e <= 119154) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 119163) {
                    if (119155 <= e && e <= 119162) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
                } else if (119163 <= e && e <= 119170) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 121344) {
                if (e < 119210) {
                    if (119173 <= e && e <= 119179) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 119362) {
                    if (119210 <= e && e <= 119213) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (119362 <= e && e <= 119364) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 121403) {
                if (121344 <= e && e <= 121398) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 121461) {
                if (121403 <= e && e <= 121452) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e === 121461) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
        } else if (e < 123628) {
            if (e < 122907) {
                if (e < 121505) {
                    if (e < 121499) {
                        if (e === 121476) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                    } else if (121499 <= e && e <= 121503) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 122880) {
                    if (121505 <= e && e <= 121519) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 122888) {
                    if (122880 <= e && e <= 122886) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (122888 <= e && e <= 122904) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 123023) {
                if (e < 122915) {
                    if (122907 <= e && e <= 122913) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (e < 122918) {
                    if (122915 <= e && e <= 122916) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (122918 <= e && e <= 122922) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 123184) {
                if (e === 123023) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 123566) {
                if (123184 <= e && e <= 123190) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e === 123566) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
        } else if (e < 127995) {
            if (e < 125136) {
                if (e < 124140) {
                    if (123628 <= e && e <= 123631) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
                } else if (124140 <= e && e <= 124143) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 125252) {
                if (125136 <= e && e <= 125142) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 127462) {
                if (125252 <= e && e <= 125258) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (127462 <= e && e <= 127487) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.REGIONAL_INDICATOR;
        } else if (e < 917632) {
            if (e < 917504) {
                if (127995 <= e && e <= 127999) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
            } else if (e < 917536) {
                if (917504 <= e && e <= 917535) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
            } else if (917536 <= e && e <= 917631) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
        } else if (e < 917760) {
            if (917632 <= e && e <= 917759) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
        } else if (e < 918e3) {
            if (917760 <= e && e <= 917999) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.EXTEND;
        } else if (918e3 <= e && e <= 921599) return $aec35899a3c9695e$var$n.CLUSTER_BREAK.CONTROL;
        return $aec35899a3c9695e$var$n.CLUSTER_BREAK.OTHER;
    }
    /**
   * Given a Unicode code point, returns if symbol is an extended pictographic or some other break
   * @param code {number} Unicode code point
   * @returns {number}
   */ static getEmojiProperty(e) {
        if (e < 10160) {
            if (e < 9728) {
                if (e < 9e3) {
                    if (e < 8482) {
                        if (e < 8252) {
                            if (e === 169 || e === 174) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                        } else if (e === 8252 || e === 8265) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e < 8596) {
                        if (e === 8482 || e === 8505) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e < 8617) {
                        if (8596 <= e && e <= 8601) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e < 8986) {
                        if (8617 <= e && e <= 8618) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (8986 <= e && e <= 8987) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 9410) {
                    if (e < 9167) {
                        if (e === 9e3 || e === 9096) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e < 9193) {
                        if (e === 9167) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e < 9208) {
                        if (9193 <= e && e <= 9203) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (9208 <= e && e <= 9210) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 9654) {
                    if (e < 9642) {
                        if (e === 9410) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (9642 <= e && e <= 9643) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 9664) {
                    if (e === 9654) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 9723) {
                    if (e === 9664) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (9723 <= e && e <= 9726) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 10035) {
                if (e < 10004) {
                    if (e < 9748) {
                        if (e < 9735) {
                            if (9728 <= e && e <= 9733) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                        } else if (9735 <= e && e <= 9746) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e < 9872) {
                        if (9748 <= e && e <= 9861) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e < 9992) {
                        if (9872 <= e && e <= 9989) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (9992 <= e && e <= 10002) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 10013) {
                    if (e === 10004 || e === 10006) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 10017) {
                    if (e === 10013) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e === 10017 || e === 10024) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 10067) {
                if (e < 10055) {
                    if (e < 10052) {
                        if (10035 <= e && e <= 10036) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e === 10052) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 10060) {
                    if (e === 10055) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e === 10060 || e === 10062) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 10083) {
                if (e < 10071) {
                    if (10067 <= e && e <= 10069) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e === 10071) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 10133) {
                if (10083 <= e && e <= 10087) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 10145) {
                if (10133 <= e && e <= 10135) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e === 10145) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
        } else if (e < 127489) {
            if (e < 12951) {
                if (e < 11035) {
                    if (e < 10548) {
                        if (e === 10160 || e === 10175) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e < 11013) {
                        if (10548 <= e && e <= 10549) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (11013 <= e && e <= 11015) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 11093) {
                    if (e < 11088) {
                        if (11035 <= e && e <= 11036) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e === 11088) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 12336) {
                    if (e === 11093) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e === 12336 || e === 12349) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 127340) {
                if (e < 126976) {
                    if (e === 12951 || e === 12953) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 127245) {
                    if (126976 <= e && e <= 127231) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 127279) {
                    if (127245 <= e && e <= 127247) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e === 127279) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 127374) {
                if (e < 127358) {
                    if (127340 <= e && e <= 127345) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (127358 <= e && e <= 127359) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 127377) {
                if (e === 127374) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 127405) {
                if (127377 <= e && e <= 127386) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (127405 <= e && e <= 127461) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
        } else if (e < 128981) {
            if (e < 127561) {
                if (e < 127535) {
                    if (e < 127514) {
                        if (127489 <= e && e <= 127503) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                    } else if (e === 127514) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 127538) {
                    if (e === 127535) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (e < 127548) {
                    if (127538 <= e && e <= 127546) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (127548 <= e && e <= 127551) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 128326) {
                if (e < 128e3) {
                    if (127561 <= e && e <= 127994) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (128e3 <= e && e <= 128317) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 128640) {
                if (128326 <= e && e <= 128591) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 128884) {
                if (128640 <= e && e <= 128767) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (128884 <= e && e <= 128895) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
        } else if (e < 129198) {
            if (e < 129096) {
                if (e < 129036) {
                    if (128981 <= e && e <= 129023) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
                } else if (129036 <= e && e <= 129039) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 129114) {
                if (129096 <= e && e <= 129103) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (e < 129160) {
                if (129114 <= e && e <= 129119) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (129160 <= e && e <= 129167) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
        } else if (e < 129340) {
            if (e < 129292) {
                if (129198 <= e && e <= 129279) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
            } else if (129292 <= e && e <= 129338) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
        } else if (e < 129351) {
            if (129340 <= e && e <= 129349) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
        } else if (e < 130048) {
            if (129351 <= e && e <= 129791) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
        } else if (130048 <= e && e <= 131069) return $aec35899a3c9695e$var$n.EXTENDED_PICTOGRAPHIC;
        return $aec35899a3c9695e$var$n.CLUSTER_BREAK.OTHER;
    }
}
$aec35899a3c9695e$var$Fc.default = $aec35899a3c9695e$var$Pi;
var $aec35899a3c9695e$var$IE = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importDefault || function(t) {
    return t && t.__esModule ? t : {
        default: t
    };
};
Object.defineProperty($aec35899a3c9695e$var$jc, "__esModule", {
    value: !0
});
const $aec35899a3c9695e$var$UE = $aec35899a3c9695e$var$IE($aec35899a3c9695e$var$Fc);
$aec35899a3c9695e$var$jc.default = $aec35899a3c9695e$var$UE.default;
var $aec35899a3c9695e$var$OE = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(t, e, r, i) {
    i === void 0 && (i = r);
    var a = Object.getOwnPropertyDescriptor(e, r);
    (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    }), Object.defineProperty(t, i, a);
} : function(t, e, r, i) {
    i === void 0 && (i = r), t[i] = e[r];
}), $aec35899a3c9695e$var$KE = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
}), $aec35899a3c9695e$var$ME = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importStar || function(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (t != null) for(var r in t)r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && $aec35899a3c9695e$var$OE(e, t, r);
    return $aec35899a3c9695e$var$KE(e, t), e;
}, $aec35899a3c9695e$var$NE = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importDefault || function(t) {
    return t && t.__esModule ? t : {
        default: t
    };
};
Object.defineProperty($aec35899a3c9695e$var$yr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$yr.validateLanguage = $aec35899a3c9695e$var$yr.parseLanguage = $aec35899a3c9695e$var$yr.b64UrlToUtf8 = $aec35899a3c9695e$var$yr.utf8ToB64Url = $aec35899a3c9695e$var$yr.graphemeLen = $aec35899a3c9695e$var$yr.utf8Len = void 0;
const $aec35899a3c9695e$var$VE = $aec35899a3c9695e$var$NE($aec35899a3c9695e$var$jc), $aec35899a3c9695e$var$Eu = $aec35899a3c9695e$var$ME($aec35899a3c9695e$var$Rp), $aec35899a3c9695e$var$jE = (t)=>new TextEncoder().encode(t).byteLength;
$aec35899a3c9695e$var$yr.utf8Len = $aec35899a3c9695e$var$jE;
const $aec35899a3c9695e$var$FE = (t)=>new $aec35899a3c9695e$var$VE.default().countGraphemes(t);
$aec35899a3c9695e$var$yr.graphemeLen = $aec35899a3c9695e$var$FE;
const $aec35899a3c9695e$var$$E = (t)=>$aec35899a3c9695e$var$Eu.toString($aec35899a3c9695e$var$Eu.fromString(t, "utf8"), "base64url");
$aec35899a3c9695e$var$yr.utf8ToB64Url = $aec35899a3c9695e$var$$E;
const $aec35899a3c9695e$var$GE = (t)=>$aec35899a3c9695e$var$Eu.toString($aec35899a3c9695e$var$Eu.fromString(t, "base64url"), "utf8");
$aec35899a3c9695e$var$yr.b64UrlToUtf8 = $aec35899a3c9695e$var$GE;
const $aec35899a3c9695e$var$qE = (t)=>{
    const e = t.match($aec35899a3c9695e$var$Sp);
    if (!e?.groups) return null;
    const r = e.groups;
    return {
        grandfathered: r.grandfathered,
        language: r.language,
        extlang: r.extlang,
        script: r.script,
        region: r.region,
        variant: r.variant,
        extension: r.extension,
        privateUse: r.privateUseA || r.privateUseB
    };
};
$aec35899a3c9695e$var$yr.parseLanguage = $aec35899a3c9695e$var$qE;
const $aec35899a3c9695e$var$zE = (t)=>$aec35899a3c9695e$var$Sp.test(t);
$aec35899a3c9695e$var$yr.validateLanguage = $aec35899a3c9695e$var$zE;
const $aec35899a3c9695e$var$Sp = /^((?<grandfathered>(en-GB-oed|i-ami|i-bnn|i-default|i-enochian|i-hak|i-klingon|i-lux|i-mingo|i-navajo|i-pwn|i-tao|i-tay|i-tsu|sgn-BE-FR|sgn-BE-NL|sgn-CH-DE)|(art-lojban|cel-gaulish|no-bok|no-nyn|zh-guoyu|zh-hakka|zh-min|zh-min-nan|zh-xiang))|((?<language>([A-Za-z]{2,3}(-(?<extlang>[A-Za-z]{3}(-[A-Za-z]{3}){0,2}))?)|[A-Za-z]{4}|[A-Za-z]{5,8})(-(?<script>[A-Za-z]{4}))?(-(?<region>[A-Za-z]{2}|[0-9]{3}))?(-(?<variant>[A-Za-z0-9]{5,8}|[0-9][A-Za-z0-9]{3}))*(-(?<extension>[0-9A-WY-Za-wy-z](-[A-Za-z0-9]{2,8})+))*(-(?<privateUseA>x(-[A-Za-z0-9]{1,8})+))?)|(?<privateUseB>x(-[A-Za-z0-9]{1,8})+))$/;
var $aec35899a3c9695e$var$Cp = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.didDocument = t.getServiceEndpoint = t.getNotifEndpoint = t.getFeedGenEndpoint = t.getPdsEndpoint = t.getSigningDidKey = t.getVerificationMaterial = t.getSigningKey = t.getHandle = t.getDid = t.isValidDidDoc = void 0;
    const e = $aec35899a3c9695e$var$os, r = (X)=>t.didDocument.safeParse(X).success;
    t.isValidDidDoc = r;
    const i = (X)=>{
        const V = X.id;
        if (typeof V != "string") throw new Error("No `id` on document");
        return V;
    };
    t.getDid = i;
    const a = (X)=>{
        const V = X.alsoKnownAs;
        if (V) for(let q = 0; q < V.length; q++){
            const re = V[q];
            if (re.startsWith("at://")) return re.slice(5);
        }
    };
    t.getHandle = a;
    const c = (X)=>(0, t.getVerificationMaterial)(X, "atproto");
    t.getSigningKey = c;
    const h = (X, V)=>{
        const q = P(X, "verificationMethod", `#${V}`);
        if (q && q.publicKeyMultibase) return {
            type: q.type,
            publicKeyMultibase: q.publicKeyMultibase
        };
    };
    t.getVerificationMaterial = h;
    const m = (X)=>{
        const V = (0, t.getSigningKey)(X);
        if (V) return `did:key:${V.publicKeyMultibase}`;
    };
    t.getSigningDidKey = m;
    const p = (X)=>(0, t.getServiceEndpoint)(X, {
            id: "#atproto_pds",
            type: "AtprotoPersonalDataServer"
        });
    t.getPdsEndpoint = p;
    const y = (X)=>(0, t.getServiceEndpoint)(X, {
            id: "#bsky_fg",
            type: "BskyFeedGenerator"
        });
    t.getFeedGenEndpoint = y;
    const d = (X)=>(0, t.getServiceEndpoint)(X, {
            id: "#bsky_notif",
            type: "BskyNotificationService"
        });
    t.getNotifEndpoint = d;
    const v = (X, V)=>{
        const q = P(X, "service", V.id);
        if (q && !(V.type && q.type !== V.type) && typeof q.serviceEndpoint == "string") return K(q.serviceEndpoint);
    };
    t.getServiceEndpoint = v;
    function P(X, V, q) {
        const re = X[V];
        if (re) for(let ne = 0; ne < re.length; ne++){
            const fe = re[ne], ye = fe.id;
            if (ye[0] === "#" ? ye === q : // Optimized version of: itemId === `${doc.id}${id}`
            ye.length === X.id.length + q.length && ye[X.id.length] === "#" && ye.endsWith(q) && ye.startsWith(X.id)) return fe;
        }
    }
    const K = (X)=>{
        if (!(!X.startsWith("http://") && !X.startsWith("https://")) && O(X)) return X;
    }, O = URL.canParse ?? // URL.canParse is not available in Node.js < 18.17.0
    ((X)=>{
        try {
            return new URL(X), !0;
        } catch  {
            return !1;
        }
    }), Z = e.z.object({
        id: e.z.string(),
        type: e.z.string(),
        controller: e.z.string(),
        publicKeyMultibase: e.z.string().optional()
    }), Y = e.z.object({
        id: e.z.string(),
        type: e.z.string(),
        serviceEndpoint: e.z.union([
            e.z.string(),
            e.z.record(e.z.unknown())
        ])
    });
    t.didDocument = e.z.object({
        id: e.z.string(),
        alsoKnownAs: e.z.array(e.z.string()).optional(),
        verificationMethod: e.z.array(Z).optional(),
        service: e.z.array(Y).optional()
    });
})($aec35899a3c9695e$var$Cp);
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(c, h, m, p) {
        p === void 0 && (p = m);
        var y = Object.getOwnPropertyDescriptor(h, m);
        (!y || ("get" in y ? !h.__esModule : y.writable || y.configurable)) && (y = {
            enumerable: !0,
            get: function() {
                return h[m];
            }
        }), Object.defineProperty(c, p, y);
    } : function(c, h, m, p) {
        p === void 0 && (p = m), c[p] = h[m];
    }), r = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__setModuleDefault || (Object.create ? function(c, h) {
        Object.defineProperty(c, "default", {
            enumerable: !0,
            value: h
        });
    } : function(c, h) {
        c.default = h;
    }), i = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importStar || function(c) {
        if (c && c.__esModule) return c;
        var h = {};
        if (c != null) for(var m in c)m !== "default" && Object.prototype.hasOwnProperty.call(c, m) && e(h, c, m);
        return r(h, c), h;
    }, a = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__exportStar || function(c, h) {
        for(var m in c)m !== "default" && !Object.prototype.hasOwnProperty.call(h, m) && e(h, c, m);
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.util = t.check = void 0, t.check = i($aec35899a3c9695e$var$ri), t.util = i($aec35899a3c9695e$var$As), a($aec35899a3c9695e$var$_s, t), a($aec35899a3c9695e$var$mp, t), a($aec35899a3c9695e$var$As, t), a($aec35899a3c9695e$var$Ca, t), a($aec35899a3c9695e$var$yp, t), a($aec35899a3c9695e$var$ws, t), a($aec35899a3c9695e$var$_p, t), a($aec35899a3c9695e$var$wp, t), a($aec35899a3c9695e$var$yr, t), a($aec35899a3c9695e$var$Cp, t);
})($aec35899a3c9695e$var$vi);
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.BlobRef = t.jsonBlobRef = t.untypedJsonBlobRef = t.typedJsonBlobRef = void 0;
    const e = $aec35899a3c9695e$var$vi, r = $aec35899a3c9695e$var$$s, i = $aec35899a3c9695e$var$os;
    t.typedJsonBlobRef = i.z.object({
        $type: i.z.literal("blob"),
        ref: e.schema.cid,
        mimeType: i.z.string(),
        size: i.z.number()
    }).strict(), t.untypedJsonBlobRef = i.z.object({
        cid: i.z.string(),
        mimeType: i.z.string()
    }).strict(), t.jsonBlobRef = i.z.union([
        t.typedJsonBlobRef,
        t.untypedJsonBlobRef
    ]);
    class a {
        constructor(h, m, p, y){
            Object.defineProperty(this, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: h
            }), Object.defineProperty(this, "mimeType", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: m
            }), Object.defineProperty(this, "size", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: p
            }), Object.defineProperty(this, "original", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), this.original = y ?? {
                $type: "blob",
                ref: h,
                mimeType: m,
                size: p
            };
        }
        static asBlobRef(h) {
            return e.check.is(h, t.jsonBlobRef) ? a.fromJsonRef(h) : null;
        }
        static fromJsonRef(h) {
            return e.check.is(h, t.typedJsonBlobRef) ? new a(h.ref, h.mimeType, h.size) : new a(r.CID.parse(h.cid), h.mimeType, -1, h);
        }
        ipld() {
            return {
                $type: "blob",
                ref: this.ref,
                mimeType: this.mimeType,
                size: this.size
            };
        }
        toJSON() {
            return (0, e.ipldToJson)(this.ipld());
        }
    }
    t.BlobRef = a;
})($aec35899a3c9695e$var$Iu);
Object.defineProperty($aec35899a3c9695e$var$Mc, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Mc.blob = $aec35899a3c9695e$var$ZE;
const $aec35899a3c9695e$var$XE = $aec35899a3c9695e$var$Iu, $aec35899a3c9695e$var$HE = $aec35899a3c9695e$var$Rn;
function $aec35899a3c9695e$var$ZE(t, e, r, i) {
    return !i || !(i instanceof $aec35899a3c9695e$var$XE.BlobRef) ? {
        success: !1,
        error: new $aec35899a3c9695e$var$HE.ValidationError(`${e} should be a blob ref`)
    } : {
        success: !0,
        value: i
    };
}
var $aec35899a3c9695e$var$Ri = {}, $aec35899a3c9695e$var$Lr = {}, $aec35899a3c9695e$var$Lp = {};
(function(t) {
    (()=>{
        var e = {
            d: (d, v)=>{
                for(var P in v)e.o(v, P) && !e.o(d, P) && Object.defineProperty(d, P, {
                    enumerable: !0,
                    get: v[P]
                });
            },
            o: (d, v)=>Object.prototype.hasOwnProperty.call(d, v),
            r: (d)=>{
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(d, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(d, "__esModule", {
                    value: !0
                });
            }
        }, r = {};
        function i(d, v) {
            return v === void 0 && (v = "-"), new RegExp("^(?!0{4}" + v + "0{2}" + v + "0{2})((?=[0-9]{4}" + v + "(((0[^2])|1[0-2])|02(?=" + v + "(([0-1][0-9])|2[0-8])))" + v + "[0-9]{2})|(?=((([13579][26])|([2468][048])|(0[48]))0{2})|([0-9]{2}((((0|[2468])[48])|[2468][048])|([13579][26])))" + v + "02" + v + "29))([0-9]{4})" + v + "(?!((0[469])|11)" + v + "31)((0[1,3-9]|1[0-2])|(02(?!" + v + "3)))" + v + "(0[1-9]|[1-2][0-9]|3[0-1])$").test(d);
        }
        function a(d) {
            var v = /\D/.exec(d);
            return v ? v[0] : "";
        }
        function c(d, v, P) {
            v === void 0 && (v = ":"), P === void 0 && (P = !1);
            var K = new RegExp("^([0-1]|2(?=([0-3])|4" + v + "00))[0-9]" + v + "[0-5][0-9](" + v + "([0-5]|6(?=0))[0-9])?(.[0-9]{1,9})?$");
            if (!P || !/[Z+\-]/.test(d)) return K.test(d);
            if (/Z$/.test(d)) return K.test(d.replace("Z", ""));
            var O = d.includes("+"), Z = d.split(/[+-]/), Y = Z[0], X = Z[1];
            return K.test(Y) && function(V, q, re) {
                return re === void 0 && (re = ":"), new RegExp(q ? "^(0(?!(2" + re + "4)|0" + re + "3)|1(?=([0-1]|2(?=" + re + "[04])|[34](?=" + re + "0))))([03469](?=" + re + "[03])|[17](?=" + re + "0)|2(?=" + re + "[04])|5(?=" + re + "[034])|8(?=" + re + "[04]))" + re + "([03](?=0)|4(?=5))[05]$" : "^(0(?=[^0])|1(?=[0-2]))([39](?=" + re + "[03])|[0-24-8](?=" + re + "00))" + re + "[03]0$").test(V);
            }(X, O, a(X));
        }
        function h(d) {
            var v = d.split("T"), P = v[0], K = v[1], O = i(P, a(P));
            if (!K) return !1;
            var Z, Y = (Z = K.match(/([^Z+\-\d])(?=\d+\1)/), Array.isArray(Z) ? Z[0] : "");
            return O && c(K, Y, !0);
        }
        function m(d, v) {
            return v === void 0 && (v = "-"), new RegExp("^[0-9]{4}" + v + "(0(?=[^0])|1(?=[0-2]))[0-9]$").test(d);
        }
        e.r(r), e.d(r, {
            isValidDate: ()=>i,
            isValidISODateString: ()=>h,
            isValidTime: ()=>c,
            isValidYearMonth: ()=>m
        });
        var p = t;
        for(var y in r)p[y] = r[y];
        r.__esModule && Object.defineProperty(p, "__esModule", {
            value: !0
        });
    })();
})($aec35899a3c9695e$var$Lp);
Object.defineProperty($aec35899a3c9695e$var$Lr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Lr.datetime = $aec35899a3c9695e$var$QE;
$aec35899a3c9695e$var$Lr.uri = $aec35899a3c9695e$var$ev;
$aec35899a3c9695e$var$Lr.atUri = $aec35899a3c9695e$var$tv;
$aec35899a3c9695e$var$Lr.did = $aec35899a3c9695e$var$kp;
$aec35899a3c9695e$var$Lr.handle = $aec35899a3c9695e$var$Dp;
$aec35899a3c9695e$var$Lr.atIdentifier = $aec35899a3c9695e$var$rv;
$aec35899a3c9695e$var$Lr.nsid = $aec35899a3c9695e$var$iv;
$aec35899a3c9695e$var$Lr.cid = $aec35899a3c9695e$var$nv;
$aec35899a3c9695e$var$Lr.language = $aec35899a3c9695e$var$sv;
$aec35899a3c9695e$var$Lr.tid = $aec35899a3c9695e$var$av;
$aec35899a3c9695e$var$Lr.recordKey = $aec35899a3c9695e$var$ov;
const $aec35899a3c9695e$var$WE = $aec35899a3c9695e$var$Lp, $aec35899a3c9695e$var$YE = $aec35899a3c9695e$var$$s, $aec35899a3c9695e$var$Xr = $aec35899a3c9695e$var$Rn, $aec35899a3c9695e$var$Gs = $aec35899a3c9695e$var$as, $aec35899a3c9695e$var$JE = $aec35899a3c9695e$var$vi;
function $aec35899a3c9695e$var$QE(t, e) {
    try {
        if (!(0, $aec35899a3c9695e$var$WE.isValidISODateString)(e)) throw new Error();
    } catch  {
        return {
            success: !1,
            error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be an valid atproto datetime (both RFC-3339 and ISO-8601)`)
        };
    }
    return {
        success: !0,
        value: e
    };
}
function $aec35899a3c9695e$var$ev(t, e) {
    return e.match(/^\w+:(?:\/\/)?[^\s/][^\s]*$/) !== null ? {
        success: !0,
        value: e
    } : {
        success: !1,
        error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a uri`)
    };
}
function $aec35899a3c9695e$var$tv(t, e) {
    try {
        (0, $aec35899a3c9695e$var$Gs.ensureValidAtUri)(e);
    } catch  {
        return {
            success: !1,
            error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a valid at-uri`)
        };
    }
    return {
        success: !0,
        value: e
    };
}
function $aec35899a3c9695e$var$kp(t, e) {
    try {
        (0, $aec35899a3c9695e$var$Gs.ensureValidDid)(e);
    } catch  {
        return {
            success: !1,
            error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a valid did`)
        };
    }
    return {
        success: !0,
        value: e
    };
}
function $aec35899a3c9695e$var$Dp(t, e) {
    try {
        (0, $aec35899a3c9695e$var$Gs.ensureValidHandle)(e);
    } catch  {
        return {
            success: !1,
            error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a valid handle`)
        };
    }
    return {
        success: !0,
        value: e
    };
}
function $aec35899a3c9695e$var$rv(t, e) {
    if (e.startsWith("did:")) {
        const r = $aec35899a3c9695e$var$kp(t, e);
        if (r.success) return r;
    } else {
        const r = $aec35899a3c9695e$var$Dp(t, e);
        if (r.success) return r;
    }
    return {
        success: !1,
        error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a valid did or a handle`)
    };
}
function $aec35899a3c9695e$var$iv(t, e) {
    try {
        (0, $aec35899a3c9695e$var$Gs.ensureValidNsid)(e);
    } catch  {
        return {
            success: !1,
            error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a valid nsid`)
        };
    }
    return {
        success: !0,
        value: e
    };
}
function $aec35899a3c9695e$var$nv(t, e) {
    try {
        $aec35899a3c9695e$var$YE.CID.parse(e);
    } catch  {
        return {
            success: !1,
            error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a cid string`)
        };
    }
    return {
        success: !0,
        value: e
    };
}
function $aec35899a3c9695e$var$sv(t, e) {
    return (0, $aec35899a3c9695e$var$JE.validateLanguage)(e) ? {
        success: !0,
        value: e
    } : {
        success: !1,
        error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a well-formed BCP 47 language tag`)
    };
}
function $aec35899a3c9695e$var$av(t, e) {
    try {
        (0, $aec35899a3c9695e$var$Gs.ensureValidTid)(e);
    } catch  {
        return {
            success: !1,
            error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a valid TID (timestamp identifier)`)
        };
    }
    return {
        success: !0,
        value: e
    };
}
function $aec35899a3c9695e$var$ov(t, e) {
    try {
        (0, $aec35899a3c9695e$var$Gs.ensureValidRecordKey)(e);
    } catch  {
        return {
            success: !1,
            error: new $aec35899a3c9695e$var$Xr.ValidationError(`${t} must be a valid Record Key`)
        };
    }
    return {
        success: !0,
        value: e
    };
}
var $aec35899a3c9695e$var$lv = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(t, e, r, i) {
    i === void 0 && (i = r);
    var a = Object.getOwnPropertyDescriptor(e, r);
    (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    }), Object.defineProperty(t, i, a);
} : function(t, e, r, i) {
    i === void 0 && (i = r), t[i] = e[r];
}), $aec35899a3c9695e$var$uv = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
}), $aec35899a3c9695e$var$cv = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importStar || function(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (t != null) for(var r in t)r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && $aec35899a3c9695e$var$lv(e, t, r);
    return $aec35899a3c9695e$var$uv(e, t), e;
};
Object.defineProperty($aec35899a3c9695e$var$Ri, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ri.validate = $aec35899a3c9695e$var$fv;
$aec35899a3c9695e$var$Ri.boolean = $aec35899a3c9695e$var$Pp;
$aec35899a3c9695e$var$Ri.integer = $aec35899a3c9695e$var$Bp;
$aec35899a3c9695e$var$Ri.string = $aec35899a3c9695e$var$Ip;
$aec35899a3c9695e$var$Ri.bytes = $aec35899a3c9695e$var$Up;
$aec35899a3c9695e$var$Ri.cidLink = $aec35899a3c9695e$var$Op;
$aec35899a3c9695e$var$Ri.unknown = $aec35899a3c9695e$var$Kp;
const $aec35899a3c9695e$var$Md = $aec35899a3c9695e$var$vi, $aec35899a3c9695e$var$dv = $aec35899a3c9695e$var$$s, $aec35899a3c9695e$var$Or = $aec35899a3c9695e$var$cv($aec35899a3c9695e$var$Lr), $aec35899a3c9695e$var$ut = $aec35899a3c9695e$var$Rn;
function $aec35899a3c9695e$var$fv(t, e, r, i) {
    switch(r.type){
        case "boolean":
            return $aec35899a3c9695e$var$Pp(t, e, r, i);
        case "integer":
            return $aec35899a3c9695e$var$Bp(t, e, r, i);
        case "string":
            return $aec35899a3c9695e$var$Ip(t, e, r, i);
        case "bytes":
            return $aec35899a3c9695e$var$Up(t, e, r, i);
        case "cid-link":
            return $aec35899a3c9695e$var$Op(t, e, r, i);
        case "unknown":
            return $aec35899a3c9695e$var$Kp(t, e, r, i);
        default:
            return {
                success: !1,
                error: new $aec35899a3c9695e$var$ut.ValidationError(`Unexpected lexicon type: ${r.type}`)
            };
    }
}
function $aec35899a3c9695e$var$Pp(t, e, r, i) {
    r;
    const a = typeof i;
    return a === "undefined" ? typeof r.default == "boolean" ? {
        success: !0,
        value: r.default
    } : {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be a boolean`)
    } : a !== "boolean" ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be a boolean`)
    } : typeof r.const == "boolean" && i !== r.const ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be ${r.const}`)
    } : {
        success: !0,
        value: i
    };
}
function $aec35899a3c9695e$var$Bp(t, e, r, i) {
    return r, typeof i === "undefined" ? typeof r.default == "number" ? {
        success: !0,
        value: r.default
    } : {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be an integer`)
    } : Number.isInteger(i) ? typeof r.const == "number" && i !== r.const ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be ${r.const}`)
    } : Array.isArray(r.enum) && !r.enum.includes(i) ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be one of (${r.enum.join("|")})`)
    } : typeof r.maximum == "number" && i > r.maximum ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} can not be greater than ${r.maximum}`)
    } : typeof r.minimum == "number" && i < r.minimum ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} can not be less than ${r.minimum}`)
    } : {
        success: !0,
        value: i
    } : {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be an integer`)
    };
}
function $aec35899a3c9695e$var$Ip(t, e, r, i) {
    if (r, typeof i > "u") return typeof r.default == "string" ? {
        success: !0,
        value: r.default
    } : {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be a string`)
    };
    if (typeof i != "string") return {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be a string`)
    };
    if (typeof r.const == "string" && i !== r.const) return {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be ${r.const}`)
    };
    if (Array.isArray(r.enum) && !r.enum.includes(i)) return {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be one of (${r.enum.join("|")})`)
    };
    if (typeof r.minLength == "number" || typeof r.maxLength == "number") {
        if (typeof r.minLength == "number" && i.length * 3 < r.minLength) return {
            success: !1,
            error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must not be shorter than ${r.minLength} characters`)
        };
        let a = !1;
        if (typeof r.minLength > "u" && typeof r.maxLength == "number" && i.length * 3 <= r.maxLength && (a = !0), !a) {
            const c = (0, $aec35899a3c9695e$var$Md.utf8Len)(i);
            if (typeof r.maxLength == "number" && c > r.maxLength) return {
                success: !1,
                error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must not be longer than ${r.maxLength} characters`)
            };
            if (typeof r.minLength == "number" && c < r.minLength) return {
                success: !1,
                error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must not be shorter than ${r.minLength} characters`)
            };
        }
    }
    if (typeof r.maxGraphemes == "number" || typeof r.minGraphemes == "number") {
        let a = !1, c = !1;
        if (typeof r.maxGraphemes == "number" && (i.length <= r.maxGraphemes ? a = !1 : a = !0), typeof r.minGraphemes == "number") {
            if (i.length < r.minGraphemes) return {
                success: !1,
                error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must not be shorter than ${r.minGraphemes} graphemes`)
            };
            c = !0;
        }
        if (a || c) {
            const h = (0, $aec35899a3c9695e$var$Md.graphemeLen)(i);
            if (typeof r.maxGraphemes == "number" && h > r.maxGraphemes) return {
                success: !1,
                error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must not be longer than ${r.maxGraphemes} graphemes`)
            };
            if (typeof r.minGraphemes == "number" && h < r.minGraphemes) return {
                success: !1,
                error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must not be shorter than ${r.minGraphemes} graphemes`)
            };
        }
    }
    if (typeof r.format == "string") switch(r.format){
        case "datetime":
            return $aec35899a3c9695e$var$Or.datetime(e, i);
        case "uri":
            return $aec35899a3c9695e$var$Or.uri(e, i);
        case "at-uri":
            return $aec35899a3c9695e$var$Or.atUri(e, i);
        case "did":
            return $aec35899a3c9695e$var$Or.did(e, i);
        case "handle":
            return $aec35899a3c9695e$var$Or.handle(e, i);
        case "at-identifier":
            return $aec35899a3c9695e$var$Or.atIdentifier(e, i);
        case "nsid":
            return $aec35899a3c9695e$var$Or.nsid(e, i);
        case "cid":
            return $aec35899a3c9695e$var$Or.cid(e, i);
        case "language":
            return $aec35899a3c9695e$var$Or.language(e, i);
        case "tid":
            return $aec35899a3c9695e$var$Or.tid(e, i);
        case "record-key":
            return $aec35899a3c9695e$var$Or.recordKey(e, i);
    }
    return {
        success: !0,
        value: i
    };
}
function $aec35899a3c9695e$var$Up(t, e, r, i) {
    return r, !i || !(i instanceof Uint8Array) ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be a byte array`)
    } : typeof r.maxLength == "number" && i.byteLength > r.maxLength ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must not be larger than ${r.maxLength} bytes`)
    } : typeof r.minLength == "number" && i.byteLength < r.minLength ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must not be smaller than ${r.minLength} bytes`)
    } : {
        success: !0,
        value: i
    };
}
function $aec35899a3c9695e$var$Op(t, e, r, i) {
    return $aec35899a3c9695e$var$dv.CID.asCID(i) === null ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be a CID`)
    } : {
        success: !0,
        value: i
    };
}
function $aec35899a3c9695e$var$Kp(t, e, r, i) {
    return !i || typeof i != "object" ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ut.ValidationError(`${e} must be an object`)
    } : {
        success: !0,
        value: i
    };
}
Object.defineProperty($aec35899a3c9695e$var$An, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$An.validate = $aec35899a3c9695e$var$Mp;
$aec35899a3c9695e$var$An.array = $aec35899a3c9695e$var$Np;
$aec35899a3c9695e$var$An.object = $aec35899a3c9695e$var$zc;
$aec35899a3c9695e$var$An.validateOneOf = $aec35899a3c9695e$var$Xc;
const $aec35899a3c9695e$var$ii = $aec35899a3c9695e$var$Rn, $aec35899a3c9695e$var$Lc = $aec35899a3c9695e$var$ls, $aec35899a3c9695e$var$pv = $aec35899a3c9695e$var$Mc, $aec35899a3c9695e$var$hs = $aec35899a3c9695e$var$Ri;
function $aec35899a3c9695e$var$Mp(t, e, r, i) {
    switch(r.type){
        case "boolean":
            return (0, $aec35899a3c9695e$var$hs.boolean)(t, e, r, i);
        case "integer":
            return (0, $aec35899a3c9695e$var$hs.integer)(t, e, r, i);
        case "string":
            return (0, $aec35899a3c9695e$var$hs.string)(t, e, r, i);
        case "bytes":
            return (0, $aec35899a3c9695e$var$hs.bytes)(t, e, r, i);
        case "cid-link":
            return (0, $aec35899a3c9695e$var$hs.cidLink)(t, e, r, i);
        case "unknown":
            return (0, $aec35899a3c9695e$var$hs.unknown)(t, e, r, i);
        case "object":
            return $aec35899a3c9695e$var$zc(t, e, r, i);
        case "array":
            return $aec35899a3c9695e$var$Np(t, e, r, i);
        case "blob":
            return (0, $aec35899a3c9695e$var$pv.blob)(t, e, r, i);
        default:
            return {
                success: !1,
                error: new $aec35899a3c9695e$var$ii.ValidationError(`Unexpected lexicon type: ${r.type}`)
            };
    }
}
function $aec35899a3c9695e$var$Np(t, e, r, i) {
    if (!Array.isArray(i)) return {
        success: !1,
        error: new $aec35899a3c9695e$var$ii.ValidationError(`${e} must be an array`)
    };
    if (typeof r.maxLength == "number" && i.length > r.maxLength) return {
        success: !1,
        error: new $aec35899a3c9695e$var$ii.ValidationError(`${e} must not have more than ${r.maxLength} elements`)
    };
    if (typeof r.minLength == "number" && i.length < r.minLength) return {
        success: !1,
        error: new $aec35899a3c9695e$var$ii.ValidationError(`${e} must not have fewer than ${r.minLength} elements`)
    };
    const a = r.items;
    for(let c = 0; c < i.length; c++){
        const h = i[c], m = `${e}/${c}`, p = $aec35899a3c9695e$var$Xc(t, m, a, h);
        if (!p.success) return p;
    }
    return {
        success: !0,
        value: i
    };
}
function $aec35899a3c9695e$var$zc(t, e, r, i) {
    if (r, !i || typeof i != "object") return {
        success: !1,
        error: new $aec35899a3c9695e$var$ii.ValidationError(`${e} must be an object`)
    };
    const a = new Set(r.required), c = new Set(r.nullable);
    let h = i;
    if (typeof r.properties == "object") for(const m in r.properties){
        if (i[m] === null && c.has(m)) continue;
        const p = r.properties[m];
        if (typeof i[m] > "u" && !a.has(m)) {
            if (p.type === "integer" || p.type === "boolean" || p.type === "string") {
                if (typeof p.default > "u") continue;
            } else continue;
        }
        const y = `${e}/${m}`, d = $aec35899a3c9695e$var$Xc(t, y, p, i[m]), v = d.success ? d.value : i[m], P = typeof v > "u";
        if (P && a.has(m)) return {
            success: !1,
            error: new $aec35899a3c9695e$var$ii.ValidationError(`${e} must have the property "${m}"`)
        };
        if (!P && !d.success) return d;
        v !== i[m] && (h === i && (h = {
            ...i
        }), h[m] = v);
    }
    return {
        success: !0,
        value: h
    };
}
function $aec35899a3c9695e$var$Xc(t, e, r, i, a = !1) {
    let c, h;
    if (r.type === "union") {
        if (!(0, $aec35899a3c9695e$var$ii.isDiscriminatedObject)(i)) return {
            success: !1,
            error: new $aec35899a3c9695e$var$ii.ValidationError(`${e} must be an object which includes the "$type" property`)
        };
        if ($aec35899a3c9695e$var$hv(r.refs, i.$type)) h = (0, $aec35899a3c9695e$var$Lc.toConcreteTypes)(t, {
            type: "ref",
            ref: i.$type
        });
        else return r.closed ? {
            success: !1,
            error: new $aec35899a3c9695e$var$ii.ValidationError(`${e} $type must be one of ${r.refs.join(", ")}`)
        } : {
            success: !0,
            value: i
        };
    } else h = (0, $aec35899a3c9695e$var$Lc.toConcreteTypes)(t, r);
    for (const m of h){
        const p = a ? $aec35899a3c9695e$var$zc(t, e, m, i) : $aec35899a3c9695e$var$Mp(t, e, m, i);
        if (p.success) return p;
        c ?? (c = p.error);
    }
    return h.length > 1 ? {
        success: !1,
        error: new $aec35899a3c9695e$var$ii.ValidationError(`${e} did not match any of the expected definitions`)
    } : {
        success: !1,
        error: c
    };
}
const $aec35899a3c9695e$var$hv = (t, e)=>{
    const r = (0, $aec35899a3c9695e$var$Lc.toLexUri)(e);
    return t.includes(r) ? !0 : r.endsWith("#main") ? t.includes(r.replace("#main", "")) : t.includes(r + "#main");
};
var $aec35899a3c9695e$var$Hc = {}, $aec35899a3c9695e$var$mv = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(t, e, r, i) {
    i === void 0 && (i = r);
    var a = Object.getOwnPropertyDescriptor(e, r);
    (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    }), Object.defineProperty(t, i, a);
} : function(t, e, r, i) {
    i === void 0 && (i = r), t[i] = e[r];
}), $aec35899a3c9695e$var$yv = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
}), $aec35899a3c9695e$var$bv = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importStar || function(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (t != null) for(var r in t)r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && $aec35899a3c9695e$var$mv(e, t, r);
    return $aec35899a3c9695e$var$yv(e, t), e;
};
Object.defineProperty($aec35899a3c9695e$var$Hc, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Hc.params = $aec35899a3c9695e$var$vv;
const $aec35899a3c9695e$var$gv = $aec35899a3c9695e$var$Rn, $aec35899a3c9695e$var$xv = $aec35899a3c9695e$var$bv($aec35899a3c9695e$var$Ri), $aec35899a3c9695e$var$Ev = $aec35899a3c9695e$var$An;
function $aec35899a3c9695e$var$vv(t, e, r, i) {
    const a = i && typeof i == "object" ? i : {}, c = new Set(r.required ?? []);
    let h = a;
    if (typeof r.properties == "object") for(const m in r.properties){
        const p = r.properties[m], y = p.type === "array" ? (0, $aec35899a3c9695e$var$Ev.array)(t, m, p, a[m]) : $aec35899a3c9695e$var$xv.validate(t, m, p, a[m]), d = y.success ? y.value : a[m], v = typeof d > "u";
        if (v && c.has(m)) return {
            success: !1,
            error: new $aec35899a3c9695e$var$gv.ValidationError(`${e} must have the property "${m}"`)
        };
        if (!v && !y.success) return y;
        d !== a[m] && (h === a && (h = {
            ...a
        }), h[m] = d);
    }
    return {
        success: !0,
        value: h
    };
}
Object.defineProperty($aec35899a3c9695e$var$us, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$us.assertValidRecord = $aec35899a3c9695e$var$Av;
$aec35899a3c9695e$var$us.assertValidXrpcParams = $aec35899a3c9695e$var$_v;
$aec35899a3c9695e$var$us.assertValidXrpcInput = $aec35899a3c9695e$var$wv;
$aec35899a3c9695e$var$us.assertValidXrpcOutput = $aec35899a3c9695e$var$Tv;
$aec35899a3c9695e$var$us.assertValidXrpcMessage = $aec35899a3c9695e$var$Sv;
const $aec35899a3c9695e$var$Vp = $aec35899a3c9695e$var$An, $aec35899a3c9695e$var$Rv = $aec35899a3c9695e$var$Hc;
function $aec35899a3c9695e$var$Av(t, e, r) {
    const i = (0, $aec35899a3c9695e$var$Vp.object)(t, "Record", e.record, r);
    if (!i.success) throw i.error;
    return i.value;
}
function $aec35899a3c9695e$var$_v(t, e, r) {
    if (e.parameters) {
        const i = (0, $aec35899a3c9695e$var$Rv.params)(t, "Params", e.parameters, r);
        if (!i.success) throw i.error;
        return i.value;
    }
}
function $aec35899a3c9695e$var$wv(t, e, r) {
    if (e.input?.schema) return $aec35899a3c9695e$var$Zc(t, "Input", e.input.schema, r, !0);
}
function $aec35899a3c9695e$var$Tv(t, e, r) {
    if (e.output?.schema) return $aec35899a3c9695e$var$Zc(t, "Output", e.output.schema, r, !0);
}
function $aec35899a3c9695e$var$Sv(t, e, r) {
    if (e.message?.schema) return $aec35899a3c9695e$var$Zc(t, "Message", e.message.schema, r, !0);
}
function $aec35899a3c9695e$var$Zc(t, e, r, i, a = !1) {
    const c = (0, $aec35899a3c9695e$var$Vp.validateOneOf)(t, e, r, i, a);
    if (!c.success) throw c.error;
    return c.value;
}
var $aec35899a3c9695e$var$Cv = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(t, e, r, i) {
    i === void 0 && (i = r);
    var a = Object.getOwnPropertyDescriptor(e, r);
    (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    }), Object.defineProperty(t, i, a);
} : function(t, e, r, i) {
    i === void 0 && (i = r), t[i] = e[r];
}), $aec35899a3c9695e$var$Lv = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
}), $aec35899a3c9695e$var$kv = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importStar || function(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (t != null) for(var r in t)r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && $aec35899a3c9695e$var$Cv(e, t, r);
    return $aec35899a3c9695e$var$Lv(e, t), e;
};
Object.defineProperty($aec35899a3c9695e$var$Bu, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Bu.Lexicons = void 0;
const $aec35899a3c9695e$var$Jr = $aec35899a3c9695e$var$Rn, $aec35899a3c9695e$var$ea = $aec35899a3c9695e$var$us, $aec35899a3c9695e$var$Yt = $aec35899a3c9695e$var$ls, $aec35899a3c9695e$var$Nd = $aec35899a3c9695e$var$kv($aec35899a3c9695e$var$An);
class $aec35899a3c9695e$var$Dv {
    constructor(e){
        if (Object.defineProperty(this, "docs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: /* @__PURE__ */ new Map()
        }), Object.defineProperty(this, "defs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: /* @__PURE__ */ new Map()
        }), e) for (const r of e)this.add(r);
    }
    /**
   * @example clone a lexicon:
   * ```ts
   * const clone = new Lexicons(originalLexicon)
   * ```
   *
   * @example get docs array:
   * ```ts
   * const docs = Array.from(lexicons)
   * ```
   */ [Symbol.iterator]() {
        return this.docs.values();
    }
    /**
   * Add a lexicon doc.
   */ add(e) {
        const r = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e.id);
        if (this.docs.has(r)) throw new Error(`${r} has already been registered`);
        $aec35899a3c9695e$var$kc(e, r), this.docs.set(r, e);
        for (const [i, a] of $aec35899a3c9695e$var$Vd(e))this.defs.set(i, a);
    }
    /**
   * Remove a lexicon doc.
   */ remove(e) {
        e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e);
        const r = this.docs.get(e);
        if (!r) throw new Error(`Unable to remove "${e}": does not exist`);
        for (const [i, a] of $aec35899a3c9695e$var$Vd(r))this.defs.delete(i);
        this.docs.delete(e);
    }
    /**
   * Get a lexicon doc.
   */ get(e) {
        return e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e), this.docs.get(e);
    }
    /**
   * Get a definition.
   */ getDef(e) {
        return e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e), this.defs.get(e);
    }
    getDefOrThrow(e, r) {
        const i = this.getDef(e);
        if (!i) throw new $aec35899a3c9695e$var$Jr.LexiconDefNotFoundError(`Lexicon not found: ${e}`);
        if (r && !r.includes(i.type)) throw new $aec35899a3c9695e$var$Jr.InvalidLexiconError(`Not a ${r.join(" or ")} lexicon: ${e}`);
        return i;
    }
    /**
   * Validate a record or object.
   */ validate(e, r) {
        e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e);
        const i = this.getDefOrThrow(e, [
            "record",
            "object"
        ]);
        if (!(0, $aec35899a3c9695e$var$Jr.isObj)(r)) throw new $aec35899a3c9695e$var$Jr.ValidationError("Value must be an object");
        if (i.type === "record") return $aec35899a3c9695e$var$Nd.object(this, "Record", i.record, r);
        if (i.type === "object") return $aec35899a3c9695e$var$Nd.object(this, "Object", i, r);
        throw new $aec35899a3c9695e$var$Jr.InvalidLexiconError("Definition must be a record or object");
    }
    /**
   * Validate a record and throw on any error.
   */ assertValidRecord(e, r) {
        e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e);
        const i = this.getDefOrThrow(e, [
            "record"
        ]);
        if (!(0, $aec35899a3c9695e$var$Jr.isObj)(r)) throw new $aec35899a3c9695e$var$Jr.ValidationError("Record must be an object");
        if (!(0, $aec35899a3c9695e$var$Jr.hasProp)(r, "$type") || typeof r.$type != "string") throw new $aec35899a3c9695e$var$Jr.ValidationError("Record/$type must be a string");
        const a = r.$type || "";
        if ((0, $aec35899a3c9695e$var$Yt.toLexUri)(a) !== e) throw new $aec35899a3c9695e$var$Jr.ValidationError(`Invalid $type: must be ${e}, got ${a}`);
        return (0, $aec35899a3c9695e$var$ea.assertValidRecord)(this, i, r);
    }
    /**
   * Validate xrpc query params and throw on any error.
   */ assertValidXrpcParams(e, r) {
        e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e);
        const i = this.getDefOrThrow(e, [
            "query",
            "procedure",
            "subscription"
        ]);
        return (0, $aec35899a3c9695e$var$ea.assertValidXrpcParams)(this, i, r);
    }
    /**
   * Validate xrpc input body and throw on any error.
   */ assertValidXrpcInput(e, r) {
        e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e);
        const i = this.getDefOrThrow(e, [
            "procedure"
        ]);
        return (0, $aec35899a3c9695e$var$ea.assertValidXrpcInput)(this, i, r);
    }
    /**
   * Validate xrpc output body and throw on any error.
   */ assertValidXrpcOutput(e, r) {
        e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e);
        const i = this.getDefOrThrow(e, [
            "query",
            "procedure"
        ]);
        return (0, $aec35899a3c9695e$var$ea.assertValidXrpcOutput)(this, i, r);
    }
    /**
   * Validate xrpc subscription message and throw on any error.
   */ assertValidXrpcMessage(e, r) {
        e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e);
        const i = this.getDefOrThrow(e, [
            "subscription"
        ]);
        return (0, $aec35899a3c9695e$var$ea.assertValidXrpcMessage)(this, i, r);
    }
    /**
   * Resolve a lex uri given a ref
   */ resolveLexUri(e, r) {
        return e = (0, $aec35899a3c9695e$var$Yt.toLexUri)(e), (0, $aec35899a3c9695e$var$Yt.toLexUri)(r, e);
    }
}
$aec35899a3c9695e$var$Bu.Lexicons = $aec35899a3c9695e$var$Dv;
function* $aec35899a3c9695e$var$Vd(t) {
    for(const e in t.defs)yield [
        `lex:${t.id}#${e}`,
        t.defs[e]
    ], e === "main" && (yield [
        `lex:${t.id}`,
        t.defs[e]
    ]);
}
function $aec35899a3c9695e$var$kc(t, e) {
    for(const r in t)t.type === "ref" ? t.ref = (0, $aec35899a3c9695e$var$Yt.toLexUri)(t.ref, e) : t.type === "union" ? t.refs = t.refs.map((i)=>(0, $aec35899a3c9695e$var$Yt.toLexUri)(i, e)) : Array.isArray(t[r]) ? t[r] = t[r].map((i)=>typeof i == "string" ? i.startsWith("#") ? (0, $aec35899a3c9695e$var$Yt.toLexUri)(i, e) : i : i && typeof i == "object" ? $aec35899a3c9695e$var$kc(i, e) : i) : t[r] && typeof t[r] == "object" && (t[r] = $aec35899a3c9695e$var$kc(t[r], e));
    return t;
}
var $aec35899a3c9695e$var$jp = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.jsonStringToLex = t.jsonToLex = t.stringifyLex = t.lexToJson = t.ipldToLex = t.lexToIpld = void 0;
    const e = $aec35899a3c9695e$var$vi, r = $aec35899a3c9695e$var$$s, i = $aec35899a3c9695e$var$Iu, a = (d)=>{
        if (Array.isArray(d)) return d.map((v)=>(0, t.lexToIpld)(v));
        if (d && typeof d == "object") {
            if (d instanceof i.BlobRef) return d.original;
            if (r.CID.asCID(d) || d instanceof Uint8Array) return d;
            const v = {};
            for (const P of Object.keys(d))v[P] = (0, t.lexToIpld)(d[P]);
            return v;
        }
        return d;
    };
    t.lexToIpld = a;
    const c = (d)=>{
        if (Array.isArray(d)) return d.map((v)=>(0, t.ipldToLex)(v));
        if (d && typeof d == "object") {
            if ((d.$type === "blob" || typeof d.cid == "string" && typeof d.mimeType == "string") && e.check.is(d, i.jsonBlobRef)) return i.BlobRef.fromJsonRef(d);
            if (r.CID.asCID(d) || d instanceof Uint8Array) return d;
            const v = {};
            for (const P of Object.keys(d))v[P] = (0, t.ipldToLex)(d[P]);
            return v;
        }
        return d;
    };
    t.ipldToLex = c;
    const h = (d)=>(0, e.ipldToJson)((0, t.lexToIpld)(d));
    t.lexToJson = h;
    const m = (d)=>JSON.stringify((0, t.lexToJson)(d));
    t.stringifyLex = m;
    const p = (d)=>(0, t.ipldToLex)((0, e.jsonToIpld)(d));
    t.jsonToLex = p;
    const y = (d)=>(0, t.jsonToLex)(JSON.parse(d));
    t.jsonStringToLex = y;
})($aec35899a3c9695e$var$jp);
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(i, a, c, h) {
        h === void 0 && (h = c);
        var m = Object.getOwnPropertyDescriptor(a, c);
        (!m || ("get" in m ? !a.__esModule : m.writable || m.configurable)) && (m = {
            enumerable: !0,
            get: function() {
                return a[c];
            }
        }), Object.defineProperty(i, h, m);
    } : function(i, a, c, h) {
        h === void 0 && (h = c), i[h] = a[c];
    }), r = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__exportStar || function(i, a) {
        for(var c in i)c !== "default" && !Object.prototype.hasOwnProperty.call(a, c) && e(a, i, c);
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), r($aec35899a3c9695e$var$Rn, t), r($aec35899a3c9695e$var$Bu, t), r($aec35899a3c9695e$var$Iu, t), r($aec35899a3c9695e$var$jp, t);
})($aec35899a3c9695e$var$wa);
var $aec35899a3c9695e$var$Fp = {};
Object.defineProperty($aec35899a3c9695e$var$Fp, "__esModule", {
    value: !0
});
var $aec35899a3c9695e$var$ka = {};
Object.defineProperty($aec35899a3c9695e$var$ka, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ka.BSKY_LABELER_DID = void 0;
$aec35899a3c9695e$var$ka.BSKY_LABELER_DID = "did:plc:ar7c4by46qjdydhdevvrndac";
var $aec35899a3c9695e$var$Nr = {};
Object.defineProperty($aec35899a3c9695e$var$Nr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Nr.validateSavedFeed = $aec35899a3c9695e$var$Nr.getSavedFeedType = $aec35899a3c9695e$var$Nr.savedFeedsToUriArrays = $aec35899a3c9695e$var$Nr.sanitizeMutedWordValue = void 0;
const $aec35899a3c9695e$var$$p = $aec35899a3c9695e$var$as, $aec35899a3c9695e$var$Pv = $aec35899a3c9695e$var$vi;
function $aec35899a3c9695e$var$Bv(t) {
    return t.trim().replace(/^#(?!\ufe0f)/, "").replace(/[\r\n\u00AD\u2060\u200D\u200C\u200B]+/, "");
}
$aec35899a3c9695e$var$Nr.sanitizeMutedWordValue = $aec35899a3c9695e$var$Bv;
function $aec35899a3c9695e$var$Iv(t) {
    const e = [], r = [];
    for (const i of t)i.pinned && e.push(i.value), r.push(i.value);
    return {
        pinned: e,
        saved: r
    };
}
$aec35899a3c9695e$var$Nr.savedFeedsToUriArrays = $aec35899a3c9695e$var$Iv;
function $aec35899a3c9695e$var$Uv(t) {
    switch(new $aec35899a3c9695e$var$$p.AtUri(t).collection){
        case "app.bsky.feed.generator":
            return "feed";
        case "app.bsky.graph.list":
            return "list";
        default:
            return "unknown";
    }
}
$aec35899a3c9695e$var$Nr.getSavedFeedType = $aec35899a3c9695e$var$Uv;
function $aec35899a3c9695e$var$Ov(t) {
    if (new $aec35899a3c9695e$var$Pv.TID(t.id), [
        "feed",
        "list"
    ].includes(t.type)) {
        const e = new $aec35899a3c9695e$var$$p.AtUri(t.value), r = e.collection === "app.bsky.feed.generator", i = e.collection === "app.bsky.graph.list";
        if (t.type === "feed" && !r) throw new Error(`Saved feed of type 'feed' must be a feed, got ${e.collection}`);
        if (t.type === "list" && !i) throw new Error(`Saved feed of type 'list' must be a list, got ${e.collection}`);
    }
}
$aec35899a3c9695e$var$Nr.validateSavedFeed = $aec35899a3c9695e$var$Ov;
var $aec35899a3c9695e$var$x = {}, $aec35899a3c9695e$var$G = {}, $aec35899a3c9695e$var$Ou = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.XRPCInvalidResponseError = t.XRPCError = t.XRPCResponse = t.ResponseTypeStrings = t.ResponseTypeNames = t.ResponseType = t.errorResponseBody = void 0;
    const e = $aec35899a3c9695e$var$os;
    t.errorResponseBody = e.z.object({
        error: e.z.string().optional(),
        message: e.z.string().optional()
    });
    var r;
    (function(h) {
        h[h.Unknown = 1] = "Unknown", h[h.InvalidResponse = 2] = "InvalidResponse", h[h.Success = 200] = "Success", h[h.InvalidRequest = 400] = "InvalidRequest", h[h.AuthRequired = 401] = "AuthRequired", h[h.Forbidden = 403] = "Forbidden", h[h.XRPCNotSupported = 404] = "XRPCNotSupported", h[h.PayloadTooLarge = 413] = "PayloadTooLarge", h[h.RateLimitExceeded = 429] = "RateLimitExceeded", h[h.InternalServerError = 500] = "InternalServerError", h[h.MethodNotImplemented = 501] = "MethodNotImplemented", h[h.UpstreamFailure = 502] = "UpstreamFailure", h[h.NotEnoughResources = 503] = "NotEnoughResources", h[h.UpstreamTimeout = 504] = "UpstreamTimeout";
    })(r || (t.ResponseType = r = {})), t.ResponseTypeNames = {
        [r.InvalidResponse]: "InvalidResponse",
        [r.Success]: "Success",
        [r.InvalidRequest]: "InvalidRequest",
        [r.AuthRequired]: "AuthenticationRequired",
        [r.Forbidden]: "Forbidden",
        [r.XRPCNotSupported]: "XRPCNotSupported",
        [r.PayloadTooLarge]: "PayloadTooLarge",
        [r.RateLimitExceeded]: "RateLimitExceeded",
        [r.InternalServerError]: "InternalServerError",
        [r.MethodNotImplemented]: "MethodNotImplemented",
        [r.UpstreamFailure]: "UpstreamFailure",
        [r.NotEnoughResources]: "NotEnoughResources",
        [r.UpstreamTimeout]: "UpstreamTimeout"
    }, t.ResponseTypeStrings = {
        [r.InvalidResponse]: "Invalid Response",
        [r.Success]: "Success",
        [r.InvalidRequest]: "Invalid Request",
        [r.AuthRequired]: "Authentication Required",
        [r.Forbidden]: "Forbidden",
        [r.XRPCNotSupported]: "XRPC Not Supported",
        [r.PayloadTooLarge]: "Payload Too Large",
        [r.RateLimitExceeded]: "Rate Limit Exceeded",
        [r.InternalServerError]: "Internal Server Error",
        [r.MethodNotImplemented]: "Method Not Implemented",
        [r.UpstreamFailure]: "Upstream Failure",
        [r.NotEnoughResources]: "Not Enough Resources",
        [r.UpstreamTimeout]: "Upstream Timeout"
    };
    class i {
        constructor(m, p){
            Object.defineProperty(this, "data", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: m
            }), Object.defineProperty(this, "headers", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: p
            }), Object.defineProperty(this, "success", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: !0
            });
        }
    }
    t.XRPCResponse = i;
    class a extends Error {
        constructor(m, p, y, d){
            super(y || p || t.ResponseTypeStrings[m]), Object.defineProperty(this, "status", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: m
            }), Object.defineProperty(this, "error", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: p
            }), Object.defineProperty(this, "success", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: !1
            }), Object.defineProperty(this, "headers", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), this.error || (this.error = t.ResponseTypeNames[m]), this.headers = d;
        }
    }
    t.XRPCError = a;
    class c extends a {
        constructor(m, p, y){
            super(r.InvalidResponse, t.ResponseTypeStrings[r.InvalidResponse], "The server gave an invalid response and may be out of date."), Object.defineProperty(this, "lexiconNsid", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: m
            }), Object.defineProperty(this, "validationError", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: p
            }), Object.defineProperty(this, "responseBody", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: y
            });
        }
    }
    t.XRPCInvalidResponseError = c;
})($aec35899a3c9695e$var$Ou);
var $aec35899a3c9695e$var$Mi = {}, $aec35899a3c9695e$var$Ot = {};
Object.defineProperty($aec35899a3c9695e$var$Ot, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ot.httpResponseBodyParse = $aec35899a3c9695e$var$Ot.httpResponseCodeToEnum = $aec35899a3c9695e$var$Ot.encodeMethodCallBody = $aec35899a3c9695e$var$Ot.constructMethodCallHeaders = $aec35899a3c9695e$var$Ot.normalizeHeaders = $aec35899a3c9695e$var$Ot.encodeQueryParam = $aec35899a3c9695e$var$Ot.constructMethodCallUri = $aec35899a3c9695e$var$Ot.getMethodSchemaHTTPMethod = void 0;
const $aec35899a3c9695e$var$Gp = $aec35899a3c9695e$var$wa, $aec35899a3c9695e$var$ti = $aec35899a3c9695e$var$Ou;
function $aec35899a3c9695e$var$Kv(t) {
    return t.type === "procedure" ? "post" : "get";
}
$aec35899a3c9695e$var$Ot.getMethodSchemaHTTPMethod = $aec35899a3c9695e$var$Kv;
function $aec35899a3c9695e$var$Mv(t, e, r, i) {
    const a = new URL(r);
    if (a.pathname = `/xrpc/${t}`, i) for (const [c, h] of Object.entries(i)){
        const m = e.parameters?.properties?.[c];
        if (!m) throw new Error(`Invalid query parameter: ${c}`);
        h !== void 0 && (m.type === "array" ? [].concat(h).forEach((y)=>{
            a.searchParams.append(c, $aec35899a3c9695e$var$Dc(m.items.type, y));
        }) : a.searchParams.set(c, $aec35899a3c9695e$var$Dc(m.type, h)));
    }
    return a.toString();
}
$aec35899a3c9695e$var$Ot.constructMethodCallUri = $aec35899a3c9695e$var$Mv;
function $aec35899a3c9695e$var$Dc(t, e) {
    if (t === "string" || t === "unknown") return String(e);
    if (t === "float") return String(Number(e));
    if (t === "integer") return String(Number(e) | 0);
    if (t === "boolean") return e ? "true" : "false";
    if (t === "datetime") return e instanceof Date ? e.toISOString() : String(e);
    throw new Error(`Unsupported query param type: ${t}`);
}
$aec35899a3c9695e$var$Ot.encodeQueryParam = $aec35899a3c9695e$var$Dc;
function $aec35899a3c9695e$var$Nv(t) {
    const e = {};
    for (const [r, i] of Object.entries(t))e[r.toLowerCase()] = i;
    return e;
}
$aec35899a3c9695e$var$Ot.normalizeHeaders = $aec35899a3c9695e$var$Nv;
function $aec35899a3c9695e$var$Vv(t, e, r) {
    const i = r?.headers || {};
    return t.type === "procedure" && (r?.encoding && (i["Content-Type"] = r.encoding), e && typeof e == "object" && (i["Content-Type"] || (i["Content-Type"] = "application/json"))), i;
}
$aec35899a3c9695e$var$Ot.constructMethodCallHeaders = $aec35899a3c9695e$var$Vv;
function $aec35899a3c9695e$var$jv(t, e) {
    if (!(!t["content-type"] || typeof e > "u")) return e instanceof ArrayBuffer ? e : t["content-type"].startsWith("text/") ? new TextEncoder().encode(e.toString()) : t["content-type"].startsWith("application/json") ? new TextEncoder().encode((0, $aec35899a3c9695e$var$Gp.stringifyLex)(e)) : e;
}
$aec35899a3c9695e$var$Ot.encodeMethodCallBody = $aec35899a3c9695e$var$jv;
function $aec35899a3c9695e$var$Fv(t) {
    let e;
    return t in $aec35899a3c9695e$var$ti.ResponseType ? e = t : t >= 100 && t < 200 ? e = $aec35899a3c9695e$var$ti.ResponseType.XRPCNotSupported : t >= 200 && t < 300 ? e = $aec35899a3c9695e$var$ti.ResponseType.Success : t >= 300 && t < 400 ? e = $aec35899a3c9695e$var$ti.ResponseType.XRPCNotSupported : t >= 400 && t < 500 ? e = $aec35899a3c9695e$var$ti.ResponseType.InvalidRequest : e = $aec35899a3c9695e$var$ti.ResponseType.InternalServerError, e;
}
$aec35899a3c9695e$var$Ot.httpResponseCodeToEnum = $aec35899a3c9695e$var$Fv;
function $aec35899a3c9695e$var$$v(t, e) {
    if (t) {
        if (t.includes("application/json") && e?.byteLength) try {
            const r = new TextDecoder().decode(e);
            return (0, $aec35899a3c9695e$var$Gp.jsonStringToLex)(r);
        } catch (r) {
            throw new $aec35899a3c9695e$var$ti.XRPCError($aec35899a3c9695e$var$ti.ResponseType.InvalidResponse, `Failed to parse response body: ${String(r)}`);
        }
        if (t.startsWith("text/") && e?.byteLength) try {
            return new TextDecoder().decode(e);
        } catch (r) {
            throw new $aec35899a3c9695e$var$ti.XRPCError($aec35899a3c9695e$var$ti.ResponseType.InvalidResponse, `Failed to parse response body: ${String(r)}`);
        }
    }
    return e instanceof ArrayBuffer ? new Uint8Array(e) : e;
}
$aec35899a3c9695e$var$Ot.httpResponseBodyParse = $aec35899a3c9695e$var$$v;
Object.defineProperty($aec35899a3c9695e$var$Mi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Mi.defaultFetchHandler = $aec35899a3c9695e$var$Mi.ServiceClient = $aec35899a3c9695e$var$Mi.Client = void 0;
const $aec35899a3c9695e$var$qp = $aec35899a3c9695e$var$wa, $aec35899a3c9695e$var$Un = $aec35899a3c9695e$var$Ot, $aec35899a3c9695e$var$un = $aec35899a3c9695e$var$Ou;
class $aec35899a3c9695e$var$Gv {
    constructor(){
        Object.defineProperty(this, "fetch", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $aec35899a3c9695e$var$Xp
        }), Object.defineProperty(this, "lex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new $aec35899a3c9695e$var$qp.Lexicons()
        });
    }
    // method calls
    //
    async call(e, r, i, a, c) {
        return this.service(e).call(r, i, a, c);
    }
    service(e) {
        return new $aec35899a3c9695e$var$zp(this, e);
    }
    // schemas
    // =
    addLexicon(e) {
        this.lex.add(e);
    }
    addLexicons(e) {
        for (const r of e)this.addLexicon(r);
    }
    removeLexicon(e) {
        this.lex.remove(e);
    }
}
$aec35899a3c9695e$var$Mi.Client = $aec35899a3c9695e$var$Gv;
class $aec35899a3c9695e$var$zp {
    constructor(e, r){
        Object.defineProperty(this, "baseClient", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "uri", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "headers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), this.baseClient = e, this.uri = typeof r == "string" ? new URL(r) : r;
    }
    setHeader(e, r) {
        this.headers[e] = r;
    }
    unsetHeader(e) {
        delete this.headers[e];
    }
    async call(e, r, i, a) {
        const c = this.baseClient.lex.getDefOrThrow(e);
        if (!c || c.type !== "query" && c.type !== "procedure") throw new Error(`Invalid lexicon: ${e}. Must be a query or procedure.`);
        const h = (0, $aec35899a3c9695e$var$Un.getMethodSchemaHTTPMethod)(c), m = (0, $aec35899a3c9695e$var$Un.constructMethodCallUri)(e, c, this.uri, r), p = (0, $aec35899a3c9695e$var$Un.constructMethodCallHeaders)(c, i, {
            headers: {
                ...this.headers,
                ...a?.headers
            },
            encoding: a?.encoding
        }), y = await this.baseClient.fetch(m, h, p, i), d = (0, $aec35899a3c9695e$var$Un.httpResponseCodeToEnum)(y.status);
        if (d === $aec35899a3c9695e$var$un.ResponseType.Success) {
            try {
                this.baseClient.lex.assertValidXrpcOutput(e, y.body);
            } catch (v) {
                throw v instanceof $aec35899a3c9695e$var$qp.ValidationError ? new $aec35899a3c9695e$var$un.XRPCInvalidResponseError(e, v, y.body) : v;
            }
            return new $aec35899a3c9695e$var$un.XRPCResponse(y.body, y.headers);
        } else throw y.body && $aec35899a3c9695e$var$qv(y.body) ? new $aec35899a3c9695e$var$un.XRPCError(d, y.body.error, y.body.message, y.headers) : new $aec35899a3c9695e$var$un.XRPCError(d);
    }
}
$aec35899a3c9695e$var$Mi.ServiceClient = $aec35899a3c9695e$var$zp;
async function $aec35899a3c9695e$var$Xp(t, e, r, i) {
    try {
        const a = (0, $aec35899a3c9695e$var$Un.normalizeHeaders)(r), c = {
            method: e,
            headers: a,
            body: (0, $aec35899a3c9695e$var$Un.encodeMethodCallBody)(a, i),
            duplex: "half"
        }, h = await fetch(t, c), m = await h.arrayBuffer();
        return {
            status: h.status,
            headers: Object.fromEntries(h.headers.entries()),
            body: (0, $aec35899a3c9695e$var$Un.httpResponseBodyParse)(h.headers.get("content-type"), m)
        };
    } catch (a) {
        throw new $aec35899a3c9695e$var$un.XRPCError($aec35899a3c9695e$var$un.ResponseType.Unknown, String(a));
    }
}
$aec35899a3c9695e$var$Mi.defaultFetchHandler = $aec35899a3c9695e$var$Xp;
function $aec35899a3c9695e$var$qv(t) {
    return $aec35899a3c9695e$var$un.errorResponseBody.safeParse(t).success;
}
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(c, h, m, p) {
        p === void 0 && (p = m);
        var y = Object.getOwnPropertyDescriptor(h, m);
        (!y || ("get" in y ? !h.__esModule : y.writable || y.configurable)) && (y = {
            enumerable: !0,
            get: function() {
                return h[m];
            }
        }), Object.defineProperty(c, p, y);
    } : function(c, h, m, p) {
        p === void 0 && (p = m), c[p] = h[m];
    }), r = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__exportStar || function(c, h) {
        for(var m in c)m !== "default" && !Object.prototype.hasOwnProperty.call(h, m) && e(h, c, m);
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), r($aec35899a3c9695e$var$Ou, t), r($aec35899a3c9695e$var$Mi, t);
    const i = $aec35899a3c9695e$var$Mi, a = new i.Client();
    t.default = a;
})($aec35899a3c9695e$var$G);
var $aec35899a3c9695e$var$Le = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.ids = t.lexicons = t.schemas = t.schemaDict = void 0;
    const e = $aec35899a3c9695e$var$wa;
    t.schemaDict = {
        ComAtprotoAdminDefs: {
            lexicon: 1,
            id: "com.atproto.admin.defs",
            defs: {
                statusAttr: {
                    type: "object",
                    required: [
                        "applied"
                    ],
                    properties: {
                        applied: {
                            type: "boolean"
                        },
                        ref: {
                            type: "string"
                        }
                    }
                },
                accountView: {
                    type: "object",
                    required: [
                        "did",
                        "handle",
                        "indexedAt"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        handle: {
                            type: "string",
                            format: "handle"
                        },
                        email: {
                            type: "string"
                        },
                        relatedRecords: {
                            type: "array",
                            items: {
                                type: "unknown"
                            }
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        invitedBy: {
                            type: "ref",
                            ref: "lex:com.atproto.server.defs#inviteCode"
                        },
                        invites: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.server.defs#inviteCode"
                            }
                        },
                        invitesDisabled: {
                            type: "boolean"
                        },
                        emailConfirmedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        inviteNote: {
                            type: "string"
                        },
                        deactivatedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                repoRef: {
                    type: "object",
                    required: [
                        "did"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        }
                    }
                },
                repoBlobRef: {
                    type: "object",
                    required: [
                        "did",
                        "cid"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        recordUri: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                }
            }
        },
        ComAtprotoAdminDeleteAccount: {
            lexicon: 1,
            id: "com.atproto.admin.deleteAccount",
            defs: {
                main: {
                    type: "procedure",
                    description: "Delete a user account as an administrator.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminDisableAccountInvites: {
            lexicon: 1,
            id: "com.atproto.admin.disableAccountInvites",
            defs: {
                main: {
                    type: "procedure",
                    description: "Disable an account from receiving new invite codes, but does not invalidate existing codes.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "account"
                            ],
                            properties: {
                                account: {
                                    type: "string",
                                    format: "did"
                                },
                                note: {
                                    type: "string",
                                    description: "Optional reason for disabled invites."
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminDisableInviteCodes: {
            lexicon: 1,
            id: "com.atproto.admin.disableInviteCodes",
            defs: {
                main: {
                    type: "procedure",
                    description: "Disable some set of codes and/or all codes associated with a set of users.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            properties: {
                                codes: {
                                    type: "array",
                                    items: {
                                        type: "string"
                                    }
                                },
                                accounts: {
                                    type: "array",
                                    items: {
                                        type: "string"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminEnableAccountInvites: {
            lexicon: 1,
            id: "com.atproto.admin.enableAccountInvites",
            defs: {
                main: {
                    type: "procedure",
                    description: "Re-enable an account's ability to receive invite codes.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "account"
                            ],
                            properties: {
                                account: {
                                    type: "string",
                                    format: "did"
                                },
                                note: {
                                    type: "string",
                                    description: "Optional reason for enabled invites."
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminGetAccountInfo: {
            lexicon: 1,
            id: "com.atproto.admin.getAccountInfo",
            defs: {
                main: {
                    type: "query",
                    description: "Get details about an account.",
                    parameters: {
                        type: "params",
                        required: [
                            "did"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:com.atproto.admin.defs#accountView"
                        }
                    }
                }
            }
        },
        ComAtprotoAdminGetAccountInfos: {
            lexicon: 1,
            id: "com.atproto.admin.getAccountInfos",
            defs: {
                main: {
                    type: "query",
                    description: "Get details about some accounts.",
                    parameters: {
                        type: "params",
                        required: [
                            "dids"
                        ],
                        properties: {
                            dids: {
                                type: "array",
                                items: {
                                    type: "string",
                                    format: "did"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "infos"
                            ],
                            properties: {
                                infos: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.admin.defs#accountView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminGetInviteCodes: {
            lexicon: 1,
            id: "com.atproto.admin.getInviteCodes",
            defs: {
                main: {
                    type: "query",
                    description: "Get an admin view of invite codes.",
                    parameters: {
                        type: "params",
                        properties: {
                            sort: {
                                type: "string",
                                knownValues: [
                                    "recent",
                                    "usage"
                                ],
                                default: "recent"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 500,
                                default: 100
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "codes"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                codes: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.server.defs#inviteCode"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminGetSubjectStatus: {
            lexicon: 1,
            id: "com.atproto.admin.getSubjectStatus",
            defs: {
                main: {
                    type: "query",
                    description: "Get the service-specific admin status of a subject (account, record, or blob).",
                    parameters: {
                        type: "params",
                        properties: {
                            did: {
                                type: "string",
                                format: "did"
                            },
                            uri: {
                                type: "string",
                                format: "at-uri"
                            },
                            blob: {
                                type: "string",
                                format: "cid"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "subject"
                            ],
                            properties: {
                                subject: {
                                    type: "union",
                                    refs: [
                                        "lex:com.atproto.admin.defs#repoRef",
                                        "lex:com.atproto.repo.strongRef",
                                        "lex:com.atproto.admin.defs#repoBlobRef"
                                    ]
                                },
                                takedown: {
                                    type: "ref",
                                    ref: "lex:com.atproto.admin.defs#statusAttr"
                                },
                                deactivated: {
                                    type: "ref",
                                    ref: "lex:com.atproto.admin.defs#statusAttr"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminSearchAccounts: {
            lexicon: 1,
            id: "com.atproto.admin.searchAccounts",
            defs: {
                main: {
                    type: "query",
                    description: "Get list of accounts that matches your search query.",
                    parameters: {
                        type: "params",
                        properties: {
                            email: {
                                type: "string"
                            },
                            cursor: {
                                type: "string"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "accounts"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                accounts: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.admin.defs#accountView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminSendEmail: {
            lexicon: 1,
            id: "com.atproto.admin.sendEmail",
            defs: {
                main: {
                    type: "procedure",
                    description: "Send email to a user's account email address.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "recipientDid",
                                "content",
                                "senderDid"
                            ],
                            properties: {
                                recipientDid: {
                                    type: "string",
                                    format: "did"
                                },
                                content: {
                                    type: "string"
                                },
                                subject: {
                                    type: "string"
                                },
                                senderDid: {
                                    type: "string",
                                    format: "did"
                                },
                                comment: {
                                    type: "string",
                                    description: "Additional comment by the sender that won't be used in the email itself but helpful to provide more context for moderators/reviewers"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "sent"
                            ],
                            properties: {
                                sent: {
                                    type: "boolean"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminUpdateAccountEmail: {
            lexicon: 1,
            id: "com.atproto.admin.updateAccountEmail",
            defs: {
                main: {
                    type: "procedure",
                    description: "Administrative action to update an account's email.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "account",
                                "email"
                            ],
                            properties: {
                                account: {
                                    type: "string",
                                    format: "at-identifier",
                                    description: "The handle or DID of the repo."
                                },
                                email: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminUpdateAccountHandle: {
            lexicon: 1,
            id: "com.atproto.admin.updateAccountHandle",
            defs: {
                main: {
                    type: "procedure",
                    description: "Administrative action to update an account's handle.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did",
                                "handle"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                handle: {
                                    type: "string",
                                    format: "handle"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminUpdateAccountPassword: {
            lexicon: 1,
            id: "com.atproto.admin.updateAccountPassword",
            defs: {
                main: {
                    type: "procedure",
                    description: "Update the password for a user account as an administrator.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did",
                                "password"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                password: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoAdminUpdateSubjectStatus: {
            lexicon: 1,
            id: "com.atproto.admin.updateSubjectStatus",
            defs: {
                main: {
                    type: "procedure",
                    description: "Update the service-specific admin status of a subject (account, record, or blob).",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "subject"
                            ],
                            properties: {
                                subject: {
                                    type: "union",
                                    refs: [
                                        "lex:com.atproto.admin.defs#repoRef",
                                        "lex:com.atproto.repo.strongRef",
                                        "lex:com.atproto.admin.defs#repoBlobRef"
                                    ]
                                },
                                takedown: {
                                    type: "ref",
                                    ref: "lex:com.atproto.admin.defs#statusAttr"
                                },
                                deactivated: {
                                    type: "ref",
                                    ref: "lex:com.atproto.admin.defs#statusAttr"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "subject"
                            ],
                            properties: {
                                subject: {
                                    type: "union",
                                    refs: [
                                        "lex:com.atproto.admin.defs#repoRef",
                                        "lex:com.atproto.repo.strongRef",
                                        "lex:com.atproto.admin.defs#repoBlobRef"
                                    ]
                                },
                                takedown: {
                                    type: "ref",
                                    ref: "lex:com.atproto.admin.defs#statusAttr"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoIdentityGetRecommendedDidCredentials: {
            lexicon: 1,
            id: "com.atproto.identity.getRecommendedDidCredentials",
            defs: {
                main: {
                    type: "query",
                    description: "Describe the credentials that should be included in the DID doc of an account that is migrating to this service.",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            properties: {
                                rotationKeys: {
                                    description: "Recommended rotation keys for PLC dids. Should be undefined (or ignored) for did:webs.",
                                    type: "array",
                                    items: {
                                        type: "string"
                                    }
                                },
                                alsoKnownAs: {
                                    type: "array",
                                    items: {
                                        type: "string"
                                    }
                                },
                                verificationMethods: {
                                    type: "unknown"
                                },
                                services: {
                                    type: "unknown"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoIdentityRequestPlcOperationSignature: {
            lexicon: 1,
            id: "com.atproto.identity.requestPlcOperationSignature",
            defs: {
                main: {
                    type: "procedure",
                    description: "Request an email with a code to in order to request a signed PLC operation. Requires Auth."
                }
            }
        },
        ComAtprotoIdentityResolveHandle: {
            lexicon: 1,
            id: "com.atproto.identity.resolveHandle",
            defs: {
                main: {
                    type: "query",
                    description: "Resolves a handle (domain name) to a DID.",
                    parameters: {
                        type: "params",
                        required: [
                            "handle"
                        ],
                        properties: {
                            handle: {
                                type: "string",
                                format: "handle",
                                description: "The handle to resolve."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoIdentitySignPlcOperation: {
            lexicon: 1,
            id: "com.atproto.identity.signPlcOperation",
            defs: {
                main: {
                    type: "procedure",
                    description: "Signs a PLC operation to update some value(s) in the requesting DID's document.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            properties: {
                                token: {
                                    description: "A token received through com.atproto.identity.requestPlcOperationSignature",
                                    type: "string"
                                },
                                rotationKeys: {
                                    type: "array",
                                    items: {
                                        type: "string"
                                    }
                                },
                                alsoKnownAs: {
                                    type: "array",
                                    items: {
                                        type: "string"
                                    }
                                },
                                verificationMethods: {
                                    type: "unknown"
                                },
                                services: {
                                    type: "unknown"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "operation"
                            ],
                            properties: {
                                operation: {
                                    type: "unknown",
                                    description: "A signed DID PLC operation."
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoIdentitySubmitPlcOperation: {
            lexicon: 1,
            id: "com.atproto.identity.submitPlcOperation",
            defs: {
                main: {
                    type: "procedure",
                    description: "Validates a PLC operation to ensure that it doesn't violate a service's constraints or get the identity into a bad state, then submits it to the PLC registry",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "operation"
                            ],
                            properties: {
                                operation: {
                                    type: "unknown"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoIdentityUpdateHandle: {
            lexicon: 1,
            id: "com.atproto.identity.updateHandle",
            defs: {
                main: {
                    type: "procedure",
                    description: "Updates the current account's handle. Verifies handle validity, and updates did:plc document if necessary. Implemented by PDS, and requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "handle"
                            ],
                            properties: {
                                handle: {
                                    type: "string",
                                    format: "handle",
                                    description: "The new handle."
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoLabelDefs: {
            lexicon: 1,
            id: "com.atproto.label.defs",
            defs: {
                label: {
                    type: "object",
                    description: "Metadata tag on an atproto resource (eg, repo or record).",
                    required: [
                        "src",
                        "uri",
                        "val",
                        "cts"
                    ],
                    properties: {
                        ver: {
                            type: "integer",
                            description: "The AT Protocol version of the label object."
                        },
                        src: {
                            type: "string",
                            format: "did",
                            description: "DID of the actor who created this label."
                        },
                        uri: {
                            type: "string",
                            format: "uri",
                            description: "AT URI of the record, repository (account), or other resource that this label applies to."
                        },
                        cid: {
                            type: "string",
                            format: "cid",
                            description: "Optionally, CID specifying the specific version of 'uri' resource this label applies to."
                        },
                        val: {
                            type: "string",
                            maxLength: 128,
                            description: "The short string name of the value or type of this label."
                        },
                        neg: {
                            type: "boolean",
                            description: "If true, this is a negation label, overwriting a previous label."
                        },
                        cts: {
                            type: "string",
                            format: "datetime",
                            description: "Timestamp when this label was created."
                        },
                        exp: {
                            type: "string",
                            format: "datetime",
                            description: "Timestamp at which this label expires (no longer applies)."
                        },
                        sig: {
                            type: "bytes",
                            description: "Signature of dag-cbor encoded label."
                        }
                    }
                },
                selfLabels: {
                    type: "object",
                    description: "Metadata tags on an atproto record, published by the author within the record.",
                    required: [
                        "values"
                    ],
                    properties: {
                        values: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#selfLabel"
                            },
                            maxLength: 10
                        }
                    }
                },
                selfLabel: {
                    type: "object",
                    description: "Metadata tag on an atproto record, published by the author within the record. Note that schemas should use #selfLabels, not #selfLabel.",
                    required: [
                        "val"
                    ],
                    properties: {
                        val: {
                            type: "string",
                            maxLength: 128,
                            description: "The short string name of the value or type of this label."
                        }
                    }
                },
                labelValueDefinition: {
                    type: "object",
                    description: "Declares a label value and its expected interpretations and behaviors.",
                    required: [
                        "identifier",
                        "severity",
                        "blurs",
                        "locales"
                    ],
                    properties: {
                        identifier: {
                            type: "string",
                            description: "The value of the label being defined. Must only include lowercase ascii and the '-' character ([a-z-]+).",
                            maxLength: 100,
                            maxGraphemes: 100
                        },
                        severity: {
                            type: "string",
                            description: "How should a client visually convey this label? 'inform' means neutral and informational; 'alert' means negative and warning; 'none' means show nothing.",
                            knownValues: [
                                "inform",
                                "alert",
                                "none"
                            ]
                        },
                        blurs: {
                            type: "string",
                            description: "What should this label hide in the UI, if applied? 'content' hides all of the target; 'media' hides the images/video/audio; 'none' hides nothing.",
                            knownValues: [
                                "content",
                                "media",
                                "none"
                            ]
                        },
                        defaultSetting: {
                            type: "string",
                            description: "The default setting for this label.",
                            knownValues: [
                                "ignore",
                                "warn",
                                "hide"
                            ],
                            default: "warn"
                        },
                        adultOnly: {
                            type: "boolean",
                            description: "Does the user need to have adult content enabled in order to configure this label?"
                        },
                        locales: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#labelValueDefinitionStrings"
                            }
                        }
                    }
                },
                labelValueDefinitionStrings: {
                    type: "object",
                    description: "Strings which describe the label in the UI, localized into a specific language.",
                    required: [
                        "lang",
                        "name",
                        "description"
                    ],
                    properties: {
                        lang: {
                            type: "string",
                            description: "The code of the language these strings are written in.",
                            format: "language"
                        },
                        name: {
                            type: "string",
                            description: "A short human-readable name for the label.",
                            maxGraphemes: 64,
                            maxLength: 640
                        },
                        description: {
                            type: "string",
                            description: "A longer description of what the label means and why it might be applied.",
                            maxGraphemes: 1e4,
                            maxLength: 1e5
                        }
                    }
                },
                labelValue: {
                    type: "string",
                    knownValues: [
                        "!hide",
                        "!no-promote",
                        "!warn",
                        "!no-unauthenticated",
                        "dmca-violation",
                        "doxxing",
                        "porn",
                        "sexual",
                        "nudity",
                        "nsfl",
                        "gore"
                    ]
                }
            }
        },
        ComAtprotoLabelQueryLabels: {
            lexicon: 1,
            id: "com.atproto.label.queryLabels",
            defs: {
                main: {
                    type: "query",
                    description: "Find labels relevant to the provided AT-URI patterns. Public endpoint for moderation services, though may return different or additional results with auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "uriPatterns"
                        ],
                        properties: {
                            uriPatterns: {
                                type: "array",
                                items: {
                                    type: "string"
                                },
                                description: "List of AT URI patterns to match (boolean 'OR'). Each may be a prefix (ending with '*'; will match inclusive of the string leading to '*'), or a full URI."
                            },
                            sources: {
                                type: "array",
                                items: {
                                    type: "string",
                                    format: "did"
                                },
                                description: "Optional list of label sources (DIDs) to filter on."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 250,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "labels"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                labels: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.label.defs#label"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoLabelSubscribeLabels: {
            lexicon: 1,
            id: "com.atproto.label.subscribeLabels",
            defs: {
                main: {
                    type: "subscription",
                    description: "Subscribe to stream of labels (and negations). Public endpoint implemented by mod services. Uses same sequencing scheme as repo event stream.",
                    parameters: {
                        type: "params",
                        properties: {
                            cursor: {
                                type: "integer",
                                description: "The last known event seq number to backfill from."
                            }
                        }
                    },
                    message: {
                        schema: {
                            type: "union",
                            refs: [
                                "lex:com.atproto.label.subscribeLabels#labels",
                                "lex:com.atproto.label.subscribeLabels#info"
                            ]
                        }
                    },
                    errors: [
                        {
                            name: "FutureCursor"
                        }
                    ]
                },
                labels: {
                    type: "object",
                    required: [
                        "seq",
                        "labels"
                    ],
                    properties: {
                        seq: {
                            type: "integer"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        }
                    }
                },
                info: {
                    type: "object",
                    required: [
                        "name"
                    ],
                    properties: {
                        name: {
                            type: "string",
                            knownValues: [
                                "OutdatedCursor"
                            ]
                        },
                        message: {
                            type: "string"
                        }
                    }
                }
            }
        },
        ComAtprotoModerationCreateReport: {
            lexicon: 1,
            id: "com.atproto.moderation.createReport",
            defs: {
                main: {
                    type: "procedure",
                    description: "Submit a moderation report regarding an atproto account or record. Implemented by moderation services (with PDS proxying), and requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "reasonType",
                                "subject"
                            ],
                            properties: {
                                reasonType: {
                                    type: "ref",
                                    description: "Indicates the broad category of violation the report is for.",
                                    ref: "lex:com.atproto.moderation.defs#reasonType"
                                },
                                reason: {
                                    type: "string",
                                    maxGraphemes: 2e3,
                                    maxLength: 2e4,
                                    description: "Additional context about the content and violation."
                                },
                                subject: {
                                    type: "union",
                                    refs: [
                                        "lex:com.atproto.admin.defs#repoRef",
                                        "lex:com.atproto.repo.strongRef"
                                    ]
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "id",
                                "reasonType",
                                "subject",
                                "reportedBy",
                                "createdAt"
                            ],
                            properties: {
                                id: {
                                    type: "integer"
                                },
                                reasonType: {
                                    type: "ref",
                                    ref: "lex:com.atproto.moderation.defs#reasonType"
                                },
                                reason: {
                                    type: "string",
                                    maxGraphemes: 2e3,
                                    maxLength: 2e4
                                },
                                subject: {
                                    type: "union",
                                    refs: [
                                        "lex:com.atproto.admin.defs#repoRef",
                                        "lex:com.atproto.repo.strongRef"
                                    ]
                                },
                                reportedBy: {
                                    type: "string",
                                    format: "did"
                                },
                                createdAt: {
                                    type: "string",
                                    format: "datetime"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoModerationDefs: {
            lexicon: 1,
            id: "com.atproto.moderation.defs",
            defs: {
                reasonType: {
                    type: "string",
                    knownValues: [
                        "com.atproto.moderation.defs#reasonSpam",
                        "com.atproto.moderation.defs#reasonViolation",
                        "com.atproto.moderation.defs#reasonMisleading",
                        "com.atproto.moderation.defs#reasonSexual",
                        "com.atproto.moderation.defs#reasonRude",
                        "com.atproto.moderation.defs#reasonOther",
                        "com.atproto.moderation.defs#reasonAppeal"
                    ]
                },
                reasonSpam: {
                    type: "token",
                    description: "Spam: frequent unwanted promotion, replies, mentions"
                },
                reasonViolation: {
                    type: "token",
                    description: "Direct violation of server rules, laws, terms of service"
                },
                reasonMisleading: {
                    type: "token",
                    description: "Misleading identity, affiliation, or content"
                },
                reasonSexual: {
                    type: "token",
                    description: "Unwanted or mislabeled sexual content"
                },
                reasonRude: {
                    type: "token",
                    description: "Rude, harassing, explicit, or otherwise unwelcoming behavior"
                },
                reasonOther: {
                    type: "token",
                    description: "Other: reports not falling under another report category"
                },
                reasonAppeal: {
                    type: "token",
                    description: "Appeal: appeal a previously taken moderation action"
                }
            }
        },
        ComAtprotoRepoApplyWrites: {
            lexicon: 1,
            id: "com.atproto.repo.applyWrites",
            defs: {
                main: {
                    type: "procedure",
                    description: "Apply a batch transaction of repository creates, updates, and deletes. Requires auth, implemented by PDS.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "repo",
                                "writes"
                            ],
                            properties: {
                                repo: {
                                    type: "string",
                                    format: "at-identifier",
                                    description: "The handle or DID of the repo (aka, current account)."
                                },
                                validate: {
                                    type: "boolean",
                                    default: !0,
                                    description: "Can be set to 'false' to skip Lexicon schema validation of record data, for all operations."
                                },
                                writes: {
                                    type: "array",
                                    items: {
                                        type: "union",
                                        refs: [
                                            "lex:com.atproto.repo.applyWrites#create",
                                            "lex:com.atproto.repo.applyWrites#update",
                                            "lex:com.atproto.repo.applyWrites#delete"
                                        ],
                                        closed: !0
                                    }
                                },
                                swapCommit: {
                                    type: "string",
                                    description: "If provided, the entire operation will fail if the current repo commit CID does not match this value. Used to prevent conflicting repo mutations.",
                                    format: "cid"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "InvalidSwap",
                            description: "Indicates that the 'swapCommit' parameter did not match current commit."
                        }
                    ]
                },
                create: {
                    type: "object",
                    description: "Operation which creates a new record.",
                    required: [
                        "collection",
                        "value"
                    ],
                    properties: {
                        collection: {
                            type: "string",
                            format: "nsid"
                        },
                        rkey: {
                            type: "string",
                            maxLength: 15
                        },
                        value: {
                            type: "unknown"
                        }
                    }
                },
                update: {
                    type: "object",
                    description: "Operation which updates an existing record.",
                    required: [
                        "collection",
                        "rkey",
                        "value"
                    ],
                    properties: {
                        collection: {
                            type: "string",
                            format: "nsid"
                        },
                        rkey: {
                            type: "string"
                        },
                        value: {
                            type: "unknown"
                        }
                    }
                },
                delete: {
                    type: "object",
                    description: "Operation which deletes an existing record.",
                    required: [
                        "collection",
                        "rkey"
                    ],
                    properties: {
                        collection: {
                            type: "string",
                            format: "nsid"
                        },
                        rkey: {
                            type: "string"
                        }
                    }
                }
            }
        },
        ComAtprotoRepoCreateRecord: {
            lexicon: 1,
            id: "com.atproto.repo.createRecord",
            defs: {
                main: {
                    type: "procedure",
                    description: "Create a single new repository record. Requires auth, implemented by PDS.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "repo",
                                "collection",
                                "record"
                            ],
                            properties: {
                                repo: {
                                    type: "string",
                                    format: "at-identifier",
                                    description: "The handle or DID of the repo (aka, current account)."
                                },
                                collection: {
                                    type: "string",
                                    format: "nsid",
                                    description: "The NSID of the record collection."
                                },
                                rkey: {
                                    type: "string",
                                    description: "The Record Key.",
                                    maxLength: 15
                                },
                                validate: {
                                    type: "boolean",
                                    default: !0,
                                    description: "Can be set to 'false' to skip Lexicon schema validation of record data."
                                },
                                record: {
                                    type: "unknown",
                                    description: "The record itself. Must contain a $type field."
                                },
                                swapCommit: {
                                    type: "string",
                                    format: "cid",
                                    description: "Compare and swap with the previous commit by CID."
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "uri",
                                "cid"
                            ],
                            properties: {
                                uri: {
                                    type: "string",
                                    format: "at-uri"
                                },
                                cid: {
                                    type: "string",
                                    format: "cid"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "InvalidSwap",
                            description: "Indicates that 'swapCommit' didn't match current repo commit."
                        }
                    ]
                }
            }
        },
        ComAtprotoRepoDeleteRecord: {
            lexicon: 1,
            id: "com.atproto.repo.deleteRecord",
            defs: {
                main: {
                    type: "procedure",
                    description: "Delete a repository record, or ensure it doesn't exist. Requires auth, implemented by PDS.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "repo",
                                "collection",
                                "rkey"
                            ],
                            properties: {
                                repo: {
                                    type: "string",
                                    format: "at-identifier",
                                    description: "The handle or DID of the repo (aka, current account)."
                                },
                                collection: {
                                    type: "string",
                                    format: "nsid",
                                    description: "The NSID of the record collection."
                                },
                                rkey: {
                                    type: "string",
                                    description: "The Record Key."
                                },
                                swapRecord: {
                                    type: "string",
                                    format: "cid",
                                    description: "Compare and swap with the previous record by CID."
                                },
                                swapCommit: {
                                    type: "string",
                                    format: "cid",
                                    description: "Compare and swap with the previous commit by CID."
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "InvalidSwap"
                        }
                    ]
                }
            }
        },
        ComAtprotoRepoDescribeRepo: {
            lexicon: 1,
            id: "com.atproto.repo.describeRepo",
            defs: {
                main: {
                    type: "query",
                    description: "Get information about an account and repository, including the list of collections. Does not require auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "repo"
                        ],
                        properties: {
                            repo: {
                                type: "string",
                                format: "at-identifier",
                                description: "The handle or DID of the repo."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "handle",
                                "did",
                                "didDoc",
                                "collections",
                                "handleIsCorrect"
                            ],
                            properties: {
                                handle: {
                                    type: "string",
                                    format: "handle"
                                },
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                didDoc: {
                                    type: "unknown",
                                    description: "The complete DID document for this account."
                                },
                                collections: {
                                    type: "array",
                                    description: "List of all the collections (NSIDs) for which this repo contains at least one record.",
                                    items: {
                                        type: "string",
                                        format: "nsid"
                                    }
                                },
                                handleIsCorrect: {
                                    type: "boolean",
                                    description: "Indicates if handle is currently valid (resolves bi-directionally)"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoRepoGetRecord: {
            lexicon: 1,
            id: "com.atproto.repo.getRecord",
            defs: {
                main: {
                    type: "query",
                    description: "Get a single record from a repository. Does not require auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "repo",
                            "collection",
                            "rkey"
                        ],
                        properties: {
                            repo: {
                                type: "string",
                                format: "at-identifier",
                                description: "The handle or DID of the repo."
                            },
                            collection: {
                                type: "string",
                                format: "nsid",
                                description: "The NSID of the record collection."
                            },
                            rkey: {
                                type: "string",
                                description: "The Record Key."
                            },
                            cid: {
                                type: "string",
                                format: "cid",
                                description: "The CID of the version of the record. If not specified, then return the most recent version."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "uri",
                                "value"
                            ],
                            properties: {
                                uri: {
                                    type: "string",
                                    format: "at-uri"
                                },
                                cid: {
                                    type: "string",
                                    format: "cid"
                                },
                                value: {
                                    type: "unknown"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoRepoImportRepo: {
            lexicon: 1,
            id: "com.atproto.repo.importRepo",
            defs: {
                main: {
                    type: "procedure",
                    description: "Import a repo in the form of a CAR file. Requires Content-Length HTTP header to be set.",
                    input: {
                        encoding: "application/vnd.ipld.car"
                    }
                }
            }
        },
        ComAtprotoRepoListMissingBlobs: {
            lexicon: 1,
            id: "com.atproto.repo.listMissingBlobs",
            defs: {
                main: {
                    type: "query",
                    description: "Returns a list of missing blobs for the requesting account. Intended to be used in the account migration flow.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 1e3,
                                default: 500
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "blobs"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                blobs: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.repo.listMissingBlobs#recordBlob"
                                    }
                                }
                            }
                        }
                    }
                },
                recordBlob: {
                    type: "object",
                    required: [
                        "cid",
                        "recordUri"
                    ],
                    properties: {
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        recordUri: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                }
            }
        },
        ComAtprotoRepoListRecords: {
            lexicon: 1,
            id: "com.atproto.repo.listRecords",
            defs: {
                main: {
                    type: "query",
                    description: "List a range of records in a repository, matching a specific collection. Does not require auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "repo",
                            "collection"
                        ],
                        properties: {
                            repo: {
                                type: "string",
                                format: "at-identifier",
                                description: "The handle or DID of the repo."
                            },
                            collection: {
                                type: "string",
                                format: "nsid",
                                description: "The NSID of the record type."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50,
                                description: "The number of records to return."
                            },
                            cursor: {
                                type: "string"
                            },
                            rkeyStart: {
                                type: "string",
                                description: "DEPRECATED: The lowest sort-ordered rkey to start from (exclusive)"
                            },
                            rkeyEnd: {
                                type: "string",
                                description: "DEPRECATED: The highest sort-ordered rkey to stop at (exclusive)"
                            },
                            reverse: {
                                type: "boolean",
                                description: "Flag to reverse the order of the returned records."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "records"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                records: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.repo.listRecords#record"
                                    }
                                }
                            }
                        }
                    }
                },
                record: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "value"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        value: {
                            type: "unknown"
                        }
                    }
                }
            }
        },
        ComAtprotoRepoPutRecord: {
            lexicon: 1,
            id: "com.atproto.repo.putRecord",
            defs: {
                main: {
                    type: "procedure",
                    description: "Write a repository record, creating or updating it as needed. Requires auth, implemented by PDS.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "repo",
                                "collection",
                                "rkey",
                                "record"
                            ],
                            nullable: [
                                "swapRecord"
                            ],
                            properties: {
                                repo: {
                                    type: "string",
                                    format: "at-identifier",
                                    description: "The handle or DID of the repo (aka, current account)."
                                },
                                collection: {
                                    type: "string",
                                    format: "nsid",
                                    description: "The NSID of the record collection."
                                },
                                rkey: {
                                    type: "string",
                                    description: "The Record Key.",
                                    maxLength: 15
                                },
                                validate: {
                                    type: "boolean",
                                    default: !0,
                                    description: "Can be set to 'false' to skip Lexicon schema validation of record data."
                                },
                                record: {
                                    type: "unknown",
                                    description: "The record to write."
                                },
                                swapRecord: {
                                    type: "string",
                                    format: "cid",
                                    description: "Compare and swap with the previous record by CID. WARNING: nullable and optional field; may cause problems with golang implementation"
                                },
                                swapCommit: {
                                    type: "string",
                                    format: "cid",
                                    description: "Compare and swap with the previous commit by CID."
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "uri",
                                "cid"
                            ],
                            properties: {
                                uri: {
                                    type: "string",
                                    format: "at-uri"
                                },
                                cid: {
                                    type: "string",
                                    format: "cid"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "InvalidSwap"
                        }
                    ]
                }
            }
        },
        ComAtprotoRepoStrongRef: {
            lexicon: 1,
            id: "com.atproto.repo.strongRef",
            description: "A URI with a content-hash fingerprint.",
            defs: {
                main: {
                    type: "object",
                    required: [
                        "uri",
                        "cid"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        }
                    }
                }
            }
        },
        ComAtprotoRepoUploadBlob: {
            lexicon: 1,
            id: "com.atproto.repo.uploadBlob",
            defs: {
                main: {
                    type: "procedure",
                    description: "Upload a new blob, to be referenced from a repository record. The blob will be deleted if it is not referenced within a time window (eg, minutes). Blob restrictions (mimetype, size, etc) are enforced when the reference is created. Requires auth, implemented by PDS.",
                    input: {
                        encoding: "*/*"
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "blob"
                            ],
                            properties: {
                                blob: {
                                    type: "blob"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerActivateAccount: {
            lexicon: 1,
            id: "com.atproto.server.activateAccount",
            defs: {
                main: {
                    type: "procedure",
                    description: "Activates a currently deactivated account. Used to finalize account migration after the account's repo is imported and identity is setup."
                }
            }
        },
        ComAtprotoServerCheckAccountStatus: {
            lexicon: 1,
            id: "com.atproto.server.checkAccountStatus",
            defs: {
                main: {
                    type: "query",
                    description: "Returns the status of an account, especially as pertaining to import or recovery. Can be called many times over the course of an account migration. Requires auth and can only be called pertaining to oneself.",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "activated",
                                "validDid",
                                "repoCommit",
                                "repoRev",
                                "repoBlocks",
                                "indexedRecords",
                                "privateStateValues",
                                "expectedBlobs",
                                "importedBlobs"
                            ],
                            properties: {
                                activated: {
                                    type: "boolean"
                                },
                                validDid: {
                                    type: "boolean"
                                },
                                repoCommit: {
                                    type: "string",
                                    format: "cid"
                                },
                                repoRev: {
                                    type: "string"
                                },
                                repoBlocks: {
                                    type: "integer"
                                },
                                indexedRecords: {
                                    type: "integer"
                                },
                                privateStateValues: {
                                    type: "integer"
                                },
                                expectedBlobs: {
                                    type: "integer"
                                },
                                importedBlobs: {
                                    type: "integer"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerConfirmEmail: {
            lexicon: 1,
            id: "com.atproto.server.confirmEmail",
            defs: {
                main: {
                    type: "procedure",
                    description: "Confirm an email using a token from com.atproto.server.requestEmailConfirmation.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "email",
                                "token"
                            ],
                            properties: {
                                email: {
                                    type: "string"
                                },
                                token: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "AccountNotFound"
                        },
                        {
                            name: "ExpiredToken"
                        },
                        {
                            name: "InvalidToken"
                        },
                        {
                            name: "InvalidEmail"
                        }
                    ]
                }
            }
        },
        ComAtprotoServerCreateAccount: {
            lexicon: 1,
            id: "com.atproto.server.createAccount",
            defs: {
                main: {
                    type: "procedure",
                    description: "Create an account. Implemented by PDS.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "handle"
                            ],
                            properties: {
                                email: {
                                    type: "string"
                                },
                                handle: {
                                    type: "string",
                                    format: "handle",
                                    description: "Requested handle for the account."
                                },
                                did: {
                                    type: "string",
                                    format: "did",
                                    description: "Pre-existing atproto DID, being imported to a new account."
                                },
                                inviteCode: {
                                    type: "string"
                                },
                                verificationCode: {
                                    type: "string"
                                },
                                verificationPhone: {
                                    type: "string"
                                },
                                password: {
                                    type: "string",
                                    description: "Initial account password. May need to meet instance-specific password strength requirements."
                                },
                                recoveryKey: {
                                    type: "string",
                                    description: "DID PLC rotation key (aka, recovery key) to be included in PLC creation operation."
                                },
                                plcOp: {
                                    type: "unknown",
                                    description: "A signed DID PLC operation to be submitted as part of importing an existing account to this instance. NOTE: this optional field may be updated when full account migration is implemented."
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            description: "Account login session returned on successful account creation.",
                            required: [
                                "accessJwt",
                                "refreshJwt",
                                "handle",
                                "did"
                            ],
                            properties: {
                                accessJwt: {
                                    type: "string"
                                },
                                refreshJwt: {
                                    type: "string"
                                },
                                handle: {
                                    type: "string",
                                    format: "handle"
                                },
                                did: {
                                    type: "string",
                                    format: "did",
                                    description: "The DID of the new account."
                                },
                                didDoc: {
                                    type: "unknown",
                                    description: "Complete DID document."
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "InvalidHandle"
                        },
                        {
                            name: "InvalidPassword"
                        },
                        {
                            name: "InvalidInviteCode"
                        },
                        {
                            name: "HandleNotAvailable"
                        },
                        {
                            name: "UnsupportedDomain"
                        },
                        {
                            name: "UnresolvableDid"
                        },
                        {
                            name: "IncompatibleDidDoc"
                        }
                    ]
                }
            }
        },
        ComAtprotoServerCreateAppPassword: {
            lexicon: 1,
            id: "com.atproto.server.createAppPassword",
            defs: {
                main: {
                    type: "procedure",
                    description: "Create an App Password.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "name"
                            ],
                            properties: {
                                name: {
                                    type: "string",
                                    description: "A short name for the App Password, to help distinguish them."
                                },
                                privileged: {
                                    type: "boolean",
                                    description: "If an app password has 'privileged' access to possibly sensitive account state. Meant for use with trusted clients."
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:com.atproto.server.createAppPassword#appPassword"
                        }
                    },
                    errors: [
                        {
                            name: "AccountTakedown"
                        }
                    ]
                },
                appPassword: {
                    type: "object",
                    required: [
                        "name",
                        "password",
                        "createdAt"
                    ],
                    properties: {
                        name: {
                            type: "string"
                        },
                        password: {
                            type: "string"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        privileged: {
                            type: "boolean"
                        }
                    }
                }
            }
        },
        ComAtprotoServerCreateInviteCode: {
            lexicon: 1,
            id: "com.atproto.server.createInviteCode",
            defs: {
                main: {
                    type: "procedure",
                    description: "Create an invite code.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "useCount"
                            ],
                            properties: {
                                useCount: {
                                    type: "integer"
                                },
                                forAccount: {
                                    type: "string",
                                    format: "did"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "code"
                            ],
                            properties: {
                                code: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerCreateInviteCodes: {
            lexicon: 1,
            id: "com.atproto.server.createInviteCodes",
            defs: {
                main: {
                    type: "procedure",
                    description: "Create invite codes.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "codeCount",
                                "useCount"
                            ],
                            properties: {
                                codeCount: {
                                    type: "integer",
                                    default: 1
                                },
                                useCount: {
                                    type: "integer"
                                },
                                forAccounts: {
                                    type: "array",
                                    items: {
                                        type: "string",
                                        format: "did"
                                    }
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "codes"
                            ],
                            properties: {
                                codes: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.server.createInviteCodes#accountCodes"
                                    }
                                }
                            }
                        }
                    }
                },
                accountCodes: {
                    type: "object",
                    required: [
                        "account",
                        "codes"
                    ],
                    properties: {
                        account: {
                            type: "string"
                        },
                        codes: {
                            type: "array",
                            items: {
                                type: "string"
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerCreateSession: {
            lexicon: 1,
            id: "com.atproto.server.createSession",
            defs: {
                main: {
                    type: "procedure",
                    description: "Create an authentication session.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "identifier",
                                "password"
                            ],
                            properties: {
                                identifier: {
                                    type: "string",
                                    description: "Handle or other identifier supported by the server for the authenticating user."
                                },
                                password: {
                                    type: "string"
                                },
                                authFactorToken: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "accessJwt",
                                "refreshJwt",
                                "handle",
                                "did"
                            ],
                            properties: {
                                accessJwt: {
                                    type: "string"
                                },
                                refreshJwt: {
                                    type: "string"
                                },
                                handle: {
                                    type: "string",
                                    format: "handle"
                                },
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                didDoc: {
                                    type: "unknown"
                                },
                                email: {
                                    type: "string"
                                },
                                emailConfirmed: {
                                    type: "boolean"
                                },
                                emailAuthFactor: {
                                    type: "boolean"
                                },
                                active: {
                                    type: "boolean"
                                },
                                status: {
                                    type: "string",
                                    description: "If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.",
                                    knownValues: [
                                        "takendown",
                                        "suspended",
                                        "deactivated"
                                    ]
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "AccountTakedown"
                        },
                        {
                            name: "AuthFactorTokenRequired"
                        }
                    ]
                }
            }
        },
        ComAtprotoServerDeactivateAccount: {
            lexicon: 1,
            id: "com.atproto.server.deactivateAccount",
            defs: {
                main: {
                    type: "procedure",
                    description: "Deactivates a currently active account. Stops serving of repo, and future writes to repo until reactivated. Used to finalize account migration with the old host after the account has been activated on the new host.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            properties: {
                                deleteAfter: {
                                    type: "string",
                                    format: "datetime",
                                    description: "A recommendation to server as to how long they should hold onto the deactivated account before deleting."
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerDefs: {
            lexicon: 1,
            id: "com.atproto.server.defs",
            defs: {
                inviteCode: {
                    type: "object",
                    required: [
                        "code",
                        "available",
                        "disabled",
                        "forAccount",
                        "createdBy",
                        "createdAt",
                        "uses"
                    ],
                    properties: {
                        code: {
                            type: "string"
                        },
                        available: {
                            type: "integer"
                        },
                        disabled: {
                            type: "boolean"
                        },
                        forAccount: {
                            type: "string"
                        },
                        createdBy: {
                            type: "string"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        uses: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.server.defs#inviteCodeUse"
                            }
                        }
                    }
                },
                inviteCodeUse: {
                    type: "object",
                    required: [
                        "usedBy",
                        "usedAt"
                    ],
                    properties: {
                        usedBy: {
                            type: "string",
                            format: "did"
                        },
                        usedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                }
            }
        },
        ComAtprotoServerDeleteAccount: {
            lexicon: 1,
            id: "com.atproto.server.deleteAccount",
            defs: {
                main: {
                    type: "procedure",
                    description: "Delete an actor's account with a token and password. Can only be called after requesting a deletion token. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did",
                                "password",
                                "token"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                password: {
                                    type: "string"
                                },
                                token: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "ExpiredToken"
                        },
                        {
                            name: "InvalidToken"
                        }
                    ]
                }
            }
        },
        ComAtprotoServerDeleteSession: {
            lexicon: 1,
            id: "com.atproto.server.deleteSession",
            defs: {
                main: {
                    type: "procedure",
                    description: "Delete the current session. Requires auth."
                }
            }
        },
        ComAtprotoServerDescribeServer: {
            lexicon: 1,
            id: "com.atproto.server.describeServer",
            defs: {
                main: {
                    type: "query",
                    description: "Describes the server's account creation requirements and capabilities. Implemented by PDS.",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did",
                                "availableUserDomains"
                            ],
                            properties: {
                                inviteCodeRequired: {
                                    type: "boolean",
                                    description: "If true, an invite code must be supplied to create an account on this instance."
                                },
                                phoneVerificationRequired: {
                                    type: "boolean",
                                    description: "If true, a phone verification token must be supplied to create an account on this instance."
                                },
                                availableUserDomains: {
                                    type: "array",
                                    description: "List of domain suffixes that can be used in account handles.",
                                    items: {
                                        type: "string"
                                    }
                                },
                                links: {
                                    type: "ref",
                                    description: "URLs of service policy documents.",
                                    ref: "lex:com.atproto.server.describeServer#links"
                                },
                                contact: {
                                    type: "ref",
                                    description: "Contact information",
                                    ref: "lex:com.atproto.server.describeServer#contact"
                                },
                                did: {
                                    type: "string",
                                    format: "did"
                                }
                            }
                        }
                    }
                },
                links: {
                    type: "object",
                    properties: {
                        privacyPolicy: {
                            type: "string",
                            format: "uri"
                        },
                        termsOfService: {
                            type: "string",
                            format: "uri"
                        }
                    }
                },
                contact: {
                    type: "object",
                    properties: {
                        email: {
                            type: "string"
                        }
                    }
                }
            }
        },
        ComAtprotoServerGetAccountInviteCodes: {
            lexicon: 1,
            id: "com.atproto.server.getAccountInviteCodes",
            defs: {
                main: {
                    type: "query",
                    description: "Get all invite codes for the current account. Requires auth.",
                    parameters: {
                        type: "params",
                        properties: {
                            includeUsed: {
                                type: "boolean",
                                default: !0
                            },
                            createAvailable: {
                                type: "boolean",
                                default: !0,
                                description: "Controls whether any new 'earned' but not 'created' invites should be created."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "codes"
                            ],
                            properties: {
                                codes: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.server.defs#inviteCode"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "DuplicateCreate"
                        }
                    ]
                }
            }
        },
        ComAtprotoServerGetServiceAuth: {
            lexicon: 1,
            id: "com.atproto.server.getServiceAuth",
            defs: {
                main: {
                    type: "query",
                    description: "Get a signed token on behalf of the requesting DID for the requested service.",
                    parameters: {
                        type: "params",
                        required: [
                            "aud"
                        ],
                        properties: {
                            aud: {
                                type: "string",
                                format: "did",
                                description: "The DID of the service that the token will be used to authenticate with"
                            },
                            exp: {
                                type: "integer",
                                description: "The time in Unix Epoch seconds that the JWT expires. Defaults to 60 seconds in the future. The service may enforce certain time bounds on tokens depending on the requested scope."
                            },
                            lxm: {
                                type: "string",
                                format: "nsid",
                                description: "Lexicon (XRPC) method to bind the requested token to"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "token"
                            ],
                            properties: {
                                token: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "BadExpiration",
                            description: "Indicates that the requested expiration date is not a valid. May be in the past or may be reliant on the requested scopes."
                        }
                    ]
                }
            }
        },
        ComAtprotoServerGetSession: {
            lexicon: 1,
            id: "com.atproto.server.getSession",
            defs: {
                main: {
                    type: "query",
                    description: "Get information about the current auth session. Requires auth.",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "handle",
                                "did"
                            ],
                            properties: {
                                handle: {
                                    type: "string",
                                    format: "handle"
                                },
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                email: {
                                    type: "string"
                                },
                                emailConfirmed: {
                                    type: "boolean"
                                },
                                emailAuthFactor: {
                                    type: "boolean"
                                },
                                didDoc: {
                                    type: "unknown"
                                },
                                active: {
                                    type: "boolean"
                                },
                                status: {
                                    type: "string",
                                    description: "If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.",
                                    knownValues: [
                                        "takendown",
                                        "suspended",
                                        "deactivated"
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerListAppPasswords: {
            lexicon: 1,
            id: "com.atproto.server.listAppPasswords",
            defs: {
                main: {
                    type: "query",
                    description: "List all App Passwords.",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "passwords"
                            ],
                            properties: {
                                passwords: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.server.listAppPasswords#appPassword"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "AccountTakedown"
                        }
                    ]
                },
                appPassword: {
                    type: "object",
                    required: [
                        "name",
                        "createdAt"
                    ],
                    properties: {
                        name: {
                            type: "string"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        privileged: {
                            type: "boolean"
                        }
                    }
                }
            }
        },
        ComAtprotoServerRefreshSession: {
            lexicon: 1,
            id: "com.atproto.server.refreshSession",
            defs: {
                main: {
                    type: "procedure",
                    description: "Refresh an authentication session. Requires auth using the 'refreshJwt' (not the 'accessJwt').",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "accessJwt",
                                "refreshJwt",
                                "handle",
                                "did"
                            ],
                            properties: {
                                accessJwt: {
                                    type: "string"
                                },
                                refreshJwt: {
                                    type: "string"
                                },
                                handle: {
                                    type: "string",
                                    format: "handle"
                                },
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                didDoc: {
                                    type: "unknown"
                                },
                                active: {
                                    type: "boolean"
                                },
                                status: {
                                    type: "string",
                                    description: "Hosting status of the account. If not specified, then assume 'active'.",
                                    knownValues: [
                                        "takendown",
                                        "suspended",
                                        "deactivated"
                                    ]
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "AccountTakedown"
                        }
                    ]
                }
            }
        },
        ComAtprotoServerRequestAccountDelete: {
            lexicon: 1,
            id: "com.atproto.server.requestAccountDelete",
            defs: {
                main: {
                    type: "procedure",
                    description: "Initiate a user account deletion via email."
                }
            }
        },
        ComAtprotoServerRequestEmailConfirmation: {
            lexicon: 1,
            id: "com.atproto.server.requestEmailConfirmation",
            defs: {
                main: {
                    type: "procedure",
                    description: "Request an email with a code to confirm ownership of email."
                }
            }
        },
        ComAtprotoServerRequestEmailUpdate: {
            lexicon: 1,
            id: "com.atproto.server.requestEmailUpdate",
            defs: {
                main: {
                    type: "procedure",
                    description: "Request a token in order to update email.",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "tokenRequired"
                            ],
                            properties: {
                                tokenRequired: {
                                    type: "boolean"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerRequestPasswordReset: {
            lexicon: 1,
            id: "com.atproto.server.requestPasswordReset",
            defs: {
                main: {
                    type: "procedure",
                    description: "Initiate a user account password reset via email.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "email"
                            ],
                            properties: {
                                email: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerReserveSigningKey: {
            lexicon: 1,
            id: "com.atproto.server.reserveSigningKey",
            defs: {
                main: {
                    type: "procedure",
                    description: "Reserve a repo signing key, for use with account creation. Necessary so that a DID PLC update operation can be constructed during an account migraiton. Public and does not require auth; implemented by PDS. NOTE: this endpoint may change when full account migration is implemented.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did",
                                    description: "The DID to reserve a key for."
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "signingKey"
                            ],
                            properties: {
                                signingKey: {
                                    type: "string",
                                    description: "The public key for the reserved signing key, in did:key serialization."
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerResetPassword: {
            lexicon: 1,
            id: "com.atproto.server.resetPassword",
            defs: {
                main: {
                    type: "procedure",
                    description: "Reset a user account password using a token.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "token",
                                "password"
                            ],
                            properties: {
                                token: {
                                    type: "string"
                                },
                                password: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "ExpiredToken"
                        },
                        {
                            name: "InvalidToken"
                        }
                    ]
                }
            }
        },
        ComAtprotoServerRevokeAppPassword: {
            lexicon: 1,
            id: "com.atproto.server.revokeAppPassword",
            defs: {
                main: {
                    type: "procedure",
                    description: "Revoke an App Password by name.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "name"
                            ],
                            properties: {
                                name: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoServerUpdateEmail: {
            lexicon: 1,
            id: "com.atproto.server.updateEmail",
            defs: {
                main: {
                    type: "procedure",
                    description: "Update an account's email.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "email"
                            ],
                            properties: {
                                email: {
                                    type: "string"
                                },
                                emailAuthFactor: {
                                    type: "boolean"
                                },
                                token: {
                                    type: "string",
                                    description: "Requires a token from com.atproto.sever.requestEmailUpdate if the account's email has been confirmed."
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "ExpiredToken"
                        },
                        {
                            name: "InvalidToken"
                        },
                        {
                            name: "TokenRequired"
                        }
                    ]
                }
            }
        },
        ComAtprotoSyncGetBlob: {
            lexicon: 1,
            id: "com.atproto.sync.getBlob",
            defs: {
                main: {
                    type: "query",
                    description: "Get a blob associated with a given account. Returns the full blob as originally uploaded. Does not require auth; implemented by PDS.",
                    parameters: {
                        type: "params",
                        required: [
                            "did",
                            "cid"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did",
                                description: "The DID of the account."
                            },
                            cid: {
                                type: "string",
                                format: "cid",
                                description: "The CID of the blob to fetch"
                            }
                        }
                    },
                    output: {
                        encoding: "*/*"
                    },
                    errors: [
                        {
                            name: "BlobNotFound"
                        },
                        {
                            name: "RepoNotFound"
                        },
                        {
                            name: "RepoTakendown"
                        },
                        {
                            name: "RepoSuspended"
                        },
                        {
                            name: "RepoDeactivated"
                        }
                    ]
                }
            }
        },
        ComAtprotoSyncGetBlocks: {
            lexicon: 1,
            id: "com.atproto.sync.getBlocks",
            defs: {
                main: {
                    type: "query",
                    description: "Get data blocks from a given repo, by CID. For example, intermediate MST nodes, or records. Does not require auth; implemented by PDS.",
                    parameters: {
                        type: "params",
                        required: [
                            "did",
                            "cids"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did",
                                description: "The DID of the repo."
                            },
                            cids: {
                                type: "array",
                                items: {
                                    type: "string",
                                    format: "cid"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/vnd.ipld.car"
                    },
                    errors: [
                        {
                            name: "BlockNotFound"
                        },
                        {
                            name: "RepoNotFound"
                        },
                        {
                            name: "RepoTakendown"
                        },
                        {
                            name: "RepoSuspended"
                        },
                        {
                            name: "RepoDeactivated"
                        }
                    ]
                }
            }
        },
        ComAtprotoSyncGetCheckout: {
            lexicon: 1,
            id: "com.atproto.sync.getCheckout",
            defs: {
                main: {
                    type: "query",
                    description: "DEPRECATED - please use com.atproto.sync.getRepo instead",
                    parameters: {
                        type: "params",
                        required: [
                            "did"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did",
                                description: "The DID of the repo."
                            }
                        }
                    },
                    output: {
                        encoding: "application/vnd.ipld.car"
                    }
                }
            }
        },
        ComAtprotoSyncGetHead: {
            lexicon: 1,
            id: "com.atproto.sync.getHead",
            defs: {
                main: {
                    type: "query",
                    description: "DEPRECATED - please use com.atproto.sync.getLatestCommit instead",
                    parameters: {
                        type: "params",
                        required: [
                            "did"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did",
                                description: "The DID of the repo."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "root"
                            ],
                            properties: {
                                root: {
                                    type: "string",
                                    format: "cid"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "HeadNotFound"
                        }
                    ]
                }
            }
        },
        ComAtprotoSyncGetLatestCommit: {
            lexicon: 1,
            id: "com.atproto.sync.getLatestCommit",
            defs: {
                main: {
                    type: "query",
                    description: "Get the current commit CID & revision of the specified repo. Does not require auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "did"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did",
                                description: "The DID of the repo."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "cid",
                                "rev"
                            ],
                            properties: {
                                cid: {
                                    type: "string",
                                    format: "cid"
                                },
                                rev: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "RepoNotFound"
                        },
                        {
                            name: "RepoTakendown"
                        },
                        {
                            name: "RepoSuspended"
                        },
                        {
                            name: "RepoDeactivated"
                        }
                    ]
                }
            }
        },
        ComAtprotoSyncGetRecord: {
            lexicon: 1,
            id: "com.atproto.sync.getRecord",
            defs: {
                main: {
                    type: "query",
                    description: "Get data blocks needed to prove the existence or non-existence of record in the current version of repo. Does not require auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "did",
                            "collection",
                            "rkey"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did",
                                description: "The DID of the repo."
                            },
                            collection: {
                                type: "string",
                                format: "nsid"
                            },
                            rkey: {
                                type: "string",
                                description: "Record Key"
                            },
                            commit: {
                                type: "string",
                                format: "cid",
                                description: "DEPRECATED: referenced a repo commit by CID, and retrieved record as of that commit"
                            }
                        }
                    },
                    output: {
                        encoding: "application/vnd.ipld.car"
                    },
                    errors: [
                        {
                            name: "RecordNotFound"
                        },
                        {
                            name: "RepoNotFound"
                        },
                        {
                            name: "RepoTakendown"
                        },
                        {
                            name: "RepoSuspended"
                        },
                        {
                            name: "RepoDeactivated"
                        }
                    ]
                }
            }
        },
        ComAtprotoSyncGetRepo: {
            lexicon: 1,
            id: "com.atproto.sync.getRepo",
            defs: {
                main: {
                    type: "query",
                    description: "Download a repository export as CAR file. Optionally only a 'diff' since a previous revision. Does not require auth; implemented by PDS.",
                    parameters: {
                        type: "params",
                        required: [
                            "did"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did",
                                description: "The DID of the repo."
                            },
                            since: {
                                type: "string",
                                description: "The revision ('rev') of the repo to create a diff from."
                            }
                        }
                    },
                    output: {
                        encoding: "application/vnd.ipld.car"
                    },
                    errors: [
                        {
                            name: "RepoNotFound"
                        },
                        {
                            name: "RepoTakendown"
                        },
                        {
                            name: "RepoSuspended"
                        },
                        {
                            name: "RepoDeactivated"
                        }
                    ]
                }
            }
        },
        ComAtprotoSyncGetRepoStatus: {
            lexicon: 1,
            id: "com.atproto.sync.getRepoStatus",
            defs: {
                main: {
                    type: "query",
                    description: "Get the hosting status for a repository, on this server. Expected to be implemented by PDS and Relay.",
                    parameters: {
                        type: "params",
                        required: [
                            "did"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did",
                                description: "The DID of the repo."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did",
                                "active"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                active: {
                                    type: "boolean"
                                },
                                status: {
                                    type: "string",
                                    description: "If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.",
                                    knownValues: [
                                        "takendown",
                                        "suspended",
                                        "deactivated"
                                    ]
                                },
                                rev: {
                                    type: "string",
                                    description: "Optional field, the current rev of the repo, if active=true"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "RepoNotFound"
                        }
                    ]
                }
            }
        },
        ComAtprotoSyncListBlobs: {
            lexicon: 1,
            id: "com.atproto.sync.listBlobs",
            defs: {
                main: {
                    type: "query",
                    description: "List blob CIDs for an account, since some repo revision. Does not require auth; implemented by PDS.",
                    parameters: {
                        type: "params",
                        required: [
                            "did"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did",
                                description: "The DID of the repo."
                            },
                            since: {
                                type: "string",
                                description: "Optional revision of the repo to list blobs since."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 1e3,
                                default: 500
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "cids"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                cids: {
                                    type: "array",
                                    items: {
                                        type: "string",
                                        format: "cid"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "RepoNotFound"
                        },
                        {
                            name: "RepoTakendown"
                        },
                        {
                            name: "RepoSuspended"
                        },
                        {
                            name: "RepoDeactivated"
                        }
                    ]
                }
            }
        },
        ComAtprotoSyncListRepos: {
            lexicon: 1,
            id: "com.atproto.sync.listRepos",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates all the DID, rev, and commit CID for all repos hosted by this service. Does not require auth; implemented by PDS and Relay.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 1e3,
                                default: 500
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "repos"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                repos: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.sync.listRepos#repo"
                                    }
                                }
                            }
                        }
                    }
                },
                repo: {
                    type: "object",
                    required: [
                        "did",
                        "head",
                        "rev"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        head: {
                            type: "string",
                            format: "cid",
                            description: "Current repo commit CID"
                        },
                        rev: {
                            type: "string"
                        },
                        active: {
                            type: "boolean"
                        },
                        status: {
                            type: "string",
                            description: "If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.",
                            knownValues: [
                                "takendown",
                                "suspended",
                                "deactivated"
                            ]
                        }
                    }
                }
            }
        },
        ComAtprotoSyncNotifyOfUpdate: {
            lexicon: 1,
            id: "com.atproto.sync.notifyOfUpdate",
            defs: {
                main: {
                    type: "procedure",
                    description: "Notify a crawling service of a recent update, and that crawling should resume. Intended use is after a gap between repo stream events caused the crawling service to disconnect. Does not require auth; implemented by Relay.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "hostname"
                            ],
                            properties: {
                                hostname: {
                                    type: "string",
                                    description: "Hostname of the current service (usually a PDS) that is notifying of update."
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoSyncRequestCrawl: {
            lexicon: 1,
            id: "com.atproto.sync.requestCrawl",
            defs: {
                main: {
                    type: "procedure",
                    description: "Request a service to persistently crawl hosted repos. Expected use is new PDS instances declaring their existence to Relays. Does not require auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "hostname"
                            ],
                            properties: {
                                hostname: {
                                    type: "string",
                                    description: "Hostname of the current service (eg, PDS) that is requesting to be crawled."
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoSyncSubscribeRepos: {
            lexicon: 1,
            id: "com.atproto.sync.subscribeRepos",
            defs: {
                main: {
                    type: "subscription",
                    description: "Repository event stream, aka Firehose endpoint. Outputs repo commits with diff data, and identity update events, for all repositories on the current server. See the atproto specifications for details around stream sequencing, repo versioning, CAR diff format, and more. Public and does not require auth; implemented by PDS and Relay.",
                    parameters: {
                        type: "params",
                        properties: {
                            cursor: {
                                type: "integer",
                                description: "The last known event seq number to backfill from."
                            }
                        }
                    },
                    message: {
                        schema: {
                            type: "union",
                            refs: [
                                "lex:com.atproto.sync.subscribeRepos#commit",
                                "lex:com.atproto.sync.subscribeRepos#identity",
                                "lex:com.atproto.sync.subscribeRepos#account",
                                "lex:com.atproto.sync.subscribeRepos#handle",
                                "lex:com.atproto.sync.subscribeRepos#migrate",
                                "lex:com.atproto.sync.subscribeRepos#tombstone",
                                "lex:com.atproto.sync.subscribeRepos#info"
                            ]
                        }
                    },
                    errors: [
                        {
                            name: "FutureCursor"
                        },
                        {
                            name: "ConsumerTooSlow",
                            description: "If the consumer of the stream can not keep up with events, and a backlog gets too large, the server will drop the connection."
                        }
                    ]
                },
                commit: {
                    type: "object",
                    description: "Represents an update of repository state. Note that empty commits are allowed, which include no repo data changes, but an update to rev and signature.",
                    required: [
                        "seq",
                        "rebase",
                        "tooBig",
                        "repo",
                        "commit",
                        "rev",
                        "since",
                        "blocks",
                        "ops",
                        "blobs",
                        "time"
                    ],
                    nullable: [
                        "prev",
                        "since"
                    ],
                    properties: {
                        seq: {
                            type: "integer",
                            description: "The stream sequence number of this message."
                        },
                        rebase: {
                            type: "boolean",
                            description: "DEPRECATED -- unused"
                        },
                        tooBig: {
                            type: "boolean",
                            description: "Indicates that this commit contained too many ops, or data size was too large. Consumers will need to make a separate request to get missing data."
                        },
                        repo: {
                            type: "string",
                            format: "did",
                            description: "The repo this event comes from."
                        },
                        commit: {
                            type: "cid-link",
                            description: "Repo commit object CID."
                        },
                        prev: {
                            type: "cid-link",
                            description: "DEPRECATED -- unused. WARNING -- nullable and optional; stick with optional to ensure golang interoperability."
                        },
                        rev: {
                            type: "string",
                            description: "The rev of the emitted commit. Note that this information is also in the commit object included in blocks, unless this is a tooBig event."
                        },
                        since: {
                            type: "string",
                            description: "The rev of the last emitted commit from this repo (if any)."
                        },
                        blocks: {
                            type: "bytes",
                            description: "CAR file containing relevant blocks, as a diff since the previous repo state.",
                            maxLength: 1e6
                        },
                        ops: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.sync.subscribeRepos#repoOp",
                                description: "List of repo mutation operations in this commit (eg, records created, updated, or deleted)."
                            },
                            maxLength: 200
                        },
                        blobs: {
                            type: "array",
                            items: {
                                type: "cid-link",
                                description: "List of new blobs (by CID) referenced by records in this commit."
                            }
                        },
                        time: {
                            type: "string",
                            format: "datetime",
                            description: "Timestamp of when this message was originally broadcast."
                        }
                    }
                },
                identity: {
                    type: "object",
                    description: "Represents a change to an account's identity. Could be an updated handle, signing key, or pds hosting endpoint. Serves as a prod to all downstream services to refresh their identity cache.",
                    required: [
                        "seq",
                        "did",
                        "time"
                    ],
                    properties: {
                        seq: {
                            type: "integer"
                        },
                        did: {
                            type: "string",
                            format: "did"
                        },
                        time: {
                            type: "string",
                            format: "datetime"
                        },
                        handle: {
                            type: "string",
                            format: "handle",
                            description: "The current handle for the account, or 'handle.invalid' if validation fails. This field is optional, might have been validated or passed-through from an upstream source. Semantics and behaviors for PDS vs Relay may evolve in the future; see atproto specs for more details."
                        }
                    }
                },
                account: {
                    type: "object",
                    description: "Represents a change to an account's status on a host (eg, PDS or Relay). The semantics of this event are that the status is at the host which emitted the event, not necessarily that at the currently active PDS. Eg, a Relay takedown would emit a takedown with active=false, even if the PDS is still active.",
                    required: [
                        "seq",
                        "did",
                        "time",
                        "active"
                    ],
                    properties: {
                        seq: {
                            type: "integer"
                        },
                        did: {
                            type: "string",
                            format: "did"
                        },
                        time: {
                            type: "string",
                            format: "datetime"
                        },
                        active: {
                            type: "boolean",
                            description: "Indicates that the account has a repository which can be fetched from the host that emitted this event."
                        },
                        status: {
                            type: "string",
                            description: "If active=false, this optional field indicates a reason for why the account is not active.",
                            knownValues: [
                                "takendown",
                                "suspended",
                                "deleted",
                                "deactivated"
                            ]
                        }
                    }
                },
                handle: {
                    type: "object",
                    description: "DEPRECATED -- Use #identity event instead",
                    required: [
                        "seq",
                        "did",
                        "handle",
                        "time"
                    ],
                    properties: {
                        seq: {
                            type: "integer"
                        },
                        did: {
                            type: "string",
                            format: "did"
                        },
                        handle: {
                            type: "string",
                            format: "handle"
                        },
                        time: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                migrate: {
                    type: "object",
                    description: "DEPRECATED -- Use #account event instead",
                    required: [
                        "seq",
                        "did",
                        "migrateTo",
                        "time"
                    ],
                    nullable: [
                        "migrateTo"
                    ],
                    properties: {
                        seq: {
                            type: "integer"
                        },
                        did: {
                            type: "string",
                            format: "did"
                        },
                        migrateTo: {
                            type: "string"
                        },
                        time: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                tombstone: {
                    type: "object",
                    description: "DEPRECATED -- Use #account event instead",
                    required: [
                        "seq",
                        "did",
                        "time"
                    ],
                    properties: {
                        seq: {
                            type: "integer"
                        },
                        did: {
                            type: "string",
                            format: "did"
                        },
                        time: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                info: {
                    type: "object",
                    required: [
                        "name"
                    ],
                    properties: {
                        name: {
                            type: "string",
                            knownValues: [
                                "OutdatedCursor"
                            ]
                        },
                        message: {
                            type: "string"
                        }
                    }
                },
                repoOp: {
                    type: "object",
                    description: "A repo operation, ie a mutation of a single record.",
                    required: [
                        "action",
                        "path",
                        "cid"
                    ],
                    nullable: [
                        "cid"
                    ],
                    properties: {
                        action: {
                            type: "string",
                            knownValues: [
                                "create",
                                "update",
                                "delete"
                            ]
                        },
                        path: {
                            type: "string"
                        },
                        cid: {
                            type: "cid-link",
                            description: "For creates and updates, the new record CID. For deletions, null."
                        }
                    }
                }
            }
        },
        ComAtprotoTempCheckSignupQueue: {
            lexicon: 1,
            id: "com.atproto.temp.checkSignupQueue",
            defs: {
                main: {
                    type: "query",
                    description: "Check accounts location in signup queue.",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "activated"
                            ],
                            properties: {
                                activated: {
                                    type: "boolean"
                                },
                                placeInQueue: {
                                    type: "integer"
                                },
                                estimatedTimeMs: {
                                    type: "integer"
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoTempFetchLabels: {
            lexicon: 1,
            id: "com.atproto.temp.fetchLabels",
            defs: {
                main: {
                    type: "query",
                    description: "DEPRECATED: use queryLabels or subscribeLabels instead -- Fetch all labels from a labeler created after a certain date.",
                    parameters: {
                        type: "params",
                        properties: {
                            since: {
                                type: "integer"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 250,
                                default: 50
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "labels"
                            ],
                            properties: {
                                labels: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:com.atproto.label.defs#label"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ComAtprotoTempRequestPhoneVerification: {
            lexicon: 1,
            id: "com.atproto.temp.requestPhoneVerification",
            defs: {
                main: {
                    type: "procedure",
                    description: "Request a verification code to be sent to the supplied phone number",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "phoneNumber"
                            ],
                            properties: {
                                phoneNumber: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyActorDefs: {
            lexicon: 1,
            id: "app.bsky.actor.defs",
            defs: {
                profileViewBasic: {
                    type: "object",
                    required: [
                        "did",
                        "handle"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        handle: {
                            type: "string",
                            format: "handle"
                        },
                        displayName: {
                            type: "string",
                            maxGraphemes: 64,
                            maxLength: 640
                        },
                        avatar: {
                            type: "string",
                            format: "uri"
                        },
                        associated: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileAssociated"
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#viewerState"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                profileView: {
                    type: "object",
                    required: [
                        "did",
                        "handle"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        handle: {
                            type: "string",
                            format: "handle"
                        },
                        displayName: {
                            type: "string",
                            maxGraphemes: 64,
                            maxLength: 640
                        },
                        description: {
                            type: "string",
                            maxGraphemes: 256,
                            maxLength: 2560
                        },
                        avatar: {
                            type: "string",
                            format: "uri"
                        },
                        associated: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileAssociated"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#viewerState"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        }
                    }
                },
                profileViewDetailed: {
                    type: "object",
                    required: [
                        "did",
                        "handle"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        handle: {
                            type: "string",
                            format: "handle"
                        },
                        displayName: {
                            type: "string",
                            maxGraphemes: 64,
                            maxLength: 640
                        },
                        description: {
                            type: "string",
                            maxGraphemes: 256,
                            maxLength: 2560
                        },
                        avatar: {
                            type: "string",
                            format: "uri"
                        },
                        banner: {
                            type: "string",
                            format: "uri"
                        },
                        followersCount: {
                            type: "integer"
                        },
                        followsCount: {
                            type: "integer"
                        },
                        postsCount: {
                            type: "integer"
                        },
                        associated: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileAssociated"
                        },
                        joinedViaStarterPack: {
                            type: "ref",
                            ref: "lex:app.bsky.graph.defs#starterPackViewBasic"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#viewerState"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        }
                    }
                },
                profileAssociated: {
                    type: "object",
                    properties: {
                        lists: {
                            type: "integer"
                        },
                        feedgens: {
                            type: "integer"
                        },
                        starterPacks: {
                            type: "integer"
                        },
                        labeler: {
                            type: "boolean"
                        },
                        chat: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileAssociatedChat"
                        }
                    }
                },
                profileAssociatedChat: {
                    type: "object",
                    required: [
                        "allowIncoming"
                    ],
                    properties: {
                        allowIncoming: {
                            type: "string",
                            knownValues: [
                                "all",
                                "none",
                                "following"
                            ]
                        }
                    }
                },
                viewerState: {
                    type: "object",
                    description: "Metadata about the requesting account's relationship with the subject account. Only has meaningful content for authed requests.",
                    properties: {
                        muted: {
                            type: "boolean"
                        },
                        mutedByList: {
                            type: "ref",
                            ref: "lex:app.bsky.graph.defs#listViewBasic"
                        },
                        blockedBy: {
                            type: "boolean"
                        },
                        blocking: {
                            type: "string",
                            format: "at-uri"
                        },
                        blockingByList: {
                            type: "ref",
                            ref: "lex:app.bsky.graph.defs#listViewBasic"
                        },
                        following: {
                            type: "string",
                            format: "at-uri"
                        },
                        followedBy: {
                            type: "string",
                            format: "at-uri"
                        },
                        knownFollowers: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#knownFollowers"
                        }
                    }
                },
                knownFollowers: {
                    type: "object",
                    description: "The subject's followers whom you also follow",
                    required: [
                        "count",
                        "followers"
                    ],
                    properties: {
                        count: {
                            type: "integer"
                        },
                        followers: {
                            type: "array",
                            minLength: 0,
                            maxLength: 5,
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.actor.defs#profileViewBasic"
                            }
                        }
                    }
                },
                preferences: {
                    type: "array",
                    items: {
                        type: "union",
                        refs: [
                            "lex:app.bsky.actor.defs#adultContentPref",
                            "lex:app.bsky.actor.defs#contentLabelPref",
                            "lex:app.bsky.actor.defs#savedFeedsPref",
                            "lex:app.bsky.actor.defs#savedFeedsPrefV2",
                            "lex:app.bsky.actor.defs#personalDetailsPref",
                            "lex:app.bsky.actor.defs#feedViewPref",
                            "lex:app.bsky.actor.defs#threadViewPref",
                            "lex:app.bsky.actor.defs#interestsPref",
                            "lex:app.bsky.actor.defs#mutedWordsPref",
                            "lex:app.bsky.actor.defs#hiddenPostsPref",
                            "lex:app.bsky.actor.defs#bskyAppStatePref",
                            "lex:app.bsky.actor.defs#labelersPref"
                        ]
                    }
                },
                adultContentPref: {
                    type: "object",
                    required: [
                        "enabled"
                    ],
                    properties: {
                        enabled: {
                            type: "boolean",
                            default: !1
                        }
                    }
                },
                contentLabelPref: {
                    type: "object",
                    required: [
                        "label",
                        "visibility"
                    ],
                    properties: {
                        labelerDid: {
                            type: "string",
                            description: "Which labeler does this preference apply to? If undefined, applies globally.",
                            format: "did"
                        },
                        label: {
                            type: "string"
                        },
                        visibility: {
                            type: "string",
                            knownValues: [
                                "ignore",
                                "show",
                                "warn",
                                "hide"
                            ]
                        }
                    }
                },
                savedFeed: {
                    type: "object",
                    required: [
                        "id",
                        "type",
                        "value",
                        "pinned"
                    ],
                    properties: {
                        id: {
                            type: "string"
                        },
                        type: {
                            type: "string",
                            knownValues: [
                                "feed",
                                "list",
                                "timeline"
                            ]
                        },
                        value: {
                            type: "string"
                        },
                        pinned: {
                            type: "boolean"
                        }
                    }
                },
                savedFeedsPrefV2: {
                    type: "object",
                    required: [
                        "items"
                    ],
                    properties: {
                        items: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.actor.defs#savedFeed"
                            }
                        }
                    }
                },
                savedFeedsPref: {
                    type: "object",
                    required: [
                        "pinned",
                        "saved"
                    ],
                    properties: {
                        pinned: {
                            type: "array",
                            items: {
                                type: "string",
                                format: "at-uri"
                            }
                        },
                        saved: {
                            type: "array",
                            items: {
                                type: "string",
                                format: "at-uri"
                            }
                        },
                        timelineIndex: {
                            type: "integer"
                        }
                    }
                },
                personalDetailsPref: {
                    type: "object",
                    properties: {
                        birthDate: {
                            type: "string",
                            format: "datetime",
                            description: "The birth date of account owner."
                        }
                    }
                },
                feedViewPref: {
                    type: "object",
                    required: [
                        "feed"
                    ],
                    properties: {
                        feed: {
                            type: "string",
                            description: "The URI of the feed, or an identifier which describes the feed."
                        },
                        hideReplies: {
                            type: "boolean",
                            description: "Hide replies in the feed."
                        },
                        hideRepliesByUnfollowed: {
                            type: "boolean",
                            description: "Hide replies in the feed if they are not by followed users.",
                            default: !0
                        },
                        hideRepliesByLikeCount: {
                            type: "integer",
                            description: "Hide replies in the feed if they do not have this number of likes."
                        },
                        hideReposts: {
                            type: "boolean",
                            description: "Hide reposts in the feed."
                        },
                        hideQuotePosts: {
                            type: "boolean",
                            description: "Hide quote posts in the feed."
                        }
                    }
                },
                threadViewPref: {
                    type: "object",
                    properties: {
                        sort: {
                            type: "string",
                            description: "Sorting mode for threads.",
                            knownValues: [
                                "oldest",
                                "newest",
                                "most-likes",
                                "random"
                            ]
                        },
                        prioritizeFollowedUsers: {
                            type: "boolean",
                            description: "Show followed users at the top of all replies."
                        }
                    }
                },
                interestsPref: {
                    type: "object",
                    required: [
                        "tags"
                    ],
                    properties: {
                        tags: {
                            type: "array",
                            maxLength: 100,
                            items: {
                                type: "string",
                                maxLength: 640,
                                maxGraphemes: 64
                            },
                            description: "A list of tags which describe the account owner's interests gathered during onboarding."
                        }
                    }
                },
                mutedWordTarget: {
                    type: "string",
                    knownValues: [
                        "content",
                        "tag"
                    ],
                    maxLength: 640,
                    maxGraphemes: 64
                },
                mutedWord: {
                    type: "object",
                    description: "A word that the account owner has muted.",
                    required: [
                        "value",
                        "targets"
                    ],
                    properties: {
                        id: {
                            type: "string"
                        },
                        value: {
                            type: "string",
                            description: "The muted word itself.",
                            maxLength: 1e4,
                            maxGraphemes: 1e3
                        },
                        targets: {
                            type: "array",
                            description: "The intended targets of the muted word.",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.actor.defs#mutedWordTarget"
                            }
                        },
                        actorTarget: {
                            type: "string",
                            description: "Groups of users to apply the muted word to. If undefined, applies to all users.",
                            knownValues: [
                                "all",
                                "exclude-following"
                            ],
                            default: "all"
                        },
                        expiresAt: {
                            type: "string",
                            format: "datetime",
                            description: "The date and time at which the muted word will expire and no longer be applied."
                        }
                    }
                },
                mutedWordsPref: {
                    type: "object",
                    required: [
                        "items"
                    ],
                    properties: {
                        items: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.actor.defs#mutedWord"
                            },
                            description: "A list of words the account owner has muted."
                        }
                    }
                },
                hiddenPostsPref: {
                    type: "object",
                    required: [
                        "items"
                    ],
                    properties: {
                        items: {
                            type: "array",
                            items: {
                                type: "string",
                                format: "at-uri"
                            },
                            description: "A list of URIs of posts the account owner has hidden."
                        }
                    }
                },
                labelersPref: {
                    type: "object",
                    required: [
                        "labelers"
                    ],
                    properties: {
                        labelers: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.actor.defs#labelerPrefItem"
                            }
                        }
                    }
                },
                labelerPrefItem: {
                    type: "object",
                    required: [
                        "did"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        }
                    }
                },
                bskyAppStatePref: {
                    description: "A grab bag of state that's specific to the bsky.app program. Third-party apps shouldn't use this.",
                    type: "object",
                    properties: {
                        activeProgressGuide: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#bskyAppProgressGuide"
                        },
                        queuedNudges: {
                            description: "An array of tokens which identify nudges (modals, popups, tours, highlight dots) that should be shown to the user.",
                            type: "array",
                            maxLength: 1e3,
                            items: {
                                type: "string",
                                maxLength: 100
                            }
                        }
                    }
                },
                bskyAppProgressGuide: {
                    description: "If set, an active progress guide. Once completed, can be set to undefined. Should have unspecced fields tracking progress.",
                    type: "object",
                    required: [
                        "guide"
                    ],
                    properties: {
                        guide: {
                            type: "string",
                            maxLength: 100
                        }
                    }
                }
            }
        },
        AppBskyActorGetPreferences: {
            lexicon: 1,
            id: "app.bsky.actor.getPreferences",
            defs: {
                main: {
                    type: "query",
                    description: "Get private preferences attached to the current account. Expected use is synchronization between multiple devices, and import/export during account migration. Requires auth.",
                    parameters: {
                        type: "params",
                        properties: {}
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "preferences"
                            ],
                            properties: {
                                preferences: {
                                    type: "ref",
                                    ref: "lex:app.bsky.actor.defs#preferences"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyActorGetProfile: {
            lexicon: 1,
            id: "app.bsky.actor.getProfile",
            defs: {
                main: {
                    type: "query",
                    description: "Get detailed profile view of an actor. Does not require auth, but contains relevant metadata with auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier",
                                description: "Handle or DID of account to fetch profile of."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileViewDetailed"
                        }
                    }
                }
            }
        },
        AppBskyActorGetProfiles: {
            lexicon: 1,
            id: "app.bsky.actor.getProfiles",
            defs: {
                main: {
                    type: "query",
                    description: "Get detailed profile views of multiple actors.",
                    parameters: {
                        type: "params",
                        required: [
                            "actors"
                        ],
                        properties: {
                            actors: {
                                type: "array",
                                items: {
                                    type: "string",
                                    format: "at-identifier"
                                },
                                maxLength: 25
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "profiles"
                            ],
                            properties: {
                                profiles: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileViewDetailed"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyActorGetSuggestions: {
            lexicon: 1,
            id: "app.bsky.actor.getSuggestions",
            defs: {
                main: {
                    type: "query",
                    description: "Get a list of suggested actors. Expected use is discovery of accounts to follow during new account onboarding.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "actors"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                actors: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyActorProfile: {
            lexicon: 1,
            id: "app.bsky.actor.profile",
            defs: {
                main: {
                    type: "record",
                    description: "A declaration of a Bluesky account profile.",
                    key: "literal:self",
                    record: {
                        type: "object",
                        properties: {
                            displayName: {
                                type: "string",
                                maxGraphemes: 64,
                                maxLength: 640
                            },
                            description: {
                                type: "string",
                                description: "Free-form profile description text.",
                                maxGraphemes: 256,
                                maxLength: 2560
                            },
                            avatar: {
                                type: "blob",
                                description: "Small image to be displayed next to posts from account. AKA, 'profile picture'",
                                accept: [
                                    "image/png",
                                    "image/jpeg"
                                ],
                                maxSize: 1e6
                            },
                            banner: {
                                type: "blob",
                                description: "Larger horizontal image to display behind profile view.",
                                accept: [
                                    "image/png",
                                    "image/jpeg"
                                ],
                                maxSize: 1e6
                            },
                            labels: {
                                type: "union",
                                description: "Self-label values, specific to the Bluesky application, on the overall account.",
                                refs: [
                                    "lex:com.atproto.label.defs#selfLabels"
                                ]
                            },
                            joinedViaStarterPack: {
                                type: "ref",
                                ref: "lex:com.atproto.repo.strongRef"
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyActorPutPreferences: {
            lexicon: 1,
            id: "app.bsky.actor.putPreferences",
            defs: {
                main: {
                    type: "procedure",
                    description: "Set the private preferences attached to the account.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "preferences"
                            ],
                            properties: {
                                preferences: {
                                    type: "ref",
                                    ref: "lex:app.bsky.actor.defs#preferences"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyActorSearchActors: {
            lexicon: 1,
            id: "app.bsky.actor.searchActors",
            defs: {
                main: {
                    type: "query",
                    description: "Find actors (profiles) matching search criteria. Does not require auth.",
                    parameters: {
                        type: "params",
                        properties: {
                            term: {
                                type: "string",
                                description: "DEPRECATED: use 'q' instead."
                            },
                            q: {
                                type: "string",
                                description: "Search query string. Syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 25
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "actors"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                actors: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyActorSearchActorsTypeahead: {
            lexicon: 1,
            id: "app.bsky.actor.searchActorsTypeahead",
            defs: {
                main: {
                    type: "query",
                    description: "Find actor suggestions for a prefix search term. Expected use is for auto-completion during text field entry. Does not require auth.",
                    parameters: {
                        type: "params",
                        properties: {
                            term: {
                                type: "string",
                                description: "DEPRECATED: use 'q' instead."
                            },
                            q: {
                                type: "string",
                                description: "Search query prefix; not a full query string."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 10
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "actors"
                            ],
                            properties: {
                                actors: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileViewBasic"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyEmbedExternal: {
            lexicon: 1,
            id: "app.bsky.embed.external",
            defs: {
                main: {
                    type: "object",
                    description: "A representation of some externally linked content (eg, a URL and 'card'), embedded in a Bluesky record (eg, a post).",
                    required: [
                        "external"
                    ],
                    properties: {
                        external: {
                            type: "ref",
                            ref: "lex:app.bsky.embed.external#external"
                        }
                    }
                },
                external: {
                    type: "object",
                    required: [
                        "uri",
                        "title",
                        "description"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "uri"
                        },
                        title: {
                            type: "string"
                        },
                        description: {
                            type: "string"
                        },
                        thumb: {
                            type: "blob",
                            accept: [
                                "image/*"
                            ],
                            maxSize: 1e6
                        }
                    }
                },
                view: {
                    type: "object",
                    required: [
                        "external"
                    ],
                    properties: {
                        external: {
                            type: "ref",
                            ref: "lex:app.bsky.embed.external#viewExternal"
                        }
                    }
                },
                viewExternal: {
                    type: "object",
                    required: [
                        "uri",
                        "title",
                        "description"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "uri"
                        },
                        title: {
                            type: "string"
                        },
                        description: {
                            type: "string"
                        },
                        thumb: {
                            type: "string",
                            format: "uri"
                        }
                    }
                }
            }
        },
        AppBskyEmbedImages: {
            lexicon: 1,
            id: "app.bsky.embed.images",
            description: "A set of images embedded in a Bluesky record (eg, a post).",
            defs: {
                main: {
                    type: "object",
                    required: [
                        "images"
                    ],
                    properties: {
                        images: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.embed.images#image"
                            },
                            maxLength: 4
                        }
                    }
                },
                image: {
                    type: "object",
                    required: [
                        "image",
                        "alt"
                    ],
                    properties: {
                        image: {
                            type: "blob",
                            accept: [
                                "image/*"
                            ],
                            maxSize: 1e6
                        },
                        alt: {
                            type: "string",
                            description: "Alt text description of the image, for accessibility."
                        },
                        aspectRatio: {
                            type: "ref",
                            ref: "lex:app.bsky.embed.images#aspectRatio"
                        }
                    }
                },
                aspectRatio: {
                    type: "object",
                    description: "width:height represents an aspect ratio. It may be approximate, and may not correspond to absolute dimensions in any given unit.",
                    required: [
                        "width",
                        "height"
                    ],
                    properties: {
                        width: {
                            type: "integer",
                            minimum: 1
                        },
                        height: {
                            type: "integer",
                            minimum: 1
                        }
                    }
                },
                view: {
                    type: "object",
                    required: [
                        "images"
                    ],
                    properties: {
                        images: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.embed.images#viewImage"
                            },
                            maxLength: 4
                        }
                    }
                },
                viewImage: {
                    type: "object",
                    required: [
                        "thumb",
                        "fullsize",
                        "alt"
                    ],
                    properties: {
                        thumb: {
                            type: "string",
                            format: "uri",
                            description: "Fully-qualified URL where a thumbnail of the image can be fetched. For example, CDN location provided by the App View."
                        },
                        fullsize: {
                            type: "string",
                            format: "uri",
                            description: "Fully-qualified URL where a large version of the image can be fetched. May or may not be the exact original blob. For example, CDN location provided by the App View."
                        },
                        alt: {
                            type: "string",
                            description: "Alt text description of the image, for accessibility."
                        },
                        aspectRatio: {
                            type: "ref",
                            ref: "lex:app.bsky.embed.images#aspectRatio"
                        }
                    }
                }
            }
        },
        AppBskyEmbedRecord: {
            lexicon: 1,
            id: "app.bsky.embed.record",
            description: "A representation of a record embedded in a Bluesky record (eg, a post). For example, a quote-post, or sharing a feed generator record.",
            defs: {
                main: {
                    type: "object",
                    required: [
                        "record"
                    ],
                    properties: {
                        record: {
                            type: "ref",
                            ref: "lex:com.atproto.repo.strongRef"
                        }
                    }
                },
                view: {
                    type: "object",
                    required: [
                        "record"
                    ],
                    properties: {
                        record: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.embed.record#viewRecord",
                                "lex:app.bsky.embed.record#viewNotFound",
                                "lex:app.bsky.embed.record#viewBlocked",
                                "lex:app.bsky.feed.defs#generatorView",
                                "lex:app.bsky.graph.defs#listView",
                                "lex:app.bsky.labeler.defs#labelerView",
                                "lex:app.bsky.graph.defs#starterPackViewBasic"
                            ]
                        }
                    }
                },
                viewRecord: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "author",
                        "value",
                        "indexedAt"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        author: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileViewBasic"
                        },
                        value: {
                            type: "unknown",
                            description: "The record data itself."
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        replyCount: {
                            type: "integer"
                        },
                        repostCount: {
                            type: "integer"
                        },
                        likeCount: {
                            type: "integer"
                        },
                        embeds: {
                            type: "array",
                            items: {
                                type: "union",
                                refs: [
                                    "lex:app.bsky.embed.images#view",
                                    "lex:app.bsky.embed.external#view",
                                    "lex:app.bsky.embed.record#view",
                                    "lex:app.bsky.embed.recordWithMedia#view"
                                ]
                            }
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                viewNotFound: {
                    type: "object",
                    required: [
                        "uri",
                        "notFound"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        notFound: {
                            type: "boolean",
                            const: !0
                        }
                    }
                },
                viewBlocked: {
                    type: "object",
                    required: [
                        "uri",
                        "blocked",
                        "author"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        blocked: {
                            type: "boolean",
                            const: !0
                        },
                        author: {
                            type: "ref",
                            ref: "lex:app.bsky.feed.defs#blockedAuthor"
                        }
                    }
                }
            }
        },
        AppBskyEmbedRecordWithMedia: {
            lexicon: 1,
            id: "app.bsky.embed.recordWithMedia",
            description: "A representation of a record embedded in a Bluesky record (eg, a post), alongside other compatible embeds. For example, a quote post and image, or a quote post and external URL card.",
            defs: {
                main: {
                    type: "object",
                    required: [
                        "record",
                        "media"
                    ],
                    properties: {
                        record: {
                            type: "ref",
                            ref: "lex:app.bsky.embed.record"
                        },
                        media: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.embed.images",
                                "lex:app.bsky.embed.external"
                            ]
                        }
                    }
                },
                view: {
                    type: "object",
                    required: [
                        "record",
                        "media"
                    ],
                    properties: {
                        record: {
                            type: "ref",
                            ref: "lex:app.bsky.embed.record#view"
                        },
                        media: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.embed.images#view",
                                "lex:app.bsky.embed.external#view"
                            ]
                        }
                    }
                }
            }
        },
        AppBskyFeedDefs: {
            lexicon: 1,
            id: "app.bsky.feed.defs",
            defs: {
                postView: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "author",
                        "record",
                        "indexedAt"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        author: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileViewBasic"
                        },
                        record: {
                            type: "unknown"
                        },
                        embed: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.embed.images#view",
                                "lex:app.bsky.embed.external#view",
                                "lex:app.bsky.embed.record#view",
                                "lex:app.bsky.embed.recordWithMedia#view"
                            ]
                        },
                        replyCount: {
                            type: "integer"
                        },
                        repostCount: {
                            type: "integer"
                        },
                        likeCount: {
                            type: "integer"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.feed.defs#viewerState"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        threadgate: {
                            type: "ref",
                            ref: "lex:app.bsky.feed.defs#threadgateView"
                        }
                    }
                },
                viewerState: {
                    type: "object",
                    description: "Metadata about the requesting account's relationship with the subject content. Only has meaningful content for authed requests.",
                    properties: {
                        repost: {
                            type: "string",
                            format: "at-uri"
                        },
                        like: {
                            type: "string",
                            format: "at-uri"
                        },
                        threadMuted: {
                            type: "boolean"
                        },
                        replyDisabled: {
                            type: "boolean"
                        }
                    }
                },
                feedViewPost: {
                    type: "object",
                    required: [
                        "post"
                    ],
                    properties: {
                        post: {
                            type: "ref",
                            ref: "lex:app.bsky.feed.defs#postView"
                        },
                        reply: {
                            type: "ref",
                            ref: "lex:app.bsky.feed.defs#replyRef"
                        },
                        reason: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.feed.defs#reasonRepost"
                            ]
                        },
                        feedContext: {
                            type: "string",
                            description: "Context provided by feed generator that may be passed back alongside interactions.",
                            maxLength: 2e3
                        }
                    }
                },
                replyRef: {
                    type: "object",
                    required: [
                        "root",
                        "parent"
                    ],
                    properties: {
                        root: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.feed.defs#postView",
                                "lex:app.bsky.feed.defs#notFoundPost",
                                "lex:app.bsky.feed.defs#blockedPost"
                            ]
                        },
                        parent: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.feed.defs#postView",
                                "lex:app.bsky.feed.defs#notFoundPost",
                                "lex:app.bsky.feed.defs#blockedPost"
                            ]
                        },
                        grandparentAuthor: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileViewBasic",
                            description: "When parent is a reply to another post, this is the author of that post."
                        }
                    }
                },
                reasonRepost: {
                    type: "object",
                    required: [
                        "by",
                        "indexedAt"
                    ],
                    properties: {
                        by: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileViewBasic"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                threadViewPost: {
                    type: "object",
                    required: [
                        "post"
                    ],
                    properties: {
                        post: {
                            type: "ref",
                            ref: "lex:app.bsky.feed.defs#postView"
                        },
                        parent: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.feed.defs#threadViewPost",
                                "lex:app.bsky.feed.defs#notFoundPost",
                                "lex:app.bsky.feed.defs#blockedPost"
                            ]
                        },
                        replies: {
                            type: "array",
                            items: {
                                type: "union",
                                refs: [
                                    "lex:app.bsky.feed.defs#threadViewPost",
                                    "lex:app.bsky.feed.defs#notFoundPost",
                                    "lex:app.bsky.feed.defs#blockedPost"
                                ]
                            }
                        }
                    }
                },
                notFoundPost: {
                    type: "object",
                    required: [
                        "uri",
                        "notFound"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        notFound: {
                            type: "boolean",
                            const: !0
                        }
                    }
                },
                blockedPost: {
                    type: "object",
                    required: [
                        "uri",
                        "blocked",
                        "author"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        blocked: {
                            type: "boolean",
                            const: !0
                        },
                        author: {
                            type: "ref",
                            ref: "lex:app.bsky.feed.defs#blockedAuthor"
                        }
                    }
                },
                blockedAuthor: {
                    type: "object",
                    required: [
                        "did"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#viewerState"
                        }
                    }
                },
                generatorView: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "did",
                        "creator",
                        "displayName",
                        "indexedAt"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        did: {
                            type: "string",
                            format: "did"
                        },
                        creator: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileView"
                        },
                        displayName: {
                            type: "string"
                        },
                        description: {
                            type: "string",
                            maxGraphemes: 300,
                            maxLength: 3e3
                        },
                        descriptionFacets: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.richtext.facet"
                            }
                        },
                        avatar: {
                            type: "string",
                            format: "uri"
                        },
                        likeCount: {
                            type: "integer",
                            minimum: 0
                        },
                        acceptsInteractions: {
                            type: "boolean"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.feed.defs#generatorViewerState"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                generatorViewerState: {
                    type: "object",
                    properties: {
                        like: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                },
                skeletonFeedPost: {
                    type: "object",
                    required: [
                        "post"
                    ],
                    properties: {
                        post: {
                            type: "string",
                            format: "at-uri"
                        },
                        reason: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.feed.defs#skeletonReasonRepost"
                            ]
                        },
                        feedContext: {
                            type: "string",
                            description: "Context that will be passed through to client and may be passed to feed generator back alongside interactions.",
                            maxLength: 2e3
                        }
                    }
                },
                skeletonReasonRepost: {
                    type: "object",
                    required: [
                        "repost"
                    ],
                    properties: {
                        repost: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                },
                threadgateView: {
                    type: "object",
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        record: {
                            type: "unknown"
                        },
                        lists: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.graph.defs#listViewBasic"
                            }
                        }
                    }
                },
                interaction: {
                    type: "object",
                    properties: {
                        item: {
                            type: "string",
                            format: "at-uri"
                        },
                        event: {
                            type: "string",
                            knownValues: [
                                "app.bsky.feed.defs#requestLess",
                                "app.bsky.feed.defs#requestMore",
                                "app.bsky.feed.defs#clickthroughItem",
                                "app.bsky.feed.defs#clickthroughAuthor",
                                "app.bsky.feed.defs#clickthroughReposter",
                                "app.bsky.feed.defs#clickthroughEmbed",
                                "app.bsky.feed.defs#interactionSeen",
                                "app.bsky.feed.defs#interactionLike",
                                "app.bsky.feed.defs#interactionRepost",
                                "app.bsky.feed.defs#interactionReply",
                                "app.bsky.feed.defs#interactionQuote",
                                "app.bsky.feed.defs#interactionShare"
                            ]
                        },
                        feedContext: {
                            type: "string",
                            description: "Context on a feed item that was originally supplied by the feed generator on getFeedSkeleton.",
                            maxLength: 2e3
                        }
                    }
                },
                requestLess: {
                    type: "token",
                    description: "Request that less content like the given feed item be shown in the feed"
                },
                requestMore: {
                    type: "token",
                    description: "Request that more content like the given feed item be shown in the feed"
                },
                clickthroughItem: {
                    type: "token",
                    description: "User clicked through to the feed item"
                },
                clickthroughAuthor: {
                    type: "token",
                    description: "User clicked through to the author of the feed item"
                },
                clickthroughReposter: {
                    type: "token",
                    description: "User clicked through to the reposter of the feed item"
                },
                clickthroughEmbed: {
                    type: "token",
                    description: "User clicked through to the embedded content of the feed item"
                },
                interactionSeen: {
                    type: "token",
                    description: "Feed item was seen by user"
                },
                interactionLike: {
                    type: "token",
                    description: "User liked the feed item"
                },
                interactionRepost: {
                    type: "token",
                    description: "User reposted the feed item"
                },
                interactionReply: {
                    type: "token",
                    description: "User replied to the feed item"
                },
                interactionQuote: {
                    type: "token",
                    description: "User quoted the feed item"
                },
                interactionShare: {
                    type: "token",
                    description: "User shared the feed item"
                }
            }
        },
        AppBskyFeedDescribeFeedGenerator: {
            lexicon: 1,
            id: "app.bsky.feed.describeFeedGenerator",
            defs: {
                main: {
                    type: "query",
                    description: "Get information about a feed generator, including policies and offered feed URIs. Does not require auth; implemented by Feed Generator services (not App View).",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did",
                                "feeds"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                feeds: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.describeFeedGenerator#feed"
                                    }
                                },
                                links: {
                                    type: "ref",
                                    ref: "lex:app.bsky.feed.describeFeedGenerator#links"
                                }
                            }
                        }
                    }
                },
                feed: {
                    type: "object",
                    required: [
                        "uri"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                },
                links: {
                    type: "object",
                    properties: {
                        privacyPolicy: {
                            type: "string"
                        },
                        termsOfService: {
                            type: "string"
                        }
                    }
                }
            }
        },
        AppBskyFeedGenerator: {
            lexicon: 1,
            id: "app.bsky.feed.generator",
            defs: {
                main: {
                    type: "record",
                    description: "Record declaring of the existence of a feed generator, and containing metadata about it. The record can exist in any repository.",
                    key: "any",
                    record: {
                        type: "object",
                        required: [
                            "did",
                            "displayName",
                            "createdAt"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did"
                            },
                            displayName: {
                                type: "string",
                                maxGraphemes: 24,
                                maxLength: 240
                            },
                            description: {
                                type: "string",
                                maxGraphemes: 300,
                                maxLength: 3e3
                            },
                            descriptionFacets: {
                                type: "array",
                                items: {
                                    type: "ref",
                                    ref: "lex:app.bsky.richtext.facet"
                                }
                            },
                            avatar: {
                                type: "blob",
                                accept: [
                                    "image/png",
                                    "image/jpeg"
                                ],
                                maxSize: 1e6
                            },
                            acceptsInteractions: {
                                type: "boolean",
                                description: "Declaration that a feed accepts feedback interactions from a client through app.bsky.feed.sendInteractions"
                            },
                            labels: {
                                type: "union",
                                description: "Self-label values",
                                refs: [
                                    "lex:com.atproto.label.defs#selfLabels"
                                ]
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedGetActorFeeds: {
            lexicon: 1,
            id: "app.bsky.feed.getActorFeeds",
            defs: {
                main: {
                    type: "query",
                    description: "Get a list of feeds (feed generator records) created by the actor (in the actor's repo).",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feeds"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                feeds: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#generatorView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedGetActorLikes: {
            lexicon: 1,
            id: "app.bsky.feed.getActorLikes",
            defs: {
                main: {
                    type: "query",
                    description: "Get a list of posts liked by an actor. Does not require auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feed"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                feed: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#feedViewPost"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "BlockedActor"
                        },
                        {
                            name: "BlockedByActor"
                        }
                    ]
                }
            }
        },
        AppBskyFeedGetAuthorFeed: {
            lexicon: 1,
            id: "app.bsky.feed.getAuthorFeed",
            defs: {
                main: {
                    type: "query",
                    description: "Get a view of an actor's 'author feed' (post and reposts by the author). Does not require auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            },
                            filter: {
                                type: "string",
                                description: "Combinations of post/repost types to include in response.",
                                knownValues: [
                                    "posts_with_replies",
                                    "posts_no_replies",
                                    "posts_with_media",
                                    "posts_and_author_threads"
                                ],
                                default: "posts_with_replies"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feed"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                feed: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#feedViewPost"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "BlockedActor"
                        },
                        {
                            name: "BlockedByActor"
                        }
                    ]
                }
            }
        },
        AppBskyFeedGetFeed: {
            lexicon: 1,
            id: "app.bsky.feed.getFeed",
            defs: {
                main: {
                    type: "query",
                    description: "Get a hydrated feed from an actor's selected feed generator. Implemented by App View.",
                    parameters: {
                        type: "params",
                        required: [
                            "feed"
                        ],
                        properties: {
                            feed: {
                                type: "string",
                                format: "at-uri"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feed"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                feed: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#feedViewPost"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "UnknownFeed"
                        }
                    ]
                }
            }
        },
        AppBskyFeedGetFeedGenerator: {
            lexicon: 1,
            id: "app.bsky.feed.getFeedGenerator",
            defs: {
                main: {
                    type: "query",
                    description: "Get information about a feed generator. Implemented by AppView.",
                    parameters: {
                        type: "params",
                        required: [
                            "feed"
                        ],
                        properties: {
                            feed: {
                                type: "string",
                                format: "at-uri",
                                description: "AT-URI of the feed generator record."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "view",
                                "isOnline",
                                "isValid"
                            ],
                            properties: {
                                view: {
                                    type: "ref",
                                    ref: "lex:app.bsky.feed.defs#generatorView"
                                },
                                isOnline: {
                                    type: "boolean",
                                    description: "Indicates whether the feed generator service has been online recently, or else seems to be inactive."
                                },
                                isValid: {
                                    type: "boolean",
                                    description: "Indicates whether the feed generator service is compatible with the record declaration."
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedGetFeedGenerators: {
            lexicon: 1,
            id: "app.bsky.feed.getFeedGenerators",
            defs: {
                main: {
                    type: "query",
                    description: "Get information about a list of feed generators.",
                    parameters: {
                        type: "params",
                        required: [
                            "feeds"
                        ],
                        properties: {
                            feeds: {
                                type: "array",
                                items: {
                                    type: "string",
                                    format: "at-uri"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feeds"
                            ],
                            properties: {
                                feeds: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#generatorView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedGetFeedSkeleton: {
            lexicon: 1,
            id: "app.bsky.feed.getFeedSkeleton",
            defs: {
                main: {
                    type: "query",
                    description: "Get a skeleton of a feed provided by a feed generator. Auth is optional, depending on provider requirements, and provides the DID of the requester. Implemented by Feed Generator Service.",
                    parameters: {
                        type: "params",
                        required: [
                            "feed"
                        ],
                        properties: {
                            feed: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference to feed generator record describing the specific feed being requested."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feed"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                feed: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#skeletonFeedPost"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "UnknownFeed"
                        }
                    ]
                }
            }
        },
        AppBskyFeedGetLikes: {
            lexicon: 1,
            id: "app.bsky.feed.getLikes",
            defs: {
                main: {
                    type: "query",
                    description: "Get like records which reference a subject (by AT-URI and CID).",
                    parameters: {
                        type: "params",
                        required: [
                            "uri"
                        ],
                        properties: {
                            uri: {
                                type: "string",
                                format: "at-uri",
                                description: "AT-URI of the subject (eg, a post record)."
                            },
                            cid: {
                                type: "string",
                                format: "cid",
                                description: "CID of the subject record (aka, specific version of record), to filter likes."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "uri",
                                "likes"
                            ],
                            properties: {
                                uri: {
                                    type: "string",
                                    format: "at-uri"
                                },
                                cid: {
                                    type: "string",
                                    format: "cid"
                                },
                                cursor: {
                                    type: "string"
                                },
                                likes: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.getLikes#like"
                                    }
                                }
                            }
                        }
                    }
                },
                like: {
                    type: "object",
                    required: [
                        "indexedAt",
                        "createdAt",
                        "actor"
                    ],
                    properties: {
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        actor: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileView"
                        }
                    }
                }
            }
        },
        AppBskyFeedGetListFeed: {
            lexicon: 1,
            id: "app.bsky.feed.getListFeed",
            defs: {
                main: {
                    type: "query",
                    description: "Get a feed of recent posts from a list (posts and reposts from any actors on the list). Does not require auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "list"
                        ],
                        properties: {
                            list: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference (AT-URI) to the list record."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feed"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                feed: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#feedViewPost"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "UnknownList"
                        }
                    ]
                }
            }
        },
        AppBskyFeedGetPostThread: {
            lexicon: 1,
            id: "app.bsky.feed.getPostThread",
            defs: {
                main: {
                    type: "query",
                    description: "Get posts in a thread. Does not require auth, but additional metadata and filtering will be applied for authed requests.",
                    parameters: {
                        type: "params",
                        required: [
                            "uri"
                        ],
                        properties: {
                            uri: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference (AT-URI) to post record."
                            },
                            depth: {
                                type: "integer",
                                description: "How many levels of reply depth should be included in response.",
                                default: 6,
                                minimum: 0,
                                maximum: 1e3
                            },
                            parentHeight: {
                                type: "integer",
                                description: "How many levels of parent (and grandparent, etc) post to include.",
                                default: 80,
                                minimum: 0,
                                maximum: 1e3
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "thread"
                            ],
                            properties: {
                                thread: {
                                    type: "union",
                                    refs: [
                                        "lex:app.bsky.feed.defs#threadViewPost",
                                        "lex:app.bsky.feed.defs#notFoundPost",
                                        "lex:app.bsky.feed.defs#blockedPost"
                                    ]
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "NotFound"
                        }
                    ]
                }
            }
        },
        AppBskyFeedGetPosts: {
            lexicon: 1,
            id: "app.bsky.feed.getPosts",
            defs: {
                main: {
                    type: "query",
                    description: "Gets post views for a specified list of posts (by AT-URI). This is sometimes referred to as 'hydrating' a 'feed skeleton'.",
                    parameters: {
                        type: "params",
                        required: [
                            "uris"
                        ],
                        properties: {
                            uris: {
                                type: "array",
                                description: "List of post AT-URIs to return hydrated views for.",
                                items: {
                                    type: "string",
                                    format: "at-uri"
                                },
                                maxLength: 25
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "posts"
                            ],
                            properties: {
                                posts: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#postView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedGetRepostedBy: {
            lexicon: 1,
            id: "app.bsky.feed.getRepostedBy",
            defs: {
                main: {
                    type: "query",
                    description: "Get a list of reposts for a given post.",
                    parameters: {
                        type: "params",
                        required: [
                            "uri"
                        ],
                        properties: {
                            uri: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference (AT-URI) of post record"
                            },
                            cid: {
                                type: "string",
                                format: "cid",
                                description: "If supplied, filters to reposts of specific version (by CID) of the post record."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "uri",
                                "repostedBy"
                            ],
                            properties: {
                                uri: {
                                    type: "string",
                                    format: "at-uri"
                                },
                                cid: {
                                    type: "string",
                                    format: "cid"
                                },
                                cursor: {
                                    type: "string"
                                },
                                repostedBy: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedGetSuggestedFeeds: {
            lexicon: 1,
            id: "app.bsky.feed.getSuggestedFeeds",
            defs: {
                main: {
                    type: "query",
                    description: "Get a list of suggested feeds (feed generators) for the requesting account.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feeds"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                feeds: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#generatorView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedGetTimeline: {
            lexicon: 1,
            id: "app.bsky.feed.getTimeline",
            defs: {
                main: {
                    type: "query",
                    description: "Get a view of the requesting account's home timeline. This is expected to be some form of reverse-chronological feed.",
                    parameters: {
                        type: "params",
                        properties: {
                            algorithm: {
                                type: "string",
                                description: "Variant 'algorithm' for timeline. Implementation-specific. NOTE: most feed flexibility has been moved to feed generator mechanism."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feed"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                feed: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#feedViewPost"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedLike: {
            lexicon: 1,
            id: "app.bsky.feed.like",
            defs: {
                main: {
                    type: "record",
                    description: "Record declaring a 'like' of a piece of subject content.",
                    key: "tid",
                    record: {
                        type: "object",
                        required: [
                            "subject",
                            "createdAt"
                        ],
                        properties: {
                            subject: {
                                type: "ref",
                                ref: "lex:com.atproto.repo.strongRef"
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedPost: {
            lexicon: 1,
            id: "app.bsky.feed.post",
            defs: {
                main: {
                    type: "record",
                    description: "Record containing a Bluesky post.",
                    key: "tid",
                    record: {
                        type: "object",
                        required: [
                            "text",
                            "createdAt"
                        ],
                        properties: {
                            text: {
                                type: "string",
                                maxLength: 3e3,
                                maxGraphemes: 300,
                                description: "The primary post content. May be an empty string, if there are embeds."
                            },
                            entities: {
                                type: "array",
                                description: "DEPRECATED: replaced by app.bsky.richtext.facet.",
                                items: {
                                    type: "ref",
                                    ref: "lex:app.bsky.feed.post#entity"
                                }
                            },
                            facets: {
                                type: "array",
                                description: "Annotations of text (mentions, URLs, hashtags, etc)",
                                items: {
                                    type: "ref",
                                    ref: "lex:app.bsky.richtext.facet"
                                }
                            },
                            reply: {
                                type: "ref",
                                ref: "lex:app.bsky.feed.post#replyRef"
                            },
                            embed: {
                                type: "union",
                                refs: [
                                    "lex:app.bsky.embed.images",
                                    "lex:app.bsky.embed.external",
                                    "lex:app.bsky.embed.record",
                                    "lex:app.bsky.embed.recordWithMedia"
                                ]
                            },
                            langs: {
                                type: "array",
                                description: "Indicates human language of post primary text content.",
                                maxLength: 3,
                                items: {
                                    type: "string",
                                    format: "language"
                                }
                            },
                            labels: {
                                type: "union",
                                description: "Self-label values for this post. Effectively content warnings.",
                                refs: [
                                    "lex:com.atproto.label.defs#selfLabels"
                                ]
                            },
                            tags: {
                                type: "array",
                                description: "Additional hashtags, in addition to any included in post text and facets.",
                                maxLength: 8,
                                items: {
                                    type: "string",
                                    maxLength: 640,
                                    maxGraphemes: 64
                                }
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime",
                                description: "Client-declared timestamp when this post was originally created."
                            }
                        }
                    }
                },
                replyRef: {
                    type: "object",
                    required: [
                        "root",
                        "parent"
                    ],
                    properties: {
                        root: {
                            type: "ref",
                            ref: "lex:com.atproto.repo.strongRef"
                        },
                        parent: {
                            type: "ref",
                            ref: "lex:com.atproto.repo.strongRef"
                        }
                    }
                },
                entity: {
                    type: "object",
                    description: "Deprecated: use facets instead.",
                    required: [
                        "index",
                        "type",
                        "value"
                    ],
                    properties: {
                        index: {
                            type: "ref",
                            ref: "lex:app.bsky.feed.post#textSlice"
                        },
                        type: {
                            type: "string",
                            description: "Expected values are 'mention' and 'link'."
                        },
                        value: {
                            type: "string"
                        }
                    }
                },
                textSlice: {
                    type: "object",
                    description: "Deprecated. Use app.bsky.richtext instead -- A text segment. Start is inclusive, end is exclusive. Indices are for utf16-encoded strings.",
                    required: [
                        "start",
                        "end"
                    ],
                    properties: {
                        start: {
                            type: "integer",
                            minimum: 0
                        },
                        end: {
                            type: "integer",
                            minimum: 0
                        }
                    }
                }
            }
        },
        AppBskyFeedRepost: {
            lexicon: 1,
            id: "app.bsky.feed.repost",
            defs: {
                main: {
                    description: "Record representing a 'repost' of an existing Bluesky post.",
                    type: "record",
                    key: "tid",
                    record: {
                        type: "object",
                        required: [
                            "subject",
                            "createdAt"
                        ],
                        properties: {
                            subject: {
                                type: "ref",
                                ref: "lex:com.atproto.repo.strongRef"
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyFeedSearchPosts: {
            lexicon: 1,
            id: "app.bsky.feed.searchPosts",
            defs: {
                main: {
                    type: "query",
                    description: "Find posts matching search criteria, returning views of those posts.",
                    parameters: {
                        type: "params",
                        required: [
                            "q"
                        ],
                        properties: {
                            q: {
                                type: "string",
                                description: "Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended."
                            },
                            sort: {
                                type: "string",
                                knownValues: [
                                    "top",
                                    "latest"
                                ],
                                default: "latest",
                                description: "Specifies the ranking order of results."
                            },
                            since: {
                                type: "string",
                                description: "Filter results for posts after the indicated datetime (inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYYY-MM-DD)."
                            },
                            until: {
                                type: "string",
                                description: "Filter results for posts before the indicated datetime (not inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYY-MM-DD)."
                            },
                            mentions: {
                                type: "string",
                                format: "at-identifier",
                                description: "Filter to posts which mention the given account. Handles are resolved to DID before query-time. Only matches rich-text facet mentions."
                            },
                            author: {
                                type: "string",
                                format: "at-identifier",
                                description: "Filter to posts by the given account. Handles are resolved to DID before query-time."
                            },
                            lang: {
                                type: "string",
                                format: "language",
                                description: "Filter to posts in the given language. Expected to be based on post language field, though server may override language detection."
                            },
                            domain: {
                                type: "string",
                                description: "Filter to posts with URLs (facet links or embeds) linking to the given domain (hostname). Server may apply hostname normalization."
                            },
                            url: {
                                type: "string",
                                format: "uri",
                                description: "Filter to posts with links (facet links or embeds) pointing to this URL. Server may apply URL normalization or fuzzy matching."
                            },
                            tag: {
                                type: "array",
                                items: {
                                    type: "string",
                                    maxLength: 640,
                                    maxGraphemes: 64
                                },
                                description: "Filter to posts with the given tag (hashtag), based on rich-text facet or tag field. Do not include the hash (#) prefix. Multiple tags can be specified, with 'AND' matching."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 25
                            },
                            cursor: {
                                type: "string",
                                description: "Optional pagination mechanism; may not necessarily allow scrolling through entire result set."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "posts"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                hitsTotal: {
                                    type: "integer",
                                    description: "Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits."
                                },
                                posts: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#postView"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "BadQueryString"
                        }
                    ]
                }
            }
        },
        AppBskyFeedSendInteractions: {
            lexicon: 1,
            id: "app.bsky.feed.sendInteractions",
            defs: {
                main: {
                    type: "procedure",
                    description: "Send information about interactions with feed items back to the feed generator that served them.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "interactions"
                            ],
                            properties: {
                                interactions: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#interaction"
                                    }
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            properties: {}
                        }
                    }
                }
            }
        },
        AppBskyFeedThreadgate: {
            lexicon: 1,
            id: "app.bsky.feed.threadgate",
            defs: {
                main: {
                    type: "record",
                    key: "tid",
                    description: "Record defining interaction gating rules for a thread (aka, reply controls). The record key (rkey) of the threadgate record must match the record key of the thread's root post, and that record must be in the same repository..",
                    record: {
                        type: "object",
                        required: [
                            "post",
                            "createdAt"
                        ],
                        properties: {
                            post: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference (AT-URI) to the post record."
                            },
                            allow: {
                                type: "array",
                                maxLength: 5,
                                items: {
                                    type: "union",
                                    refs: [
                                        "lex:app.bsky.feed.threadgate#mentionRule",
                                        "lex:app.bsky.feed.threadgate#followingRule",
                                        "lex:app.bsky.feed.threadgate#listRule"
                                    ]
                                }
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                },
                mentionRule: {
                    type: "object",
                    description: "Allow replies from actors mentioned in your post.",
                    properties: {}
                },
                followingRule: {
                    type: "object",
                    description: "Allow replies from actors you follow.",
                    properties: {}
                },
                listRule: {
                    type: "object",
                    description: "Allow replies from actors on a list.",
                    required: [
                        "list"
                    ],
                    properties: {
                        list: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                }
            }
        },
        AppBskyGraphBlock: {
            lexicon: 1,
            id: "app.bsky.graph.block",
            defs: {
                main: {
                    type: "record",
                    description: "Record declaring a 'block' relationship against another account. NOTE: blocks are public in Bluesky; see blog posts for details.",
                    key: "tid",
                    record: {
                        type: "object",
                        required: [
                            "subject",
                            "createdAt"
                        ],
                        properties: {
                            subject: {
                                type: "string",
                                format: "did",
                                description: "DID of the account to be blocked."
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphDefs: {
            lexicon: 1,
            id: "app.bsky.graph.defs",
            defs: {
                listViewBasic: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "name",
                        "purpose"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        name: {
                            type: "string",
                            maxLength: 64,
                            minLength: 1
                        },
                        purpose: {
                            type: "ref",
                            ref: "lex:app.bsky.graph.defs#listPurpose"
                        },
                        avatar: {
                            type: "string",
                            format: "uri"
                        },
                        listItemCount: {
                            type: "integer",
                            minimum: 0
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.graph.defs#listViewerState"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                listView: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "creator",
                        "name",
                        "purpose",
                        "indexedAt"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        creator: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileView"
                        },
                        name: {
                            type: "string",
                            maxLength: 64,
                            minLength: 1
                        },
                        purpose: {
                            type: "ref",
                            ref: "lex:app.bsky.graph.defs#listPurpose"
                        },
                        description: {
                            type: "string",
                            maxGraphemes: 300,
                            maxLength: 3e3
                        },
                        descriptionFacets: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.richtext.facet"
                            }
                        },
                        avatar: {
                            type: "string",
                            format: "uri"
                        },
                        listItemCount: {
                            type: "integer",
                            minimum: 0
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.graph.defs#listViewerState"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                listItemView: {
                    type: "object",
                    required: [
                        "uri",
                        "subject"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        subject: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileView"
                        }
                    }
                },
                starterPackView: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "record",
                        "creator",
                        "indexedAt"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        record: {
                            type: "unknown"
                        },
                        creator: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileViewBasic"
                        },
                        list: {
                            type: "ref",
                            ref: "lex:app.bsky.graph.defs#listViewBasic"
                        },
                        listItemsSample: {
                            type: "array",
                            maxLength: 12,
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.graph.defs#listItemView"
                            }
                        },
                        feeds: {
                            type: "array",
                            maxLength: 3,
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.feed.defs#generatorView"
                            }
                        },
                        joinedWeekCount: {
                            type: "integer",
                            minimum: 0
                        },
                        joinedAllTimeCount: {
                            type: "integer",
                            minimum: 0
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                starterPackViewBasic: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "record",
                        "creator",
                        "indexedAt"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        record: {
                            type: "unknown"
                        },
                        creator: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileViewBasic"
                        },
                        listItemCount: {
                            type: "integer",
                            minimum: 0
                        },
                        joinedWeekCount: {
                            type: "integer",
                            minimum: 0
                        },
                        joinedAllTimeCount: {
                            type: "integer",
                            minimum: 0
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                listPurpose: {
                    type: "string",
                    knownValues: [
                        "app.bsky.graph.defs#modlist",
                        "app.bsky.graph.defs#curatelist",
                        "app.bsky.graph.defs#referencelist"
                    ]
                },
                modlist: {
                    type: "token",
                    description: "A list of actors to apply an aggregate moderation action (mute/block) on."
                },
                curatelist: {
                    type: "token",
                    description: "A list of actors used for curation purposes such as list feeds or interaction gating."
                },
                referencelist: {
                    type: "token",
                    description: "A list of actors used for only for reference purposes such as within a starter pack."
                },
                listViewerState: {
                    type: "object",
                    properties: {
                        muted: {
                            type: "boolean"
                        },
                        blocked: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                },
                notFoundActor: {
                    type: "object",
                    description: "indicates that a handle or DID could not be resolved",
                    required: [
                        "actor",
                        "notFound"
                    ],
                    properties: {
                        actor: {
                            type: "string",
                            format: "at-identifier"
                        },
                        notFound: {
                            type: "boolean",
                            const: !0
                        }
                    }
                },
                relationship: {
                    type: "object",
                    description: "lists the bi-directional graph relationships between one actor (not indicated in the object), and the target actors (the DID included in the object)",
                    required: [
                        "did"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        following: {
                            type: "string",
                            format: "at-uri",
                            description: "if the actor follows this DID, this is the AT-URI of the follow record"
                        },
                        followedBy: {
                            type: "string",
                            format: "at-uri",
                            description: "if the actor is followed by this DID, contains the AT-URI of the follow record"
                        }
                    }
                }
            }
        },
        AppBskyGraphFollow: {
            lexicon: 1,
            id: "app.bsky.graph.follow",
            defs: {
                main: {
                    type: "record",
                    description: "Record declaring a social 'follow' relationship of another account. Duplicate follows will be ignored by the AppView.",
                    key: "tid",
                    record: {
                        type: "object",
                        required: [
                            "subject",
                            "createdAt"
                        ],
                        properties: {
                            subject: {
                                type: "string",
                                format: "did"
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetActorStarterPacks: {
            lexicon: 1,
            id: "app.bsky.graph.getActorStarterPacks",
            defs: {
                main: {
                    type: "query",
                    description: "Get a list of starter packs created by the actor.",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "starterPacks"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                starterPacks: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.graph.defs#starterPackViewBasic"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetBlocks: {
            lexicon: 1,
            id: "app.bsky.graph.getBlocks",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates which accounts the requesting account is currently blocking. Requires auth.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "blocks"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                blocks: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetFollowers: {
            lexicon: 1,
            id: "app.bsky.graph.getFollowers",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates accounts which follow a specified account (actor).",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "subject",
                                "followers"
                            ],
                            properties: {
                                subject: {
                                    type: "ref",
                                    ref: "lex:app.bsky.actor.defs#profileView"
                                },
                                cursor: {
                                    type: "string"
                                },
                                followers: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetFollows: {
            lexicon: 1,
            id: "app.bsky.graph.getFollows",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates accounts which a specified account (actor) follows.",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "subject",
                                "follows"
                            ],
                            properties: {
                                subject: {
                                    type: "ref",
                                    ref: "lex:app.bsky.actor.defs#profileView"
                                },
                                cursor: {
                                    type: "string"
                                },
                                follows: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetKnownFollowers: {
            lexicon: 1,
            id: "app.bsky.graph.getKnownFollowers",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates accounts which follow a specified account (actor) and are followed by the viewer.",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "subject",
                                "followers"
                            ],
                            properties: {
                                subject: {
                                    type: "ref",
                                    ref: "lex:app.bsky.actor.defs#profileView"
                                },
                                cursor: {
                                    type: "string"
                                },
                                followers: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetList: {
            lexicon: 1,
            id: "app.bsky.graph.getList",
            defs: {
                main: {
                    type: "query",
                    description: "Gets a 'view' (with additional context) of a specified list.",
                    parameters: {
                        type: "params",
                        required: [
                            "list"
                        ],
                        properties: {
                            list: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference (AT-URI) of the list record to hydrate."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "list",
                                "items"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                list: {
                                    type: "ref",
                                    ref: "lex:app.bsky.graph.defs#listView"
                                },
                                items: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.graph.defs#listItemView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetListBlocks: {
            lexicon: 1,
            id: "app.bsky.graph.getListBlocks",
            defs: {
                main: {
                    type: "query",
                    description: "Get mod lists that the requesting account (actor) is blocking. Requires auth.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "lists"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                lists: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.graph.defs#listView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetListMutes: {
            lexicon: 1,
            id: "app.bsky.graph.getListMutes",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates mod lists that the requesting account (actor) currently has muted. Requires auth.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "lists"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                lists: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.graph.defs#listView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetLists: {
            lexicon: 1,
            id: "app.bsky.graph.getLists",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates the lists created by a specified account (actor).",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier",
                                description: "The account (actor) to enumerate lists from."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "lists"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                lists: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.graph.defs#listView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetMutes: {
            lexicon: 1,
            id: "app.bsky.graph.getMutes",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates accounts that the requesting account (actor) currently has muted. Requires auth.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "mutes"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                mutes: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetRelationships: {
            lexicon: 1,
            id: "app.bsky.graph.getRelationships",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates public relationships between one account, and a list of other accounts. Does not require auth.",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier",
                                description: "Primary account requesting relationships for."
                            },
                            others: {
                                type: "array",
                                description: "List of 'other' accounts to be related back to the primary.",
                                maxLength: 30,
                                items: {
                                    type: "string",
                                    format: "at-identifier"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "relationships"
                            ],
                            properties: {
                                actor: {
                                    type: "string",
                                    format: "did"
                                },
                                relationships: {
                                    type: "array",
                                    items: {
                                        type: "union",
                                        refs: [
                                            "lex:app.bsky.graph.defs#relationship",
                                            "lex:app.bsky.graph.defs#notFoundActor"
                                        ]
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "ActorNotFound",
                            description: "the primary actor at-identifier could not be resolved"
                        }
                    ]
                }
            }
        },
        AppBskyGraphGetStarterPack: {
            lexicon: 1,
            id: "app.bsky.graph.getStarterPack",
            defs: {
                main: {
                    type: "query",
                    description: "Gets a view of a starter pack.",
                    parameters: {
                        type: "params",
                        required: [
                            "starterPack"
                        ],
                        properties: {
                            starterPack: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference (AT-URI) of the starter pack record."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "starterPack"
                            ],
                            properties: {
                                starterPack: {
                                    type: "ref",
                                    ref: "lex:app.bsky.graph.defs#starterPackView"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetStarterPacks: {
            lexicon: 1,
            id: "app.bsky.graph.getStarterPacks",
            defs: {
                main: {
                    type: "query",
                    description: "Get views for a list of starter packs.",
                    parameters: {
                        type: "params",
                        required: [
                            "uris"
                        ],
                        properties: {
                            uris: {
                                type: "array",
                                items: {
                                    type: "string",
                                    format: "at-uri"
                                },
                                maxLength: 25
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "starterPacks"
                            ],
                            properties: {
                                starterPacks: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.graph.defs#starterPackViewBasic"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphGetSuggestedFollowsByActor: {
            lexicon: 1,
            id: "app.bsky.graph.getSuggestedFollowsByActor",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerates follows similar to a given account (actor). Expected use is to recommend additional accounts immediately after following one account.",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "at-identifier"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "suggestions"
                            ],
                            properties: {
                                suggestions: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.actor.defs#profileView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphList: {
            lexicon: 1,
            id: "app.bsky.graph.list",
            defs: {
                main: {
                    type: "record",
                    description: "Record representing a list of accounts (actors). Scope includes both moderation-oriented lists and curration-oriented lists.",
                    key: "tid",
                    record: {
                        type: "object",
                        required: [
                            "name",
                            "purpose",
                            "createdAt"
                        ],
                        properties: {
                            purpose: {
                                type: "ref",
                                description: "Defines the purpose of the list (aka, moderation-oriented or curration-oriented)",
                                ref: "lex:app.bsky.graph.defs#listPurpose"
                            },
                            name: {
                                type: "string",
                                maxLength: 64,
                                minLength: 1,
                                description: "Display name for list; can not be empty."
                            },
                            description: {
                                type: "string",
                                maxGraphemes: 300,
                                maxLength: 3e3
                            },
                            descriptionFacets: {
                                type: "array",
                                items: {
                                    type: "ref",
                                    ref: "lex:app.bsky.richtext.facet"
                                }
                            },
                            avatar: {
                                type: "blob",
                                accept: [
                                    "image/png",
                                    "image/jpeg"
                                ],
                                maxSize: 1e6
                            },
                            labels: {
                                type: "union",
                                refs: [
                                    "lex:com.atproto.label.defs#selfLabels"
                                ]
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphListblock: {
            lexicon: 1,
            id: "app.bsky.graph.listblock",
            defs: {
                main: {
                    type: "record",
                    description: "Record representing a block relationship against an entire an entire list of accounts (actors).",
                    key: "tid",
                    record: {
                        type: "object",
                        required: [
                            "subject",
                            "createdAt"
                        ],
                        properties: {
                            subject: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference (AT-URI) to the mod list record."
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphListitem: {
            lexicon: 1,
            id: "app.bsky.graph.listitem",
            defs: {
                main: {
                    type: "record",
                    description: "Record representing an account's inclusion on a specific list. The AppView will ignore duplicate listitem records.",
                    key: "tid",
                    record: {
                        type: "object",
                        required: [
                            "subject",
                            "list",
                            "createdAt"
                        ],
                        properties: {
                            subject: {
                                type: "string",
                                format: "did",
                                description: "The account which is included on the list."
                            },
                            list: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference (AT-URI) to the list record (app.bsky.graph.list)."
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphMuteActor: {
            lexicon: 1,
            id: "app.bsky.graph.muteActor",
            defs: {
                main: {
                    type: "procedure",
                    description: "Creates a mute relationship for the specified account. Mutes are private in Bluesky. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "actor"
                            ],
                            properties: {
                                actor: {
                                    type: "string",
                                    format: "at-identifier"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphMuteActorList: {
            lexicon: 1,
            id: "app.bsky.graph.muteActorList",
            defs: {
                main: {
                    type: "procedure",
                    description: "Creates a mute relationship for the specified list of accounts. Mutes are private in Bluesky. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "list"
                            ],
                            properties: {
                                list: {
                                    type: "string",
                                    format: "at-uri"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphMuteThread: {
            lexicon: 1,
            id: "app.bsky.graph.muteThread",
            defs: {
                main: {
                    type: "procedure",
                    description: "Mutes a thread preventing notifications from the thread and any of its children. Mutes are private in Bluesky. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "root"
                            ],
                            properties: {
                                root: {
                                    type: "string",
                                    format: "at-uri"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphStarterpack: {
            lexicon: 1,
            id: "app.bsky.graph.starterpack",
            defs: {
                main: {
                    type: "record",
                    description: "Record defining a starter pack of actors and feeds for new users.",
                    key: "tid",
                    record: {
                        type: "object",
                        required: [
                            "name",
                            "list",
                            "createdAt"
                        ],
                        properties: {
                            name: {
                                type: "string",
                                maxGraphemes: 50,
                                maxLength: 500,
                                minLength: 1,
                                description: "Display name for starter pack; can not be empty."
                            },
                            description: {
                                type: "string",
                                maxGraphemes: 300,
                                maxLength: 3e3
                            },
                            descriptionFacets: {
                                type: "array",
                                items: {
                                    type: "ref",
                                    ref: "lex:app.bsky.richtext.facet"
                                }
                            },
                            list: {
                                type: "string",
                                format: "at-uri",
                                description: "Reference (AT-URI) to the list record."
                            },
                            feeds: {
                                type: "array",
                                maxLength: 3,
                                items: {
                                    type: "ref",
                                    ref: "lex:app.bsky.graph.starterpack#feedItem"
                                }
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                },
                feedItem: {
                    type: "object",
                    required: [
                        "uri"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                }
            }
        },
        AppBskyGraphUnmuteActor: {
            lexicon: 1,
            id: "app.bsky.graph.unmuteActor",
            defs: {
                main: {
                    type: "procedure",
                    description: "Unmutes the specified account. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "actor"
                            ],
                            properties: {
                                actor: {
                                    type: "string",
                                    format: "at-identifier"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphUnmuteActorList: {
            lexicon: 1,
            id: "app.bsky.graph.unmuteActorList",
            defs: {
                main: {
                    type: "procedure",
                    description: "Unmutes the specified list of accounts. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "list"
                            ],
                            properties: {
                                list: {
                                    type: "string",
                                    format: "at-uri"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyGraphUnmuteThread: {
            lexicon: 1,
            id: "app.bsky.graph.unmuteThread",
            defs: {
                main: {
                    type: "procedure",
                    description: "Unmutes the specified thread. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "root"
                            ],
                            properties: {
                                root: {
                                    type: "string",
                                    format: "at-uri"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyLabelerDefs: {
            lexicon: 1,
            id: "app.bsky.labeler.defs",
            defs: {
                labelerView: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "creator",
                        "indexedAt"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        creator: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileView"
                        },
                        likeCount: {
                            type: "integer",
                            minimum: 0
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.labeler.defs#labelerViewerState"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        }
                    }
                },
                labelerViewDetailed: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "creator",
                        "policies",
                        "indexedAt"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        creator: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileView"
                        },
                        policies: {
                            type: "ref",
                            ref: "lex:app.bsky.labeler.defs#labelerPolicies"
                        },
                        likeCount: {
                            type: "integer",
                            minimum: 0
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.labeler.defs#labelerViewerState"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        }
                    }
                },
                labelerViewerState: {
                    type: "object",
                    properties: {
                        like: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                },
                labelerPolicies: {
                    type: "object",
                    required: [
                        "labelValues"
                    ],
                    properties: {
                        labelValues: {
                            type: "array",
                            description: "The label values which this labeler publishes. May include global or custom labels.",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#labelValue"
                            }
                        },
                        labelValueDefinitions: {
                            type: "array",
                            description: "Label values created by this labeler and scoped exclusively to it. Labels defined here will override global label definitions for this labeler.",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#labelValueDefinition"
                            }
                        }
                    }
                }
            }
        },
        AppBskyLabelerGetServices: {
            lexicon: 1,
            id: "app.bsky.labeler.getServices",
            defs: {
                main: {
                    type: "query",
                    description: "Get information about a list of labeler services.",
                    parameters: {
                        type: "params",
                        required: [
                            "dids"
                        ],
                        properties: {
                            dids: {
                                type: "array",
                                items: {
                                    type: "string",
                                    format: "did"
                                }
                            },
                            detailed: {
                                type: "boolean",
                                default: !1
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "views"
                            ],
                            properties: {
                                views: {
                                    type: "array",
                                    items: {
                                        type: "union",
                                        refs: [
                                            "lex:app.bsky.labeler.defs#labelerView",
                                            "lex:app.bsky.labeler.defs#labelerViewDetailed"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyLabelerService: {
            lexicon: 1,
            id: "app.bsky.labeler.service",
            defs: {
                main: {
                    type: "record",
                    description: "A declaration of the existence of labeler service.",
                    key: "literal:self",
                    record: {
                        type: "object",
                        required: [
                            "policies",
                            "createdAt"
                        ],
                        properties: {
                            policies: {
                                type: "ref",
                                ref: "lex:app.bsky.labeler.defs#labelerPolicies"
                            },
                            labels: {
                                type: "union",
                                refs: [
                                    "lex:com.atproto.label.defs#selfLabels"
                                ]
                            },
                            createdAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    }
                }
            }
        },
        AppBskyNotificationGetUnreadCount: {
            lexicon: 1,
            id: "app.bsky.notification.getUnreadCount",
            defs: {
                main: {
                    type: "query",
                    description: "Count the number of unread notifications for the requesting account. Requires auth.",
                    parameters: {
                        type: "params",
                        properties: {
                            priority: {
                                type: "boolean"
                            },
                            seenAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "count"
                            ],
                            properties: {
                                count: {
                                    type: "integer"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyNotificationListNotifications: {
            lexicon: 1,
            id: "app.bsky.notification.listNotifications",
            defs: {
                main: {
                    type: "query",
                    description: "Enumerate notifications for the requesting account. Requires auth.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            priority: {
                                type: "boolean"
                            },
                            cursor: {
                                type: "string"
                            },
                            seenAt: {
                                type: "string",
                                format: "datetime"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "notifications"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                notifications: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.notification.listNotifications#notification"
                                    }
                                },
                                priority: {
                                    type: "boolean"
                                },
                                seenAt: {
                                    type: "string",
                                    format: "datetime"
                                }
                            }
                        }
                    }
                },
                notification: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "author",
                        "reason",
                        "record",
                        "isRead",
                        "indexedAt"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        author: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileView"
                        },
                        reason: {
                            type: "string",
                            description: "Expected values are 'like', 'repost', 'follow', 'mention', 'reply', 'quote', and 'starterpack-joined'.",
                            knownValues: [
                                "like",
                                "repost",
                                "follow",
                                "mention",
                                "reply",
                                "quote",
                                "starterpack-joined"
                            ]
                        },
                        reasonSubject: {
                            type: "string",
                            format: "at-uri"
                        },
                        record: {
                            type: "unknown"
                        },
                        isRead: {
                            type: "boolean"
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        }
                    }
                }
            }
        },
        AppBskyNotificationPutPreferences: {
            lexicon: 1,
            id: "app.bsky.notification.putPreferences",
            defs: {
                main: {
                    type: "procedure",
                    description: "Set notification-related preferences for an account. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "priority"
                            ],
                            properties: {
                                priority: {
                                    type: "boolean"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyNotificationRegisterPush: {
            lexicon: 1,
            id: "app.bsky.notification.registerPush",
            defs: {
                main: {
                    type: "procedure",
                    description: "Register to receive push notifications, via a specified service, for the requesting account. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "serviceDid",
                                "token",
                                "platform",
                                "appId"
                            ],
                            properties: {
                                serviceDid: {
                                    type: "string",
                                    format: "did"
                                },
                                token: {
                                    type: "string"
                                },
                                platform: {
                                    type: "string",
                                    knownValues: [
                                        "ios",
                                        "android",
                                        "web"
                                    ]
                                },
                                appId: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyNotificationUpdateSeen: {
            lexicon: 1,
            id: "app.bsky.notification.updateSeen",
            defs: {
                main: {
                    type: "procedure",
                    description: "Notify server that the requesting account has seen notifications. Requires auth.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "seenAt"
                            ],
                            properties: {
                                seenAt: {
                                    type: "string",
                                    format: "datetime"
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyRichtextFacet: {
            lexicon: 1,
            id: "app.bsky.richtext.facet",
            defs: {
                main: {
                    type: "object",
                    description: "Annotation of a sub-string within rich text.",
                    required: [
                        "index",
                        "features"
                    ],
                    properties: {
                        index: {
                            type: "ref",
                            ref: "lex:app.bsky.richtext.facet#byteSlice"
                        },
                        features: {
                            type: "array",
                            items: {
                                type: "union",
                                refs: [
                                    "lex:app.bsky.richtext.facet#mention",
                                    "lex:app.bsky.richtext.facet#link",
                                    "lex:app.bsky.richtext.facet#tag"
                                ]
                            }
                        }
                    }
                },
                mention: {
                    type: "object",
                    description: "Facet feature for mention of another account. The text is usually a handle, including a '@' prefix, but the facet reference is a DID.",
                    required: [
                        "did"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        }
                    }
                },
                link: {
                    type: "object",
                    description: "Facet feature for a URL. The text URL may have been simplified or truncated, but the facet reference should be a complete URL.",
                    required: [
                        "uri"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "uri"
                        }
                    }
                },
                tag: {
                    type: "object",
                    description: "Facet feature for a hashtag. The text usually includes a '#' prefix, but the facet reference should not (except in the case of 'double hash tags').",
                    required: [
                        "tag"
                    ],
                    properties: {
                        tag: {
                            type: "string",
                            maxLength: 640,
                            maxGraphemes: 64
                        }
                    }
                },
                byteSlice: {
                    type: "object",
                    description: "Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets.",
                    required: [
                        "byteStart",
                        "byteEnd"
                    ],
                    properties: {
                        byteStart: {
                            type: "integer",
                            minimum: 0
                        },
                        byteEnd: {
                            type: "integer",
                            minimum: 0
                        }
                    }
                }
            }
        },
        AppBskyUnspeccedDefs: {
            lexicon: 1,
            id: "app.bsky.unspecced.defs",
            defs: {
                skeletonSearchPost: {
                    type: "object",
                    required: [
                        "uri"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                },
                skeletonSearchActor: {
                    type: "object",
                    required: [
                        "did"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        }
                    }
                }
            }
        },
        AppBskyUnspeccedGetPopularFeedGenerators: {
            lexicon: 1,
            id: "app.bsky.unspecced.getPopularFeedGenerators",
            defs: {
                main: {
                    type: "query",
                    description: "An unspecced view of globally popular feed generators.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            },
                            query: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "feeds"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                feeds: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.feed.defs#generatorView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyUnspeccedGetSuggestionsSkeleton: {
            lexicon: 1,
            id: "app.bsky.unspecced.getSuggestionsSkeleton",
            defs: {
                main: {
                    type: "query",
                    description: "Get a skeleton of suggested actors. Intended to be called and then hydrated through app.bsky.actor.getSuggestions",
                    parameters: {
                        type: "params",
                        properties: {
                            viewer: {
                                type: "string",
                                format: "did",
                                description: "DID of the account making the request (not included for public/unauthenticated queries). Used to boost followed accounts in ranking."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            },
                            relativeToDid: {
                                type: "string",
                                format: "did",
                                description: "DID of the account to get suggestions relative to. If not provided, suggestions will be based on the viewer."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "actors"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                actors: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.unspecced.defs#skeletonSearchActor"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        AppBskyUnspeccedGetTaggedSuggestions: {
            lexicon: 1,
            id: "app.bsky.unspecced.getTaggedSuggestions",
            defs: {
                main: {
                    type: "query",
                    description: "Get a list of suggestions (feeds and users) tagged with categories",
                    parameters: {
                        type: "params",
                        properties: {}
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "suggestions"
                            ],
                            properties: {
                                suggestions: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.unspecced.getTaggedSuggestions#suggestion"
                                    }
                                }
                            }
                        }
                    }
                },
                suggestion: {
                    type: "object",
                    required: [
                        "tag",
                        "subjectType",
                        "subject"
                    ],
                    properties: {
                        tag: {
                            type: "string"
                        },
                        subjectType: {
                            type: "string",
                            knownValues: [
                                "actor",
                                "feed"
                            ]
                        },
                        subject: {
                            type: "string",
                            format: "uri"
                        }
                    }
                }
            }
        },
        AppBskyUnspeccedSearchActorsSkeleton: {
            lexicon: 1,
            id: "app.bsky.unspecced.searchActorsSkeleton",
            defs: {
                main: {
                    type: "query",
                    description: "Backend Actors (profile) search, returns only skeleton.",
                    parameters: {
                        type: "params",
                        required: [
                            "q"
                        ],
                        properties: {
                            q: {
                                type: "string",
                                description: "Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended. For typeahead search, only simple term match is supported, not full syntax."
                            },
                            viewer: {
                                type: "string",
                                format: "did",
                                description: "DID of the account making the request (not included for public/unauthenticated queries). Used to boost followed accounts in ranking."
                            },
                            typeahead: {
                                type: "boolean",
                                description: "If true, acts as fast/simple 'typeahead' query."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 25
                            },
                            cursor: {
                                type: "string",
                                description: "Optional pagination mechanism; may not necessarily allow scrolling through entire result set."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "actors"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                hitsTotal: {
                                    type: "integer",
                                    description: "Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits."
                                },
                                actors: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.unspecced.defs#skeletonSearchActor"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "BadQueryString"
                        }
                    ]
                }
            }
        },
        AppBskyUnspeccedSearchPostsSkeleton: {
            lexicon: 1,
            id: "app.bsky.unspecced.searchPostsSkeleton",
            defs: {
                main: {
                    type: "query",
                    description: "Backend Posts search, returns only skeleton",
                    parameters: {
                        type: "params",
                        required: [
                            "q"
                        ],
                        properties: {
                            q: {
                                type: "string",
                                description: "Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended."
                            },
                            sort: {
                                type: "string",
                                knownValues: [
                                    "top",
                                    "latest"
                                ],
                                default: "latest",
                                description: "Specifies the ranking order of results."
                            },
                            since: {
                                type: "string",
                                description: "Filter results for posts after the indicated datetime (inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYYY-MM-DD)."
                            },
                            until: {
                                type: "string",
                                description: "Filter results for posts before the indicated datetime (not inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYY-MM-DD)."
                            },
                            mentions: {
                                type: "string",
                                format: "at-identifier",
                                description: "Filter to posts which mention the given account. Handles are resolved to DID before query-time. Only matches rich-text facet mentions."
                            },
                            author: {
                                type: "string",
                                format: "at-identifier",
                                description: "Filter to posts by the given account. Handles are resolved to DID before query-time."
                            },
                            lang: {
                                type: "string",
                                format: "language",
                                description: "Filter to posts in the given language. Expected to be based on post language field, though server may override language detection."
                            },
                            domain: {
                                type: "string",
                                description: "Filter to posts with URLs (facet links or embeds) linking to the given domain (hostname). Server may apply hostname normalization."
                            },
                            url: {
                                type: "string",
                                format: "uri",
                                description: "Filter to posts with links (facet links or embeds) pointing to this URL. Server may apply URL normalization or fuzzy matching."
                            },
                            tag: {
                                type: "array",
                                items: {
                                    type: "string",
                                    maxLength: 640,
                                    maxGraphemes: 64
                                },
                                description: "Filter to posts with the given tag (hashtag), based on rich-text facet or tag field. Do not include the hash (#) prefix. Multiple tags can be specified, with 'AND' matching."
                            },
                            viewer: {
                                type: "string",
                                format: "did",
                                description: "DID of the account making the request (not included for public/unauthenticated queries). Used for 'from:me' queries."
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 25
                            },
                            cursor: {
                                type: "string",
                                description: "Optional pagination mechanism; may not necessarily allow scrolling through entire result set."
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "posts"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                hitsTotal: {
                                    type: "integer",
                                    description: "Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits."
                                },
                                posts: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:app.bsky.unspecced.defs#skeletonSearchPost"
                                    }
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "BadQueryString"
                        }
                    ]
                }
            }
        },
        ChatBskyActorDeclaration: {
            lexicon: 1,
            id: "chat.bsky.actor.declaration",
            defs: {
                main: {
                    type: "record",
                    description: "A declaration of a Bluesky chat account.",
                    key: "literal:self",
                    record: {
                        type: "object",
                        required: [
                            "allowIncoming"
                        ],
                        properties: {
                            allowIncoming: {
                                type: "string",
                                knownValues: [
                                    "all",
                                    "none",
                                    "following"
                                ]
                            }
                        }
                    }
                }
            }
        },
        ChatBskyActorDefs: {
            lexicon: 1,
            id: "chat.bsky.actor.defs",
            defs: {
                profileViewBasic: {
                    type: "object",
                    required: [
                        "did",
                        "handle"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        handle: {
                            type: "string",
                            format: "handle"
                        },
                        displayName: {
                            type: "string",
                            maxGraphemes: 64,
                            maxLength: 640
                        },
                        avatar: {
                            type: "string",
                            format: "uri"
                        },
                        associated: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileAssociated"
                        },
                        viewer: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#viewerState"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        chatDisabled: {
                            type: "boolean",
                            description: "Set to true when the actor cannot actively participate in converations"
                        }
                    }
                }
            }
        },
        ChatBskyActorDeleteAccount: {
            lexicon: 1,
            id: "chat.bsky.actor.deleteAccount",
            defs: {
                main: {
                    type: "procedure",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            properties: {}
                        }
                    }
                }
            }
        },
        ChatBskyActorExportAccountData: {
            lexicon: 1,
            id: "chat.bsky.actor.exportAccountData",
            defs: {
                main: {
                    type: "query",
                    output: {
                        encoding: "application/jsonl"
                    }
                }
            }
        },
        ChatBskyConvoDefs: {
            lexicon: 1,
            id: "chat.bsky.convo.defs",
            defs: {
                messageRef: {
                    type: "object",
                    required: [
                        "did",
                        "messageId",
                        "convoId"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        convoId: {
                            type: "string"
                        },
                        messageId: {
                            type: "string"
                        }
                    }
                },
                messageInput: {
                    type: "object",
                    required: [
                        "text"
                    ],
                    properties: {
                        text: {
                            type: "string",
                            maxLength: 1e4,
                            maxGraphemes: 1e3
                        },
                        facets: {
                            type: "array",
                            description: "Annotations of text (mentions, URLs, hashtags, etc)",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.richtext.facet"
                            }
                        },
                        embed: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.embed.record"
                            ]
                        }
                    }
                },
                messageView: {
                    type: "object",
                    required: [
                        "id",
                        "rev",
                        "text",
                        "sender",
                        "sentAt"
                    ],
                    properties: {
                        id: {
                            type: "string"
                        },
                        rev: {
                            type: "string"
                        },
                        text: {
                            type: "string",
                            maxLength: 1e4,
                            maxGraphemes: 1e3
                        },
                        facets: {
                            type: "array",
                            description: "Annotations of text (mentions, URLs, hashtags, etc)",
                            items: {
                                type: "ref",
                                ref: "lex:app.bsky.richtext.facet"
                            }
                        },
                        embed: {
                            type: "union",
                            refs: [
                                "lex:app.bsky.embed.record#view"
                            ]
                        },
                        sender: {
                            type: "ref",
                            ref: "lex:chat.bsky.convo.defs#messageViewSender"
                        },
                        sentAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                deletedMessageView: {
                    type: "object",
                    required: [
                        "id",
                        "rev",
                        "sender",
                        "sentAt"
                    ],
                    properties: {
                        id: {
                            type: "string"
                        },
                        rev: {
                            type: "string"
                        },
                        sender: {
                            type: "ref",
                            ref: "lex:chat.bsky.convo.defs#messageViewSender"
                        },
                        sentAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                messageViewSender: {
                    type: "object",
                    required: [
                        "did"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        }
                    }
                },
                convoView: {
                    type: "object",
                    required: [
                        "id",
                        "rev",
                        "members",
                        "muted",
                        "unreadCount"
                    ],
                    properties: {
                        id: {
                            type: "string"
                        },
                        rev: {
                            type: "string"
                        },
                        members: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:chat.bsky.actor.defs#profileViewBasic"
                            }
                        },
                        lastMessage: {
                            type: "union",
                            refs: [
                                "lex:chat.bsky.convo.defs#messageView",
                                "lex:chat.bsky.convo.defs#deletedMessageView"
                            ]
                        },
                        muted: {
                            type: "boolean"
                        },
                        unreadCount: {
                            type: "integer"
                        }
                    }
                },
                logBeginConvo: {
                    type: "object",
                    required: [
                        "rev",
                        "convoId"
                    ],
                    properties: {
                        rev: {
                            type: "string"
                        },
                        convoId: {
                            type: "string"
                        }
                    }
                },
                logLeaveConvo: {
                    type: "object",
                    required: [
                        "rev",
                        "convoId"
                    ],
                    properties: {
                        rev: {
                            type: "string"
                        },
                        convoId: {
                            type: "string"
                        }
                    }
                },
                logCreateMessage: {
                    type: "object",
                    required: [
                        "rev",
                        "convoId",
                        "message"
                    ],
                    properties: {
                        rev: {
                            type: "string"
                        },
                        convoId: {
                            type: "string"
                        },
                        message: {
                            type: "union",
                            refs: [
                                "lex:chat.bsky.convo.defs#messageView",
                                "lex:chat.bsky.convo.defs#deletedMessageView"
                            ]
                        }
                    }
                },
                logDeleteMessage: {
                    type: "object",
                    required: [
                        "rev",
                        "convoId",
                        "message"
                    ],
                    properties: {
                        rev: {
                            type: "string"
                        },
                        convoId: {
                            type: "string"
                        },
                        message: {
                            type: "union",
                            refs: [
                                "lex:chat.bsky.convo.defs#messageView",
                                "lex:chat.bsky.convo.defs#deletedMessageView"
                            ]
                        }
                    }
                }
            }
        },
        ChatBskyConvoDeleteMessageForSelf: {
            lexicon: 1,
            id: "chat.bsky.convo.deleteMessageForSelf",
            defs: {
                main: {
                    type: "procedure",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convoId",
                                "messageId"
                            ],
                            properties: {
                                convoId: {
                                    type: "string"
                                },
                                messageId: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:chat.bsky.convo.defs#deletedMessageView"
                        }
                    }
                }
            }
        },
        ChatBskyConvoGetConvo: {
            lexicon: 1,
            id: "chat.bsky.convo.getConvo",
            defs: {
                main: {
                    type: "query",
                    parameters: {
                        type: "params",
                        required: [
                            "convoId"
                        ],
                        properties: {
                            convoId: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convo"
                            ],
                            properties: {
                                convo: {
                                    type: "ref",
                                    ref: "lex:chat.bsky.convo.defs#convoView"
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyConvoGetConvoForMembers: {
            lexicon: 1,
            id: "chat.bsky.convo.getConvoForMembers",
            defs: {
                main: {
                    type: "query",
                    parameters: {
                        type: "params",
                        required: [
                            "members"
                        ],
                        properties: {
                            members: {
                                type: "array",
                                minLength: 1,
                                maxLength: 10,
                                items: {
                                    type: "string",
                                    format: "did"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convo"
                            ],
                            properties: {
                                convo: {
                                    type: "ref",
                                    ref: "lex:chat.bsky.convo.defs#convoView"
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyConvoGetLog: {
            lexicon: 1,
            id: "chat.bsky.convo.getLog",
            defs: {
                main: {
                    type: "query",
                    parameters: {
                        type: "params",
                        required: [],
                        properties: {
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "logs"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                logs: {
                                    type: "array",
                                    items: {
                                        type: "union",
                                        refs: [
                                            "lex:chat.bsky.convo.defs#logBeginConvo",
                                            "lex:chat.bsky.convo.defs#logLeaveConvo",
                                            "lex:chat.bsky.convo.defs#logCreateMessage",
                                            "lex:chat.bsky.convo.defs#logDeleteMessage"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyConvoGetMessages: {
            lexicon: 1,
            id: "chat.bsky.convo.getMessages",
            defs: {
                main: {
                    type: "query",
                    parameters: {
                        type: "params",
                        required: [
                            "convoId"
                        ],
                        properties: {
                            convoId: {
                                type: "string"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "messages"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                messages: {
                                    type: "array",
                                    items: {
                                        type: "union",
                                        refs: [
                                            "lex:chat.bsky.convo.defs#messageView",
                                            "lex:chat.bsky.convo.defs#deletedMessageView"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyConvoLeaveConvo: {
            lexicon: 1,
            id: "chat.bsky.convo.leaveConvo",
            defs: {
                main: {
                    type: "procedure",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convoId"
                            ],
                            properties: {
                                convoId: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convoId",
                                "rev"
                            ],
                            properties: {
                                convoId: {
                                    type: "string"
                                },
                                rev: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyConvoListConvos: {
            lexicon: 1,
            id: "chat.bsky.convo.listConvos",
            defs: {
                main: {
                    type: "query",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convos"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                convos: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:chat.bsky.convo.defs#convoView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyConvoMuteConvo: {
            lexicon: 1,
            id: "chat.bsky.convo.muteConvo",
            defs: {
                main: {
                    type: "procedure",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convoId"
                            ],
                            properties: {
                                convoId: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convo"
                            ],
                            properties: {
                                convo: {
                                    type: "ref",
                                    ref: "lex:chat.bsky.convo.defs#convoView"
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyConvoSendMessage: {
            lexicon: 1,
            id: "chat.bsky.convo.sendMessage",
            defs: {
                main: {
                    type: "procedure",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convoId",
                                "message"
                            ],
                            properties: {
                                convoId: {
                                    type: "string"
                                },
                                message: {
                                    type: "ref",
                                    ref: "lex:chat.bsky.convo.defs#messageInput"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:chat.bsky.convo.defs#messageView"
                        }
                    }
                }
            }
        },
        ChatBskyConvoSendMessageBatch: {
            lexicon: 1,
            id: "chat.bsky.convo.sendMessageBatch",
            defs: {
                main: {
                    type: "procedure",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "items"
                            ],
                            properties: {
                                items: {
                                    type: "array",
                                    maxLength: 100,
                                    items: {
                                        type: "ref",
                                        ref: "lex:chat.bsky.convo.sendMessageBatch#batchItem"
                                    }
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "items"
                            ],
                            properties: {
                                items: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:chat.bsky.convo.defs#messageView"
                                    }
                                }
                            }
                        }
                    }
                },
                batchItem: {
                    type: "object",
                    required: [
                        "convoId",
                        "message"
                    ],
                    properties: {
                        convoId: {
                            type: "string"
                        },
                        message: {
                            type: "ref",
                            ref: "lex:chat.bsky.convo.defs#messageInput"
                        }
                    }
                }
            }
        },
        ChatBskyConvoUnmuteConvo: {
            lexicon: 1,
            id: "chat.bsky.convo.unmuteConvo",
            defs: {
                main: {
                    type: "procedure",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convoId"
                            ],
                            properties: {
                                convoId: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convo"
                            ],
                            properties: {
                                convo: {
                                    type: "ref",
                                    ref: "lex:chat.bsky.convo.defs#convoView"
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyConvoUpdateRead: {
            lexicon: 1,
            id: "chat.bsky.convo.updateRead",
            defs: {
                main: {
                    type: "procedure",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convoId"
                            ],
                            properties: {
                                convoId: {
                                    type: "string"
                                },
                                messageId: {
                                    type: "string"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "convo"
                            ],
                            properties: {
                                convo: {
                                    type: "ref",
                                    ref: "lex:chat.bsky.convo.defs#convoView"
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyModerationGetActorMetadata: {
            lexicon: 1,
            id: "chat.bsky.moderation.getActorMetadata",
            defs: {
                main: {
                    type: "query",
                    parameters: {
                        type: "params",
                        required: [
                            "actor"
                        ],
                        properties: {
                            actor: {
                                type: "string",
                                format: "did"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "day",
                                "month",
                                "all"
                            ],
                            properties: {
                                day: {
                                    type: "ref",
                                    ref: "lex:chat.bsky.moderation.getActorMetadata#metadata"
                                },
                                month: {
                                    type: "ref",
                                    ref: "lex:chat.bsky.moderation.getActorMetadata#metadata"
                                },
                                all: {
                                    type: "ref",
                                    ref: "lex:chat.bsky.moderation.getActorMetadata#metadata"
                                }
                            }
                        }
                    }
                },
                metadata: {
                    type: "object",
                    required: [
                        "messagesSent",
                        "messagesReceived",
                        "convos",
                        "convosStarted"
                    ],
                    properties: {
                        messagesSent: {
                            type: "integer"
                        },
                        messagesReceived: {
                            type: "integer"
                        },
                        convos: {
                            type: "integer"
                        },
                        convosStarted: {
                            type: "integer"
                        }
                    }
                }
            }
        },
        ChatBskyModerationGetMessageContext: {
            lexicon: 1,
            id: "chat.bsky.moderation.getMessageContext",
            defs: {
                main: {
                    type: "query",
                    parameters: {
                        type: "params",
                        required: [
                            "messageId"
                        ],
                        properties: {
                            convoId: {
                                type: "string",
                                description: "Conversation that the message is from. NOTE: this field will eventually be required."
                            },
                            messageId: {
                                type: "string"
                            },
                            before: {
                                type: "integer",
                                default: 5
                            },
                            after: {
                                type: "integer",
                                default: 5
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "messages"
                            ],
                            properties: {
                                messages: {
                                    type: "array",
                                    items: {
                                        type: "union",
                                        refs: [
                                            "lex:chat.bsky.convo.defs#messageView",
                                            "lex:chat.bsky.convo.defs#deletedMessageView"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ChatBskyModerationUpdateActorAccess: {
            lexicon: 1,
            id: "chat.bsky.moderation.updateActorAccess",
            defs: {
                main: {
                    type: "procedure",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "actor",
                                "allowAccess"
                            ],
                            properties: {
                                actor: {
                                    type: "string",
                                    format: "did"
                                },
                                allowAccess: {
                                    type: "boolean"
                                },
                                ref: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        ToolsOzoneCommunicationCreateTemplate: {
            lexicon: 1,
            id: "tools.ozone.communication.createTemplate",
            defs: {
                main: {
                    type: "procedure",
                    description: "Administrative action to create a new, re-usable communication (email for now) template.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "subject",
                                "contentMarkdown",
                                "name"
                            ],
                            properties: {
                                name: {
                                    type: "string",
                                    description: "Name of the template."
                                },
                                contentMarkdown: {
                                    type: "string",
                                    description: "Content of the template, markdown supported, can contain variable placeholders."
                                },
                                subject: {
                                    type: "string",
                                    description: "Subject of the message, used in emails."
                                },
                                createdBy: {
                                    type: "string",
                                    format: "did",
                                    description: "DID of the user who is creating the template."
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:tools.ozone.communication.defs#templateView"
                        }
                    }
                }
            }
        },
        ToolsOzoneCommunicationDefs: {
            lexicon: 1,
            id: "tools.ozone.communication.defs",
            defs: {
                templateView: {
                    type: "object",
                    required: [
                        "id",
                        "name",
                        "contentMarkdown",
                        "disabled",
                        "lastUpdatedBy",
                        "createdAt",
                        "updatedAt"
                    ],
                    properties: {
                        id: {
                            type: "string"
                        },
                        name: {
                            type: "string",
                            description: "Name of the template."
                        },
                        subject: {
                            type: "string",
                            description: "Content of the template, can contain markdown and variable placeholders."
                        },
                        contentMarkdown: {
                            type: "string",
                            description: "Subject of the message, used in emails."
                        },
                        disabled: {
                            type: "boolean"
                        },
                        lastUpdatedBy: {
                            type: "string",
                            format: "did",
                            description: "DID of the user who last updated the template."
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        updatedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                }
            }
        },
        ToolsOzoneCommunicationDeleteTemplate: {
            lexicon: 1,
            id: "tools.ozone.communication.deleteTemplate",
            defs: {
                main: {
                    type: "procedure",
                    description: "Delete a communication template.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "id"
                            ],
                            properties: {
                                id: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        ToolsOzoneCommunicationListTemplates: {
            lexicon: 1,
            id: "tools.ozone.communication.listTemplates",
            defs: {
                main: {
                    type: "query",
                    description: "Get list of all communication templates.",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "communicationTemplates"
                            ],
                            properties: {
                                communicationTemplates: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:tools.ozone.communication.defs#templateView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ToolsOzoneCommunicationUpdateTemplate: {
            lexicon: 1,
            id: "tools.ozone.communication.updateTemplate",
            defs: {
                main: {
                    type: "procedure",
                    description: "Administrative action to update an existing communication template. Allows passing partial fields to patch specific fields only.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "id"
                            ],
                            properties: {
                                id: {
                                    type: "string",
                                    description: "ID of the template to be updated."
                                },
                                name: {
                                    type: "string",
                                    description: "Name of the template."
                                },
                                contentMarkdown: {
                                    type: "string",
                                    description: "Content of the template, markdown supported, can contain variable placeholders."
                                },
                                subject: {
                                    type: "string",
                                    description: "Subject of the message, used in emails."
                                },
                                updatedBy: {
                                    type: "string",
                                    format: "did",
                                    description: "DID of the user who is updating the template."
                                },
                                disabled: {
                                    type: "boolean"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:tools.ozone.communication.defs#templateView"
                        }
                    }
                }
            }
        },
        ToolsOzoneModerationDefs: {
            lexicon: 1,
            id: "tools.ozone.moderation.defs",
            defs: {
                modEventView: {
                    type: "object",
                    required: [
                        "id",
                        "event",
                        "subject",
                        "subjectBlobCids",
                        "createdBy",
                        "createdAt"
                    ],
                    properties: {
                        id: {
                            type: "integer"
                        },
                        event: {
                            type: "union",
                            refs: [
                                "lex:tools.ozone.moderation.defs#modEventTakedown",
                                "lex:tools.ozone.moderation.defs#modEventReverseTakedown",
                                "lex:tools.ozone.moderation.defs#modEventComment",
                                "lex:tools.ozone.moderation.defs#modEventReport",
                                "lex:tools.ozone.moderation.defs#modEventLabel",
                                "lex:tools.ozone.moderation.defs#modEventAcknowledge",
                                "lex:tools.ozone.moderation.defs#modEventEscalate",
                                "lex:tools.ozone.moderation.defs#modEventMute",
                                "lex:tools.ozone.moderation.defs#modEventUnmute",
                                "lex:tools.ozone.moderation.defs#modEventMuteReporter",
                                "lex:tools.ozone.moderation.defs#modEventUnmuteReporter",
                                "lex:tools.ozone.moderation.defs#modEventEmail",
                                "lex:tools.ozone.moderation.defs#modEventResolveAppeal",
                                "lex:tools.ozone.moderation.defs#modEventDivert",
                                "lex:tools.ozone.moderation.defs#modEventTag"
                            ]
                        },
                        subject: {
                            type: "union",
                            refs: [
                                "lex:com.atproto.admin.defs#repoRef",
                                "lex:com.atproto.repo.strongRef",
                                "lex:chat.bsky.convo.defs#messageRef"
                            ]
                        },
                        subjectBlobCids: {
                            type: "array",
                            items: {
                                type: "string"
                            }
                        },
                        createdBy: {
                            type: "string",
                            format: "did"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        creatorHandle: {
                            type: "string"
                        },
                        subjectHandle: {
                            type: "string"
                        }
                    }
                },
                modEventViewDetail: {
                    type: "object",
                    required: [
                        "id",
                        "event",
                        "subject",
                        "subjectBlobs",
                        "createdBy",
                        "createdAt"
                    ],
                    properties: {
                        id: {
                            type: "integer"
                        },
                        event: {
                            type: "union",
                            refs: [
                                "lex:tools.ozone.moderation.defs#modEventTakedown",
                                "lex:tools.ozone.moderation.defs#modEventReverseTakedown",
                                "lex:tools.ozone.moderation.defs#modEventComment",
                                "lex:tools.ozone.moderation.defs#modEventReport",
                                "lex:tools.ozone.moderation.defs#modEventLabel",
                                "lex:tools.ozone.moderation.defs#modEventAcknowledge",
                                "lex:tools.ozone.moderation.defs#modEventEscalate",
                                "lex:tools.ozone.moderation.defs#modEventMute",
                                "lex:tools.ozone.moderation.defs#modEventUnmute",
                                "lex:tools.ozone.moderation.defs#modEventMuteReporter",
                                "lex:tools.ozone.moderation.defs#modEventUnmuteReporter",
                                "lex:tools.ozone.moderation.defs#modEventEmail",
                                "lex:tools.ozone.moderation.defs#modEventResolveAppeal",
                                "lex:tools.ozone.moderation.defs#modEventDivert",
                                "lex:tools.ozone.moderation.defs#modEventTag"
                            ]
                        },
                        subject: {
                            type: "union",
                            refs: [
                                "lex:tools.ozone.moderation.defs#repoView",
                                "lex:tools.ozone.moderation.defs#repoViewNotFound",
                                "lex:tools.ozone.moderation.defs#recordView",
                                "lex:tools.ozone.moderation.defs#recordViewNotFound"
                            ]
                        },
                        subjectBlobs: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:tools.ozone.moderation.defs#blobView"
                            }
                        },
                        createdBy: {
                            type: "string",
                            format: "did"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                subjectStatusView: {
                    type: "object",
                    required: [
                        "id",
                        "subject",
                        "createdAt",
                        "updatedAt",
                        "reviewState"
                    ],
                    properties: {
                        id: {
                            type: "integer"
                        },
                        subject: {
                            type: "union",
                            refs: [
                                "lex:com.atproto.admin.defs#repoRef",
                                "lex:com.atproto.repo.strongRef"
                            ]
                        },
                        subjectBlobCids: {
                            type: "array",
                            items: {
                                type: "string",
                                format: "cid"
                            }
                        },
                        subjectRepoHandle: {
                            type: "string"
                        },
                        updatedAt: {
                            type: "string",
                            format: "datetime",
                            description: "Timestamp referencing when the last update was made to the moderation status of the subject"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime",
                            description: "Timestamp referencing the first moderation status impacting event was emitted on the subject"
                        },
                        reviewState: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#subjectReviewState"
                        },
                        comment: {
                            type: "string",
                            description: "Sticky comment on the subject."
                        },
                        muteUntil: {
                            type: "string",
                            format: "datetime"
                        },
                        muteReportingUntil: {
                            type: "string",
                            format: "datetime"
                        },
                        lastReviewedBy: {
                            type: "string",
                            format: "did"
                        },
                        lastReviewedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        lastReportedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        lastAppealedAt: {
                            type: "string",
                            format: "datetime",
                            description: "Timestamp referencing when the author of the subject appealed a moderation action"
                        },
                        takendown: {
                            type: "boolean"
                        },
                        appealed: {
                            type: "boolean",
                            description: "True indicates that the a previously taken moderator action was appealed against, by the author of the content. False indicates last appeal was resolved by moderators."
                        },
                        suspendUntil: {
                            type: "string",
                            format: "datetime"
                        },
                        tags: {
                            type: "array",
                            items: {
                                type: "string"
                            }
                        }
                    }
                },
                subjectReviewState: {
                    type: "string",
                    knownValues: [
                        "lex:tools.ozone.moderation.defs#reviewOpen",
                        "lex:tools.ozone.moderation.defs#reviewEscalated",
                        "lex:tools.ozone.moderation.defs#reviewClosed",
                        "lex:tools.ozone.moderation.defs#reviewNone"
                    ]
                },
                reviewOpen: {
                    type: "token",
                    description: "Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator"
                },
                reviewEscalated: {
                    type: "token",
                    description: "Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator"
                },
                reviewClosed: {
                    type: "token",
                    description: "Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator"
                },
                reviewNone: {
                    type: "token",
                    description: "Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it"
                },
                modEventTakedown: {
                    type: "object",
                    description: "Take down a subject permanently or temporarily",
                    properties: {
                        comment: {
                            type: "string"
                        },
                        durationInHours: {
                            type: "integer",
                            description: "Indicates how long the takedown should be in effect before automatically expiring."
                        }
                    }
                },
                modEventReverseTakedown: {
                    type: "object",
                    description: "Revert take down action on a subject",
                    properties: {
                        comment: {
                            type: "string",
                            description: "Describe reasoning behind the reversal."
                        }
                    }
                },
                modEventResolveAppeal: {
                    type: "object",
                    description: "Resolve appeal on a subject",
                    properties: {
                        comment: {
                            type: "string",
                            description: "Describe resolution."
                        }
                    }
                },
                modEventComment: {
                    type: "object",
                    description: "Add a comment to a subject",
                    required: [
                        "comment"
                    ],
                    properties: {
                        comment: {
                            type: "string"
                        },
                        sticky: {
                            type: "boolean",
                            description: "Make the comment persistent on the subject"
                        }
                    }
                },
                modEventReport: {
                    type: "object",
                    description: "Report a subject",
                    required: [
                        "reportType"
                    ],
                    properties: {
                        comment: {
                            type: "string"
                        },
                        isReporterMuted: {
                            type: "boolean",
                            description: "Set to true if the reporter was muted from reporting at the time of the event. These reports won't impact the reviewState of the subject."
                        },
                        reportType: {
                            type: "ref",
                            ref: "lex:com.atproto.moderation.defs#reasonType"
                        }
                    }
                },
                modEventLabel: {
                    type: "object",
                    description: "Apply/Negate labels on a subject",
                    required: [
                        "createLabelVals",
                        "negateLabelVals"
                    ],
                    properties: {
                        comment: {
                            type: "string"
                        },
                        createLabelVals: {
                            type: "array",
                            items: {
                                type: "string"
                            }
                        },
                        negateLabelVals: {
                            type: "array",
                            items: {
                                type: "string"
                            }
                        }
                    }
                },
                modEventAcknowledge: {
                    type: "object",
                    properties: {
                        comment: {
                            type: "string"
                        }
                    }
                },
                modEventEscalate: {
                    type: "object",
                    properties: {
                        comment: {
                            type: "string"
                        }
                    }
                },
                modEventMute: {
                    type: "object",
                    description: "Mute incoming reports on a subject",
                    required: [
                        "durationInHours"
                    ],
                    properties: {
                        comment: {
                            type: "string"
                        },
                        durationInHours: {
                            type: "integer",
                            description: "Indicates how long the subject should remain muted."
                        }
                    }
                },
                modEventUnmute: {
                    type: "object",
                    description: "Unmute action on a subject",
                    properties: {
                        comment: {
                            type: "string",
                            description: "Describe reasoning behind the reversal."
                        }
                    }
                },
                modEventMuteReporter: {
                    type: "object",
                    description: "Mute incoming reports from an account",
                    required: [
                        "durationInHours"
                    ],
                    properties: {
                        comment: {
                            type: "string"
                        },
                        durationInHours: {
                            type: "integer",
                            description: "Indicates how long the account should remain muted."
                        }
                    }
                },
                modEventUnmuteReporter: {
                    type: "object",
                    description: "Unmute incoming reports from an account",
                    properties: {
                        comment: {
                            type: "string",
                            description: "Describe reasoning behind the reversal."
                        }
                    }
                },
                modEventEmail: {
                    type: "object",
                    description: "Keep a log of outgoing email to a user",
                    required: [
                        "subjectLine"
                    ],
                    properties: {
                        subjectLine: {
                            type: "string",
                            description: "The subject line of the email sent to the user."
                        },
                        content: {
                            type: "string",
                            description: "The content of the email sent to the user."
                        },
                        comment: {
                            type: "string",
                            description: "Additional comment about the outgoing comm."
                        }
                    }
                },
                modEventDivert: {
                    type: "object",
                    description: "Divert a record's blobs to a 3rd party service for further scanning/tagging",
                    properties: {
                        comment: {
                            type: "string"
                        }
                    }
                },
                modEventTag: {
                    type: "object",
                    description: "Add/Remove a tag on a subject",
                    required: [
                        "add",
                        "remove"
                    ],
                    properties: {
                        add: {
                            type: "array",
                            items: {
                                type: "string"
                            },
                            description: "Tags to be added to the subject. If already exists, won't be duplicated."
                        },
                        remove: {
                            type: "array",
                            items: {
                                type: "string"
                            },
                            description: "Tags to be removed to the subject. Ignores a tag If it doesn't exist, won't be duplicated."
                        },
                        comment: {
                            type: "string",
                            description: "Additional comment about added/removed tags."
                        }
                    }
                },
                repoView: {
                    type: "object",
                    required: [
                        "did",
                        "handle",
                        "relatedRecords",
                        "indexedAt",
                        "moderation"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        handle: {
                            type: "string",
                            format: "handle"
                        },
                        email: {
                            type: "string"
                        },
                        relatedRecords: {
                            type: "array",
                            items: {
                                type: "unknown"
                            }
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        moderation: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#moderation"
                        },
                        invitedBy: {
                            type: "ref",
                            ref: "lex:com.atproto.server.defs#inviteCode"
                        },
                        invitesDisabled: {
                            type: "boolean"
                        },
                        inviteNote: {
                            type: "string"
                        },
                        deactivatedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                repoViewDetail: {
                    type: "object",
                    required: [
                        "did",
                        "handle",
                        "relatedRecords",
                        "indexedAt",
                        "moderation"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        handle: {
                            type: "string",
                            format: "handle"
                        },
                        email: {
                            type: "string"
                        },
                        relatedRecords: {
                            type: "array",
                            items: {
                                type: "unknown"
                            }
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        moderation: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#moderationDetail"
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        invitedBy: {
                            type: "ref",
                            ref: "lex:com.atproto.server.defs#inviteCode"
                        },
                        invites: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.server.defs#inviteCode"
                            }
                        },
                        invitesDisabled: {
                            type: "boolean"
                        },
                        inviteNote: {
                            type: "string"
                        },
                        emailConfirmedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        deactivatedAt: {
                            type: "string",
                            format: "datetime"
                        }
                    }
                },
                repoViewNotFound: {
                    type: "object",
                    required: [
                        "did"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        }
                    }
                },
                recordView: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "value",
                        "blobCids",
                        "indexedAt",
                        "moderation",
                        "repo"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        value: {
                            type: "unknown"
                        },
                        blobCids: {
                            type: "array",
                            items: {
                                type: "string",
                                format: "cid"
                            }
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        moderation: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#moderation"
                        },
                        repo: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#repoView"
                        }
                    }
                },
                recordViewDetail: {
                    type: "object",
                    required: [
                        "uri",
                        "cid",
                        "value",
                        "blobs",
                        "indexedAt",
                        "moderation",
                        "repo"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        },
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        value: {
                            type: "unknown"
                        },
                        blobs: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:tools.ozone.moderation.defs#blobView"
                            }
                        },
                        labels: {
                            type: "array",
                            items: {
                                type: "ref",
                                ref: "lex:com.atproto.label.defs#label"
                            }
                        },
                        indexedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        moderation: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#moderationDetail"
                        },
                        repo: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#repoView"
                        }
                    }
                },
                recordViewNotFound: {
                    type: "object",
                    required: [
                        "uri"
                    ],
                    properties: {
                        uri: {
                            type: "string",
                            format: "at-uri"
                        }
                    }
                },
                moderation: {
                    type: "object",
                    properties: {
                        subjectStatus: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#subjectStatusView"
                        }
                    }
                },
                moderationDetail: {
                    type: "object",
                    properties: {
                        subjectStatus: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#subjectStatusView"
                        }
                    }
                },
                blobView: {
                    type: "object",
                    required: [
                        "cid",
                        "mimeType",
                        "size",
                        "createdAt"
                    ],
                    properties: {
                        cid: {
                            type: "string",
                            format: "cid"
                        },
                        mimeType: {
                            type: "string"
                        },
                        size: {
                            type: "integer"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        details: {
                            type: "union",
                            refs: [
                                "lex:tools.ozone.moderation.defs#imageDetails",
                                "lex:tools.ozone.moderation.defs#videoDetails"
                            ]
                        },
                        moderation: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#moderation"
                        }
                    }
                },
                imageDetails: {
                    type: "object",
                    required: [
                        "width",
                        "height"
                    ],
                    properties: {
                        width: {
                            type: "integer"
                        },
                        height: {
                            type: "integer"
                        }
                    }
                },
                videoDetails: {
                    type: "object",
                    required: [
                        "width",
                        "height",
                        "length"
                    ],
                    properties: {
                        width: {
                            type: "integer"
                        },
                        height: {
                            type: "integer"
                        },
                        length: {
                            type: "integer"
                        }
                    }
                }
            }
        },
        ToolsOzoneModerationEmitEvent: {
            lexicon: 1,
            id: "tools.ozone.moderation.emitEvent",
            defs: {
                main: {
                    type: "procedure",
                    description: "Take a moderation action on an actor.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "event",
                                "subject",
                                "createdBy"
                            ],
                            properties: {
                                event: {
                                    type: "union",
                                    refs: [
                                        "lex:tools.ozone.moderation.defs#modEventTakedown",
                                        "lex:tools.ozone.moderation.defs#modEventAcknowledge",
                                        "lex:tools.ozone.moderation.defs#modEventEscalate",
                                        "lex:tools.ozone.moderation.defs#modEventComment",
                                        "lex:tools.ozone.moderation.defs#modEventLabel",
                                        "lex:tools.ozone.moderation.defs#modEventReport",
                                        "lex:tools.ozone.moderation.defs#modEventMute",
                                        "lex:tools.ozone.moderation.defs#modEventUnmute",
                                        "lex:tools.ozone.moderation.defs#modEventMuteReporter",
                                        "lex:tools.ozone.moderation.defs#modEventUnmuteReporter",
                                        "lex:tools.ozone.moderation.defs#modEventReverseTakedown",
                                        "lex:tools.ozone.moderation.defs#modEventEmail",
                                        "lex:tools.ozone.moderation.defs#modEventTag"
                                    ]
                                },
                                subject: {
                                    type: "union",
                                    refs: [
                                        "lex:com.atproto.admin.defs#repoRef",
                                        "lex:com.atproto.repo.strongRef"
                                    ]
                                },
                                subjectBlobCids: {
                                    type: "array",
                                    items: {
                                        type: "string",
                                        format: "cid"
                                    }
                                },
                                createdBy: {
                                    type: "string",
                                    format: "did"
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#modEventView"
                        }
                    },
                    errors: [
                        {
                            name: "SubjectHasAction"
                        }
                    ]
                }
            }
        },
        ToolsOzoneModerationGetEvent: {
            lexicon: 1,
            id: "tools.ozone.moderation.getEvent",
            defs: {
                main: {
                    type: "query",
                    description: "Get details about a moderation event.",
                    parameters: {
                        type: "params",
                        required: [
                            "id"
                        ],
                        properties: {
                            id: {
                                type: "integer"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#modEventViewDetail"
                        }
                    }
                }
            }
        },
        ToolsOzoneModerationGetRecord: {
            lexicon: 1,
            id: "tools.ozone.moderation.getRecord",
            defs: {
                main: {
                    type: "query",
                    description: "Get details about a record.",
                    parameters: {
                        type: "params",
                        required: [
                            "uri"
                        ],
                        properties: {
                            uri: {
                                type: "string",
                                format: "at-uri"
                            },
                            cid: {
                                type: "string",
                                format: "cid"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#recordViewDetail"
                        }
                    },
                    errors: [
                        {
                            name: "RecordNotFound"
                        }
                    ]
                }
            }
        },
        ToolsOzoneModerationGetRepo: {
            lexicon: 1,
            id: "tools.ozone.moderation.getRepo",
            defs: {
                main: {
                    type: "query",
                    description: "Get details about a repository.",
                    parameters: {
                        type: "params",
                        required: [
                            "did"
                        ],
                        properties: {
                            did: {
                                type: "string",
                                format: "did"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:tools.ozone.moderation.defs#repoViewDetail"
                        }
                    },
                    errors: [
                        {
                            name: "RepoNotFound"
                        }
                    ]
                }
            }
        },
        ToolsOzoneModerationQueryEvents: {
            lexicon: 1,
            id: "tools.ozone.moderation.queryEvents",
            defs: {
                main: {
                    type: "query",
                    description: "List moderation events related to a subject.",
                    parameters: {
                        type: "params",
                        properties: {
                            types: {
                                type: "array",
                                items: {
                                    type: "string"
                                },
                                description: "The types of events (fully qualified string in the format of tools.ozone.moderation.defs#modEvent<name>) to filter by. If not specified, all events are returned."
                            },
                            createdBy: {
                                type: "string",
                                format: "did"
                            },
                            sortDirection: {
                                type: "string",
                                default: "desc",
                                enum: [
                                    "asc",
                                    "desc"
                                ],
                                description: "Sort direction for the events. Defaults to descending order of created at timestamp."
                            },
                            createdAfter: {
                                type: "string",
                                format: "datetime",
                                description: "Retrieve events created after a given timestamp"
                            },
                            createdBefore: {
                                type: "string",
                                format: "datetime",
                                description: "Retrieve events created before a given timestamp"
                            },
                            subject: {
                                type: "string",
                                format: "uri"
                            },
                            includeAllUserRecords: {
                                type: "boolean",
                                default: !1,
                                description: "If true, events on all record types (posts, lists, profile etc.) owned by the did are returned"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            hasComment: {
                                type: "boolean",
                                description: "If true, only events with comments are returned"
                            },
                            comment: {
                                type: "string",
                                description: "If specified, only events with comments containing the keyword are returned"
                            },
                            addedLabels: {
                                type: "array",
                                items: {
                                    type: "string"
                                },
                                description: "If specified, only events where all of these labels were added are returned"
                            },
                            removedLabels: {
                                type: "array",
                                items: {
                                    type: "string"
                                },
                                description: "If specified, only events where all of these labels were removed are returned"
                            },
                            addedTags: {
                                type: "array",
                                items: {
                                    type: "string"
                                },
                                description: "If specified, only events where all of these tags were added are returned"
                            },
                            removedTags: {
                                type: "array",
                                items: {
                                    type: "string"
                                },
                                description: "If specified, only events where all of these tags were removed are returned"
                            },
                            reportTypes: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "events"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                events: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:tools.ozone.moderation.defs#modEventView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ToolsOzoneModerationQueryStatuses: {
            lexicon: 1,
            id: "tools.ozone.moderation.queryStatuses",
            defs: {
                main: {
                    type: "query",
                    description: "View moderation statuses of subjects (record or repo).",
                    parameters: {
                        type: "params",
                        properties: {
                            subject: {
                                type: "string",
                                format: "uri"
                            },
                            comment: {
                                type: "string",
                                description: "Search subjects by keyword from comments"
                            },
                            reportedAfter: {
                                type: "string",
                                format: "datetime",
                                description: "Search subjects reported after a given timestamp"
                            },
                            reportedBefore: {
                                type: "string",
                                format: "datetime",
                                description: "Search subjects reported before a given timestamp"
                            },
                            reviewedAfter: {
                                type: "string",
                                format: "datetime",
                                description: "Search subjects reviewed after a given timestamp"
                            },
                            reviewedBefore: {
                                type: "string",
                                format: "datetime",
                                description: "Search subjects reviewed before a given timestamp"
                            },
                            includeMuted: {
                                type: "boolean",
                                description: "By default, we don't include muted subjects in the results. Set this to true to include them."
                            },
                            onlyMuted: {
                                type: "boolean",
                                description: "When set to true, only muted subjects and reporters will be returned."
                            },
                            reviewState: {
                                type: "string",
                                description: "Specify when fetching subjects in a certain state"
                            },
                            ignoreSubjects: {
                                type: "array",
                                items: {
                                    type: "string",
                                    format: "uri"
                                }
                            },
                            lastReviewedBy: {
                                type: "string",
                                format: "did",
                                description: "Get all subject statuses that were reviewed by a specific moderator"
                            },
                            sortField: {
                                type: "string",
                                default: "lastReportedAt",
                                enum: [
                                    "lastReviewedAt",
                                    "lastReportedAt"
                                ]
                            },
                            sortDirection: {
                                type: "string",
                                default: "desc",
                                enum: [
                                    "asc",
                                    "desc"
                                ]
                            },
                            takendown: {
                                type: "boolean",
                                description: "Get subjects that were taken down"
                            },
                            appealed: {
                                type: "boolean",
                                description: "Get subjects in unresolved appealed status"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            tags: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            },
                            excludeTags: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "subjectStatuses"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                subjectStatuses: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:tools.ozone.moderation.defs#subjectStatusView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ToolsOzoneModerationSearchRepos: {
            lexicon: 1,
            id: "tools.ozone.moderation.searchRepos",
            defs: {
                main: {
                    type: "query",
                    description: "Find repositories based on a search term.",
                    parameters: {
                        type: "params",
                        properties: {
                            term: {
                                type: "string",
                                description: "DEPRECATED: use 'q' instead"
                            },
                            q: {
                                type: "string"
                            },
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "repos"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                repos: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:tools.ozone.moderation.defs#repoView"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ToolsOzoneServerGetConfig: {
            lexicon: 1,
            id: "tools.ozone.server.getConfig",
            defs: {
                main: {
                    type: "query",
                    description: "Get details about ozone's server configuration.",
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            properties: {
                                appview: {
                                    type: "ref",
                                    ref: "lex:tools.ozone.server.getConfig#serviceConfig"
                                },
                                pds: {
                                    type: "ref",
                                    ref: "lex:tools.ozone.server.getConfig#serviceConfig"
                                },
                                blobDivert: {
                                    type: "ref",
                                    ref: "lex:tools.ozone.server.getConfig#serviceConfig"
                                },
                                chat: {
                                    type: "ref",
                                    ref: "lex:tools.ozone.server.getConfig#serviceConfig"
                                },
                                viewer: {
                                    type: "ref",
                                    ref: "lex:tools.ozone.server.getConfig#viewerConfig"
                                }
                            }
                        }
                    }
                },
                serviceConfig: {
                    type: "object",
                    properties: {
                        url: {
                            type: "string",
                            format: "uri"
                        }
                    }
                },
                viewerConfig: {
                    type: "object",
                    properties: {
                        role: {
                            type: "string",
                            knownValues: [
                                "tools.ozone.team.defs#roleAdmin",
                                "tools.ozone.team.defs#roleModerator",
                                "tools.ozone.team.defs#roleTriage"
                            ]
                        }
                    }
                }
            }
        },
        ToolsOzoneTeamAddMember: {
            lexicon: 1,
            id: "tools.ozone.team.addMember",
            defs: {
                main: {
                    type: "procedure",
                    description: "Add a member to the ozone team. Requires admin role.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did",
                                "role"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                role: {
                                    type: "string",
                                    knownValues: [
                                        "tools.ozone.team.defs#roleAdmin",
                                        "tools.ozone.team.defs#roleModerator",
                                        "tools.ozone.team.defs#roleTriage"
                                    ]
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:tools.ozone.team.defs#member"
                        }
                    },
                    errors: [
                        {
                            name: "MemberAlreadyExists",
                            description: "Member already exists in the team."
                        }
                    ]
                }
            }
        },
        ToolsOzoneTeamDefs: {
            lexicon: 1,
            id: "tools.ozone.team.defs",
            defs: {
                member: {
                    type: "object",
                    required: [
                        "did",
                        "role"
                    ],
                    properties: {
                        did: {
                            type: "string",
                            format: "did"
                        },
                        disabled: {
                            type: "boolean"
                        },
                        profile: {
                            type: "ref",
                            ref: "lex:app.bsky.actor.defs#profileViewDetailed"
                        },
                        createdAt: {
                            type: "string",
                            format: "datetime"
                        },
                        updatedAt: {
                            type: "string",
                            format: "datetime"
                        },
                        lastUpdatedBy: {
                            type: "string"
                        },
                        role: {
                            type: "string",
                            knownValues: [
                                "lex:tools.ozone.team.defs#roleAdmin",
                                "lex:tools.ozone.team.defs#roleModerator",
                                "lex:tools.ozone.team.defs#roleTriage"
                            ]
                        }
                    }
                },
                roleAdmin: {
                    type: "token",
                    description: "Admin role. Highest level of access, can perform all actions."
                },
                roleModerator: {
                    type: "token",
                    description: "Moderator role. Can perform most actions."
                },
                roleTriage: {
                    type: "token",
                    description: "Triage role. Mostly intended for monitoring and escalating issues."
                }
            }
        },
        ToolsOzoneTeamDeleteMember: {
            lexicon: 1,
            id: "tools.ozone.team.deleteMember",
            defs: {
                main: {
                    type: "procedure",
                    description: "Delete a member from ozone team. Requires admin role.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                }
                            }
                        }
                    },
                    errors: [
                        {
                            name: "MemberNotFound",
                            description: "The member being deleted does not exist"
                        },
                        {
                            name: "CannotDeleteSelf",
                            description: "You can not delete yourself from the team"
                        }
                    ]
                }
            }
        },
        ToolsOzoneTeamListMembers: {
            lexicon: 1,
            id: "tools.ozone.team.listMembers",
            defs: {
                main: {
                    type: "query",
                    description: "List all members with access to the ozone service.",
                    parameters: {
                        type: "params",
                        properties: {
                            limit: {
                                type: "integer",
                                minimum: 1,
                                maximum: 100,
                                default: 50
                            },
                            cursor: {
                                type: "string"
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "members"
                            ],
                            properties: {
                                cursor: {
                                    type: "string"
                                },
                                members: {
                                    type: "array",
                                    items: {
                                        type: "ref",
                                        ref: "lex:tools.ozone.team.defs#member"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        ToolsOzoneTeamUpdateMember: {
            lexicon: 1,
            id: "tools.ozone.team.updateMember",
            defs: {
                main: {
                    type: "procedure",
                    description: "Update a member in the ozone service. Requires admin role.",
                    input: {
                        encoding: "application/json",
                        schema: {
                            type: "object",
                            required: [
                                "did"
                            ],
                            properties: {
                                did: {
                                    type: "string",
                                    format: "did"
                                },
                                disabled: {
                                    type: "boolean"
                                },
                                role: {
                                    type: "string",
                                    knownValues: [
                                        "tools.ozone.team.defs#roleAdmin",
                                        "tools.ozone.team.defs#roleModerator",
                                        "tools.ozone.team.defs#roleTriage"
                                    ]
                                }
                            }
                        }
                    },
                    output: {
                        encoding: "application/json",
                        schema: {
                            type: "ref",
                            ref: "lex:tools.ozone.team.defs#member"
                        }
                    },
                    errors: [
                        {
                            name: "MemberNotFound",
                            description: "The member being updated does not exist in the team"
                        }
                    ]
                }
            }
        }
    }, t.schemas = Object.values(t.schemaDict), t.lexicons = new e.Lexicons(t.schemas), t.ids = {
        ComAtprotoAdminDefs: "com.atproto.admin.defs",
        ComAtprotoAdminDeleteAccount: "com.atproto.admin.deleteAccount",
        ComAtprotoAdminDisableAccountInvites: "com.atproto.admin.disableAccountInvites",
        ComAtprotoAdminDisableInviteCodes: "com.atproto.admin.disableInviteCodes",
        ComAtprotoAdminEnableAccountInvites: "com.atproto.admin.enableAccountInvites",
        ComAtprotoAdminGetAccountInfo: "com.atproto.admin.getAccountInfo",
        ComAtprotoAdminGetAccountInfos: "com.atproto.admin.getAccountInfos",
        ComAtprotoAdminGetInviteCodes: "com.atproto.admin.getInviteCodes",
        ComAtprotoAdminGetSubjectStatus: "com.atproto.admin.getSubjectStatus",
        ComAtprotoAdminSearchAccounts: "com.atproto.admin.searchAccounts",
        ComAtprotoAdminSendEmail: "com.atproto.admin.sendEmail",
        ComAtprotoAdminUpdateAccountEmail: "com.atproto.admin.updateAccountEmail",
        ComAtprotoAdminUpdateAccountHandle: "com.atproto.admin.updateAccountHandle",
        ComAtprotoAdminUpdateAccountPassword: "com.atproto.admin.updateAccountPassword",
        ComAtprotoAdminUpdateSubjectStatus: "com.atproto.admin.updateSubjectStatus",
        ComAtprotoIdentityGetRecommendedDidCredentials: "com.atproto.identity.getRecommendedDidCredentials",
        ComAtprotoIdentityRequestPlcOperationSignature: "com.atproto.identity.requestPlcOperationSignature",
        ComAtprotoIdentityResolveHandle: "com.atproto.identity.resolveHandle",
        ComAtprotoIdentitySignPlcOperation: "com.atproto.identity.signPlcOperation",
        ComAtprotoIdentitySubmitPlcOperation: "com.atproto.identity.submitPlcOperation",
        ComAtprotoIdentityUpdateHandle: "com.atproto.identity.updateHandle",
        ComAtprotoLabelDefs: "com.atproto.label.defs",
        ComAtprotoLabelQueryLabels: "com.atproto.label.queryLabels",
        ComAtprotoLabelSubscribeLabels: "com.atproto.label.subscribeLabels",
        ComAtprotoModerationCreateReport: "com.atproto.moderation.createReport",
        ComAtprotoModerationDefs: "com.atproto.moderation.defs",
        ComAtprotoRepoApplyWrites: "com.atproto.repo.applyWrites",
        ComAtprotoRepoCreateRecord: "com.atproto.repo.createRecord",
        ComAtprotoRepoDeleteRecord: "com.atproto.repo.deleteRecord",
        ComAtprotoRepoDescribeRepo: "com.atproto.repo.describeRepo",
        ComAtprotoRepoGetRecord: "com.atproto.repo.getRecord",
        ComAtprotoRepoImportRepo: "com.atproto.repo.importRepo",
        ComAtprotoRepoListMissingBlobs: "com.atproto.repo.listMissingBlobs",
        ComAtprotoRepoListRecords: "com.atproto.repo.listRecords",
        ComAtprotoRepoPutRecord: "com.atproto.repo.putRecord",
        ComAtprotoRepoStrongRef: "com.atproto.repo.strongRef",
        ComAtprotoRepoUploadBlob: "com.atproto.repo.uploadBlob",
        ComAtprotoServerActivateAccount: "com.atproto.server.activateAccount",
        ComAtprotoServerCheckAccountStatus: "com.atproto.server.checkAccountStatus",
        ComAtprotoServerConfirmEmail: "com.atproto.server.confirmEmail",
        ComAtprotoServerCreateAccount: "com.atproto.server.createAccount",
        ComAtprotoServerCreateAppPassword: "com.atproto.server.createAppPassword",
        ComAtprotoServerCreateInviteCode: "com.atproto.server.createInviteCode",
        ComAtprotoServerCreateInviteCodes: "com.atproto.server.createInviteCodes",
        ComAtprotoServerCreateSession: "com.atproto.server.createSession",
        ComAtprotoServerDeactivateAccount: "com.atproto.server.deactivateAccount",
        ComAtprotoServerDefs: "com.atproto.server.defs",
        ComAtprotoServerDeleteAccount: "com.atproto.server.deleteAccount",
        ComAtprotoServerDeleteSession: "com.atproto.server.deleteSession",
        ComAtprotoServerDescribeServer: "com.atproto.server.describeServer",
        ComAtprotoServerGetAccountInviteCodes: "com.atproto.server.getAccountInviteCodes",
        ComAtprotoServerGetServiceAuth: "com.atproto.server.getServiceAuth",
        ComAtprotoServerGetSession: "com.atproto.server.getSession",
        ComAtprotoServerListAppPasswords: "com.atproto.server.listAppPasswords",
        ComAtprotoServerRefreshSession: "com.atproto.server.refreshSession",
        ComAtprotoServerRequestAccountDelete: "com.atproto.server.requestAccountDelete",
        ComAtprotoServerRequestEmailConfirmation: "com.atproto.server.requestEmailConfirmation",
        ComAtprotoServerRequestEmailUpdate: "com.atproto.server.requestEmailUpdate",
        ComAtprotoServerRequestPasswordReset: "com.atproto.server.requestPasswordReset",
        ComAtprotoServerReserveSigningKey: "com.atproto.server.reserveSigningKey",
        ComAtprotoServerResetPassword: "com.atproto.server.resetPassword",
        ComAtprotoServerRevokeAppPassword: "com.atproto.server.revokeAppPassword",
        ComAtprotoServerUpdateEmail: "com.atproto.server.updateEmail",
        ComAtprotoSyncGetBlob: "com.atproto.sync.getBlob",
        ComAtprotoSyncGetBlocks: "com.atproto.sync.getBlocks",
        ComAtprotoSyncGetCheckout: "com.atproto.sync.getCheckout",
        ComAtprotoSyncGetHead: "com.atproto.sync.getHead",
        ComAtprotoSyncGetLatestCommit: "com.atproto.sync.getLatestCommit",
        ComAtprotoSyncGetRecord: "com.atproto.sync.getRecord",
        ComAtprotoSyncGetRepo: "com.atproto.sync.getRepo",
        ComAtprotoSyncGetRepoStatus: "com.atproto.sync.getRepoStatus",
        ComAtprotoSyncListBlobs: "com.atproto.sync.listBlobs",
        ComAtprotoSyncListRepos: "com.atproto.sync.listRepos",
        ComAtprotoSyncNotifyOfUpdate: "com.atproto.sync.notifyOfUpdate",
        ComAtprotoSyncRequestCrawl: "com.atproto.sync.requestCrawl",
        ComAtprotoSyncSubscribeRepos: "com.atproto.sync.subscribeRepos",
        ComAtprotoTempCheckSignupQueue: "com.atproto.temp.checkSignupQueue",
        ComAtprotoTempFetchLabels: "com.atproto.temp.fetchLabels",
        ComAtprotoTempRequestPhoneVerification: "com.atproto.temp.requestPhoneVerification",
        AppBskyActorDefs: "app.bsky.actor.defs",
        AppBskyActorGetPreferences: "app.bsky.actor.getPreferences",
        AppBskyActorGetProfile: "app.bsky.actor.getProfile",
        AppBskyActorGetProfiles: "app.bsky.actor.getProfiles",
        AppBskyActorGetSuggestions: "app.bsky.actor.getSuggestions",
        AppBskyActorProfile: "app.bsky.actor.profile",
        AppBskyActorPutPreferences: "app.bsky.actor.putPreferences",
        AppBskyActorSearchActors: "app.bsky.actor.searchActors",
        AppBskyActorSearchActorsTypeahead: "app.bsky.actor.searchActorsTypeahead",
        AppBskyEmbedExternal: "app.bsky.embed.external",
        AppBskyEmbedImages: "app.bsky.embed.images",
        AppBskyEmbedRecord: "app.bsky.embed.record",
        AppBskyEmbedRecordWithMedia: "app.bsky.embed.recordWithMedia",
        AppBskyFeedDefs: "app.bsky.feed.defs",
        AppBskyFeedDescribeFeedGenerator: "app.bsky.feed.describeFeedGenerator",
        AppBskyFeedGenerator: "app.bsky.feed.generator",
        AppBskyFeedGetActorFeeds: "app.bsky.feed.getActorFeeds",
        AppBskyFeedGetActorLikes: "app.bsky.feed.getActorLikes",
        AppBskyFeedGetAuthorFeed: "app.bsky.feed.getAuthorFeed",
        AppBskyFeedGetFeed: "app.bsky.feed.getFeed",
        AppBskyFeedGetFeedGenerator: "app.bsky.feed.getFeedGenerator",
        AppBskyFeedGetFeedGenerators: "app.bsky.feed.getFeedGenerators",
        AppBskyFeedGetFeedSkeleton: "app.bsky.feed.getFeedSkeleton",
        AppBskyFeedGetLikes: "app.bsky.feed.getLikes",
        AppBskyFeedGetListFeed: "app.bsky.feed.getListFeed",
        AppBskyFeedGetPostThread: "app.bsky.feed.getPostThread",
        AppBskyFeedGetPosts: "app.bsky.feed.getPosts",
        AppBskyFeedGetRepostedBy: "app.bsky.feed.getRepostedBy",
        AppBskyFeedGetSuggestedFeeds: "app.bsky.feed.getSuggestedFeeds",
        AppBskyFeedGetTimeline: "app.bsky.feed.getTimeline",
        AppBskyFeedLike: "app.bsky.feed.like",
        AppBskyFeedPost: "app.bsky.feed.post",
        AppBskyFeedRepost: "app.bsky.feed.repost",
        AppBskyFeedSearchPosts: "app.bsky.feed.searchPosts",
        AppBskyFeedSendInteractions: "app.bsky.feed.sendInteractions",
        AppBskyFeedThreadgate: "app.bsky.feed.threadgate",
        AppBskyGraphBlock: "app.bsky.graph.block",
        AppBskyGraphDefs: "app.bsky.graph.defs",
        AppBskyGraphFollow: "app.bsky.graph.follow",
        AppBskyGraphGetActorStarterPacks: "app.bsky.graph.getActorStarterPacks",
        AppBskyGraphGetBlocks: "app.bsky.graph.getBlocks",
        AppBskyGraphGetFollowers: "app.bsky.graph.getFollowers",
        AppBskyGraphGetFollows: "app.bsky.graph.getFollows",
        AppBskyGraphGetKnownFollowers: "app.bsky.graph.getKnownFollowers",
        AppBskyGraphGetList: "app.bsky.graph.getList",
        AppBskyGraphGetListBlocks: "app.bsky.graph.getListBlocks",
        AppBskyGraphGetListMutes: "app.bsky.graph.getListMutes",
        AppBskyGraphGetLists: "app.bsky.graph.getLists",
        AppBskyGraphGetMutes: "app.bsky.graph.getMutes",
        AppBskyGraphGetRelationships: "app.bsky.graph.getRelationships",
        AppBskyGraphGetStarterPack: "app.bsky.graph.getStarterPack",
        AppBskyGraphGetStarterPacks: "app.bsky.graph.getStarterPacks",
        AppBskyGraphGetSuggestedFollowsByActor: "app.bsky.graph.getSuggestedFollowsByActor",
        AppBskyGraphList: "app.bsky.graph.list",
        AppBskyGraphListblock: "app.bsky.graph.listblock",
        AppBskyGraphListitem: "app.bsky.graph.listitem",
        AppBskyGraphMuteActor: "app.bsky.graph.muteActor",
        AppBskyGraphMuteActorList: "app.bsky.graph.muteActorList",
        AppBskyGraphMuteThread: "app.bsky.graph.muteThread",
        AppBskyGraphStarterpack: "app.bsky.graph.starterpack",
        AppBskyGraphUnmuteActor: "app.bsky.graph.unmuteActor",
        AppBskyGraphUnmuteActorList: "app.bsky.graph.unmuteActorList",
        AppBskyGraphUnmuteThread: "app.bsky.graph.unmuteThread",
        AppBskyLabelerDefs: "app.bsky.labeler.defs",
        AppBskyLabelerGetServices: "app.bsky.labeler.getServices",
        AppBskyLabelerService: "app.bsky.labeler.service",
        AppBskyNotificationGetUnreadCount: "app.bsky.notification.getUnreadCount",
        AppBskyNotificationListNotifications: "app.bsky.notification.listNotifications",
        AppBskyNotificationPutPreferences: "app.bsky.notification.putPreferences",
        AppBskyNotificationRegisterPush: "app.bsky.notification.registerPush",
        AppBskyNotificationUpdateSeen: "app.bsky.notification.updateSeen",
        AppBskyRichtextFacet: "app.bsky.richtext.facet",
        AppBskyUnspeccedDefs: "app.bsky.unspecced.defs",
        AppBskyUnspeccedGetPopularFeedGenerators: "app.bsky.unspecced.getPopularFeedGenerators",
        AppBskyUnspeccedGetSuggestionsSkeleton: "app.bsky.unspecced.getSuggestionsSkeleton",
        AppBskyUnspeccedGetTaggedSuggestions: "app.bsky.unspecced.getTaggedSuggestions",
        AppBskyUnspeccedSearchActorsSkeleton: "app.bsky.unspecced.searchActorsSkeleton",
        AppBskyUnspeccedSearchPostsSkeleton: "app.bsky.unspecced.searchPostsSkeleton",
        ChatBskyActorDeclaration: "chat.bsky.actor.declaration",
        ChatBskyActorDefs: "chat.bsky.actor.defs",
        ChatBskyActorDeleteAccount: "chat.bsky.actor.deleteAccount",
        ChatBskyActorExportAccountData: "chat.bsky.actor.exportAccountData",
        ChatBskyConvoDefs: "chat.bsky.convo.defs",
        ChatBskyConvoDeleteMessageForSelf: "chat.bsky.convo.deleteMessageForSelf",
        ChatBskyConvoGetConvo: "chat.bsky.convo.getConvo",
        ChatBskyConvoGetConvoForMembers: "chat.bsky.convo.getConvoForMembers",
        ChatBskyConvoGetLog: "chat.bsky.convo.getLog",
        ChatBskyConvoGetMessages: "chat.bsky.convo.getMessages",
        ChatBskyConvoLeaveConvo: "chat.bsky.convo.leaveConvo",
        ChatBskyConvoListConvos: "chat.bsky.convo.listConvos",
        ChatBskyConvoMuteConvo: "chat.bsky.convo.muteConvo",
        ChatBskyConvoSendMessage: "chat.bsky.convo.sendMessage",
        ChatBskyConvoSendMessageBatch: "chat.bsky.convo.sendMessageBatch",
        ChatBskyConvoUnmuteConvo: "chat.bsky.convo.unmuteConvo",
        ChatBskyConvoUpdateRead: "chat.bsky.convo.updateRead",
        ChatBskyModerationGetActorMetadata: "chat.bsky.moderation.getActorMetadata",
        ChatBskyModerationGetMessageContext: "chat.bsky.moderation.getMessageContext",
        ChatBskyModerationUpdateActorAccess: "chat.bsky.moderation.updateActorAccess",
        ToolsOzoneCommunicationCreateTemplate: "tools.ozone.communication.createTemplate",
        ToolsOzoneCommunicationDefs: "tools.ozone.communication.defs",
        ToolsOzoneCommunicationDeleteTemplate: "tools.ozone.communication.deleteTemplate",
        ToolsOzoneCommunicationListTemplates: "tools.ozone.communication.listTemplates",
        ToolsOzoneCommunicationUpdateTemplate: "tools.ozone.communication.updateTemplate",
        ToolsOzoneModerationDefs: "tools.ozone.moderation.defs",
        ToolsOzoneModerationEmitEvent: "tools.ozone.moderation.emitEvent",
        ToolsOzoneModerationGetEvent: "tools.ozone.moderation.getEvent",
        ToolsOzoneModerationGetRecord: "tools.ozone.moderation.getRecord",
        ToolsOzoneModerationGetRepo: "tools.ozone.moderation.getRepo",
        ToolsOzoneModerationQueryEvents: "tools.ozone.moderation.queryEvents",
        ToolsOzoneModerationQueryStatuses: "tools.ozone.moderation.queryStatuses",
        ToolsOzoneModerationSearchRepos: "tools.ozone.moderation.searchRepos",
        ToolsOzoneServerGetConfig: "tools.ozone.server.getConfig",
        ToolsOzoneTeamAddMember: "tools.ozone.team.addMember",
        ToolsOzoneTeamDefs: "tools.ozone.team.defs",
        ToolsOzoneTeamDeleteMember: "tools.ozone.team.deleteMember",
        ToolsOzoneTeamListMembers: "tools.ozone.team.listMembers",
        ToolsOzoneTeamUpdateMember: "tools.ozone.team.updateMember"
    };
})($aec35899a3c9695e$var$Le);
var $aec35899a3c9695e$var$Da = {};
Object.defineProperty($aec35899a3c9695e$var$Da, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Da.toKnownErr = void 0;
const $aec35899a3c9695e$var$zv = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Xv(t) {
    return $aec35899a3c9695e$var$zv.XRPCError, t;
}
$aec35899a3c9695e$var$Da.toKnownErr = $aec35899a3c9695e$var$Xv;
var $aec35899a3c9695e$var$Pa = {};
Object.defineProperty($aec35899a3c9695e$var$Pa, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Pa.toKnownErr = void 0;
const $aec35899a3c9695e$var$Hv = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Zv(t) {
    return $aec35899a3c9695e$var$Hv.XRPCError, t;
}
$aec35899a3c9695e$var$Pa.toKnownErr = $aec35899a3c9695e$var$Zv;
var $aec35899a3c9695e$var$Ba = {};
Object.defineProperty($aec35899a3c9695e$var$Ba, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ba.toKnownErr = void 0;
const $aec35899a3c9695e$var$Wv = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Yv(t) {
    return $aec35899a3c9695e$var$Wv.XRPCError, t;
}
$aec35899a3c9695e$var$Ba.toKnownErr = $aec35899a3c9695e$var$Yv;
var $aec35899a3c9695e$var$Ia = {};
Object.defineProperty($aec35899a3c9695e$var$Ia, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ia.toKnownErr = void 0;
const $aec35899a3c9695e$var$Jv = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Qv(t) {
    return $aec35899a3c9695e$var$Jv.XRPCError, t;
}
$aec35899a3c9695e$var$Ia.toKnownErr = $aec35899a3c9695e$var$Qv;
var $aec35899a3c9695e$var$Ua = {};
Object.defineProperty($aec35899a3c9695e$var$Ua, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ua.toKnownErr = void 0;
const $aec35899a3c9695e$var$eR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$tR(t) {
    return $aec35899a3c9695e$var$eR.XRPCError, t;
}
$aec35899a3c9695e$var$Ua.toKnownErr = $aec35899a3c9695e$var$tR;
var $aec35899a3c9695e$var$Oa = {};
Object.defineProperty($aec35899a3c9695e$var$Oa, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Oa.toKnownErr = void 0;
const $aec35899a3c9695e$var$rR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$iR(t) {
    return $aec35899a3c9695e$var$rR.XRPCError, t;
}
$aec35899a3c9695e$var$Oa.toKnownErr = $aec35899a3c9695e$var$iR;
var $aec35899a3c9695e$var$Ka = {};
Object.defineProperty($aec35899a3c9695e$var$Ka, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ka.toKnownErr = void 0;
const $aec35899a3c9695e$var$nR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$sR(t) {
    return $aec35899a3c9695e$var$nR.XRPCError, t;
}
$aec35899a3c9695e$var$Ka.toKnownErr = $aec35899a3c9695e$var$sR;
var $aec35899a3c9695e$var$Ma = {};
Object.defineProperty($aec35899a3c9695e$var$Ma, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ma.toKnownErr = void 0;
const $aec35899a3c9695e$var$aR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$oR(t) {
    return $aec35899a3c9695e$var$aR.XRPCError, t;
}
$aec35899a3c9695e$var$Ma.toKnownErr = $aec35899a3c9695e$var$oR;
var $aec35899a3c9695e$var$Na = {};
Object.defineProperty($aec35899a3c9695e$var$Na, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Na.toKnownErr = void 0;
const $aec35899a3c9695e$var$lR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$uR(t) {
    return $aec35899a3c9695e$var$lR.XRPCError, t;
}
$aec35899a3c9695e$var$Na.toKnownErr = $aec35899a3c9695e$var$uR;
var $aec35899a3c9695e$var$Va = {};
Object.defineProperty($aec35899a3c9695e$var$Va, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Va.toKnownErr = void 0;
const $aec35899a3c9695e$var$cR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$dR(t) {
    return $aec35899a3c9695e$var$cR.XRPCError, t;
}
$aec35899a3c9695e$var$Va.toKnownErr = $aec35899a3c9695e$var$dR;
var $aec35899a3c9695e$var$ja = {};
Object.defineProperty($aec35899a3c9695e$var$ja, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ja.toKnownErr = void 0;
const $aec35899a3c9695e$var$fR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$pR(t) {
    return $aec35899a3c9695e$var$fR.XRPCError, t;
}
$aec35899a3c9695e$var$ja.toKnownErr = $aec35899a3c9695e$var$pR;
var $aec35899a3c9695e$var$Fa = {};
Object.defineProperty($aec35899a3c9695e$var$Fa, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Fa.toKnownErr = void 0;
const $aec35899a3c9695e$var$hR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$mR(t) {
    return $aec35899a3c9695e$var$hR.XRPCError, t;
}
$aec35899a3c9695e$var$Fa.toKnownErr = $aec35899a3c9695e$var$mR;
var $aec35899a3c9695e$var$$a = {};
Object.defineProperty($aec35899a3c9695e$var$$a, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$$a.toKnownErr = void 0;
const $aec35899a3c9695e$var$yR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$bR(t) {
    return $aec35899a3c9695e$var$yR.XRPCError, t;
}
$aec35899a3c9695e$var$$a.toKnownErr = $aec35899a3c9695e$var$bR;
var $aec35899a3c9695e$var$Ga = {};
Object.defineProperty($aec35899a3c9695e$var$Ga, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ga.toKnownErr = void 0;
const $aec35899a3c9695e$var$gR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$xR(t) {
    return $aec35899a3c9695e$var$gR.XRPCError, t;
}
$aec35899a3c9695e$var$Ga.toKnownErr = $aec35899a3c9695e$var$xR;
var $aec35899a3c9695e$var$qa = {};
Object.defineProperty($aec35899a3c9695e$var$qa, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$qa.toKnownErr = void 0;
const $aec35899a3c9695e$var$ER = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$vR(t) {
    return $aec35899a3c9695e$var$ER.XRPCError, t;
}
$aec35899a3c9695e$var$qa.toKnownErr = $aec35899a3c9695e$var$vR;
var $aec35899a3c9695e$var$za = {};
Object.defineProperty($aec35899a3c9695e$var$za, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$za.toKnownErr = void 0;
const $aec35899a3c9695e$var$RR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$AR(t) {
    return $aec35899a3c9695e$var$RR.XRPCError, t;
}
$aec35899a3c9695e$var$za.toKnownErr = $aec35899a3c9695e$var$AR;
var $aec35899a3c9695e$var$Xa = {};
Object.defineProperty($aec35899a3c9695e$var$Xa, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Xa.toKnownErr = void 0;
const $aec35899a3c9695e$var$_R = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$wR(t) {
    return $aec35899a3c9695e$var$_R.XRPCError, t;
}
$aec35899a3c9695e$var$Xa.toKnownErr = $aec35899a3c9695e$var$wR;
var $aec35899a3c9695e$var$Ha = {};
Object.defineProperty($aec35899a3c9695e$var$Ha, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ha.toKnownErr = void 0;
const $aec35899a3c9695e$var$TR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$SR(t) {
    return $aec35899a3c9695e$var$TR.XRPCError, t;
}
$aec35899a3c9695e$var$Ha.toKnownErr = $aec35899a3c9695e$var$SR;
var $aec35899a3c9695e$var$Za = {};
Object.defineProperty($aec35899a3c9695e$var$Za, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Za.toKnownErr = void 0;
const $aec35899a3c9695e$var$CR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$LR(t) {
    return $aec35899a3c9695e$var$CR.XRPCError, t;
}
$aec35899a3c9695e$var$Za.toKnownErr = $aec35899a3c9695e$var$LR;
var $aec35899a3c9695e$var$Wa = {};
Object.defineProperty($aec35899a3c9695e$var$Wa, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Wa.toKnownErr = void 0;
const $aec35899a3c9695e$var$kR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$DR(t) {
    return $aec35899a3c9695e$var$kR.XRPCError, t;
}
$aec35899a3c9695e$var$Wa.toKnownErr = $aec35899a3c9695e$var$DR;
var $aec35899a3c9695e$var$Ya = {};
Object.defineProperty($aec35899a3c9695e$var$Ya, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ya.toKnownErr = void 0;
const $aec35899a3c9695e$var$PR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$BR(t) {
    return $aec35899a3c9695e$var$PR.XRPCError, t;
}
$aec35899a3c9695e$var$Ya.toKnownErr = $aec35899a3c9695e$var$BR;
var $aec35899a3c9695e$var$Ja = {};
Object.defineProperty($aec35899a3c9695e$var$Ja, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ja.toKnownErr = void 0;
const $aec35899a3c9695e$var$IR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$UR(t) {
    return $aec35899a3c9695e$var$IR.XRPCError, t;
}
$aec35899a3c9695e$var$Ja.toKnownErr = $aec35899a3c9695e$var$UR;
var $aec35899a3c9695e$var$Dt = {}, $aec35899a3c9695e$var$_e = {};
Object.defineProperty($aec35899a3c9695e$var$_e, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$_e.hasProp = $aec35899a3c9695e$var$_e.isObj = void 0;
function $aec35899a3c9695e$var$OR(t) {
    return typeof t == "object" && t !== null;
}
$aec35899a3c9695e$var$_e.isObj = $aec35899a3c9695e$var$OR;
function $aec35899a3c9695e$var$KR(t, e) {
    return e in t;
}
$aec35899a3c9695e$var$_e.hasProp = $aec35899a3c9695e$var$KR;
Object.defineProperty($aec35899a3c9695e$var$Dt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Dt.validateDelete = $aec35899a3c9695e$var$Dt.isDelete = $aec35899a3c9695e$var$Dt.validateUpdate = $aec35899a3c9695e$var$Dt.isUpdate = $aec35899a3c9695e$var$Dt.validateCreate = $aec35899a3c9695e$var$Dt.isCreate = $aec35899a3c9695e$var$Dt.toKnownErr = $aec35899a3c9695e$var$Dt.InvalidSwapError = void 0;
const $aec35899a3c9695e$var$Hp = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Ts = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Wc = $aec35899a3c9695e$var$Le;
let $aec35899a3c9695e$var$Zp = class extends $aec35899a3c9695e$var$Hp.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Dt.InvalidSwapError = $aec35899a3c9695e$var$Zp;
function $aec35899a3c9695e$var$MR(t) {
    return t instanceof $aec35899a3c9695e$var$Hp.XRPCError && t.error === "InvalidSwap" ? new $aec35899a3c9695e$var$Zp(t) : t;
}
$aec35899a3c9695e$var$Dt.toKnownErr = $aec35899a3c9695e$var$MR;
function $aec35899a3c9695e$var$NR(t) {
    return (0, $aec35899a3c9695e$var$Ts.isObj)(t) && (0, $aec35899a3c9695e$var$Ts.hasProp)(t, "$type") && t.$type === "com.atproto.repo.applyWrites#create";
}
$aec35899a3c9695e$var$Dt.isCreate = $aec35899a3c9695e$var$NR;
function $aec35899a3c9695e$var$VR(t) {
    return $aec35899a3c9695e$var$Wc.lexicons.validate("com.atproto.repo.applyWrites#create", t);
}
$aec35899a3c9695e$var$Dt.validateCreate = $aec35899a3c9695e$var$VR;
function $aec35899a3c9695e$var$jR(t) {
    return (0, $aec35899a3c9695e$var$Ts.isObj)(t) && (0, $aec35899a3c9695e$var$Ts.hasProp)(t, "$type") && t.$type === "com.atproto.repo.applyWrites#update";
}
$aec35899a3c9695e$var$Dt.isUpdate = $aec35899a3c9695e$var$jR;
function $aec35899a3c9695e$var$FR(t) {
    return $aec35899a3c9695e$var$Wc.lexicons.validate("com.atproto.repo.applyWrites#update", t);
}
$aec35899a3c9695e$var$Dt.validateUpdate = $aec35899a3c9695e$var$FR;
function $aec35899a3c9695e$var$$R(t) {
    return (0, $aec35899a3c9695e$var$Ts.isObj)(t) && (0, $aec35899a3c9695e$var$Ts.hasProp)(t, "$type") && t.$type === "com.atproto.repo.applyWrites#delete";
}
$aec35899a3c9695e$var$Dt.isDelete = $aec35899a3c9695e$var$$R;
function $aec35899a3c9695e$var$GR(t) {
    return $aec35899a3c9695e$var$Wc.lexicons.validate("com.atproto.repo.applyWrites#delete", t);
}
$aec35899a3c9695e$var$Dt.validateDelete = $aec35899a3c9695e$var$GR;
var $aec35899a3c9695e$var$Nn = {};
Object.defineProperty($aec35899a3c9695e$var$Nn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Nn.toKnownErr = $aec35899a3c9695e$var$Nn.InvalidSwapError = void 0;
const $aec35899a3c9695e$var$Wp = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$Yp = class extends $aec35899a3c9695e$var$Wp.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Nn.InvalidSwapError = $aec35899a3c9695e$var$Yp;
function $aec35899a3c9695e$var$qR(t) {
    return t instanceof $aec35899a3c9695e$var$Wp.XRPCError && t.error === "InvalidSwap" ? new $aec35899a3c9695e$var$Yp(t) : t;
}
$aec35899a3c9695e$var$Nn.toKnownErr = $aec35899a3c9695e$var$qR;
var $aec35899a3c9695e$var$Vn = {};
Object.defineProperty($aec35899a3c9695e$var$Vn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Vn.toKnownErr = $aec35899a3c9695e$var$Vn.InvalidSwapError = void 0;
const $aec35899a3c9695e$var$Jp = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$Qp = class extends $aec35899a3c9695e$var$Jp.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Vn.InvalidSwapError = $aec35899a3c9695e$var$Qp;
function $aec35899a3c9695e$var$zR(t) {
    return t instanceof $aec35899a3c9695e$var$Jp.XRPCError && t.error === "InvalidSwap" ? new $aec35899a3c9695e$var$Qp(t) : t;
}
$aec35899a3c9695e$var$Vn.toKnownErr = $aec35899a3c9695e$var$zR;
var $aec35899a3c9695e$var$Qa = {};
Object.defineProperty($aec35899a3c9695e$var$Qa, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Qa.toKnownErr = void 0;
const $aec35899a3c9695e$var$XR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$HR(t) {
    return $aec35899a3c9695e$var$XR.XRPCError, t;
}
$aec35899a3c9695e$var$Qa.toKnownErr = $aec35899a3c9695e$var$HR;
var $aec35899a3c9695e$var$eo = {};
Object.defineProperty($aec35899a3c9695e$var$eo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$eo.toKnownErr = void 0;
const $aec35899a3c9695e$var$ZR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$WR(t) {
    return $aec35899a3c9695e$var$ZR.XRPCError, t;
}
$aec35899a3c9695e$var$eo.toKnownErr = $aec35899a3c9695e$var$WR;
var $aec35899a3c9695e$var$to = {};
Object.defineProperty($aec35899a3c9695e$var$to, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$to.toKnownErr = void 0;
const $aec35899a3c9695e$var$YR = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$JR(t) {
    return $aec35899a3c9695e$var$YR.XRPCError, t;
}
$aec35899a3c9695e$var$to.toKnownErr = $aec35899a3c9695e$var$JR;
var $aec35899a3c9695e$var$Ni = {};
Object.defineProperty($aec35899a3c9695e$var$Ni, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ni.validateRecordBlob = $aec35899a3c9695e$var$Ni.isRecordBlob = $aec35899a3c9695e$var$Ni.toKnownErr = void 0;
const $aec35899a3c9695e$var$QR = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$jd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$eA = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$tA(t) {
    return $aec35899a3c9695e$var$QR.XRPCError, t;
}
$aec35899a3c9695e$var$Ni.toKnownErr = $aec35899a3c9695e$var$tA;
function $aec35899a3c9695e$var$rA(t) {
    return (0, $aec35899a3c9695e$var$jd.isObj)(t) && (0, $aec35899a3c9695e$var$jd.hasProp)(t, "$type") && t.$type === "com.atproto.repo.listMissingBlobs#recordBlob";
}
$aec35899a3c9695e$var$Ni.isRecordBlob = $aec35899a3c9695e$var$rA;
function $aec35899a3c9695e$var$iA(t) {
    return $aec35899a3c9695e$var$eA.lexicons.validate("com.atproto.repo.listMissingBlobs#recordBlob", t);
}
$aec35899a3c9695e$var$Ni.validateRecordBlob = $aec35899a3c9695e$var$iA;
var $aec35899a3c9695e$var$Vi = {};
Object.defineProperty($aec35899a3c9695e$var$Vi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Vi.validateRecord = $aec35899a3c9695e$var$Vi.isRecord = $aec35899a3c9695e$var$Vi.toKnownErr = void 0;
const $aec35899a3c9695e$var$nA = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Fd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$sA = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$aA(t) {
    return $aec35899a3c9695e$var$nA.XRPCError, t;
}
$aec35899a3c9695e$var$Vi.toKnownErr = $aec35899a3c9695e$var$aA;
function $aec35899a3c9695e$var$oA(t) {
    return (0, $aec35899a3c9695e$var$Fd.isObj)(t) && (0, $aec35899a3c9695e$var$Fd.hasProp)(t, "$type") && t.$type === "com.atproto.repo.listRecords#record";
}
$aec35899a3c9695e$var$Vi.isRecord = $aec35899a3c9695e$var$oA;
function $aec35899a3c9695e$var$lA(t) {
    return $aec35899a3c9695e$var$sA.lexicons.validate("com.atproto.repo.listRecords#record", t);
}
$aec35899a3c9695e$var$Vi.validateRecord = $aec35899a3c9695e$var$lA;
var $aec35899a3c9695e$var$jn = {};
Object.defineProperty($aec35899a3c9695e$var$jn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$jn.toKnownErr = $aec35899a3c9695e$var$jn.InvalidSwapError = void 0;
const $aec35899a3c9695e$var$eh = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$th extends $aec35899a3c9695e$var$eh.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$jn.InvalidSwapError = $aec35899a3c9695e$var$th;
function $aec35899a3c9695e$var$uA(t) {
    return t instanceof $aec35899a3c9695e$var$eh.XRPCError && t.error === "InvalidSwap" ? new $aec35899a3c9695e$var$th(t) : t;
}
$aec35899a3c9695e$var$jn.toKnownErr = $aec35899a3c9695e$var$uA;
var $aec35899a3c9695e$var$ro = {};
Object.defineProperty($aec35899a3c9695e$var$ro, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ro.toKnownErr = void 0;
const $aec35899a3c9695e$var$cA = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$dA(t) {
    return $aec35899a3c9695e$var$cA.XRPCError, t;
}
$aec35899a3c9695e$var$ro.toKnownErr = $aec35899a3c9695e$var$dA;
var $aec35899a3c9695e$var$io = {};
Object.defineProperty($aec35899a3c9695e$var$io, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$io.toKnownErr = void 0;
const $aec35899a3c9695e$var$fA = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$pA(t) {
    return $aec35899a3c9695e$var$fA.XRPCError, t;
}
$aec35899a3c9695e$var$io.toKnownErr = $aec35899a3c9695e$var$pA;
var $aec35899a3c9695e$var$no = {};
Object.defineProperty($aec35899a3c9695e$var$no, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$no.toKnownErr = void 0;
const $aec35899a3c9695e$var$hA = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$mA(t) {
    return $aec35899a3c9695e$var$hA.XRPCError, t;
}
$aec35899a3c9695e$var$no.toKnownErr = $aec35899a3c9695e$var$mA;
var $aec35899a3c9695e$var$Rr = {};
Object.defineProperty($aec35899a3c9695e$var$Rr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Rr.toKnownErr = $aec35899a3c9695e$var$Rr.InvalidEmailError = $aec35899a3c9695e$var$Rr.InvalidTokenError = $aec35899a3c9695e$var$Rr.ExpiredTokenError = $aec35899a3c9695e$var$Rr.AccountNotFoundError = void 0;
const $aec35899a3c9695e$var$so = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$rh extends $aec35899a3c9695e$var$so.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Rr.AccountNotFoundError = $aec35899a3c9695e$var$rh;
let $aec35899a3c9695e$var$ih = class extends $aec35899a3c9695e$var$so.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Rr.ExpiredTokenError = $aec35899a3c9695e$var$ih;
let $aec35899a3c9695e$var$nh = class extends $aec35899a3c9695e$var$so.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Rr.InvalidTokenError = $aec35899a3c9695e$var$nh;
class $aec35899a3c9695e$var$sh extends $aec35899a3c9695e$var$so.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Rr.InvalidEmailError = $aec35899a3c9695e$var$sh;
function $aec35899a3c9695e$var$yA(t) {
    if (t instanceof $aec35899a3c9695e$var$so.XRPCError) {
        if (t.error === "AccountNotFound") return new $aec35899a3c9695e$var$rh(t);
        if (t.error === "ExpiredToken") return new $aec35899a3c9695e$var$ih(t);
        if (t.error === "InvalidToken") return new $aec35899a3c9695e$var$nh(t);
        if (t.error === "InvalidEmail") return new $aec35899a3c9695e$var$sh(t);
    }
    return t;
}
$aec35899a3c9695e$var$Rr.toKnownErr = $aec35899a3c9695e$var$yA;
var $aec35899a3c9695e$var$Pt = {};
Object.defineProperty($aec35899a3c9695e$var$Pt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Pt.toKnownErr = $aec35899a3c9695e$var$Pt.IncompatibleDidDocError = $aec35899a3c9695e$var$Pt.UnresolvableDidError = $aec35899a3c9695e$var$Pt.UnsupportedDomainError = $aec35899a3c9695e$var$Pt.HandleNotAvailableError = $aec35899a3c9695e$var$Pt.InvalidInviteCodeError = $aec35899a3c9695e$var$Pt.InvalidPasswordError = $aec35899a3c9695e$var$Pt.InvalidHandleError = void 0;
const $aec35899a3c9695e$var$_n = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$ah extends $aec35899a3c9695e$var$_n.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Pt.InvalidHandleError = $aec35899a3c9695e$var$ah;
class $aec35899a3c9695e$var$oh extends $aec35899a3c9695e$var$_n.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Pt.InvalidPasswordError = $aec35899a3c9695e$var$oh;
class $aec35899a3c9695e$var$lh extends $aec35899a3c9695e$var$_n.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Pt.InvalidInviteCodeError = $aec35899a3c9695e$var$lh;
class $aec35899a3c9695e$var$uh extends $aec35899a3c9695e$var$_n.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Pt.HandleNotAvailableError = $aec35899a3c9695e$var$uh;
class $aec35899a3c9695e$var$ch extends $aec35899a3c9695e$var$_n.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Pt.UnsupportedDomainError = $aec35899a3c9695e$var$ch;
class $aec35899a3c9695e$var$dh extends $aec35899a3c9695e$var$_n.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Pt.UnresolvableDidError = $aec35899a3c9695e$var$dh;
class $aec35899a3c9695e$var$fh extends $aec35899a3c9695e$var$_n.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Pt.IncompatibleDidDocError = $aec35899a3c9695e$var$fh;
function $aec35899a3c9695e$var$bA(t) {
    if (t instanceof $aec35899a3c9695e$var$_n.XRPCError) {
        if (t.error === "InvalidHandle") return new $aec35899a3c9695e$var$ah(t);
        if (t.error === "InvalidPassword") return new $aec35899a3c9695e$var$oh(t);
        if (t.error === "InvalidInviteCode") return new $aec35899a3c9695e$var$lh(t);
        if (t.error === "HandleNotAvailable") return new $aec35899a3c9695e$var$uh(t);
        if (t.error === "UnsupportedDomain") return new $aec35899a3c9695e$var$ch(t);
        if (t.error === "UnresolvableDid") return new $aec35899a3c9695e$var$dh(t);
        if (t.error === "IncompatibleDidDoc") return new $aec35899a3c9695e$var$fh(t);
    }
    return t;
}
$aec35899a3c9695e$var$Pt.toKnownErr = $aec35899a3c9695e$var$bA;
var $aec35899a3c9695e$var$Vr = {};
Object.defineProperty($aec35899a3c9695e$var$Vr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Vr.validateAppPassword = $aec35899a3c9695e$var$Vr.isAppPassword = $aec35899a3c9695e$var$Vr.toKnownErr = $aec35899a3c9695e$var$Vr.AccountTakedownError = void 0;
const $aec35899a3c9695e$var$ph = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$$d = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$gA = $aec35899a3c9695e$var$Le;
let $aec35899a3c9695e$var$hh = class extends $aec35899a3c9695e$var$ph.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Vr.AccountTakedownError = $aec35899a3c9695e$var$hh;
function $aec35899a3c9695e$var$xA(t) {
    return t instanceof $aec35899a3c9695e$var$ph.XRPCError && t.error === "AccountTakedown" ? new $aec35899a3c9695e$var$hh(t) : t;
}
$aec35899a3c9695e$var$Vr.toKnownErr = $aec35899a3c9695e$var$xA;
function $aec35899a3c9695e$var$EA(t) {
    return (0, $aec35899a3c9695e$var$$d.isObj)(t) && (0, $aec35899a3c9695e$var$$d.hasProp)(t, "$type") && t.$type === "com.atproto.server.createAppPassword#appPassword";
}
$aec35899a3c9695e$var$Vr.isAppPassword = $aec35899a3c9695e$var$EA;
function $aec35899a3c9695e$var$vA(t) {
    return $aec35899a3c9695e$var$gA.lexicons.validate("com.atproto.server.createAppPassword#appPassword", t);
}
$aec35899a3c9695e$var$Vr.validateAppPassword = $aec35899a3c9695e$var$vA;
var $aec35899a3c9695e$var$ao = {};
Object.defineProperty($aec35899a3c9695e$var$ao, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ao.toKnownErr = void 0;
const $aec35899a3c9695e$var$RA = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$AA(t) {
    return $aec35899a3c9695e$var$RA.XRPCError, t;
}
$aec35899a3c9695e$var$ao.toKnownErr = $aec35899a3c9695e$var$AA;
var $aec35899a3c9695e$var$ji = {};
Object.defineProperty($aec35899a3c9695e$var$ji, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ji.validateAccountCodes = $aec35899a3c9695e$var$ji.isAccountCodes = $aec35899a3c9695e$var$ji.toKnownErr = void 0;
const $aec35899a3c9695e$var$_A = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Gd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$wA = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$TA(t) {
    return $aec35899a3c9695e$var$_A.XRPCError, t;
}
$aec35899a3c9695e$var$ji.toKnownErr = $aec35899a3c9695e$var$TA;
function $aec35899a3c9695e$var$SA(t) {
    return (0, $aec35899a3c9695e$var$Gd.isObj)(t) && (0, $aec35899a3c9695e$var$Gd.hasProp)(t, "$type") && t.$type === "com.atproto.server.createInviteCodes#accountCodes";
}
$aec35899a3c9695e$var$ji.isAccountCodes = $aec35899a3c9695e$var$SA;
function $aec35899a3c9695e$var$CA(t) {
    return $aec35899a3c9695e$var$wA.lexicons.validate("com.atproto.server.createInviteCodes#accountCodes", t);
}
$aec35899a3c9695e$var$ji.validateAccountCodes = $aec35899a3c9695e$var$CA;
var $aec35899a3c9695e$var$Fi = {};
Object.defineProperty($aec35899a3c9695e$var$Fi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Fi.toKnownErr = $aec35899a3c9695e$var$Fi.AuthFactorTokenRequiredError = $aec35899a3c9695e$var$Fi.AccountTakedownError = void 0;
const $aec35899a3c9695e$var$Yc = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$mh = class extends $aec35899a3c9695e$var$Yc.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Fi.AccountTakedownError = $aec35899a3c9695e$var$mh;
class $aec35899a3c9695e$var$yh extends $aec35899a3c9695e$var$Yc.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Fi.AuthFactorTokenRequiredError = $aec35899a3c9695e$var$yh;
function $aec35899a3c9695e$var$LA(t) {
    if (t instanceof $aec35899a3c9695e$var$Yc.XRPCError) {
        if (t.error === "AccountTakedown") return new $aec35899a3c9695e$var$mh(t);
        if (t.error === "AuthFactorTokenRequired") return new $aec35899a3c9695e$var$yh(t);
    }
    return t;
}
$aec35899a3c9695e$var$Fi.toKnownErr = $aec35899a3c9695e$var$LA;
var $aec35899a3c9695e$var$oo = {};
Object.defineProperty($aec35899a3c9695e$var$oo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$oo.toKnownErr = void 0;
const $aec35899a3c9695e$var$kA = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$DA(t) {
    return $aec35899a3c9695e$var$kA.XRPCError, t;
}
$aec35899a3c9695e$var$oo.toKnownErr = $aec35899a3c9695e$var$DA;
var $aec35899a3c9695e$var$$i = {};
Object.defineProperty($aec35899a3c9695e$var$$i, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$$i.toKnownErr = $aec35899a3c9695e$var$$i.InvalidTokenError = $aec35899a3c9695e$var$$i.ExpiredTokenError = void 0;
const $aec35899a3c9695e$var$Jc = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$bh = class extends $aec35899a3c9695e$var$Jc.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$$i.ExpiredTokenError = $aec35899a3c9695e$var$bh;
let $aec35899a3c9695e$var$gh = class extends $aec35899a3c9695e$var$Jc.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$$i.InvalidTokenError = $aec35899a3c9695e$var$gh;
function $aec35899a3c9695e$var$PA(t) {
    if (t instanceof $aec35899a3c9695e$var$Jc.XRPCError) {
        if (t.error === "ExpiredToken") return new $aec35899a3c9695e$var$bh(t);
        if (t.error === "InvalidToken") return new $aec35899a3c9695e$var$gh(t);
    }
    return t;
}
$aec35899a3c9695e$var$$i.toKnownErr = $aec35899a3c9695e$var$PA;
var $aec35899a3c9695e$var$lo = {};
Object.defineProperty($aec35899a3c9695e$var$lo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$lo.toKnownErr = void 0;
const $aec35899a3c9695e$var$BA = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$IA(t) {
    return $aec35899a3c9695e$var$BA.XRPCError, t;
}
$aec35899a3c9695e$var$lo.toKnownErr = $aec35899a3c9695e$var$IA;
var $aec35899a3c9695e$var$Ar = {};
Object.defineProperty($aec35899a3c9695e$var$Ar, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ar.validateContact = $aec35899a3c9695e$var$Ar.isContact = $aec35899a3c9695e$var$Ar.validateLinks = $aec35899a3c9695e$var$Ar.isLinks = $aec35899a3c9695e$var$Ar.toKnownErr = void 0;
const $aec35899a3c9695e$var$UA = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$vu = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$xh = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$OA(t) {
    return $aec35899a3c9695e$var$UA.XRPCError, t;
}
$aec35899a3c9695e$var$Ar.toKnownErr = $aec35899a3c9695e$var$OA;
function $aec35899a3c9695e$var$KA(t) {
    return (0, $aec35899a3c9695e$var$vu.isObj)(t) && (0, $aec35899a3c9695e$var$vu.hasProp)(t, "$type") && t.$type === "com.atproto.server.describeServer#links";
}
$aec35899a3c9695e$var$Ar.isLinks = $aec35899a3c9695e$var$KA;
function $aec35899a3c9695e$var$MA(t) {
    return $aec35899a3c9695e$var$xh.lexicons.validate("com.atproto.server.describeServer#links", t);
}
$aec35899a3c9695e$var$Ar.validateLinks = $aec35899a3c9695e$var$MA;
function $aec35899a3c9695e$var$NA(t) {
    return (0, $aec35899a3c9695e$var$vu.isObj)(t) && (0, $aec35899a3c9695e$var$vu.hasProp)(t, "$type") && t.$type === "com.atproto.server.describeServer#contact";
}
$aec35899a3c9695e$var$Ar.isContact = $aec35899a3c9695e$var$NA;
function $aec35899a3c9695e$var$VA(t) {
    return $aec35899a3c9695e$var$xh.lexicons.validate("com.atproto.server.describeServer#contact", t);
}
$aec35899a3c9695e$var$Ar.validateContact = $aec35899a3c9695e$var$VA;
var $aec35899a3c9695e$var$Fn = {};
Object.defineProperty($aec35899a3c9695e$var$Fn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Fn.toKnownErr = $aec35899a3c9695e$var$Fn.DuplicateCreateError = void 0;
const $aec35899a3c9695e$var$Eh = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$vh extends $aec35899a3c9695e$var$Eh.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Fn.DuplicateCreateError = $aec35899a3c9695e$var$vh;
function $aec35899a3c9695e$var$jA(t) {
    return t instanceof $aec35899a3c9695e$var$Eh.XRPCError && t.error === "DuplicateCreate" ? new $aec35899a3c9695e$var$vh(t) : t;
}
$aec35899a3c9695e$var$Fn.toKnownErr = $aec35899a3c9695e$var$jA;
var $aec35899a3c9695e$var$$n = {};
Object.defineProperty($aec35899a3c9695e$var$$n, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$$n.toKnownErr = $aec35899a3c9695e$var$$n.BadExpirationError = void 0;
const $aec35899a3c9695e$var$Rh = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$Ah extends $aec35899a3c9695e$var$Rh.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$$n.BadExpirationError = $aec35899a3c9695e$var$Ah;
function $aec35899a3c9695e$var$FA(t) {
    return t instanceof $aec35899a3c9695e$var$Rh.XRPCError && t.error === "BadExpiration" ? new $aec35899a3c9695e$var$Ah(t) : t;
}
$aec35899a3c9695e$var$$n.toKnownErr = $aec35899a3c9695e$var$FA;
var $aec35899a3c9695e$var$uo = {};
Object.defineProperty($aec35899a3c9695e$var$uo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$uo.toKnownErr = void 0;
const $aec35899a3c9695e$var$$A = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$GA(t) {
    return $aec35899a3c9695e$var$$A.XRPCError, t;
}
$aec35899a3c9695e$var$uo.toKnownErr = $aec35899a3c9695e$var$GA;
var $aec35899a3c9695e$var$jr = {};
Object.defineProperty($aec35899a3c9695e$var$jr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$jr.validateAppPassword = $aec35899a3c9695e$var$jr.isAppPassword = $aec35899a3c9695e$var$jr.toKnownErr = $aec35899a3c9695e$var$jr.AccountTakedownError = void 0;
const $aec35899a3c9695e$var$_h = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$qd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$qA = $aec35899a3c9695e$var$Le;
let $aec35899a3c9695e$var$wh = class extends $aec35899a3c9695e$var$_h.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$jr.AccountTakedownError = $aec35899a3c9695e$var$wh;
function $aec35899a3c9695e$var$zA(t) {
    return t instanceof $aec35899a3c9695e$var$_h.XRPCError && t.error === "AccountTakedown" ? new $aec35899a3c9695e$var$wh(t) : t;
}
$aec35899a3c9695e$var$jr.toKnownErr = $aec35899a3c9695e$var$zA;
function $aec35899a3c9695e$var$XA(t) {
    return (0, $aec35899a3c9695e$var$qd.isObj)(t) && (0, $aec35899a3c9695e$var$qd.hasProp)(t, "$type") && t.$type === "com.atproto.server.listAppPasswords#appPassword";
}
$aec35899a3c9695e$var$jr.isAppPassword = $aec35899a3c9695e$var$XA;
function $aec35899a3c9695e$var$HA(t) {
    return $aec35899a3c9695e$var$qA.lexicons.validate("com.atproto.server.listAppPasswords#appPassword", t);
}
$aec35899a3c9695e$var$jr.validateAppPassword = $aec35899a3c9695e$var$HA;
var $aec35899a3c9695e$var$Gn = {};
Object.defineProperty($aec35899a3c9695e$var$Gn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Gn.toKnownErr = $aec35899a3c9695e$var$Gn.AccountTakedownError = void 0;
const $aec35899a3c9695e$var$Th = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$Sh extends $aec35899a3c9695e$var$Th.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Gn.AccountTakedownError = $aec35899a3c9695e$var$Sh;
function $aec35899a3c9695e$var$ZA(t) {
    return t instanceof $aec35899a3c9695e$var$Th.XRPCError && t.error === "AccountTakedown" ? new $aec35899a3c9695e$var$Sh(t) : t;
}
$aec35899a3c9695e$var$Gn.toKnownErr = $aec35899a3c9695e$var$ZA;
var $aec35899a3c9695e$var$co = {};
Object.defineProperty($aec35899a3c9695e$var$co, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$co.toKnownErr = void 0;
const $aec35899a3c9695e$var$WA = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$YA(t) {
    return $aec35899a3c9695e$var$WA.XRPCError, t;
}
$aec35899a3c9695e$var$co.toKnownErr = $aec35899a3c9695e$var$YA;
var $aec35899a3c9695e$var$fo = {};
Object.defineProperty($aec35899a3c9695e$var$fo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$fo.toKnownErr = void 0;
const $aec35899a3c9695e$var$JA = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$QA(t) {
    return $aec35899a3c9695e$var$JA.XRPCError, t;
}
$aec35899a3c9695e$var$fo.toKnownErr = $aec35899a3c9695e$var$QA;
var $aec35899a3c9695e$var$po = {};
Object.defineProperty($aec35899a3c9695e$var$po, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$po.toKnownErr = void 0;
const $aec35899a3c9695e$var$e_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$t_(t) {
    return $aec35899a3c9695e$var$e_.XRPCError, t;
}
$aec35899a3c9695e$var$po.toKnownErr = $aec35899a3c9695e$var$t_;
var $aec35899a3c9695e$var$ho = {};
Object.defineProperty($aec35899a3c9695e$var$ho, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ho.toKnownErr = void 0;
const $aec35899a3c9695e$var$r_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$i_(t) {
    return $aec35899a3c9695e$var$r_.XRPCError, t;
}
$aec35899a3c9695e$var$ho.toKnownErr = $aec35899a3c9695e$var$i_;
var $aec35899a3c9695e$var$mo = {};
Object.defineProperty($aec35899a3c9695e$var$mo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$mo.toKnownErr = void 0;
const $aec35899a3c9695e$var$n_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$s_(t) {
    return $aec35899a3c9695e$var$n_.XRPCError, t;
}
$aec35899a3c9695e$var$mo.toKnownErr = $aec35899a3c9695e$var$s_;
var $aec35899a3c9695e$var$Gi = {};
Object.defineProperty($aec35899a3c9695e$var$Gi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Gi.toKnownErr = $aec35899a3c9695e$var$Gi.InvalidTokenError = $aec35899a3c9695e$var$Gi.ExpiredTokenError = void 0;
const $aec35899a3c9695e$var$Qc = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$Ch = class extends $aec35899a3c9695e$var$Qc.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Gi.ExpiredTokenError = $aec35899a3c9695e$var$Ch;
let $aec35899a3c9695e$var$Lh = class extends $aec35899a3c9695e$var$Qc.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Gi.InvalidTokenError = $aec35899a3c9695e$var$Lh;
function $aec35899a3c9695e$var$a_(t) {
    if (t instanceof $aec35899a3c9695e$var$Qc.XRPCError) {
        if (t.error === "ExpiredToken") return new $aec35899a3c9695e$var$Ch(t);
        if (t.error === "InvalidToken") return new $aec35899a3c9695e$var$Lh(t);
    }
    return t;
}
$aec35899a3c9695e$var$Gi.toKnownErr = $aec35899a3c9695e$var$a_;
var $aec35899a3c9695e$var$yo = {};
Object.defineProperty($aec35899a3c9695e$var$yo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$yo.toKnownErr = void 0;
const $aec35899a3c9695e$var$o_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$l_(t) {
    return $aec35899a3c9695e$var$o_.XRPCError, t;
}
$aec35899a3c9695e$var$yo.toKnownErr = $aec35899a3c9695e$var$l_;
var $aec35899a3c9695e$var$Fr = {};
Object.defineProperty($aec35899a3c9695e$var$Fr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Fr.toKnownErr = $aec35899a3c9695e$var$Fr.TokenRequiredError = $aec35899a3c9695e$var$Fr.InvalidTokenError = $aec35899a3c9695e$var$Fr.ExpiredTokenError = void 0;
const $aec35899a3c9695e$var$Ku = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$kh extends $aec35899a3c9695e$var$Ku.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Fr.ExpiredTokenError = $aec35899a3c9695e$var$kh;
class $aec35899a3c9695e$var$Dh extends $aec35899a3c9695e$var$Ku.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Fr.InvalidTokenError = $aec35899a3c9695e$var$Dh;
class $aec35899a3c9695e$var$Ph extends $aec35899a3c9695e$var$Ku.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Fr.TokenRequiredError = $aec35899a3c9695e$var$Ph;
function $aec35899a3c9695e$var$u_(t) {
    if (t instanceof $aec35899a3c9695e$var$Ku.XRPCError) {
        if (t.error === "ExpiredToken") return new $aec35899a3c9695e$var$kh(t);
        if (t.error === "InvalidToken") return new $aec35899a3c9695e$var$Dh(t);
        if (t.error === "TokenRequired") return new $aec35899a3c9695e$var$Ph(t);
    }
    return t;
}
$aec35899a3c9695e$var$Fr.toKnownErr = $aec35899a3c9695e$var$u_;
var $aec35899a3c9695e$var$ar = {};
Object.defineProperty($aec35899a3c9695e$var$ar, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ar.toKnownErr = $aec35899a3c9695e$var$ar.RepoDeactivatedError = $aec35899a3c9695e$var$ar.RepoSuspendedError = $aec35899a3c9695e$var$ar.RepoTakendownError = $aec35899a3c9695e$var$ar.RepoNotFoundError = $aec35899a3c9695e$var$ar.BlobNotFoundError = void 0;
const $aec35899a3c9695e$var$qs = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$Bh extends $aec35899a3c9695e$var$qs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$ar.BlobNotFoundError = $aec35899a3c9695e$var$Bh;
let $aec35899a3c9695e$var$Ih = class extends $aec35899a3c9695e$var$qs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$ar.RepoNotFoundError = $aec35899a3c9695e$var$Ih;
let $aec35899a3c9695e$var$Uh = class extends $aec35899a3c9695e$var$qs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$ar.RepoTakendownError = $aec35899a3c9695e$var$Uh;
let $aec35899a3c9695e$var$Oh = class extends $aec35899a3c9695e$var$qs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$ar.RepoSuspendedError = $aec35899a3c9695e$var$Oh;
let $aec35899a3c9695e$var$Kh = class extends $aec35899a3c9695e$var$qs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$ar.RepoDeactivatedError = $aec35899a3c9695e$var$Kh;
function $aec35899a3c9695e$var$c_(t) {
    if (t instanceof $aec35899a3c9695e$var$qs.XRPCError) {
        if (t.error === "BlobNotFound") return new $aec35899a3c9695e$var$Bh(t);
        if (t.error === "RepoNotFound") return new $aec35899a3c9695e$var$Ih(t);
        if (t.error === "RepoTakendown") return new $aec35899a3c9695e$var$Uh(t);
        if (t.error === "RepoSuspended") return new $aec35899a3c9695e$var$Oh(t);
        if (t.error === "RepoDeactivated") return new $aec35899a3c9695e$var$Kh(t);
    }
    return t;
}
$aec35899a3c9695e$var$ar.toKnownErr = $aec35899a3c9695e$var$c_;
var $aec35899a3c9695e$var$or = {};
Object.defineProperty($aec35899a3c9695e$var$or, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$or.toKnownErr = $aec35899a3c9695e$var$or.RepoDeactivatedError = $aec35899a3c9695e$var$or.RepoSuspendedError = $aec35899a3c9695e$var$or.RepoTakendownError = $aec35899a3c9695e$var$or.RepoNotFoundError = $aec35899a3c9695e$var$or.BlockNotFoundError = void 0;
const $aec35899a3c9695e$var$zs = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$Mh extends $aec35899a3c9695e$var$zs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$or.BlockNotFoundError = $aec35899a3c9695e$var$Mh;
let $aec35899a3c9695e$var$Nh = class extends $aec35899a3c9695e$var$zs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$or.RepoNotFoundError = $aec35899a3c9695e$var$Nh;
let $aec35899a3c9695e$var$Vh = class extends $aec35899a3c9695e$var$zs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$or.RepoTakendownError = $aec35899a3c9695e$var$Vh;
let $aec35899a3c9695e$var$jh = class extends $aec35899a3c9695e$var$zs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$or.RepoSuspendedError = $aec35899a3c9695e$var$jh;
let $aec35899a3c9695e$var$Fh = class extends $aec35899a3c9695e$var$zs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$or.RepoDeactivatedError = $aec35899a3c9695e$var$Fh;
function $aec35899a3c9695e$var$d_(t) {
    if (t instanceof $aec35899a3c9695e$var$zs.XRPCError) {
        if (t.error === "BlockNotFound") return new $aec35899a3c9695e$var$Mh(t);
        if (t.error === "RepoNotFound") return new $aec35899a3c9695e$var$Nh(t);
        if (t.error === "RepoTakendown") return new $aec35899a3c9695e$var$Vh(t);
        if (t.error === "RepoSuspended") return new $aec35899a3c9695e$var$jh(t);
        if (t.error === "RepoDeactivated") return new $aec35899a3c9695e$var$Fh(t);
    }
    return t;
}
$aec35899a3c9695e$var$or.toKnownErr = $aec35899a3c9695e$var$d_;
var $aec35899a3c9695e$var$bo = {};
Object.defineProperty($aec35899a3c9695e$var$bo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$bo.toKnownErr = void 0;
const $aec35899a3c9695e$var$f_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$p_(t) {
    return $aec35899a3c9695e$var$f_.XRPCError, t;
}
$aec35899a3c9695e$var$bo.toKnownErr = $aec35899a3c9695e$var$p_;
var $aec35899a3c9695e$var$qn = {};
Object.defineProperty($aec35899a3c9695e$var$qn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$qn.toKnownErr = $aec35899a3c9695e$var$qn.HeadNotFoundError = void 0;
const $aec35899a3c9695e$var$$h = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$Gh extends $aec35899a3c9695e$var$$h.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$qn.HeadNotFoundError = $aec35899a3c9695e$var$Gh;
function $aec35899a3c9695e$var$h_(t) {
    return t instanceof $aec35899a3c9695e$var$$h.XRPCError && t.error === "HeadNotFound" ? new $aec35899a3c9695e$var$Gh(t) : t;
}
$aec35899a3c9695e$var$qn.toKnownErr = $aec35899a3c9695e$var$h_;
var $aec35899a3c9695e$var$_r = {};
Object.defineProperty($aec35899a3c9695e$var$_r, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$_r.toKnownErr = $aec35899a3c9695e$var$_r.RepoDeactivatedError = $aec35899a3c9695e$var$_r.RepoSuspendedError = $aec35899a3c9695e$var$_r.RepoTakendownError = $aec35899a3c9695e$var$_r.RepoNotFoundError = void 0;
const $aec35899a3c9695e$var$go = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$qh = class extends $aec35899a3c9695e$var$go.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$_r.RepoNotFoundError = $aec35899a3c9695e$var$qh;
let $aec35899a3c9695e$var$zh = class extends $aec35899a3c9695e$var$go.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$_r.RepoTakendownError = $aec35899a3c9695e$var$zh;
let $aec35899a3c9695e$var$Xh = class extends $aec35899a3c9695e$var$go.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$_r.RepoSuspendedError = $aec35899a3c9695e$var$Xh;
let $aec35899a3c9695e$var$Hh = class extends $aec35899a3c9695e$var$go.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$_r.RepoDeactivatedError = $aec35899a3c9695e$var$Hh;
function $aec35899a3c9695e$var$m_(t) {
    if (t instanceof $aec35899a3c9695e$var$go.XRPCError) {
        if (t.error === "RepoNotFound") return new $aec35899a3c9695e$var$qh(t);
        if (t.error === "RepoTakendown") return new $aec35899a3c9695e$var$zh(t);
        if (t.error === "RepoSuspended") return new $aec35899a3c9695e$var$Xh(t);
        if (t.error === "RepoDeactivated") return new $aec35899a3c9695e$var$Hh(t);
    }
    return t;
}
$aec35899a3c9695e$var$_r.toKnownErr = $aec35899a3c9695e$var$m_;
var $aec35899a3c9695e$var$lr = {};
Object.defineProperty($aec35899a3c9695e$var$lr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$lr.toKnownErr = $aec35899a3c9695e$var$lr.RepoDeactivatedError = $aec35899a3c9695e$var$lr.RepoSuspendedError = $aec35899a3c9695e$var$lr.RepoTakendownError = $aec35899a3c9695e$var$lr.RepoNotFoundError = $aec35899a3c9695e$var$lr.RecordNotFoundError = void 0;
const $aec35899a3c9695e$var$Xs = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$Zh = class extends $aec35899a3c9695e$var$Xs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$lr.RecordNotFoundError = $aec35899a3c9695e$var$Zh;
let $aec35899a3c9695e$var$Wh = class extends $aec35899a3c9695e$var$Xs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$lr.RepoNotFoundError = $aec35899a3c9695e$var$Wh;
let $aec35899a3c9695e$var$Yh = class extends $aec35899a3c9695e$var$Xs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$lr.RepoTakendownError = $aec35899a3c9695e$var$Yh;
let $aec35899a3c9695e$var$Jh = class extends $aec35899a3c9695e$var$Xs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$lr.RepoSuspendedError = $aec35899a3c9695e$var$Jh;
let $aec35899a3c9695e$var$Qh = class extends $aec35899a3c9695e$var$Xs.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$lr.RepoDeactivatedError = $aec35899a3c9695e$var$Qh;
function $aec35899a3c9695e$var$y_(t) {
    if (t instanceof $aec35899a3c9695e$var$Xs.XRPCError) {
        if (t.error === "RecordNotFound") return new $aec35899a3c9695e$var$Zh(t);
        if (t.error === "RepoNotFound") return new $aec35899a3c9695e$var$Wh(t);
        if (t.error === "RepoTakendown") return new $aec35899a3c9695e$var$Yh(t);
        if (t.error === "RepoSuspended") return new $aec35899a3c9695e$var$Jh(t);
        if (t.error === "RepoDeactivated") return new $aec35899a3c9695e$var$Qh(t);
    }
    return t;
}
$aec35899a3c9695e$var$lr.toKnownErr = $aec35899a3c9695e$var$y_;
var $aec35899a3c9695e$var$wr = {};
Object.defineProperty($aec35899a3c9695e$var$wr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$wr.toKnownErr = $aec35899a3c9695e$var$wr.RepoDeactivatedError = $aec35899a3c9695e$var$wr.RepoSuspendedError = $aec35899a3c9695e$var$wr.RepoTakendownError = $aec35899a3c9695e$var$wr.RepoNotFoundError = void 0;
const $aec35899a3c9695e$var$xo = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$e0 = class extends $aec35899a3c9695e$var$xo.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$wr.RepoNotFoundError = $aec35899a3c9695e$var$e0;
let $aec35899a3c9695e$var$t0 = class extends $aec35899a3c9695e$var$xo.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$wr.RepoTakendownError = $aec35899a3c9695e$var$t0;
let $aec35899a3c9695e$var$r0 = class extends $aec35899a3c9695e$var$xo.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$wr.RepoSuspendedError = $aec35899a3c9695e$var$r0;
let $aec35899a3c9695e$var$i0 = class extends $aec35899a3c9695e$var$xo.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$wr.RepoDeactivatedError = $aec35899a3c9695e$var$i0;
function $aec35899a3c9695e$var$b_(t) {
    if (t instanceof $aec35899a3c9695e$var$xo.XRPCError) {
        if (t.error === "RepoNotFound") return new $aec35899a3c9695e$var$e0(t);
        if (t.error === "RepoTakendown") return new $aec35899a3c9695e$var$t0(t);
        if (t.error === "RepoSuspended") return new $aec35899a3c9695e$var$r0(t);
        if (t.error === "RepoDeactivated") return new $aec35899a3c9695e$var$i0(t);
    }
    return t;
}
$aec35899a3c9695e$var$wr.toKnownErr = $aec35899a3c9695e$var$b_;
var $aec35899a3c9695e$var$zn = {};
Object.defineProperty($aec35899a3c9695e$var$zn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$zn.toKnownErr = $aec35899a3c9695e$var$zn.RepoNotFoundError = void 0;
const $aec35899a3c9695e$var$n0 = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$s0 = class extends $aec35899a3c9695e$var$n0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$zn.RepoNotFoundError = $aec35899a3c9695e$var$s0;
function $aec35899a3c9695e$var$g_(t) {
    return t instanceof $aec35899a3c9695e$var$n0.XRPCError && t.error === "RepoNotFound" ? new $aec35899a3c9695e$var$s0(t) : t;
}
$aec35899a3c9695e$var$zn.toKnownErr = $aec35899a3c9695e$var$g_;
var $aec35899a3c9695e$var$Tr = {};
Object.defineProperty($aec35899a3c9695e$var$Tr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Tr.toKnownErr = $aec35899a3c9695e$var$Tr.RepoDeactivatedError = $aec35899a3c9695e$var$Tr.RepoSuspendedError = $aec35899a3c9695e$var$Tr.RepoTakendownError = $aec35899a3c9695e$var$Tr.RepoNotFoundError = void 0;
const $aec35899a3c9695e$var$Eo = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$a0 = class extends $aec35899a3c9695e$var$Eo.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Tr.RepoNotFoundError = $aec35899a3c9695e$var$a0;
class $aec35899a3c9695e$var$o0 extends $aec35899a3c9695e$var$Eo.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Tr.RepoTakendownError = $aec35899a3c9695e$var$o0;
class $aec35899a3c9695e$var$l0 extends $aec35899a3c9695e$var$Eo.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Tr.RepoSuspendedError = $aec35899a3c9695e$var$l0;
class $aec35899a3c9695e$var$u0 extends $aec35899a3c9695e$var$Eo.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Tr.RepoDeactivatedError = $aec35899a3c9695e$var$u0;
function $aec35899a3c9695e$var$x_(t) {
    if (t instanceof $aec35899a3c9695e$var$Eo.XRPCError) {
        if (t.error === "RepoNotFound") return new $aec35899a3c9695e$var$a0(t);
        if (t.error === "RepoTakendown") return new $aec35899a3c9695e$var$o0(t);
        if (t.error === "RepoSuspended") return new $aec35899a3c9695e$var$l0(t);
        if (t.error === "RepoDeactivated") return new $aec35899a3c9695e$var$u0(t);
    }
    return t;
}
$aec35899a3c9695e$var$Tr.toKnownErr = $aec35899a3c9695e$var$x_;
var $aec35899a3c9695e$var$qi = {};
Object.defineProperty($aec35899a3c9695e$var$qi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$qi.validateRepo = $aec35899a3c9695e$var$qi.isRepo = $aec35899a3c9695e$var$qi.toKnownErr = void 0;
const $aec35899a3c9695e$var$E_ = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$zd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$v_ = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$R_(t) {
    return $aec35899a3c9695e$var$E_.XRPCError, t;
}
$aec35899a3c9695e$var$qi.toKnownErr = $aec35899a3c9695e$var$R_;
function $aec35899a3c9695e$var$A_(t) {
    return (0, $aec35899a3c9695e$var$zd.isObj)(t) && (0, $aec35899a3c9695e$var$zd.hasProp)(t, "$type") && t.$type === "com.atproto.sync.listRepos#repo";
}
$aec35899a3c9695e$var$qi.isRepo = $aec35899a3c9695e$var$A_;
function $aec35899a3c9695e$var$__(t) {
    return $aec35899a3c9695e$var$v_.lexicons.validate("com.atproto.sync.listRepos#repo", t);
}
$aec35899a3c9695e$var$qi.validateRepo = $aec35899a3c9695e$var$__;
var $aec35899a3c9695e$var$vo = {};
Object.defineProperty($aec35899a3c9695e$var$vo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$vo.toKnownErr = void 0;
const $aec35899a3c9695e$var$w_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$T_(t) {
    return $aec35899a3c9695e$var$w_.XRPCError, t;
}
$aec35899a3c9695e$var$vo.toKnownErr = $aec35899a3c9695e$var$T_;
var $aec35899a3c9695e$var$Ro = {};
Object.defineProperty($aec35899a3c9695e$var$Ro, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ro.toKnownErr = void 0;
const $aec35899a3c9695e$var$S_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$C_(t) {
    return $aec35899a3c9695e$var$S_.XRPCError, t;
}
$aec35899a3c9695e$var$Ro.toKnownErr = $aec35899a3c9695e$var$C_;
var $aec35899a3c9695e$var$Ao = {};
Object.defineProperty($aec35899a3c9695e$var$Ao, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ao.toKnownErr = void 0;
const $aec35899a3c9695e$var$L_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$k_(t) {
    return $aec35899a3c9695e$var$L_.XRPCError, t;
}
$aec35899a3c9695e$var$Ao.toKnownErr = $aec35899a3c9695e$var$k_;
var $aec35899a3c9695e$var$_o = {};
Object.defineProperty($aec35899a3c9695e$var$_o, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$_o.toKnownErr = void 0;
const $aec35899a3c9695e$var$D_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$P_(t) {
    return $aec35899a3c9695e$var$D_.XRPCError, t;
}
$aec35899a3c9695e$var$_o.toKnownErr = $aec35899a3c9695e$var$P_;
var $aec35899a3c9695e$var$wo = {};
Object.defineProperty($aec35899a3c9695e$var$wo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$wo.toKnownErr = void 0;
const $aec35899a3c9695e$var$B_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$I_(t) {
    return $aec35899a3c9695e$var$B_.XRPCError, t;
}
$aec35899a3c9695e$var$wo.toKnownErr = $aec35899a3c9695e$var$I_;
var $aec35899a3c9695e$var$To = {};
Object.defineProperty($aec35899a3c9695e$var$To, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$To.toKnownErr = void 0;
const $aec35899a3c9695e$var$U_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$O_(t) {
    return $aec35899a3c9695e$var$U_.XRPCError, t;
}
$aec35899a3c9695e$var$To.toKnownErr = $aec35899a3c9695e$var$O_;
var $aec35899a3c9695e$var$So = {};
Object.defineProperty($aec35899a3c9695e$var$So, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$So.toKnownErr = void 0;
const $aec35899a3c9695e$var$K_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$M_(t) {
    return $aec35899a3c9695e$var$K_.XRPCError, t;
}
$aec35899a3c9695e$var$So.toKnownErr = $aec35899a3c9695e$var$M_;
var $aec35899a3c9695e$var$Co = {};
Object.defineProperty($aec35899a3c9695e$var$Co, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Co.toKnownErr = void 0;
const $aec35899a3c9695e$var$N_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$V_(t) {
    return $aec35899a3c9695e$var$N_.XRPCError, t;
}
$aec35899a3c9695e$var$Co.toKnownErr = $aec35899a3c9695e$var$V_;
var $aec35899a3c9695e$var$Lo = {};
Object.defineProperty($aec35899a3c9695e$var$Lo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Lo.toKnownErr = void 0;
const $aec35899a3c9695e$var$j_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$F_(t) {
    return $aec35899a3c9695e$var$j_.XRPCError, t;
}
$aec35899a3c9695e$var$Lo.toKnownErr = $aec35899a3c9695e$var$F_;
var $aec35899a3c9695e$var$ko = {};
Object.defineProperty($aec35899a3c9695e$var$ko, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ko.toKnownErr = void 0;
const $aec35899a3c9695e$var$$_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$G_(t) {
    return $aec35899a3c9695e$var$$_.XRPCError, t;
}
$aec35899a3c9695e$var$ko.toKnownErr = $aec35899a3c9695e$var$G_;
var $aec35899a3c9695e$var$Do = {};
Object.defineProperty($aec35899a3c9695e$var$Do, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Do.toKnownErr = void 0;
const $aec35899a3c9695e$var$q_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$z_(t) {
    return $aec35899a3c9695e$var$q_.XRPCError, t;
}
$aec35899a3c9695e$var$Do.toKnownErr = $aec35899a3c9695e$var$z_;
var $aec35899a3c9695e$var$Po = {};
Object.defineProperty($aec35899a3c9695e$var$Po, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Po.toKnownErr = void 0;
const $aec35899a3c9695e$var$X_ = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$H_(t) {
    return $aec35899a3c9695e$var$X_.XRPCError, t;
}
$aec35899a3c9695e$var$Po.toKnownErr = $aec35899a3c9695e$var$H_;
var $aec35899a3c9695e$var$Sr = {};
Object.defineProperty($aec35899a3c9695e$var$Sr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Sr.validateLinks = $aec35899a3c9695e$var$Sr.isLinks = $aec35899a3c9695e$var$Sr.validateFeed = $aec35899a3c9695e$var$Sr.isFeed = $aec35899a3c9695e$var$Sr.toKnownErr = void 0;
const $aec35899a3c9695e$var$Z_ = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Ru = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$c0 = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$W_(t) {
    return $aec35899a3c9695e$var$Z_.XRPCError, t;
}
$aec35899a3c9695e$var$Sr.toKnownErr = $aec35899a3c9695e$var$W_;
function $aec35899a3c9695e$var$Y_(t) {
    return (0, $aec35899a3c9695e$var$Ru.isObj)(t) && (0, $aec35899a3c9695e$var$Ru.hasProp)(t, "$type") && t.$type === "app.bsky.feed.describeFeedGenerator#feed";
}
$aec35899a3c9695e$var$Sr.isFeed = $aec35899a3c9695e$var$Y_;
function $aec35899a3c9695e$var$J_(t) {
    return $aec35899a3c9695e$var$c0.lexicons.validate("app.bsky.feed.describeFeedGenerator#feed", t);
}
$aec35899a3c9695e$var$Sr.validateFeed = $aec35899a3c9695e$var$J_;
function $aec35899a3c9695e$var$Q_(t) {
    return (0, $aec35899a3c9695e$var$Ru.isObj)(t) && (0, $aec35899a3c9695e$var$Ru.hasProp)(t, "$type") && t.$type === "app.bsky.feed.describeFeedGenerator#links";
}
$aec35899a3c9695e$var$Sr.isLinks = $aec35899a3c9695e$var$Q_;
function $aec35899a3c9695e$var$ew(t) {
    return $aec35899a3c9695e$var$c0.lexicons.validate("app.bsky.feed.describeFeedGenerator#links", t);
}
$aec35899a3c9695e$var$Sr.validateLinks = $aec35899a3c9695e$var$ew;
var $aec35899a3c9695e$var$Bo = {};
Object.defineProperty($aec35899a3c9695e$var$Bo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Bo.toKnownErr = void 0;
const $aec35899a3c9695e$var$tw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$rw(t) {
    return $aec35899a3c9695e$var$tw.XRPCError, t;
}
$aec35899a3c9695e$var$Bo.toKnownErr = $aec35899a3c9695e$var$rw;
var $aec35899a3c9695e$var$zi = {};
Object.defineProperty($aec35899a3c9695e$var$zi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$zi.toKnownErr = $aec35899a3c9695e$var$zi.BlockedByActorError = $aec35899a3c9695e$var$zi.BlockedActorError = void 0;
const $aec35899a3c9695e$var$ed = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$d0 = class extends $aec35899a3c9695e$var$ed.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$zi.BlockedActorError = $aec35899a3c9695e$var$d0;
let $aec35899a3c9695e$var$f0 = class extends $aec35899a3c9695e$var$ed.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$zi.BlockedByActorError = $aec35899a3c9695e$var$f0;
function $aec35899a3c9695e$var$iw(t) {
    if (t instanceof $aec35899a3c9695e$var$ed.XRPCError) {
        if (t.error === "BlockedActor") return new $aec35899a3c9695e$var$d0(t);
        if (t.error === "BlockedByActor") return new $aec35899a3c9695e$var$f0(t);
    }
    return t;
}
$aec35899a3c9695e$var$zi.toKnownErr = $aec35899a3c9695e$var$iw;
var $aec35899a3c9695e$var$Xi = {};
Object.defineProperty($aec35899a3c9695e$var$Xi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Xi.toKnownErr = $aec35899a3c9695e$var$Xi.BlockedByActorError = $aec35899a3c9695e$var$Xi.BlockedActorError = void 0;
const $aec35899a3c9695e$var$td = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$p0 extends $aec35899a3c9695e$var$td.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Xi.BlockedActorError = $aec35899a3c9695e$var$p0;
class $aec35899a3c9695e$var$h0 extends $aec35899a3c9695e$var$td.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Xi.BlockedByActorError = $aec35899a3c9695e$var$h0;
function $aec35899a3c9695e$var$nw(t) {
    if (t instanceof $aec35899a3c9695e$var$td.XRPCError) {
        if (t.error === "BlockedActor") return new $aec35899a3c9695e$var$p0(t);
        if (t.error === "BlockedByActor") return new $aec35899a3c9695e$var$h0(t);
    }
    return t;
}
$aec35899a3c9695e$var$Xi.toKnownErr = $aec35899a3c9695e$var$nw;
var $aec35899a3c9695e$var$Xn = {};
Object.defineProperty($aec35899a3c9695e$var$Xn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Xn.toKnownErr = $aec35899a3c9695e$var$Xn.UnknownFeedError = void 0;
const $aec35899a3c9695e$var$m0 = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$y0 = class extends $aec35899a3c9695e$var$m0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Xn.UnknownFeedError = $aec35899a3c9695e$var$y0;
function $aec35899a3c9695e$var$sw(t) {
    return t instanceof $aec35899a3c9695e$var$m0.XRPCError && t.error === "UnknownFeed" ? new $aec35899a3c9695e$var$y0(t) : t;
}
$aec35899a3c9695e$var$Xn.toKnownErr = $aec35899a3c9695e$var$sw;
var $aec35899a3c9695e$var$Io = {};
Object.defineProperty($aec35899a3c9695e$var$Io, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Io.toKnownErr = void 0;
const $aec35899a3c9695e$var$aw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$ow(t) {
    return $aec35899a3c9695e$var$aw.XRPCError, t;
}
$aec35899a3c9695e$var$Io.toKnownErr = $aec35899a3c9695e$var$ow;
var $aec35899a3c9695e$var$Uo = {};
Object.defineProperty($aec35899a3c9695e$var$Uo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Uo.toKnownErr = void 0;
const $aec35899a3c9695e$var$lw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$uw(t) {
    return $aec35899a3c9695e$var$lw.XRPCError, t;
}
$aec35899a3c9695e$var$Uo.toKnownErr = $aec35899a3c9695e$var$uw;
var $aec35899a3c9695e$var$Hn = {};
Object.defineProperty($aec35899a3c9695e$var$Hn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Hn.toKnownErr = $aec35899a3c9695e$var$Hn.UnknownFeedError = void 0;
const $aec35899a3c9695e$var$b0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$g0 extends $aec35899a3c9695e$var$b0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Hn.UnknownFeedError = $aec35899a3c9695e$var$g0;
function $aec35899a3c9695e$var$cw(t) {
    return t instanceof $aec35899a3c9695e$var$b0.XRPCError && t.error === "UnknownFeed" ? new $aec35899a3c9695e$var$g0(t) : t;
}
$aec35899a3c9695e$var$Hn.toKnownErr = $aec35899a3c9695e$var$cw;
var $aec35899a3c9695e$var$Hi = {};
Object.defineProperty($aec35899a3c9695e$var$Hi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Hi.validateLike = $aec35899a3c9695e$var$Hi.isLike = $aec35899a3c9695e$var$Hi.toKnownErr = void 0;
const $aec35899a3c9695e$var$dw = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Xd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$fw = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$pw(t) {
    return $aec35899a3c9695e$var$dw.XRPCError, t;
}
$aec35899a3c9695e$var$Hi.toKnownErr = $aec35899a3c9695e$var$pw;
function $aec35899a3c9695e$var$hw(t) {
    return (0, $aec35899a3c9695e$var$Xd.isObj)(t) && (0, $aec35899a3c9695e$var$Xd.hasProp)(t, "$type") && t.$type === "app.bsky.feed.getLikes#like";
}
$aec35899a3c9695e$var$Hi.isLike = $aec35899a3c9695e$var$hw;
function $aec35899a3c9695e$var$mw(t) {
    return $aec35899a3c9695e$var$fw.lexicons.validate("app.bsky.feed.getLikes#like", t);
}
$aec35899a3c9695e$var$Hi.validateLike = $aec35899a3c9695e$var$mw;
var $aec35899a3c9695e$var$Zn = {};
Object.defineProperty($aec35899a3c9695e$var$Zn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Zn.toKnownErr = $aec35899a3c9695e$var$Zn.UnknownListError = void 0;
const $aec35899a3c9695e$var$x0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$E0 extends $aec35899a3c9695e$var$x0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Zn.UnknownListError = $aec35899a3c9695e$var$E0;
function $aec35899a3c9695e$var$yw(t) {
    return t instanceof $aec35899a3c9695e$var$x0.XRPCError && t.error === "UnknownList" ? new $aec35899a3c9695e$var$E0(t) : t;
}
$aec35899a3c9695e$var$Zn.toKnownErr = $aec35899a3c9695e$var$yw;
var $aec35899a3c9695e$var$Wn = {};
Object.defineProperty($aec35899a3c9695e$var$Wn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Wn.toKnownErr = $aec35899a3c9695e$var$Wn.NotFoundError = void 0;
const $aec35899a3c9695e$var$v0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$R0 extends $aec35899a3c9695e$var$v0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Wn.NotFoundError = $aec35899a3c9695e$var$R0;
function $aec35899a3c9695e$var$bw(t) {
    return t instanceof $aec35899a3c9695e$var$v0.XRPCError && t.error === "NotFound" ? new $aec35899a3c9695e$var$R0(t) : t;
}
$aec35899a3c9695e$var$Wn.toKnownErr = $aec35899a3c9695e$var$bw;
var $aec35899a3c9695e$var$Oo = {};
Object.defineProperty($aec35899a3c9695e$var$Oo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Oo.toKnownErr = void 0;
const $aec35899a3c9695e$var$gw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$xw(t) {
    return $aec35899a3c9695e$var$gw.XRPCError, t;
}
$aec35899a3c9695e$var$Oo.toKnownErr = $aec35899a3c9695e$var$xw;
var $aec35899a3c9695e$var$Ko = {};
Object.defineProperty($aec35899a3c9695e$var$Ko, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ko.toKnownErr = void 0;
const $aec35899a3c9695e$var$Ew = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$vw(t) {
    return $aec35899a3c9695e$var$Ew.XRPCError, t;
}
$aec35899a3c9695e$var$Ko.toKnownErr = $aec35899a3c9695e$var$vw;
var $aec35899a3c9695e$var$Mo = {};
Object.defineProperty($aec35899a3c9695e$var$Mo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Mo.toKnownErr = void 0;
const $aec35899a3c9695e$var$Rw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Aw(t) {
    return $aec35899a3c9695e$var$Rw.XRPCError, t;
}
$aec35899a3c9695e$var$Mo.toKnownErr = $aec35899a3c9695e$var$Aw;
var $aec35899a3c9695e$var$No = {};
Object.defineProperty($aec35899a3c9695e$var$No, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$No.toKnownErr = void 0;
const $aec35899a3c9695e$var$_w = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$ww(t) {
    return $aec35899a3c9695e$var$_w.XRPCError, t;
}
$aec35899a3c9695e$var$No.toKnownErr = $aec35899a3c9695e$var$ww;
var $aec35899a3c9695e$var$Yn = {};
Object.defineProperty($aec35899a3c9695e$var$Yn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Yn.toKnownErr = $aec35899a3c9695e$var$Yn.BadQueryStringError = void 0;
const $aec35899a3c9695e$var$A0 = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$_0 = class extends $aec35899a3c9695e$var$A0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Yn.BadQueryStringError = $aec35899a3c9695e$var$_0;
function $aec35899a3c9695e$var$Tw(t) {
    return t instanceof $aec35899a3c9695e$var$A0.XRPCError && t.error === "BadQueryString" ? new $aec35899a3c9695e$var$_0(t) : t;
}
$aec35899a3c9695e$var$Yn.toKnownErr = $aec35899a3c9695e$var$Tw;
var $aec35899a3c9695e$var$Vo = {};
Object.defineProperty($aec35899a3c9695e$var$Vo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Vo.toKnownErr = void 0;
const $aec35899a3c9695e$var$Sw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Cw(t) {
    return $aec35899a3c9695e$var$Sw.XRPCError, t;
}
$aec35899a3c9695e$var$Vo.toKnownErr = $aec35899a3c9695e$var$Cw;
var $aec35899a3c9695e$var$jo = {};
Object.defineProperty($aec35899a3c9695e$var$jo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$jo.toKnownErr = void 0;
const $aec35899a3c9695e$var$Lw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$kw(t) {
    return $aec35899a3c9695e$var$Lw.XRPCError, t;
}
$aec35899a3c9695e$var$jo.toKnownErr = $aec35899a3c9695e$var$kw;
var $aec35899a3c9695e$var$Fo = {};
Object.defineProperty($aec35899a3c9695e$var$Fo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Fo.toKnownErr = void 0;
const $aec35899a3c9695e$var$Dw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Pw(t) {
    return $aec35899a3c9695e$var$Dw.XRPCError, t;
}
$aec35899a3c9695e$var$Fo.toKnownErr = $aec35899a3c9695e$var$Pw;
var $aec35899a3c9695e$var$$o = {};
Object.defineProperty($aec35899a3c9695e$var$$o, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$$o.toKnownErr = void 0;
const $aec35899a3c9695e$var$Bw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Iw(t) {
    return $aec35899a3c9695e$var$Bw.XRPCError, t;
}
$aec35899a3c9695e$var$$o.toKnownErr = $aec35899a3c9695e$var$Iw;
var $aec35899a3c9695e$var$Go = {};
Object.defineProperty($aec35899a3c9695e$var$Go, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Go.toKnownErr = void 0;
const $aec35899a3c9695e$var$Uw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Ow(t) {
    return $aec35899a3c9695e$var$Uw.XRPCError, t;
}
$aec35899a3c9695e$var$Go.toKnownErr = $aec35899a3c9695e$var$Ow;
var $aec35899a3c9695e$var$qo = {};
Object.defineProperty($aec35899a3c9695e$var$qo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$qo.toKnownErr = void 0;
const $aec35899a3c9695e$var$Kw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Mw(t) {
    return $aec35899a3c9695e$var$Kw.XRPCError, t;
}
$aec35899a3c9695e$var$qo.toKnownErr = $aec35899a3c9695e$var$Mw;
var $aec35899a3c9695e$var$zo = {};
Object.defineProperty($aec35899a3c9695e$var$zo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$zo.toKnownErr = void 0;
const $aec35899a3c9695e$var$Nw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Vw(t) {
    return $aec35899a3c9695e$var$Nw.XRPCError, t;
}
$aec35899a3c9695e$var$zo.toKnownErr = $aec35899a3c9695e$var$Vw;
var $aec35899a3c9695e$var$Xo = {};
Object.defineProperty($aec35899a3c9695e$var$Xo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Xo.toKnownErr = void 0;
const $aec35899a3c9695e$var$jw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Fw(t) {
    return $aec35899a3c9695e$var$jw.XRPCError, t;
}
$aec35899a3c9695e$var$Xo.toKnownErr = $aec35899a3c9695e$var$Fw;
var $aec35899a3c9695e$var$Ho = {};
Object.defineProperty($aec35899a3c9695e$var$Ho, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ho.toKnownErr = void 0;
const $aec35899a3c9695e$var$$w = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Gw(t) {
    return $aec35899a3c9695e$var$$w.XRPCError, t;
}
$aec35899a3c9695e$var$Ho.toKnownErr = $aec35899a3c9695e$var$Gw;
var $aec35899a3c9695e$var$Zo = {};
Object.defineProperty($aec35899a3c9695e$var$Zo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Zo.toKnownErr = void 0;
const $aec35899a3c9695e$var$qw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$zw(t) {
    return $aec35899a3c9695e$var$qw.XRPCError, t;
}
$aec35899a3c9695e$var$Zo.toKnownErr = $aec35899a3c9695e$var$zw;
var $aec35899a3c9695e$var$Wo = {};
Object.defineProperty($aec35899a3c9695e$var$Wo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Wo.toKnownErr = void 0;
const $aec35899a3c9695e$var$Xw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Hw(t) {
    return $aec35899a3c9695e$var$Xw.XRPCError, t;
}
$aec35899a3c9695e$var$Wo.toKnownErr = $aec35899a3c9695e$var$Hw;
var $aec35899a3c9695e$var$Jn = {};
Object.defineProperty($aec35899a3c9695e$var$Jn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Jn.toKnownErr = $aec35899a3c9695e$var$Jn.ActorNotFoundError = void 0;
const $aec35899a3c9695e$var$w0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$T0 extends $aec35899a3c9695e$var$w0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Jn.ActorNotFoundError = $aec35899a3c9695e$var$T0;
function $aec35899a3c9695e$var$Zw(t) {
    return t instanceof $aec35899a3c9695e$var$w0.XRPCError && t.error === "ActorNotFound" ? new $aec35899a3c9695e$var$T0(t) : t;
}
$aec35899a3c9695e$var$Jn.toKnownErr = $aec35899a3c9695e$var$Zw;
var $aec35899a3c9695e$var$Yo = {};
Object.defineProperty($aec35899a3c9695e$var$Yo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Yo.toKnownErr = void 0;
const $aec35899a3c9695e$var$Ww = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Yw(t) {
    return $aec35899a3c9695e$var$Ww.XRPCError, t;
}
$aec35899a3c9695e$var$Yo.toKnownErr = $aec35899a3c9695e$var$Yw;
var $aec35899a3c9695e$var$Jo = {};
Object.defineProperty($aec35899a3c9695e$var$Jo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Jo.toKnownErr = void 0;
const $aec35899a3c9695e$var$Jw = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$Qw(t) {
    return $aec35899a3c9695e$var$Jw.XRPCError, t;
}
$aec35899a3c9695e$var$Jo.toKnownErr = $aec35899a3c9695e$var$Qw;
var $aec35899a3c9695e$var$Qo = {};
Object.defineProperty($aec35899a3c9695e$var$Qo, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Qo.toKnownErr = void 0;
const $aec35899a3c9695e$var$eT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$tT(t) {
    return $aec35899a3c9695e$var$eT.XRPCError, t;
}
$aec35899a3c9695e$var$Qo.toKnownErr = $aec35899a3c9695e$var$tT;
var $aec35899a3c9695e$var$el = {};
Object.defineProperty($aec35899a3c9695e$var$el, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$el.toKnownErr = void 0;
const $aec35899a3c9695e$var$rT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$iT(t) {
    return $aec35899a3c9695e$var$rT.XRPCError, t;
}
$aec35899a3c9695e$var$el.toKnownErr = $aec35899a3c9695e$var$iT;
var $aec35899a3c9695e$var$tl = {};
Object.defineProperty($aec35899a3c9695e$var$tl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$tl.toKnownErr = void 0;
const $aec35899a3c9695e$var$nT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$sT(t) {
    return $aec35899a3c9695e$var$nT.XRPCError, t;
}
$aec35899a3c9695e$var$tl.toKnownErr = $aec35899a3c9695e$var$sT;
var $aec35899a3c9695e$var$rl = {};
Object.defineProperty($aec35899a3c9695e$var$rl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$rl.toKnownErr = void 0;
const $aec35899a3c9695e$var$aT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$oT(t) {
    return $aec35899a3c9695e$var$aT.XRPCError, t;
}
$aec35899a3c9695e$var$rl.toKnownErr = $aec35899a3c9695e$var$oT;
var $aec35899a3c9695e$var$il = {};
Object.defineProperty($aec35899a3c9695e$var$il, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$il.toKnownErr = void 0;
const $aec35899a3c9695e$var$lT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$uT(t) {
    return $aec35899a3c9695e$var$lT.XRPCError, t;
}
$aec35899a3c9695e$var$il.toKnownErr = $aec35899a3c9695e$var$uT;
var $aec35899a3c9695e$var$nl = {};
Object.defineProperty($aec35899a3c9695e$var$nl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$nl.toKnownErr = void 0;
const $aec35899a3c9695e$var$cT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$dT(t) {
    return $aec35899a3c9695e$var$cT.XRPCError, t;
}
$aec35899a3c9695e$var$nl.toKnownErr = $aec35899a3c9695e$var$dT;
var $aec35899a3c9695e$var$sl = {};
Object.defineProperty($aec35899a3c9695e$var$sl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$sl.toKnownErr = void 0;
const $aec35899a3c9695e$var$fT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$pT(t) {
    return $aec35899a3c9695e$var$fT.XRPCError, t;
}
$aec35899a3c9695e$var$sl.toKnownErr = $aec35899a3c9695e$var$pT;
var $aec35899a3c9695e$var$al = {};
Object.defineProperty($aec35899a3c9695e$var$al, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$al.toKnownErr = void 0;
const $aec35899a3c9695e$var$hT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$mT(t) {
    return $aec35899a3c9695e$var$hT.XRPCError, t;
}
$aec35899a3c9695e$var$al.toKnownErr = $aec35899a3c9695e$var$mT;
var $aec35899a3c9695e$var$ol = {};
Object.defineProperty($aec35899a3c9695e$var$ol, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ol.toKnownErr = void 0;
const $aec35899a3c9695e$var$yT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$bT(t) {
    return $aec35899a3c9695e$var$yT.XRPCError, t;
}
$aec35899a3c9695e$var$ol.toKnownErr = $aec35899a3c9695e$var$bT;
var $aec35899a3c9695e$var$Zi = {};
Object.defineProperty($aec35899a3c9695e$var$Zi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Zi.validateNotification = $aec35899a3c9695e$var$Zi.isNotification = $aec35899a3c9695e$var$Zi.toKnownErr = void 0;
const $aec35899a3c9695e$var$gT = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Hd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$xT = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$ET(t) {
    return $aec35899a3c9695e$var$gT.XRPCError, t;
}
$aec35899a3c9695e$var$Zi.toKnownErr = $aec35899a3c9695e$var$ET;
function $aec35899a3c9695e$var$vT(t) {
    return (0, $aec35899a3c9695e$var$Hd.isObj)(t) && (0, $aec35899a3c9695e$var$Hd.hasProp)(t, "$type") && t.$type === "app.bsky.notification.listNotifications#notification";
}
$aec35899a3c9695e$var$Zi.isNotification = $aec35899a3c9695e$var$vT;
function $aec35899a3c9695e$var$RT(t) {
    return $aec35899a3c9695e$var$xT.lexicons.validate("app.bsky.notification.listNotifications#notification", t);
}
$aec35899a3c9695e$var$Zi.validateNotification = $aec35899a3c9695e$var$RT;
var $aec35899a3c9695e$var$ll = {};
Object.defineProperty($aec35899a3c9695e$var$ll, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ll.toKnownErr = void 0;
const $aec35899a3c9695e$var$AT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$_T(t) {
    return $aec35899a3c9695e$var$AT.XRPCError, t;
}
$aec35899a3c9695e$var$ll.toKnownErr = $aec35899a3c9695e$var$_T;
var $aec35899a3c9695e$var$ul = {};
Object.defineProperty($aec35899a3c9695e$var$ul, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ul.toKnownErr = void 0;
const $aec35899a3c9695e$var$wT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$TT(t) {
    return $aec35899a3c9695e$var$wT.XRPCError, t;
}
$aec35899a3c9695e$var$ul.toKnownErr = $aec35899a3c9695e$var$TT;
var $aec35899a3c9695e$var$cl = {};
Object.defineProperty($aec35899a3c9695e$var$cl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$cl.toKnownErr = void 0;
const $aec35899a3c9695e$var$ST = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$CT(t) {
    return $aec35899a3c9695e$var$ST.XRPCError, t;
}
$aec35899a3c9695e$var$cl.toKnownErr = $aec35899a3c9695e$var$CT;
var $aec35899a3c9695e$var$dl = {};
Object.defineProperty($aec35899a3c9695e$var$dl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$dl.toKnownErr = void 0;
const $aec35899a3c9695e$var$LT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$kT(t) {
    return $aec35899a3c9695e$var$LT.XRPCError, t;
}
$aec35899a3c9695e$var$dl.toKnownErr = $aec35899a3c9695e$var$kT;
var $aec35899a3c9695e$var$fl = {};
Object.defineProperty($aec35899a3c9695e$var$fl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$fl.toKnownErr = void 0;
const $aec35899a3c9695e$var$DT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$PT(t) {
    return $aec35899a3c9695e$var$DT.XRPCError, t;
}
$aec35899a3c9695e$var$fl.toKnownErr = $aec35899a3c9695e$var$PT;
var $aec35899a3c9695e$var$Wi = {};
Object.defineProperty($aec35899a3c9695e$var$Wi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Wi.validateSuggestion = $aec35899a3c9695e$var$Wi.isSuggestion = $aec35899a3c9695e$var$Wi.toKnownErr = void 0;
const $aec35899a3c9695e$var$BT = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Zd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$IT = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$UT(t) {
    return $aec35899a3c9695e$var$BT.XRPCError, t;
}
$aec35899a3c9695e$var$Wi.toKnownErr = $aec35899a3c9695e$var$UT;
function $aec35899a3c9695e$var$OT(t) {
    return (0, $aec35899a3c9695e$var$Zd.isObj)(t) && (0, $aec35899a3c9695e$var$Zd.hasProp)(t, "$type") && t.$type === "app.bsky.unspecced.getTaggedSuggestions#suggestion";
}
$aec35899a3c9695e$var$Wi.isSuggestion = $aec35899a3c9695e$var$OT;
function $aec35899a3c9695e$var$KT(t) {
    return $aec35899a3c9695e$var$IT.lexicons.validate("app.bsky.unspecced.getTaggedSuggestions#suggestion", t);
}
$aec35899a3c9695e$var$Wi.validateSuggestion = $aec35899a3c9695e$var$KT;
var $aec35899a3c9695e$var$Qn = {};
Object.defineProperty($aec35899a3c9695e$var$Qn, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Qn.toKnownErr = $aec35899a3c9695e$var$Qn.BadQueryStringError = void 0;
const $aec35899a3c9695e$var$S0 = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$C0 = class extends $aec35899a3c9695e$var$S0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Qn.BadQueryStringError = $aec35899a3c9695e$var$C0;
function $aec35899a3c9695e$var$MT(t) {
    return t instanceof $aec35899a3c9695e$var$S0.XRPCError && t.error === "BadQueryString" ? new $aec35899a3c9695e$var$C0(t) : t;
}
$aec35899a3c9695e$var$Qn.toKnownErr = $aec35899a3c9695e$var$MT;
var $aec35899a3c9695e$var$es = {};
Object.defineProperty($aec35899a3c9695e$var$es, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$es.toKnownErr = $aec35899a3c9695e$var$es.BadQueryStringError = void 0;
const $aec35899a3c9695e$var$L0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$k0 extends $aec35899a3c9695e$var$L0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$es.BadQueryStringError = $aec35899a3c9695e$var$k0;
function $aec35899a3c9695e$var$NT(t) {
    return t instanceof $aec35899a3c9695e$var$L0.XRPCError && t.error === "BadQueryString" ? new $aec35899a3c9695e$var$k0(t) : t;
}
$aec35899a3c9695e$var$es.toKnownErr = $aec35899a3c9695e$var$NT;
var $aec35899a3c9695e$var$pl = {};
Object.defineProperty($aec35899a3c9695e$var$pl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$pl.toKnownErr = void 0;
const $aec35899a3c9695e$var$VT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$jT(t) {
    return $aec35899a3c9695e$var$VT.XRPCError, t;
}
$aec35899a3c9695e$var$pl.toKnownErr = $aec35899a3c9695e$var$jT;
var $aec35899a3c9695e$var$hl = {};
Object.defineProperty($aec35899a3c9695e$var$hl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$hl.toKnownErr = void 0;
const $aec35899a3c9695e$var$FT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$$T(t) {
    return $aec35899a3c9695e$var$FT.XRPCError, t;
}
$aec35899a3c9695e$var$hl.toKnownErr = $aec35899a3c9695e$var$$T;
var $aec35899a3c9695e$var$ml = {};
Object.defineProperty($aec35899a3c9695e$var$ml, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ml.toKnownErr = void 0;
const $aec35899a3c9695e$var$GT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$qT(t) {
    return $aec35899a3c9695e$var$GT.XRPCError, t;
}
$aec35899a3c9695e$var$ml.toKnownErr = $aec35899a3c9695e$var$qT;
var $aec35899a3c9695e$var$yl = {};
Object.defineProperty($aec35899a3c9695e$var$yl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$yl.toKnownErr = void 0;
const $aec35899a3c9695e$var$zT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$XT(t) {
    return $aec35899a3c9695e$var$zT.XRPCError, t;
}
$aec35899a3c9695e$var$yl.toKnownErr = $aec35899a3c9695e$var$XT;
var $aec35899a3c9695e$var$bl = {};
Object.defineProperty($aec35899a3c9695e$var$bl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$bl.toKnownErr = void 0;
const $aec35899a3c9695e$var$HT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$ZT(t) {
    return $aec35899a3c9695e$var$HT.XRPCError, t;
}
$aec35899a3c9695e$var$bl.toKnownErr = $aec35899a3c9695e$var$ZT;
var $aec35899a3c9695e$var$gl = {};
Object.defineProperty($aec35899a3c9695e$var$gl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$gl.toKnownErr = void 0;
const $aec35899a3c9695e$var$WT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$YT(t) {
    return $aec35899a3c9695e$var$WT.XRPCError, t;
}
$aec35899a3c9695e$var$gl.toKnownErr = $aec35899a3c9695e$var$YT;
var $aec35899a3c9695e$var$xl = {};
Object.defineProperty($aec35899a3c9695e$var$xl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$xl.toKnownErr = void 0;
const $aec35899a3c9695e$var$JT = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$QT(t) {
    return $aec35899a3c9695e$var$JT.XRPCError, t;
}
$aec35899a3c9695e$var$xl.toKnownErr = $aec35899a3c9695e$var$QT;
var $aec35899a3c9695e$var$El = {};
Object.defineProperty($aec35899a3c9695e$var$El, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$El.toKnownErr = void 0;
const $aec35899a3c9695e$var$eS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$tS(t) {
    return $aec35899a3c9695e$var$eS.XRPCError, t;
}
$aec35899a3c9695e$var$El.toKnownErr = $aec35899a3c9695e$var$tS;
var $aec35899a3c9695e$var$vl = {};
Object.defineProperty($aec35899a3c9695e$var$vl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$vl.toKnownErr = void 0;
const $aec35899a3c9695e$var$rS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$iS(t) {
    return $aec35899a3c9695e$var$rS.XRPCError, t;
}
$aec35899a3c9695e$var$vl.toKnownErr = $aec35899a3c9695e$var$iS;
var $aec35899a3c9695e$var$Rl = {};
Object.defineProperty($aec35899a3c9695e$var$Rl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Rl.toKnownErr = void 0;
const $aec35899a3c9695e$var$nS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$sS(t) {
    return $aec35899a3c9695e$var$nS.XRPCError, t;
}
$aec35899a3c9695e$var$Rl.toKnownErr = $aec35899a3c9695e$var$sS;
var $aec35899a3c9695e$var$Al = {};
Object.defineProperty($aec35899a3c9695e$var$Al, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Al.toKnownErr = void 0;
const $aec35899a3c9695e$var$aS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$oS(t) {
    return $aec35899a3c9695e$var$aS.XRPCError, t;
}
$aec35899a3c9695e$var$Al.toKnownErr = $aec35899a3c9695e$var$oS;
var $aec35899a3c9695e$var$Yi = {};
Object.defineProperty($aec35899a3c9695e$var$Yi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Yi.validateBatchItem = $aec35899a3c9695e$var$Yi.isBatchItem = $aec35899a3c9695e$var$Yi.toKnownErr = void 0;
const $aec35899a3c9695e$var$lS = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Wd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$uS = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$cS(t) {
    return $aec35899a3c9695e$var$lS.XRPCError, t;
}
$aec35899a3c9695e$var$Yi.toKnownErr = $aec35899a3c9695e$var$cS;
function $aec35899a3c9695e$var$dS(t) {
    return (0, $aec35899a3c9695e$var$Wd.isObj)(t) && (0, $aec35899a3c9695e$var$Wd.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.sendMessageBatch#batchItem";
}
$aec35899a3c9695e$var$Yi.isBatchItem = $aec35899a3c9695e$var$dS;
function $aec35899a3c9695e$var$fS(t) {
    return $aec35899a3c9695e$var$uS.lexicons.validate("chat.bsky.convo.sendMessageBatch#batchItem", t);
}
$aec35899a3c9695e$var$Yi.validateBatchItem = $aec35899a3c9695e$var$fS;
var $aec35899a3c9695e$var$_l = {};
Object.defineProperty($aec35899a3c9695e$var$_l, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$_l.toKnownErr = void 0;
const $aec35899a3c9695e$var$pS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$hS(t) {
    return $aec35899a3c9695e$var$pS.XRPCError, t;
}
$aec35899a3c9695e$var$_l.toKnownErr = $aec35899a3c9695e$var$hS;
var $aec35899a3c9695e$var$wl = {};
Object.defineProperty($aec35899a3c9695e$var$wl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$wl.toKnownErr = void 0;
const $aec35899a3c9695e$var$mS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$yS(t) {
    return $aec35899a3c9695e$var$mS.XRPCError, t;
}
$aec35899a3c9695e$var$wl.toKnownErr = $aec35899a3c9695e$var$yS;
var $aec35899a3c9695e$var$Ji = {};
Object.defineProperty($aec35899a3c9695e$var$Ji, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ji.validateMetadata = $aec35899a3c9695e$var$Ji.isMetadata = $aec35899a3c9695e$var$Ji.toKnownErr = void 0;
const $aec35899a3c9695e$var$bS = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Yd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$gS = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$xS(t) {
    return $aec35899a3c9695e$var$bS.XRPCError, t;
}
$aec35899a3c9695e$var$Ji.toKnownErr = $aec35899a3c9695e$var$xS;
function $aec35899a3c9695e$var$ES(t) {
    return (0, $aec35899a3c9695e$var$Yd.isObj)(t) && (0, $aec35899a3c9695e$var$Yd.hasProp)(t, "$type") && t.$type === "chat.bsky.moderation.getActorMetadata#metadata";
}
$aec35899a3c9695e$var$Ji.isMetadata = $aec35899a3c9695e$var$ES;
function $aec35899a3c9695e$var$vS(t) {
    return $aec35899a3c9695e$var$gS.lexicons.validate("chat.bsky.moderation.getActorMetadata#metadata", t);
}
$aec35899a3c9695e$var$Ji.validateMetadata = $aec35899a3c9695e$var$vS;
var $aec35899a3c9695e$var$Tl = {};
Object.defineProperty($aec35899a3c9695e$var$Tl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Tl.toKnownErr = void 0;
const $aec35899a3c9695e$var$RS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$AS(t) {
    return $aec35899a3c9695e$var$RS.XRPCError, t;
}
$aec35899a3c9695e$var$Tl.toKnownErr = $aec35899a3c9695e$var$AS;
var $aec35899a3c9695e$var$Sl = {};
Object.defineProperty($aec35899a3c9695e$var$Sl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Sl.toKnownErr = void 0;
const $aec35899a3c9695e$var$_S = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$wS(t) {
    return $aec35899a3c9695e$var$_S.XRPCError, t;
}
$aec35899a3c9695e$var$Sl.toKnownErr = $aec35899a3c9695e$var$wS;
var $aec35899a3c9695e$var$Cl = {};
Object.defineProperty($aec35899a3c9695e$var$Cl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Cl.toKnownErr = void 0;
const $aec35899a3c9695e$var$TS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$SS(t) {
    return $aec35899a3c9695e$var$TS.XRPCError, t;
}
$aec35899a3c9695e$var$Cl.toKnownErr = $aec35899a3c9695e$var$SS;
var $aec35899a3c9695e$var$Ll = {};
Object.defineProperty($aec35899a3c9695e$var$Ll, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ll.toKnownErr = void 0;
const $aec35899a3c9695e$var$CS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$LS(t) {
    return $aec35899a3c9695e$var$CS.XRPCError, t;
}
$aec35899a3c9695e$var$Ll.toKnownErr = $aec35899a3c9695e$var$LS;
var $aec35899a3c9695e$var$kl = {};
Object.defineProperty($aec35899a3c9695e$var$kl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$kl.toKnownErr = void 0;
const $aec35899a3c9695e$var$kS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$DS(t) {
    return $aec35899a3c9695e$var$kS.XRPCError, t;
}
$aec35899a3c9695e$var$kl.toKnownErr = $aec35899a3c9695e$var$DS;
var $aec35899a3c9695e$var$Dl = {};
Object.defineProperty($aec35899a3c9695e$var$Dl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Dl.toKnownErr = void 0;
const $aec35899a3c9695e$var$PS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$BS(t) {
    return $aec35899a3c9695e$var$PS.XRPCError, t;
}
$aec35899a3c9695e$var$Dl.toKnownErr = $aec35899a3c9695e$var$BS;
var $aec35899a3c9695e$var$ts = {};
Object.defineProperty($aec35899a3c9695e$var$ts, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ts.toKnownErr = $aec35899a3c9695e$var$ts.SubjectHasActionError = void 0;
const $aec35899a3c9695e$var$D0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$P0 extends $aec35899a3c9695e$var$D0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$ts.SubjectHasActionError = $aec35899a3c9695e$var$P0;
function $aec35899a3c9695e$var$IS(t) {
    return t instanceof $aec35899a3c9695e$var$D0.XRPCError && t.error === "SubjectHasAction" ? new $aec35899a3c9695e$var$P0(t) : t;
}
$aec35899a3c9695e$var$ts.toKnownErr = $aec35899a3c9695e$var$IS;
var $aec35899a3c9695e$var$Pl = {};
Object.defineProperty($aec35899a3c9695e$var$Pl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Pl.toKnownErr = void 0;
const $aec35899a3c9695e$var$US = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$OS(t) {
    return $aec35899a3c9695e$var$US.XRPCError, t;
}
$aec35899a3c9695e$var$Pl.toKnownErr = $aec35899a3c9695e$var$OS;
var $aec35899a3c9695e$var$rs = {};
Object.defineProperty($aec35899a3c9695e$var$rs, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$rs.toKnownErr = $aec35899a3c9695e$var$rs.RecordNotFoundError = void 0;
const $aec35899a3c9695e$var$B0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$I0 extends $aec35899a3c9695e$var$B0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$rs.RecordNotFoundError = $aec35899a3c9695e$var$I0;
function $aec35899a3c9695e$var$KS(t) {
    return t instanceof $aec35899a3c9695e$var$B0.XRPCError && t.error === "RecordNotFound" ? new $aec35899a3c9695e$var$I0(t) : t;
}
$aec35899a3c9695e$var$rs.toKnownErr = $aec35899a3c9695e$var$KS;
var $aec35899a3c9695e$var$is = {};
Object.defineProperty($aec35899a3c9695e$var$is, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$is.toKnownErr = $aec35899a3c9695e$var$is.RepoNotFoundError = void 0;
const $aec35899a3c9695e$var$U0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$O0 extends $aec35899a3c9695e$var$U0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$is.RepoNotFoundError = $aec35899a3c9695e$var$O0;
function $aec35899a3c9695e$var$MS(t) {
    return t instanceof $aec35899a3c9695e$var$U0.XRPCError && t.error === "RepoNotFound" ? new $aec35899a3c9695e$var$O0(t) : t;
}
$aec35899a3c9695e$var$is.toKnownErr = $aec35899a3c9695e$var$MS;
var $aec35899a3c9695e$var$Bl = {};
Object.defineProperty($aec35899a3c9695e$var$Bl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Bl.toKnownErr = void 0;
const $aec35899a3c9695e$var$NS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$VS(t) {
    return $aec35899a3c9695e$var$NS.XRPCError, t;
}
$aec35899a3c9695e$var$Bl.toKnownErr = $aec35899a3c9695e$var$VS;
var $aec35899a3c9695e$var$Il = {};
Object.defineProperty($aec35899a3c9695e$var$Il, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Il.toKnownErr = void 0;
const $aec35899a3c9695e$var$jS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$FS(t) {
    return $aec35899a3c9695e$var$jS.XRPCError, t;
}
$aec35899a3c9695e$var$Il.toKnownErr = $aec35899a3c9695e$var$FS;
var $aec35899a3c9695e$var$Ul = {};
Object.defineProperty($aec35899a3c9695e$var$Ul, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ul.toKnownErr = void 0;
const $aec35899a3c9695e$var$$S = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$GS(t) {
    return $aec35899a3c9695e$var$$S.XRPCError, t;
}
$aec35899a3c9695e$var$Ul.toKnownErr = $aec35899a3c9695e$var$GS;
var $aec35899a3c9695e$var$Cr = {};
Object.defineProperty($aec35899a3c9695e$var$Cr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Cr.validateViewerConfig = $aec35899a3c9695e$var$Cr.isViewerConfig = $aec35899a3c9695e$var$Cr.validateServiceConfig = $aec35899a3c9695e$var$Cr.isServiceConfig = $aec35899a3c9695e$var$Cr.toKnownErr = void 0;
const $aec35899a3c9695e$var$qS = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$Au = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$K0 = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$zS(t) {
    return $aec35899a3c9695e$var$qS.XRPCError, t;
}
$aec35899a3c9695e$var$Cr.toKnownErr = $aec35899a3c9695e$var$zS;
function $aec35899a3c9695e$var$XS(t) {
    return (0, $aec35899a3c9695e$var$Au.isObj)(t) && (0, $aec35899a3c9695e$var$Au.hasProp)(t, "$type") && t.$type === "tools.ozone.server.getConfig#serviceConfig";
}
$aec35899a3c9695e$var$Cr.isServiceConfig = $aec35899a3c9695e$var$XS;
function $aec35899a3c9695e$var$HS(t) {
    return $aec35899a3c9695e$var$K0.lexicons.validate("tools.ozone.server.getConfig#serviceConfig", t);
}
$aec35899a3c9695e$var$Cr.validateServiceConfig = $aec35899a3c9695e$var$HS;
function $aec35899a3c9695e$var$ZS(t) {
    return (0, $aec35899a3c9695e$var$Au.isObj)(t) && (0, $aec35899a3c9695e$var$Au.hasProp)(t, "$type") && t.$type === "tools.ozone.server.getConfig#viewerConfig";
}
$aec35899a3c9695e$var$Cr.isViewerConfig = $aec35899a3c9695e$var$ZS;
function $aec35899a3c9695e$var$WS(t) {
    return $aec35899a3c9695e$var$K0.lexicons.validate("tools.ozone.server.getConfig#viewerConfig", t);
}
$aec35899a3c9695e$var$Cr.validateViewerConfig = $aec35899a3c9695e$var$WS;
var $aec35899a3c9695e$var$ns = {};
Object.defineProperty($aec35899a3c9695e$var$ns, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ns.toKnownErr = $aec35899a3c9695e$var$ns.MemberAlreadyExistsError = void 0;
const $aec35899a3c9695e$var$M0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$N0 extends $aec35899a3c9695e$var$M0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$ns.MemberAlreadyExistsError = $aec35899a3c9695e$var$N0;
function $aec35899a3c9695e$var$YS(t) {
    return t instanceof $aec35899a3c9695e$var$M0.XRPCError && t.error === "MemberAlreadyExists" ? new $aec35899a3c9695e$var$N0(t) : t;
}
$aec35899a3c9695e$var$ns.toKnownErr = $aec35899a3c9695e$var$YS;
var $aec35899a3c9695e$var$Qi = {};
Object.defineProperty($aec35899a3c9695e$var$Qi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Qi.toKnownErr = $aec35899a3c9695e$var$Qi.CannotDeleteSelfError = $aec35899a3c9695e$var$Qi.MemberNotFoundError = void 0;
const $aec35899a3c9695e$var$rd = $aec35899a3c9695e$var$G;
let $aec35899a3c9695e$var$V0 = class extends $aec35899a3c9695e$var$rd.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
};
$aec35899a3c9695e$var$Qi.MemberNotFoundError = $aec35899a3c9695e$var$V0;
class $aec35899a3c9695e$var$j0 extends $aec35899a3c9695e$var$rd.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$Qi.CannotDeleteSelfError = $aec35899a3c9695e$var$j0;
function $aec35899a3c9695e$var$JS(t) {
    if (t instanceof $aec35899a3c9695e$var$rd.XRPCError) {
        if (t.error === "MemberNotFound") return new $aec35899a3c9695e$var$V0(t);
        if (t.error === "CannotDeleteSelf") return new $aec35899a3c9695e$var$j0(t);
    }
    return t;
}
$aec35899a3c9695e$var$Qi.toKnownErr = $aec35899a3c9695e$var$JS;
var $aec35899a3c9695e$var$Ol = {};
Object.defineProperty($aec35899a3c9695e$var$Ol, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ol.toKnownErr = void 0;
const $aec35899a3c9695e$var$QS = $aec35899a3c9695e$var$G;
function $aec35899a3c9695e$var$eC(t) {
    return $aec35899a3c9695e$var$QS.XRPCError, t;
}
$aec35899a3c9695e$var$Ol.toKnownErr = $aec35899a3c9695e$var$eC;
var $aec35899a3c9695e$var$ss = {};
Object.defineProperty($aec35899a3c9695e$var$ss, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ss.toKnownErr = $aec35899a3c9695e$var$ss.MemberNotFoundError = void 0;
const $aec35899a3c9695e$var$F0 = $aec35899a3c9695e$var$G;
class $aec35899a3c9695e$var$$0 extends $aec35899a3c9695e$var$F0.XRPCError {
    constructor(e){
        super(e.status, e.error, e.message, e.headers);
    }
}
$aec35899a3c9695e$var$ss.MemberNotFoundError = $aec35899a3c9695e$var$$0;
function $aec35899a3c9695e$var$tC(t) {
    return t instanceof $aec35899a3c9695e$var$F0.XRPCError && t.error === "MemberNotFound" ? new $aec35899a3c9695e$var$$0(t) : t;
}
$aec35899a3c9695e$var$ss.toKnownErr = $aec35899a3c9695e$var$tC;
var $aec35899a3c9695e$var$Kt = {};
Object.defineProperty($aec35899a3c9695e$var$Kt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Kt.validateRepoBlobRef = $aec35899a3c9695e$var$Kt.isRepoBlobRef = $aec35899a3c9695e$var$Kt.validateRepoRef = $aec35899a3c9695e$var$Kt.isRepoRef = $aec35899a3c9695e$var$Kt.validateAccountView = $aec35899a3c9695e$var$Kt.isAccountView = $aec35899a3c9695e$var$Kt.validateStatusAttr = $aec35899a3c9695e$var$Kt.isStatusAttr = void 0;
const $aec35899a3c9695e$var$mn = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Mu = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$rC(t) {
    return (0, $aec35899a3c9695e$var$mn.isObj)(t) && (0, $aec35899a3c9695e$var$mn.hasProp)(t, "$type") && t.$type === "com.atproto.admin.defs#statusAttr";
}
$aec35899a3c9695e$var$Kt.isStatusAttr = $aec35899a3c9695e$var$rC;
function $aec35899a3c9695e$var$iC(t) {
    return $aec35899a3c9695e$var$Mu.lexicons.validate("com.atproto.admin.defs#statusAttr", t);
}
$aec35899a3c9695e$var$Kt.validateStatusAttr = $aec35899a3c9695e$var$iC;
function $aec35899a3c9695e$var$nC(t) {
    return (0, $aec35899a3c9695e$var$mn.isObj)(t) && (0, $aec35899a3c9695e$var$mn.hasProp)(t, "$type") && t.$type === "com.atproto.admin.defs#accountView";
}
$aec35899a3c9695e$var$Kt.isAccountView = $aec35899a3c9695e$var$nC;
function $aec35899a3c9695e$var$sC(t) {
    return $aec35899a3c9695e$var$Mu.lexicons.validate("com.atproto.admin.defs#accountView", t);
}
$aec35899a3c9695e$var$Kt.validateAccountView = $aec35899a3c9695e$var$sC;
function $aec35899a3c9695e$var$aC(t) {
    return (0, $aec35899a3c9695e$var$mn.isObj)(t) && (0, $aec35899a3c9695e$var$mn.hasProp)(t, "$type") && t.$type === "com.atproto.admin.defs#repoRef";
}
$aec35899a3c9695e$var$Kt.isRepoRef = $aec35899a3c9695e$var$aC;
function $aec35899a3c9695e$var$oC(t) {
    return $aec35899a3c9695e$var$Mu.lexicons.validate("com.atproto.admin.defs#repoRef", t);
}
$aec35899a3c9695e$var$Kt.validateRepoRef = $aec35899a3c9695e$var$oC;
function $aec35899a3c9695e$var$lC(t) {
    return (0, $aec35899a3c9695e$var$mn.isObj)(t) && (0, $aec35899a3c9695e$var$mn.hasProp)(t, "$type") && t.$type === "com.atproto.admin.defs#repoBlobRef";
}
$aec35899a3c9695e$var$Kt.isRepoBlobRef = $aec35899a3c9695e$var$lC;
function $aec35899a3c9695e$var$uC(t) {
    return $aec35899a3c9695e$var$Mu.lexicons.validate("com.atproto.admin.defs#repoBlobRef", t);
}
$aec35899a3c9695e$var$Kt.validateRepoBlobRef = $aec35899a3c9695e$var$uC;
var $aec35899a3c9695e$var$gt = {};
Object.defineProperty($aec35899a3c9695e$var$gt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$gt.validateLabelValueDefinitionStrings = $aec35899a3c9695e$var$gt.isLabelValueDefinitionStrings = $aec35899a3c9695e$var$gt.validateLabelValueDefinition = $aec35899a3c9695e$var$gt.isLabelValueDefinition = $aec35899a3c9695e$var$gt.validateSelfLabel = $aec35899a3c9695e$var$gt.isSelfLabel = $aec35899a3c9695e$var$gt.validateSelfLabels = $aec35899a3c9695e$var$gt.isSelfLabels = $aec35899a3c9695e$var$gt.validateLabel = $aec35899a3c9695e$var$gt.isLabel = void 0;
const $aec35899a3c9695e$var$mi = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Kl = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$cC(t) {
    return (0, $aec35899a3c9695e$var$mi.isObj)(t) && (0, $aec35899a3c9695e$var$mi.hasProp)(t, "$type") && t.$type === "com.atproto.label.defs#label";
}
$aec35899a3c9695e$var$gt.isLabel = $aec35899a3c9695e$var$cC;
function $aec35899a3c9695e$var$dC(t) {
    return $aec35899a3c9695e$var$Kl.lexicons.validate("com.atproto.label.defs#label", t);
}
$aec35899a3c9695e$var$gt.validateLabel = $aec35899a3c9695e$var$dC;
function $aec35899a3c9695e$var$fC(t) {
    return (0, $aec35899a3c9695e$var$mi.isObj)(t) && (0, $aec35899a3c9695e$var$mi.hasProp)(t, "$type") && t.$type === "com.atproto.label.defs#selfLabels";
}
$aec35899a3c9695e$var$gt.isSelfLabels = $aec35899a3c9695e$var$fC;
function $aec35899a3c9695e$var$pC(t) {
    return $aec35899a3c9695e$var$Kl.lexicons.validate("com.atproto.label.defs#selfLabels", t);
}
$aec35899a3c9695e$var$gt.validateSelfLabels = $aec35899a3c9695e$var$pC;
function $aec35899a3c9695e$var$hC(t) {
    return (0, $aec35899a3c9695e$var$mi.isObj)(t) && (0, $aec35899a3c9695e$var$mi.hasProp)(t, "$type") && t.$type === "com.atproto.label.defs#selfLabel";
}
$aec35899a3c9695e$var$gt.isSelfLabel = $aec35899a3c9695e$var$hC;
function $aec35899a3c9695e$var$mC(t) {
    return $aec35899a3c9695e$var$Kl.lexicons.validate("com.atproto.label.defs#selfLabel", t);
}
$aec35899a3c9695e$var$gt.validateSelfLabel = $aec35899a3c9695e$var$mC;
function $aec35899a3c9695e$var$yC(t) {
    return (0, $aec35899a3c9695e$var$mi.isObj)(t) && (0, $aec35899a3c9695e$var$mi.hasProp)(t, "$type") && t.$type === "com.atproto.label.defs#labelValueDefinition";
}
$aec35899a3c9695e$var$gt.isLabelValueDefinition = $aec35899a3c9695e$var$yC;
function $aec35899a3c9695e$var$bC(t) {
    return $aec35899a3c9695e$var$Kl.lexicons.validate("com.atproto.label.defs#labelValueDefinition", t);
}
$aec35899a3c9695e$var$gt.validateLabelValueDefinition = $aec35899a3c9695e$var$bC;
function $aec35899a3c9695e$var$gC(t) {
    return (0, $aec35899a3c9695e$var$mi.isObj)(t) && (0, $aec35899a3c9695e$var$mi.hasProp)(t, "$type") && t.$type === "com.atproto.label.defs#labelValueDefinitionStrings";
}
$aec35899a3c9695e$var$gt.isLabelValueDefinitionStrings = $aec35899a3c9695e$var$gC;
function $aec35899a3c9695e$var$xC(t) {
    return $aec35899a3c9695e$var$Kl.lexicons.validate("com.atproto.label.defs#labelValueDefinitionStrings", t);
}
$aec35899a3c9695e$var$gt.validateLabelValueDefinitionStrings = $aec35899a3c9695e$var$xC;
var $aec35899a3c9695e$var$ni = {};
Object.defineProperty($aec35899a3c9695e$var$ni, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ni.validateInfo = $aec35899a3c9695e$var$ni.isInfo = $aec35899a3c9695e$var$ni.validateLabels = $aec35899a3c9695e$var$ni.isLabels = void 0;
const $aec35899a3c9695e$var$_u = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$G0 = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$EC(t) {
    return (0, $aec35899a3c9695e$var$_u.isObj)(t) && (0, $aec35899a3c9695e$var$_u.hasProp)(t, "$type") && t.$type === "com.atproto.label.subscribeLabels#labels";
}
$aec35899a3c9695e$var$ni.isLabels = $aec35899a3c9695e$var$EC;
function $aec35899a3c9695e$var$vC(t) {
    return $aec35899a3c9695e$var$G0.lexicons.validate("com.atproto.label.subscribeLabels#labels", t);
}
$aec35899a3c9695e$var$ni.validateLabels = $aec35899a3c9695e$var$vC;
function $aec35899a3c9695e$var$RC(t) {
    return (0, $aec35899a3c9695e$var$_u.isObj)(t) && (0, $aec35899a3c9695e$var$_u.hasProp)(t, "$type") && t.$type === "com.atproto.label.subscribeLabels#info";
}
$aec35899a3c9695e$var$ni.isInfo = $aec35899a3c9695e$var$RC;
function $aec35899a3c9695e$var$AC(t) {
    return $aec35899a3c9695e$var$G0.lexicons.validate("com.atproto.label.subscribeLabels#info", t);
}
$aec35899a3c9695e$var$ni.validateInfo = $aec35899a3c9695e$var$AC;
var $aec35899a3c9695e$var$Jt = {};
Object.defineProperty($aec35899a3c9695e$var$Jt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Jt.REASONAPPEAL = $aec35899a3c9695e$var$Jt.REASONOTHER = $aec35899a3c9695e$var$Jt.REASONRUDE = $aec35899a3c9695e$var$Jt.REASONSEXUAL = $aec35899a3c9695e$var$Jt.REASONMISLEADING = $aec35899a3c9695e$var$Jt.REASONVIOLATION = $aec35899a3c9695e$var$Jt.REASONSPAM = void 0;
$aec35899a3c9695e$var$Jt.REASONSPAM = "com.atproto.moderation.defs#reasonSpam";
$aec35899a3c9695e$var$Jt.REASONVIOLATION = "com.atproto.moderation.defs#reasonViolation";
$aec35899a3c9695e$var$Jt.REASONMISLEADING = "com.atproto.moderation.defs#reasonMisleading";
$aec35899a3c9695e$var$Jt.REASONSEXUAL = "com.atproto.moderation.defs#reasonSexual";
$aec35899a3c9695e$var$Jt.REASONRUDE = "com.atproto.moderation.defs#reasonRude";
$aec35899a3c9695e$var$Jt.REASONOTHER = "com.atproto.moderation.defs#reasonOther";
$aec35899a3c9695e$var$Jt.REASONAPPEAL = "com.atproto.moderation.defs#reasonAppeal";
var $aec35899a3c9695e$var$Ss = {};
Object.defineProperty($aec35899a3c9695e$var$Ss, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ss.validateMain = $aec35899a3c9695e$var$Ss.isMain = void 0;
const $aec35899a3c9695e$var$Jd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$_C = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$wC(t) {
    return (0, $aec35899a3c9695e$var$Jd.isObj)(t) && (0, $aec35899a3c9695e$var$Jd.hasProp)(t, "$type") && (t.$type === "com.atproto.repo.strongRef#main" || t.$type === "com.atproto.repo.strongRef");
}
$aec35899a3c9695e$var$Ss.isMain = $aec35899a3c9695e$var$wC;
function $aec35899a3c9695e$var$TC(t) {
    return $aec35899a3c9695e$var$_C.lexicons.validate("com.atproto.repo.strongRef#main", t);
}
$aec35899a3c9695e$var$Ss.validateMain = $aec35899a3c9695e$var$TC;
var $aec35899a3c9695e$var$si = {};
Object.defineProperty($aec35899a3c9695e$var$si, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$si.validateInviteCodeUse = $aec35899a3c9695e$var$si.isInviteCodeUse = $aec35899a3c9695e$var$si.validateInviteCode = $aec35899a3c9695e$var$si.isInviteCode = void 0;
const $aec35899a3c9695e$var$wu = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$q0 = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$SC(t) {
    return (0, $aec35899a3c9695e$var$wu.isObj)(t) && (0, $aec35899a3c9695e$var$wu.hasProp)(t, "$type") && t.$type === "com.atproto.server.defs#inviteCode";
}
$aec35899a3c9695e$var$si.isInviteCode = $aec35899a3c9695e$var$SC;
function $aec35899a3c9695e$var$CC(t) {
    return $aec35899a3c9695e$var$q0.lexicons.validate("com.atproto.server.defs#inviteCode", t);
}
$aec35899a3c9695e$var$si.validateInviteCode = $aec35899a3c9695e$var$CC;
function $aec35899a3c9695e$var$LC(t) {
    return (0, $aec35899a3c9695e$var$wu.isObj)(t) && (0, $aec35899a3c9695e$var$wu.hasProp)(t, "$type") && t.$type === "com.atproto.server.defs#inviteCodeUse";
}
$aec35899a3c9695e$var$si.isInviteCodeUse = $aec35899a3c9695e$var$LC;
function $aec35899a3c9695e$var$kC(t) {
    return $aec35899a3c9695e$var$q0.lexicons.validate("com.atproto.server.defs#inviteCodeUse", t);
}
$aec35899a3c9695e$var$si.validateInviteCodeUse = $aec35899a3c9695e$var$kC;
var $aec35899a3c9695e$var$Ze = {};
Object.defineProperty($aec35899a3c9695e$var$Ze, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ze.validateRepoOp = $aec35899a3c9695e$var$Ze.isRepoOp = $aec35899a3c9695e$var$Ze.validateInfo = $aec35899a3c9695e$var$Ze.isInfo = $aec35899a3c9695e$var$Ze.validateTombstone = $aec35899a3c9695e$var$Ze.isTombstone = $aec35899a3c9695e$var$Ze.validateMigrate = $aec35899a3c9695e$var$Ze.isMigrate = $aec35899a3c9695e$var$Ze.validateHandle = $aec35899a3c9695e$var$Ze.isHandle = $aec35899a3c9695e$var$Ze.validateAccount = $aec35899a3c9695e$var$Ze.isAccount = $aec35899a3c9695e$var$Ze.validateIdentity = $aec35899a3c9695e$var$Ze.isIdentity = $aec35899a3c9695e$var$Ze.validateCommit = $aec35899a3c9695e$var$Ze.isCommit = void 0;
const $aec35899a3c9695e$var$er = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$wn = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$DC(t) {
    return (0, $aec35899a3c9695e$var$er.isObj)(t) && (0, $aec35899a3c9695e$var$er.hasProp)(t, "$type") && t.$type === "com.atproto.sync.subscribeRepos#commit";
}
$aec35899a3c9695e$var$Ze.isCommit = $aec35899a3c9695e$var$DC;
function $aec35899a3c9695e$var$PC(t) {
    return $aec35899a3c9695e$var$wn.lexicons.validate("com.atproto.sync.subscribeRepos#commit", t);
}
$aec35899a3c9695e$var$Ze.validateCommit = $aec35899a3c9695e$var$PC;
function $aec35899a3c9695e$var$BC(t) {
    return (0, $aec35899a3c9695e$var$er.isObj)(t) && (0, $aec35899a3c9695e$var$er.hasProp)(t, "$type") && t.$type === "com.atproto.sync.subscribeRepos#identity";
}
$aec35899a3c9695e$var$Ze.isIdentity = $aec35899a3c9695e$var$BC;
function $aec35899a3c9695e$var$IC(t) {
    return $aec35899a3c9695e$var$wn.lexicons.validate("com.atproto.sync.subscribeRepos#identity", t);
}
$aec35899a3c9695e$var$Ze.validateIdentity = $aec35899a3c9695e$var$IC;
function $aec35899a3c9695e$var$UC(t) {
    return (0, $aec35899a3c9695e$var$er.isObj)(t) && (0, $aec35899a3c9695e$var$er.hasProp)(t, "$type") && t.$type === "com.atproto.sync.subscribeRepos#account";
}
$aec35899a3c9695e$var$Ze.isAccount = $aec35899a3c9695e$var$UC;
function $aec35899a3c9695e$var$OC(t) {
    return $aec35899a3c9695e$var$wn.lexicons.validate("com.atproto.sync.subscribeRepos#account", t);
}
$aec35899a3c9695e$var$Ze.validateAccount = $aec35899a3c9695e$var$OC;
function $aec35899a3c9695e$var$KC(t) {
    return (0, $aec35899a3c9695e$var$er.isObj)(t) && (0, $aec35899a3c9695e$var$er.hasProp)(t, "$type") && t.$type === "com.atproto.sync.subscribeRepos#handle";
}
$aec35899a3c9695e$var$Ze.isHandle = $aec35899a3c9695e$var$KC;
function $aec35899a3c9695e$var$MC(t) {
    return $aec35899a3c9695e$var$wn.lexicons.validate("com.atproto.sync.subscribeRepos#handle", t);
}
$aec35899a3c9695e$var$Ze.validateHandle = $aec35899a3c9695e$var$MC;
function $aec35899a3c9695e$var$NC(t) {
    return (0, $aec35899a3c9695e$var$er.isObj)(t) && (0, $aec35899a3c9695e$var$er.hasProp)(t, "$type") && t.$type === "com.atproto.sync.subscribeRepos#migrate";
}
$aec35899a3c9695e$var$Ze.isMigrate = $aec35899a3c9695e$var$NC;
function $aec35899a3c9695e$var$VC(t) {
    return $aec35899a3c9695e$var$wn.lexicons.validate("com.atproto.sync.subscribeRepos#migrate", t);
}
$aec35899a3c9695e$var$Ze.validateMigrate = $aec35899a3c9695e$var$VC;
function $aec35899a3c9695e$var$jC(t) {
    return (0, $aec35899a3c9695e$var$er.isObj)(t) && (0, $aec35899a3c9695e$var$er.hasProp)(t, "$type") && t.$type === "com.atproto.sync.subscribeRepos#tombstone";
}
$aec35899a3c9695e$var$Ze.isTombstone = $aec35899a3c9695e$var$jC;
function $aec35899a3c9695e$var$FC(t) {
    return $aec35899a3c9695e$var$wn.lexicons.validate("com.atproto.sync.subscribeRepos#tombstone", t);
}
$aec35899a3c9695e$var$Ze.validateTombstone = $aec35899a3c9695e$var$FC;
function $aec35899a3c9695e$var$$C(t) {
    return (0, $aec35899a3c9695e$var$er.isObj)(t) && (0, $aec35899a3c9695e$var$er.hasProp)(t, "$type") && t.$type === "com.atproto.sync.subscribeRepos#info";
}
$aec35899a3c9695e$var$Ze.isInfo = $aec35899a3c9695e$var$$C;
function $aec35899a3c9695e$var$GC(t) {
    return $aec35899a3c9695e$var$wn.lexicons.validate("com.atproto.sync.subscribeRepos#info", t);
}
$aec35899a3c9695e$var$Ze.validateInfo = $aec35899a3c9695e$var$GC;
function $aec35899a3c9695e$var$qC(t) {
    return (0, $aec35899a3c9695e$var$er.isObj)(t) && (0, $aec35899a3c9695e$var$er.hasProp)(t, "$type") && t.$type === "com.atproto.sync.subscribeRepos#repoOp";
}
$aec35899a3c9695e$var$Ze.isRepoOp = $aec35899a3c9695e$var$qC;
function $aec35899a3c9695e$var$zC(t) {
    return $aec35899a3c9695e$var$wn.lexicons.validate("com.atproto.sync.subscribeRepos#repoOp", t);
}
$aec35899a3c9695e$var$Ze.validateRepoOp = $aec35899a3c9695e$var$zC;
var $aec35899a3c9695e$var$ae = {};
Object.defineProperty($aec35899a3c9695e$var$ae, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ae.validateBskyAppProgressGuide = $aec35899a3c9695e$var$ae.isBskyAppProgressGuide = $aec35899a3c9695e$var$ae.validateBskyAppStatePref = $aec35899a3c9695e$var$ae.isBskyAppStatePref = $aec35899a3c9695e$var$ae.validateLabelerPrefItem = $aec35899a3c9695e$var$ae.isLabelerPrefItem = $aec35899a3c9695e$var$ae.validateLabelersPref = $aec35899a3c9695e$var$ae.isLabelersPref = $aec35899a3c9695e$var$ae.validateHiddenPostsPref = $aec35899a3c9695e$var$ae.isHiddenPostsPref = $aec35899a3c9695e$var$ae.validateMutedWordsPref = $aec35899a3c9695e$var$ae.isMutedWordsPref = $aec35899a3c9695e$var$ae.validateMutedWord = $aec35899a3c9695e$var$ae.isMutedWord = $aec35899a3c9695e$var$ae.validateInterestsPref = $aec35899a3c9695e$var$ae.isInterestsPref = $aec35899a3c9695e$var$ae.validateThreadViewPref = $aec35899a3c9695e$var$ae.isThreadViewPref = $aec35899a3c9695e$var$ae.validateFeedViewPref = $aec35899a3c9695e$var$ae.isFeedViewPref = $aec35899a3c9695e$var$ae.validatePersonalDetailsPref = $aec35899a3c9695e$var$ae.isPersonalDetailsPref = $aec35899a3c9695e$var$ae.validateSavedFeedsPref = $aec35899a3c9695e$var$ae.isSavedFeedsPref = $aec35899a3c9695e$var$ae.validateSavedFeedsPrefV2 = $aec35899a3c9695e$var$ae.isSavedFeedsPrefV2 = $aec35899a3c9695e$var$ae.validateSavedFeed = $aec35899a3c9695e$var$ae.isSavedFeed = $aec35899a3c9695e$var$ae.validateContentLabelPref = $aec35899a3c9695e$var$ae.isContentLabelPref = $aec35899a3c9695e$var$ae.validateAdultContentPref = $aec35899a3c9695e$var$ae.isAdultContentPref = $aec35899a3c9695e$var$ae.validateKnownFollowers = $aec35899a3c9695e$var$ae.isKnownFollowers = $aec35899a3c9695e$var$ae.validateViewerState = $aec35899a3c9695e$var$ae.isViewerState = $aec35899a3c9695e$var$ae.validateProfileAssociatedChat = $aec35899a3c9695e$var$ae.isProfileAssociatedChat = $aec35899a3c9695e$var$ae.validateProfileAssociated = $aec35899a3c9695e$var$ae.isProfileAssociated = $aec35899a3c9695e$var$ae.validateProfileViewDetailed = $aec35899a3c9695e$var$ae.isProfileViewDetailed = $aec35899a3c9695e$var$ae.validateProfileView = $aec35899a3c9695e$var$ae.isProfileView = $aec35899a3c9695e$var$ae.validateProfileViewBasic = $aec35899a3c9695e$var$ae.isProfileViewBasic = void 0;
const $aec35899a3c9695e$var$Pe = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$bt = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$XC(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#profileViewBasic";
}
$aec35899a3c9695e$var$ae.isProfileViewBasic = $aec35899a3c9695e$var$XC;
function $aec35899a3c9695e$var$HC(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#profileViewBasic", t);
}
$aec35899a3c9695e$var$ae.validateProfileViewBasic = $aec35899a3c9695e$var$HC;
function $aec35899a3c9695e$var$ZC(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#profileView";
}
$aec35899a3c9695e$var$ae.isProfileView = $aec35899a3c9695e$var$ZC;
function $aec35899a3c9695e$var$WC(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#profileView", t);
}
$aec35899a3c9695e$var$ae.validateProfileView = $aec35899a3c9695e$var$WC;
function $aec35899a3c9695e$var$YC(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#profileViewDetailed";
}
$aec35899a3c9695e$var$ae.isProfileViewDetailed = $aec35899a3c9695e$var$YC;
function $aec35899a3c9695e$var$JC(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#profileViewDetailed", t);
}
$aec35899a3c9695e$var$ae.validateProfileViewDetailed = $aec35899a3c9695e$var$JC;
function $aec35899a3c9695e$var$QC(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#profileAssociated";
}
$aec35899a3c9695e$var$ae.isProfileAssociated = $aec35899a3c9695e$var$QC;
function $aec35899a3c9695e$var$e1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#profileAssociated", t);
}
$aec35899a3c9695e$var$ae.validateProfileAssociated = $aec35899a3c9695e$var$e1;
function $aec35899a3c9695e$var$t1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#profileAssociatedChat";
}
$aec35899a3c9695e$var$ae.isProfileAssociatedChat = $aec35899a3c9695e$var$t1;
function $aec35899a3c9695e$var$r1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#profileAssociatedChat", t);
}
$aec35899a3c9695e$var$ae.validateProfileAssociatedChat = $aec35899a3c9695e$var$r1;
function $aec35899a3c9695e$var$i1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#viewerState";
}
$aec35899a3c9695e$var$ae.isViewerState = $aec35899a3c9695e$var$i1;
function $aec35899a3c9695e$var$n1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#viewerState", t);
}
$aec35899a3c9695e$var$ae.validateViewerState = $aec35899a3c9695e$var$n1;
function $aec35899a3c9695e$var$s1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#knownFollowers";
}
$aec35899a3c9695e$var$ae.isKnownFollowers = $aec35899a3c9695e$var$s1;
function $aec35899a3c9695e$var$a1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#knownFollowers", t);
}
$aec35899a3c9695e$var$ae.validateKnownFollowers = $aec35899a3c9695e$var$a1;
function $aec35899a3c9695e$var$o1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#adultContentPref";
}
$aec35899a3c9695e$var$ae.isAdultContentPref = $aec35899a3c9695e$var$o1;
function $aec35899a3c9695e$var$l1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#adultContentPref", t);
}
$aec35899a3c9695e$var$ae.validateAdultContentPref = $aec35899a3c9695e$var$l1;
function $aec35899a3c9695e$var$u1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#contentLabelPref";
}
$aec35899a3c9695e$var$ae.isContentLabelPref = $aec35899a3c9695e$var$u1;
function $aec35899a3c9695e$var$c1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#contentLabelPref", t);
}
$aec35899a3c9695e$var$ae.validateContentLabelPref = $aec35899a3c9695e$var$c1;
function $aec35899a3c9695e$var$d1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#savedFeed";
}
$aec35899a3c9695e$var$ae.isSavedFeed = $aec35899a3c9695e$var$d1;
function $aec35899a3c9695e$var$f1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#savedFeed", t);
}
$aec35899a3c9695e$var$ae.validateSavedFeed = $aec35899a3c9695e$var$f1;
function $aec35899a3c9695e$var$p1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#savedFeedsPrefV2";
}
$aec35899a3c9695e$var$ae.isSavedFeedsPrefV2 = $aec35899a3c9695e$var$p1;
function $aec35899a3c9695e$var$h1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#savedFeedsPrefV2", t);
}
$aec35899a3c9695e$var$ae.validateSavedFeedsPrefV2 = $aec35899a3c9695e$var$h1;
function $aec35899a3c9695e$var$m1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#savedFeedsPref";
}
$aec35899a3c9695e$var$ae.isSavedFeedsPref = $aec35899a3c9695e$var$m1;
function $aec35899a3c9695e$var$y1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#savedFeedsPref", t);
}
$aec35899a3c9695e$var$ae.validateSavedFeedsPref = $aec35899a3c9695e$var$y1;
function $aec35899a3c9695e$var$b1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#personalDetailsPref";
}
$aec35899a3c9695e$var$ae.isPersonalDetailsPref = $aec35899a3c9695e$var$b1;
function $aec35899a3c9695e$var$g1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#personalDetailsPref", t);
}
$aec35899a3c9695e$var$ae.validatePersonalDetailsPref = $aec35899a3c9695e$var$g1;
function $aec35899a3c9695e$var$x1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#feedViewPref";
}
$aec35899a3c9695e$var$ae.isFeedViewPref = $aec35899a3c9695e$var$x1;
function $aec35899a3c9695e$var$E1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#feedViewPref", t);
}
$aec35899a3c9695e$var$ae.validateFeedViewPref = $aec35899a3c9695e$var$E1;
function $aec35899a3c9695e$var$v1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#threadViewPref";
}
$aec35899a3c9695e$var$ae.isThreadViewPref = $aec35899a3c9695e$var$v1;
function $aec35899a3c9695e$var$R1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#threadViewPref", t);
}
$aec35899a3c9695e$var$ae.validateThreadViewPref = $aec35899a3c9695e$var$R1;
function $aec35899a3c9695e$var$A1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#interestsPref";
}
$aec35899a3c9695e$var$ae.isInterestsPref = $aec35899a3c9695e$var$A1;
function $aec35899a3c9695e$var$_1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#interestsPref", t);
}
$aec35899a3c9695e$var$ae.validateInterestsPref = $aec35899a3c9695e$var$_1;
function $aec35899a3c9695e$var$w1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#mutedWord";
}
$aec35899a3c9695e$var$ae.isMutedWord = $aec35899a3c9695e$var$w1;
function $aec35899a3c9695e$var$T1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#mutedWord", t);
}
$aec35899a3c9695e$var$ae.validateMutedWord = $aec35899a3c9695e$var$T1;
function $aec35899a3c9695e$var$S1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#mutedWordsPref";
}
$aec35899a3c9695e$var$ae.isMutedWordsPref = $aec35899a3c9695e$var$S1;
function $aec35899a3c9695e$var$C1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#mutedWordsPref", t);
}
$aec35899a3c9695e$var$ae.validateMutedWordsPref = $aec35899a3c9695e$var$C1;
function $aec35899a3c9695e$var$L1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#hiddenPostsPref";
}
$aec35899a3c9695e$var$ae.isHiddenPostsPref = $aec35899a3c9695e$var$L1;
function $aec35899a3c9695e$var$k1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#hiddenPostsPref", t);
}
$aec35899a3c9695e$var$ae.validateHiddenPostsPref = $aec35899a3c9695e$var$k1;
function $aec35899a3c9695e$var$D1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#labelersPref";
}
$aec35899a3c9695e$var$ae.isLabelersPref = $aec35899a3c9695e$var$D1;
function $aec35899a3c9695e$var$P1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#labelersPref", t);
}
$aec35899a3c9695e$var$ae.validateLabelersPref = $aec35899a3c9695e$var$P1;
function $aec35899a3c9695e$var$B1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#labelerPrefItem";
}
$aec35899a3c9695e$var$ae.isLabelerPrefItem = $aec35899a3c9695e$var$B1;
function $aec35899a3c9695e$var$I1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#labelerPrefItem", t);
}
$aec35899a3c9695e$var$ae.validateLabelerPrefItem = $aec35899a3c9695e$var$I1;
function $aec35899a3c9695e$var$U1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#bskyAppStatePref";
}
$aec35899a3c9695e$var$ae.isBskyAppStatePref = $aec35899a3c9695e$var$U1;
function $aec35899a3c9695e$var$O1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#bskyAppStatePref", t);
}
$aec35899a3c9695e$var$ae.validateBskyAppStatePref = $aec35899a3c9695e$var$O1;
function $aec35899a3c9695e$var$K1(t) {
    return (0, $aec35899a3c9695e$var$Pe.isObj)(t) && (0, $aec35899a3c9695e$var$Pe.hasProp)(t, "$type") && t.$type === "app.bsky.actor.defs#bskyAppProgressGuide";
}
$aec35899a3c9695e$var$ae.isBskyAppProgressGuide = $aec35899a3c9695e$var$K1;
function $aec35899a3c9695e$var$M1(t) {
    return $aec35899a3c9695e$var$bt.lexicons.validate("app.bsky.actor.defs#bskyAppProgressGuide", t);
}
$aec35899a3c9695e$var$ae.validateBskyAppProgressGuide = $aec35899a3c9695e$var$M1;
var $aec35899a3c9695e$var$Cs = {};
Object.defineProperty($aec35899a3c9695e$var$Cs, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Cs.validateRecord = $aec35899a3c9695e$var$Cs.isRecord = void 0;
const $aec35899a3c9695e$var$Qd = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$N1 = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$V1(t) {
    return (0, $aec35899a3c9695e$var$Qd.isObj)(t) && (0, $aec35899a3c9695e$var$Qd.hasProp)(t, "$type") && (t.$type === "app.bsky.actor.profile#main" || t.$type === "app.bsky.actor.profile");
}
$aec35899a3c9695e$var$Cs.isRecord = $aec35899a3c9695e$var$V1;
function $aec35899a3c9695e$var$j1(t) {
    return $aec35899a3c9695e$var$N1.lexicons.validate("app.bsky.actor.profile#main", t);
}
$aec35899a3c9695e$var$Cs.validateRecord = $aec35899a3c9695e$var$j1;
var $aec35899a3c9695e$var$Mt = {};
Object.defineProperty($aec35899a3c9695e$var$Mt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Mt.validateViewExternal = $aec35899a3c9695e$var$Mt.isViewExternal = $aec35899a3c9695e$var$Mt.validateView = $aec35899a3c9695e$var$Mt.isView = $aec35899a3c9695e$var$Mt.validateExternal = $aec35899a3c9695e$var$Mt.isExternal = $aec35899a3c9695e$var$Mt.validateMain = $aec35899a3c9695e$var$Mt.isMain = void 0;
const $aec35899a3c9695e$var$yn = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Nu = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$F1(t) {
    return (0, $aec35899a3c9695e$var$yn.isObj)(t) && (0, $aec35899a3c9695e$var$yn.hasProp)(t, "$type") && (t.$type === "app.bsky.embed.external#main" || t.$type === "app.bsky.embed.external");
}
$aec35899a3c9695e$var$Mt.isMain = $aec35899a3c9695e$var$F1;
function $aec35899a3c9695e$var$$1(t) {
    return $aec35899a3c9695e$var$Nu.lexicons.validate("app.bsky.embed.external#main", t);
}
$aec35899a3c9695e$var$Mt.validateMain = $aec35899a3c9695e$var$$1;
function $aec35899a3c9695e$var$G1(t) {
    return (0, $aec35899a3c9695e$var$yn.isObj)(t) && (0, $aec35899a3c9695e$var$yn.hasProp)(t, "$type") && t.$type === "app.bsky.embed.external#external";
}
$aec35899a3c9695e$var$Mt.isExternal = $aec35899a3c9695e$var$G1;
function $aec35899a3c9695e$var$q1(t) {
    return $aec35899a3c9695e$var$Nu.lexicons.validate("app.bsky.embed.external#external", t);
}
$aec35899a3c9695e$var$Mt.validateExternal = $aec35899a3c9695e$var$q1;
function $aec35899a3c9695e$var$z1(t) {
    return (0, $aec35899a3c9695e$var$yn.isObj)(t) && (0, $aec35899a3c9695e$var$yn.hasProp)(t, "$type") && t.$type === "app.bsky.embed.external#view";
}
$aec35899a3c9695e$var$Mt.isView = $aec35899a3c9695e$var$z1;
function $aec35899a3c9695e$var$X1(t) {
    return $aec35899a3c9695e$var$Nu.lexicons.validate("app.bsky.embed.external#view", t);
}
$aec35899a3c9695e$var$Mt.validateView = $aec35899a3c9695e$var$X1;
function $aec35899a3c9695e$var$H1(t) {
    return (0, $aec35899a3c9695e$var$yn.isObj)(t) && (0, $aec35899a3c9695e$var$yn.hasProp)(t, "$type") && t.$type === "app.bsky.embed.external#viewExternal";
}
$aec35899a3c9695e$var$Mt.isViewExternal = $aec35899a3c9695e$var$H1;
function $aec35899a3c9695e$var$Z1(t) {
    return $aec35899a3c9695e$var$Nu.lexicons.validate("app.bsky.embed.external#viewExternal", t);
}
$aec35899a3c9695e$var$Mt.validateViewExternal = $aec35899a3c9695e$var$Z1;
var $aec35899a3c9695e$var$xt = {};
Object.defineProperty($aec35899a3c9695e$var$xt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$xt.validateViewImage = $aec35899a3c9695e$var$xt.isViewImage = $aec35899a3c9695e$var$xt.validateView = $aec35899a3c9695e$var$xt.isView = $aec35899a3c9695e$var$xt.validateAspectRatio = $aec35899a3c9695e$var$xt.isAspectRatio = $aec35899a3c9695e$var$xt.validateImage = $aec35899a3c9695e$var$xt.isImage = $aec35899a3c9695e$var$xt.validateMain = $aec35899a3c9695e$var$xt.isMain = void 0;
const $aec35899a3c9695e$var$yi = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Ml = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$W1(t) {
    return (0, $aec35899a3c9695e$var$yi.isObj)(t) && (0, $aec35899a3c9695e$var$yi.hasProp)(t, "$type") && (t.$type === "app.bsky.embed.images#main" || t.$type === "app.bsky.embed.images");
}
$aec35899a3c9695e$var$xt.isMain = $aec35899a3c9695e$var$W1;
function $aec35899a3c9695e$var$Y1(t) {
    return $aec35899a3c9695e$var$Ml.lexicons.validate("app.bsky.embed.images#main", t);
}
$aec35899a3c9695e$var$xt.validateMain = $aec35899a3c9695e$var$Y1;
function $aec35899a3c9695e$var$J1(t) {
    return (0, $aec35899a3c9695e$var$yi.isObj)(t) && (0, $aec35899a3c9695e$var$yi.hasProp)(t, "$type") && t.$type === "app.bsky.embed.images#image";
}
$aec35899a3c9695e$var$xt.isImage = $aec35899a3c9695e$var$J1;
function $aec35899a3c9695e$var$Q1(t) {
    return $aec35899a3c9695e$var$Ml.lexicons.validate("app.bsky.embed.images#image", t);
}
$aec35899a3c9695e$var$xt.validateImage = $aec35899a3c9695e$var$Q1;
function $aec35899a3c9695e$var$eL(t) {
    return (0, $aec35899a3c9695e$var$yi.isObj)(t) && (0, $aec35899a3c9695e$var$yi.hasProp)(t, "$type") && t.$type === "app.bsky.embed.images#aspectRatio";
}
$aec35899a3c9695e$var$xt.isAspectRatio = $aec35899a3c9695e$var$eL;
function $aec35899a3c9695e$var$tL(t) {
    return $aec35899a3c9695e$var$Ml.lexicons.validate("app.bsky.embed.images#aspectRatio", t);
}
$aec35899a3c9695e$var$xt.validateAspectRatio = $aec35899a3c9695e$var$tL;
function $aec35899a3c9695e$var$rL(t) {
    return (0, $aec35899a3c9695e$var$yi.isObj)(t) && (0, $aec35899a3c9695e$var$yi.hasProp)(t, "$type") && t.$type === "app.bsky.embed.images#view";
}
$aec35899a3c9695e$var$xt.isView = $aec35899a3c9695e$var$rL;
function $aec35899a3c9695e$var$iL(t) {
    return $aec35899a3c9695e$var$Ml.lexicons.validate("app.bsky.embed.images#view", t);
}
$aec35899a3c9695e$var$xt.validateView = $aec35899a3c9695e$var$iL;
function $aec35899a3c9695e$var$nL(t) {
    return (0, $aec35899a3c9695e$var$yi.isObj)(t) && (0, $aec35899a3c9695e$var$yi.hasProp)(t, "$type") && t.$type === "app.bsky.embed.images#viewImage";
}
$aec35899a3c9695e$var$xt.isViewImage = $aec35899a3c9695e$var$nL;
function $aec35899a3c9695e$var$sL(t) {
    return $aec35899a3c9695e$var$Ml.lexicons.validate("app.bsky.embed.images#viewImage", t);
}
$aec35899a3c9695e$var$xt.validateViewImage = $aec35899a3c9695e$var$sL;
var $aec35899a3c9695e$var$Et = {};
Object.defineProperty($aec35899a3c9695e$var$Et, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Et.validateViewBlocked = $aec35899a3c9695e$var$Et.isViewBlocked = $aec35899a3c9695e$var$Et.validateViewNotFound = $aec35899a3c9695e$var$Et.isViewNotFound = $aec35899a3c9695e$var$Et.validateViewRecord = $aec35899a3c9695e$var$Et.isViewRecord = $aec35899a3c9695e$var$Et.validateView = $aec35899a3c9695e$var$Et.isView = $aec35899a3c9695e$var$Et.validateMain = $aec35899a3c9695e$var$Et.isMain = void 0;
const $aec35899a3c9695e$var$bi = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Nl = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$aL(t) {
    return (0, $aec35899a3c9695e$var$bi.isObj)(t) && (0, $aec35899a3c9695e$var$bi.hasProp)(t, "$type") && (t.$type === "app.bsky.embed.record#main" || t.$type === "app.bsky.embed.record");
}
$aec35899a3c9695e$var$Et.isMain = $aec35899a3c9695e$var$aL;
function $aec35899a3c9695e$var$oL(t) {
    return $aec35899a3c9695e$var$Nl.lexicons.validate("app.bsky.embed.record#main", t);
}
$aec35899a3c9695e$var$Et.validateMain = $aec35899a3c9695e$var$oL;
function $aec35899a3c9695e$var$lL(t) {
    return (0, $aec35899a3c9695e$var$bi.isObj)(t) && (0, $aec35899a3c9695e$var$bi.hasProp)(t, "$type") && t.$type === "app.bsky.embed.record#view";
}
$aec35899a3c9695e$var$Et.isView = $aec35899a3c9695e$var$lL;
function $aec35899a3c9695e$var$uL(t) {
    return $aec35899a3c9695e$var$Nl.lexicons.validate("app.bsky.embed.record#view", t);
}
$aec35899a3c9695e$var$Et.validateView = $aec35899a3c9695e$var$uL;
function $aec35899a3c9695e$var$cL(t) {
    return (0, $aec35899a3c9695e$var$bi.isObj)(t) && (0, $aec35899a3c9695e$var$bi.hasProp)(t, "$type") && t.$type === "app.bsky.embed.record#viewRecord";
}
$aec35899a3c9695e$var$Et.isViewRecord = $aec35899a3c9695e$var$cL;
function $aec35899a3c9695e$var$dL(t) {
    return $aec35899a3c9695e$var$Nl.lexicons.validate("app.bsky.embed.record#viewRecord", t);
}
$aec35899a3c9695e$var$Et.validateViewRecord = $aec35899a3c9695e$var$dL;
function $aec35899a3c9695e$var$fL(t) {
    return (0, $aec35899a3c9695e$var$bi.isObj)(t) && (0, $aec35899a3c9695e$var$bi.hasProp)(t, "$type") && t.$type === "app.bsky.embed.record#viewNotFound";
}
$aec35899a3c9695e$var$Et.isViewNotFound = $aec35899a3c9695e$var$fL;
function $aec35899a3c9695e$var$pL(t) {
    return $aec35899a3c9695e$var$Nl.lexicons.validate("app.bsky.embed.record#viewNotFound", t);
}
$aec35899a3c9695e$var$Et.validateViewNotFound = $aec35899a3c9695e$var$pL;
function $aec35899a3c9695e$var$hL(t) {
    return (0, $aec35899a3c9695e$var$bi.isObj)(t) && (0, $aec35899a3c9695e$var$bi.hasProp)(t, "$type") && t.$type === "app.bsky.embed.record#viewBlocked";
}
$aec35899a3c9695e$var$Et.isViewBlocked = $aec35899a3c9695e$var$hL;
function $aec35899a3c9695e$var$mL(t) {
    return $aec35899a3c9695e$var$Nl.lexicons.validate("app.bsky.embed.record#viewBlocked", t);
}
$aec35899a3c9695e$var$Et.validateViewBlocked = $aec35899a3c9695e$var$mL;
var $aec35899a3c9695e$var$ai = {};
Object.defineProperty($aec35899a3c9695e$var$ai, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ai.validateView = $aec35899a3c9695e$var$ai.isView = $aec35899a3c9695e$var$ai.validateMain = $aec35899a3c9695e$var$ai.isMain = void 0;
const $aec35899a3c9695e$var$Tu = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$z0 = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$yL(t) {
    return (0, $aec35899a3c9695e$var$Tu.isObj)(t) && (0, $aec35899a3c9695e$var$Tu.hasProp)(t, "$type") && (t.$type === "app.bsky.embed.recordWithMedia#main" || t.$type === "app.bsky.embed.recordWithMedia");
}
$aec35899a3c9695e$var$ai.isMain = $aec35899a3c9695e$var$yL;
function $aec35899a3c9695e$var$bL(t) {
    return $aec35899a3c9695e$var$z0.lexicons.validate("app.bsky.embed.recordWithMedia#main", t);
}
$aec35899a3c9695e$var$ai.validateMain = $aec35899a3c9695e$var$bL;
function $aec35899a3c9695e$var$gL(t) {
    return (0, $aec35899a3c9695e$var$Tu.isObj)(t) && (0, $aec35899a3c9695e$var$Tu.hasProp)(t, "$type") && t.$type === "app.bsky.embed.recordWithMedia#view";
}
$aec35899a3c9695e$var$ai.isView = $aec35899a3c9695e$var$gL;
function $aec35899a3c9695e$var$xL(t) {
    return $aec35899a3c9695e$var$z0.lexicons.validate("app.bsky.embed.recordWithMedia#view", t);
}
$aec35899a3c9695e$var$ai.validateView = $aec35899a3c9695e$var$xL;
var $aec35899a3c9695e$var$ce = {};
Object.defineProperty($aec35899a3c9695e$var$ce, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ce.INTERACTIONSHARE = $aec35899a3c9695e$var$ce.INTERACTIONQUOTE = $aec35899a3c9695e$var$ce.INTERACTIONREPLY = $aec35899a3c9695e$var$ce.INTERACTIONREPOST = $aec35899a3c9695e$var$ce.INTERACTIONLIKE = $aec35899a3c9695e$var$ce.INTERACTIONSEEN = $aec35899a3c9695e$var$ce.CLICKTHROUGHEMBED = $aec35899a3c9695e$var$ce.CLICKTHROUGHREPOSTER = $aec35899a3c9695e$var$ce.CLICKTHROUGHAUTHOR = $aec35899a3c9695e$var$ce.CLICKTHROUGHITEM = $aec35899a3c9695e$var$ce.REQUESTMORE = $aec35899a3c9695e$var$ce.REQUESTLESS = $aec35899a3c9695e$var$ce.validateInteraction = $aec35899a3c9695e$var$ce.isInteraction = $aec35899a3c9695e$var$ce.validateThreadgateView = $aec35899a3c9695e$var$ce.isThreadgateView = $aec35899a3c9695e$var$ce.validateSkeletonReasonRepost = $aec35899a3c9695e$var$ce.isSkeletonReasonRepost = $aec35899a3c9695e$var$ce.validateSkeletonFeedPost = $aec35899a3c9695e$var$ce.isSkeletonFeedPost = $aec35899a3c9695e$var$ce.validateGeneratorViewerState = $aec35899a3c9695e$var$ce.isGeneratorViewerState = $aec35899a3c9695e$var$ce.validateGeneratorView = $aec35899a3c9695e$var$ce.isGeneratorView = $aec35899a3c9695e$var$ce.validateBlockedAuthor = $aec35899a3c9695e$var$ce.isBlockedAuthor = $aec35899a3c9695e$var$ce.validateBlockedPost = $aec35899a3c9695e$var$ce.isBlockedPost = $aec35899a3c9695e$var$ce.validateNotFoundPost = $aec35899a3c9695e$var$ce.isNotFoundPost = $aec35899a3c9695e$var$ce.validateThreadViewPost = $aec35899a3c9695e$var$ce.isThreadViewPost = $aec35899a3c9695e$var$ce.validateReasonRepost = $aec35899a3c9695e$var$ce.isReasonRepost = $aec35899a3c9695e$var$ce.validateReplyRef = $aec35899a3c9695e$var$ce.isReplyRef = $aec35899a3c9695e$var$ce.validateFeedViewPost = $aec35899a3c9695e$var$ce.isFeedViewPost = $aec35899a3c9695e$var$ce.validateViewerState = $aec35899a3c9695e$var$ce.isViewerState = $aec35899a3c9695e$var$ce.validatePostView = $aec35899a3c9695e$var$ce.isPostView = void 0;
const $aec35899a3c9695e$var$Qe = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$cr = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$EL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#postView";
}
$aec35899a3c9695e$var$ce.isPostView = $aec35899a3c9695e$var$EL;
function $aec35899a3c9695e$var$vL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#postView", t);
}
$aec35899a3c9695e$var$ce.validatePostView = $aec35899a3c9695e$var$vL;
function $aec35899a3c9695e$var$RL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#viewerState";
}
$aec35899a3c9695e$var$ce.isViewerState = $aec35899a3c9695e$var$RL;
function $aec35899a3c9695e$var$AL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#viewerState", t);
}
$aec35899a3c9695e$var$ce.validateViewerState = $aec35899a3c9695e$var$AL;
function $aec35899a3c9695e$var$_L(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#feedViewPost";
}
$aec35899a3c9695e$var$ce.isFeedViewPost = $aec35899a3c9695e$var$_L;
function $aec35899a3c9695e$var$wL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#feedViewPost", t);
}
$aec35899a3c9695e$var$ce.validateFeedViewPost = $aec35899a3c9695e$var$wL;
function $aec35899a3c9695e$var$TL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#replyRef";
}
$aec35899a3c9695e$var$ce.isReplyRef = $aec35899a3c9695e$var$TL;
function $aec35899a3c9695e$var$SL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#replyRef", t);
}
$aec35899a3c9695e$var$ce.validateReplyRef = $aec35899a3c9695e$var$SL;
function $aec35899a3c9695e$var$CL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#reasonRepost";
}
$aec35899a3c9695e$var$ce.isReasonRepost = $aec35899a3c9695e$var$CL;
function $aec35899a3c9695e$var$LL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#reasonRepost", t);
}
$aec35899a3c9695e$var$ce.validateReasonRepost = $aec35899a3c9695e$var$LL;
function $aec35899a3c9695e$var$kL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#threadViewPost";
}
$aec35899a3c9695e$var$ce.isThreadViewPost = $aec35899a3c9695e$var$kL;
function $aec35899a3c9695e$var$DL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#threadViewPost", t);
}
$aec35899a3c9695e$var$ce.validateThreadViewPost = $aec35899a3c9695e$var$DL;
function $aec35899a3c9695e$var$PL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#notFoundPost";
}
$aec35899a3c9695e$var$ce.isNotFoundPost = $aec35899a3c9695e$var$PL;
function $aec35899a3c9695e$var$BL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#notFoundPost", t);
}
$aec35899a3c9695e$var$ce.validateNotFoundPost = $aec35899a3c9695e$var$BL;
function $aec35899a3c9695e$var$IL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#blockedPost";
}
$aec35899a3c9695e$var$ce.isBlockedPost = $aec35899a3c9695e$var$IL;
function $aec35899a3c9695e$var$UL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#blockedPost", t);
}
$aec35899a3c9695e$var$ce.validateBlockedPost = $aec35899a3c9695e$var$UL;
function $aec35899a3c9695e$var$OL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#blockedAuthor";
}
$aec35899a3c9695e$var$ce.isBlockedAuthor = $aec35899a3c9695e$var$OL;
function $aec35899a3c9695e$var$KL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#blockedAuthor", t);
}
$aec35899a3c9695e$var$ce.validateBlockedAuthor = $aec35899a3c9695e$var$KL;
function $aec35899a3c9695e$var$ML(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#generatorView";
}
$aec35899a3c9695e$var$ce.isGeneratorView = $aec35899a3c9695e$var$ML;
function $aec35899a3c9695e$var$NL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#generatorView", t);
}
$aec35899a3c9695e$var$ce.validateGeneratorView = $aec35899a3c9695e$var$NL;
function $aec35899a3c9695e$var$VL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#generatorViewerState";
}
$aec35899a3c9695e$var$ce.isGeneratorViewerState = $aec35899a3c9695e$var$VL;
function $aec35899a3c9695e$var$jL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#generatorViewerState", t);
}
$aec35899a3c9695e$var$ce.validateGeneratorViewerState = $aec35899a3c9695e$var$jL;
function $aec35899a3c9695e$var$FL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#skeletonFeedPost";
}
$aec35899a3c9695e$var$ce.isSkeletonFeedPost = $aec35899a3c9695e$var$FL;
function $aec35899a3c9695e$var$$L(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#skeletonFeedPost", t);
}
$aec35899a3c9695e$var$ce.validateSkeletonFeedPost = $aec35899a3c9695e$var$$L;
function $aec35899a3c9695e$var$GL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#skeletonReasonRepost";
}
$aec35899a3c9695e$var$ce.isSkeletonReasonRepost = $aec35899a3c9695e$var$GL;
function $aec35899a3c9695e$var$qL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#skeletonReasonRepost", t);
}
$aec35899a3c9695e$var$ce.validateSkeletonReasonRepost = $aec35899a3c9695e$var$qL;
function $aec35899a3c9695e$var$zL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#threadgateView";
}
$aec35899a3c9695e$var$ce.isThreadgateView = $aec35899a3c9695e$var$zL;
function $aec35899a3c9695e$var$XL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#threadgateView", t);
}
$aec35899a3c9695e$var$ce.validateThreadgateView = $aec35899a3c9695e$var$XL;
function $aec35899a3c9695e$var$HL(t) {
    return (0, $aec35899a3c9695e$var$Qe.isObj)(t) && (0, $aec35899a3c9695e$var$Qe.hasProp)(t, "$type") && t.$type === "app.bsky.feed.defs#interaction";
}
$aec35899a3c9695e$var$ce.isInteraction = $aec35899a3c9695e$var$HL;
function $aec35899a3c9695e$var$ZL(t) {
    return $aec35899a3c9695e$var$cr.lexicons.validate("app.bsky.feed.defs#interaction", t);
}
$aec35899a3c9695e$var$ce.validateInteraction = $aec35899a3c9695e$var$ZL;
$aec35899a3c9695e$var$ce.REQUESTLESS = "app.bsky.feed.defs#requestLess";
$aec35899a3c9695e$var$ce.REQUESTMORE = "app.bsky.feed.defs#requestMore";
$aec35899a3c9695e$var$ce.CLICKTHROUGHITEM = "app.bsky.feed.defs#clickthroughItem";
$aec35899a3c9695e$var$ce.CLICKTHROUGHAUTHOR = "app.bsky.feed.defs#clickthroughAuthor";
$aec35899a3c9695e$var$ce.CLICKTHROUGHREPOSTER = "app.bsky.feed.defs#clickthroughReposter";
$aec35899a3c9695e$var$ce.CLICKTHROUGHEMBED = "app.bsky.feed.defs#clickthroughEmbed";
$aec35899a3c9695e$var$ce.INTERACTIONSEEN = "app.bsky.feed.defs#interactionSeen";
$aec35899a3c9695e$var$ce.INTERACTIONLIKE = "app.bsky.feed.defs#interactionLike";
$aec35899a3c9695e$var$ce.INTERACTIONREPOST = "app.bsky.feed.defs#interactionRepost";
$aec35899a3c9695e$var$ce.INTERACTIONREPLY = "app.bsky.feed.defs#interactionReply";
$aec35899a3c9695e$var$ce.INTERACTIONQUOTE = "app.bsky.feed.defs#interactionQuote";
$aec35899a3c9695e$var$ce.INTERACTIONSHARE = "app.bsky.feed.defs#interactionShare";
var $aec35899a3c9695e$var$Ls = {};
Object.defineProperty($aec35899a3c9695e$var$Ls, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ls.validateRecord = $aec35899a3c9695e$var$Ls.isRecord = void 0;
const $aec35899a3c9695e$var$ef = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$WL = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$YL(t) {
    return (0, $aec35899a3c9695e$var$ef.isObj)(t) && (0, $aec35899a3c9695e$var$ef.hasProp)(t, "$type") && (t.$type === "app.bsky.feed.generator#main" || t.$type === "app.bsky.feed.generator");
}
$aec35899a3c9695e$var$Ls.isRecord = $aec35899a3c9695e$var$YL;
function $aec35899a3c9695e$var$JL(t) {
    return $aec35899a3c9695e$var$WL.lexicons.validate("app.bsky.feed.generator#main", t);
}
$aec35899a3c9695e$var$Ls.validateRecord = $aec35899a3c9695e$var$JL;
var $aec35899a3c9695e$var$ks = {};
Object.defineProperty($aec35899a3c9695e$var$ks, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ks.validateRecord = $aec35899a3c9695e$var$ks.isRecord = void 0;
const $aec35899a3c9695e$var$tf = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$QL = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$ek(t) {
    return (0, $aec35899a3c9695e$var$tf.isObj)(t) && (0, $aec35899a3c9695e$var$tf.hasProp)(t, "$type") && (t.$type === "app.bsky.feed.like#main" || t.$type === "app.bsky.feed.like");
}
$aec35899a3c9695e$var$ks.isRecord = $aec35899a3c9695e$var$ek;
function $aec35899a3c9695e$var$tk(t) {
    return $aec35899a3c9695e$var$QL.lexicons.validate("app.bsky.feed.like#main", t);
}
$aec35899a3c9695e$var$ks.validateRecord = $aec35899a3c9695e$var$tk;
var $aec35899a3c9695e$var$Nt = {};
Object.defineProperty($aec35899a3c9695e$var$Nt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Nt.validateTextSlice = $aec35899a3c9695e$var$Nt.isTextSlice = $aec35899a3c9695e$var$Nt.validateEntity = $aec35899a3c9695e$var$Nt.isEntity = $aec35899a3c9695e$var$Nt.validateReplyRef = $aec35899a3c9695e$var$Nt.isReplyRef = $aec35899a3c9695e$var$Nt.validateRecord = $aec35899a3c9695e$var$Nt.isRecord = void 0;
const $aec35899a3c9695e$var$bn = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Vu = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$rk(t) {
    return (0, $aec35899a3c9695e$var$bn.isObj)(t) && (0, $aec35899a3c9695e$var$bn.hasProp)(t, "$type") && (t.$type === "app.bsky.feed.post#main" || t.$type === "app.bsky.feed.post");
}
$aec35899a3c9695e$var$Nt.isRecord = $aec35899a3c9695e$var$rk;
function $aec35899a3c9695e$var$ik(t) {
    return $aec35899a3c9695e$var$Vu.lexicons.validate("app.bsky.feed.post#main", t);
}
$aec35899a3c9695e$var$Nt.validateRecord = $aec35899a3c9695e$var$ik;
function $aec35899a3c9695e$var$nk(t) {
    return (0, $aec35899a3c9695e$var$bn.isObj)(t) && (0, $aec35899a3c9695e$var$bn.hasProp)(t, "$type") && t.$type === "app.bsky.feed.post#replyRef";
}
$aec35899a3c9695e$var$Nt.isReplyRef = $aec35899a3c9695e$var$nk;
function $aec35899a3c9695e$var$sk(t) {
    return $aec35899a3c9695e$var$Vu.lexicons.validate("app.bsky.feed.post#replyRef", t);
}
$aec35899a3c9695e$var$Nt.validateReplyRef = $aec35899a3c9695e$var$sk;
function $aec35899a3c9695e$var$ak(t) {
    return (0, $aec35899a3c9695e$var$bn.isObj)(t) && (0, $aec35899a3c9695e$var$bn.hasProp)(t, "$type") && t.$type === "app.bsky.feed.post#entity";
}
$aec35899a3c9695e$var$Nt.isEntity = $aec35899a3c9695e$var$ak;
function $aec35899a3c9695e$var$ok(t) {
    return $aec35899a3c9695e$var$Vu.lexicons.validate("app.bsky.feed.post#entity", t);
}
$aec35899a3c9695e$var$Nt.validateEntity = $aec35899a3c9695e$var$ok;
function $aec35899a3c9695e$var$lk(t) {
    return (0, $aec35899a3c9695e$var$bn.isObj)(t) && (0, $aec35899a3c9695e$var$bn.hasProp)(t, "$type") && t.$type === "app.bsky.feed.post#textSlice";
}
$aec35899a3c9695e$var$Nt.isTextSlice = $aec35899a3c9695e$var$lk;
function $aec35899a3c9695e$var$uk(t) {
    return $aec35899a3c9695e$var$Vu.lexicons.validate("app.bsky.feed.post#textSlice", t);
}
$aec35899a3c9695e$var$Nt.validateTextSlice = $aec35899a3c9695e$var$uk;
var $aec35899a3c9695e$var$Ds = {};
Object.defineProperty($aec35899a3c9695e$var$Ds, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ds.validateRecord = $aec35899a3c9695e$var$Ds.isRecord = void 0;
const $aec35899a3c9695e$var$rf = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$ck = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$dk(t) {
    return (0, $aec35899a3c9695e$var$rf.isObj)(t) && (0, $aec35899a3c9695e$var$rf.hasProp)(t, "$type") && (t.$type === "app.bsky.feed.repost#main" || t.$type === "app.bsky.feed.repost");
}
$aec35899a3c9695e$var$Ds.isRecord = $aec35899a3c9695e$var$dk;
function $aec35899a3c9695e$var$fk(t) {
    return $aec35899a3c9695e$var$ck.lexicons.validate("app.bsky.feed.repost#main", t);
}
$aec35899a3c9695e$var$Ds.validateRecord = $aec35899a3c9695e$var$fk;
var $aec35899a3c9695e$var$Vt = {};
Object.defineProperty($aec35899a3c9695e$var$Vt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Vt.validateListRule = $aec35899a3c9695e$var$Vt.isListRule = $aec35899a3c9695e$var$Vt.validateFollowingRule = $aec35899a3c9695e$var$Vt.isFollowingRule = $aec35899a3c9695e$var$Vt.validateMentionRule = $aec35899a3c9695e$var$Vt.isMentionRule = $aec35899a3c9695e$var$Vt.validateRecord = $aec35899a3c9695e$var$Vt.isRecord = void 0;
const $aec35899a3c9695e$var$gn = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$ju = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$pk(t) {
    return (0, $aec35899a3c9695e$var$gn.isObj)(t) && (0, $aec35899a3c9695e$var$gn.hasProp)(t, "$type") && (t.$type === "app.bsky.feed.threadgate#main" || t.$type === "app.bsky.feed.threadgate");
}
$aec35899a3c9695e$var$Vt.isRecord = $aec35899a3c9695e$var$pk;
function $aec35899a3c9695e$var$hk(t) {
    return $aec35899a3c9695e$var$ju.lexicons.validate("app.bsky.feed.threadgate#main", t);
}
$aec35899a3c9695e$var$Vt.validateRecord = $aec35899a3c9695e$var$hk;
function $aec35899a3c9695e$var$mk(t) {
    return (0, $aec35899a3c9695e$var$gn.isObj)(t) && (0, $aec35899a3c9695e$var$gn.hasProp)(t, "$type") && t.$type === "app.bsky.feed.threadgate#mentionRule";
}
$aec35899a3c9695e$var$Vt.isMentionRule = $aec35899a3c9695e$var$mk;
function $aec35899a3c9695e$var$yk(t) {
    return $aec35899a3c9695e$var$ju.lexicons.validate("app.bsky.feed.threadgate#mentionRule", t);
}
$aec35899a3c9695e$var$Vt.validateMentionRule = $aec35899a3c9695e$var$yk;
function $aec35899a3c9695e$var$bk(t) {
    return (0, $aec35899a3c9695e$var$gn.isObj)(t) && (0, $aec35899a3c9695e$var$gn.hasProp)(t, "$type") && t.$type === "app.bsky.feed.threadgate#followingRule";
}
$aec35899a3c9695e$var$Vt.isFollowingRule = $aec35899a3c9695e$var$bk;
function $aec35899a3c9695e$var$gk(t) {
    return $aec35899a3c9695e$var$ju.lexicons.validate("app.bsky.feed.threadgate#followingRule", t);
}
$aec35899a3c9695e$var$Vt.validateFollowingRule = $aec35899a3c9695e$var$gk;
function $aec35899a3c9695e$var$xk(t) {
    return (0, $aec35899a3c9695e$var$gn.isObj)(t) && (0, $aec35899a3c9695e$var$gn.hasProp)(t, "$type") && t.$type === "app.bsky.feed.threadgate#listRule";
}
$aec35899a3c9695e$var$Vt.isListRule = $aec35899a3c9695e$var$xk;
function $aec35899a3c9695e$var$Ek(t) {
    return $aec35899a3c9695e$var$ju.lexicons.validate("app.bsky.feed.threadgate#listRule", t);
}
$aec35899a3c9695e$var$Vt.validateListRule = $aec35899a3c9695e$var$Ek;
var $aec35899a3c9695e$var$Ps = {};
Object.defineProperty($aec35899a3c9695e$var$Ps, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ps.validateRecord = $aec35899a3c9695e$var$Ps.isRecord = void 0;
const $aec35899a3c9695e$var$nf = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$vk = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$Rk(t) {
    return (0, $aec35899a3c9695e$var$nf.isObj)(t) && (0, $aec35899a3c9695e$var$nf.hasProp)(t, "$type") && (t.$type === "app.bsky.graph.block#main" || t.$type === "app.bsky.graph.block");
}
$aec35899a3c9695e$var$Ps.isRecord = $aec35899a3c9695e$var$Rk;
function $aec35899a3c9695e$var$Ak(t) {
    return $aec35899a3c9695e$var$vk.lexicons.validate("app.bsky.graph.block#main", t);
}
$aec35899a3c9695e$var$Ps.validateRecord = $aec35899a3c9695e$var$Ak;
var $aec35899a3c9695e$var$Ve = {};
Object.defineProperty($aec35899a3c9695e$var$Ve, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ve.validateRelationship = $aec35899a3c9695e$var$Ve.isRelationship = $aec35899a3c9695e$var$Ve.validateNotFoundActor = $aec35899a3c9695e$var$Ve.isNotFoundActor = $aec35899a3c9695e$var$Ve.validateListViewerState = $aec35899a3c9695e$var$Ve.isListViewerState = $aec35899a3c9695e$var$Ve.REFERENCELIST = $aec35899a3c9695e$var$Ve.CURATELIST = $aec35899a3c9695e$var$Ve.MODLIST = $aec35899a3c9695e$var$Ve.validateStarterPackViewBasic = $aec35899a3c9695e$var$Ve.isStarterPackViewBasic = $aec35899a3c9695e$var$Ve.validateStarterPackView = $aec35899a3c9695e$var$Ve.isStarterPackView = $aec35899a3c9695e$var$Ve.validateListItemView = $aec35899a3c9695e$var$Ve.isListItemView = $aec35899a3c9695e$var$Ve.validateListView = $aec35899a3c9695e$var$Ve.isListView = $aec35899a3c9695e$var$Ve.validateListViewBasic = $aec35899a3c9695e$var$Ve.isListViewBasic = void 0;
const $aec35899a3c9695e$var$tr = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Tn = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$_k(t) {
    return (0, $aec35899a3c9695e$var$tr.isObj)(t) && (0, $aec35899a3c9695e$var$tr.hasProp)(t, "$type") && t.$type === "app.bsky.graph.defs#listViewBasic";
}
$aec35899a3c9695e$var$Ve.isListViewBasic = $aec35899a3c9695e$var$_k;
function $aec35899a3c9695e$var$wk(t) {
    return $aec35899a3c9695e$var$Tn.lexicons.validate("app.bsky.graph.defs#listViewBasic", t);
}
$aec35899a3c9695e$var$Ve.validateListViewBasic = $aec35899a3c9695e$var$wk;
function $aec35899a3c9695e$var$Tk(t) {
    return (0, $aec35899a3c9695e$var$tr.isObj)(t) && (0, $aec35899a3c9695e$var$tr.hasProp)(t, "$type") && t.$type === "app.bsky.graph.defs#listView";
}
$aec35899a3c9695e$var$Ve.isListView = $aec35899a3c9695e$var$Tk;
function $aec35899a3c9695e$var$Sk(t) {
    return $aec35899a3c9695e$var$Tn.lexicons.validate("app.bsky.graph.defs#listView", t);
}
$aec35899a3c9695e$var$Ve.validateListView = $aec35899a3c9695e$var$Sk;
function $aec35899a3c9695e$var$Ck(t) {
    return (0, $aec35899a3c9695e$var$tr.isObj)(t) && (0, $aec35899a3c9695e$var$tr.hasProp)(t, "$type") && t.$type === "app.bsky.graph.defs#listItemView";
}
$aec35899a3c9695e$var$Ve.isListItemView = $aec35899a3c9695e$var$Ck;
function $aec35899a3c9695e$var$Lk(t) {
    return $aec35899a3c9695e$var$Tn.lexicons.validate("app.bsky.graph.defs#listItemView", t);
}
$aec35899a3c9695e$var$Ve.validateListItemView = $aec35899a3c9695e$var$Lk;
function $aec35899a3c9695e$var$kk(t) {
    return (0, $aec35899a3c9695e$var$tr.isObj)(t) && (0, $aec35899a3c9695e$var$tr.hasProp)(t, "$type") && t.$type === "app.bsky.graph.defs#starterPackView";
}
$aec35899a3c9695e$var$Ve.isStarterPackView = $aec35899a3c9695e$var$kk;
function $aec35899a3c9695e$var$Dk(t) {
    return $aec35899a3c9695e$var$Tn.lexicons.validate("app.bsky.graph.defs#starterPackView", t);
}
$aec35899a3c9695e$var$Ve.validateStarterPackView = $aec35899a3c9695e$var$Dk;
function $aec35899a3c9695e$var$Pk(t) {
    return (0, $aec35899a3c9695e$var$tr.isObj)(t) && (0, $aec35899a3c9695e$var$tr.hasProp)(t, "$type") && t.$type === "app.bsky.graph.defs#starterPackViewBasic";
}
$aec35899a3c9695e$var$Ve.isStarterPackViewBasic = $aec35899a3c9695e$var$Pk;
function $aec35899a3c9695e$var$Bk(t) {
    return $aec35899a3c9695e$var$Tn.lexicons.validate("app.bsky.graph.defs#starterPackViewBasic", t);
}
$aec35899a3c9695e$var$Ve.validateStarterPackViewBasic = $aec35899a3c9695e$var$Bk;
$aec35899a3c9695e$var$Ve.MODLIST = "app.bsky.graph.defs#modlist";
$aec35899a3c9695e$var$Ve.CURATELIST = "app.bsky.graph.defs#curatelist";
$aec35899a3c9695e$var$Ve.REFERENCELIST = "app.bsky.graph.defs#referencelist";
function $aec35899a3c9695e$var$Ik(t) {
    return (0, $aec35899a3c9695e$var$tr.isObj)(t) && (0, $aec35899a3c9695e$var$tr.hasProp)(t, "$type") && t.$type === "app.bsky.graph.defs#listViewerState";
}
$aec35899a3c9695e$var$Ve.isListViewerState = $aec35899a3c9695e$var$Ik;
function $aec35899a3c9695e$var$Uk(t) {
    return $aec35899a3c9695e$var$Tn.lexicons.validate("app.bsky.graph.defs#listViewerState", t);
}
$aec35899a3c9695e$var$Ve.validateListViewerState = $aec35899a3c9695e$var$Uk;
function $aec35899a3c9695e$var$Ok(t) {
    return (0, $aec35899a3c9695e$var$tr.isObj)(t) && (0, $aec35899a3c9695e$var$tr.hasProp)(t, "$type") && t.$type === "app.bsky.graph.defs#notFoundActor";
}
$aec35899a3c9695e$var$Ve.isNotFoundActor = $aec35899a3c9695e$var$Ok;
function $aec35899a3c9695e$var$Kk(t) {
    return $aec35899a3c9695e$var$Tn.lexicons.validate("app.bsky.graph.defs#notFoundActor", t);
}
$aec35899a3c9695e$var$Ve.validateNotFoundActor = $aec35899a3c9695e$var$Kk;
function $aec35899a3c9695e$var$Mk(t) {
    return (0, $aec35899a3c9695e$var$tr.isObj)(t) && (0, $aec35899a3c9695e$var$tr.hasProp)(t, "$type") && t.$type === "app.bsky.graph.defs#relationship";
}
$aec35899a3c9695e$var$Ve.isRelationship = $aec35899a3c9695e$var$Mk;
function $aec35899a3c9695e$var$Nk(t) {
    return $aec35899a3c9695e$var$Tn.lexicons.validate("app.bsky.graph.defs#relationship", t);
}
$aec35899a3c9695e$var$Ve.validateRelationship = $aec35899a3c9695e$var$Nk;
var $aec35899a3c9695e$var$Bs = {};
Object.defineProperty($aec35899a3c9695e$var$Bs, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Bs.validateRecord = $aec35899a3c9695e$var$Bs.isRecord = void 0;
const $aec35899a3c9695e$var$sf = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Vk = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$jk(t) {
    return (0, $aec35899a3c9695e$var$sf.isObj)(t) && (0, $aec35899a3c9695e$var$sf.hasProp)(t, "$type") && (t.$type === "app.bsky.graph.follow#main" || t.$type === "app.bsky.graph.follow");
}
$aec35899a3c9695e$var$Bs.isRecord = $aec35899a3c9695e$var$jk;
function $aec35899a3c9695e$var$Fk(t) {
    return $aec35899a3c9695e$var$Vk.lexicons.validate("app.bsky.graph.follow#main", t);
}
$aec35899a3c9695e$var$Bs.validateRecord = $aec35899a3c9695e$var$Fk;
var $aec35899a3c9695e$var$Is = {};
Object.defineProperty($aec35899a3c9695e$var$Is, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Is.validateRecord = $aec35899a3c9695e$var$Is.isRecord = void 0;
const $aec35899a3c9695e$var$af = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$$k = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$Gk(t) {
    return (0, $aec35899a3c9695e$var$af.isObj)(t) && (0, $aec35899a3c9695e$var$af.hasProp)(t, "$type") && (t.$type === "app.bsky.graph.list#main" || t.$type === "app.bsky.graph.list");
}
$aec35899a3c9695e$var$Is.isRecord = $aec35899a3c9695e$var$Gk;
function $aec35899a3c9695e$var$qk(t) {
    return $aec35899a3c9695e$var$$k.lexicons.validate("app.bsky.graph.list#main", t);
}
$aec35899a3c9695e$var$Is.validateRecord = $aec35899a3c9695e$var$qk;
var $aec35899a3c9695e$var$Us = {};
Object.defineProperty($aec35899a3c9695e$var$Us, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Us.validateRecord = $aec35899a3c9695e$var$Us.isRecord = void 0;
const $aec35899a3c9695e$var$of = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$zk = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$Xk(t) {
    return (0, $aec35899a3c9695e$var$of.isObj)(t) && (0, $aec35899a3c9695e$var$of.hasProp)(t, "$type") && (t.$type === "app.bsky.graph.listblock#main" || t.$type === "app.bsky.graph.listblock");
}
$aec35899a3c9695e$var$Us.isRecord = $aec35899a3c9695e$var$Xk;
function $aec35899a3c9695e$var$Hk(t) {
    return $aec35899a3c9695e$var$zk.lexicons.validate("app.bsky.graph.listblock#main", t);
}
$aec35899a3c9695e$var$Us.validateRecord = $aec35899a3c9695e$var$Hk;
var $aec35899a3c9695e$var$Os = {};
Object.defineProperty($aec35899a3c9695e$var$Os, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Os.validateRecord = $aec35899a3c9695e$var$Os.isRecord = void 0;
const $aec35899a3c9695e$var$lf = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Zk = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$Wk(t) {
    return (0, $aec35899a3c9695e$var$lf.isObj)(t) && (0, $aec35899a3c9695e$var$lf.hasProp)(t, "$type") && (t.$type === "app.bsky.graph.listitem#main" || t.$type === "app.bsky.graph.listitem");
}
$aec35899a3c9695e$var$Os.isRecord = $aec35899a3c9695e$var$Wk;
function $aec35899a3c9695e$var$Yk(t) {
    return $aec35899a3c9695e$var$Zk.lexicons.validate("app.bsky.graph.listitem#main", t);
}
$aec35899a3c9695e$var$Os.validateRecord = $aec35899a3c9695e$var$Yk;
var $aec35899a3c9695e$var$oi = {};
Object.defineProperty($aec35899a3c9695e$var$oi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$oi.validateFeedItem = $aec35899a3c9695e$var$oi.isFeedItem = $aec35899a3c9695e$var$oi.validateRecord = $aec35899a3c9695e$var$oi.isRecord = void 0;
const $aec35899a3c9695e$var$Su = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$X0 = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$Jk(t) {
    return (0, $aec35899a3c9695e$var$Su.isObj)(t) && (0, $aec35899a3c9695e$var$Su.hasProp)(t, "$type") && (t.$type === "app.bsky.graph.starterpack#main" || t.$type === "app.bsky.graph.starterpack");
}
$aec35899a3c9695e$var$oi.isRecord = $aec35899a3c9695e$var$Jk;
function $aec35899a3c9695e$var$Qk(t) {
    return $aec35899a3c9695e$var$X0.lexicons.validate("app.bsky.graph.starterpack#main", t);
}
$aec35899a3c9695e$var$oi.validateRecord = $aec35899a3c9695e$var$Qk;
function $aec35899a3c9695e$var$eD(t) {
    return (0, $aec35899a3c9695e$var$Su.isObj)(t) && (0, $aec35899a3c9695e$var$Su.hasProp)(t, "$type") && t.$type === "app.bsky.graph.starterpack#feedItem";
}
$aec35899a3c9695e$var$oi.isFeedItem = $aec35899a3c9695e$var$eD;
function $aec35899a3c9695e$var$tD(t) {
    return $aec35899a3c9695e$var$X0.lexicons.validate("app.bsky.graph.starterpack#feedItem", t);
}
$aec35899a3c9695e$var$oi.validateFeedItem = $aec35899a3c9695e$var$tD;
var $aec35899a3c9695e$var$jt = {};
Object.defineProperty($aec35899a3c9695e$var$jt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$jt.validateLabelerPolicies = $aec35899a3c9695e$var$jt.isLabelerPolicies = $aec35899a3c9695e$var$jt.validateLabelerViewerState = $aec35899a3c9695e$var$jt.isLabelerViewerState = $aec35899a3c9695e$var$jt.validateLabelerViewDetailed = $aec35899a3c9695e$var$jt.isLabelerViewDetailed = $aec35899a3c9695e$var$jt.validateLabelerView = $aec35899a3c9695e$var$jt.isLabelerView = void 0;
const $aec35899a3c9695e$var$xn = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Fu = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$rD(t) {
    return (0, $aec35899a3c9695e$var$xn.isObj)(t) && (0, $aec35899a3c9695e$var$xn.hasProp)(t, "$type") && t.$type === "app.bsky.labeler.defs#labelerView";
}
$aec35899a3c9695e$var$jt.isLabelerView = $aec35899a3c9695e$var$rD;
function $aec35899a3c9695e$var$iD(t) {
    return $aec35899a3c9695e$var$Fu.lexicons.validate("app.bsky.labeler.defs#labelerView", t);
}
$aec35899a3c9695e$var$jt.validateLabelerView = $aec35899a3c9695e$var$iD;
function $aec35899a3c9695e$var$nD(t) {
    return (0, $aec35899a3c9695e$var$xn.isObj)(t) && (0, $aec35899a3c9695e$var$xn.hasProp)(t, "$type") && t.$type === "app.bsky.labeler.defs#labelerViewDetailed";
}
$aec35899a3c9695e$var$jt.isLabelerViewDetailed = $aec35899a3c9695e$var$nD;
function $aec35899a3c9695e$var$sD(t) {
    return $aec35899a3c9695e$var$Fu.lexicons.validate("app.bsky.labeler.defs#labelerViewDetailed", t);
}
$aec35899a3c9695e$var$jt.validateLabelerViewDetailed = $aec35899a3c9695e$var$sD;
function $aec35899a3c9695e$var$aD(t) {
    return (0, $aec35899a3c9695e$var$xn.isObj)(t) && (0, $aec35899a3c9695e$var$xn.hasProp)(t, "$type") && t.$type === "app.bsky.labeler.defs#labelerViewerState";
}
$aec35899a3c9695e$var$jt.isLabelerViewerState = $aec35899a3c9695e$var$aD;
function $aec35899a3c9695e$var$oD(t) {
    return $aec35899a3c9695e$var$Fu.lexicons.validate("app.bsky.labeler.defs#labelerViewerState", t);
}
$aec35899a3c9695e$var$jt.validateLabelerViewerState = $aec35899a3c9695e$var$oD;
function $aec35899a3c9695e$var$lD(t) {
    return (0, $aec35899a3c9695e$var$xn.isObj)(t) && (0, $aec35899a3c9695e$var$xn.hasProp)(t, "$type") && t.$type === "app.bsky.labeler.defs#labelerPolicies";
}
$aec35899a3c9695e$var$jt.isLabelerPolicies = $aec35899a3c9695e$var$lD;
function $aec35899a3c9695e$var$uD(t) {
    return $aec35899a3c9695e$var$Fu.lexicons.validate("app.bsky.labeler.defs#labelerPolicies", t);
}
$aec35899a3c9695e$var$jt.validateLabelerPolicies = $aec35899a3c9695e$var$uD;
var $aec35899a3c9695e$var$Ks = {};
Object.defineProperty($aec35899a3c9695e$var$Ks, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ks.validateRecord = $aec35899a3c9695e$var$Ks.isRecord = void 0;
const $aec35899a3c9695e$var$uf = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$cD = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$dD(t) {
    return (0, $aec35899a3c9695e$var$uf.isObj)(t) && (0, $aec35899a3c9695e$var$uf.hasProp)(t, "$type") && (t.$type === "app.bsky.labeler.service#main" || t.$type === "app.bsky.labeler.service");
}
$aec35899a3c9695e$var$Ks.isRecord = $aec35899a3c9695e$var$dD;
function $aec35899a3c9695e$var$fD(t) {
    return $aec35899a3c9695e$var$cD.lexicons.validate("app.bsky.labeler.service#main", t);
}
$aec35899a3c9695e$var$Ks.validateRecord = $aec35899a3c9695e$var$fD;
var $aec35899a3c9695e$var$vt = {};
Object.defineProperty($aec35899a3c9695e$var$vt, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$vt.validateByteSlice = $aec35899a3c9695e$var$vt.isByteSlice = $aec35899a3c9695e$var$vt.validateTag = $aec35899a3c9695e$var$vt.isTag = $aec35899a3c9695e$var$vt.validateLink = $aec35899a3c9695e$var$vt.isLink = $aec35899a3c9695e$var$vt.validateMention = $aec35899a3c9695e$var$vt.isMention = $aec35899a3c9695e$var$vt.validateMain = $aec35899a3c9695e$var$vt.isMain = void 0;
const $aec35899a3c9695e$var$gi = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Vl = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$pD(t) {
    return (0, $aec35899a3c9695e$var$gi.isObj)(t) && (0, $aec35899a3c9695e$var$gi.hasProp)(t, "$type") && (t.$type === "app.bsky.richtext.facet#main" || t.$type === "app.bsky.richtext.facet");
}
$aec35899a3c9695e$var$vt.isMain = $aec35899a3c9695e$var$pD;
function $aec35899a3c9695e$var$hD(t) {
    return $aec35899a3c9695e$var$Vl.lexicons.validate("app.bsky.richtext.facet#main", t);
}
$aec35899a3c9695e$var$vt.validateMain = $aec35899a3c9695e$var$hD;
function $aec35899a3c9695e$var$mD(t) {
    return (0, $aec35899a3c9695e$var$gi.isObj)(t) && (0, $aec35899a3c9695e$var$gi.hasProp)(t, "$type") && t.$type === "app.bsky.richtext.facet#mention";
}
$aec35899a3c9695e$var$vt.isMention = $aec35899a3c9695e$var$mD;
function $aec35899a3c9695e$var$yD(t) {
    return $aec35899a3c9695e$var$Vl.lexicons.validate("app.bsky.richtext.facet#mention", t);
}
$aec35899a3c9695e$var$vt.validateMention = $aec35899a3c9695e$var$yD;
function $aec35899a3c9695e$var$bD(t) {
    return (0, $aec35899a3c9695e$var$gi.isObj)(t) && (0, $aec35899a3c9695e$var$gi.hasProp)(t, "$type") && t.$type === "app.bsky.richtext.facet#link";
}
$aec35899a3c9695e$var$vt.isLink = $aec35899a3c9695e$var$bD;
function $aec35899a3c9695e$var$gD(t) {
    return $aec35899a3c9695e$var$Vl.lexicons.validate("app.bsky.richtext.facet#link", t);
}
$aec35899a3c9695e$var$vt.validateLink = $aec35899a3c9695e$var$gD;
function $aec35899a3c9695e$var$xD(t) {
    return (0, $aec35899a3c9695e$var$gi.isObj)(t) && (0, $aec35899a3c9695e$var$gi.hasProp)(t, "$type") && t.$type === "app.bsky.richtext.facet#tag";
}
$aec35899a3c9695e$var$vt.isTag = $aec35899a3c9695e$var$xD;
function $aec35899a3c9695e$var$ED(t) {
    return $aec35899a3c9695e$var$Vl.lexicons.validate("app.bsky.richtext.facet#tag", t);
}
$aec35899a3c9695e$var$vt.validateTag = $aec35899a3c9695e$var$ED;
function $aec35899a3c9695e$var$vD(t) {
    return (0, $aec35899a3c9695e$var$gi.isObj)(t) && (0, $aec35899a3c9695e$var$gi.hasProp)(t, "$type") && t.$type === "app.bsky.richtext.facet#byteSlice";
}
$aec35899a3c9695e$var$vt.isByteSlice = $aec35899a3c9695e$var$vD;
function $aec35899a3c9695e$var$RD(t) {
    return $aec35899a3c9695e$var$Vl.lexicons.validate("app.bsky.richtext.facet#byteSlice", t);
}
$aec35899a3c9695e$var$vt.validateByteSlice = $aec35899a3c9695e$var$RD;
var $aec35899a3c9695e$var$li = {};
Object.defineProperty($aec35899a3c9695e$var$li, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$li.validateSkeletonSearchActor = $aec35899a3c9695e$var$li.isSkeletonSearchActor = $aec35899a3c9695e$var$li.validateSkeletonSearchPost = $aec35899a3c9695e$var$li.isSkeletonSearchPost = void 0;
const $aec35899a3c9695e$var$Cu = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$H0 = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$AD(t) {
    return (0, $aec35899a3c9695e$var$Cu.isObj)(t) && (0, $aec35899a3c9695e$var$Cu.hasProp)(t, "$type") && t.$type === "app.bsky.unspecced.defs#skeletonSearchPost";
}
$aec35899a3c9695e$var$li.isSkeletonSearchPost = $aec35899a3c9695e$var$AD;
function $aec35899a3c9695e$var$_D(t) {
    return $aec35899a3c9695e$var$H0.lexicons.validate("app.bsky.unspecced.defs#skeletonSearchPost", t);
}
$aec35899a3c9695e$var$li.validateSkeletonSearchPost = $aec35899a3c9695e$var$_D;
function $aec35899a3c9695e$var$wD(t) {
    return (0, $aec35899a3c9695e$var$Cu.isObj)(t) && (0, $aec35899a3c9695e$var$Cu.hasProp)(t, "$type") && t.$type === "app.bsky.unspecced.defs#skeletonSearchActor";
}
$aec35899a3c9695e$var$li.isSkeletonSearchActor = $aec35899a3c9695e$var$wD;
function $aec35899a3c9695e$var$TD(t) {
    return $aec35899a3c9695e$var$H0.lexicons.validate("app.bsky.unspecced.defs#skeletonSearchActor", t);
}
$aec35899a3c9695e$var$li.validateSkeletonSearchActor = $aec35899a3c9695e$var$TD;
var $aec35899a3c9695e$var$Ms = {};
Object.defineProperty($aec35899a3c9695e$var$Ms, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ms.validateRecord = $aec35899a3c9695e$var$Ms.isRecord = void 0;
const $aec35899a3c9695e$var$cf = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$SD = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$CD(t) {
    return (0, $aec35899a3c9695e$var$cf.isObj)(t) && (0, $aec35899a3c9695e$var$cf.hasProp)(t, "$type") && (t.$type === "chat.bsky.actor.declaration#main" || t.$type === "chat.bsky.actor.declaration");
}
$aec35899a3c9695e$var$Ms.isRecord = $aec35899a3c9695e$var$CD;
function $aec35899a3c9695e$var$LD(t) {
    return $aec35899a3c9695e$var$SD.lexicons.validate("chat.bsky.actor.declaration#main", t);
}
$aec35899a3c9695e$var$Ms.validateRecord = $aec35899a3c9695e$var$LD;
var $aec35899a3c9695e$var$Ns = {};
Object.defineProperty($aec35899a3c9695e$var$Ns, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ns.validateProfileViewBasic = $aec35899a3c9695e$var$Ns.isProfileViewBasic = void 0;
const $aec35899a3c9695e$var$df = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$kD = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$DD(t) {
    return (0, $aec35899a3c9695e$var$df.isObj)(t) && (0, $aec35899a3c9695e$var$df.hasProp)(t, "$type") && t.$type === "chat.bsky.actor.defs#profileViewBasic";
}
$aec35899a3c9695e$var$Ns.isProfileViewBasic = $aec35899a3c9695e$var$DD;
function $aec35899a3c9695e$var$PD(t) {
    return $aec35899a3c9695e$var$kD.lexicons.validate("chat.bsky.actor.defs#profileViewBasic", t);
}
$aec35899a3c9695e$var$Ns.validateProfileViewBasic = $aec35899a3c9695e$var$PD;
var $aec35899a3c9695e$var$Ke = {};
Object.defineProperty($aec35899a3c9695e$var$Ke, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ke.validateLogDeleteMessage = $aec35899a3c9695e$var$Ke.isLogDeleteMessage = $aec35899a3c9695e$var$Ke.validateLogCreateMessage = $aec35899a3c9695e$var$Ke.isLogCreateMessage = $aec35899a3c9695e$var$Ke.validateLogLeaveConvo = $aec35899a3c9695e$var$Ke.isLogLeaveConvo = $aec35899a3c9695e$var$Ke.validateLogBeginConvo = $aec35899a3c9695e$var$Ke.isLogBeginConvo = $aec35899a3c9695e$var$Ke.validateConvoView = $aec35899a3c9695e$var$Ke.isConvoView = $aec35899a3c9695e$var$Ke.validateMessageViewSender = $aec35899a3c9695e$var$Ke.isMessageViewSender = $aec35899a3c9695e$var$Ke.validateDeletedMessageView = $aec35899a3c9695e$var$Ke.isDeletedMessageView = $aec35899a3c9695e$var$Ke.validateMessageView = $aec35899a3c9695e$var$Ke.isMessageView = $aec35899a3c9695e$var$Ke.validateMessageInput = $aec35899a3c9695e$var$Ke.isMessageInput = $aec35899a3c9695e$var$Ke.validateMessageRef = $aec35899a3c9695e$var$Ke.isMessageRef = void 0;
const $aec35899a3c9695e$var$St = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$Ai = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$BD(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#messageRef";
}
$aec35899a3c9695e$var$Ke.isMessageRef = $aec35899a3c9695e$var$BD;
function $aec35899a3c9695e$var$ID(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#messageRef", t);
}
$aec35899a3c9695e$var$Ke.validateMessageRef = $aec35899a3c9695e$var$ID;
function $aec35899a3c9695e$var$UD(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#messageInput";
}
$aec35899a3c9695e$var$Ke.isMessageInput = $aec35899a3c9695e$var$UD;
function $aec35899a3c9695e$var$OD(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#messageInput", t);
}
$aec35899a3c9695e$var$Ke.validateMessageInput = $aec35899a3c9695e$var$OD;
function $aec35899a3c9695e$var$KD(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#messageView";
}
$aec35899a3c9695e$var$Ke.isMessageView = $aec35899a3c9695e$var$KD;
function $aec35899a3c9695e$var$MD(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#messageView", t);
}
$aec35899a3c9695e$var$Ke.validateMessageView = $aec35899a3c9695e$var$MD;
function $aec35899a3c9695e$var$ND(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#deletedMessageView";
}
$aec35899a3c9695e$var$Ke.isDeletedMessageView = $aec35899a3c9695e$var$ND;
function $aec35899a3c9695e$var$VD(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#deletedMessageView", t);
}
$aec35899a3c9695e$var$Ke.validateDeletedMessageView = $aec35899a3c9695e$var$VD;
function $aec35899a3c9695e$var$jD(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#messageViewSender";
}
$aec35899a3c9695e$var$Ke.isMessageViewSender = $aec35899a3c9695e$var$jD;
function $aec35899a3c9695e$var$FD(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#messageViewSender", t);
}
$aec35899a3c9695e$var$Ke.validateMessageViewSender = $aec35899a3c9695e$var$FD;
function $aec35899a3c9695e$var$$D(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#convoView";
}
$aec35899a3c9695e$var$Ke.isConvoView = $aec35899a3c9695e$var$$D;
function $aec35899a3c9695e$var$GD(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#convoView", t);
}
$aec35899a3c9695e$var$Ke.validateConvoView = $aec35899a3c9695e$var$GD;
function $aec35899a3c9695e$var$qD(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#logBeginConvo";
}
$aec35899a3c9695e$var$Ke.isLogBeginConvo = $aec35899a3c9695e$var$qD;
function $aec35899a3c9695e$var$zD(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#logBeginConvo", t);
}
$aec35899a3c9695e$var$Ke.validateLogBeginConvo = $aec35899a3c9695e$var$zD;
function $aec35899a3c9695e$var$XD(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#logLeaveConvo";
}
$aec35899a3c9695e$var$Ke.isLogLeaveConvo = $aec35899a3c9695e$var$XD;
function $aec35899a3c9695e$var$HD(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#logLeaveConvo", t);
}
$aec35899a3c9695e$var$Ke.validateLogLeaveConvo = $aec35899a3c9695e$var$HD;
function $aec35899a3c9695e$var$ZD(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#logCreateMessage";
}
$aec35899a3c9695e$var$Ke.isLogCreateMessage = $aec35899a3c9695e$var$ZD;
function $aec35899a3c9695e$var$WD(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#logCreateMessage", t);
}
$aec35899a3c9695e$var$Ke.validateLogCreateMessage = $aec35899a3c9695e$var$WD;
function $aec35899a3c9695e$var$YD(t) {
    return (0, $aec35899a3c9695e$var$St.isObj)(t) && (0, $aec35899a3c9695e$var$St.hasProp)(t, "$type") && t.$type === "chat.bsky.convo.defs#logDeleteMessage";
}
$aec35899a3c9695e$var$Ke.isLogDeleteMessage = $aec35899a3c9695e$var$YD;
function $aec35899a3c9695e$var$JD(t) {
    return $aec35899a3c9695e$var$Ai.lexicons.validate("chat.bsky.convo.defs#logDeleteMessage", t);
}
$aec35899a3c9695e$var$Ke.validateLogDeleteMessage = $aec35899a3c9695e$var$JD;
var $aec35899a3c9695e$var$Vs = {};
Object.defineProperty($aec35899a3c9695e$var$Vs, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Vs.validateTemplateView = $aec35899a3c9695e$var$Vs.isTemplateView = void 0;
const $aec35899a3c9695e$var$ff = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$QD = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$eP(t) {
    return (0, $aec35899a3c9695e$var$ff.isObj)(t) && (0, $aec35899a3c9695e$var$ff.hasProp)(t, "$type") && t.$type === "tools.ozone.communication.defs#templateView";
}
$aec35899a3c9695e$var$Vs.isTemplateView = $aec35899a3c9695e$var$eP;
function $aec35899a3c9695e$var$tP(t) {
    return $aec35899a3c9695e$var$QD.lexicons.validate("tools.ozone.communication.defs#templateView", t);
}
$aec35899a3c9695e$var$Vs.validateTemplateView = $aec35899a3c9695e$var$tP;
var $aec35899a3c9695e$var$W = {};
Object.defineProperty($aec35899a3c9695e$var$W, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$W.validateRecordViewDetail = $aec35899a3c9695e$var$W.isRecordViewDetail = $aec35899a3c9695e$var$W.validateRecordView = $aec35899a3c9695e$var$W.isRecordView = $aec35899a3c9695e$var$W.validateRepoViewNotFound = $aec35899a3c9695e$var$W.isRepoViewNotFound = $aec35899a3c9695e$var$W.validateRepoViewDetail = $aec35899a3c9695e$var$W.isRepoViewDetail = $aec35899a3c9695e$var$W.validateRepoView = $aec35899a3c9695e$var$W.isRepoView = $aec35899a3c9695e$var$W.validateModEventTag = $aec35899a3c9695e$var$W.isModEventTag = $aec35899a3c9695e$var$W.validateModEventDivert = $aec35899a3c9695e$var$W.isModEventDivert = $aec35899a3c9695e$var$W.validateModEventEmail = $aec35899a3c9695e$var$W.isModEventEmail = $aec35899a3c9695e$var$W.validateModEventUnmuteReporter = $aec35899a3c9695e$var$W.isModEventUnmuteReporter = $aec35899a3c9695e$var$W.validateModEventMuteReporter = $aec35899a3c9695e$var$W.isModEventMuteReporter = $aec35899a3c9695e$var$W.validateModEventUnmute = $aec35899a3c9695e$var$W.isModEventUnmute = $aec35899a3c9695e$var$W.validateModEventMute = $aec35899a3c9695e$var$W.isModEventMute = $aec35899a3c9695e$var$W.validateModEventEscalate = $aec35899a3c9695e$var$W.isModEventEscalate = $aec35899a3c9695e$var$W.validateModEventAcknowledge = $aec35899a3c9695e$var$W.isModEventAcknowledge = $aec35899a3c9695e$var$W.validateModEventLabel = $aec35899a3c9695e$var$W.isModEventLabel = $aec35899a3c9695e$var$W.validateModEventReport = $aec35899a3c9695e$var$W.isModEventReport = $aec35899a3c9695e$var$W.validateModEventComment = $aec35899a3c9695e$var$W.isModEventComment = $aec35899a3c9695e$var$W.validateModEventResolveAppeal = $aec35899a3c9695e$var$W.isModEventResolveAppeal = $aec35899a3c9695e$var$W.validateModEventReverseTakedown = $aec35899a3c9695e$var$W.isModEventReverseTakedown = $aec35899a3c9695e$var$W.validateModEventTakedown = $aec35899a3c9695e$var$W.isModEventTakedown = $aec35899a3c9695e$var$W.REVIEWNONE = $aec35899a3c9695e$var$W.REVIEWCLOSED = $aec35899a3c9695e$var$W.REVIEWESCALATED = $aec35899a3c9695e$var$W.REVIEWOPEN = $aec35899a3c9695e$var$W.validateSubjectStatusView = $aec35899a3c9695e$var$W.isSubjectStatusView = $aec35899a3c9695e$var$W.validateModEventViewDetail = $aec35899a3c9695e$var$W.isModEventViewDetail = $aec35899a3c9695e$var$W.validateModEventView = $aec35899a3c9695e$var$W.isModEventView = void 0;
$aec35899a3c9695e$var$W.validateVideoDetails = $aec35899a3c9695e$var$W.isVideoDetails = $aec35899a3c9695e$var$W.validateImageDetails = $aec35899a3c9695e$var$W.isImageDetails = $aec35899a3c9695e$var$W.validateBlobView = $aec35899a3c9695e$var$W.isBlobView = $aec35899a3c9695e$var$W.validateModerationDetail = $aec35899a3c9695e$var$W.isModerationDetail = $aec35899a3c9695e$var$W.validateModeration = $aec35899a3c9695e$var$W.isModeration = $aec35899a3c9695e$var$W.validateRecordViewNotFound = $aec35899a3c9695e$var$W.isRecordViewNotFound = void 0;
const $aec35899a3c9695e$var$Re = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$et = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$rP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventView";
}
$aec35899a3c9695e$var$W.isModEventView = $aec35899a3c9695e$var$rP;
function $aec35899a3c9695e$var$iP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventView", t);
}
$aec35899a3c9695e$var$W.validateModEventView = $aec35899a3c9695e$var$iP;
function $aec35899a3c9695e$var$nP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventViewDetail";
}
$aec35899a3c9695e$var$W.isModEventViewDetail = $aec35899a3c9695e$var$nP;
function $aec35899a3c9695e$var$sP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventViewDetail", t);
}
$aec35899a3c9695e$var$W.validateModEventViewDetail = $aec35899a3c9695e$var$sP;
function $aec35899a3c9695e$var$aP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#subjectStatusView";
}
$aec35899a3c9695e$var$W.isSubjectStatusView = $aec35899a3c9695e$var$aP;
function $aec35899a3c9695e$var$oP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#subjectStatusView", t);
}
$aec35899a3c9695e$var$W.validateSubjectStatusView = $aec35899a3c9695e$var$oP;
$aec35899a3c9695e$var$W.REVIEWOPEN = "tools.ozone.moderation.defs#reviewOpen";
$aec35899a3c9695e$var$W.REVIEWESCALATED = "tools.ozone.moderation.defs#reviewEscalated";
$aec35899a3c9695e$var$W.REVIEWCLOSED = "tools.ozone.moderation.defs#reviewClosed";
$aec35899a3c9695e$var$W.REVIEWNONE = "tools.ozone.moderation.defs#reviewNone";
function $aec35899a3c9695e$var$lP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventTakedown";
}
$aec35899a3c9695e$var$W.isModEventTakedown = $aec35899a3c9695e$var$lP;
function $aec35899a3c9695e$var$uP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventTakedown", t);
}
$aec35899a3c9695e$var$W.validateModEventTakedown = $aec35899a3c9695e$var$uP;
function $aec35899a3c9695e$var$cP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventReverseTakedown";
}
$aec35899a3c9695e$var$W.isModEventReverseTakedown = $aec35899a3c9695e$var$cP;
function $aec35899a3c9695e$var$dP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventReverseTakedown", t);
}
$aec35899a3c9695e$var$W.validateModEventReverseTakedown = $aec35899a3c9695e$var$dP;
function $aec35899a3c9695e$var$fP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventResolveAppeal";
}
$aec35899a3c9695e$var$W.isModEventResolveAppeal = $aec35899a3c9695e$var$fP;
function $aec35899a3c9695e$var$pP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventResolveAppeal", t);
}
$aec35899a3c9695e$var$W.validateModEventResolveAppeal = $aec35899a3c9695e$var$pP;
function $aec35899a3c9695e$var$hP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventComment";
}
$aec35899a3c9695e$var$W.isModEventComment = $aec35899a3c9695e$var$hP;
function $aec35899a3c9695e$var$mP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventComment", t);
}
$aec35899a3c9695e$var$W.validateModEventComment = $aec35899a3c9695e$var$mP;
function $aec35899a3c9695e$var$yP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventReport";
}
$aec35899a3c9695e$var$W.isModEventReport = $aec35899a3c9695e$var$yP;
function $aec35899a3c9695e$var$bP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventReport", t);
}
$aec35899a3c9695e$var$W.validateModEventReport = $aec35899a3c9695e$var$bP;
function $aec35899a3c9695e$var$gP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventLabel";
}
$aec35899a3c9695e$var$W.isModEventLabel = $aec35899a3c9695e$var$gP;
function $aec35899a3c9695e$var$xP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventLabel", t);
}
$aec35899a3c9695e$var$W.validateModEventLabel = $aec35899a3c9695e$var$xP;
function $aec35899a3c9695e$var$EP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventAcknowledge";
}
$aec35899a3c9695e$var$W.isModEventAcknowledge = $aec35899a3c9695e$var$EP;
function $aec35899a3c9695e$var$vP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventAcknowledge", t);
}
$aec35899a3c9695e$var$W.validateModEventAcknowledge = $aec35899a3c9695e$var$vP;
function $aec35899a3c9695e$var$RP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventEscalate";
}
$aec35899a3c9695e$var$W.isModEventEscalate = $aec35899a3c9695e$var$RP;
function $aec35899a3c9695e$var$AP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventEscalate", t);
}
$aec35899a3c9695e$var$W.validateModEventEscalate = $aec35899a3c9695e$var$AP;
function $aec35899a3c9695e$var$_P(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventMute";
}
$aec35899a3c9695e$var$W.isModEventMute = $aec35899a3c9695e$var$_P;
function $aec35899a3c9695e$var$wP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventMute", t);
}
$aec35899a3c9695e$var$W.validateModEventMute = $aec35899a3c9695e$var$wP;
function $aec35899a3c9695e$var$TP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventUnmute";
}
$aec35899a3c9695e$var$W.isModEventUnmute = $aec35899a3c9695e$var$TP;
function $aec35899a3c9695e$var$SP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventUnmute", t);
}
$aec35899a3c9695e$var$W.validateModEventUnmute = $aec35899a3c9695e$var$SP;
function $aec35899a3c9695e$var$CP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventMuteReporter";
}
$aec35899a3c9695e$var$W.isModEventMuteReporter = $aec35899a3c9695e$var$CP;
function $aec35899a3c9695e$var$LP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventMuteReporter", t);
}
$aec35899a3c9695e$var$W.validateModEventMuteReporter = $aec35899a3c9695e$var$LP;
function $aec35899a3c9695e$var$kP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventUnmuteReporter";
}
$aec35899a3c9695e$var$W.isModEventUnmuteReporter = $aec35899a3c9695e$var$kP;
function $aec35899a3c9695e$var$DP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventUnmuteReporter", t);
}
$aec35899a3c9695e$var$W.validateModEventUnmuteReporter = $aec35899a3c9695e$var$DP;
function $aec35899a3c9695e$var$PP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventEmail";
}
$aec35899a3c9695e$var$W.isModEventEmail = $aec35899a3c9695e$var$PP;
function $aec35899a3c9695e$var$BP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventEmail", t);
}
$aec35899a3c9695e$var$W.validateModEventEmail = $aec35899a3c9695e$var$BP;
function $aec35899a3c9695e$var$IP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventDivert";
}
$aec35899a3c9695e$var$W.isModEventDivert = $aec35899a3c9695e$var$IP;
function $aec35899a3c9695e$var$UP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventDivert", t);
}
$aec35899a3c9695e$var$W.validateModEventDivert = $aec35899a3c9695e$var$UP;
function $aec35899a3c9695e$var$OP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#modEventTag";
}
$aec35899a3c9695e$var$W.isModEventTag = $aec35899a3c9695e$var$OP;
function $aec35899a3c9695e$var$KP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#modEventTag", t);
}
$aec35899a3c9695e$var$W.validateModEventTag = $aec35899a3c9695e$var$KP;
function $aec35899a3c9695e$var$MP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#repoView";
}
$aec35899a3c9695e$var$W.isRepoView = $aec35899a3c9695e$var$MP;
function $aec35899a3c9695e$var$NP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#repoView", t);
}
$aec35899a3c9695e$var$W.validateRepoView = $aec35899a3c9695e$var$NP;
function $aec35899a3c9695e$var$VP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#repoViewDetail";
}
$aec35899a3c9695e$var$W.isRepoViewDetail = $aec35899a3c9695e$var$VP;
function $aec35899a3c9695e$var$jP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#repoViewDetail", t);
}
$aec35899a3c9695e$var$W.validateRepoViewDetail = $aec35899a3c9695e$var$jP;
function $aec35899a3c9695e$var$FP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#repoViewNotFound";
}
$aec35899a3c9695e$var$W.isRepoViewNotFound = $aec35899a3c9695e$var$FP;
function $aec35899a3c9695e$var$$P(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#repoViewNotFound", t);
}
$aec35899a3c9695e$var$W.validateRepoViewNotFound = $aec35899a3c9695e$var$$P;
function $aec35899a3c9695e$var$GP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#recordView";
}
$aec35899a3c9695e$var$W.isRecordView = $aec35899a3c9695e$var$GP;
function $aec35899a3c9695e$var$qP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#recordView", t);
}
$aec35899a3c9695e$var$W.validateRecordView = $aec35899a3c9695e$var$qP;
function $aec35899a3c9695e$var$zP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#recordViewDetail";
}
$aec35899a3c9695e$var$W.isRecordViewDetail = $aec35899a3c9695e$var$zP;
function $aec35899a3c9695e$var$XP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#recordViewDetail", t);
}
$aec35899a3c9695e$var$W.validateRecordViewDetail = $aec35899a3c9695e$var$XP;
function $aec35899a3c9695e$var$HP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#recordViewNotFound";
}
$aec35899a3c9695e$var$W.isRecordViewNotFound = $aec35899a3c9695e$var$HP;
function $aec35899a3c9695e$var$ZP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#recordViewNotFound", t);
}
$aec35899a3c9695e$var$W.validateRecordViewNotFound = $aec35899a3c9695e$var$ZP;
function $aec35899a3c9695e$var$WP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#moderation";
}
$aec35899a3c9695e$var$W.isModeration = $aec35899a3c9695e$var$WP;
function $aec35899a3c9695e$var$YP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#moderation", t);
}
$aec35899a3c9695e$var$W.validateModeration = $aec35899a3c9695e$var$YP;
function $aec35899a3c9695e$var$JP(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#moderationDetail";
}
$aec35899a3c9695e$var$W.isModerationDetail = $aec35899a3c9695e$var$JP;
function $aec35899a3c9695e$var$QP(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#moderationDetail", t);
}
$aec35899a3c9695e$var$W.validateModerationDetail = $aec35899a3c9695e$var$QP;
function $aec35899a3c9695e$var$eB(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#blobView";
}
$aec35899a3c9695e$var$W.isBlobView = $aec35899a3c9695e$var$eB;
function $aec35899a3c9695e$var$tB(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#blobView", t);
}
$aec35899a3c9695e$var$W.validateBlobView = $aec35899a3c9695e$var$tB;
function $aec35899a3c9695e$var$rB(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#imageDetails";
}
$aec35899a3c9695e$var$W.isImageDetails = $aec35899a3c9695e$var$rB;
function $aec35899a3c9695e$var$iB(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#imageDetails", t);
}
$aec35899a3c9695e$var$W.validateImageDetails = $aec35899a3c9695e$var$iB;
function $aec35899a3c9695e$var$nB(t) {
    return (0, $aec35899a3c9695e$var$Re.isObj)(t) && (0, $aec35899a3c9695e$var$Re.hasProp)(t, "$type") && t.$type === "tools.ozone.moderation.defs#videoDetails";
}
$aec35899a3c9695e$var$W.isVideoDetails = $aec35899a3c9695e$var$nB;
function $aec35899a3c9695e$var$sB(t) {
    return $aec35899a3c9695e$var$et.lexicons.validate("tools.ozone.moderation.defs#videoDetails", t);
}
$aec35899a3c9695e$var$W.validateVideoDetails = $aec35899a3c9695e$var$sB;
var $aec35899a3c9695e$var$Dr = {};
Object.defineProperty($aec35899a3c9695e$var$Dr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Dr.ROLETRIAGE = $aec35899a3c9695e$var$Dr.ROLEMODERATOR = $aec35899a3c9695e$var$Dr.ROLEADMIN = $aec35899a3c9695e$var$Dr.validateMember = $aec35899a3c9695e$var$Dr.isMember = void 0;
const $aec35899a3c9695e$var$pf = $aec35899a3c9695e$var$_e, $aec35899a3c9695e$var$aB = $aec35899a3c9695e$var$Le;
function $aec35899a3c9695e$var$oB(t) {
    return (0, $aec35899a3c9695e$var$pf.isObj)(t) && (0, $aec35899a3c9695e$var$pf.hasProp)(t, "$type") && t.$type === "tools.ozone.team.defs#member";
}
$aec35899a3c9695e$var$Dr.isMember = $aec35899a3c9695e$var$oB;
function $aec35899a3c9695e$var$lB(t) {
    return $aec35899a3c9695e$var$aB.lexicons.validate("tools.ozone.team.defs#member", t);
}
$aec35899a3c9695e$var$Dr.validateMember = $aec35899a3c9695e$var$lB;
$aec35899a3c9695e$var$Dr.ROLEADMIN = "tools.ozone.team.defs#roleAdmin";
$aec35899a3c9695e$var$Dr.ROLEMODERATOR = "tools.ozone.team.defs#roleModerator";
$aec35899a3c9695e$var$Dr.ROLETRIAGE = "tools.ozone.team.defs#roleTriage";
var $aec35899a3c9695e$var$uB = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(t, e, r, i) {
    i === void 0 && (i = r);
    var a = Object.getOwnPropertyDescriptor(e, r);
    (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    }), Object.defineProperty(t, i, a);
} : function(t, e, r, i) {
    i === void 0 && (i = r), t[i] = e[r];
}), $aec35899a3c9695e$var$cB = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
}), $aec35899a3c9695e$var$_ = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importStar || function(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (t != null) for(var r in t)r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && $aec35899a3c9695e$var$uB(e, t, r);
    return $aec35899a3c9695e$var$cB(e, t), e;
};
Object.defineProperty($aec35899a3c9695e$var$x, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$x.ComAtprotoServerDescribeServer = $aec35899a3c9695e$var$x.ComAtprotoServerDeleteSession = $aec35899a3c9695e$var$x.ComAtprotoServerDeleteAccount = $aec35899a3c9695e$var$x.ComAtprotoServerDefs = $aec35899a3c9695e$var$x.ComAtprotoServerDeactivateAccount = $aec35899a3c9695e$var$x.ComAtprotoServerCreateSession = $aec35899a3c9695e$var$x.ComAtprotoServerCreateInviteCodes = $aec35899a3c9695e$var$x.ComAtprotoServerCreateInviteCode = $aec35899a3c9695e$var$x.ComAtprotoServerCreateAppPassword = $aec35899a3c9695e$var$x.ComAtprotoServerCreateAccount = $aec35899a3c9695e$var$x.ComAtprotoServerConfirmEmail = $aec35899a3c9695e$var$x.ComAtprotoServerCheckAccountStatus = $aec35899a3c9695e$var$x.ComAtprotoServerActivateAccount = $aec35899a3c9695e$var$x.ComAtprotoRepoUploadBlob = $aec35899a3c9695e$var$x.ComAtprotoRepoStrongRef = $aec35899a3c9695e$var$x.ComAtprotoRepoPutRecord = $aec35899a3c9695e$var$x.ComAtprotoRepoListRecords = $aec35899a3c9695e$var$x.ComAtprotoRepoListMissingBlobs = $aec35899a3c9695e$var$x.ComAtprotoRepoImportRepo = $aec35899a3c9695e$var$x.ComAtprotoRepoGetRecord = $aec35899a3c9695e$var$x.ComAtprotoRepoDescribeRepo = $aec35899a3c9695e$var$x.ComAtprotoRepoDeleteRecord = $aec35899a3c9695e$var$x.ComAtprotoRepoCreateRecord = $aec35899a3c9695e$var$x.ComAtprotoRepoApplyWrites = $aec35899a3c9695e$var$x.ComAtprotoModerationDefs = $aec35899a3c9695e$var$x.ComAtprotoModerationCreateReport = $aec35899a3c9695e$var$x.ComAtprotoLabelSubscribeLabels = $aec35899a3c9695e$var$x.ComAtprotoLabelQueryLabels = $aec35899a3c9695e$var$x.ComAtprotoLabelDefs = $aec35899a3c9695e$var$x.ComAtprotoIdentityUpdateHandle = $aec35899a3c9695e$var$x.ComAtprotoIdentitySubmitPlcOperation = $aec35899a3c9695e$var$x.ComAtprotoIdentitySignPlcOperation = $aec35899a3c9695e$var$x.ComAtprotoIdentityResolveHandle = $aec35899a3c9695e$var$x.ComAtprotoIdentityRequestPlcOperationSignature = $aec35899a3c9695e$var$x.ComAtprotoIdentityGetRecommendedDidCredentials = $aec35899a3c9695e$var$x.ComAtprotoAdminUpdateSubjectStatus = $aec35899a3c9695e$var$x.ComAtprotoAdminUpdateAccountPassword = $aec35899a3c9695e$var$x.ComAtprotoAdminUpdateAccountHandle = $aec35899a3c9695e$var$x.ComAtprotoAdminUpdateAccountEmail = $aec35899a3c9695e$var$x.ComAtprotoAdminSendEmail = $aec35899a3c9695e$var$x.ComAtprotoAdminSearchAccounts = $aec35899a3c9695e$var$x.ComAtprotoAdminGetSubjectStatus = $aec35899a3c9695e$var$x.ComAtprotoAdminGetInviteCodes = $aec35899a3c9695e$var$x.ComAtprotoAdminGetAccountInfos = $aec35899a3c9695e$var$x.ComAtprotoAdminGetAccountInfo = $aec35899a3c9695e$var$x.ComAtprotoAdminEnableAccountInvites = $aec35899a3c9695e$var$x.ComAtprotoAdminDisableInviteCodes = $aec35899a3c9695e$var$x.ComAtprotoAdminDisableAccountInvites = $aec35899a3c9695e$var$x.ComAtprotoAdminDeleteAccount = $aec35899a3c9695e$var$x.ComAtprotoAdminDefs = void 0;
$aec35899a3c9695e$var$x.AppBskyFeedGetFeedGenerator = $aec35899a3c9695e$var$x.AppBskyFeedGetFeed = $aec35899a3c9695e$var$x.AppBskyFeedGetAuthorFeed = $aec35899a3c9695e$var$x.AppBskyFeedGetActorLikes = $aec35899a3c9695e$var$x.AppBskyFeedGetActorFeeds = $aec35899a3c9695e$var$x.AppBskyFeedGenerator = $aec35899a3c9695e$var$x.AppBskyFeedDescribeFeedGenerator = $aec35899a3c9695e$var$x.AppBskyFeedDefs = $aec35899a3c9695e$var$x.AppBskyEmbedRecordWithMedia = $aec35899a3c9695e$var$x.AppBskyEmbedRecord = $aec35899a3c9695e$var$x.AppBskyEmbedImages = $aec35899a3c9695e$var$x.AppBskyEmbedExternal = $aec35899a3c9695e$var$x.AppBskyActorSearchActorsTypeahead = $aec35899a3c9695e$var$x.AppBskyActorSearchActors = $aec35899a3c9695e$var$x.AppBskyActorPutPreferences = $aec35899a3c9695e$var$x.AppBskyActorProfile = $aec35899a3c9695e$var$x.AppBskyActorGetSuggestions = $aec35899a3c9695e$var$x.AppBskyActorGetProfiles = $aec35899a3c9695e$var$x.AppBskyActorGetProfile = $aec35899a3c9695e$var$x.AppBskyActorGetPreferences = $aec35899a3c9695e$var$x.AppBskyActorDefs = $aec35899a3c9695e$var$x.ComAtprotoTempRequestPhoneVerification = $aec35899a3c9695e$var$x.ComAtprotoTempFetchLabels = $aec35899a3c9695e$var$x.ComAtprotoTempCheckSignupQueue = $aec35899a3c9695e$var$x.ComAtprotoSyncSubscribeRepos = $aec35899a3c9695e$var$x.ComAtprotoSyncRequestCrawl = $aec35899a3c9695e$var$x.ComAtprotoSyncNotifyOfUpdate = $aec35899a3c9695e$var$x.ComAtprotoSyncListRepos = $aec35899a3c9695e$var$x.ComAtprotoSyncListBlobs = $aec35899a3c9695e$var$x.ComAtprotoSyncGetRepoStatus = $aec35899a3c9695e$var$x.ComAtprotoSyncGetRepo = $aec35899a3c9695e$var$x.ComAtprotoSyncGetRecord = $aec35899a3c9695e$var$x.ComAtprotoSyncGetLatestCommit = $aec35899a3c9695e$var$x.ComAtprotoSyncGetHead = $aec35899a3c9695e$var$x.ComAtprotoSyncGetCheckout = $aec35899a3c9695e$var$x.ComAtprotoSyncGetBlocks = $aec35899a3c9695e$var$x.ComAtprotoSyncGetBlob = $aec35899a3c9695e$var$x.ComAtprotoServerUpdateEmail = $aec35899a3c9695e$var$x.ComAtprotoServerRevokeAppPassword = $aec35899a3c9695e$var$x.ComAtprotoServerResetPassword = $aec35899a3c9695e$var$x.ComAtprotoServerReserveSigningKey = $aec35899a3c9695e$var$x.ComAtprotoServerRequestPasswordReset = $aec35899a3c9695e$var$x.ComAtprotoServerRequestEmailUpdate = $aec35899a3c9695e$var$x.ComAtprotoServerRequestEmailConfirmation = $aec35899a3c9695e$var$x.ComAtprotoServerRequestAccountDelete = $aec35899a3c9695e$var$x.ComAtprotoServerRefreshSession = $aec35899a3c9695e$var$x.ComAtprotoServerListAppPasswords = $aec35899a3c9695e$var$x.ComAtprotoServerGetSession = $aec35899a3c9695e$var$x.ComAtprotoServerGetServiceAuth = $aec35899a3c9695e$var$x.ComAtprotoServerGetAccountInviteCodes = void 0;
$aec35899a3c9695e$var$x.AppBskyNotificationUpdateSeen = $aec35899a3c9695e$var$x.AppBskyNotificationRegisterPush = $aec35899a3c9695e$var$x.AppBskyNotificationPutPreferences = $aec35899a3c9695e$var$x.AppBskyNotificationListNotifications = $aec35899a3c9695e$var$x.AppBskyNotificationGetUnreadCount = $aec35899a3c9695e$var$x.AppBskyLabelerService = $aec35899a3c9695e$var$x.AppBskyLabelerGetServices = $aec35899a3c9695e$var$x.AppBskyLabelerDefs = $aec35899a3c9695e$var$x.AppBskyGraphUnmuteThread = $aec35899a3c9695e$var$x.AppBskyGraphUnmuteActorList = $aec35899a3c9695e$var$x.AppBskyGraphUnmuteActor = $aec35899a3c9695e$var$x.AppBskyGraphStarterpack = $aec35899a3c9695e$var$x.AppBskyGraphMuteThread = $aec35899a3c9695e$var$x.AppBskyGraphMuteActorList = $aec35899a3c9695e$var$x.AppBskyGraphMuteActor = $aec35899a3c9695e$var$x.AppBskyGraphListitem = $aec35899a3c9695e$var$x.AppBskyGraphListblock = $aec35899a3c9695e$var$x.AppBskyGraphList = $aec35899a3c9695e$var$x.AppBskyGraphGetSuggestedFollowsByActor = $aec35899a3c9695e$var$x.AppBskyGraphGetStarterPacks = $aec35899a3c9695e$var$x.AppBskyGraphGetStarterPack = $aec35899a3c9695e$var$x.AppBskyGraphGetRelationships = $aec35899a3c9695e$var$x.AppBskyGraphGetMutes = $aec35899a3c9695e$var$x.AppBskyGraphGetLists = $aec35899a3c9695e$var$x.AppBskyGraphGetListMutes = $aec35899a3c9695e$var$x.AppBskyGraphGetListBlocks = $aec35899a3c9695e$var$x.AppBskyGraphGetList = $aec35899a3c9695e$var$x.AppBskyGraphGetKnownFollowers = $aec35899a3c9695e$var$x.AppBskyGraphGetFollows = $aec35899a3c9695e$var$x.AppBskyGraphGetFollowers = $aec35899a3c9695e$var$x.AppBskyGraphGetBlocks = $aec35899a3c9695e$var$x.AppBskyGraphGetActorStarterPacks = $aec35899a3c9695e$var$x.AppBskyGraphFollow = $aec35899a3c9695e$var$x.AppBskyGraphDefs = $aec35899a3c9695e$var$x.AppBskyGraphBlock = $aec35899a3c9695e$var$x.AppBskyFeedThreadgate = $aec35899a3c9695e$var$x.AppBskyFeedSendInteractions = $aec35899a3c9695e$var$x.AppBskyFeedSearchPosts = $aec35899a3c9695e$var$x.AppBskyFeedRepost = $aec35899a3c9695e$var$x.AppBskyFeedPost = $aec35899a3c9695e$var$x.AppBskyFeedLike = $aec35899a3c9695e$var$x.AppBskyFeedGetTimeline = $aec35899a3c9695e$var$x.AppBskyFeedGetSuggestedFeeds = $aec35899a3c9695e$var$x.AppBskyFeedGetRepostedBy = $aec35899a3c9695e$var$x.AppBskyFeedGetPosts = $aec35899a3c9695e$var$x.AppBskyFeedGetPostThread = $aec35899a3c9695e$var$x.AppBskyFeedGetListFeed = $aec35899a3c9695e$var$x.AppBskyFeedGetLikes = $aec35899a3c9695e$var$x.AppBskyFeedGetFeedSkeleton = $aec35899a3c9695e$var$x.AppBskyFeedGetFeedGenerators = void 0;
$aec35899a3c9695e$var$x.TOOLS_OZONE_MODERATION = $aec35899a3c9695e$var$x.APP_BSKY_GRAPH = $aec35899a3c9695e$var$x.APP_BSKY_FEED = $aec35899a3c9695e$var$x.COM_ATPROTO_MODERATION = $aec35899a3c9695e$var$x.ToolsOzoneTeamUpdateMember = $aec35899a3c9695e$var$x.ToolsOzoneTeamListMembers = $aec35899a3c9695e$var$x.ToolsOzoneTeamDeleteMember = $aec35899a3c9695e$var$x.ToolsOzoneTeamDefs = $aec35899a3c9695e$var$x.ToolsOzoneTeamAddMember = $aec35899a3c9695e$var$x.ToolsOzoneServerGetConfig = $aec35899a3c9695e$var$x.ToolsOzoneModerationSearchRepos = $aec35899a3c9695e$var$x.ToolsOzoneModerationQueryStatuses = $aec35899a3c9695e$var$x.ToolsOzoneModerationQueryEvents = $aec35899a3c9695e$var$x.ToolsOzoneModerationGetRepo = $aec35899a3c9695e$var$x.ToolsOzoneModerationGetRecord = $aec35899a3c9695e$var$x.ToolsOzoneModerationGetEvent = $aec35899a3c9695e$var$x.ToolsOzoneModerationEmitEvent = $aec35899a3c9695e$var$x.ToolsOzoneModerationDefs = $aec35899a3c9695e$var$x.ToolsOzoneCommunicationUpdateTemplate = $aec35899a3c9695e$var$x.ToolsOzoneCommunicationListTemplates = $aec35899a3c9695e$var$x.ToolsOzoneCommunicationDeleteTemplate = $aec35899a3c9695e$var$x.ToolsOzoneCommunicationDefs = $aec35899a3c9695e$var$x.ToolsOzoneCommunicationCreateTemplate = $aec35899a3c9695e$var$x.ChatBskyModerationUpdateActorAccess = $aec35899a3c9695e$var$x.ChatBskyModerationGetMessageContext = $aec35899a3c9695e$var$x.ChatBskyModerationGetActorMetadata = $aec35899a3c9695e$var$x.ChatBskyConvoUpdateRead = $aec35899a3c9695e$var$x.ChatBskyConvoUnmuteConvo = $aec35899a3c9695e$var$x.ChatBskyConvoSendMessageBatch = $aec35899a3c9695e$var$x.ChatBskyConvoSendMessage = $aec35899a3c9695e$var$x.ChatBskyConvoMuteConvo = $aec35899a3c9695e$var$x.ChatBskyConvoListConvos = $aec35899a3c9695e$var$x.ChatBskyConvoLeaveConvo = $aec35899a3c9695e$var$x.ChatBskyConvoGetMessages = $aec35899a3c9695e$var$x.ChatBskyConvoGetLog = $aec35899a3c9695e$var$x.ChatBskyConvoGetConvoForMembers = $aec35899a3c9695e$var$x.ChatBskyConvoGetConvo = $aec35899a3c9695e$var$x.ChatBskyConvoDeleteMessageForSelf = $aec35899a3c9695e$var$x.ChatBskyConvoDefs = $aec35899a3c9695e$var$x.ChatBskyActorExportAccountData = $aec35899a3c9695e$var$x.ChatBskyActorDeleteAccount = $aec35899a3c9695e$var$x.ChatBskyActorDefs = $aec35899a3c9695e$var$x.ChatBskyActorDeclaration = $aec35899a3c9695e$var$x.AppBskyUnspeccedSearchPostsSkeleton = $aec35899a3c9695e$var$x.AppBskyUnspeccedSearchActorsSkeleton = $aec35899a3c9695e$var$x.AppBskyUnspeccedGetTaggedSuggestions = $aec35899a3c9695e$var$x.AppBskyUnspeccedGetSuggestionsSkeleton = $aec35899a3c9695e$var$x.AppBskyUnspeccedGetPopularFeedGenerators = $aec35899a3c9695e$var$x.AppBskyUnspeccedDefs = $aec35899a3c9695e$var$x.AppBskyRichtextFacet = void 0;
$aec35899a3c9695e$var$x.ToolsOzoneTeamNS = $aec35899a3c9695e$var$x.ToolsOzoneServerNS = $aec35899a3c9695e$var$x.ToolsOzoneModerationNS = $aec35899a3c9695e$var$x.ToolsOzoneCommunicationNS = $aec35899a3c9695e$var$x.ToolsOzoneNS = $aec35899a3c9695e$var$x.ToolsNS = $aec35899a3c9695e$var$x.ChatBskyModerationNS = $aec35899a3c9695e$var$x.ChatBskyConvoNS = $aec35899a3c9695e$var$x.DeclarationRecord = $aec35899a3c9695e$var$x.ChatBskyActorNS = $aec35899a3c9695e$var$x.ChatBskyNS = $aec35899a3c9695e$var$x.ChatNS = $aec35899a3c9695e$var$x.AppBskyUnspeccedNS = $aec35899a3c9695e$var$x.AppBskyRichtextNS = $aec35899a3c9695e$var$x.AppBskyNotificationNS = $aec35899a3c9695e$var$x.ServiceRecord = $aec35899a3c9695e$var$x.AppBskyLabelerNS = $aec35899a3c9695e$var$x.StarterpackRecord = $aec35899a3c9695e$var$x.ListitemRecord = $aec35899a3c9695e$var$x.ListblockRecord = $aec35899a3c9695e$var$x.ListRecord = $aec35899a3c9695e$var$x.FollowRecord = $aec35899a3c9695e$var$x.BlockRecord = $aec35899a3c9695e$var$x.AppBskyGraphNS = $aec35899a3c9695e$var$x.ThreadgateRecord = $aec35899a3c9695e$var$x.RepostRecord = $aec35899a3c9695e$var$x.PostRecord = $aec35899a3c9695e$var$x.LikeRecord = $aec35899a3c9695e$var$x.GeneratorRecord = $aec35899a3c9695e$var$x.AppBskyFeedNS = $aec35899a3c9695e$var$x.AppBskyEmbedNS = $aec35899a3c9695e$var$x.ProfileRecord = $aec35899a3c9695e$var$x.AppBskyActorNS = $aec35899a3c9695e$var$x.AppBskyNS = $aec35899a3c9695e$var$x.AppNS = $aec35899a3c9695e$var$x.ComAtprotoTempNS = $aec35899a3c9695e$var$x.ComAtprotoSyncNS = $aec35899a3c9695e$var$x.ComAtprotoServerNS = $aec35899a3c9695e$var$x.ComAtprotoRepoNS = $aec35899a3c9695e$var$x.ComAtprotoModerationNS = $aec35899a3c9695e$var$x.ComAtprotoLabelNS = $aec35899a3c9695e$var$x.ComAtprotoIdentityNS = $aec35899a3c9695e$var$x.ComAtprotoAdminNS = $aec35899a3c9695e$var$x.ComAtprotoNS = $aec35899a3c9695e$var$x.ComNS = $aec35899a3c9695e$var$x.AtpServiceClient = $aec35899a3c9695e$var$x.AtpBaseClient = $aec35899a3c9695e$var$x.TOOLS_OZONE_TEAM = void 0;
const $aec35899a3c9695e$var$dB = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$fB = $aec35899a3c9695e$var$Le, $aec35899a3c9695e$var$pB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Da), $aec35899a3c9695e$var$hB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Pa), $aec35899a3c9695e$var$mB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ba), $aec35899a3c9695e$var$yB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ia), $aec35899a3c9695e$var$bB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ua), $aec35899a3c9695e$var$gB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Oa), $aec35899a3c9695e$var$xB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ka), $aec35899a3c9695e$var$EB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ma), $aec35899a3c9695e$var$vB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Na), $aec35899a3c9695e$var$RB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Va), $aec35899a3c9695e$var$AB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ja), $aec35899a3c9695e$var$_B = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fa), $aec35899a3c9695e$var$wB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$$a), $aec35899a3c9695e$var$TB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ga), $aec35899a3c9695e$var$SB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$qa), $aec35899a3c9695e$var$CB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$za), $aec35899a3c9695e$var$LB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Xa), $aec35899a3c9695e$var$kB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ha), $aec35899a3c9695e$var$DB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Za), $aec35899a3c9695e$var$PB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Wa), $aec35899a3c9695e$var$BB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ya), $aec35899a3c9695e$var$IB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ja), $aec35899a3c9695e$var$UB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Dt), $aec35899a3c9695e$var$OB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Nn), $aec35899a3c9695e$var$KB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vn), $aec35899a3c9695e$var$MB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Qa), $aec35899a3c9695e$var$NB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$eo), $aec35899a3c9695e$var$VB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$to), $aec35899a3c9695e$var$jB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ni), $aec35899a3c9695e$var$FB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vi), $aec35899a3c9695e$var$$B = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$jn), $aec35899a3c9695e$var$GB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ro), $aec35899a3c9695e$var$qB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$io), $aec35899a3c9695e$var$zB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$no), $aec35899a3c9695e$var$XB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Rr), $aec35899a3c9695e$var$HB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Pt), $aec35899a3c9695e$var$ZB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vr), $aec35899a3c9695e$var$WB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ao), $aec35899a3c9695e$var$YB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ji), $aec35899a3c9695e$var$JB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fi), $aec35899a3c9695e$var$QB = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$oo), $aec35899a3c9695e$var$eI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$$i), $aec35899a3c9695e$var$tI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$lo), $aec35899a3c9695e$var$rI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ar), $aec35899a3c9695e$var$iI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fn), $aec35899a3c9695e$var$nI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$$n), $aec35899a3c9695e$var$sI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$uo), $aec35899a3c9695e$var$aI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$jr), $aec35899a3c9695e$var$oI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Gn), $aec35899a3c9695e$var$lI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$co), $aec35899a3c9695e$var$uI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$fo), $aec35899a3c9695e$var$cI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$po), $aec35899a3c9695e$var$dI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ho), $aec35899a3c9695e$var$fI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$mo), $aec35899a3c9695e$var$pI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Gi), $aec35899a3c9695e$var$hI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$yo), $aec35899a3c9695e$var$mI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fr), $aec35899a3c9695e$var$yI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ar), $aec35899a3c9695e$var$bI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$or), $aec35899a3c9695e$var$gI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$bo), $aec35899a3c9695e$var$xI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$qn), $aec35899a3c9695e$var$EI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$_r), $aec35899a3c9695e$var$vI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$lr), $aec35899a3c9695e$var$RI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$wr), $aec35899a3c9695e$var$AI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$zn), $aec35899a3c9695e$var$_I = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Tr), $aec35899a3c9695e$var$wI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$qi), $aec35899a3c9695e$var$TI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$vo), $aec35899a3c9695e$var$SI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ro), $aec35899a3c9695e$var$CI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ao), $aec35899a3c9695e$var$LI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$_o), $aec35899a3c9695e$var$kI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$wo), $aec35899a3c9695e$var$DI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$To), $aec35899a3c9695e$var$PI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$So), $aec35899a3c9695e$var$BI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Co), $aec35899a3c9695e$var$II = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Lo), $aec35899a3c9695e$var$UI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ko), $aec35899a3c9695e$var$OI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Do), $aec35899a3c9695e$var$KI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Po), $aec35899a3c9695e$var$MI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Sr), $aec35899a3c9695e$var$NI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Bo), $aec35899a3c9695e$var$VI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$zi), $aec35899a3c9695e$var$jI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Xi), $aec35899a3c9695e$var$FI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Xn), $aec35899a3c9695e$var$$I = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Io), $aec35899a3c9695e$var$GI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Uo), $aec35899a3c9695e$var$qI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Hn), $aec35899a3c9695e$var$zI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Hi), $aec35899a3c9695e$var$XI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Zn), $aec35899a3c9695e$var$HI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Wn), $aec35899a3c9695e$var$ZI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Oo), $aec35899a3c9695e$var$WI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ko), $aec35899a3c9695e$var$YI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Mo), $aec35899a3c9695e$var$JI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$No), $aec35899a3c9695e$var$QI = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Yn), $aec35899a3c9695e$var$eU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vo), $aec35899a3c9695e$var$tU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$jo), $aec35899a3c9695e$var$rU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fo), $aec35899a3c9695e$var$iU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$$o), $aec35899a3c9695e$var$nU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Go), $aec35899a3c9695e$var$sU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$qo), $aec35899a3c9695e$var$aU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$zo), $aec35899a3c9695e$var$oU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Xo), $aec35899a3c9695e$var$lU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ho), $aec35899a3c9695e$var$uU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Zo), $aec35899a3c9695e$var$cU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Wo), $aec35899a3c9695e$var$dU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Jn), $aec35899a3c9695e$var$fU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Yo), $aec35899a3c9695e$var$pU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Jo), $aec35899a3c9695e$var$hU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Qo), $aec35899a3c9695e$var$mU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$el), $aec35899a3c9695e$var$yU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$tl), $aec35899a3c9695e$var$bU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$rl), $aec35899a3c9695e$var$gU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$il), $aec35899a3c9695e$var$xU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$nl), $aec35899a3c9695e$var$EU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$sl), $aec35899a3c9695e$var$vU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$al), $aec35899a3c9695e$var$RU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ol), $aec35899a3c9695e$var$AU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Zi), $aec35899a3c9695e$var$_U = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ll), $aec35899a3c9695e$var$wU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ul), $aec35899a3c9695e$var$TU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$cl), $aec35899a3c9695e$var$SU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$dl), $aec35899a3c9695e$var$CU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$fl), $aec35899a3c9695e$var$LU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Wi), $aec35899a3c9695e$var$kU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Qn), $aec35899a3c9695e$var$DU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$es), $aec35899a3c9695e$var$PU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$pl), $aec35899a3c9695e$var$BU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$hl), $aec35899a3c9695e$var$IU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ml), $aec35899a3c9695e$var$UU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$yl), $aec35899a3c9695e$var$OU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$bl), $aec35899a3c9695e$var$KU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$gl), $aec35899a3c9695e$var$MU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$xl), $aec35899a3c9695e$var$NU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$El), $aec35899a3c9695e$var$VU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$vl), $aec35899a3c9695e$var$jU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Rl), $aec35899a3c9695e$var$FU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Al), $aec35899a3c9695e$var$$U = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Yi), $aec35899a3c9695e$var$GU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$_l), $aec35899a3c9695e$var$qU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$wl), $aec35899a3c9695e$var$zU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ji), $aec35899a3c9695e$var$XU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Tl), $aec35899a3c9695e$var$HU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Sl), $aec35899a3c9695e$var$ZU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Cl), $aec35899a3c9695e$var$WU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ll), $aec35899a3c9695e$var$YU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$kl), $aec35899a3c9695e$var$JU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Dl), $aec35899a3c9695e$var$QU = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ts), $aec35899a3c9695e$var$eO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Pl), $aec35899a3c9695e$var$tO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$rs), $aec35899a3c9695e$var$rO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$is), $aec35899a3c9695e$var$iO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Bl), $aec35899a3c9695e$var$nO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Il), $aec35899a3c9695e$var$sO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ul), $aec35899a3c9695e$var$aO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Cr), $aec35899a3c9695e$var$oO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ns), $aec35899a3c9695e$var$lO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Qi), $aec35899a3c9695e$var$uO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ol), $aec35899a3c9695e$var$cO = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ss);
$aec35899a3c9695e$var$x.ComAtprotoAdminDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Kt);
$aec35899a3c9695e$var$x.ComAtprotoAdminDeleteAccount = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Da);
$aec35899a3c9695e$var$x.ComAtprotoAdminDisableAccountInvites = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Pa);
$aec35899a3c9695e$var$x.ComAtprotoAdminDisableInviteCodes = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ba);
$aec35899a3c9695e$var$x.ComAtprotoAdminEnableAccountInvites = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ia);
$aec35899a3c9695e$var$x.ComAtprotoAdminGetAccountInfo = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ua);
$aec35899a3c9695e$var$x.ComAtprotoAdminGetAccountInfos = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Oa);
$aec35899a3c9695e$var$x.ComAtprotoAdminGetInviteCodes = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ka);
$aec35899a3c9695e$var$x.ComAtprotoAdminGetSubjectStatus = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ma);
$aec35899a3c9695e$var$x.ComAtprotoAdminSearchAccounts = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Na);
$aec35899a3c9695e$var$x.ComAtprotoAdminSendEmail = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Va);
$aec35899a3c9695e$var$x.ComAtprotoAdminUpdateAccountEmail = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ja);
$aec35899a3c9695e$var$x.ComAtprotoAdminUpdateAccountHandle = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fa);
$aec35899a3c9695e$var$x.ComAtprotoAdminUpdateAccountPassword = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$$a);
$aec35899a3c9695e$var$x.ComAtprotoAdminUpdateSubjectStatus = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ga);
$aec35899a3c9695e$var$x.ComAtprotoIdentityGetRecommendedDidCredentials = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$qa);
$aec35899a3c9695e$var$x.ComAtprotoIdentityRequestPlcOperationSignature = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$za);
$aec35899a3c9695e$var$x.ComAtprotoIdentityResolveHandle = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Xa);
$aec35899a3c9695e$var$x.ComAtprotoIdentitySignPlcOperation = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ha);
$aec35899a3c9695e$var$x.ComAtprotoIdentitySubmitPlcOperation = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Za);
$aec35899a3c9695e$var$x.ComAtprotoIdentityUpdateHandle = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Wa);
$aec35899a3c9695e$var$x.ComAtprotoLabelDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$gt);
$aec35899a3c9695e$var$x.ComAtprotoLabelQueryLabels = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ya);
$aec35899a3c9695e$var$x.ComAtprotoLabelSubscribeLabels = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ni);
$aec35899a3c9695e$var$x.ComAtprotoModerationCreateReport = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ja);
$aec35899a3c9695e$var$x.ComAtprotoModerationDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Jt);
$aec35899a3c9695e$var$x.ComAtprotoRepoApplyWrites = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Dt);
$aec35899a3c9695e$var$x.ComAtprotoRepoCreateRecord = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Nn);
$aec35899a3c9695e$var$x.ComAtprotoRepoDeleteRecord = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vn);
$aec35899a3c9695e$var$x.ComAtprotoRepoDescribeRepo = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Qa);
$aec35899a3c9695e$var$x.ComAtprotoRepoGetRecord = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$eo);
$aec35899a3c9695e$var$x.ComAtprotoRepoImportRepo = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$to);
$aec35899a3c9695e$var$x.ComAtprotoRepoListMissingBlobs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ni);
$aec35899a3c9695e$var$x.ComAtprotoRepoListRecords = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vi);
$aec35899a3c9695e$var$x.ComAtprotoRepoPutRecord = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$jn);
$aec35899a3c9695e$var$x.ComAtprotoRepoStrongRef = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ss);
$aec35899a3c9695e$var$x.ComAtprotoRepoUploadBlob = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ro);
$aec35899a3c9695e$var$x.ComAtprotoServerActivateAccount = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$io);
$aec35899a3c9695e$var$x.ComAtprotoServerCheckAccountStatus = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$no);
$aec35899a3c9695e$var$x.ComAtprotoServerConfirmEmail = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Rr);
$aec35899a3c9695e$var$x.ComAtprotoServerCreateAccount = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Pt);
$aec35899a3c9695e$var$x.ComAtprotoServerCreateAppPassword = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vr);
$aec35899a3c9695e$var$x.ComAtprotoServerCreateInviteCode = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ao);
$aec35899a3c9695e$var$x.ComAtprotoServerCreateInviteCodes = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ji);
$aec35899a3c9695e$var$x.ComAtprotoServerCreateSession = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fi);
$aec35899a3c9695e$var$x.ComAtprotoServerDeactivateAccount = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$oo);
$aec35899a3c9695e$var$x.ComAtprotoServerDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$si);
$aec35899a3c9695e$var$x.ComAtprotoServerDeleteAccount = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$$i);
$aec35899a3c9695e$var$x.ComAtprotoServerDeleteSession = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$lo);
$aec35899a3c9695e$var$x.ComAtprotoServerDescribeServer = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ar);
$aec35899a3c9695e$var$x.ComAtprotoServerGetAccountInviteCodes = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fn);
$aec35899a3c9695e$var$x.ComAtprotoServerGetServiceAuth = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$$n);
$aec35899a3c9695e$var$x.ComAtprotoServerGetSession = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$uo);
$aec35899a3c9695e$var$x.ComAtprotoServerListAppPasswords = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$jr);
$aec35899a3c9695e$var$x.ComAtprotoServerRefreshSession = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Gn);
$aec35899a3c9695e$var$x.ComAtprotoServerRequestAccountDelete = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$co);
$aec35899a3c9695e$var$x.ComAtprotoServerRequestEmailConfirmation = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$fo);
$aec35899a3c9695e$var$x.ComAtprotoServerRequestEmailUpdate = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$po);
$aec35899a3c9695e$var$x.ComAtprotoServerRequestPasswordReset = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ho);
$aec35899a3c9695e$var$x.ComAtprotoServerReserveSigningKey = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$mo);
$aec35899a3c9695e$var$x.ComAtprotoServerResetPassword = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Gi);
$aec35899a3c9695e$var$x.ComAtprotoServerRevokeAppPassword = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$yo);
$aec35899a3c9695e$var$x.ComAtprotoServerUpdateEmail = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fr);
$aec35899a3c9695e$var$x.ComAtprotoSyncGetBlob = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ar);
$aec35899a3c9695e$var$x.ComAtprotoSyncGetBlocks = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$or);
$aec35899a3c9695e$var$x.ComAtprotoSyncGetCheckout = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$bo);
$aec35899a3c9695e$var$x.ComAtprotoSyncGetHead = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$qn);
$aec35899a3c9695e$var$x.ComAtprotoSyncGetLatestCommit = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$_r);
$aec35899a3c9695e$var$x.ComAtprotoSyncGetRecord = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$lr);
$aec35899a3c9695e$var$x.ComAtprotoSyncGetRepo = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$wr);
$aec35899a3c9695e$var$x.ComAtprotoSyncGetRepoStatus = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$zn);
$aec35899a3c9695e$var$x.ComAtprotoSyncListBlobs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Tr);
$aec35899a3c9695e$var$x.ComAtprotoSyncListRepos = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$qi);
$aec35899a3c9695e$var$x.ComAtprotoSyncNotifyOfUpdate = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$vo);
$aec35899a3c9695e$var$x.ComAtprotoSyncRequestCrawl = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ro);
$aec35899a3c9695e$var$x.ComAtprotoSyncSubscribeRepos = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ze);
$aec35899a3c9695e$var$x.ComAtprotoTempCheckSignupQueue = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ao);
$aec35899a3c9695e$var$x.ComAtprotoTempFetchLabels = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$_o);
$aec35899a3c9695e$var$x.ComAtprotoTempRequestPhoneVerification = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$wo);
$aec35899a3c9695e$var$x.AppBskyActorDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ae);
$aec35899a3c9695e$var$x.AppBskyActorGetPreferences = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$To);
$aec35899a3c9695e$var$x.AppBskyActorGetProfile = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$So);
$aec35899a3c9695e$var$x.AppBskyActorGetProfiles = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Co);
$aec35899a3c9695e$var$x.AppBskyActorGetSuggestions = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Lo);
$aec35899a3c9695e$var$x.AppBskyActorProfile = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Cs);
$aec35899a3c9695e$var$x.AppBskyActorPutPreferences = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ko);
$aec35899a3c9695e$var$x.AppBskyActorSearchActors = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Do);
$aec35899a3c9695e$var$x.AppBskyActorSearchActorsTypeahead = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Po);
$aec35899a3c9695e$var$x.AppBskyEmbedExternal = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Mt);
$aec35899a3c9695e$var$x.AppBskyEmbedImages = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$xt);
$aec35899a3c9695e$var$x.AppBskyEmbedRecord = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Et);
$aec35899a3c9695e$var$x.AppBskyEmbedRecordWithMedia = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ai);
$aec35899a3c9695e$var$x.AppBskyFeedDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ce);
$aec35899a3c9695e$var$x.AppBskyFeedDescribeFeedGenerator = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Sr);
$aec35899a3c9695e$var$x.AppBskyFeedGenerator = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ls);
$aec35899a3c9695e$var$x.AppBskyFeedGetActorFeeds = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Bo);
$aec35899a3c9695e$var$x.AppBskyFeedGetActorLikes = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$zi);
$aec35899a3c9695e$var$x.AppBskyFeedGetAuthorFeed = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Xi);
$aec35899a3c9695e$var$x.AppBskyFeedGetFeed = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Xn);
$aec35899a3c9695e$var$x.AppBskyFeedGetFeedGenerator = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Io);
$aec35899a3c9695e$var$x.AppBskyFeedGetFeedGenerators = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Uo);
$aec35899a3c9695e$var$x.AppBskyFeedGetFeedSkeleton = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Hn);
$aec35899a3c9695e$var$x.AppBskyFeedGetLikes = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Hi);
$aec35899a3c9695e$var$x.AppBskyFeedGetListFeed = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Zn);
$aec35899a3c9695e$var$x.AppBskyFeedGetPostThread = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Wn);
$aec35899a3c9695e$var$x.AppBskyFeedGetPosts = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Oo);
$aec35899a3c9695e$var$x.AppBskyFeedGetRepostedBy = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ko);
$aec35899a3c9695e$var$x.AppBskyFeedGetSuggestedFeeds = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Mo);
$aec35899a3c9695e$var$x.AppBskyFeedGetTimeline = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$No);
$aec35899a3c9695e$var$x.AppBskyFeedLike = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ks);
$aec35899a3c9695e$var$x.AppBskyFeedPost = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Nt);
$aec35899a3c9695e$var$x.AppBskyFeedRepost = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ds);
$aec35899a3c9695e$var$x.AppBskyFeedSearchPosts = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Yn);
$aec35899a3c9695e$var$x.AppBskyFeedSendInteractions = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vo);
$aec35899a3c9695e$var$x.AppBskyFeedThreadgate = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vt);
$aec35899a3c9695e$var$x.AppBskyGraphBlock = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ps);
$aec35899a3c9695e$var$x.AppBskyGraphDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ve);
$aec35899a3c9695e$var$x.AppBskyGraphFollow = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Bs);
$aec35899a3c9695e$var$x.AppBskyGraphGetActorStarterPacks = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$jo);
$aec35899a3c9695e$var$x.AppBskyGraphGetBlocks = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Fo);
$aec35899a3c9695e$var$x.AppBskyGraphGetFollowers = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$$o);
$aec35899a3c9695e$var$x.AppBskyGraphGetFollows = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Go);
$aec35899a3c9695e$var$x.AppBskyGraphGetKnownFollowers = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$qo);
$aec35899a3c9695e$var$x.AppBskyGraphGetList = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$zo);
$aec35899a3c9695e$var$x.AppBskyGraphGetListBlocks = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Xo);
$aec35899a3c9695e$var$x.AppBskyGraphGetListMutes = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ho);
$aec35899a3c9695e$var$x.AppBskyGraphGetLists = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Zo);
$aec35899a3c9695e$var$x.AppBskyGraphGetMutes = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Wo);
$aec35899a3c9695e$var$x.AppBskyGraphGetRelationships = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Jn);
$aec35899a3c9695e$var$x.AppBskyGraphGetStarterPack = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Yo);
$aec35899a3c9695e$var$x.AppBskyGraphGetStarterPacks = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Jo);
$aec35899a3c9695e$var$x.AppBskyGraphGetSuggestedFollowsByActor = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Qo);
$aec35899a3c9695e$var$x.AppBskyGraphList = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Is);
$aec35899a3c9695e$var$x.AppBskyGraphListblock = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Us);
$aec35899a3c9695e$var$x.AppBskyGraphListitem = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Os);
$aec35899a3c9695e$var$x.AppBskyGraphMuteActor = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$el);
$aec35899a3c9695e$var$x.AppBskyGraphMuteActorList = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$tl);
$aec35899a3c9695e$var$x.AppBskyGraphMuteThread = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$rl);
$aec35899a3c9695e$var$x.AppBskyGraphStarterpack = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$oi);
$aec35899a3c9695e$var$x.AppBskyGraphUnmuteActor = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$il);
$aec35899a3c9695e$var$x.AppBskyGraphUnmuteActorList = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$nl);
$aec35899a3c9695e$var$x.AppBskyGraphUnmuteThread = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$sl);
$aec35899a3c9695e$var$x.AppBskyLabelerDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$jt);
$aec35899a3c9695e$var$x.AppBskyLabelerGetServices = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$al);
$aec35899a3c9695e$var$x.AppBskyLabelerService = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ks);
$aec35899a3c9695e$var$x.AppBskyNotificationGetUnreadCount = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ol);
$aec35899a3c9695e$var$x.AppBskyNotificationListNotifications = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Zi);
$aec35899a3c9695e$var$x.AppBskyNotificationPutPreferences = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ll);
$aec35899a3c9695e$var$x.AppBskyNotificationRegisterPush = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ul);
$aec35899a3c9695e$var$x.AppBskyNotificationUpdateSeen = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$cl);
$aec35899a3c9695e$var$x.AppBskyRichtextFacet = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$vt);
$aec35899a3c9695e$var$x.AppBskyUnspeccedDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$li);
$aec35899a3c9695e$var$x.AppBskyUnspeccedGetPopularFeedGenerators = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$dl);
$aec35899a3c9695e$var$x.AppBskyUnspeccedGetSuggestionsSkeleton = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$fl);
$aec35899a3c9695e$var$x.AppBskyUnspeccedGetTaggedSuggestions = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Wi);
$aec35899a3c9695e$var$x.AppBskyUnspeccedSearchActorsSkeleton = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Qn);
$aec35899a3c9695e$var$x.AppBskyUnspeccedSearchPostsSkeleton = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$es);
$aec35899a3c9695e$var$x.ChatBskyActorDeclaration = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ms);
$aec35899a3c9695e$var$x.ChatBskyActorDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ns);
$aec35899a3c9695e$var$x.ChatBskyActorDeleteAccount = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$pl);
$aec35899a3c9695e$var$x.ChatBskyActorExportAccountData = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$hl);
$aec35899a3c9695e$var$x.ChatBskyConvoDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ke);
$aec35899a3c9695e$var$x.ChatBskyConvoDeleteMessageForSelf = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ml);
$aec35899a3c9695e$var$x.ChatBskyConvoGetConvo = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$yl);
$aec35899a3c9695e$var$x.ChatBskyConvoGetConvoForMembers = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$bl);
$aec35899a3c9695e$var$x.ChatBskyConvoGetLog = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$gl);
$aec35899a3c9695e$var$x.ChatBskyConvoGetMessages = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$xl);
$aec35899a3c9695e$var$x.ChatBskyConvoLeaveConvo = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$El);
$aec35899a3c9695e$var$x.ChatBskyConvoListConvos = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$vl);
$aec35899a3c9695e$var$x.ChatBskyConvoMuteConvo = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Rl);
$aec35899a3c9695e$var$x.ChatBskyConvoSendMessage = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Al);
$aec35899a3c9695e$var$x.ChatBskyConvoSendMessageBatch = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Yi);
$aec35899a3c9695e$var$x.ChatBskyConvoUnmuteConvo = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$_l);
$aec35899a3c9695e$var$x.ChatBskyConvoUpdateRead = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$wl);
$aec35899a3c9695e$var$x.ChatBskyModerationGetActorMetadata = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ji);
$aec35899a3c9695e$var$x.ChatBskyModerationGetMessageContext = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Tl);
$aec35899a3c9695e$var$x.ChatBskyModerationUpdateActorAccess = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Sl);
$aec35899a3c9695e$var$x.ToolsOzoneCommunicationCreateTemplate = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Cl);
$aec35899a3c9695e$var$x.ToolsOzoneCommunicationDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Vs);
$aec35899a3c9695e$var$x.ToolsOzoneCommunicationDeleteTemplate = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ll);
$aec35899a3c9695e$var$x.ToolsOzoneCommunicationListTemplates = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$kl);
$aec35899a3c9695e$var$x.ToolsOzoneCommunicationUpdateTemplate = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Dl);
$aec35899a3c9695e$var$x.ToolsOzoneModerationDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$W);
$aec35899a3c9695e$var$x.ToolsOzoneModerationEmitEvent = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ts);
$aec35899a3c9695e$var$x.ToolsOzoneModerationGetEvent = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Pl);
$aec35899a3c9695e$var$x.ToolsOzoneModerationGetRecord = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$rs);
$aec35899a3c9695e$var$x.ToolsOzoneModerationGetRepo = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$is);
$aec35899a3c9695e$var$x.ToolsOzoneModerationQueryEvents = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Bl);
$aec35899a3c9695e$var$x.ToolsOzoneModerationQueryStatuses = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Il);
$aec35899a3c9695e$var$x.ToolsOzoneModerationSearchRepos = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ul);
$aec35899a3c9695e$var$x.ToolsOzoneServerGetConfig = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Cr);
$aec35899a3c9695e$var$x.ToolsOzoneTeamAddMember = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ns);
$aec35899a3c9695e$var$x.ToolsOzoneTeamDefs = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Dr);
$aec35899a3c9695e$var$x.ToolsOzoneTeamDeleteMember = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Qi);
$aec35899a3c9695e$var$x.ToolsOzoneTeamListMembers = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$Ol);
$aec35899a3c9695e$var$x.ToolsOzoneTeamUpdateMember = $aec35899a3c9695e$var$_($aec35899a3c9695e$var$ss);
$aec35899a3c9695e$var$x.COM_ATPROTO_MODERATION = {
    DefsReasonSpam: "com.atproto.moderation.defs#reasonSpam",
    DefsReasonViolation: "com.atproto.moderation.defs#reasonViolation",
    DefsReasonMisleading: "com.atproto.moderation.defs#reasonMisleading",
    DefsReasonSexual: "com.atproto.moderation.defs#reasonSexual",
    DefsReasonRude: "com.atproto.moderation.defs#reasonRude",
    DefsReasonOther: "com.atproto.moderation.defs#reasonOther",
    DefsReasonAppeal: "com.atproto.moderation.defs#reasonAppeal"
};
$aec35899a3c9695e$var$x.APP_BSKY_FEED = {
    DefsRequestLess: "app.bsky.feed.defs#requestLess",
    DefsRequestMore: "app.bsky.feed.defs#requestMore",
    DefsClickthroughItem: "app.bsky.feed.defs#clickthroughItem",
    DefsClickthroughAuthor: "app.bsky.feed.defs#clickthroughAuthor",
    DefsClickthroughReposter: "app.bsky.feed.defs#clickthroughReposter",
    DefsClickthroughEmbed: "app.bsky.feed.defs#clickthroughEmbed",
    DefsInteractionSeen: "app.bsky.feed.defs#interactionSeen",
    DefsInteractionLike: "app.bsky.feed.defs#interactionLike",
    DefsInteractionRepost: "app.bsky.feed.defs#interactionRepost",
    DefsInteractionReply: "app.bsky.feed.defs#interactionReply",
    DefsInteractionQuote: "app.bsky.feed.defs#interactionQuote",
    DefsInteractionShare: "app.bsky.feed.defs#interactionShare"
};
$aec35899a3c9695e$var$x.APP_BSKY_GRAPH = {
    DefsModlist: "app.bsky.graph.defs#modlist",
    DefsCuratelist: "app.bsky.graph.defs#curatelist",
    DefsReferencelist: "app.bsky.graph.defs#referencelist"
};
$aec35899a3c9695e$var$x.TOOLS_OZONE_MODERATION = {
    DefsReviewOpen: "tools.ozone.moderation.defs#reviewOpen",
    DefsReviewEscalated: "tools.ozone.moderation.defs#reviewEscalated",
    DefsReviewClosed: "tools.ozone.moderation.defs#reviewClosed",
    DefsReviewNone: "tools.ozone.moderation.defs#reviewNone"
};
$aec35899a3c9695e$var$x.TOOLS_OZONE_TEAM = {
    DefsRoleAdmin: "tools.ozone.team.defs#roleAdmin",
    DefsRoleModerator: "tools.ozone.team.defs#roleModerator",
    DefsRoleTriage: "tools.ozone.team.defs#roleTriage"
};
class $aec35899a3c9695e$var$dO {
    constructor(){
        Object.defineProperty(this, "xrpc", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new $aec35899a3c9695e$var$dB.Client()
        }), this.xrpc.addLexicons($aec35899a3c9695e$var$fB.schemas);
    }
    service(e) {
        return new $aec35899a3c9695e$var$Z0(this, this.xrpc.service(e));
    }
}
$aec35899a3c9695e$var$x.AtpBaseClient = $aec35899a3c9695e$var$dO;
class $aec35899a3c9695e$var$Z0 {
    constructor(e, r){
        Object.defineProperty(this, "_baseClient", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "xrpc", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "com", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "app", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "chat", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "tools", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._baseClient = e, this.xrpc = r, this.com = new $aec35899a3c9695e$var$W0(this), this.app = new $aec35899a3c9695e$var$am(this), this.chat = new $aec35899a3c9695e$var$Lm(this), this.tools = new $aec35899a3c9695e$var$Um(this);
    }
    setHeader(e, r) {
        this.xrpc.setHeader(e, r);
    }
}
$aec35899a3c9695e$var$x.AtpServiceClient = $aec35899a3c9695e$var$Z0;
class $aec35899a3c9695e$var$W0 {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "atproto", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.atproto = new $aec35899a3c9695e$var$Y0(e);
    }
}
$aec35899a3c9695e$var$x.ComNS = $aec35899a3c9695e$var$W0;
class $aec35899a3c9695e$var$Y0 {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "admin", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "identity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "label", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moderation", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "repo", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "server", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "sync", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "temp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.admin = new $aec35899a3c9695e$var$J0(e), this.identity = new $aec35899a3c9695e$var$Q0(e), this.label = new $aec35899a3c9695e$var$em(e), this.moderation = new $aec35899a3c9695e$var$tm(e), this.repo = new $aec35899a3c9695e$var$rm(e), this.server = new $aec35899a3c9695e$var$im(e), this.sync = new $aec35899a3c9695e$var$nm(e), this.temp = new $aec35899a3c9695e$var$sm(e);
    }
}
$aec35899a3c9695e$var$x.ComAtprotoNS = $aec35899a3c9695e$var$Y0;
class $aec35899a3c9695e$var$J0 {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    deleteAccount(e, r) {
        return this._service.xrpc.call("com.atproto.admin.deleteAccount", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$pB.toKnownErr(i);
        });
    }
    disableAccountInvites(e, r) {
        return this._service.xrpc.call("com.atproto.admin.disableAccountInvites", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$hB.toKnownErr(i);
        });
    }
    disableInviteCodes(e, r) {
        return this._service.xrpc.call("com.atproto.admin.disableInviteCodes", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$mB.toKnownErr(i);
        });
    }
    enableAccountInvites(e, r) {
        return this._service.xrpc.call("com.atproto.admin.enableAccountInvites", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$yB.toKnownErr(i);
        });
    }
    getAccountInfo(e, r) {
        return this._service.xrpc.call("com.atproto.admin.getAccountInfo", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$bB.toKnownErr(i);
        });
    }
    getAccountInfos(e, r) {
        return this._service.xrpc.call("com.atproto.admin.getAccountInfos", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$gB.toKnownErr(i);
        });
    }
    getInviteCodes(e, r) {
        return this._service.xrpc.call("com.atproto.admin.getInviteCodes", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$xB.toKnownErr(i);
        });
    }
    getSubjectStatus(e, r) {
        return this._service.xrpc.call("com.atproto.admin.getSubjectStatus", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$EB.toKnownErr(i);
        });
    }
    searchAccounts(e, r) {
        return this._service.xrpc.call("com.atproto.admin.searchAccounts", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$vB.toKnownErr(i);
        });
    }
    sendEmail(e, r) {
        return this._service.xrpc.call("com.atproto.admin.sendEmail", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$RB.toKnownErr(i);
        });
    }
    updateAccountEmail(e, r) {
        return this._service.xrpc.call("com.atproto.admin.updateAccountEmail", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$AB.toKnownErr(i);
        });
    }
    updateAccountHandle(e, r) {
        return this._service.xrpc.call("com.atproto.admin.updateAccountHandle", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$_B.toKnownErr(i);
        });
    }
    updateAccountPassword(e, r) {
        return this._service.xrpc.call("com.atproto.admin.updateAccountPassword", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$wB.toKnownErr(i);
        });
    }
    updateSubjectStatus(e, r) {
        return this._service.xrpc.call("com.atproto.admin.updateSubjectStatus", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$TB.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ComAtprotoAdminNS = $aec35899a3c9695e$var$J0;
class $aec35899a3c9695e$var$Q0 {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    getRecommendedDidCredentials(e, r) {
        return this._service.xrpc.call("com.atproto.identity.getRecommendedDidCredentials", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$SB.toKnownErr(i);
        });
    }
    requestPlcOperationSignature(e, r) {
        return this._service.xrpc.call("com.atproto.identity.requestPlcOperationSignature", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$CB.toKnownErr(i);
        });
    }
    resolveHandle(e, r) {
        return this._service.xrpc.call("com.atproto.identity.resolveHandle", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$LB.toKnownErr(i);
        });
    }
    signPlcOperation(e, r) {
        return this._service.xrpc.call("com.atproto.identity.signPlcOperation", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$kB.toKnownErr(i);
        });
    }
    submitPlcOperation(e, r) {
        return this._service.xrpc.call("com.atproto.identity.submitPlcOperation", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$DB.toKnownErr(i);
        });
    }
    updateHandle(e, r) {
        return this._service.xrpc.call("com.atproto.identity.updateHandle", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$PB.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ComAtprotoIdentityNS = $aec35899a3c9695e$var$Q0;
class $aec35899a3c9695e$var$em {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    queryLabels(e, r) {
        return this._service.xrpc.call("com.atproto.label.queryLabels", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$BB.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ComAtprotoLabelNS = $aec35899a3c9695e$var$em;
class $aec35899a3c9695e$var$tm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    createReport(e, r) {
        return this._service.xrpc.call("com.atproto.moderation.createReport", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$IB.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ComAtprotoModerationNS = $aec35899a3c9695e$var$tm;
class $aec35899a3c9695e$var$rm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    applyWrites(e, r) {
        return this._service.xrpc.call("com.atproto.repo.applyWrites", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$UB.toKnownErr(i);
        });
    }
    createRecord(e, r) {
        return this._service.xrpc.call("com.atproto.repo.createRecord", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$OB.toKnownErr(i);
        });
    }
    deleteRecord(e, r) {
        return this._service.xrpc.call("com.atproto.repo.deleteRecord", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$KB.toKnownErr(i);
        });
    }
    describeRepo(e, r) {
        return this._service.xrpc.call("com.atproto.repo.describeRepo", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$MB.toKnownErr(i);
        });
    }
    getRecord(e, r) {
        return this._service.xrpc.call("com.atproto.repo.getRecord", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$NB.toKnownErr(i);
        });
    }
    importRepo(e, r) {
        return this._service.xrpc.call("com.atproto.repo.importRepo", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$VB.toKnownErr(i);
        });
    }
    listMissingBlobs(e, r) {
        return this._service.xrpc.call("com.atproto.repo.listMissingBlobs", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$jB.toKnownErr(i);
        });
    }
    listRecords(e, r) {
        return this._service.xrpc.call("com.atproto.repo.listRecords", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$FB.toKnownErr(i);
        });
    }
    putRecord(e, r) {
        return this._service.xrpc.call("com.atproto.repo.putRecord", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$$B.toKnownErr(i);
        });
    }
    uploadBlob(e, r) {
        return this._service.xrpc.call("com.atproto.repo.uploadBlob", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$GB.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ComAtprotoRepoNS = $aec35899a3c9695e$var$rm;
class $aec35899a3c9695e$var$im {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    activateAccount(e, r) {
        return this._service.xrpc.call("com.atproto.server.activateAccount", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$qB.toKnownErr(i);
        });
    }
    checkAccountStatus(e, r) {
        return this._service.xrpc.call("com.atproto.server.checkAccountStatus", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$zB.toKnownErr(i);
        });
    }
    confirmEmail(e, r) {
        return this._service.xrpc.call("com.atproto.server.confirmEmail", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$XB.toKnownErr(i);
        });
    }
    createAccount(e, r) {
        return this._service.xrpc.call("com.atproto.server.createAccount", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$HB.toKnownErr(i);
        });
    }
    createAppPassword(e, r) {
        return this._service.xrpc.call("com.atproto.server.createAppPassword", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$ZB.toKnownErr(i);
        });
    }
    createInviteCode(e, r) {
        return this._service.xrpc.call("com.atproto.server.createInviteCode", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$WB.toKnownErr(i);
        });
    }
    createInviteCodes(e, r) {
        return this._service.xrpc.call("com.atproto.server.createInviteCodes", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$YB.toKnownErr(i);
        });
    }
    createSession(e, r) {
        return this._service.xrpc.call("com.atproto.server.createSession", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$JB.toKnownErr(i);
        });
    }
    deactivateAccount(e, r) {
        return this._service.xrpc.call("com.atproto.server.deactivateAccount", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$QB.toKnownErr(i);
        });
    }
    deleteAccount(e, r) {
        return this._service.xrpc.call("com.atproto.server.deleteAccount", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$eI.toKnownErr(i);
        });
    }
    deleteSession(e, r) {
        return this._service.xrpc.call("com.atproto.server.deleteSession", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$tI.toKnownErr(i);
        });
    }
    describeServer(e, r) {
        return this._service.xrpc.call("com.atproto.server.describeServer", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$rI.toKnownErr(i);
        });
    }
    getAccountInviteCodes(e, r) {
        return this._service.xrpc.call("com.atproto.server.getAccountInviteCodes", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$iI.toKnownErr(i);
        });
    }
    getServiceAuth(e, r) {
        return this._service.xrpc.call("com.atproto.server.getServiceAuth", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$nI.toKnownErr(i);
        });
    }
    getSession(e, r) {
        return this._service.xrpc.call("com.atproto.server.getSession", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$sI.toKnownErr(i);
        });
    }
    listAppPasswords(e, r) {
        return this._service.xrpc.call("com.atproto.server.listAppPasswords", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$aI.toKnownErr(i);
        });
    }
    refreshSession(e, r) {
        return this._service.xrpc.call("com.atproto.server.refreshSession", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$oI.toKnownErr(i);
        });
    }
    requestAccountDelete(e, r) {
        return this._service.xrpc.call("com.atproto.server.requestAccountDelete", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$lI.toKnownErr(i);
        });
    }
    requestEmailConfirmation(e, r) {
        return this._service.xrpc.call("com.atproto.server.requestEmailConfirmation", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$uI.toKnownErr(i);
        });
    }
    requestEmailUpdate(e, r) {
        return this._service.xrpc.call("com.atproto.server.requestEmailUpdate", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$cI.toKnownErr(i);
        });
    }
    requestPasswordReset(e, r) {
        return this._service.xrpc.call("com.atproto.server.requestPasswordReset", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$dI.toKnownErr(i);
        });
    }
    reserveSigningKey(e, r) {
        return this._service.xrpc.call("com.atproto.server.reserveSigningKey", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$fI.toKnownErr(i);
        });
    }
    resetPassword(e, r) {
        return this._service.xrpc.call("com.atproto.server.resetPassword", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$pI.toKnownErr(i);
        });
    }
    revokeAppPassword(e, r) {
        return this._service.xrpc.call("com.atproto.server.revokeAppPassword", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$hI.toKnownErr(i);
        });
    }
    updateEmail(e, r) {
        return this._service.xrpc.call("com.atproto.server.updateEmail", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$mI.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ComAtprotoServerNS = $aec35899a3c9695e$var$im;
class $aec35899a3c9695e$var$nm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    getBlob(e, r) {
        return this._service.xrpc.call("com.atproto.sync.getBlob", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$yI.toKnownErr(i);
        });
    }
    getBlocks(e, r) {
        return this._service.xrpc.call("com.atproto.sync.getBlocks", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$bI.toKnownErr(i);
        });
    }
    getCheckout(e, r) {
        return this._service.xrpc.call("com.atproto.sync.getCheckout", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$gI.toKnownErr(i);
        });
    }
    getHead(e, r) {
        return this._service.xrpc.call("com.atproto.sync.getHead", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$xI.toKnownErr(i);
        });
    }
    getLatestCommit(e, r) {
        return this._service.xrpc.call("com.atproto.sync.getLatestCommit", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$EI.toKnownErr(i);
        });
    }
    getRecord(e, r) {
        return this._service.xrpc.call("com.atproto.sync.getRecord", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$vI.toKnownErr(i);
        });
    }
    getRepo(e, r) {
        return this._service.xrpc.call("com.atproto.sync.getRepo", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$RI.toKnownErr(i);
        });
    }
    getRepoStatus(e, r) {
        return this._service.xrpc.call("com.atproto.sync.getRepoStatus", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$AI.toKnownErr(i);
        });
    }
    listBlobs(e, r) {
        return this._service.xrpc.call("com.atproto.sync.listBlobs", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$_I.toKnownErr(i);
        });
    }
    listRepos(e, r) {
        return this._service.xrpc.call("com.atproto.sync.listRepos", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$wI.toKnownErr(i);
        });
    }
    notifyOfUpdate(e, r) {
        return this._service.xrpc.call("com.atproto.sync.notifyOfUpdate", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$TI.toKnownErr(i);
        });
    }
    requestCrawl(e, r) {
        return this._service.xrpc.call("com.atproto.sync.requestCrawl", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$SI.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ComAtprotoSyncNS = $aec35899a3c9695e$var$nm;
class $aec35899a3c9695e$var$sm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    checkSignupQueue(e, r) {
        return this._service.xrpc.call("com.atproto.temp.checkSignupQueue", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$CI.toKnownErr(i);
        });
    }
    fetchLabels(e, r) {
        return this._service.xrpc.call("com.atproto.temp.fetchLabels", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$LI.toKnownErr(i);
        });
    }
    requestPhoneVerification(e, r) {
        return this._service.xrpc.call("com.atproto.temp.requestPhoneVerification", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$kI.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ComAtprotoTempNS = $aec35899a3c9695e$var$sm;
class $aec35899a3c9695e$var$am {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "bsky", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.bsky = new $aec35899a3c9695e$var$om(e);
    }
}
$aec35899a3c9695e$var$x.AppNS = $aec35899a3c9695e$var$am;
class $aec35899a3c9695e$var$om {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "actor", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "embed", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "feed", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "graph", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "labeler", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "notification", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "richtext", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "unspecced", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.actor = new $aec35899a3c9695e$var$lm(e), this.embed = new $aec35899a3c9695e$var$cm(e), this.feed = new $aec35899a3c9695e$var$dm(e), this.graph = new $aec35899a3c9695e$var$bm(e), this.labeler = new $aec35899a3c9695e$var$_m(e), this.notification = new $aec35899a3c9695e$var$Tm(e), this.richtext = new $aec35899a3c9695e$var$Sm(e), this.unspecced = new $aec35899a3c9695e$var$Cm(e);
    }
}
$aec35899a3c9695e$var$x.AppBskyNS = $aec35899a3c9695e$var$om;
class $aec35899a3c9695e$var$lm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "profile", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.profile = new $aec35899a3c9695e$var$um(e);
    }
    getPreferences(e, r) {
        return this._service.xrpc.call("app.bsky.actor.getPreferences", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$DI.toKnownErr(i);
        });
    }
    getProfile(e, r) {
        return this._service.xrpc.call("app.bsky.actor.getProfile", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$PI.toKnownErr(i);
        });
    }
    getProfiles(e, r) {
        return this._service.xrpc.call("app.bsky.actor.getProfiles", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$BI.toKnownErr(i);
        });
    }
    getSuggestions(e, r) {
        return this._service.xrpc.call("app.bsky.actor.getSuggestions", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$II.toKnownErr(i);
        });
    }
    putPreferences(e, r) {
        return this._service.xrpc.call("app.bsky.actor.putPreferences", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$UI.toKnownErr(i);
        });
    }
    searchActors(e, r) {
        return this._service.xrpc.call("app.bsky.actor.searchActors", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$OI.toKnownErr(i);
        });
    }
    searchActorsTypeahead(e, r) {
        return this._service.xrpc.call("app.bsky.actor.searchActorsTypeahead", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$KI.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.AppBskyActorNS = $aec35899a3c9695e$var$lm;
class $aec35899a3c9695e$var$um {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.actor.profile",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.actor.profile",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.actor.profile", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.actor.profile",
            rkey: "self",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.actor.profile",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.ProfileRecord = $aec35899a3c9695e$var$um;
class $aec35899a3c9695e$var$cm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
}
$aec35899a3c9695e$var$x.AppBskyEmbedNS = $aec35899a3c9695e$var$cm;
class $aec35899a3c9695e$var$dm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "generator", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "like", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "post", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "repost", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "threadgate", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.generator = new $aec35899a3c9695e$var$fm(e), this.like = new $aec35899a3c9695e$var$pm(e), this.post = new $aec35899a3c9695e$var$hm(e), this.repost = new $aec35899a3c9695e$var$mm(e), this.threadgate = new $aec35899a3c9695e$var$ym(e);
    }
    describeFeedGenerator(e, r) {
        return this._service.xrpc.call("app.bsky.feed.describeFeedGenerator", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$MI.toKnownErr(i);
        });
    }
    getActorFeeds(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getActorFeeds", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$NI.toKnownErr(i);
        });
    }
    getActorLikes(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getActorLikes", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$VI.toKnownErr(i);
        });
    }
    getAuthorFeed(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getAuthorFeed", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$jI.toKnownErr(i);
        });
    }
    getFeed(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getFeed", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$FI.toKnownErr(i);
        });
    }
    getFeedGenerator(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getFeedGenerator", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$$I.toKnownErr(i);
        });
    }
    getFeedGenerators(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getFeedGenerators", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$GI.toKnownErr(i);
        });
    }
    getFeedSkeleton(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getFeedSkeleton", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$qI.toKnownErr(i);
        });
    }
    getLikes(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getLikes", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$zI.toKnownErr(i);
        });
    }
    getListFeed(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getListFeed", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$XI.toKnownErr(i);
        });
    }
    getPostThread(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getPostThread", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$HI.toKnownErr(i);
        });
    }
    getPosts(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getPosts", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$ZI.toKnownErr(i);
        });
    }
    getRepostedBy(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getRepostedBy", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$WI.toKnownErr(i);
        });
    }
    getSuggestedFeeds(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getSuggestedFeeds", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$YI.toKnownErr(i);
        });
    }
    getTimeline(e, r) {
        return this._service.xrpc.call("app.bsky.feed.getTimeline", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$JI.toKnownErr(i);
        });
    }
    searchPosts(e, r) {
        return this._service.xrpc.call("app.bsky.feed.searchPosts", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$QI.toKnownErr(i);
        });
    }
    sendInteractions(e, r) {
        return this._service.xrpc.call("app.bsky.feed.sendInteractions", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$eU.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.AppBskyFeedNS = $aec35899a3c9695e$var$dm;
class $aec35899a3c9695e$var$fm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.feed.generator",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.feed.generator",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.feed.generator", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.feed.generator",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.feed.generator",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.GeneratorRecord = $aec35899a3c9695e$var$fm;
class $aec35899a3c9695e$var$pm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.feed.like",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.feed.like",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.feed.like", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.feed.like",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.feed.like",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.LikeRecord = $aec35899a3c9695e$var$pm;
class $aec35899a3c9695e$var$hm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.feed.post",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.feed.post",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.feed.post", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.feed.post",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.feed.post",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.PostRecord = $aec35899a3c9695e$var$hm;
class $aec35899a3c9695e$var$mm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.feed.repost",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.feed.repost",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.feed.repost", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.feed.repost",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.feed.repost",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.RepostRecord = $aec35899a3c9695e$var$mm;
class $aec35899a3c9695e$var$ym {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.feed.threadgate",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.feed.threadgate",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.feed.threadgate", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.feed.threadgate",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.feed.threadgate",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.ThreadgateRecord = $aec35899a3c9695e$var$ym;
class $aec35899a3c9695e$var$bm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "block", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "follow", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "listblock", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "listitem", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "starterpack", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.block = new $aec35899a3c9695e$var$gm(e), this.follow = new $aec35899a3c9695e$var$xm(e), this.list = new $aec35899a3c9695e$var$Em(e), this.listblock = new $aec35899a3c9695e$var$vm(e), this.listitem = new $aec35899a3c9695e$var$Rm(e), this.starterpack = new $aec35899a3c9695e$var$Am(e);
    }
    getActorStarterPacks(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getActorStarterPacks", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$tU.toKnownErr(i);
        });
    }
    getBlocks(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getBlocks", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$rU.toKnownErr(i);
        });
    }
    getFollowers(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getFollowers", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$iU.toKnownErr(i);
        });
    }
    getFollows(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getFollows", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$nU.toKnownErr(i);
        });
    }
    getKnownFollowers(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getKnownFollowers", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$sU.toKnownErr(i);
        });
    }
    getList(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getList", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$aU.toKnownErr(i);
        });
    }
    getListBlocks(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getListBlocks", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$oU.toKnownErr(i);
        });
    }
    getListMutes(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getListMutes", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$lU.toKnownErr(i);
        });
    }
    getLists(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getLists", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$uU.toKnownErr(i);
        });
    }
    getMutes(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getMutes", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$cU.toKnownErr(i);
        });
    }
    getRelationships(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getRelationships", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$dU.toKnownErr(i);
        });
    }
    getStarterPack(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getStarterPack", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$fU.toKnownErr(i);
        });
    }
    getStarterPacks(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getStarterPacks", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$pU.toKnownErr(i);
        });
    }
    getSuggestedFollowsByActor(e, r) {
        return this._service.xrpc.call("app.bsky.graph.getSuggestedFollowsByActor", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$hU.toKnownErr(i);
        });
    }
    muteActor(e, r) {
        return this._service.xrpc.call("app.bsky.graph.muteActor", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$mU.toKnownErr(i);
        });
    }
    muteActorList(e, r) {
        return this._service.xrpc.call("app.bsky.graph.muteActorList", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$yU.toKnownErr(i);
        });
    }
    muteThread(e, r) {
        return this._service.xrpc.call("app.bsky.graph.muteThread", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$bU.toKnownErr(i);
        });
    }
    unmuteActor(e, r) {
        return this._service.xrpc.call("app.bsky.graph.unmuteActor", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$gU.toKnownErr(i);
        });
    }
    unmuteActorList(e, r) {
        return this._service.xrpc.call("app.bsky.graph.unmuteActorList", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$xU.toKnownErr(i);
        });
    }
    unmuteThread(e, r) {
        return this._service.xrpc.call("app.bsky.graph.unmuteThread", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$EU.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.AppBskyGraphNS = $aec35899a3c9695e$var$bm;
class $aec35899a3c9695e$var$gm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.graph.block",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.graph.block",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.graph.block", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.graph.block",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.graph.block",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.BlockRecord = $aec35899a3c9695e$var$gm;
class $aec35899a3c9695e$var$xm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.graph.follow",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.graph.follow",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.graph.follow", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.graph.follow",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.graph.follow",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.FollowRecord = $aec35899a3c9695e$var$xm;
class $aec35899a3c9695e$var$Em {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.graph.list",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.graph.list",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.graph.list", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.graph.list",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.graph.list",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.ListRecord = $aec35899a3c9695e$var$Em;
class $aec35899a3c9695e$var$vm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.graph.listblock",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.graph.listblock",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.graph.listblock", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.graph.listblock",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.graph.listblock",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.ListblockRecord = $aec35899a3c9695e$var$vm;
class $aec35899a3c9695e$var$Rm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.graph.listitem",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.graph.listitem",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.graph.listitem", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.graph.listitem",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.graph.listitem",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.ListitemRecord = $aec35899a3c9695e$var$Rm;
class $aec35899a3c9695e$var$Am {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.graph.starterpack",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.graph.starterpack",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.graph.starterpack", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.graph.starterpack",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.graph.starterpack",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.StarterpackRecord = $aec35899a3c9695e$var$Am;
class $aec35899a3c9695e$var$_m {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.service = new $aec35899a3c9695e$var$wm(e);
    }
    getServices(e, r) {
        return this._service.xrpc.call("app.bsky.labeler.getServices", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$vU.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.AppBskyLabelerNS = $aec35899a3c9695e$var$_m;
class $aec35899a3c9695e$var$wm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "app.bsky.labeler.service",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "app.bsky.labeler.service",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "app.bsky.labeler.service", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "app.bsky.labeler.service",
            rkey: "self",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "app.bsky.labeler.service",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.ServiceRecord = $aec35899a3c9695e$var$wm;
class $aec35899a3c9695e$var$Tm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    getUnreadCount(e, r) {
        return this._service.xrpc.call("app.bsky.notification.getUnreadCount", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$RU.toKnownErr(i);
        });
    }
    listNotifications(e, r) {
        return this._service.xrpc.call("app.bsky.notification.listNotifications", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$AU.toKnownErr(i);
        });
    }
    putPreferences(e, r) {
        return this._service.xrpc.call("app.bsky.notification.putPreferences", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$_U.toKnownErr(i);
        });
    }
    registerPush(e, r) {
        return this._service.xrpc.call("app.bsky.notification.registerPush", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$wU.toKnownErr(i);
        });
    }
    updateSeen(e, r) {
        return this._service.xrpc.call("app.bsky.notification.updateSeen", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$TU.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.AppBskyNotificationNS = $aec35899a3c9695e$var$Tm;
class $aec35899a3c9695e$var$Sm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
}
$aec35899a3c9695e$var$x.AppBskyRichtextNS = $aec35899a3c9695e$var$Sm;
class $aec35899a3c9695e$var$Cm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    getPopularFeedGenerators(e, r) {
        return this._service.xrpc.call("app.bsky.unspecced.getPopularFeedGenerators", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$SU.toKnownErr(i);
        });
    }
    getSuggestionsSkeleton(e, r) {
        return this._service.xrpc.call("app.bsky.unspecced.getSuggestionsSkeleton", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$CU.toKnownErr(i);
        });
    }
    getTaggedSuggestions(e, r) {
        return this._service.xrpc.call("app.bsky.unspecced.getTaggedSuggestions", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$LU.toKnownErr(i);
        });
    }
    searchActorsSkeleton(e, r) {
        return this._service.xrpc.call("app.bsky.unspecced.searchActorsSkeleton", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$kU.toKnownErr(i);
        });
    }
    searchPostsSkeleton(e, r) {
        return this._service.xrpc.call("app.bsky.unspecced.searchPostsSkeleton", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$DU.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.AppBskyUnspeccedNS = $aec35899a3c9695e$var$Cm;
class $aec35899a3c9695e$var$Lm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "bsky", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.bsky = new $aec35899a3c9695e$var$km(e);
    }
}
$aec35899a3c9695e$var$x.ChatNS = $aec35899a3c9695e$var$Lm;
class $aec35899a3c9695e$var$km {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "actor", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "convo", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moderation", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.actor = new $aec35899a3c9695e$var$Dm(e), this.convo = new $aec35899a3c9695e$var$Bm(e), this.moderation = new $aec35899a3c9695e$var$Im(e);
    }
}
$aec35899a3c9695e$var$x.ChatBskyNS = $aec35899a3c9695e$var$km;
class $aec35899a3c9695e$var$Dm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "declaration", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.declaration = new $aec35899a3c9695e$var$Pm(e);
    }
    deleteAccount(e, r) {
        return this._service.xrpc.call("chat.bsky.actor.deleteAccount", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$PU.toKnownErr(i);
        });
    }
    exportAccountData(e, r) {
        return this._service.xrpc.call("chat.bsky.actor.exportAccountData", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$BU.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ChatBskyActorNS = $aec35899a3c9695e$var$Dm;
class $aec35899a3c9695e$var$Pm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    async list(e) {
        return (await this._service.xrpc.call("com.atproto.repo.listRecords", {
            collection: "chat.bsky.actor.declaration",
            ...e
        })).data;
    }
    async get(e) {
        return (await this._service.xrpc.call("com.atproto.repo.getRecord", {
            collection: "chat.bsky.actor.declaration",
            ...e
        })).data;
    }
    async create(e, r, i) {
        return r.$type = "chat.bsky.actor.declaration", (await this._service.xrpc.call("com.atproto.repo.createRecord", void 0, {
            collection: "chat.bsky.actor.declaration",
            rkey: "self",
            ...e,
            record: r
        }, {
            encoding: "application/json",
            headers: i
        })).data;
    }
    async delete(e, r) {
        await this._service.xrpc.call("com.atproto.repo.deleteRecord", void 0, {
            collection: "chat.bsky.actor.declaration",
            ...e
        }, {
            headers: r
        });
    }
}
$aec35899a3c9695e$var$x.DeclarationRecord = $aec35899a3c9695e$var$Pm;
class $aec35899a3c9695e$var$Bm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    deleteMessageForSelf(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.deleteMessageForSelf", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$IU.toKnownErr(i);
        });
    }
    getConvo(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.getConvo", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$UU.toKnownErr(i);
        });
    }
    getConvoForMembers(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.getConvoForMembers", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$OU.toKnownErr(i);
        });
    }
    getLog(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.getLog", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$KU.toKnownErr(i);
        });
    }
    getMessages(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.getMessages", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$MU.toKnownErr(i);
        });
    }
    leaveConvo(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.leaveConvo", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$NU.toKnownErr(i);
        });
    }
    listConvos(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.listConvos", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$VU.toKnownErr(i);
        });
    }
    muteConvo(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.muteConvo", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$jU.toKnownErr(i);
        });
    }
    sendMessage(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.sendMessage", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$FU.toKnownErr(i);
        });
    }
    sendMessageBatch(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.sendMessageBatch", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$$U.toKnownErr(i);
        });
    }
    unmuteConvo(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.unmuteConvo", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$GU.toKnownErr(i);
        });
    }
    updateRead(e, r) {
        return this._service.xrpc.call("chat.bsky.convo.updateRead", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$qU.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ChatBskyConvoNS = $aec35899a3c9695e$var$Bm;
class $aec35899a3c9695e$var$Im {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    getActorMetadata(e, r) {
        return this._service.xrpc.call("chat.bsky.moderation.getActorMetadata", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$zU.toKnownErr(i);
        });
    }
    getMessageContext(e, r) {
        return this._service.xrpc.call("chat.bsky.moderation.getMessageContext", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$XU.toKnownErr(i);
        });
    }
    updateActorAccess(e, r) {
        return this._service.xrpc.call("chat.bsky.moderation.updateActorAccess", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$HU.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ChatBskyModerationNS = $aec35899a3c9695e$var$Im;
class $aec35899a3c9695e$var$Um {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "ozone", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.ozone = new $aec35899a3c9695e$var$Om(e);
    }
}
$aec35899a3c9695e$var$x.ToolsNS = $aec35899a3c9695e$var$Um;
class $aec35899a3c9695e$var$Om {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "communication", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moderation", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "server", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "team", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e, this.communication = new $aec35899a3c9695e$var$Km(e), this.moderation = new $aec35899a3c9695e$var$Mm(e), this.server = new $aec35899a3c9695e$var$Nm(e), this.team = new $aec35899a3c9695e$var$Vm(e);
    }
}
$aec35899a3c9695e$var$x.ToolsOzoneNS = $aec35899a3c9695e$var$Om;
class $aec35899a3c9695e$var$Km {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    createTemplate(e, r) {
        return this._service.xrpc.call("tools.ozone.communication.createTemplate", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$ZU.toKnownErr(i);
        });
    }
    deleteTemplate(e, r) {
        return this._service.xrpc.call("tools.ozone.communication.deleteTemplate", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$WU.toKnownErr(i);
        });
    }
    listTemplates(e, r) {
        return this._service.xrpc.call("tools.ozone.communication.listTemplates", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$YU.toKnownErr(i);
        });
    }
    updateTemplate(e, r) {
        return this._service.xrpc.call("tools.ozone.communication.updateTemplate", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$JU.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ToolsOzoneCommunicationNS = $aec35899a3c9695e$var$Km;
class $aec35899a3c9695e$var$Mm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    emitEvent(e, r) {
        return this._service.xrpc.call("tools.ozone.moderation.emitEvent", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$QU.toKnownErr(i);
        });
    }
    getEvent(e, r) {
        return this._service.xrpc.call("tools.ozone.moderation.getEvent", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$eO.toKnownErr(i);
        });
    }
    getRecord(e, r) {
        return this._service.xrpc.call("tools.ozone.moderation.getRecord", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$tO.toKnownErr(i);
        });
    }
    getRepo(e, r) {
        return this._service.xrpc.call("tools.ozone.moderation.getRepo", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$rO.toKnownErr(i);
        });
    }
    queryEvents(e, r) {
        return this._service.xrpc.call("tools.ozone.moderation.queryEvents", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$iO.toKnownErr(i);
        });
    }
    queryStatuses(e, r) {
        return this._service.xrpc.call("tools.ozone.moderation.queryStatuses", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$nO.toKnownErr(i);
        });
    }
    searchRepos(e, r) {
        return this._service.xrpc.call("tools.ozone.moderation.searchRepos", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$sO.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ToolsOzoneModerationNS = $aec35899a3c9695e$var$Mm;
class $aec35899a3c9695e$var$Nm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    getConfig(e, r) {
        return this._service.xrpc.call("tools.ozone.server.getConfig", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$aO.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ToolsOzoneServerNS = $aec35899a3c9695e$var$Nm;
class $aec35899a3c9695e$var$Vm {
    constructor(e){
        Object.defineProperty(this, "_service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this._service = e;
    }
    addMember(e, r) {
        return this._service.xrpc.call("tools.ozone.team.addMember", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$oO.toKnownErr(i);
        });
    }
    deleteMember(e, r) {
        return this._service.xrpc.call("tools.ozone.team.deleteMember", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$lO.toKnownErr(i);
        });
    }
    listMembers(e, r) {
        return this._service.xrpc.call("tools.ozone.team.listMembers", e, void 0, r).catch((i)=>{
            throw $aec35899a3c9695e$var$uO.toKnownErr(i);
        });
    }
    updateMember(e, r) {
        return this._service.xrpc.call("tools.ozone.team.updateMember", r?.qp, e, r).catch((i)=>{
            throw $aec35899a3c9695e$var$cO.toKnownErr(i);
        });
    }
}
$aec35899a3c9695e$var$x.ToolsOzoneTeamNS = $aec35899a3c9695e$var$Vm;
var $aec35899a3c9695e$var$js = {};
Object.defineProperty($aec35899a3c9695e$var$js, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$js.AtpAgent = void 0;
const $aec35899a3c9695e$var$fO = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$au = $aec35899a3c9695e$var$G, $aec35899a3c9695e$var$hf = $aec35899a3c9695e$var$vi, $aec35899a3c9695e$var$pO = $aec35899a3c9695e$var$x, $aec35899a3c9695e$var$hO = $aec35899a3c9695e$var$ka, $aec35899a3c9695e$var$mO = "com.atproto.server.refreshSession";
class $aec35899a3c9695e$var$vr {
    get com() {
        return this.api.com;
    }
    /**
   * Configures the API globally.
   */ static configure(e) {
        e.fetch && ($aec35899a3c9695e$var$vr.fetch = e.fetch), e.appLabelers && ($aec35899a3c9695e$var$vr.appLabelers = e.appLabelers);
    }
    constructor(e){
        Object.defineProperty(this, "service", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "api", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "session", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "labelersHeader", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "proxyHeader", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pdsUrl", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "_baseClient", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "_persistSession", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "_refreshSessionPromise", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "uploadBlob", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (r, i)=>this.api.com.atproto.repo.uploadBlob(r, i)
        }), Object.defineProperty(this, "resolveHandle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (r, i)=>this.api.com.atproto.identity.resolveHandle(r, i)
        }), Object.defineProperty(this, "updateHandle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (r, i)=>this.api.com.atproto.identity.updateHandle(r, i)
        }), Object.defineProperty(this, "createModerationReport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (r, i)=>this.api.com.atproto.moderation.createReport(r, i)
        }), this.service = e.service instanceof URL ? e.service : new URL(e.service), this._persistSession = e.persistSession, this._baseClient = new $aec35899a3c9695e$var$pO.AtpBaseClient(), this._baseClient.xrpc.fetch = this._fetch.bind(this), this.api = this._baseClient.service(e.service);
    }
    clone() {
        const e = new $aec35899a3c9695e$var$vr({
            service: this.service
        });
        return this.copyInto(e), e;
    }
    copyInto(e) {
        e.session = this.session, e.labelersHeader = this.labelersHeader, e.proxyHeader = this.proxyHeader, e.pdsUrl = this.pdsUrl, e.api.xrpc.uri = this.pdsUrl || this.service;
    }
    withProxy(e, r) {
        const i = this.clone();
        return i.configureProxyHeader(e, r), i;
    }
    /**
   * Is there any active session?
   */ get hasSession() {
        return !!this.session;
    }
    /**
   * Sets the "Persist Session" method which can be used to store access tokens
   * as they change.
   */ setPersistSessionHandler(e) {
        this._persistSession = e;
    }
    /**
   * Configures the moderation services to be applied on requests.
   * NOTE: this is called automatically by getPreferences() and the relevant moderation config
   * methods in BskyAgent instances.
   */ configureLabelersHeader(e) {
        this.labelersHeader = e;
    }
    /**
   * Configures the atproto-proxy header to be applied on requests
   */ configureProxyHeader(e, r) {
        r.startsWith("did:") && (this.proxyHeader = `${r}#${e}`);
    }
    /**
   * Create a new account and hydrate its session in this agent.
   */ async createAccount(e) {
        try {
            const r = await this.api.com.atproto.server.createAccount(e);
            return this.session = {
                accessJwt: r.data.accessJwt,
                refreshJwt: r.data.refreshJwt,
                handle: r.data.handle,
                did: r.data.did,
                email: e.email,
                emailConfirmed: !1,
                emailAuthFactor: !1,
                active: !0
            }, this._updateApiEndpoint(r.data.didDoc), r;
        } catch (r) {
            throw this.session = void 0, r;
        } finally{
            this.session ? this._persistSession?.("create", this.session) : this._persistSession?.("create-failed", void 0);
        }
    }
    /**
   * Start a new session with this agent.
   */ async login(e) {
        try {
            const r = await this.api.com.atproto.server.createSession({
                identifier: e.identifier,
                password: e.password,
                authFactorToken: e.authFactorToken
            });
            return this.session = {
                accessJwt: r.data.accessJwt,
                refreshJwt: r.data.refreshJwt,
                handle: r.data.handle,
                did: r.data.did,
                email: r.data.email,
                emailConfirmed: r.data.emailConfirmed,
                emailAuthFactor: r.data.emailAuthFactor,
                active: r.data.active ?? !0,
                status: r.data.status
            }, this._updateApiEndpoint(r.data.didDoc), r;
        } catch (r) {
            throw this.session = void 0, r;
        } finally{
            this.session ? this._persistSession?.("create", this.session) : this._persistSession?.("create-failed", void 0);
        }
    }
    /**
   * Resume a pre-existing session with this agent.
   */ async resumeSession(e) {
        try {
            this.session = e;
            const r = await this.api.com.atproto.server.getSession();
            if (r.data.did !== this.session.did) throw new $aec35899a3c9695e$var$au.XRPCError($aec35899a3c9695e$var$au.ResponseType.InvalidRequest, "Invalid session", "InvalidDID");
            return this.session.email = r.data.email, this.session.handle = r.data.handle, this.session.emailConfirmed = r.data.emailConfirmed, this.session.emailAuthFactor = r.data.emailAuthFactor, this.session.active = r.data.active ?? !0, this.session.status = r.data.status, this._updateApiEndpoint(r.data.didDoc), this._persistSession?.("update", this.session), r;
        } catch (r) {
            throw this.session = void 0, r instanceof $aec35899a3c9695e$var$au.XRPCError ? [
                1,
                408,
                425,
                429,
                500,
                502,
                503,
                504,
                522,
                524
            ].includes(r.status) ? this._persistSession?.("network-error", void 0) : this._persistSession?.("expired", void 0) : this._persistSession?.("network-error", void 0), r;
        }
    }
    /**
   * Internal helper to add authorization headers to requests.
   */ _addHeaders(e) {
        !e.authorization && this.session?.accessJwt && (e = {
            ...e,
            authorization: `Bearer ${this.session.accessJwt}`
        }), this.proxyHeader && (e = {
            ...e,
            "atproto-proxy": this.proxyHeader
        });
        const r = "atproto-accept-labelers", i = $aec35899a3c9695e$var$vr.appLabelers.map((a)=>`${a};redact`).concat(this.labelersHeader.filter((a)=>a.startsWith("did:")));
        return e[r] && i.push(...e[r].split(",").map((a)=>a.trim())), e = {
            ...e,
            [r]: i.join(", ")
        }, e;
    }
    /**
   * Internal fetch handler which adds access-token management
   */ async _fetch(e, r, i, a) {
        if (!$aec35899a3c9695e$var$vr.fetch) throw new Error("AtpAgent fetch() method not configured");
        await this._refreshSessionPromise;
        let c = await $aec35899a3c9695e$var$vr.fetch(e, r, this._addHeaders(i), a);
        return $aec35899a3c9695e$var$mf(c, [
            "ExpiredToken"
        ]) && this.session?.refreshJwt && (await this.refreshSession(), c = await $aec35899a3c9695e$var$vr.fetch(e, r, this._addHeaders(i), a)), c;
    }
    /**
   * Internal helper to refresh sessions
   * - Wraps the actual implementation in a promise-guard to ensure only
   *   one refresh is attempted at a time.
   */ async refreshSession() {
        if (this._refreshSessionPromise) return this._refreshSessionPromise;
        this._refreshSessionPromise = this._refreshSessionInner();
        try {
            await this._refreshSessionPromise;
        } finally{
            this._refreshSessionPromise = void 0;
        }
    }
    /**
   * Internal helper to refresh sessions (actual behavior)
   */ async _refreshSessionInner() {
        if (!$aec35899a3c9695e$var$vr.fetch) throw new Error("AtpAgent fetch() method not configured");
        if (!this.session?.refreshJwt) return;
        const e = new URL((this.pdsUrl || this.service).origin);
        e.pathname = `/xrpc/${$aec35899a3c9695e$var$mO}`;
        const r = await $aec35899a3c9695e$var$vr.fetch(e.toString(), "POST", {
            authorization: `Bearer ${this.session.refreshJwt}`
        }, void 0);
        $aec35899a3c9695e$var$mf(r, [
            "ExpiredToken",
            "InvalidToken"
        ]) ? (this.session = void 0, this._persistSession?.("expired", void 0)) : $aec35899a3c9695e$var$bO(this._baseClient, r.body) && (this.session = {
            ...this.session || {},
            accessJwt: r.body.accessJwt,
            refreshJwt: r.body.refreshJwt,
            handle: r.body.handle,
            did: r.body.did
        }, this._updateApiEndpoint(r.body.didDoc), this._persistSession?.("update", this.session));
    }
    /**
   * Helper to update the pds endpoint dynamically.
   *
   * The session methods (create, resume, refresh) may respond with the user's
   * did document which contains the user's canonical PDS endpoint. That endpoint
   * may differ from the endpoint used to contact the server. We capture that
   * PDS endpoint and update the client to use that given endpoint for future
   * requests. (This helps ensure smooth migrations between PDSes, especially
   * when the PDSes are operated by a single org.)
   */ _updateApiEndpoint(e) {
        if ((0, $aec35899a3c9695e$var$hf.isValidDidDoc)(e)) {
            const r = (0, $aec35899a3c9695e$var$hf.getPdsEndpoint)(e);
            this.pdsUrl = r ? new URL(r) : void 0;
        }
        this.api.xrpc.uri = this.pdsUrl || this.service;
    }
}
$aec35899a3c9695e$var$js.AtpAgent = $aec35899a3c9695e$var$vr;
Object.defineProperty($aec35899a3c9695e$var$vr, "fetch", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $aec35899a3c9695e$var$au.defaultFetchHandler
});
Object.defineProperty($aec35899a3c9695e$var$vr, "appLabelers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: [
        $aec35899a3c9695e$var$hO.BSKY_LABELER_DID
    ]
});
function $aec35899a3c9695e$var$yO(t) {
    return $aec35899a3c9695e$var$fO.errorResponseBody.safeParse(t).success;
}
function $aec35899a3c9695e$var$mf(t, e) {
    return t.status !== 400 || !$aec35899a3c9695e$var$yO(t.body) ? !1 : typeof t.body.error == "string" && e.includes(t.body.error);
}
function $aec35899a3c9695e$var$bO(t, e) {
    try {
        return t.xrpc.lex.assertValidXrpcOutput("com.atproto.server.refreshSession", e), !0;
    } catch  {
        return !1;
    }
}
var $aec35899a3c9695e$var$Fs = {}, $aec35899a3c9695e$var$Hs = {};
Object.defineProperty($aec35899a3c9695e$var$Hs, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Hs.UnicodeString = void 0;
const $aec35899a3c9695e$var$gO = $aec35899a3c9695e$var$vi, $aec35899a3c9695e$var$yf = new TextEncoder(), $aec35899a3c9695e$var$xO = new TextDecoder();
class $aec35899a3c9695e$var$EO {
    constructor(e){
        Object.defineProperty(this, "utf16", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "utf8", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "_graphemeLen", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.utf16 = e, this.utf8 = $aec35899a3c9695e$var$yf.encode(e);
    }
    get length() {
        return this.utf8.byteLength;
    }
    get graphemeLength() {
        return this._graphemeLen || (this._graphemeLen = (0, $aec35899a3c9695e$var$gO.graphemeLen)(this.utf16)), this._graphemeLen;
    }
    slice(e, r) {
        return $aec35899a3c9695e$var$xO.decode(this.utf8.slice(e, r));
    }
    utf16IndexToUtf8Index(e) {
        return $aec35899a3c9695e$var$yf.encode(this.utf16.slice(0, e)).byteLength;
    }
    toString() {
        return this.utf16;
    }
}
$aec35899a3c9695e$var$Hs.UnicodeString = $aec35899a3c9695e$var$EO;
var $aec35899a3c9695e$var$jl = {};
Object.defineProperty($aec35899a3c9695e$var$jl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$jl.sanitizeRichText = void 0;
const $aec35899a3c9695e$var$vO = $aec35899a3c9695e$var$Hs, $aec35899a3c9695e$var$RO = /[\r\n]([\u00AD\u2060\u200D\u200C\u200B\s]*[\r\n]){2,}/, $aec35899a3c9695e$var$AO = `

`;
function $aec35899a3c9695e$var$_O(t, e) {
    return e.cleanNewlines && (t = $aec35899a3c9695e$var$wO(t, $aec35899a3c9695e$var$RO, $aec35899a3c9695e$var$AO)), t;
}
$aec35899a3c9695e$var$jl.sanitizeRichText = $aec35899a3c9695e$var$_O;
function $aec35899a3c9695e$var$wO(t, e, r) {
    t = t.clone();
    let i = t.unicodeText.utf16.match(e);
    for(; i && typeof i.index < "u";){
        const a = t.unicodeText, c = t.unicodeText.utf16IndexToUtf8Index(i.index), h = c + new $aec35899a3c9695e$var$vO.UnicodeString(i[0]).length;
        if (t.delete(c, h), t.unicodeText.utf16 === a.utf16) break;
        t.insert(c, r), i = t.unicodeText.utf16.match(e);
    }
    return t;
}
var $aec35899a3c9695e$var$$u = {};
const $aec35899a3c9695e$var$TO = [
    "aaa",
    "aarp",
    "abb",
    "abbott",
    "abbvie",
    "abc",
    "able",
    "abogado",
    "abudhabi",
    "ac",
    "academy",
    "accenture",
    "accountant",
    "accountants",
    "aco",
    "actor",
    "ad",
    "ads",
    "adult",
    "ae",
    "aeg",
    "aero",
    "aetna",
    "af",
    "afl",
    "africa",
    "ag",
    "agakhan",
    "agency",
    "ai",
    "aig",
    "airbus",
    "airforce",
    "airtel",
    "akdn",
    "al",
    "alibaba",
    "alipay",
    "allfinanz",
    "allstate",
    "ally",
    "alsace",
    "alstom",
    "am",
    "amazon",
    "americanexpress",
    "americanfamily",
    "amex",
    "amfam",
    "amica",
    "amsterdam",
    "analytics",
    "android",
    "anquan",
    "anz",
    "ao",
    "aol",
    "apartments",
    "app",
    "apple",
    "aq",
    "aquarelle",
    "ar",
    "arab",
    "aramco",
    "archi",
    "army",
    "arpa",
    "art",
    "arte",
    "as",
    "asda",
    "asia",
    "associates",
    "at",
    "athleta",
    "attorney",
    "au",
    "auction",
    "audi",
    "audible",
    "audio",
    "auspost",
    "author",
    "auto",
    "autos",
    "aw",
    "aws",
    "ax",
    "axa",
    "az",
    "azure",
    "ba",
    "baby",
    "baidu",
    "banamex",
    "band",
    "bank",
    "bar",
    "barcelona",
    "barclaycard",
    "barclays",
    "barefoot",
    "bargains",
    "baseball",
    "basketball",
    "bauhaus",
    "bayern",
    "bb",
    "bbc",
    "bbt",
    "bbva",
    "bcg",
    "bcn",
    "bd",
    "be",
    "beats",
    "beauty",
    "beer",
    "bentley",
    "berlin",
    "best",
    "bestbuy",
    "bet",
    "bf",
    "bg",
    "bh",
    "bharti",
    "bi",
    "bible",
    "bid",
    "bike",
    "bing",
    "bingo",
    "bio",
    "biz",
    "bj",
    "black",
    "blackfriday",
    "blockbuster",
    "blog",
    "bloomberg",
    "blue",
    "bm",
    "bms",
    "bmw",
    "bn",
    "bnpparibas",
    "bo",
    "boats",
    "boehringer",
    "bofa",
    "bom",
    "bond",
    "boo",
    "book",
    "booking",
    "bosch",
    "bostik",
    "boston",
    "bot",
    "boutique",
    "box",
    "br",
    "bradesco",
    "bridgestone",
    "broadway",
    "broker",
    "brother",
    "brussels",
    "bs",
    "bt",
    "build",
    "builders",
    "business",
    "buy",
    "buzz",
    "bv",
    "bw",
    "by",
    "bz",
    "bzh",
    "ca",
    "cab",
    "cafe",
    "cal",
    "call",
    "calvinklein",
    "cam",
    "camera",
    "camp",
    "canon",
    "capetown",
    "capital",
    "capitalone",
    "car",
    "caravan",
    "cards",
    "care",
    "career",
    "careers",
    "cars",
    "casa",
    "case",
    "cash",
    "casino",
    "cat",
    "catering",
    "catholic",
    "cba",
    "cbn",
    "cbre",
    "cc",
    "cd",
    "center",
    "ceo",
    "cern",
    "cf",
    "cfa",
    "cfd",
    "cg",
    "ch",
    "chanel",
    "channel",
    "charity",
    "chase",
    "chat",
    "cheap",
    "chintai",
    "christmas",
    "chrome",
    "church",
    "ci",
    "cipriani",
    "circle",
    "cisco",
    "citadel",
    "citi",
    "citic",
    "city",
    "ck",
    "cl",
    "claims",
    "cleaning",
    "click",
    "clinic",
    "clinique",
    "clothing",
    "cloud",
    "club",
    "clubmed",
    "cm",
    "cn",
    "co",
    "coach",
    "codes",
    "coffee",
    "college",
    "cologne",
    "com",
    "commbank",
    "community",
    "company",
    "compare",
    "computer",
    "comsec",
    "condos",
    "construction",
    "consulting",
    "contact",
    "contractors",
    "cooking",
    "cool",
    "coop",
    "corsica",
    "country",
    "coupon",
    "coupons",
    "courses",
    "cpa",
    "cr",
    "credit",
    "creditcard",
    "creditunion",
    "cricket",
    "crown",
    "crs",
    "cruise",
    "cruises",
    "cu",
    "cuisinella",
    "cv",
    "cw",
    "cx",
    "cy",
    "cymru",
    "cyou",
    "cz",
    "dad",
    "dance",
    "data",
    "date",
    "dating",
    "datsun",
    "day",
    "dclk",
    "dds",
    "de",
    "deal",
    "dealer",
    "deals",
    "degree",
    "delivery",
    "dell",
    "deloitte",
    "delta",
    "democrat",
    "dental",
    "dentist",
    "desi",
    "design",
    "dev",
    "dhl",
    "diamonds",
    "diet",
    "digital",
    "direct",
    "directory",
    "discount",
    "discover",
    "dish",
    "diy",
    "dj",
    "dk",
    "dm",
    "dnp",
    "do",
    "docs",
    "doctor",
    "dog",
    "domains",
    "dot",
    "download",
    "drive",
    "dtv",
    "dubai",
    "dunlop",
    "dupont",
    "durban",
    "dvag",
    "dvr",
    "dz",
    "earth",
    "eat",
    "ec",
    "eco",
    "edeka",
    "edu",
    "education",
    "ee",
    "eg",
    "email",
    "emerck",
    "energy",
    "engineer",
    "engineering",
    "enterprises",
    "epson",
    "equipment",
    "er",
    "ericsson",
    "erni",
    "es",
    "esq",
    "estate",
    "et",
    "eu",
    "eurovision",
    "eus",
    "events",
    "exchange",
    "expert",
    "exposed",
    "express",
    "extraspace",
    "fage",
    "fail",
    "fairwinds",
    "faith",
    "family",
    "fan",
    "fans",
    "farm",
    "farmers",
    "fashion",
    "fast",
    "fedex",
    "feedback",
    "ferrari",
    "ferrero",
    "fi",
    "fidelity",
    "fido",
    "film",
    "final",
    "finance",
    "financial",
    "fire",
    "firestone",
    "firmdale",
    "fish",
    "fishing",
    "fit",
    "fitness",
    "fj",
    "fk",
    "flickr",
    "flights",
    "flir",
    "florist",
    "flowers",
    "fly",
    "fm",
    "fo",
    "foo",
    "food",
    "football",
    "ford",
    "forex",
    "forsale",
    "forum",
    "foundation",
    "fox",
    "fr",
    "free",
    "fresenius",
    "frl",
    "frogans",
    "frontier",
    "ftr",
    "fujitsu",
    "fun",
    "fund",
    "furniture",
    "futbol",
    "fyi",
    "ga",
    "gal",
    "gallery",
    "gallo",
    "gallup",
    "game",
    "games",
    "gap",
    "garden",
    "gay",
    "gb",
    "gbiz",
    "gd",
    "gdn",
    "ge",
    "gea",
    "gent",
    "genting",
    "george",
    "gf",
    "gg",
    "ggee",
    "gh",
    "gi",
    "gift",
    "gifts",
    "gives",
    "giving",
    "gl",
    "glass",
    "gle",
    "global",
    "globo",
    "gm",
    "gmail",
    "gmbh",
    "gmo",
    "gmx",
    "gn",
    "godaddy",
    "gold",
    "goldpoint",
    "golf",
    "goo",
    "goodyear",
    "goog",
    "google",
    "gop",
    "got",
    "gov",
    "gp",
    "gq",
    "gr",
    "grainger",
    "graphics",
    "gratis",
    "green",
    "gripe",
    "grocery",
    "group",
    "gs",
    "gt",
    "gu",
    "gucci",
    "guge",
    "guide",
    "guitars",
    "guru",
    "gw",
    "gy",
    "hair",
    "hamburg",
    "hangout",
    "haus",
    "hbo",
    "hdfc",
    "hdfcbank",
    "health",
    "healthcare",
    "help",
    "helsinki",
    "here",
    "hermes",
    "hiphop",
    "hisamitsu",
    "hitachi",
    "hiv",
    "hk",
    "hkt",
    "hm",
    "hn",
    "hockey",
    "holdings",
    "holiday",
    "homedepot",
    "homegoods",
    "homes",
    "homesense",
    "honda",
    "horse",
    "hospital",
    "host",
    "hosting",
    "hot",
    "hotels",
    "hotmail",
    "house",
    "how",
    "hr",
    "hsbc",
    "ht",
    "hu",
    "hughes",
    "hyatt",
    "hyundai",
    "ibm",
    "icbc",
    "ice",
    "icu",
    "id",
    "ie",
    "ieee",
    "ifm",
    "ikano",
    "il",
    "im",
    "imamat",
    "imdb",
    "immo",
    "immobilien",
    "in",
    "inc",
    "industries",
    "infiniti",
    "info",
    "ing",
    "ink",
    "institute",
    "insurance",
    "insure",
    "int",
    "international",
    "intuit",
    "investments",
    "io",
    "ipiranga",
    "iq",
    "ir",
    "irish",
    "is",
    "ismaili",
    "ist",
    "istanbul",
    "it",
    "itau",
    "itv",
    "jaguar",
    "java",
    "jcb",
    "je",
    "jeep",
    "jetzt",
    "jewelry",
    "jio",
    "jll",
    "jm",
    "jmp",
    "jnj",
    "jo",
    "jobs",
    "joburg",
    "jot",
    "joy",
    "jp",
    "jpmorgan",
    "jprs",
    "juegos",
    "juniper",
    "kaufen",
    "kddi",
    "ke",
    "kerryhotels",
    "kerrylogistics",
    "kerryproperties",
    "kfh",
    "kg",
    "kh",
    "ki",
    "kia",
    "kids",
    "kim",
    "kindle",
    "kitchen",
    "kiwi",
    "km",
    "kn",
    "koeln",
    "komatsu",
    "kosher",
    "kp",
    "kpmg",
    "kpn",
    "kr",
    "krd",
    "kred",
    "kuokgroup",
    "kw",
    "ky",
    "kyoto",
    "kz",
    "la",
    "lacaixa",
    "lamborghini",
    "lamer",
    "lancaster",
    "land",
    "landrover",
    "lanxess",
    "lasalle",
    "lat",
    "latino",
    "latrobe",
    "law",
    "lawyer",
    "lb",
    "lc",
    "lds",
    "lease",
    "leclerc",
    "lefrak",
    "legal",
    "lego",
    "lexus",
    "lgbt",
    "li",
    "lidl",
    "life",
    "lifeinsurance",
    "lifestyle",
    "lighting",
    "like",
    "lilly",
    "limited",
    "limo",
    "lincoln",
    "link",
    "lipsy",
    "live",
    "living",
    "lk",
    "llc",
    "llp",
    "loan",
    "loans",
    "locker",
    "locus",
    "lol",
    "london",
    "lotte",
    "lotto",
    "love",
    "lpl",
    "lplfinancial",
    "lr",
    "ls",
    "lt",
    "ltd",
    "ltda",
    "lu",
    "lundbeck",
    "luxe",
    "luxury",
    "lv",
    "ly",
    "ma",
    "madrid",
    "maif",
    "maison",
    "makeup",
    "man",
    "management",
    "mango",
    "map",
    "market",
    "marketing",
    "markets",
    "marriott",
    "marshalls",
    "mattel",
    "mba",
    "mc",
    "mckinsey",
    "md",
    "me",
    "med",
    "media",
    "meet",
    "melbourne",
    "meme",
    "memorial",
    "men",
    "menu",
    "merckmsd",
    "mg",
    "mh",
    "miami",
    "microsoft",
    "mil",
    "mini",
    "mint",
    "mit",
    "mitsubishi",
    "mk",
    "ml",
    "mlb",
    "mls",
    "mm",
    "mma",
    "mn",
    "mo",
    "mobi",
    "mobile",
    "moda",
    "moe",
    "moi",
    "mom",
    "monash",
    "money",
    "monster",
    "mormon",
    "mortgage",
    "moscow",
    "moto",
    "motorcycles",
    "mov",
    "movie",
    "mp",
    "mq",
    "mr",
    "ms",
    "msd",
    "mt",
    "mtn",
    "mtr",
    "mu",
    "museum",
    "music",
    "mv",
    "mw",
    "mx",
    "my",
    "mz",
    "na",
    "nab",
    "nagoya",
    "name",
    "navy",
    "nba",
    "nc",
    "ne",
    "nec",
    "net",
    "netbank",
    "netflix",
    "network",
    "neustar",
    "new",
    "news",
    "next",
    "nextdirect",
    "nexus",
    "nf",
    "nfl",
    "ng",
    "ngo",
    "nhk",
    "ni",
    "nico",
    "nike",
    "nikon",
    "ninja",
    "nissan",
    "nissay",
    "nl",
    "no",
    "nokia",
    "norton",
    "now",
    "nowruz",
    "nowtv",
    "np",
    "nr",
    "nra",
    "nrw",
    "ntt",
    "nu",
    "nyc",
    "nz",
    "obi",
    "observer",
    "office",
    "okinawa",
    "olayan",
    "olayangroup",
    "ollo",
    "om",
    "omega",
    "one",
    "ong",
    "onl",
    "online",
    "ooo",
    "open",
    "oracle",
    "orange",
    "org",
    "organic",
    "origins",
    "osaka",
    "otsuka",
    "ott",
    "ovh",
    "pa",
    "page",
    "panasonic",
    "paris",
    "pars",
    "partners",
    "parts",
    "party",
    "pay",
    "pccw",
    "pe",
    "pet",
    "pf",
    "pfizer",
    "pg",
    "ph",
    "pharmacy",
    "phd",
    "philips",
    "phone",
    "photo",
    "photography",
    "photos",
    "physio",
    "pics",
    "pictet",
    "pictures",
    "pid",
    "pin",
    "ping",
    "pink",
    "pioneer",
    "pizza",
    "pk",
    "pl",
    "place",
    "play",
    "playstation",
    "plumbing",
    "plus",
    "pm",
    "pn",
    "pnc",
    "pohl",
    "poker",
    "politie",
    "porn",
    "post",
    "pr",
    "pramerica",
    "praxi",
    "press",
    "prime",
    "pro",
    "prod",
    "productions",
    "prof",
    "progressive",
    "promo",
    "properties",
    "property",
    "protection",
    "pru",
    "prudential",
    "ps",
    "pt",
    "pub",
    "pw",
    "pwc",
    "py",
    "qa",
    "qpon",
    "quebec",
    "quest",
    "racing",
    "radio",
    "re",
    "read",
    "realestate",
    "realtor",
    "realty",
    "recipes",
    "red",
    "redstone",
    "redumbrella",
    "rehab",
    "reise",
    "reisen",
    "reit",
    "reliance",
    "ren",
    "rent",
    "rentals",
    "repair",
    "report",
    "republican",
    "rest",
    "restaurant",
    "review",
    "reviews",
    "rexroth",
    "rich",
    "richardli",
    "ricoh",
    "ril",
    "rio",
    "rip",
    "ro",
    "rocks",
    "rodeo",
    "rogers",
    "room",
    "rs",
    "rsvp",
    "ru",
    "rugby",
    "ruhr",
    "run",
    "rw",
    "rwe",
    "ryukyu",
    "sa",
    "saarland",
    "safe",
    "safety",
    "sakura",
    "sale",
    "salon",
    "samsclub",
    "samsung",
    "sandvik",
    "sandvikcoromant",
    "sanofi",
    "sap",
    "sarl",
    "sas",
    "save",
    "saxo",
    "sb",
    "sbi",
    "sbs",
    "sc",
    "scb",
    "schaeffler",
    "schmidt",
    "scholarships",
    "school",
    "schule",
    "schwarz",
    "science",
    "scot",
    "sd",
    "se",
    "search",
    "seat",
    "secure",
    "security",
    "seek",
    "select",
    "sener",
    "services",
    "seven",
    "sew",
    "sex",
    "sexy",
    "sfr",
    "sg",
    "sh",
    "shangrila",
    "sharp",
    "shell",
    "shia",
    "shiksha",
    "shoes",
    "shop",
    "shopping",
    "shouji",
    "show",
    "si",
    "silk",
    "sina",
    "singles",
    "site",
    "sj",
    "sk",
    "ski",
    "skin",
    "sky",
    "skype",
    "sl",
    "sling",
    "sm",
    "smart",
    "smile",
    "sn",
    "sncf",
    "so",
    "soccer",
    "social",
    "softbank",
    "software",
    "sohu",
    "solar",
    "solutions",
    "song",
    "sony",
    "soy",
    "spa",
    "space",
    "sport",
    "spot",
    "sr",
    "srl",
    "ss",
    "st",
    "stada",
    "staples",
    "star",
    "statebank",
    "statefarm",
    "stc",
    "stcgroup",
    "stockholm",
    "storage",
    "store",
    "stream",
    "studio",
    "study",
    "style",
    "su",
    "sucks",
    "supplies",
    "supply",
    "support",
    "surf",
    "surgery",
    "suzuki",
    "sv",
    "swatch",
    "swiss",
    "sx",
    "sy",
    "sydney",
    "systems",
    "sz",
    "tab",
    "taipei",
    "talk",
    "taobao",
    "target",
    "tatamotors",
    "tatar",
    "tattoo",
    "tax",
    "taxi",
    "tc",
    "tci",
    "td",
    "tdk",
    "team",
    "tech",
    "technology",
    "tel",
    "temasek",
    "tennis",
    "teva",
    "tf",
    "tg",
    "th",
    "thd",
    "theater",
    "theatre",
    "tiaa",
    "tickets",
    "tienda",
    "tips",
    "tires",
    "tirol",
    "tj",
    "tjmaxx",
    "tjx",
    "tk",
    "tkmaxx",
    "tl",
    "tm",
    "tmall",
    "tn",
    "to",
    "today",
    "tokyo",
    "tools",
    "top",
    "toray",
    "toshiba",
    "total",
    "tours",
    "town",
    "toyota",
    "toys",
    "tr",
    "trade",
    "trading",
    "training",
    "travel",
    "travelers",
    "travelersinsurance",
    "trust",
    "trv",
    "tt",
    "tube",
    "tui",
    "tunes",
    "tushu",
    "tv",
    "tvs",
    "tw",
    "tz",
    "ua",
    "ubank",
    "ubs",
    "ug",
    "uk",
    "unicom",
    "university",
    "uno",
    "uol",
    "ups",
    "us",
    "uy",
    "uz",
    "va",
    "vacations",
    "vana",
    "vanguard",
    "vc",
    "ve",
    "vegas",
    "ventures",
    "verisign",
    "verm\xf6gensberater",
    "verm\xf6gensberatung",
    "versicherung",
    "vet",
    "vg",
    "vi",
    "viajes",
    "video",
    "vig",
    "viking",
    "villas",
    "vin",
    "vip",
    "virgin",
    "visa",
    "vision",
    "viva",
    "vivo",
    "vlaanderen",
    "vn",
    "vodka",
    "volvo",
    "vote",
    "voting",
    "voto",
    "voyage",
    "vu",
    "wales",
    "walmart",
    "walter",
    "wang",
    "wanggou",
    "watch",
    "watches",
    "weather",
    "weatherchannel",
    "webcam",
    "weber",
    "website",
    "wed",
    "wedding",
    "weibo",
    "weir",
    "wf",
    "whoswho",
    "wien",
    "wiki",
    "williamhill",
    "win",
    "windows",
    "wine",
    "winners",
    "wme",
    "wolterskluwer",
    "woodside",
    "work",
    "works",
    "world",
    "wow",
    "ws",
    "wtc",
    "wtf",
    "xbox",
    "xerox",
    "xihuan",
    "xin",
    "xxx",
    "xyz",
    "yachts",
    "yahoo",
    "yamaxun",
    "yandex",
    "ye",
    "yodobashi",
    "yoga",
    "yokohama",
    "you",
    "youtube",
    "yt",
    "yun",
    "za",
    "zappos",
    "zara",
    "zero",
    "zip",
    "zm",
    "zone",
    "zuerich",
    "zw",
    "\u03B5\u03BB",
    "\u03B5\u03C5",
    "\u0431\u0433",
    "\u0431\u0435\u043B",
    "\u0434\u0435\u0442\u0438",
    "\u0435\u044E",
    "\u043A\u0430\u0442\u043E\u043B\u0438\u043A",
    "\u043A\u043E\u043C",
    "\u043C\u043A\u0434",
    "\u043C\u043E\u043D",
    "\u043C\u043E\u0441\u043A\u0432\u0430",
    "\u043E\u043D\u043B\u0430\u0439\u043D",
    "\u043E\u0440\u0433",
    "\u0440\u0443\u0441",
    "\u0440\u0444",
    "\u0441\u0430\u0439\u0442",
    "\u0441\u0440\u0431",
    "\u0443\u043A\u0440",
    "\u049B\u0430\u0437",
    "\u0570\u0561\u0575",
    "\u05D9\u05E9\u05E8\u05D0\u05DC",
    "\u05E7\u05D5\u05DD",
    "\u0627\u0628\u0648\u0638\u0628\u064A",
    "\u0627\u0631\u0627\u0645\u0643\u0648",
    "\u0627\u0644\u0627\u0631\u062F\u0646",
    "\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
    "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
    "\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
    "\u0627\u0644\u0639\u0644\u064A\u0627\u0646",
    "\u0627\u0644\u0645\u063A\u0631\u0628",
    "\u0627\u0645\u0627\u0631\u0627\u062A",
    "\u0627\u06CC\u0631\u0627\u0646",
    "\u0628\u0627\u0631\u062A",
    "\u0628\u0627\u0632\u0627\u0631",
    "\u0628\u064A\u062A\u0643",
    "\u0628\u06BE\u0627\u0631\u062A",
    "\u062A\u0648\u0646\u0633",
    "\u0633\u0648\u062F\u0627\u0646",
    "\u0633\u0648\u0631\u064A\u0629",
    "\u0634\u0628\u0643\u0629",
    "\u0639\u0631\u0627\u0642",
    "\u0639\u0631\u0628",
    "\u0639\u0645\u0627\u0646",
    "\u0641\u0644\u0633\u0637\u064A\u0646",
    "\u0642\u0637\u0631",
    "\u0643\u0627\u062B\u0648\u0644\u064A\u0643",
    "\u0643\u0648\u0645",
    "\u0645\u0635\u0631",
    "\u0645\u0644\u064A\u0633\u064A\u0627",
    "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627",
    "\u0645\u0648\u0642\u0639",
    "\u0647\u0645\u0631\u0627\u0647",
    "\u067E\u0627\u06A9\u0633\u062A\u0627\u0646",
    "\u0680\u0627\u0631\u062A",
    "\u0915\u0949\u092E",
    "\u0928\u0947\u091F",
    "\u092D\u093E\u0930\u0924",
    "\u092D\u093E\u0930\u0924\u092E\u094D",
    "\u092D\u093E\u0930\u094B\u0924",
    "\u0938\u0902\u0917\u0920\u0928",
    "\u09AC\u09BE\u0982\u09B2\u09BE",
    "\u09AD\u09BE\u09B0\u09A4",
    "\u09AD\u09BE\u09F0\u09A4",
    "\u0A2D\u0A3E\u0A30\u0A24",
    "\u0AAD\u0ABE\u0AB0\u0AA4",
    "\u0B2D\u0B3E\u0B30\u0B24",
    "\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE",
    "\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8",
    "\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD",
    "\u0C2D\u0C3E\u0C30\u0C24\u0C4D",
    "\u0CAD\u0CBE\u0CB0\u0CA4",
    "\u0D2D\u0D3E\u0D30\u0D24\u0D02",
    "\u0DBD\u0D82\u0D9A\u0DCF",
    "\u0E04\u0E2D\u0E21",
    "\u0E44\u0E17\u0E22",
    "\u0EA5\u0EB2\u0EA7",
    "\u10D2\u10D4",
    "\u307F\u3093\u306A",
    "\u30A2\u30DE\u30BE\u30F3",
    "\u30AF\u30E9\u30A6\u30C9",
    "\u30B0\u30FC\u30B0\u30EB",
    "\u30B3\u30E0",
    "\u30B9\u30C8\u30A2",
    "\u30BB\u30FC\u30EB",
    "\u30D5\u30A1\u30C3\u30B7\u30E7\u30F3",
    "\u30DD\u30A4\u30F3\u30C8",
    "\u4E16\u754C",
    "\u4E2D\u4FE1",
    "\u4E2D\u56FD",
    "\u4E2D\u570B",
    "\u4E2D\u6587\u7F51",
    "\u4E9A\u9A6C\u900A",
    "\u4F01\u4E1A",
    "\u4F5B\u5C71",
    "\u4FE1\u606F",
    "\u5065\u5EB7",
    "\u516B\u5366",
    "\u516C\u53F8",
    "\u516C\u76CA",
    "\u53F0\u6E7E",
    "\u53F0\u7063",
    "\u5546\u57CE",
    "\u5546\u5E97",
    "\u5546\u6807",
    "\u5609\u91CC",
    "\u5609\u91CC\u5927\u9152\u5E97",
    "\u5728\u7EBF",
    "\u5927\u62FF",
    "\u5929\u4E3B\u6559",
    "\u5A31\u4E50",
    "\u5BB6\u96FB",
    "\u5E7F\u4E1C",
    "\u5FAE\u535A",
    "\u6148\u5584",
    "\u6211\u7231\u4F60",
    "\u624B\u673A",
    "\u62DB\u8058",
    "\u653F\u52A1",
    "\u653F\u5E9C",
    "\u65B0\u52A0\u5761",
    "\u65B0\u95FB",
    "\u65F6\u5C1A",
    "\u66F8\u7C4D",
    "\u673A\u6784",
    "\u6DE1\u9A6C\u9521",
    "\u6E38\u620F",
    "\u6FB3\u9580",
    "\u70B9\u770B",
    "\u79FB\u52A8",
    "\u7EC4\u7EC7\u673A\u6784",
    "\u7F51\u5740",
    "\u7F51\u5E97",
    "\u7F51\u7AD9",
    "\u7F51\u7EDC",
    "\u8054\u901A",
    "\u8C37\u6B4C",
    "\u8D2D\u7269",
    "\u901A\u8CA9",
    "\u96C6\u56E2",
    "\u96FB\u8A0A\u76C8\u79D1",
    "\u98DE\u5229\u6D66",
    "\u98DF\u54C1",
    "\u9910\u5385",
    "\u9999\u683C\u91CC\u62C9",
    "\u9999\u6E2F",
    "\uB2F7\uB137",
    "\uB2F7\uCEF4",
    "\uC0BC\uC131",
    "\uD55C\uAD6D"
];
var $aec35899a3c9695e$var$$r = {};
Object.defineProperty($aec35899a3c9695e$var$$r, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$$r.TAG_REGEX = $aec35899a3c9695e$var$$r.TRAILING_PUNCTUATION_REGEX = $aec35899a3c9695e$var$$r.URL_REGEX = $aec35899a3c9695e$var$$r.MENTION_REGEX = void 0;
$aec35899a3c9695e$var$$r.MENTION_REGEX = /(^|\s|\()(@)([a-zA-Z0-9.-]+)(\b)/g;
$aec35899a3c9695e$var$$r.URL_REGEX = /(^|\s|\()((https?:\/\/[\S]+)|((?<domain>[a-z][a-z0-9]*(\.[a-z0-9]+)+)[\S]*))/gim;
$aec35899a3c9695e$var$$r.TRAILING_PUNCTUATION_REGEX = /\p{P}+$/gu;
$aec35899a3c9695e$var$$r.TAG_REGEX = /(^|\s)[#＃]((?!\ufe0f)[^\s\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]*[^\d\s\p{P}\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]+[^\s\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]*)?/gu;
var $aec35899a3c9695e$var$SO = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importDefault || function(t) {
    return t && t.__esModule ? t : {
        default: t
    };
};
Object.defineProperty($aec35899a3c9695e$var$$u, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$$u.detectFacets = void 0;
const $aec35899a3c9695e$var$CO = $aec35899a3c9695e$var$SO($aec35899a3c9695e$var$TO), $aec35899a3c9695e$var$nu = $aec35899a3c9695e$var$$r;
function $aec35899a3c9695e$var$LO(t) {
    let e;
    const r = [];
    {
        const i = $aec35899a3c9695e$var$nu.MENTION_REGEX;
        for(; e = i.exec(t.utf16);){
            if (!$aec35899a3c9695e$var$bf(e[3]) && !e[3].endsWith(".test")) continue;
            const a = t.utf16.indexOf(e[3], e.index) - 1;
            r.push({
                $type: "app.bsky.richtext.facet",
                index: {
                    byteStart: t.utf16IndexToUtf8Index(a),
                    byteEnd: t.utf16IndexToUtf8Index(a + e[3].length + 1)
                },
                features: [
                    {
                        $type: "app.bsky.richtext.facet#mention",
                        did: e[3]
                    }
                ]
            });
        }
    }
    {
        const i = $aec35899a3c9695e$var$nu.URL_REGEX;
        for(; e = i.exec(t.utf16);){
            let a = e[2];
            if (!a.startsWith("http")) {
                const m = e.groups?.domain;
                if (!m || !$aec35899a3c9695e$var$bf(m)) continue;
                a = `https://${a}`;
            }
            const c = t.utf16.indexOf(e[2], e.index), h = {
                start: c,
                end: c + e[2].length
            };
            /[.,;:!?]$/.test(a) && (a = a.slice(0, -1), h.end--), /[)]$/.test(a) && !a.includes("(") && (a = a.slice(0, -1), h.end--), r.push({
                index: {
                    byteStart: t.utf16IndexToUtf8Index(h.start),
                    byteEnd: t.utf16IndexToUtf8Index(h.end)
                },
                features: [
                    {
                        $type: "app.bsky.richtext.facet#link",
                        uri: a
                    }
                ]
            });
        }
    }
    {
        const i = $aec35899a3c9695e$var$nu.TAG_REGEX;
        for(; e = i.exec(t.utf16);){
            const a = e[1];
            let c = e[2];
            if (!c || (c = c.trim().replace($aec35899a3c9695e$var$nu.TRAILING_PUNCTUATION_REGEX, ""), c.length === 0 || c.length > 64)) continue;
            const h = e.index + a.length;
            r.push({
                index: {
                    byteStart: t.utf16IndexToUtf8Index(h),
                    byteEnd: t.utf16IndexToUtf8Index(h + 1 + c.length)
                },
                features: [
                    {
                        $type: "app.bsky.richtext.facet#tag",
                        tag: c
                    }
                ]
            });
        }
    }
    return r.length > 0 ? r : void 0;
}
$aec35899a3c9695e$var$$u.detectFacets = $aec35899a3c9695e$var$LO;
function $aec35899a3c9695e$var$bf(t) {
    return !!$aec35899a3c9695e$var$CO.default.find((e)=>{
        const r = t.lastIndexOf(e);
        return r === -1 ? !1 : t.charAt(r - 1) === "." && r === t.length - e.length;
    });
}
Object.defineProperty($aec35899a3c9695e$var$Fs, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Fs.RichText = $aec35899a3c9695e$var$Fs.RichTextSegment = void 0;
const $aec35899a3c9695e$var$In = $aec35899a3c9695e$var$x, $aec35899a3c9695e$var$hc = $aec35899a3c9695e$var$Hs, $aec35899a3c9695e$var$kO = $aec35899a3c9695e$var$jl, $aec35899a3c9695e$var$gf = $aec35899a3c9695e$var$$u;
class $aec35899a3c9695e$var$bs {
    constructor(e, r){
        Object.defineProperty(this, "text", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e
        }), Object.defineProperty(this, "facet", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
        });
    }
    get link() {
        const e = this.facet?.features.find($aec35899a3c9695e$var$In.AppBskyRichtextFacet.isLink);
        if ($aec35899a3c9695e$var$In.AppBskyRichtextFacet.isLink(e)) return e;
    }
    isLink() {
        return !!this.link;
    }
    get mention() {
        const e = this.facet?.features.find($aec35899a3c9695e$var$In.AppBskyRichtextFacet.isMention);
        if ($aec35899a3c9695e$var$In.AppBskyRichtextFacet.isMention(e)) return e;
    }
    isMention() {
        return !!this.mention;
    }
    get tag() {
        const e = this.facet?.features.find($aec35899a3c9695e$var$In.AppBskyRichtextFacet.isTag);
        if ($aec35899a3c9695e$var$In.AppBskyRichtextFacet.isTag(e)) return e;
    }
    isTag() {
        return !!this.tag;
    }
}
$aec35899a3c9695e$var$Fs.RichTextSegment = $aec35899a3c9695e$var$bs;
class $aec35899a3c9695e$var$id {
    constructor(e, r){
        Object.defineProperty(this, "unicodeText", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "facets", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.unicodeText = new $aec35899a3c9695e$var$hc.UnicodeString(e.text), this.facets = e.facets, !this.facets?.length && e.entities?.length && (this.facets = $aec35899a3c9695e$var$DO(this.unicodeText, e.entities)), this.facets && this.facets.sort($aec35899a3c9695e$var$mc), r?.cleanNewlines && (0, $aec35899a3c9695e$var$kO.sanitizeRichText)(this, {
            cleanNewlines: !0
        }).copyInto(this);
    }
    get text() {
        return this.unicodeText.toString();
    }
    get length() {
        return this.unicodeText.length;
    }
    get graphemeLength() {
        return this.unicodeText.graphemeLength;
    }
    clone() {
        return new $aec35899a3c9695e$var$id({
            text: this.unicodeText.utf16,
            facets: $aec35899a3c9695e$var$xf(this.facets)
        });
    }
    copyInto(e) {
        e.unicodeText = this.unicodeText, e.facets = $aec35899a3c9695e$var$xf(this.facets);
    }
    *segments() {
        const e = this.facets || [];
        if (!e.length) {
            yield new $aec35899a3c9695e$var$bs(this.unicodeText.utf16);
            return;
        }
        let r = 0, i = 0;
        do {
            const a = e[i];
            if (r < a.index.byteStart) yield new $aec35899a3c9695e$var$bs(this.unicodeText.slice(r, a.index.byteStart));
            else if (r > a.index.byteStart) {
                i++;
                continue;
            }
            if (a.index.byteStart < a.index.byteEnd) {
                const c = this.unicodeText.slice(a.index.byteStart, a.index.byteEnd);
                c.trim() ? yield new $aec35899a3c9695e$var$bs(c, a) : yield new $aec35899a3c9695e$var$bs(c);
            }
            r = a.index.byteEnd, i++;
        }while (i < e.length);
        r < this.unicodeText.length && (yield new $aec35899a3c9695e$var$bs(this.unicodeText.slice(r, this.unicodeText.length)));
    }
    insert(e, r) {
        if (this.unicodeText = new $aec35899a3c9695e$var$hc.UnicodeString(this.unicodeText.slice(0, e) + r + this.unicodeText.slice(e)), !this.facets?.length) return this;
        const i = r.length;
        for (const a of this.facets)e <= a.index.byteStart ? (a.index.byteStart += i, a.index.byteEnd += i) : e >= a.index.byteStart && e < a.index.byteEnd && (a.index.byteEnd += i);
        return this;
    }
    delete(e, r) {
        if (this.unicodeText = new $aec35899a3c9695e$var$hc.UnicodeString(this.unicodeText.slice(0, e) + this.unicodeText.slice(r)), !this.facets?.length) return this;
        const i = r - e;
        for (const a of this.facets)e <= a.index.byteStart && r >= a.index.byteEnd ? (a.index.byteStart = 0, a.index.byteEnd = 0) : e > a.index.byteEnd || (e > a.index.byteStart && e <= a.index.byteEnd && r > a.index.byteEnd ? a.index.byteEnd = e : e >= a.index.byteStart && r <= a.index.byteEnd ? a.index.byteEnd -= i : e < a.index.byteStart && r >= a.index.byteStart && r <= a.index.byteEnd ? (a.index.byteStart = e, a.index.byteEnd -= i) : r < a.index.byteStart && (a.index.byteStart -= i, a.index.byteEnd -= i));
        return this.facets = this.facets.filter((a)=>a.index.byteStart < a.index.byteEnd), this;
    }
    /**
   * Detects facets such as links and mentions
   * Note: Overwrites the existing facets with auto-detected facets
   */ async detectFacets(e) {
        if (this.facets = (0, $aec35899a3c9695e$var$gf.detectFacets)(this.unicodeText), this.facets) {
            for (const r of this.facets)for (const i of r.features)if ($aec35899a3c9695e$var$In.AppBskyRichtextFacet.isMention(i)) {
                const a = await e.resolveHandle({
                    handle: i.did
                }).catch((c)=>{}).then((c)=>c?.data.did);
                i.did = a || "";
            }
            this.facets.sort($aec35899a3c9695e$var$mc);
        }
    }
    /**
   * Detects facets such as links and mentions but does not resolve them
   * Will produce invalid facets! For instance, mentions will not have their DIDs set.
   * Note: Overwrites the existing facets with auto-detected facets
   */ detectFacetsWithoutResolution() {
        this.facets = (0, $aec35899a3c9695e$var$gf.detectFacets)(this.unicodeText), this.facets && this.facets.sort($aec35899a3c9695e$var$mc);
    }
}
$aec35899a3c9695e$var$Fs.RichText = $aec35899a3c9695e$var$id;
const $aec35899a3c9695e$var$mc = (t, e)=>t.index.byteStart - e.index.byteStart;
function $aec35899a3c9695e$var$DO(t, e) {
    const r = [];
    for (const i of e)i.type === "link" ? r.push({
        $type: "app.bsky.richtext.facet",
        index: {
            byteStart: t.utf16IndexToUtf8Index(i.index.start),
            byteEnd: t.utf16IndexToUtf8Index(i.index.end)
        },
        features: [
            {
                $type: "app.bsky.richtext.facet#link",
                uri: i.value
            }
        ]
    }) : i.type === "mention" && r.push({
        $type: "app.bsky.richtext.facet",
        index: {
            byteStart: t.utf16IndexToUtf8Index(i.index.start),
            byteEnd: t.utf16IndexToUtf8Index(i.index.end)
        },
        features: [
            {
                $type: "app.bsky.richtext.facet#mention",
                did: i.value
            }
        ]
    });
    return r;
}
function $aec35899a3c9695e$var$xf(t) {
    return typeof t > "u" ? t : JSON.parse(JSON.stringify(t));
}
var $aec35899a3c9695e$var$nd = {}, $aec35899a3c9695e$var$xi = {}, $aec35899a3c9695e$var$zr = {}, $aec35899a3c9695e$var$ur = {};
Object.defineProperty($aec35899a3c9695e$var$ur, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ur.NOOP_BEHAVIOR = $aec35899a3c9695e$var$ur.HIDE_BEHAVIOR = $aec35899a3c9695e$var$ur.MUTEWORD_BEHAVIOR = $aec35899a3c9695e$var$ur.MUTE_BEHAVIOR = $aec35899a3c9695e$var$ur.BLOCK_BEHAVIOR = $aec35899a3c9695e$var$ur.CUSTOM_LABEL_VALUE_RE = void 0;
$aec35899a3c9695e$var$ur.CUSTOM_LABEL_VALUE_RE = /^[a-z-]+$/;
$aec35899a3c9695e$var$ur.BLOCK_BEHAVIOR = {
    profileList: "blur",
    profileView: "alert",
    avatar: "blur",
    banner: "blur",
    contentList: "blur",
    contentView: "blur"
};
$aec35899a3c9695e$var$ur.MUTE_BEHAVIOR = {
    profileList: "inform",
    profileView: "alert",
    contentList: "blur",
    contentView: "inform"
};
$aec35899a3c9695e$var$ur.MUTEWORD_BEHAVIOR = {
    contentList: "blur",
    contentView: "blur"
};
$aec35899a3c9695e$var$ur.HIDE_BEHAVIOR = {
    contentList: "blur",
    contentView: "blur"
};
$aec35899a3c9695e$var$ur.NOOP_BEHAVIOR = {};
var $aec35899a3c9695e$var$Fl = {};
Object.defineProperty($aec35899a3c9695e$var$Fl, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Fl.ModerationUI = void 0;
class $aec35899a3c9695e$var$PO {
    constructor(){
        Object.defineProperty(this, "noOverride", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "filters", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "blurs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "alerts", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "informs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        });
    }
    get filter() {
        return this.filters.length !== 0;
    }
    get blur() {
        return this.blurs.length !== 0;
    }
    get alert() {
        return this.alerts.length !== 0;
    }
    get inform() {
        return this.informs.length !== 0;
    }
}
$aec35899a3c9695e$var$Fl.ModerationUI = $aec35899a3c9695e$var$PO;
var $aec35899a3c9695e$var$En = {};
Object.defineProperty($aec35899a3c9695e$var$En, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$En.LABELS = $aec35899a3c9695e$var$En.DEFAULT_LABEL_SETTINGS = void 0;
$aec35899a3c9695e$var$En.DEFAULT_LABEL_SETTINGS = {
    porn: "hide",
    sexual: "warn",
    nudity: "ignore",
    "graphic-media": "warn"
};
$aec35899a3c9695e$var$En.LABELS = {
    "!hide": {
        identifier: "!hide",
        configurable: !1,
        defaultSetting: "hide",
        flags: [
            "no-override",
            "no-self"
        ],
        severity: "alert",
        blurs: "content",
        behaviors: {
            account: {
                profileList: "blur",
                profileView: "blur",
                avatar: "blur",
                banner: "blur",
                displayName: "blur",
                contentList: "blur",
                contentView: "blur"
            },
            profile: {
                avatar: "blur",
                banner: "blur",
                displayName: "blur"
            },
            content: {
                contentList: "blur",
                contentView: "blur"
            }
        },
        locales: []
    },
    "!warn": {
        identifier: "!warn",
        configurable: !1,
        defaultSetting: "warn",
        flags: [
            "no-self"
        ],
        severity: "none",
        blurs: "content",
        behaviors: {
            account: {
                profileList: "blur",
                profileView: "blur",
                avatar: "blur",
                banner: "blur",
                contentList: "blur",
                contentView: "blur"
            },
            profile: {
                avatar: "blur",
                banner: "blur",
                displayName: "blur"
            },
            content: {
                contentList: "blur",
                contentView: "blur"
            }
        },
        locales: []
    },
    "!no-unauthenticated": {
        identifier: "!no-unauthenticated",
        configurable: !1,
        defaultSetting: "hide",
        flags: [
            "no-override",
            "unauthed"
        ],
        severity: "none",
        blurs: "content",
        behaviors: {
            account: {
                profileList: "blur",
                profileView: "blur",
                avatar: "blur",
                banner: "blur",
                displayName: "blur",
                contentList: "blur",
                contentView: "blur"
            },
            profile: {
                avatar: "blur",
                banner: "blur",
                displayName: "blur"
            },
            content: {
                contentList: "blur",
                contentView: "blur"
            }
        },
        locales: []
    },
    porn: {
        identifier: "porn",
        configurable: !0,
        defaultSetting: "hide",
        flags: [
            "adult"
        ],
        severity: "none",
        blurs: "media",
        behaviors: {
            account: {
                avatar: "blur",
                banner: "blur"
            },
            profile: {
                avatar: "blur",
                banner: "blur"
            },
            content: {
                contentMedia: "blur"
            }
        },
        locales: []
    },
    sexual: {
        identifier: "sexual",
        configurable: !0,
        defaultSetting: "warn",
        flags: [
            "adult"
        ],
        severity: "none",
        blurs: "media",
        behaviors: {
            account: {
                avatar: "blur",
                banner: "blur"
            },
            profile: {
                avatar: "blur",
                banner: "blur"
            },
            content: {
                contentMedia: "blur"
            }
        },
        locales: []
    },
    nudity: {
        identifier: "nudity",
        configurable: !0,
        defaultSetting: "ignore",
        flags: [],
        severity: "none",
        blurs: "media",
        behaviors: {
            account: {
                avatar: "blur",
                banner: "blur"
            },
            profile: {
                avatar: "blur",
                banner: "blur"
            },
            content: {
                contentMedia: "blur"
            }
        },
        locales: []
    },
    "graphic-media": {
        identifier: "graphic-media",
        flags: [
            "adult"
        ],
        configurable: !0,
        defaultSetting: "warn",
        severity: "none",
        blurs: "media",
        behaviors: {
            account: {
                avatar: "blur",
                banner: "blur"
            },
            profile: {
                avatar: "blur",
                banner: "blur"
            },
            content: {
                contentMedia: "blur"
            }
        },
        locales: []
    }
};
Object.defineProperty($aec35899a3c9695e$var$zr, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$zr.ModerationDecision = void 0;
const $aec35899a3c9695e$var$mr = $aec35899a3c9695e$var$ur, $aec35899a3c9695e$var$BO = $aec35899a3c9695e$var$Fl, $aec35899a3c9695e$var$Ef = $aec35899a3c9695e$var$En;
var $aec35899a3c9695e$var$cn;
(function(t) {
    t[t.High = 0] = "High", t[t.Medium = 1] = "Medium", t[t.Low = 2] = "Low";
})($aec35899a3c9695e$var$cn || ($aec35899a3c9695e$var$cn = {}));
class $aec35899a3c9695e$var$sd {
    constructor(){
        Object.defineProperty(this, "did", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "isMe", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "causes", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        });
    }
    static merge(...e) {
        const r = e.filter((a)=>!!a), i = new $aec35899a3c9695e$var$sd();
        return r[0] && (i.did = r[0].did, i.isMe = r[0].isMe), i.causes = r.flatMap((a)=>a.causes), i;
    }
    downgrade() {
        for (const e of this.causes)e.downgraded = !0;
        return this;
    }
    get blocked() {
        return !!this.blockCause;
    }
    get muted() {
        return !!this.muteCause;
    }
    get blockCause() {
        return this.causes.find((e)=>e.type === "blocking" || e.type === "blocked-by" || e.type === "block-other");
    }
    get muteCause() {
        return this.causes.find((e)=>e.type === "muted");
    }
    get labelCauses() {
        return this.causes.filter((e)=>e.type === "label");
    }
    ui(e) {
        const r = new $aec35899a3c9695e$var$BO.ModerationUI();
        for (const i of this.causes)if (i.type === "blocking" || i.type === "blocked-by" || i.type === "block-other") {
            if (this.isMe) continue;
            (e === "profileList" || e === "contentList") && r.filters.push(i), i.downgraded || ($aec35899a3c9695e$var$mr.BLOCK_BEHAVIOR[e] === "blur" ? (r.noOverride = !0, r.blurs.push(i)) : $aec35899a3c9695e$var$mr.BLOCK_BEHAVIOR[e] === "alert" ? r.alerts.push(i) : $aec35899a3c9695e$var$mr.BLOCK_BEHAVIOR[e] === "inform" && r.informs.push(i));
        } else if (i.type === "muted") {
            if (this.isMe) continue;
            (e === "profileList" || e === "contentList") && r.filters.push(i), i.downgraded || ($aec35899a3c9695e$var$mr.MUTE_BEHAVIOR[e] === "blur" ? r.blurs.push(i) : $aec35899a3c9695e$var$mr.MUTE_BEHAVIOR[e] === "alert" ? r.alerts.push(i) : $aec35899a3c9695e$var$mr.MUTE_BEHAVIOR[e] === "inform" && r.informs.push(i));
        } else if (i.type === "mute-word") {
            if (this.isMe) continue;
            e === "contentList" && r.filters.push(i), i.downgraded || ($aec35899a3c9695e$var$mr.MUTEWORD_BEHAVIOR[e] === "blur" ? r.blurs.push(i) : $aec35899a3c9695e$var$mr.MUTEWORD_BEHAVIOR[e] === "alert" ? r.alerts.push(i) : $aec35899a3c9695e$var$mr.MUTEWORD_BEHAVIOR[e] === "inform" && r.informs.push(i));
        } else i.type === "hidden" ? ((e === "profileList" || e === "contentList") && r.filters.push(i), i.downgraded || ($aec35899a3c9695e$var$mr.HIDE_BEHAVIOR[e] === "blur" ? r.blurs.push(i) : $aec35899a3c9695e$var$mr.HIDE_BEHAVIOR[e] === "alert" ? r.alerts.push(i) : $aec35899a3c9695e$var$mr.HIDE_BEHAVIOR[e] === "inform" && r.informs.push(i))) : i.type === "label" && (e === "profileList" && i.target === "account" ? i.setting === "hide" && !this.isMe && r.filters.push(i) : e === "contentList" && (i.target === "account" || i.target === "content") && i.setting === "hide" && !this.isMe && r.filters.push(i), i.downgraded || (i.behavior[e] === "blur" ? (r.blurs.push(i), i.noOverride && !this.isMe && (r.noOverride = !0)) : i.behavior[e] === "alert" ? r.alerts.push(i) : i.behavior[e] === "inform" && r.informs.push(i)));
        return r.filters.sort($aec35899a3c9695e$var$vf), r.blurs.sort($aec35899a3c9695e$var$vf), r;
    }
    setDid(e) {
        this.did = e;
    }
    setIsMe(e) {
        this.isMe = e;
    }
    addHidden(e) {
        e && this.causes.push({
            type: "hidden",
            source: {
                type: "user"
            },
            priority: 6
        });
    }
    addMutedWord(e) {
        e && this.causes.push({
            type: "mute-word",
            source: {
                type: "user"
            },
            priority: 6
        });
    }
    addBlocking(e) {
        e && this.causes.push({
            type: "blocking",
            source: {
                type: "user"
            },
            priority: 3
        });
    }
    addBlockingByList(e) {
        e && this.causes.push({
            type: "blocking",
            source: {
                type: "list",
                list: e
            },
            priority: 3
        });
    }
    addBlockedBy(e) {
        e && this.causes.push({
            type: "blocked-by",
            source: {
                type: "user"
            },
            priority: 4
        });
    }
    addBlockOther(e) {
        e && this.causes.push({
            type: "block-other",
            source: {
                type: "user"
            },
            priority: 4
        });
    }
    addLabel(e, r, i) {
        const a = $aec35899a3c9695e$var$mr.CUSTOM_LABEL_VALUE_RE.test(r.val) && i.labelDefs?.[r.src]?.find((v)=>v.identifier === r.val) || $aec35899a3c9695e$var$Ef.LABELS[r.val];
        if (!a) return;
        const c = r.src === this.did, h = c ? void 0 : i.prefs.labelers.find((v)=>v.did === r.src);
        if (!c && !h || c && a.flags.includes("no-self")) return;
        let m = a.defaultSetting || "ignore";
        if (a.configurable ? a.flags.includes("adult") && !i.prefs.adultContentEnabled ? m = "hide" : h?.labels[a.identifier] ? m = h?.labels[a.identifier] : i.prefs.labels[a.identifier] && (m = i.prefs.labels[a.identifier]) : m = a.defaultSetting || "hide", m === "ignore" || a.flags.includes("unauthed") && i.userDid) return;
        let p;
        const y = $aec35899a3c9695e$var$IO(a.behaviors[e]);
        a.flags.includes("no-override") || a.flags.includes("adult") && !i.prefs.adultContentEnabled ? p = 1 : m === "hide" ? p = 2 : y === $aec35899a3c9695e$var$cn.High ? p = 5 : y === $aec35899a3c9695e$var$cn.Medium ? p = 7 : p = 8;
        let d = !1;
        (a.flags.includes("no-override") || a.flags.includes("adult") && !i.prefs.adultContentEnabled) && (d = !0), this.causes.push({
            type: "label",
            source: c || !h ? {
                type: "user"
            } : {
                type: "labeler",
                did: h.did
            },
            label: r,
            labelDef: a,
            target: e,
            setting: m,
            behavior: a.behaviors[e] || $aec35899a3c9695e$var$mr.NOOP_BEHAVIOR,
            noOverride: d,
            priority: p
        });
    }
    addMuted(e) {
        e && this.causes.push({
            type: "muted",
            source: {
                type: "user"
            },
            priority: 6
        });
    }
    addMutedByList(e) {
        e && this.causes.push({
            type: "muted",
            source: {
                type: "list",
                list: e
            },
            priority: 6
        });
    }
}
$aec35899a3c9695e$var$zr.ModerationDecision = $aec35899a3c9695e$var$sd;
function $aec35899a3c9695e$var$IO(t) {
    return t ? t.profileView === "blur" || t.contentView === "blur" ? $aec35899a3c9695e$var$cn.High : t.contentList === "blur" || t.contentMedia === "blur" ? $aec35899a3c9695e$var$cn.Medium : $aec35899a3c9695e$var$cn.Low : $aec35899a3c9695e$var$cn.Low;
}
function $aec35899a3c9695e$var$vf(t, e) {
    return t.priority - e.priority;
}
Object.defineProperty($aec35899a3c9695e$var$xi, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$xi.filterAccountLabels = $aec35899a3c9695e$var$xi.decideAccount = void 0;
const $aec35899a3c9695e$var$UO = $aec35899a3c9695e$var$zr;
function $aec35899a3c9695e$var$OO(t, e) {
    const r = new $aec35899a3c9695e$var$UO.ModerationDecision();
    r.setDid(t.did), r.setIsMe(t.did === e.userDid), t.viewer?.muted && (t.viewer?.mutedByList ? r.addMutedByList(t.viewer?.mutedByList) : r.addMuted(t.viewer?.muted)), t.viewer?.blocking && (t.viewer?.blockingByList ? r.addBlockingByList(t.viewer?.blockingByList) : r.addBlocking(t.viewer?.blocking)), r.addBlockedBy(t.viewer?.blockedBy);
    for (const i of $aec35899a3c9695e$var$jm(t.labels))r.addLabel("account", i, e);
    return r;
}
$aec35899a3c9695e$var$xi.decideAccount = $aec35899a3c9695e$var$OO;
function $aec35899a3c9695e$var$jm(t) {
    return t ? t.filter((e)=>!e.uri.endsWith("/app.bsky.actor.profile/self") || e.val === "!no-unauthenticated") : [];
}
$aec35899a3c9695e$var$xi.filterAccountLabels = $aec35899a3c9695e$var$jm;
var $aec35899a3c9695e$var$Ei = {};
Object.defineProperty($aec35899a3c9695e$var$Ei, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Ei.filterProfileLabels = $aec35899a3c9695e$var$Ei.decideProfile = void 0;
const $aec35899a3c9695e$var$KO = $aec35899a3c9695e$var$zr;
function $aec35899a3c9695e$var$MO(t, e) {
    const r = new $aec35899a3c9695e$var$KO.ModerationDecision();
    r.setDid(t.did), r.setIsMe(t.did === e.userDid);
    for (const i of $aec35899a3c9695e$var$Fm(t.labels))r.addLabel("profile", i, e);
    return r;
}
$aec35899a3c9695e$var$Ei.decideProfile = $aec35899a3c9695e$var$MO;
function $aec35899a3c9695e$var$Fm(t) {
    return t ? t.filter((e)=>e.uri.endsWith("/app.bsky.actor.profile/self")) : [];
}
$aec35899a3c9695e$var$Ei.filterProfileLabels = $aec35899a3c9695e$var$Fm;
var $aec35899a3c9695e$var$Gu = {};
Object.defineProperty($aec35899a3c9695e$var$Gu, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Gu.decideNotification = void 0;
const $aec35899a3c9695e$var$Rf = $aec35899a3c9695e$var$zr, $aec35899a3c9695e$var$NO = $aec35899a3c9695e$var$xi, $aec35899a3c9695e$var$VO = $aec35899a3c9695e$var$Ei;
function $aec35899a3c9695e$var$jO(t, e) {
    const r = new $aec35899a3c9695e$var$Rf.ModerationDecision();
    if (r.setDid(t.author.did), r.setIsMe(t.author.did === e.userDid), t.labels?.length) for (const i of t.labels)r.addLabel("content", i, e);
    return $aec35899a3c9695e$var$Rf.ModerationDecision.merge(r, (0, $aec35899a3c9695e$var$NO.decideAccount)(t.author, e), (0, $aec35899a3c9695e$var$VO.decideProfile)(t.author, e));
}
$aec35899a3c9695e$var$Gu.decideNotification = $aec35899a3c9695e$var$jO;
var $aec35899a3c9695e$var$qu = {}, $aec35899a3c9695e$var$$l = {};
Object.defineProperty($aec35899a3c9695e$var$$l, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$$l.hasMutedWord = void 0;
const $aec35899a3c9695e$var$FO = $aec35899a3c9695e$var$x, $aec35899a3c9695e$var$Af = {
    LEADING_TRAILING_PUNCTUATION: /(?:^\p{P}+|\p{P}+$)/gu,
    ESCAPE: /[[\]{}()*+?.\\^$|\s]/g,
    SEPARATORS: /[/\-–—()[\]_]+/g,
    WORD_BOUNDARY: /[\s\n\t\r\f\v]+?/g
}, $aec35899a3c9695e$var$$O = [
    "ja",
    // Japanese
    "zh",
    // Chinese
    "ko",
    // Korean
    "th",
    // Thai
    "vi"
];
function $aec35899a3c9695e$var$GO({ mutedWords: t, text: e, facets: r, outlineTags: i, languages: a, actor: c }) {
    const h = $aec35899a3c9695e$var$$O.includes(a?.[0] || ""), m = [].concat(i || []).concat((r || []).flatMap((p)=>p.features.filter($aec35899a3c9695e$var$FO.AppBskyRichtextFacet.isTag).map((y)=>y.tag))).map((p)=>p.toLowerCase());
    for (const p of t){
        const y = p.value.toLowerCase(), d = e.toLowerCase();
        if (p.expiresAt && p.expiresAt < /* @__PURE__ */ new Date().toISOString() || p.actorTarget === "exclude-following" && c?.viewer?.following) continue;
        if (m.includes(y)) return !0;
        if (!p.targets.includes("content")) continue;
        if ((y.length === 1 || h) && d.includes(y)) return !0;
        if (y.length > d.length) continue;
        if (y === d || /(?:\s|\p{P})+?/u.test(y) && d.includes(y)) return !0;
        const v = d.split($aec35899a3c9695e$var$Af.WORD_BOUNDARY);
        for (const P of v){
            if (P === y) return !0;
            const K = P.replace($aec35899a3c9695e$var$Af.LEADING_TRAILING_PUNCTUATION, "");
            if (y === K) return !0;
            if (!(y.length > K.length) && /\p{P}+/u.test(K)) {
                const O = K.replace(/\p{P}+/gu, " ");
                if (O === y || O.replace(/\s/gu, "") === y) return !0;
                const Y = K.split(/\p{P}+/u);
                for (const X of Y)if (X === y) return !0;
            }
        }
    }
    return !1;
}
$aec35899a3c9695e$var$$l.hasMutedWord = $aec35899a3c9695e$var$GO;
Object.defineProperty($aec35899a3c9695e$var$qu, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$qu.decidePost = void 0;
const $aec35899a3c9695e$var$va = $aec35899a3c9695e$var$zr, $aec35899a3c9695e$var$lt = $aec35899a3c9695e$var$x, $aec35899a3c9695e$var$Qr = $aec35899a3c9695e$var$$l, $aec35899a3c9695e$var$$m = $aec35899a3c9695e$var$xi, $aec35899a3c9695e$var$Gm = $aec35899a3c9695e$var$Ei;
function $aec35899a3c9695e$var$qO(t, e) {
    const r = new $aec35899a3c9695e$var$va.ModerationDecision();
    if (r.setDid(t.author.did), r.setIsMe(t.author.did === e.userDid), t.labels?.length) for (const a of t.labels)r.addLabel("content", a, e);
    r.addHidden($aec35899a3c9695e$var$zO(t, e.prefs.hiddenPosts)), r.isMe || r.addMutedWord($aec35899a3c9695e$var$XO(t, e.prefs.mutedWords));
    let i;
    return t.embed && ($aec35899a3c9695e$var$lt.AppBskyEmbedRecord.isViewRecord(t.embed.record) ? i = $aec35899a3c9695e$var$_f(t.embed.record, e) : $aec35899a3c9695e$var$lt.AppBskyEmbedRecordWithMedia.isView(t.embed) && $aec35899a3c9695e$var$lt.AppBskyEmbedRecord.isViewRecord(t.embed.record.record) ? i = $aec35899a3c9695e$var$_f(t.embed.record.record, e) : $aec35899a3c9695e$var$lt.AppBskyEmbedRecord.isViewBlocked(t.embed.record) ? i = $aec35899a3c9695e$var$wf(t.embed.record, e) : $aec35899a3c9695e$var$lt.AppBskyEmbedRecordWithMedia.isView(t.embed) && $aec35899a3c9695e$var$lt.AppBskyEmbedRecord.isViewBlocked(t.embed.record.record) && (i = $aec35899a3c9695e$var$wf(t.embed.record.record, e))), $aec35899a3c9695e$var$va.ModerationDecision.merge(r, i?.downgrade(), (0, $aec35899a3c9695e$var$$m.decideAccount)(t.author, e), (0, $aec35899a3c9695e$var$Gm.decideProfile)(t.author, e));
}
$aec35899a3c9695e$var$qu.decidePost = $aec35899a3c9695e$var$qO;
function $aec35899a3c9695e$var$_f(t, e) {
    const r = new $aec35899a3c9695e$var$va.ModerationDecision();
    if (r.setDid(t.author.did), r.setIsMe(t.author.did === e.userDid), t.labels?.length) for (const i of t.labels)r.addLabel("content", i, e);
    return $aec35899a3c9695e$var$va.ModerationDecision.merge(r, (0, $aec35899a3c9695e$var$$m.decideAccount)(t.author, e), (0, $aec35899a3c9695e$var$Gm.decideProfile)(t.author, e));
}
function $aec35899a3c9695e$var$wf(t, e) {
    const r = new $aec35899a3c9695e$var$va.ModerationDecision();
    return r.setDid(t.author.did), r.setIsMe(t.author.did === e.userDid), t.author.viewer?.muted && (t.author.viewer?.mutedByList ? r.addMutedByList(t.author.viewer?.mutedByList) : r.addMuted(t.author.viewer?.muted)), t.author.viewer?.blocking && (t.author.viewer?.blockingByList ? r.addBlockingByList(t.author.viewer?.blockingByList) : r.addBlocking(t.author.viewer?.blocking)), r.addBlockedBy(t.author.viewer?.blockedBy), r;
}
function $aec35899a3c9695e$var$zO(t, e) {
    return e?.length ? !!(e.includes(t.uri) || t.embed && ($aec35899a3c9695e$var$lt.AppBskyEmbedRecord.isViewRecord(t.embed.record) && e.includes(t.embed.record.uri) || $aec35899a3c9695e$var$lt.AppBskyEmbedRecordWithMedia.isView(t.embed) && $aec35899a3c9695e$var$lt.AppBskyEmbedRecord.isViewRecord(t.embed.record.record) && e.includes(t.embed.record.record.uri))) : !1;
}
function $aec35899a3c9695e$var$XO(t, e) {
    if (!e?.length) return !1;
    const r = t.author;
    if ($aec35899a3c9695e$var$lt.AppBskyFeedPost.isRecord(t.record)) {
        if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
            mutedWords: e,
            text: t.record.text,
            facets: t.record.facets,
            outlineTags: t.record.tags,
            languages: t.record.langs,
            actor: r
        })) return !0;
        if (t.record.embed && $aec35899a3c9695e$var$lt.AppBskyEmbedImages.isMain(t.record.embed)) {
            for (const i of t.record.embed.images)if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
                mutedWords: e,
                text: i.alt,
                languages: t.record.langs,
                actor: r
            })) return !0;
        }
    }
    if (t.embed) {
        if ($aec35899a3c9695e$var$lt.AppBskyEmbedRecord.isViewRecord(t.embed.record)) {
            if ($aec35899a3c9695e$var$lt.AppBskyFeedPost.isRecord(t.embed.record.value)) {
                const i = t.embed.record.value, a = t.embed.record.author;
                if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
                    mutedWords: e,
                    text: i.text,
                    facets: i.facets,
                    outlineTags: i.tags,
                    languages: i.langs,
                    actor: a
                })) return !0;
                if ($aec35899a3c9695e$var$lt.AppBskyEmbedImages.isMain(i.embed)) {
                    for (const c of i.embed.images)if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
                        mutedWords: e,
                        text: c.alt,
                        languages: i.langs,
                        actor: a
                    })) return !0;
                }
                if ($aec35899a3c9695e$var$lt.AppBskyEmbedExternal.isMain(i.embed)) {
                    const { external: c } = i.embed;
                    if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
                        mutedWords: e,
                        text: c.title + " " + c.description,
                        languages: [],
                        actor: a
                    })) return !0;
                }
                if ($aec35899a3c9695e$var$lt.AppBskyEmbedRecordWithMedia.isMain(i.embed)) {
                    if ($aec35899a3c9695e$var$lt.AppBskyEmbedExternal.isMain(i.embed.media)) {
                        const { external: c } = i.embed.media;
                        if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
                            mutedWords: e,
                            text: c.title + " " + c.description,
                            languages: [],
                            actor: a
                        })) return !0;
                    }
                    if ($aec35899a3c9695e$var$lt.AppBskyEmbedImages.isMain(i.embed.media)) {
                        for (const c of i.embed.media.images)if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
                            mutedWords: e,
                            text: c.alt,
                            languages: $aec35899a3c9695e$var$lt.AppBskyFeedPost.isRecord(i.record) ? i.langs : [],
                            actor: a
                        })) return !0;
                    }
                }
            }
        } else if ($aec35899a3c9695e$var$lt.AppBskyEmbedExternal.isView(t.embed)) {
            const { external: i } = t.embed;
            if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
                mutedWords: e,
                text: i.title + " " + i.description,
                languages: [],
                actor: r
            })) return !0;
        } else if ($aec35899a3c9695e$var$lt.AppBskyEmbedRecordWithMedia.isView(t.embed) && $aec35899a3c9695e$var$lt.AppBskyEmbedRecord.isViewRecord(t.embed.record.record)) {
            const i = t.embed.record.record.author;
            if ($aec35899a3c9695e$var$lt.AppBskyFeedPost.isRecord(t.embed.record.record.value)) {
                const a = t.embed.record.record.value;
                if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
                    mutedWords: e,
                    text: a.text,
                    facets: a.facets,
                    outlineTags: a.tags,
                    languages: a.langs,
                    actor: i
                })) return !0;
            }
            if ($aec35899a3c9695e$var$lt.AppBskyEmbedImages.isView(t.embed.media)) {
                for (const a of t.embed.media.images)if ((0, $aec35899a3c9695e$var$Qr.hasMutedWord)({
                    mutedWords: e,
                    text: a.alt,
                    languages: $aec35899a3c9695e$var$lt.AppBskyFeedPost.isRecord(t.record) ? t.record.langs : [],
                    actor: i
                })) return !0;
            }
        }
    }
    return !1;
}
var $aec35899a3c9695e$var$zu = {};
Object.defineProperty($aec35899a3c9695e$var$zu, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$zu.decideFeedGenerator = void 0;
const $aec35899a3c9695e$var$Tf = $aec35899a3c9695e$var$zr, $aec35899a3c9695e$var$HO = $aec35899a3c9695e$var$xi, $aec35899a3c9695e$var$ZO = $aec35899a3c9695e$var$Ei;
function $aec35899a3c9695e$var$WO(t, e) {
    const r = new $aec35899a3c9695e$var$Tf.ModerationDecision();
    if (r.setDid(t.creator.did), r.setIsMe(t.creator.did === e.userDid), t.labels?.length) for (const i of t.labels)r.addLabel("content", i, e);
    return $aec35899a3c9695e$var$Tf.ModerationDecision.merge(r, (0, $aec35899a3c9695e$var$HO.decideAccount)(t.creator, e), (0, $aec35899a3c9695e$var$ZO.decideProfile)(t.creator, e));
}
$aec35899a3c9695e$var$zu.decideFeedGenerator = $aec35899a3c9695e$var$WO;
var $aec35899a3c9695e$var$Xu = {};
Object.defineProperty($aec35899a3c9695e$var$Xu, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Xu.decideUserList = void 0;
const $aec35899a3c9695e$var$YO = $aec35899a3c9695e$var$as, $aec35899a3c9695e$var$Sf = $aec35899a3c9695e$var$zr, $aec35899a3c9695e$var$JO = $aec35899a3c9695e$var$xi, $aec35899a3c9695e$var$QO = $aec35899a3c9695e$var$Ei;
function $aec35899a3c9695e$var$eK(t, e) {
    const r = new $aec35899a3c9695e$var$Sf.ModerationDecision(), i = $aec35899a3c9695e$var$tK(t.creator) ? t.creator : void 0;
    if (i) {
        if (r.setDid(i.did), r.setIsMe(i.did === e.userDid), t.labels?.length) for (const c of t.labels)r.addLabel("content", c, e);
        return $aec35899a3c9695e$var$Sf.ModerationDecision.merge(r, (0, $aec35899a3c9695e$var$JO.decideAccount)(i, e), (0, $aec35899a3c9695e$var$QO.decideProfile)(i, e));
    }
    const a = new $aec35899a3c9695e$var$YO.AtUri(t.uri).hostname;
    if (r.setDid(a), r.setIsMe(a === e.userDid), t.labels?.length) for (const c of t.labels)r.addLabel("content", c, e);
    return r;
}
$aec35899a3c9695e$var$Xu.decideUserList = $aec35899a3c9695e$var$eK;
function $aec35899a3c9695e$var$tK(t) {
    return t && typeof t == "object" && "did" in t;
}
var $aec35899a3c9695e$var$ui = {};
Object.defineProperty($aec35899a3c9695e$var$ui, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$ui.interpretLabelValueDefinitions = $aec35899a3c9695e$var$ui.interpretLabelValueDefinition = $aec35899a3c9695e$var$ui.isQuotedPostWithMedia = $aec35899a3c9695e$var$ui.isQuotedPost = void 0;
const $aec35899a3c9695e$var$ad = $aec35899a3c9695e$var$x;
function $aec35899a3c9695e$var$rK(t) {
    return !!(t && $aec35899a3c9695e$var$ad.AppBskyEmbedRecord.isView(t));
}
$aec35899a3c9695e$var$ui.isQuotedPost = $aec35899a3c9695e$var$rK;
function $aec35899a3c9695e$var$iK(t) {
    return !!(t && $aec35899a3c9695e$var$ad.AppBskyEmbedRecordWithMedia.isView(t));
}
$aec35899a3c9695e$var$ui.isQuotedPostWithMedia = $aec35899a3c9695e$var$iK;
function $aec35899a3c9695e$var$qm(t, e) {
    const r = {
        account: {},
        profile: {},
        content: {}
    }, i = t.severity === "alert" ? "alert" : t.severity === "inform" ? "inform" : void 0;
    t.blurs === "content" ? (r.account.profileList = i, r.account.profileView = i, r.account.contentList = "blur", r.account.contentView = t.adultOnly ? "blur" : i, r.profile.profileList = i, r.profile.profileView = i, r.content.contentList = "blur", r.content.contentView = t.adultOnly ? "blur" : i) : t.blurs === "media" ? (r.account.profileList = i, r.account.profileView = i, r.account.avatar = "blur", r.account.banner = "blur", r.profile.profileList = i, r.profile.profileView = i, r.profile.avatar = "blur", r.profile.banner = "blur", r.content.contentMedia = "blur") : t.blurs === "none" && (r.account.profileList = i, r.account.profileView = i, r.account.contentList = i, r.account.contentView = i, r.profile.profileList = i, r.profile.profileView = i, r.content.contentList = i, r.content.contentView = i);
    let a = "warn";
    (t.defaultSetting === "hide" || t.defaultSetting === "ignore") && (a = t.defaultSetting);
    const c = [
        "no-self"
    ];
    return t.adultOnly && c.push("adult"), {
        ...t,
        definedBy: e,
        configurable: !0,
        defaultSetting: a,
        flags: c,
        behaviors: r
    };
}
$aec35899a3c9695e$var$ui.interpretLabelValueDefinition = $aec35899a3c9695e$var$qm;
function $aec35899a3c9695e$var$nK(t) {
    return (t.policies?.labelValueDefinitions || []).filter((e)=>$aec35899a3c9695e$var$ad.ComAtprotoLabelDefs.validateLabelValueDefinition(e).success).map((e)=>$aec35899a3c9695e$var$qm(e, t.creator.did));
}
$aec35899a3c9695e$var$ui.interpretLabelValueDefinitions = $aec35899a3c9695e$var$nK;
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.moderateUserList = t.moderateFeedGenerator = t.moderateNotification = t.moderatePost = t.moderateProfile = t.interpretLabelValueDefinitions = t.interpretLabelValueDefinition = t.hasMutedWord = t.ModerationDecision = t.ModerationUI = void 0;
    const e = $aec35899a3c9695e$var$xi, r = $aec35899a3c9695e$var$Ei, i = $aec35899a3c9695e$var$Gu, a = $aec35899a3c9695e$var$qu, c = $aec35899a3c9695e$var$zu, h = $aec35899a3c9695e$var$Xu, m = $aec35899a3c9695e$var$zr;
    var p = $aec35899a3c9695e$var$Fl;
    Object.defineProperty(t, "ModerationUI", {
        enumerable: !0,
        get: function() {
            return p.ModerationUI;
        }
    });
    var y = $aec35899a3c9695e$var$zr;
    Object.defineProperty(t, "ModerationDecision", {
        enumerable: !0,
        get: function() {
            return y.ModerationDecision;
        }
    });
    var d = $aec35899a3c9695e$var$$l;
    Object.defineProperty(t, "hasMutedWord", {
        enumerable: !0,
        get: function() {
            return d.hasMutedWord;
        }
    });
    var v = $aec35899a3c9695e$var$ui;
    Object.defineProperty(t, "interpretLabelValueDefinition", {
        enumerable: !0,
        get: function() {
            return v.interpretLabelValueDefinition;
        }
    }), Object.defineProperty(t, "interpretLabelValueDefinitions", {
        enumerable: !0,
        get: function() {
            return v.interpretLabelValueDefinitions;
        }
    });
    function P(X, V) {
        return m.ModerationDecision.merge((0, e.decideAccount)(X, V), (0, r.decideProfile)(X, V));
    }
    t.moderateProfile = P;
    function K(X, V) {
        return (0, a.decidePost)(X, V);
    }
    t.moderatePost = K;
    function O(X, V) {
        return (0, i.decideNotification)(X, V);
    }
    t.moderateNotification = O;
    function Z(X, V) {
        return (0, c.decideFeedGenerator)(X, V);
    }
    t.moderateFeedGenerator = Z;
    function Y(X, V) {
        return (0, h.decideUserList)(X, V);
    }
    t.moderateUserList = Y;
})($aec35899a3c9695e$var$nd);
var $aec35899a3c9695e$var$Hu = {};
Object.defineProperty($aec35899a3c9695e$var$Hu, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Hu.mock = void 0;
const $aec35899a3c9695e$var$ta = "bafyreiclp443lavogvhj3d2ob2cxbfuscni2k5jk7bebjzg7khl3esabwq";
$aec35899a3c9695e$var$Hu.mock = {
    post ({ text: t, facets: e, reply: r, embed: i }) {
        return {
            $type: "app.bsky.feed.post",
            text: t,
            facets: e,
            reply: r,
            embed: i,
            langs: [
                "en"
            ],
            createdAt: /* @__PURE__ */ new Date().toISOString()
        };
    },
    postView ({ record: t, author: e, embed: r, replyCount: i, repostCount: a, likeCount: c, viewer: h, labels: m }) {
        return {
            $type: "app.bsky.feed.defs#postView",
            uri: `at://${e.did}/app.bsky.feed.post/fake`,
            cid: $aec35899a3c9695e$var$ta,
            author: e,
            record: t,
            embed: r,
            replyCount: i,
            repostCount: a,
            likeCount: c,
            indexedAt: /* @__PURE__ */ new Date().toISOString(),
            viewer: h,
            labels: m
        };
    },
    embedRecordView ({ record: t, author: e, labels: r }) {
        return {
            $type: "app.bsky.embed.record#view",
            record: {
                $type: "app.bsky.embed.record#viewRecord",
                uri: `at://${e.did}/app.bsky.feed.post/fake`,
                cid: $aec35899a3c9695e$var$ta,
                author: e,
                value: t,
                labels: r,
                indexedAt: /* @__PURE__ */ new Date().toISOString()
            }
        };
    },
    profileViewBasic ({ handle: t, displayName: e, description: r, viewer: i, labels: a }) {
        return {
            did: `did:web:${t}`,
            handle: t,
            displayName: e,
            description: r,
            // technically not in ProfileViewBasic but useful in some cases
            viewer: i,
            labels: a
        };
    },
    actorViewerState ({ muted: t, mutedByList: e, blockedBy: r, blocking: i, blockingByList: a, following: c, followedBy: h }) {
        return {
            muted: t,
            mutedByList: e,
            blockedBy: r,
            blocking: i,
            blockingByList: a,
            following: c,
            followedBy: h
        };
    },
    listViewBasic ({ name: t }) {
        return {
            uri: "at://did:plc:fake/app.bsky.graph.list/fake",
            cid: $aec35899a3c9695e$var$ta,
            name: t,
            purpose: "app.bsky.graph.defs#modlist",
            indexedAt: /* @__PURE__ */ new Date().toISOString()
        };
    },
    replyNotification ({ author: t, record: e, labels: r }) {
        return {
            uri: `at://${t.did}/app.bsky.feed.post/fake`,
            cid: $aec35899a3c9695e$var$ta,
            author: t,
            reason: "reply",
            reasonSubject: `at://${t.did}/app.bsky.feed.post/fake-parent`,
            record: e,
            isRead: !1,
            indexedAt: /* @__PURE__ */ new Date().toISOString(),
            labels: r
        };
    },
    followNotification ({ author: t, subjectDid: e, labels: r }) {
        return {
            uri: `at://${t.did}/app.bsky.graph.follow/fake`,
            cid: $aec35899a3c9695e$var$ta,
            author: t,
            reason: "follow",
            record: {
                $type: "app.bsky.graph.follow",
                createdAt: /* @__PURE__ */ new Date().toISOString(),
                subject: e
            },
            isRead: !1,
            indexedAt: /* @__PURE__ */ new Date().toISOString(),
            labels: r
        };
    },
    label ({ val: t, uri: e, src: r }) {
        return {
            src: r || "did:plc:fake-labeler",
            uri: e,
            val: t,
            cts: /* @__PURE__ */ new Date().toISOString()
        };
    }
};
var $aec35899a3c9695e$var$Zu = {}, $aec35899a3c9695e$var$od = {}, $aec35899a3c9695e$var$ei = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__classPrivateFieldGet || function(t, e, r, i) {
    if (r === "a" && !i) throw new TypeError("Private accessor was defined without a getter");
    if (typeof e == "function" ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return r === "m" ? i : r === "a" ? i.call(t) : i ? i.value : e.get(t);
}, $aec35899a3c9695e$var$yc = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__classPrivateFieldSet || function(t, e, r, i, a) {
    if (i === "m") throw new TypeError("Private method is not writable");
    if (i === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
    if (typeof e == "function" ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return i === "a" ? a.call(t, r) : a ? a.value = r : e.set(t, r), r;
}, $aec35899a3c9695e$var$Di, $aec35899a3c9695e$var$an;
Object.defineProperty($aec35899a3c9695e$var$od, "__esModule", {
    value: !0
});
class $aec35899a3c9695e$var$sK {
    constructor(){
        $aec35899a3c9695e$var$Di.set(this, !1), $aec35899a3c9695e$var$an.set(this, /* @__PURE__ */ new Set());
    }
    /**
   * Whether the lock is currently acquired or not. Accessing this property does not affect the
   * status of the lock.
   */ get acquired() {
        return $aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$Di, "f");
    }
    /**
   * Acquires the lock, waiting if necessary for it to become free if it is already locked. The
   * returned promise is fulfilled once the lock is acquired.
   *
   * A timeout (in milliseconds) may be optionally provided. If the lock cannot be acquired before
   * the timeout elapses, the returned promise is rejected with an error. The behavior of invalid
   * timeout values depends on how `setTimeout` handles those values.
   *
   * After acquiring the lock, you **must** call `release` when you are done with it.
   */ acquireAsync({ timeout: e } = {}) {
        if (!$aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$Di, "f")) return $aec35899a3c9695e$var$yc(this, $aec35899a3c9695e$var$Di, !0, "f"), Promise.resolve();
        if (e == null) return new Promise((a)=>{
            $aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$an, "f").add(a);
        });
        let r, i;
        return Promise.race([
            new Promise((a)=>{
                r = ()=>{
                    clearTimeout(i), a();
                }, $aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$an, "f").add(r);
            }),
            new Promise((a, c)=>{
                i = setTimeout(()=>{
                    $aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$an, "f").delete(r), c(new Error("Timed out waiting for lock"));
                }, e);
            })
        ]);
    }
    /**
   * Acquires the lock if it is free and otherwise returns immediately without waiting. Returns
   * `true` if the lock was free and is now acquired, and `false` otherwise.
   *
   * This method differs from calling `acquireAsync` with a zero-millisecond timeout in that it runs
   * synchronously without waiting for the JavaScript task queue.
   */ tryAcquire() {
        return $aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$Di, "f") ? !1 : ($aec35899a3c9695e$var$yc(this, $aec35899a3c9695e$var$Di, !0, "f"), !0);
    }
    /**
   * Releases the lock and gives it to the next waiting acquirer, if there is one. Each acquirer
   * must release the lock exactly once.
   */ release() {
        if (!$aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$Di, "f")) throw new Error("Cannot release an unacquired lock");
        if ($aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$an, "f").size > 0) {
            const [e] = $aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$an, "f");
            $aec35899a3c9695e$var$ei(this, $aec35899a3c9695e$var$an, "f").delete(e), e();
        } else $aec35899a3c9695e$var$yc(this, $aec35899a3c9695e$var$Di, !1, "f");
    }
}
$aec35899a3c9695e$var$od.default = $aec35899a3c9695e$var$sK;
$aec35899a3c9695e$var$Di = /* @__PURE__ */ new WeakMap(), $aec35899a3c9695e$var$an = /* @__PURE__ */ new WeakMap();
var $aec35899a3c9695e$var$aK = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__importDefault || function(t) {
    return t && t.__esModule ? t : {
        default: t
    };
};
Object.defineProperty($aec35899a3c9695e$var$Zu, "__esModule", {
    value: !0
});
$aec35899a3c9695e$var$Zu.BskyAgent = void 0;
const $aec35899a3c9695e$var$ms = $aec35899a3c9695e$var$as, $aec35899a3c9695e$var$on = $aec35899a3c9695e$var$vi, $aec35899a3c9695e$var$oK = $aec35899a3c9695e$var$aK($aec35899a3c9695e$var$od), $aec35899a3c9695e$var$lK = $aec35899a3c9695e$var$js, $aec35899a3c9695e$var$oe = $aec35899a3c9695e$var$x, $aec35899a3c9695e$var$uK = $aec35899a3c9695e$var$En, $aec35899a3c9695e$var$ln = $aec35899a3c9695e$var$Nr, $aec35899a3c9695e$var$cK = $aec35899a3c9695e$var$nd, $aec35899a3c9695e$var$Cf = {
    hideReplies: !1,
    hideRepliesByUnfollowed: !0,
    hideRepliesByLikeCount: 0,
    hideReposts: !1,
    hideQuotePosts: !1
}, $aec35899a3c9695e$var$dK = {
    sort: "oldest",
    prioritizeFollowedUsers: !0
};
class $aec35899a3c9695e$var$gs extends $aec35899a3c9695e$var$lK.AtpAgent {
    constructor(){
        super(...arguments), Object.defineProperty(this, "_prefsLock", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new $aec35899a3c9695e$var$oK.default()
        }), Object.defineProperty(this, "getTimeline", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.feed.getTimeline(e, r)
        }), Object.defineProperty(this, "getAuthorFeed", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.feed.getAuthorFeed(e, r)
        }), Object.defineProperty(this, "getActorLikes", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.feed.getActorLikes(e, r)
        }), Object.defineProperty(this, "getPostThread", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.feed.getPostThread(e, r)
        }), Object.defineProperty(this, "getPost", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e)=>this.api.app.bsky.feed.post.get(e)
        }), Object.defineProperty(this, "getPosts", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.feed.getPosts(e, r)
        }), Object.defineProperty(this, "getLikes", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.feed.getLikes(e, r)
        }), Object.defineProperty(this, "getRepostedBy", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.feed.getRepostedBy(e, r)
        }), Object.defineProperty(this, "getFollows", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.graph.getFollows(e, r)
        }), Object.defineProperty(this, "getFollowers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.graph.getFollowers(e, r)
        }), Object.defineProperty(this, "getProfile", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.actor.getProfile(e, r)
        }), Object.defineProperty(this, "getProfiles", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.actor.getProfiles(e, r)
        }), Object.defineProperty(this, "getSuggestions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.actor.getSuggestions(e, r)
        }), Object.defineProperty(this, "searchActors", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.actor.searchActors(e, r)
        }), Object.defineProperty(this, "searchActorsTypeahead", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.actor.searchActorsTypeahead(e, r)
        }), Object.defineProperty(this, "listNotifications", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.notification.listNotifications(e, r)
        }), Object.defineProperty(this, "countUnreadNotifications", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.notification.getUnreadCount(e, r)
        }), Object.defineProperty(this, "getLabelers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (e, r)=>this.api.app.bsky.labeler.getServices(e, r)
        });
    }
    clone() {
        const e = new $aec35899a3c9695e$var$gs({
            service: this.service
        });
        return this.copyInto(e), e;
    }
    get app() {
        return this.api.app;
    }
    async getLabelDefinitions(e) {
        let r = $aec35899a3c9695e$var$gs.appLabelers;
        $aec35899a3c9695e$var$hK(e) ? r = r.concat(e.moderationPrefs.labelers.map((c)=>c.did)) : $aec35899a3c9695e$var$zm(e) ? r = r.concat(e.labelers.map((c)=>c.did)) : r = r.concat(e);
        const i = await this.getLabelers({
            dids: r,
            detailed: !0
        }), a = {};
        if (i.data) for (const c of i.data.views)a[c.creator.did] = (0, $aec35899a3c9695e$var$cK.interpretLabelValueDefinitions)(c);
        return a;
    }
    async post(e) {
        if (!this.session) throw new Error("Not logged in");
        return e.createdAt = e.createdAt || /* @__PURE__ */ new Date().toISOString(), this.api.app.bsky.feed.post.create({
            repo: this.session.did
        }, e);
    }
    async deletePost(e) {
        if (!this.session) throw new Error("Not logged in");
        const r = new $aec35899a3c9695e$var$ms.AtUri(e);
        return await this.api.app.bsky.feed.post.delete({
            repo: r.hostname,
            rkey: r.rkey
        });
    }
    async like(e, r) {
        if (!this.session) throw new Error("Not logged in");
        return await this.api.app.bsky.feed.like.create({
            repo: this.session.did
        }, {
            subject: {
                uri: e,
                cid: r
            },
            createdAt: /* @__PURE__ */ new Date().toISOString()
        });
    }
    async deleteLike(e) {
        if (!this.session) throw new Error("Not logged in");
        const r = new $aec35899a3c9695e$var$ms.AtUri(e);
        return await this.api.app.bsky.feed.like.delete({
            repo: r.hostname,
            rkey: r.rkey
        });
    }
    async repost(e, r) {
        if (!this.session) throw new Error("Not logged in");
        return await this.api.app.bsky.feed.repost.create({
            repo: this.session.did
        }, {
            subject: {
                uri: e,
                cid: r
            },
            createdAt: /* @__PURE__ */ new Date().toISOString()
        });
    }
    async deleteRepost(e) {
        if (!this.session) throw new Error("Not logged in");
        const r = new $aec35899a3c9695e$var$ms.AtUri(e);
        return await this.api.app.bsky.feed.repost.delete({
            repo: r.hostname,
            rkey: r.rkey
        });
    }
    async follow(e) {
        if (!this.session) throw new Error("Not logged in");
        return await this.api.app.bsky.graph.follow.create({
            repo: this.session.did
        }, {
            subject: e,
            createdAt: /* @__PURE__ */ new Date().toISOString()
        });
    }
    async deleteFollow(e) {
        if (!this.session) throw new Error("Not logged in");
        const r = new $aec35899a3c9695e$var$ms.AtUri(e);
        return await this.api.app.bsky.graph.follow.delete({
            repo: r.hostname,
            rkey: r.rkey
        });
    }
    async upsertProfile(e) {
        if (!this.session) throw new Error("Not logged in");
        let r = 5;
        for(; r >= 0;){
            const i = await this.com.atproto.repo.getRecord({
                repo: this.session.did,
                collection: "app.bsky.actor.profile",
                rkey: "self"
            }).catch((h)=>{}), a = await e(i?.data.value);
            a && (a.$type = "app.bsky.actor.profile");
            const c = $aec35899a3c9695e$var$oe.AppBskyActorProfile.validateRecord(a);
            if (!c.success) throw c.error;
            try {
                await this.com.atproto.repo.putRecord({
                    repo: this.session.did,
                    collection: "app.bsky.actor.profile",
                    rkey: "self",
                    record: a,
                    swapRecord: i?.data.cid || null
                });
            } catch (h) {
                if (r > 0 && h instanceof $aec35899a3c9695e$var$oe.ComAtprotoRepoPutRecord.InvalidSwapError) {
                    r--;
                    continue;
                } else throw h;
            }
            break;
        }
    }
    async mute(e) {
        return this.api.app.bsky.graph.muteActor({
            actor: e
        });
    }
    async unmute(e) {
        return this.api.app.bsky.graph.unmuteActor({
            actor: e
        });
    }
    async muteModList(e) {
        return this.api.app.bsky.graph.muteActorList({
            list: e
        });
    }
    async unmuteModList(e) {
        return this.api.app.bsky.graph.unmuteActorList({
            list: e
        });
    }
    async blockModList(e) {
        if (!this.session) throw new Error("Not logged in");
        return await this.api.app.bsky.graph.listblock.create({
            repo: this.session.did
        }, {
            subject: e,
            createdAt: /* @__PURE__ */ new Date().toISOString()
        });
    }
    async unblockModList(e) {
        if (!this.session) throw new Error("Not logged in");
        const r = await this.api.app.bsky.graph.getList({
            list: e,
            limit: 1
        });
        if (!r.data.list.viewer?.blocked) return;
        const { rkey: i } = new $aec35899a3c9695e$var$ms.AtUri(r.data.list.viewer.blocked);
        return await this.api.app.bsky.graph.listblock.delete({
            repo: this.session.did,
            rkey: i
        });
    }
    async updateSeenNotifications(e) {
        return e = e || /* @__PURE__ */ new Date().toISOString(), this.api.app.bsky.notification.updateSeen({
            seenAt: e
        });
    }
    async getPreferences() {
        const e = {
            feeds: {
                saved: void 0,
                pinned: void 0
            },
            // @ts-ignore populating below
            savedFeeds: void 0,
            feedViewPrefs: {
                home: {
                    ...$aec35899a3c9695e$var$Cf
                }
            },
            threadViewPrefs: {
                ...$aec35899a3c9695e$var$dK
            },
            moderationPrefs: {
                adultContentEnabled: !1,
                labels: {
                    ...$aec35899a3c9695e$var$uK.DEFAULT_LABEL_SETTINGS
                },
                labelers: $aec35899a3c9695e$var$gs.appLabelers.map((a)=>({
                        did: a,
                        labels: {}
                    })),
                mutedWords: [],
                hiddenPosts: []
            },
            birthDate: void 0,
            interests: {
                tags: []
            },
            bskyAppState: {
                queuedNudges: [],
                activeProgressGuide: void 0
            }
        }, r = await this.app.bsky.actor.getPreferences({}), i = [];
        for (const a of r.data.preferences)if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isAdultContentPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateAdultContentPref(a).success) e.moderationPrefs.adultContentEnabled = a.enabled;
        else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isContentLabelPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateContentLabelPref(a).success) {
            const c = $aec35899a3c9695e$var$fK(a);
            i.push(c);
        } else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isLabelersPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateLabelersPref(a).success) e.moderationPrefs.labelers = $aec35899a3c9695e$var$gs.appLabelers.map((c)=>({
                did: c,
                labels: {}
            })).concat(a.labelers.map((c)=>({
                ...c,
                labels: {}
            })));
        else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isSavedFeedsPrefV2(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateSavedFeedsPrefV2(a).success) e.savedFeeds = a.items;
        else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isSavedFeedsPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateSavedFeedsPref(a).success) e.feeds.saved = a.saved, e.feeds.pinned = a.pinned;
        else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isPersonalDetailsPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validatePersonalDetailsPref(a).success) a.birthDate && (e.birthDate = new Date(a.birthDate));
        else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isFeedViewPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateFeedViewPref(a).success) {
            const { $type: c, feed: h, ...m } = a;
            e.feedViewPrefs[a.feed] = {
                ...$aec35899a3c9695e$var$Cf,
                ...m
            };
        } else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isThreadViewPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateThreadViewPref(a).success) {
            const { $type: c, ...h } = a;
            e.threadViewPrefs = {
                ...e.threadViewPrefs,
                ...h
            };
        } else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isInterestsPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateInterestsPref(a).success) {
            const { $type: c, ...h } = a;
            e.interests = {
                ...e.interests,
                ...h
            };
        } else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateMutedWordsPref(a).success) {
            const { $type: c, ...h } = a;
            e.moderationPrefs.mutedWords = h.items, e.moderationPrefs.mutedWords.length && (e.moderationPrefs.mutedWords = e.moderationPrefs.mutedWords.map((m)=>(m.actorTarget = m.actorTarget || "all", m)));
        } else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isHiddenPostsPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateHiddenPostsPref(a).success) {
            const { $type: c, ...h } = a;
            e.moderationPrefs.hiddenPosts = h.items;
        } else if ($aec35899a3c9695e$var$oe.AppBskyActorDefs.isBskyAppStatePref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateBskyAppStatePref(a).success) {
            const { $type: c, ...h } = a;
            e.bskyAppState.queuedNudges = h.queuedNudges || [], e.bskyAppState.activeProgressGuide = h.activeProgressGuide;
        }
        if (e.savedFeeds === void 0) {
            const { saved: a, pinned: c } = e.feeds;
            if (a && c) {
                const h = /* @__PURE__ */ new Map();
                h.set("timeline", {
                    id: $aec35899a3c9695e$var$on.TID.nextStr(),
                    type: "timeline",
                    value: "following",
                    pinned: !0
                });
                for (const m of c){
                    const p = (0, $aec35899a3c9695e$var$ln.getSavedFeedType)(m);
                    p !== "unknown" && h.set(m, {
                        id: $aec35899a3c9695e$var$on.TID.nextStr(),
                        type: p,
                        value: m,
                        pinned: !0
                    });
                }
                for (const m of a)if (!h.has(m)) {
                    const p = (0, $aec35899a3c9695e$var$ln.getSavedFeedType)(m);
                    if (p === "unknown") continue;
                    h.set(m, {
                        id: $aec35899a3c9695e$var$on.TID.nextStr(),
                        type: p,
                        value: m,
                        pinned: !1
                    });
                }
                e.savedFeeds = Array.from(h.values());
            } else e.savedFeeds = [
                {
                    id: $aec35899a3c9695e$var$on.TID.nextStr(),
                    type: "timeline",
                    value: "following",
                    pinned: !0
                }
            ];
            await this.overwriteSavedFeeds(e.savedFeeds);
        }
        for (const a of i)if (a.labelerDid) {
            const c = e.moderationPrefs.labelers.find((h)=>h.did === a.labelerDid);
            if (!c) continue;
            c.labels[a.label] = a.visibility;
        } else e.moderationPrefs.labels[a.label] = a.visibility;
        return e.moderationPrefs.labels = $aec35899a3c9695e$var$pK(e.moderationPrefs.labels), this.configureLabelersHeader($aec35899a3c9695e$var$bc(r.data.preferences)), e;
    }
    async overwriteSavedFeeds(e) {
        e.forEach($aec35899a3c9695e$var$ln.validateSavedFeed);
        const r = /* @__PURE__ */ new Map();
        return e.forEach((i)=>{
            r.has(i.id) && r.delete(i.id), r.set(i.id, i);
        }), $aec35899a3c9695e$var$su(this, ()=>Array.from(r.values()));
    }
    async updateSavedFeeds(e) {
        return e.map($aec35899a3c9695e$var$ln.validateSavedFeed), $aec35899a3c9695e$var$su(this, (r)=>r.map((i)=>{
                const a = e.find((c)=>i.id === c.id);
                return a ? {
                    ...i,
                    // only update pinned
                    pinned: a.pinned
                } : i;
            }));
    }
    async addSavedFeeds(e) {
        const r = e.map((i)=>({
                ...i,
                id: $aec35899a3c9695e$var$on.TID.nextStr()
            }));
        return r.forEach($aec35899a3c9695e$var$ln.validateSavedFeed), $aec35899a3c9695e$var$su(this, (i)=>[
                ...i,
                ...r
            ]);
    }
    async removeSavedFeeds(e) {
        return $aec35899a3c9695e$var$su(this, (r)=>[
                ...r.filter((i)=>!e.find((a)=>i.id === a))
            ]);
    }
    /**
   * @deprecated use `overwriteSavedFeeds`
   */ async setSavedFeeds(e, r) {
        return $aec35899a3c9695e$var$ra(this, ()=>({
                saved: e,
                pinned: r
            }));
    }
    /**
   * @deprecated use `addSavedFeeds`
   */ async addSavedFeed(e) {
        return $aec35899a3c9695e$var$ra(this, (r, i)=>({
                saved: [
                    ...r.filter((a)=>a !== e),
                    e
                ],
                pinned: i
            }));
    }
    /**
   * @deprecated use `removeSavedFeeds`
   */ async removeSavedFeed(e) {
        return $aec35899a3c9695e$var$ra(this, (r, i)=>({
                saved: r.filter((a)=>a !== e),
                pinned: i.filter((a)=>a !== e)
            }));
    }
    /**
   * @deprecated use `addSavedFeeds` or `updateSavedFeeds`
   */ async addPinnedFeed(e) {
        return $aec35899a3c9695e$var$ra(this, (r, i)=>({
                saved: [
                    ...r.filter((a)=>a !== e),
                    e
                ],
                pinned: [
                    ...i.filter((a)=>a !== e),
                    e
                ]
            }));
    }
    /**
   * @deprecated use `updateSavedFeeds` or `removeSavedFeeds`
   */ async removePinnedFeed(e) {
        return $aec35899a3c9695e$var$ra(this, (r, i)=>({
                saved: r,
                pinned: i.filter((a)=>a !== e)
            }));
    }
    async setAdultContentEnabled(e) {
        await $aec35899a3c9695e$var$Gt(this, (r)=>{
            let i = r.findLast((a)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isAdultContentPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateAdultContentPref(a).success);
            return i ? i.enabled = e : i = {
                $type: "app.bsky.actor.defs#adultContentPref",
                enabled: e
            }, r.filter((a)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isAdultContentPref(a)).concat([
                i
            ]);
        });
    }
    async setContentLabelPref(e, r, i) {
        i && (0, $aec35899a3c9695e$var$ms.ensureValidDid)(i), await $aec35899a3c9695e$var$Gt(this, (a)=>{
            let c = a.findLast((m)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isContentLabelPref(m) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateContentLabelPref(m).success && m.label === e && m.labelerDid === i), h;
            if (c ? c.visibility = r : c = {
                $type: "app.bsky.actor.defs#contentLabelPref",
                label: e,
                labelerDid: i,
                visibility: r
            }, $aec35899a3c9695e$var$oe.AppBskyActorDefs.isContentLabelPref(c) && !c.labelerDid) {
                const m = {
                    "graphic-media": "gore",
                    porn: "nsfw",
                    sexual: "suggestive"
                }[c.label];
                m && (h = a.findLast((p)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isContentLabelPref(p) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateContentLabelPref(p).success && p.label === m && p.labelerDid === void 0), h ? h.visibility = r : h = {
                    $type: "app.bsky.actor.defs#contentLabelPref",
                    label: m,
                    labelerDid: void 0,
                    visibility: r
                });
            }
            return a.filter((m)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isContentLabelPref(m) || !(m.label === e && m.labelerDid === i)).concat([
                c
            ]).filter((m)=>h ? !$aec35899a3c9695e$var$oe.AppBskyActorDefs.isContentLabelPref(m) || !(m.label === h.label && m.labelerDid === void 0) : !0).concat(h ? [
                h
            ] : []);
        });
    }
    async addLabeler(e) {
        const r = await $aec35899a3c9695e$var$Gt(this, (i)=>{
            let a = i.findLast((c)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isLabelersPref(c) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateLabelersPref(c).success);
            if (a || (a = {
                $type: "app.bsky.actor.defs#labelersPref",
                labelers: []
            }), $aec35899a3c9695e$var$oe.AppBskyActorDefs.isLabelersPref(a)) {
                let c = a.labelers.find((h)=>h.did === e);
                c || (c = {
                    did: e
                }, a.labelers.push(c));
            }
            return i.filter((c)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isLabelersPref(c)).concat([
                a
            ]);
        });
        this.configureLabelersHeader($aec35899a3c9695e$var$bc(r));
    }
    async removeLabeler(e) {
        const r = await $aec35899a3c9695e$var$Gt(this, (i)=>{
            let a = i.findLast((c)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isLabelersPref(c) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateLabelersPref(c).success);
            return a || (a = {
                $type: "app.bsky.actor.defs#labelersPref",
                labelers: []
            }), $aec35899a3c9695e$var$oe.AppBskyActorDefs.isLabelersPref(a) && (a.labelers = a.labelers.filter((c)=>c.did !== e)), i.filter((c)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isLabelersPref(c)).concat([
                a
            ]);
        });
        this.configureLabelersHeader($aec35899a3c9695e$var$bc(r));
    }
    async setPersonalDetails({ birthDate: e }) {
        e = e instanceof Date ? e.toISOString() : e, await $aec35899a3c9695e$var$Gt(this, (r)=>{
            let i = r.findLast((a)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isPersonalDetailsPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validatePersonalDetailsPref(a).success);
            return i ? i.birthDate = e : i = {
                $type: "app.bsky.actor.defs#personalDetailsPref",
                birthDate: e
            }, r.filter((a)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isPersonalDetailsPref(a)).concat([
                i
            ]);
        });
    }
    async setFeedViewPrefs(e, r) {
        await $aec35899a3c9695e$var$Gt(this, (i)=>{
            const a = i.findLast((c)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isFeedViewPref(c) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateFeedViewPref(c).success && c.feed === e);
            return a && (r = {
                ...a,
                ...r
            }), i.filter((c)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isFeedViewPref(r) || c.feed !== e).concat([
                {
                    ...r,
                    $type: "app.bsky.actor.defs#feedViewPref",
                    feed: e
                }
            ]);
        });
    }
    async setThreadViewPrefs(e) {
        await $aec35899a3c9695e$var$Gt(this, (r)=>{
            const i = r.findLast((a)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isThreadViewPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateThreadViewPref(a).success);
            return i && (e = {
                ...i,
                ...e
            }), r.filter((a)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isThreadViewPref(a)).concat([
                {
                    ...e,
                    $type: "app.bsky.actor.defs#threadViewPref"
                }
            ]);
        });
    }
    async setInterestsPref(e) {
        await $aec35899a3c9695e$var$Gt(this, (r)=>{
            const i = r.findLast((a)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isInterestsPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateInterestsPref(a).success);
            return i && (e = {
                ...i,
                ...e
            }), r.filter((a)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isInterestsPref(a)).concat([
                {
                    ...e,
                    $type: "app.bsky.actor.defs#interestsPref"
                }
            ]);
        });
    }
    /**
   * Add a muted word to user preferences.
   */ async addMutedWord(e) {
        const r = (0, $aec35899a3c9695e$var$ln.sanitizeMutedWordValue)(e.value);
        r && await $aec35899a3c9695e$var$Gt(this, (i)=>{
            let a = i.findLast((h)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(h) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateMutedWordsPref(h).success);
            const c = {
                id: $aec35899a3c9695e$var$on.TID.nextStr(),
                value: r,
                targets: e.targets || [],
                actorTarget: e.actorTarget || "all",
                expiresAt: e.expiresAt || void 0
            };
            return a && $aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(a) ? (a.items.push(c), a.items = $aec35899a3c9695e$var$gc(a.items)) : a = {
                items: [
                    c
                ]
            }, i.filter((h)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(h)).concat([
                {
                    ...a,
                    $type: "app.bsky.actor.defs#mutedWordsPref"
                }
            ]);
        });
    }
    /**
   * Convenience method to add muted words to user preferences
   */ async addMutedWords(e) {
        await Promise.all(e.map((r)=>this.addMutedWord(r)));
    }
    /**
   * @deprecated use `addMutedWords` or `addMutedWord` instead
   */ async upsertMutedWords(e) {
        await this.addMutedWords(e);
    }
    /**
   * Update a muted word in user preferences.
   */ async updateMutedWord(e) {
        await $aec35899a3c9695e$var$Gt(this, (r)=>{
            const i = r.findLast((a)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateMutedWordsPref(a).success);
            return i && $aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(i) ? (i.items = i.items.map((a)=>{
                if ($aec35899a3c9695e$var$kf(a, e)) {
                    const h = {
                        ...a,
                        ...e
                    };
                    return {
                        id: a.id || $aec35899a3c9695e$var$on.TID.nextStr(),
                        value: (0, $aec35899a3c9695e$var$ln.sanitizeMutedWordValue)(h.value) || a.value,
                        targets: h.targets || [],
                        actorTarget: h.actorTarget || "all",
                        expiresAt: h.expiresAt || void 0
                    };
                } else return a;
            }), i.items = $aec35899a3c9695e$var$gc(i.items), r.filter((a)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(a)).concat([
                {
                    ...i,
                    $type: "app.bsky.actor.defs#mutedWordsPref"
                }
            ])) : r;
        });
    }
    /**
   * Remove a muted word from user preferences.
   */ async removeMutedWord(e) {
        await $aec35899a3c9695e$var$Gt(this, (r)=>{
            const i = r.findLast((a)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateMutedWordsPref(a).success);
            if (i && $aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(i)) {
                for(let a = 0; a < i.items.length; a++)if ($aec35899a3c9695e$var$kf(i.items[a], e)) {
                    i.items.splice(a, 1);
                    break;
                }
                return i.items = $aec35899a3c9695e$var$gc(i.items), r.filter((a)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isMutedWordsPref(a)).concat([
                    {
                        ...i,
                        $type: "app.bsky.actor.defs#mutedWordsPref"
                    }
                ]);
            }
            return r;
        });
    }
    /**
   * Convenience method to remove muted words from user preferences
   */ async removeMutedWords(e) {
        await Promise.all(e.map((r)=>this.removeMutedWord(r)));
    }
    async hidePost(e) {
        await $aec35899a3c9695e$var$Lf(this, e, "hide");
    }
    async unhidePost(e) {
        await $aec35899a3c9695e$var$Lf(this, e, "unhide");
    }
    async bskyAppQueueNudges(e) {
        await $aec35899a3c9695e$var$Gt(this, (r)=>{
            let i = r.findLast((a)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isBskyAppStatePref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateBskyAppStatePref(a).success);
            return i = i || {}, e = Array.isArray(e) ? e : [
                e
            ], i.queuedNudges = (i.queuedNudges || []).concat(e), r.filter((a)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isBskyAppStatePref(a)).concat([
                {
                    ...i,
                    $type: "app.bsky.actor.defs#bskyAppStatePref"
                }
            ]);
        });
    }
    async bskyAppDismissNudges(e) {
        await $aec35899a3c9695e$var$Gt(this, (r)=>{
            let i = r.findLast((a)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isBskyAppStatePref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateBskyAppStatePref(a).success);
            return i = i || {}, e = Array.isArray(e) ? e : [
                e
            ], i.queuedNudges = (i.queuedNudges || []).filter((a)=>!e.includes(a)), r.filter((a)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isBskyAppStatePref(a)).concat([
                {
                    ...i,
                    $type: "app.bsky.actor.defs#bskyAppStatePref"
                }
            ]);
        });
    }
    async bskyAppSetActiveProgressGuide(e) {
        if (e && !$aec35899a3c9695e$var$oe.AppBskyActorDefs.validateBskyAppProgressGuide(e).success) throw new Error("Invalid progress guide");
        await $aec35899a3c9695e$var$Gt(this, (r)=>{
            let i = r.findLast((a)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isBskyAppStatePref(a) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateBskyAppStatePref(a).success);
            return i = i || {}, i.activeProgressGuide = e, r.filter((a)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isBskyAppStatePref(a)).concat([
                {
                    ...i,
                    $type: "app.bsky.actor.defs#bskyAppStatePref"
                }
            ]);
        });
    }
}
$aec35899a3c9695e$var$Zu.BskyAgent = $aec35899a3c9695e$var$gs;
async function $aec35899a3c9695e$var$Gt(t, e) {
    try {
        await t._prefsLock.acquireAsync();
        const r = await t.app.bsky.actor.getPreferences({}), i = e(r.data.preferences);
        return i === !1 ? r.data.preferences : (await t.app.bsky.actor.putPreferences({
            preferences: i
        }), i);
    } finally{
        t._prefsLock.release();
    }
}
async function $aec35899a3c9695e$var$ra(t, e) {
    let r;
    return await $aec35899a3c9695e$var$Gt(t, (i)=>{
        let a = i.findLast((c)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isSavedFeedsPref(c) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateSavedFeedsPref(c).success);
        return a ? (r = e(a.saved, a.pinned), a.saved = r.saved, a.pinned = r.pinned) : (r = e([], []), a = {
            $type: "app.bsky.actor.defs#savedFeedsPref",
            saved: r.saved,
            pinned: r.pinned
        }), i.filter((c)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isSavedFeedsPref(c)).concat([
            a
        ]);
    }), r;
}
async function $aec35899a3c9695e$var$su(t, e) {
    let r = [];
    return await $aec35899a3c9695e$var$Gt(t, (i)=>{
        let a = i.findLast((y)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isSavedFeedsPrefV2(y) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateSavedFeedsPrefV2(y).success), c = i.findLast((y)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isSavedFeedsPref(y) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateSavedFeedsPref(y).success);
        a ? (r = e(a.items), a = {
            ...a,
            items: r
        }) : (r = e([]), a = {
            $type: "app.bsky.actor.defs#savedFeedsPrefV2",
            items: r
        });
        const h = a.items.filter((y)=>y.pinned), m = a.items.filter((y)=>!y.pinned);
        a.items = h.concat(m);
        let p = i.filter((y)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isSavedFeedsPrefV2(y)).concat(a);
        if (c) {
            const { saved: y, pinned: d } = c, v = (0, $aec35899a3c9695e$var$ln.savedFeedsToUriArrays)(// v1 only supports feeds and lists
            a.items.filter((P)=>[
                    "feed",
                    "list"
                ].includes(P.type)));
            c = {
                ...c,
                saved: Array.from(/* @__PURE__ */ new Set([
                    ...y,
                    ...v.saved
                ])),
                pinned: Array.from(/* @__PURE__ */ new Set([
                    ...d,
                    ...v.pinned
                ]))
            }, p = p.filter((P)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isSavedFeedsPref(P)).concat(c);
        }
        return p;
    }), r;
}
function $aec35899a3c9695e$var$fK(t) {
    let e = t.visibility;
    return e === "show" && (e = "ignore"), {
        ...t,
        visibility: e
    };
}
function $aec35899a3c9695e$var$pK(t) {
    const e = {
        ...t
    }, r = {
        gore: "graphic-media",
        nsfw: "porn",
        suggestive: "sexual"
    };
    for(const i in e){
        const a = r[i];
        a && (e[a] = e[i]);
    }
    return e;
}
function $aec35899a3c9695e$var$bc(t) {
    const e = t.findLast((i)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isLabelersPref(i) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateLabelersPref(i).success);
    let r = [];
    return e && (r = e.labelers.map((i)=>i.did)), r;
}
async function $aec35899a3c9695e$var$Lf(t, e, r) {
    await $aec35899a3c9695e$var$Gt(t, (i)=>{
        let a = i.findLast((c)=>$aec35899a3c9695e$var$oe.AppBskyActorDefs.isHiddenPostsPref(c) && $aec35899a3c9695e$var$oe.AppBskyActorDefs.validateHiddenPostsPref(c).success);
        return a && $aec35899a3c9695e$var$oe.AppBskyActorDefs.isHiddenPostsPref(a) ? a.items = r === "hide" ? Array.from(/* @__PURE__ */ new Set([
            ...a.items,
            e
        ])) : a.items.filter((c)=>c !== e) : r === "hide" && (a = {
            $type: "app.bsky.actor.defs#hiddenPostsPref",
            items: [
                e
            ]
        }), i.filter((c)=>!$aec35899a3c9695e$var$oe.AppBskyActorDefs.isInterestsPref(c)).concat([
            {
                ...a,
                $type: "app.bsky.actor.defs#hiddenPostsPref"
            }
        ]);
    });
}
function $aec35899a3c9695e$var$hK(t) {
    return t && typeof t == "object" && "moderationPrefs" in t && $aec35899a3c9695e$var$zm(t.moderationPrefs);
}
function $aec35899a3c9695e$var$zm(t) {
    return t && typeof t == "object" && "labelers" in t;
}
function $aec35899a3c9695e$var$gc(t) {
    return t.map((e)=>({
            ...e,
            id: e.id || $aec35899a3c9695e$var$on.TID.nextStr()
        }));
}
function $aec35899a3c9695e$var$kf(t, e) {
    const r = t.id, i = r && r === e.id, a = !r && t.value === e.value;
    return i || a;
}
(function(t) {
    var e = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__createBinding || (Object.create ? function(y, d, v, P) {
        P === void 0 && (P = v);
        var K = Object.getOwnPropertyDescriptor(d, v);
        (!K || ("get" in K ? !d.__esModule : K.writable || K.configurable)) && (K = {
            enumerable: !0,
            get: function() {
                return d[v];
            }
        }), Object.defineProperty(y, P, K);
    } : function(y, d, v, P) {
        P === void 0 && (P = v), y[P] = d[v];
    }), r = $aec35899a3c9695e$var$se && $aec35899a3c9695e$var$se.__exportStar || function(y, d) {
        for(var v in y)v !== "default" && !Object.prototype.hasOwnProperty.call(d, v) && e(d, y, v);
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = t.BskyAgent = t.DEFAULT_LABEL_SETTINGS = t.LABELS = t.parseLanguage = t.jsonStringToLex = t.jsonToLex = t.stringifyLex = t.lexToJson = t.BlobRef = t.AtUri = void 0;
    var i = $aec35899a3c9695e$var$as;
    Object.defineProperty(t, "AtUri", {
        enumerable: !0,
        get: function() {
            return i.AtUri;
        }
    });
    var a = $aec35899a3c9695e$var$wa;
    Object.defineProperty(t, "BlobRef", {
        enumerable: !0,
        get: function() {
            return a.BlobRef;
        }
    }), Object.defineProperty(t, "lexToJson", {
        enumerable: !0,
        get: function() {
            return a.lexToJson;
        }
    }), Object.defineProperty(t, "stringifyLex", {
        enumerable: !0,
        get: function() {
            return a.stringifyLex;
        }
    }), Object.defineProperty(t, "jsonToLex", {
        enumerable: !0,
        get: function() {
            return a.jsonToLex;
        }
    }), Object.defineProperty(t, "jsonStringToLex", {
        enumerable: !0,
        get: function() {
            return a.jsonStringToLex;
        }
    });
    var c = $aec35899a3c9695e$var$vi;
    Object.defineProperty(t, "parseLanguage", {
        enumerable: !0,
        get: function() {
            return c.parseLanguage;
        }
    }), r($aec35899a3c9695e$var$Fp, t), r($aec35899a3c9695e$var$ka, t), r($aec35899a3c9695e$var$Nr, t), r($aec35899a3c9695e$var$x, t), r($aec35899a3c9695e$var$js, t), r($aec35899a3c9695e$var$Fs, t), r($aec35899a3c9695e$var$jl, t), r($aec35899a3c9695e$var$Hs, t), r($aec35899a3c9695e$var$$r, t), r($aec35899a3c9695e$var$nd, t), r($aec35899a3c9695e$var$ur, t), r($aec35899a3c9695e$var$Hu, t);
    var h = $aec35899a3c9695e$var$En;
    Object.defineProperty(t, "LABELS", {
        enumerable: !0,
        get: function() {
            return h.LABELS;
        }
    }), Object.defineProperty(t, "DEFAULT_LABEL_SETTINGS", {
        enumerable: !0,
        get: function() {
            return h.DEFAULT_LABEL_SETTINGS;
        }
    });
    var m = $aec35899a3c9695e$var$Zu;
    Object.defineProperty(t, "BskyAgent", {
        enumerable: !0,
        get: function() {
            return m.BskyAgent;
        }
    });
    var p = $aec35899a3c9695e$var$js;
    Object.defineProperty(t, "default", {
        enumerable: !0,
        get: function() {
            return p.AtpAgent;
        }
    });
})($aec35899a3c9695e$var$Bc);
const $aec35899a3c9695e$var$xc = new $aec35899a3c9695e$var$Bc.BskyAgent({
    service: "https://api.bsky.app"
});
var $aec35899a3c9695e$var$Xm = {
    exports: {}
};
(function(t, e) {
    (function(i, a) {
        t.exports = a();
    })($aec35899a3c9695e$var$se, function() {
        return /******/ function(r) {
            var i = {};
            function a(c) {
                if (i[c]) return i[c].exports;
                var h = i[c] = {
                    /******/ i: c,
                    /******/ l: !1,
                    /******/ exports: {}
                };
                return r[c].call(h.exports, h, h.exports, a), h.l = !0, h.exports;
            }
            return a.m = r, a.c = i, a.d = function(c, h, m) {
                a.o(c, h) || Object.defineProperty(c, h, {
                    /******/ configurable: !1,
                    /******/ enumerable: !0,
                    /******/ get: m
                });
            }, a.n = function(c) {
                var h = c && c.__esModule ? /******/ function() {
                    return c.default;
                } : /******/ function() {
                    return c;
                };
                return a.d(h, "a", h), h;
            }, a.o = function(c, h) {
                return Object.prototype.hasOwnProperty.call(c, h);
            }, a.p = "/dist/", a(a.s = 8);
        }([
            /* 0 */ /***/ function(r, i, a) {
                a.d(i, "a", function() {
                    return P;
                }), a.d(i, "b", function() {
                    return K;
                });
                var c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
                    return typeof O;
                } : function(O) {
                    return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
                };
                function h() {}
                var m = {
                    trace: h,
                    debug: h,
                    log: h,
                    warn: h,
                    info: h,
                    error: h
                }, p = m;
                function y(O, Z) {
                    return Z = "[" + O + "] > " + Z, Z;
                }
                function d(O) {
                    var Z = self.console[O];
                    return Z ? function() {
                        for(var Y = arguments.length, X = Array(Y), V = 0; V < Y; V++)X[V] = arguments[V];
                        X[0] && (X[0] = y(O, X[0])), Z.apply(self.console, X);
                    } : h;
                }
                function v(O) {
                    for(var Z = arguments.length, Y = Array(Z > 1 ? Z - 1 : 0), X = 1; X < Z; X++)Y[X - 1] = arguments[X];
                    Y.forEach(function(V) {
                        p[V] = O[V] ? O[V].bind(O) : d(V);
                    });
                }
                var P = function(Z) {
                    if (Z === !0 || (typeof Z > "u" ? "undefined" : c(Z)) === "object") {
                        v(Z, // Remove out from list here to hard-disable a log-level
                        //'trace',
                        "debug", "log", "info", "warn", "error");
                        try {
                            p.log();
                        } catch  {
                            p = m;
                        }
                    } else p = m;
                }, K = p;
            },
            /* 1 */ /***/ function(r, i, a) {
                i.a = {
                    // fired before MediaSource is attaching to media element - data: { media }
                    MEDIA_ATTACHING: "hlsMediaAttaching",
                    // fired when MediaSource has been succesfully attached to media element - data: { }
                    MEDIA_ATTACHED: "hlsMediaAttached",
                    // fired before detaching MediaSource from media element - data: { }
                    MEDIA_DETACHING: "hlsMediaDetaching",
                    // fired when MediaSource has been detached from media element - data: { }
                    MEDIA_DETACHED: "hlsMediaDetached",
                    // fired when we buffer is going to be reset - data: { }
                    BUFFER_RESET: "hlsBufferReset",
                    // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
                    BUFFER_CODECS: "hlsBufferCodecs",
                    // fired when sourcebuffers have been created - data: { tracks : tracks }
                    BUFFER_CREATED: "hlsBufferCreated",
                    // fired when we append a segment to the buffer - data: { segment: segment object }
                    BUFFER_APPENDING: "hlsBufferAppending",
                    // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
                    BUFFER_APPENDED: "hlsBufferAppended",
                    // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
                    BUFFER_EOS: "hlsBufferEos",
                    // fired when the media buffer should be flushed - data { startOffset, endOffset }
                    BUFFER_FLUSHING: "hlsBufferFlushing",
                    // fired when the media buffer has been flushed - data: { }
                    BUFFER_FLUSHED: "hlsBufferFlushed",
                    // fired to signal that a manifest loading starts - data: { url : manifestURL}
                    MANIFEST_LOADING: "hlsManifestLoading",
                    // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
                    MANIFEST_LOADED: "hlsManifestLoaded",
                    // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
                    MANIFEST_PARSED: "hlsManifestParsed",
                    // fired when a level switch is requested - data: { level : id of new level } // deprecated in favor LEVEL_SWITCHING
                    LEVEL_SWITCH: "hlsLevelSwitch",
                    // fired when a level switch is requested - data: { level : id of new level }
                    LEVEL_SWITCHING: "hlsLevelSwitching",
                    // fired when a level switch is effective - data: { level : id of new level }
                    LEVEL_SWITCHED: "hlsLevelSwitched",
                    // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
                    LEVEL_LOADING: "hlsLevelLoading",
                    // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : { trequest, tfirst, tload, mtime} }
                    LEVEL_LOADED: "hlsLevelLoaded",
                    // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
                    LEVEL_UPDATED: "hlsLevelUpdated",
                    // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
                    LEVEL_PTS_UPDATED: "hlsLevelPtsUpdated",
                    // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
                    AUDIO_TRACKS_UPDATED: "hlsAudioTracksUpdated",
                    // fired when an audio track switch occurs - data: { id : audio track id } // deprecated in favor AUDIO_TRACK_SWITCHING
                    AUDIO_TRACK_SWITCH: "hlsAudioTrackSwitch",
                    // fired when an audio track switching is requested - data: { id : audio track id }
                    AUDIO_TRACK_SWITCHING: "hlsAudioTrackSwitching",
                    // fired when an audio track switch actually occurs - data: { id : audio track id }
                    AUDIO_TRACK_SWITCHED: "hlsAudioTrackSwitched",
                    // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
                    AUDIO_TRACK_LOADING: "hlsAudioTrackLoading",
                    // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : { trequest, tfirst, tload, mtime } }
                    AUDIO_TRACK_LOADED: "hlsAudioTrackLoaded",
                    // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
                    SUBTITLE_TRACKS_UPDATED: "hlsSubtitleTracksUpdated",
                    // fired when an subtitle track switch occurs - data: { id : subtitle track id }
                    SUBTITLE_TRACK_SWITCH: "hlsSubtitleTrackSwitch",
                    // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
                    SUBTITLE_TRACK_LOADING: "hlsSubtitleTrackLoading",
                    // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : { trequest, tfirst, tload, mtime } }
                    SUBTITLE_TRACK_LOADED: "hlsSubtitleTrackLoaded",
                    // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
                    SUBTITLE_FRAG_PROCESSED: "hlsSubtitleFragProcessed",
                    // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, frag : fragment object }
                    INIT_PTS_FOUND: "hlsInitPtsFound",
                    // fired when a fragment loading starts - data: { frag : fragment object }
                    FRAG_LOADING: "hlsFragLoading",
                    // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
                    FRAG_LOAD_PROGRESS: "hlsFragLoadProgress",
                    // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
                    FRAG_LOAD_EMERGENCY_ABORTED: "hlsFragLoadEmergencyAborted",
                    // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : { trequest, tfirst, tload, length } }
                    FRAG_LOADED: "hlsFragLoaded",
                    // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
                    FRAG_DECRYPTED: "hlsFragDecrypted",
                    // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
                    FRAG_PARSING_INIT_SEGMENT: "hlsFragParsingInitSegment",
                    // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
                    FRAG_PARSING_USERDATA: "hlsFragParsingUserdata",
                    // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
                    FRAG_PARSING_METADATA: "hlsFragParsingMetadata",
                    // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
                    FRAG_PARSING_DATA: "hlsFragParsingData",
                    // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
                    FRAG_PARSED: "hlsFragParsed",
                    // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : { trequest, tfirst, tload, tparsed, tbuffered, length, bwEstimate } }
                    FRAG_BUFFERED: "hlsFragBuffered",
                    // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
                    FRAG_CHANGED: "hlsFragChanged",
                    // Identifier for a FPS drop event - data: { curentDropped, currentDecoded, totalDroppedFrames }
                    FPS_DROP: "hlsFpsDrop",
                    //triggered when FPS drop triggers auto level capping - data: { level, droppedlevel }
                    FPS_DROP_LEVEL_CAPPING: "hlsFpsDropLevelCapping",
                    // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
                    ERROR: "hlsError",
                    // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
                    DESTROYING: "hlsDestroying",
                    // fired when a decrypt key loading starts - data: { frag : fragment object }
                    KEY_LOADING: "hlsKeyLoading",
                    // fired when a decrypt key loading is completed - data: { frag : fragment object, payload : key payload, stats : { trequest, tfirst, tload, length } }
                    KEY_LOADED: "hlsKeyLoaded",
                    // fired upon stream controller state transitions - data: { previousState, nextState }
                    STREAM_STATE_TRANSITION: "hlsStreamStateTransition"
                };
            },
            /* 2 */ /***/ function(r, i, a) {
                a.d(i, "b", function() {
                    return c;
                }), a.d(i, "a", function() {
                    return h;
                });
                var c = {
                    // Identifier for a network error (loading error / timeout ...)
                    NETWORK_ERROR: "networkError",
                    // Identifier for a media Error (video/parsing/mediasource error)
                    MEDIA_ERROR: "mediaError",
                    // Identifier for a mux Error (demuxing/remuxing)
                    MUX_ERROR: "muxError",
                    // Identifier for all other errors
                    OTHER_ERROR: "otherError"
                }, h = {
                    // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
                    MANIFEST_LOAD_ERROR: "manifestLoadError",
                    // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
                    MANIFEST_LOAD_TIMEOUT: "manifestLoadTimeOut",
                    // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
                    MANIFEST_PARSING_ERROR: "manifestParsingError",
                    // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
                    MANIFEST_INCOMPATIBLE_CODECS_ERROR: "manifestIncompatibleCodecsError",
                    // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
                    LEVEL_LOAD_ERROR: "levelLoadError",
                    // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
                    LEVEL_LOAD_TIMEOUT: "levelLoadTimeOut",
                    // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
                    LEVEL_SWITCH_ERROR: "levelSwitchError",
                    // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
                    AUDIO_TRACK_LOAD_ERROR: "audioTrackLoadError",
                    // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
                    AUDIO_TRACK_LOAD_TIMEOUT: "audioTrackLoadTimeOut",
                    // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
                    FRAG_LOAD_ERROR: "fragLoadError",
                    // Identifier for fragment loop loading error - data: { frag : fragment object}
                    FRAG_LOOP_LOADING_ERROR: "fragLoopLoadingError",
                    // Identifier for fragment load timeout error - data: { frag : fragment object}
                    FRAG_LOAD_TIMEOUT: "fragLoadTimeOut",
                    // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
                    FRAG_DECRYPT_ERROR: "fragDecryptError",
                    // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
                    // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
                    FRAG_PARSING_ERROR: "fragParsingError",
                    // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
                    REMUX_ALLOC_ERROR: "remuxAllocError",
                    // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
                    KEY_LOAD_ERROR: "keyLoadError",
                    // Identifier for decrypt key load timeout error - data: { frag : fragment object}
                    KEY_LOAD_TIMEOUT: "keyLoadTimeOut",
                    // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : {  err : exception , mimeType : mimeType }
                    BUFFER_ADD_CODEC_ERROR: "bufferAddCodecError",
                    // Identifier for a buffer append error - data: append error description
                    BUFFER_APPEND_ERROR: "bufferAppendError",
                    // Identifier for a buffer appending error event - data: appending error description
                    BUFFER_APPENDING_ERROR: "bufferAppendingError",
                    // Identifier for a buffer stalled error event
                    BUFFER_STALLED_ERROR: "bufferStalledError",
                    // Identifier for a buffer full event
                    BUFFER_FULL_ERROR: "bufferFullError",
                    // Identifier for a buffer seek over hole event
                    BUFFER_SEEK_OVER_HOLE: "bufferSeekOverHole",
                    // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
                    BUFFER_NUDGE_ON_STALL: "bufferNudgeOnStall",
                    // Identifier for an internal exception happening inside hls.js while handling an event
                    INTERNAL_EXCEPTION: "internalException"
                };
            },
            /* 3 */ /***/ function(r, i, a) {
                a.d(i, "b", function() {
                    return m;
                });
                function c(p, y) {
                    if (!(p instanceof y)) throw new TypeError("Cannot call a class as a function");
                }
                var h = function() {
                    function p() {
                        c(this, p);
                    }
                    return p.isHeader = function(d, v) {
                        return v + 10 <= d.length && d[v] === 73 && d[v + 1] === 68 && d[v + 2] === 51 && d[v + 3] < 255 && d[v + 4] < 255 && d[v + 6] < 128 && d[v + 7] < 128 && d[v + 8] < 128 && d[v + 9] < 128;
                    }, p.isFooter = function(d, v) {
                        return v + 10 <= d.length && d[v] === 51 && d[v + 1] === 68 && d[v + 2] === 73 && d[v + 3] < 255 && d[v + 4] < 255 && d[v + 6] < 128 && d[v + 7] < 128 && d[v + 8] < 128 && d[v + 9] < 128;
                    }, p.getID3Data = function(d, v) {
                        for(var P = v, K = 0; p.isHeader(d, v);){
                            K += 10;
                            var O = p._readSize(d, v + 6);
                            K += O, p.isFooter(d, v + 10) && (K += 10), v += K;
                        }
                        if (K > 0) return d.subarray(P, P + K);
                    }, p._readSize = function(d, v) {
                        var P = 0;
                        return P = (d[v] & 127) << 21, P |= (d[v + 1] & 127) << 14, P |= (d[v + 2] & 127) << 7, P |= d[v + 3] & 127, P;
                    }, p.getTimeStamp = function(d) {
                        for(var v = p.getID3Frames(d), P = 0; P < v.length; P++){
                            var K = v[P];
                            if (p.isTimeStampFrame(K)) return p._readTimeStamp(K);
                        }
                    }, p.isTimeStampFrame = function(d) {
                        return d && d.key === "PRIV" && d.info === "com.apple.streaming.transportStreamTimestamp";
                    }, p._getFrameData = function(d) {
                        var v = String.fromCharCode(d[0], d[1], d[2], d[3]), P = p._readSize(d, 4), K = 10;
                        return {
                            type: v,
                            size: P,
                            data: d.subarray(K, K + P)
                        };
                    }, p.getID3Frames = function(d) {
                        for(var v = 0, P = []; p.isHeader(d, v);){
                            var K = p._readSize(d, v + 6);
                            v += 10;
                            for(var O = v + K; v + 8 < O;){
                                var Z = p._getFrameData(d.subarray(v)), Y = p._decodeFrame(Z);
                                Y && P.push(Y), v += Z.size + 10;
                            }
                            p.isFooter(d, v) && (v += 10);
                        }
                        return P;
                    }, p._decodeFrame = function(d) {
                        if (d.type === "PRIV") return p._decodePrivFrame(d);
                        if (d.type[0] === "T") return p._decodeTextFrame(d);
                        if (d.type[0] === "W") return p._decodeURLFrame(d);
                    }, p._readTimeStamp = function(d) {
                        if (d.data.byteLength === 8) {
                            var v = new Uint8Array(d.data), P = v[3] & 1, K = (v[4] << 23) + (v[5] << 15) + (v[6] << 7) + v[7];
                            return K /= 45, P && (K += 4772185884e-2), Math.round(K);
                        }
                    }, p._decodePrivFrame = function(d) {
                        if (!(d.size < 2)) {
                            var v = p._utf8ArrayToStr(d.data, !0), P = new Uint8Array(d.data.subarray(v.length + 1));
                            return {
                                key: d.type,
                                info: v,
                                data: P.buffer
                            };
                        }
                    }, p._decodeTextFrame = function(d) {
                        if (!(d.size < 2)) {
                            if (d.type === "TXXX") {
                                var v = 1, P = p._utf8ArrayToStr(d.data.subarray(v));
                                v += P.length + 1;
                                var K = p._utf8ArrayToStr(d.data.subarray(v));
                                return {
                                    key: d.type,
                                    info: P,
                                    data: K
                                };
                            } else {
                                var O = p._utf8ArrayToStr(d.data.subarray(1));
                                return {
                                    key: d.type,
                                    data: O
                                };
                            }
                        }
                    }, p._decodeURLFrame = function(d) {
                        if (d.type === "WXXX") {
                            if (d.size < 2) return;
                            var v = 1, P = p._utf8ArrayToStr(d.data.subarray(v));
                            v += P.length + 1;
                            var K = p._utf8ArrayToStr(d.data.subarray(v));
                            return {
                                key: d.type,
                                info: P,
                                data: K
                            };
                        } else {
                            var O = p._utf8ArrayToStr(d.data);
                            return {
                                key: d.type,
                                data: O
                            };
                        }
                    }, p._utf8ArrayToStr = function(d) {
                        for(var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, P = d.length, K = void 0, O = void 0, Z = void 0, Y = "", X = 0; X < P;){
                            if (K = d[X++], K === 0 && v) return Y;
                            if (K === 0 || K === 3) continue;
                            switch(K >> 4){
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                    Y += String.fromCharCode(K);
                                    break;
                                case 12:
                                case 13:
                                    O = d[X++], Y += String.fromCharCode((K & 31) << 6 | O & 63);
                                    break;
                                case 14:
                                    O = d[X++], Z = d[X++], Y += String.fromCharCode((K & 15) << 12 | (O & 63) << 6 | (Z & 63) << 0);
                                    break;
                            }
                        }
                        return Y;
                    }, p;
                }(), m = h._utf8ArrayToStr;
                i.a = h;
            },
            /* 4 */ /***/ function(r, i, a) {
                function c(V, q) {
                    if (!(V instanceof q)) throw new TypeError("Cannot call a class as a function");
                }
                var h = function() {
                    function V(q, re) {
                        c(this, V), this.subtle = q, this.aesIV = re;
                    }
                    return V.prototype.decrypt = function(re, ne) {
                        return this.subtle.decrypt({
                            name: "AES-CBC",
                            iv: this.aesIV
                        }, ne, re);
                    }, V;
                }(), m = h;
                function p(V, q) {
                    if (!(V instanceof q)) throw new TypeError("Cannot call a class as a function");
                }
                var y = function() {
                    function V(q, re) {
                        p(this, V), this.subtle = q, this.key = re;
                    }
                    return V.prototype.expandKey = function() {
                        return this.subtle.importKey("raw", this.key, {
                            name: "AES-CBC"
                        }, !1, [
                            "encrypt",
                            "decrypt"
                        ]);
                    }, V;
                }(), d = y;
                function v(V, q) {
                    if (!(V instanceof q)) throw new TypeError("Cannot call a class as a function");
                }
                var P = function() {
                    function V() {
                        v(this, V), this.rcon = [
                            0,
                            1,
                            2,
                            4,
                            8,
                            16,
                            32,
                            64,
                            128,
                            27,
                            54
                        ], this.subMix = [
                            new Uint32Array(256),
                            new Uint32Array(256),
                            new Uint32Array(256),
                            new Uint32Array(256)
                        ], this.invSubMix = [
                            new Uint32Array(256),
                            new Uint32Array(256),
                            new Uint32Array(256),
                            new Uint32Array(256)
                        ], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.initTable();
                    }
                    return V.prototype.uint8ArrayToUint32Array_ = function(re) {
                        for(var ne = new DataView(re), fe = new Uint32Array(4), ye = 0; ye < 4; ye++)fe[ye] = ne.getUint32(ye * 4);
                        return fe;
                    }, V.prototype.initTable = function() {
                        var re = this.sBox, ne = this.invSBox, fe = this.subMix, ye = fe[0], xe = fe[1], De = fe[2], Be = fe[3], Oe = this.invSubMix, we = Oe[0], Fe = Oe[1], Xe = Oe[2], ct = Oe[3], Ge = new Uint32Array(256), tt = 0, Rt = 0, dt = 0;
                        for(dt = 0; dt < 256; dt++)dt < 128 ? Ge[dt] = dt << 1 : Ge[dt] = dt << 1 ^ 283;
                        for(dt = 0; dt < 256; dt++){
                            var ft = Rt ^ Rt << 1 ^ Rt << 2 ^ Rt << 3 ^ Rt << 4;
                            ft = ft >>> 8 ^ ft & 255 ^ 99, re[tt] = ft, ne[ft] = tt;
                            var Bt = Ge[tt], He = Ge[Bt], Pr = Ge[He], pt = Ge[ft] * 257 ^ ft * 16843008;
                            ye[tt] = pt << 24 | pt >>> 8, xe[tt] = pt << 16 | pt >>> 16, De[tt] = pt << 8 | pt >>> 24, Be[tt] = pt, pt = Pr * 16843009 ^ He * 65537 ^ Bt * 257 ^ tt * 16843008, we[ft] = pt << 24 | pt >>> 8, Fe[ft] = pt << 16 | pt >>> 16, Xe[ft] = pt << 8 | pt >>> 24, ct[ft] = pt, tt ? (tt = Bt ^ Ge[Ge[Ge[Pr ^ Bt]]], Rt ^= Ge[Ge[Rt]]) : tt = Rt = 1;
                        }
                    }, V.prototype.expandKey = function(re) {
                        for(var ne = this.uint8ArrayToUint32Array_(re), fe = !0, ye = 0; ye < ne.length && fe;)fe = ne[ye] === this.key[ye], ye++;
                        if (!fe) {
                            this.key = ne;
                            var xe = this.keySize = ne.length;
                            if (xe !== 4 && xe !== 6 && xe !== 8) throw new Error("Invalid aes key size=" + xe);
                            var De = this.ksRows = (xe + 6 + 1) * 4, Be = void 0, Oe = void 0, we = this.keySchedule = new Uint32Array(De), Fe = this.invKeySchedule = new Uint32Array(De), Xe = this.sBox, ct = this.rcon, Ge = this.invSubMix, tt = Ge[0], Rt = Ge[1], dt = Ge[2], ft = Ge[3], Bt = void 0, He = void 0;
                            for(Be = 0; Be < De; Be++){
                                if (Be < xe) {
                                    Bt = we[Be] = ne[Be];
                                    continue;
                                }
                                He = Bt, Be % xe === 0 ? (He = He << 8 | He >>> 24, He = Xe[He >>> 24] << 24 | Xe[He >>> 16 & 255] << 16 | Xe[He >>> 8 & 255] << 8 | Xe[He & 255], He ^= ct[Be / xe | 0] << 24) : xe > 6 && Be % xe === 4 && (He = Xe[He >>> 24] << 24 | Xe[He >>> 16 & 255] << 16 | Xe[He >>> 8 & 255] << 8 | Xe[He & 255]), we[Be] = Bt = (we[Be - xe] ^ He) >>> 0;
                            }
                            for(Oe = 0; Oe < De; Oe++)Be = De - Oe, Oe & 3 ? He = we[Be] : He = we[Be - 4], Oe < 4 || Be <= 4 ? Fe[Oe] = He : Fe[Oe] = tt[Xe[He >>> 24]] ^ Rt[Xe[He >>> 16 & 255]] ^ dt[Xe[He >>> 8 & 255]] ^ ft[Xe[He & 255]], Fe[Oe] = Fe[Oe] >>> 0;
                        }
                    }, V.prototype.networkToHostOrderSwap = function(re) {
                        return re << 24 | (re & 65280) << 8 | (re & 16711680) >> 8 | re >>> 24;
                    }, V.prototype.decrypt = function(re, ne, fe) {
                        for(var ye = this.keySize + 6, xe = this.invKeySchedule, De = this.invSBox, Be = this.invSubMix, Oe = Be[0], we = Be[1], Fe = Be[2], Xe = Be[3], ct = this.uint8ArrayToUint32Array_(fe), Ge = ct[0], tt = ct[1], Rt = ct[2], dt = ct[3], ft = new Int32Array(re), Bt = new Int32Array(ft.length), He = void 0, Pr = void 0, pt = void 0, tn = void 0, dr = void 0, fr = void 0, Ft = void 0, pr = void 0, hr = void 0, Br = void 0, kr = void 0, ht = void 0, Ct, Sn, rr = this.networkToHostOrderSwap; ne < ft.length;){
                            for(hr = rr(ft[ne]), Br = rr(ft[ne + 1]), kr = rr(ft[ne + 2]), ht = rr(ft[ne + 3]), dr = hr ^ xe[0], fr = ht ^ xe[1], Ft = kr ^ xe[2], pr = Br ^ xe[3], Ct = 4, Sn = 1; Sn < ye; Sn++)He = Oe[dr >>> 24] ^ we[fr >> 16 & 255] ^ Fe[Ft >> 8 & 255] ^ Xe[pr & 255] ^ xe[Ct], Pr = Oe[fr >>> 24] ^ we[Ft >> 16 & 255] ^ Fe[pr >> 8 & 255] ^ Xe[dr & 255] ^ xe[Ct + 1], pt = Oe[Ft >>> 24] ^ we[pr >> 16 & 255] ^ Fe[dr >> 8 & 255] ^ Xe[fr & 255] ^ xe[Ct + 2], tn = Oe[pr >>> 24] ^ we[dr >> 16 & 255] ^ Fe[fr >> 8 & 255] ^ Xe[Ft & 255] ^ xe[Ct + 3], dr = He, fr = Pr, Ft = pt, pr = tn, Ct = Ct + 4;
                            He = De[dr >>> 24] << 24 ^ De[fr >> 16 & 255] << 16 ^ De[Ft >> 8 & 255] << 8 ^ De[pr & 255] ^ xe[Ct], Pr = De[fr >>> 24] << 24 ^ De[Ft >> 16 & 255] << 16 ^ De[pr >> 8 & 255] << 8 ^ De[dr & 255] ^ xe[Ct + 1], pt = De[Ft >>> 24] << 24 ^ De[pr >> 16 & 255] << 16 ^ De[dr >> 8 & 255] << 8 ^ De[fr & 255] ^ xe[Ct + 2], tn = De[pr >>> 24] << 24 ^ De[dr >> 16 & 255] << 16 ^ De[fr >> 8 & 255] << 8 ^ De[Ft & 255] ^ xe[Ct + 3], Ct = Ct + 3, Bt[ne] = rr(He ^ Ge), Bt[ne + 1] = rr(tn ^ tt), Bt[ne + 2] = rr(pt ^ Rt), Bt[ne + 3] = rr(Pr ^ dt), Ge = hr, tt = Br, Rt = kr, dt = ht, ne = ne + 4;
                        }
                        return Bt.buffer;
                    }, V.prototype.destroy = function() {
                        this.key = void 0, this.keySize = void 0, this.ksRows = void 0, this.sBox = void 0, this.invSBox = void 0, this.subMix = void 0, this.invSubMix = void 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.rcon = void 0;
                    }, V;
                }(), K = P, O = a(2), Z = a(0);
                function Y(V, q) {
                    if (!(V instanceof q)) throw new TypeError("Cannot call a class as a function");
                }
                var X = function() {
                    function V(q, re) {
                        Y(this, V), this.observer = q, this.config = re, this.logEnabled = !0;
                        try {
                            var ne = crypto || self.crypto;
                            this.subtle = ne.subtle || ne.webkitSubtle;
                        } catch  {}
                        this.disableWebCrypto = !this.subtle;
                    }
                    return V.prototype.isSync = function() {
                        return this.disableWebCrypto && this.config.enableSoftwareAES;
                    }, V.prototype.decrypt = function(re, ne, fe, ye) {
                        var xe = this;
                        if (this.disableWebCrypto && this.config.enableSoftwareAES) {
                            this.logEnabled && (Z.b.log("JS AES decrypt"), this.logEnabled = !1);
                            var De = this.decryptor;
                            De || (this.decryptor = De = new K()), De.expandKey(ne), ye(De.decrypt(re, 0, fe));
                        } else {
                            this.logEnabled && (Z.b.log("WebCrypto AES decrypt"), this.logEnabled = !1);
                            var Be = this.subtle;
                            this.key !== ne && (this.key = ne, this.fastAesKey = new d(Be, ne)), this.fastAesKey.expandKey().then(function(Oe) {
                                var we = new m(Be, fe);
                                we.decrypt(re, Oe).catch(function(Fe) {
                                    xe.onWebCryptoError(Fe, re, ne, fe, ye);
                                }).then(function(Fe) {
                                    ye(Fe);
                                });
                            }).catch(function(Oe) {
                                xe.onWebCryptoError(Oe, re, ne, fe, ye);
                            });
                        }
                    }, V.prototype.onWebCryptoError = function(re, ne, fe, ye, xe) {
                        this.config.enableSoftwareAES ? (Z.b.log("WebCrypto Error, disable WebCrypto API"), this.disableWebCrypto = !0, this.logEnabled = !0, this.decrypt(ne, fe, ye, xe)) : (Z.b.error("decrypting error : " + re.message), this.observer.trigger(Event.ERROR, {
                            type: O.b.MEDIA_ERROR,
                            details: O.a.FRAG_DECRYPT_ERROR,
                            fatal: !0,
                            reason: re.message
                        }));
                    }, V.prototype.destroy = function() {
                        var re = this.decryptor;
                        re && (re.destroy(), this.decryptor = void 0);
                    }, V;
                }();
                i.a = X;
            },
            /* 5 */ /***/ function(r, i) {
                function a() {
                    this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
                }
                r.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._maxListeners = void 0, a.defaultMaxListeners = 10, a.prototype.setMaxListeners = function(y) {
                    if (!h(y) || y < 0 || isNaN(y)) throw TypeError("n must be a positive number");
                    return this._maxListeners = y, this;
                }, a.prototype.emit = function(y) {
                    var d, v, P, K, O, Z;
                    if (this._events || (this._events = {}), y === "error" && (!this._events.error || m(this._events.error) && !this._events.error.length)) {
                        if (d = arguments[1], d instanceof Error) throw d;
                        var Y = new Error('Uncaught, unspecified "error" event. (' + d + ")");
                        throw Y.context = d, Y;
                    }
                    if (v = this._events[y], p(v)) return !1;
                    if (c(v)) switch(arguments.length){
                        case 1:
                            v.call(this);
                            break;
                        case 2:
                            v.call(this, arguments[1]);
                            break;
                        case 3:
                            v.call(this, arguments[1], arguments[2]);
                            break;
                        default:
                            K = Array.prototype.slice.call(arguments, 1), v.apply(this, K);
                    }
                    else if (m(v)) for(K = Array.prototype.slice.call(arguments, 1), Z = v.slice(), P = Z.length, O = 0; O < P; O++)Z[O].apply(this, K);
                    return !0;
                }, a.prototype.addListener = function(y, d) {
                    var v;
                    if (!c(d)) throw TypeError("listener must be a function");
                    return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", y, c(d.listener) ? d.listener : d), this._events[y] ? m(this._events[y]) ? this._events[y].push(d) : this._events[y] = [
                        this._events[y],
                        d
                    ] : this._events[y] = d, m(this._events[y]) && !this._events[y].warned && (p(this._maxListeners) ? v = a.defaultMaxListeners : v = this._maxListeners, v && v > 0 && this._events[y].length > v && (this._events[y].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[y].length), typeof console.trace == "function" && console.trace())), this;
                }, a.prototype.on = a.prototype.addListener, a.prototype.once = function(y, d) {
                    if (!c(d)) throw TypeError("listener must be a function");
                    var v = !1;
                    function P() {
                        this.removeListener(y, P), v || (v = !0, d.apply(this, arguments));
                    }
                    return P.listener = d, this.on(y, P), this;
                }, a.prototype.removeListener = function(y, d) {
                    var v, P, K, O;
                    if (!c(d)) throw TypeError("listener must be a function");
                    if (!this._events || !this._events[y]) return this;
                    if (v = this._events[y], K = v.length, P = -1, v === d || c(v.listener) && v.listener === d) delete this._events[y], this._events.removeListener && this.emit("removeListener", y, d);
                    else if (m(v)) {
                        for(O = K; O-- > 0;)if (v[O] === d || v[O].listener && v[O].listener === d) {
                            P = O;
                            break;
                        }
                        if (P < 0) return this;
                        v.length === 1 ? (v.length = 0, delete this._events[y]) : v.splice(P, 1), this._events.removeListener && this.emit("removeListener", y, d);
                    }
                    return this;
                }, a.prototype.removeAllListeners = function(y) {
                    var d, v;
                    if (!this._events) return this;
                    if (!this._events.removeListener) return arguments.length === 0 ? this._events = {} : this._events[y] && delete this._events[y], this;
                    if (arguments.length === 0) {
                        for(d in this._events)d !== "removeListener" && this.removeAllListeners(d);
                        return this.removeAllListeners("removeListener"), this._events = {}, this;
                    }
                    if (v = this._events[y], c(v)) this.removeListener(y, v);
                    else if (v) for(; v.length;)this.removeListener(y, v[v.length - 1]);
                    return delete this._events[y], this;
                }, a.prototype.listeners = function(y) {
                    var d;
                    return !this._events || !this._events[y] ? d = [] : c(this._events[y]) ? d = [
                        this._events[y]
                    ] : d = this._events[y].slice(), d;
                }, a.prototype.listenerCount = function(y) {
                    if (this._events) {
                        var d = this._events[y];
                        if (c(d)) return 1;
                        if (d) return d.length;
                    }
                    return 0;
                }, a.listenerCount = function(y, d) {
                    return y.listenerCount(d);
                };
                function c(y) {
                    return typeof y == "function";
                }
                function h(y) {
                    return typeof y == "number";
                }
                function m(y) {
                    return typeof y == "object" && y !== null;
                }
                function p(y) {
                    return y === void 0;
                }
            },
            /* 6 */ /***/ function(r, i, a) {
                (function(c) {
                    var h = /^((?:[^\/;?#]+:)?)(\/\/[^\/\;?#]*)?(.*?)??(;.*?)?(\?.*?)?(#.*?)?$/, m = /^([^\/;?#]*)(.*)$/, p = /(?:\/|^)\.(?=\/)/g, y = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g, d = {
                        // jshint ignore:line
                        // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
                        // E.g
                        // With opts.alwaysNormalize = false (default, spec compliant)
                        // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
                        // With opts.alwaysNormalize = true (default, not spec compliant)
                        // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
                        buildAbsoluteURL: function(v, P, K) {
                            if (K = K || {}, v = v.trim(), P = P.trim(), !P) {
                                if (!K.alwaysNormalize) return v;
                                var O = this.parseURL(v);
                                if (!Y) throw new Error("Error trying to parse base URL.");
                                return O.path = d.normalizePath(O.path), d.buildURLFromParts(O);
                            }
                            var Z = this.parseURL(P);
                            if (!Z) throw new Error("Error trying to parse relative URL.");
                            if (Z.scheme) return K.alwaysNormalize ? (Z.path = d.normalizePath(Z.path), d.buildURLFromParts(Z)) : P;
                            var Y = this.parseURL(v);
                            if (!Y) throw new Error("Error trying to parse base URL.");
                            if (!Y.netLoc && Y.path && Y.path[0] !== "/") {
                                var X = m.exec(Y.path);
                                Y.netLoc = X[1], Y.path = X[2];
                            }
                            Y.netLoc && !Y.path && (Y.path = "/");
                            var V = {
                                // 2c) Otherwise, the embedded URL inherits the scheme of
                                // the base URL.
                                scheme: Y.scheme,
                                netLoc: Z.netLoc,
                                path: null,
                                params: Z.params,
                                query: Z.query,
                                fragment: Z.fragment
                            };
                            if (!Z.netLoc && (V.netLoc = Y.netLoc, Z.path[0] !== "/")) {
                                if (!Z.path) V.path = Y.path, Z.params || (V.params = Y.params, Z.query || (V.query = Y.query));
                                else {
                                    var q = Y.path, re = q.substring(0, q.lastIndexOf("/") + 1) + Z.path;
                                    V.path = d.normalizePath(re);
                                }
                            }
                            return V.path === null && (V.path = K.alwaysNormalize ? d.normalizePath(Z.path) : Z.path), d.buildURLFromParts(V);
                        },
                        parseURL: function(v) {
                            var P = h.exec(v);
                            return P ? {
                                scheme: P[1] || "",
                                netLoc: P[2] || "",
                                path: P[3] || "",
                                params: P[4] || "",
                                query: P[5] || "",
                                fragment: P[6] || ""
                            } : null;
                        },
                        normalizePath: function(v) {
                            for(v = v.split("").reverse().join("").replace(p, ""); v.length !== (v = v.replace(y, "")).length;);
                            return v.split("").reverse().join("");
                        },
                        buildURLFromParts: function(v) {
                            return v.scheme + v.netLoc + v.path + v.params + v.query + v.fragment;
                        }
                    };
                    r.exports = d;
                })();
            },
            /* 7 */ /***/ function(r, i, a) {
                var c = a(1), h = a(2), m = a(4), p = a(0);
                function y(R, I, b, T) {
                    var C, L, D, N, M, z = navigator.userAgent.toLowerCase(), J = T, H = [
                        96e3,
                        88200,
                        64e3,
                        48e3,
                        44100,
                        32e3,
                        24e3,
                        22050,
                        16e3,
                        12e3,
                        11025,
                        8e3,
                        7350
                    ];
                    if (C = ((I[b + 2] & 192) >>> 6) + 1, L = (I[b + 2] & 60) >>> 2, L > H.length - 1) {
                        R.trigger(Event.ERROR, {
                            type: h.b.MEDIA_ERROR,
                            details: h.a.FRAG_PARSING_ERROR,
                            fatal: !0,
                            reason: "invalid ADTS sampling index:" + L
                        });
                        return;
                    }
                    return N = (I[b + 2] & 1) << 2, N |= (I[b + 3] & 192) >>> 6, p.b.log("manifest codec:" + T + ",ADTS data:type:" + C + ",sampleingIndex:" + L + "[" + H[L] + "Hz],channelConfig:" + N), /firefox/i.test(z) ? L >= 6 ? (C = 5, M = new Array(4), D = L - 3) : (C = 2, M = new Array(2), D = L) : z.indexOf("android") !== -1 ? (C = 2, M = new Array(2), D = L) : (C = 5, M = new Array(4), T && (T.indexOf("mp4a.40.29") !== -1 || T.indexOf("mp4a.40.5") !== -1) || !T && L >= 6 ? D = L - 3 : ((T && T.indexOf("mp4a.40.2") !== -1 && (L >= 6 && N === 1 || /vivaldi/i.test(z)) || !T && N === 1) && (C = 2, M = new Array(2)), D = L)), M[0] = C << 3, M[0] |= (L & 14) >> 1, M[1] |= (L & 1) << 7, M[1] |= N << 3, C === 5 && (M[1] |= (D & 14) >> 1, M[2] = (D & 1) << 7, M[2] |= 8, M[3] = 0), {
                        config: M,
                        samplerate: H[L],
                        channelCount: N,
                        codec: "mp4a.40." + C,
                        manifestCodec: J
                    };
                }
                function d(R, I) {
                    return R[I] === 255 && (R[I + 1] & 246) === 240;
                }
                function v(R, I) {
                    return R[I + 1] & 1 ? 7 : 9;
                }
                function P(R, I) {
                    return (R[I + 3] & 3) << 11 | R[I + 4] << 3 | (R[I + 5] & 224) >>> 5;
                }
                function K(R, I) {
                    return !!(I + 1 < R.length && d(R, I));
                }
                function O(R, I) {
                    if (I + 1 < R.length && d(R, I)) {
                        var b = v(R, I), T = b;
                        I + 5 < R.length && (T = P(R, I));
                        var C = I + T;
                        if (C === R.length || C + 1 < R.length && d(R, C)) return !0;
                    }
                    return !1;
                }
                function Z(R, I, b, T, C) {
                    if (!R.samplerate) {
                        var L = y(I, b, T, C);
                        R.config = L.config, R.samplerate = L.samplerate, R.channelCount = L.channelCount, R.codec = L.codec, R.manifestCodec = L.manifestCodec, p.b.log("parsed codec:" + R.codec + ",rate:" + L.samplerate + ",nb channel:" + L.channelCount);
                    }
                }
                function Y(R) {
                    return 92160000 / R;
                }
                function X(R, I, b, T, C) {
                    var L, D, N, M = R.length;
                    if (L = v(R, I), D = P(R, I), D -= L, D > 0 && I + L + D <= M) return N = b + T * C, {
                        headerLength: L,
                        frameLength: D,
                        stamp: N
                    };
                }
                function V(R, I, b, T, C) {
                    var L = Y(R.samplerate), D = X(I, b, T, C, L);
                    if (D) {
                        var N = D.stamp, M = D.headerLength, z = D.frameLength, J = {
                            unit: I.subarray(b + M, b + M + z),
                            pts: N,
                            dts: N
                        };
                        return R.samples.push(J), R.len += z, {
                            sample: J,
                            length: z + M
                        };
                    }
                }
                var q = a(3);
                function re(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var ne = function() {
                    function R(I, b, T) {
                        re(this, R), this.observer = I, this.config = T, this.remuxer = b;
                    }
                    return R.prototype.resetInitSegment = function(b, T, C, L) {
                        this._audioTrack = {
                            container: "audio/adts",
                            type: "audio",
                            id: 0,
                            sequenceNumber: 0,
                            isAAC: !0,
                            samples: [],
                            len: 0,
                            manifestCodec: T,
                            duration: L,
                            inputTimeScale: 9e4
                        };
                    }, R.prototype.resetTimeStamp = function() {}, R.probe = function(b) {
                        if (!b) return !1;
                        for(var T = q.a.getID3Data(b, 0) || [], C = T.length, L = b.length; C < L; C++)if (O(b, C)) return p.b.log("ADTS sync word found !"), !0;
                        return !1;
                    }, R.prototype.append = function(b, T, C, L) {
                        for(var D = this._audioTrack, N = q.a.getID3Data(b, 0) || [], M = q.a.getTimeStamp(N), z = M ? 90 * M : T * 9e4, J = 0, H = z, ie = b.length, te = N.length, pe = [
                            {
                                pts: H,
                                dts: H,
                                data: N
                            }
                        ]; te < ie - 1;)if (K(b, te) && te + 5 < ie) {
                            Z(D, this.observer, b, te, D.manifestCodec);
                            var le = V(D, b, te, z, J);
                            if (le) te += le.length, H = le.sample.pts, J++;
                            else {
                                p.b.log("Unable to parse AAC frame");
                                break;
                            }
                        } else q.a.isHeader(b, te) ? (N = q.a.getID3Data(b, te), pe.push({
                            pts: H,
                            dts: H,
                            data: N
                        }), te += N.length) : te++;
                        this.remuxer.remux(D, {
                            samples: []
                        }, {
                            samples: pe,
                            inputTimeScale: 9e4
                        }, {
                            samples: []
                        }, T, C, L);
                    }, R.prototype.destroy = function() {}, R;
                }(), fe = ne;
                function ye(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var xe = Math.pow(2, 32) - 1, De = function() {
                    function R(I, b) {
                        ye(this, R), this.observer = I, this.remuxer = b;
                    }
                    return R.prototype.resetTimeStamp = function(b) {
                        this.initPTS = b;
                    }, R.prototype.resetInitSegment = function(b, T, C, L) {
                        if (b && b.byteLength) {
                            var D = this.initData = R.parseInitSegment(b);
                            T == null && (T = "mp4a.40.5"), C == null && (C = "avc1.42e01e");
                            var N = {};
                            D.audio && D.video ? N.audiovideo = {
                                container: "video/mp4",
                                codec: T + "," + C,
                                initSegment: L ? b : null
                            } : (D.audio && (N.audio = {
                                container: "audio/mp4",
                                codec: T,
                                initSegment: L ? b : null
                            }), D.video && (N.video = {
                                container: "video/mp4",
                                codec: C,
                                initSegment: L ? b : null
                            })), this.observer.trigger(c.a.FRAG_PARSING_INIT_SEGMENT, {
                                tracks: N
                            });
                        } else T && (this.audioCodec = T), C && (this.videoCodec = C);
                    }, R.probe = function(b) {
                        return R.findBox({
                            data: b,
                            start: 0,
                            end: Math.min(b.length, 16384)
                        }, [
                            "moof"
                        ]).length > 0;
                    }, R.bin2str = function(b) {
                        return String.fromCharCode.apply(null, b);
                    }, R.readUint32 = function(b, T) {
                        b.data && (T += b.start, b = b.data);
                        var C = b[T] << 24 | b[T + 1] << 16 | b[T + 2] << 8 | b[T + 3];
                        return C < 0 ? 4294967296 + C : C;
                    }, R.writeUint32 = function(b, T, C) {
                        b.data && (T += b.start, b = b.data), b[T] = C >> 24, b[T + 1] = C >> 16 & 255, b[T + 2] = C >> 8 & 255, b[T + 3] = C & 255;
                    }, R.findBox = function(b, T) {
                        var C = [], L, D, N, M, z, J, H;
                        if (b.data ? (J = b.start, M = b.end, b = b.data) : (J = 0, M = b.byteLength), !T.length) return null;
                        for(L = J; L < M;)D = R.readUint32(b, L), N = R.bin2str(b.subarray(L + 4, L + 8)), H = D > 1 ? L + D : M, N === T[0] && (T.length === 1 ? C.push({
                            data: b,
                            start: L + 8,
                            end: H
                        }) : (z = R.findBox({
                            data: b,
                            start: L + 8,
                            end: H
                        }, T.slice(1)), z.length && (C = C.concat(z)))), L = H;
                        return C;
                    }, R.parseInitSegment = function(b) {
                        var T = [], C = R.findBox(b, [
                            "moov",
                            "trak"
                        ]);
                        return C.forEach(function(L) {
                            var D = R.findBox(L, [
                                "tkhd"
                            ])[0];
                            if (D) {
                                var N = D.data[D.start], M = N === 0 ? 12 : 20, z = R.readUint32(D, M), J = R.findBox(L, [
                                    "mdia",
                                    "mdhd"
                                ])[0];
                                if (J) {
                                    N = J.data[J.start], M = N === 0 ? 12 : 20;
                                    var H = R.readUint32(J, M), ie = R.findBox(L, [
                                        "mdia",
                                        "hdlr"
                                    ])[0];
                                    if (ie) {
                                        var te = R.bin2str(ie.data.subarray(ie.start + 8, ie.start + 12)), pe = {
                                            soun: "audio",
                                            vide: "video"
                                        }[te];
                                        if (pe) {
                                            var le = R.findBox(L, [
                                                "mdia",
                                                "minf",
                                                "stbl",
                                                "stsd"
                                            ]);
                                            if (le.length) {
                                                le = le[0];
                                                var ue = R.bin2str(le.data.subarray(le.start + 12, le.start + 16));
                                                p.b.log("MP4Demuxer:" + pe + ":" + ue + " found");
                                            }
                                            T[z] = {
                                                timescale: H,
                                                type: pe
                                            }, T[pe] = {
                                                timescale: H,
                                                id: z
                                            };
                                        }
                                    }
                                }
                            }
                        }), T;
                    }, R.getStartDTS = function(b, T) {
                        var C, L, D;
                        return C = R.findBox(T, [
                            "moof",
                            "traf"
                        ]), L = [].concat.apply([], C.map(function(N) {
                            return R.findBox(N, [
                                "tfhd"
                            ]).map(function(M) {
                                var z, J, H;
                                return z = R.readUint32(M, 4), J = b[z].timescale || 9e4, H = R.findBox(N, [
                                    "tfdt"
                                ]).map(function(ie) {
                                    var te, pe;
                                    return te = ie.data[ie.start], pe = R.readUint32(ie, 4), te === 1 && (pe *= Math.pow(2, 32), pe += R.readUint32(ie, 8)), pe;
                                })[0], H / J;
                            });
                        })), D = Math.min.apply(null, L), isFinite(D) ? D : 0;
                    }, R.offsetStartDTS = function(b, T, C) {
                        R.findBox(T, [
                            "moof",
                            "traf"
                        ]).map(function(L) {
                            return R.findBox(L, [
                                "tfhd"
                            ]).map(function(D) {
                                var N = R.readUint32(D, 4), M = b[N].timescale || 9e4;
                                R.findBox(L, [
                                    "tfdt"
                                ]).map(function(z) {
                                    var J = z.data[z.start], H = R.readUint32(z, 4);
                                    if (J === 0) R.writeUint32(z, 4, H - C * M);
                                    else {
                                        H *= Math.pow(2, 32), H += R.readUint32(z, 8), H -= C * M, H = Math.max(H, 0);
                                        var ie = Math.floor(H / (xe + 1)), te = Math.floor(H % (xe + 1));
                                        R.writeUint32(z, 4, ie), R.writeUint32(z, 8, te);
                                    }
                                });
                            });
                        });
                    }, R.prototype.append = function(b, T, C, L) {
                        var D = this.initData;
                        D || (this.resetInitSegment(b, this.audioCodec, this.videoCodec), D = this.initData);
                        var N = void 0, M = this.initPTS;
                        if (M === void 0) {
                            var z = R.getStartDTS(D, b);
                            this.initPTS = M = z - T, this.observer.trigger(c.a.INIT_PTS_FOUND, {
                                initPTS: M
                            });
                        }
                        R.offsetStartDTS(D, b, M), N = R.getStartDTS(D, b), this.remuxer.remux(D.audio, D.video, null, null, N, C, L, b);
                    }, R.prototype.destroy = function() {}, R;
                }(), Be = De, Oe = {
                    BitratesMap: [
                        32,
                        64,
                        96,
                        128,
                        160,
                        192,
                        224,
                        256,
                        288,
                        320,
                        352,
                        384,
                        416,
                        448,
                        32,
                        48,
                        56,
                        64,
                        80,
                        96,
                        112,
                        128,
                        160,
                        192,
                        224,
                        256,
                        320,
                        384,
                        32,
                        40,
                        48,
                        56,
                        64,
                        80,
                        96,
                        112,
                        128,
                        160,
                        192,
                        224,
                        256,
                        320,
                        32,
                        48,
                        56,
                        64,
                        80,
                        96,
                        112,
                        128,
                        144,
                        160,
                        176,
                        192,
                        224,
                        256,
                        8,
                        16,
                        24,
                        32,
                        40,
                        48,
                        56,
                        64,
                        80,
                        96,
                        112,
                        128,
                        144,
                        160
                    ],
                    SamplingRateMap: [
                        44100,
                        48e3,
                        32e3,
                        22050,
                        24e3,
                        16e3,
                        11025,
                        12e3,
                        8e3
                    ],
                    SamplesCoefficients: [
                        // MPEG 2.5
                        [
                            0,
                            // Reserved
                            72,
                            // Layer3
                            144,
                            // Layer2
                            12
                        ],
                        // Reserved
                        [
                            0,
                            // Reserved
                            0,
                            // Layer3
                            0,
                            // Layer2
                            0
                        ],
                        // MPEG 2
                        [
                            0,
                            // Reserved
                            72,
                            // Layer3
                            144,
                            // Layer2
                            12
                        ],
                        // MPEG 1
                        [
                            0,
                            // Reserved
                            144,
                            // Layer3
                            144,
                            // Layer2
                            12
                        ]
                    ],
                    BytesInSlot: [
                        0,
                        // Reserved
                        1,
                        // Layer3
                        1,
                        // Layer2
                        4
                    ],
                    appendFrame: function(I, b, T, C, L) {
                        if (!(T + 24 > b.length)) {
                            var D = this.parseHeader(b, T);
                            if (D && T + D.frameLength <= b.length) {
                                var N = D.samplesPerFrame * 9e4 / D.sampleRate, M = C + L * N, z = {
                                    unit: b.subarray(T, T + D.frameLength),
                                    pts: M,
                                    dts: M
                                };
                                return I.config = [], I.channelCount = D.channelCount, I.samplerate = D.sampleRate, I.samples.push(z), I.len += D.frameLength, {
                                    sample: z,
                                    length: D.frameLength
                                };
                            }
                        }
                    },
                    parseHeader: function(I, b) {
                        var T = I[b + 1] >> 3 & 3, C = I[b + 1] >> 1 & 3, L = I[b + 2] >> 4 & 15, D = I[b + 2] >> 2 & 3, N = I[b + 2] >> 1 & 1;
                        if (T !== 1 && L !== 0 && L !== 15 && D !== 3) {
                            var M = T === 3 ? 3 - C : C === 3 ? 3 : 4, z = Oe.BitratesMap[M * 14 + L - 1] * 1e3, J = T === 3 ? 0 : T === 2 ? 1 : 2, H = Oe.SamplingRateMap[J * 3 + D], ie = I[b + 3] >> 6 === 3 ? 1 : 2, te = Oe.SamplesCoefficients[T][C], pe = Oe.BytesInSlot[C], le = te * 8 * pe, ue = parseInt(te * z / H + N, 10) * pe;
                            return {
                                sampleRate: H,
                                channelCount: ie,
                                frameLength: ue,
                                samplesPerFrame: le
                            };
                        }
                    },
                    isHeaderPattern: function(I, b) {
                        return I[b] === 255 && (I[b + 1] & 224) === 224 && (I[b + 1] & 6) !== 0;
                    },
                    isHeader: function(I, b) {
                        return !!(b + 1 < I.length && this.isHeaderPattern(I, b));
                    },
                    probe: function(I, b) {
                        if (b + 1 < I.length && this.isHeaderPattern(I, b)) {
                            var T = 4, C = this.parseHeader(I, b), L = T;
                            C && C.frameLength && (L = C.frameLength);
                            var D = b + L;
                            if (D === I.length || D + 1 < I.length && this.isHeaderPattern(I, D)) return !0;
                        }
                        return !1;
                    }
                }, we = Oe;
                function Fe(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var Xe = function() {
                    function R(I) {
                        Fe(this, R), this.data = I, this.bytesAvailable = I.byteLength, this.word = 0, this.bitsAvailable = 0;
                    }
                    return R.prototype.loadWord = function() {
                        var b = this.data, T = this.bytesAvailable, C = b.byteLength - T, L = new Uint8Array(4), D = Math.min(4, T);
                        if (D === 0) throw new Error("no bytes available");
                        L.set(b.subarray(C, C + D)), this.word = new DataView(L.buffer).getUint32(0), this.bitsAvailable = D * 8, this.bytesAvailable -= D;
                    }, R.prototype.skipBits = function(b) {
                        var T;
                        this.bitsAvailable > b ? (this.word <<= b, this.bitsAvailable -= b) : (b -= this.bitsAvailable, T = b >> 3, b -= T >> 3, this.bytesAvailable -= T, this.loadWord(), this.word <<= b, this.bitsAvailable -= b);
                    }, R.prototype.readBits = function(b) {
                        var T = Math.min(this.bitsAvailable, b), C = this.word >>> 32 - T;
                        return b > 32 && p.b.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= T, this.bitsAvailable > 0 ? this.word <<= T : this.bytesAvailable > 0 && this.loadWord(), T = b - T, T > 0 && this.bitsAvailable ? C << T | this.readBits(T) : C;
                    }, R.prototype.skipLZ = function() {
                        var b;
                        for(b = 0; b < this.bitsAvailable; ++b)if (this.word & 2147483648 >>> b) return this.word <<= b, this.bitsAvailable -= b, b;
                        return this.loadWord(), b + this.skipLZ();
                    }, R.prototype.skipUEG = function() {
                        this.skipBits(1 + this.skipLZ());
                    }, R.prototype.skipEG = function() {
                        this.skipBits(1 + this.skipLZ());
                    }, R.prototype.readUEG = function() {
                        var b = this.skipLZ();
                        return this.readBits(b + 1) - 1;
                    }, R.prototype.readEG = function() {
                        var b = this.readUEG();
                        return 1 & b ? 1 + b >>> 1 : -1 * (b >>> 1);
                    }, R.prototype.readBoolean = function() {
                        return this.readBits(1) === 1;
                    }, R.prototype.readUByte = function() {
                        return this.readBits(8);
                    }, R.prototype.readUShort = function() {
                        return this.readBits(16);
                    }, R.prototype.readUInt = function() {
                        return this.readBits(32);
                    }, R.prototype.skipScalingList = function(b) {
                        var T = 8, C = 8, L, D;
                        for(L = 0; L < b; L++)C !== 0 && (D = this.readEG(), C = (T + D + 256) % 256), T = C === 0 ? T : C;
                    }, R.prototype.readSPS = function() {
                        var b = 0, T = 0, C = 0, L = 0, D, N, M, z, J, H, ie, te = this.readUByte.bind(this), pe = this.readBits.bind(this), le = this.readUEG.bind(this), ue = this.readBoolean.bind(this), Q = this.skipBits.bind(this), Ue = this.skipEG.bind(this), rt = this.skipUEG.bind(this), it = this.skipScalingList.bind(this);
                        if (te(), D = te(), pe(5), Q(3), te(), rt(), D === 100 || D === 110 || D === 122 || D === 244 || D === 44 || D === 83 || D === 86 || D === 118 || D === 128) {
                            var qe = le();
                            if (qe === 3 && Q(1), rt(), rt(), Q(1), ue()) for(H = qe !== 3 ? 8 : 12, ie = 0; ie < H; ie++)ue() && (ie < 6 ? it(16) : it(64));
                        }
                        rt();
                        var Je = le();
                        if (Je === 0) le();
                        else if (Je === 1) for(Q(1), Ue(), Ue(), N = le(), ie = 0; ie < N; ie++)Ue();
                        rt(), Q(1), M = le(), z = le(), J = pe(1), J === 0 && Q(1), Q(1), ue() && (b = le(), T = le(), C = le(), L = le());
                        var Te = [
                            1,
                            1
                        ];
                        if (ue() && ue()) {
                            var at = te();
                            switch(at){
                                case 1:
                                    Te = [
                                        1,
                                        1
                                    ];
                                    break;
                                case 2:
                                    Te = [
                                        12,
                                        11
                                    ];
                                    break;
                                case 3:
                                    Te = [
                                        10,
                                        11
                                    ];
                                    break;
                                case 4:
                                    Te = [
                                        16,
                                        11
                                    ];
                                    break;
                                case 5:
                                    Te = [
                                        40,
                                        33
                                    ];
                                    break;
                                case 6:
                                    Te = [
                                        24,
                                        11
                                    ];
                                    break;
                                case 7:
                                    Te = [
                                        20,
                                        11
                                    ];
                                    break;
                                case 8:
                                    Te = [
                                        32,
                                        11
                                    ];
                                    break;
                                case 9:
                                    Te = [
                                        80,
                                        33
                                    ];
                                    break;
                                case 10:
                                    Te = [
                                        18,
                                        11
                                    ];
                                    break;
                                case 11:
                                    Te = [
                                        15,
                                        11
                                    ];
                                    break;
                                case 12:
                                    Te = [
                                        64,
                                        33
                                    ];
                                    break;
                                case 13:
                                    Te = [
                                        160,
                                        99
                                    ];
                                    break;
                                case 14:
                                    Te = [
                                        4,
                                        3
                                    ];
                                    break;
                                case 15:
                                    Te = [
                                        3,
                                        2
                                    ];
                                    break;
                                case 16:
                                    Te = [
                                        2,
                                        1
                                    ];
                                    break;
                                case 255:
                                    Te = [
                                        te() << 8 | te(),
                                        te() << 8 | te()
                                    ];
                                    break;
                            }
                        }
                        return {
                            width: Math.ceil((M + 1) * 16 - b * 2 - T * 2),
                            height: (2 - J) * (z + 1) * 16 - (J ? 2 : 4) * (C + L),
                            pixelRatio: Te
                        };
                    }, R.prototype.readSliceType = function() {
                        return this.readUByte(), this.readUEG(), this.readUEG();
                    }, R;
                }(), ct = Xe;
                function Ge(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var tt = function() {
                    function R(I, b, T, C) {
                        Ge(this, R), this.decryptdata = T, this.discardEPB = C, this.decrypter = new m.a(I, b);
                    }
                    return R.prototype.decryptBuffer = function(b, T) {
                        this.decrypter.decrypt(b, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, T);
                    }, R.prototype.decryptAacSample = function(b, T, C, L) {
                        var D = b[T].unit, N = D.subarray(16, D.length - D.length % 16), M = N.buffer.slice(N.byteOffset, N.byteOffset + N.length), z = this;
                        this.decryptBuffer(M, function(J) {
                            J = new Uint8Array(J), D.set(J, 16), L || z.decryptAacSamples(b, T + 1, C);
                        });
                    }, R.prototype.decryptAacSamples = function(b, T, C) {
                        for(;; T++){
                            if (T >= b.length) {
                                C();
                                return;
                            }
                            if (!(b[T].unit.length < 32)) {
                                var L = this.decrypter.isSync();
                                if (this.decryptAacSample(b, T, C, L), !L) return;
                            }
                        }
                    }, R.prototype.getAvcEncryptedData = function(b) {
                        for(var T = Math.floor((b.length - 48) / 160) * 16 + 16, C = new Int8Array(T), L = 0, D = 32; D <= b.length - 16; D += 160, L += 16)C.set(b.subarray(D, D + 16), L);
                        return C;
                    }, R.prototype.getAvcDecryptedUnit = function(b, T) {
                        T = new Uint8Array(T);
                        for(var C = 0, L = 32; L <= b.length - 16; L += 160, C += 16)b.set(T.subarray(C, C + 16), L);
                        return b;
                    }, R.prototype.decryptAvcSample = function(b, T, C, L, D, N) {
                        var M = this.discardEPB(D.data), z = this.getAvcEncryptedData(M), J = this;
                        this.decryptBuffer(z.buffer, function(H) {
                            D.data = J.getAvcDecryptedUnit(M, H), N || J.decryptAvcSamples(b, T, C + 1, L);
                        });
                    }, R.prototype.decryptAvcSamples = function(b, T, C, L) {
                        for(;; T++, C = 0){
                            if (T >= b.length) {
                                L();
                                return;
                            }
                            for(var D = b[T].units; !(C >= D.length); C++){
                                var N = D[C];
                                if (!(N.length <= 48 || N.type !== 1 && N.type !== 5)) {
                                    var M = this.decrypter.isSync();
                                    if (this.decryptAvcSample(b, T, C, L, N, M), !M) return;
                                }
                            }
                        }
                    }, R;
                }(), Rt = tt;
                function dt(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var ft = {
                    video: 0,
                    audio: 1,
                    id3: 2,
                    text: 3
                }, Bt = function() {
                    function R(I, b, T, C) {
                        dt(this, R), this.observer = I, this.config = T, this.typeSupported = C, this.remuxer = b, this.sampleAes = null;
                    }
                    return R.prototype.setDecryptData = function(b) {
                        b != null && b.key != null && b.method === "SAMPLE-AES" ? this.sampleAes = new Rt(this.observer, this.config, b, this.discardEPB) : this.sampleAes = null;
                    }, R.probe = function(b) {
                        var T = R._syncOffset(b);
                        return T < 0 ? !1 : (T && p.b.warn("MPEG2-TS detected but first sync word found @ offset " + T + ", junk ahead ?"), !0);
                    }, R._syncOffset = function(b) {
                        for(var T = Math.min(1e3, b.length - 564), C = 0; C < T;){
                            if (b[C] === 71 && b[C + 188] === 71 && b[C + 376] === 71) return C;
                            C++;
                        }
                        return -1;
                    }, R.createTrack = function(b, T) {
                        return {
                            container: b === "video" || b === "audio" ? "video/mp2t" : void 0,
                            type: b,
                            id: ft[b],
                            pid: -1,
                            inputTimeScale: 9e4,
                            sequenceNumber: 0,
                            samples: [],
                            len: 0,
                            dropped: b === "video" ? 0 : void 0,
                            isAAC: b === "audio" ? !0 : void 0,
                            duration: b === "audio" ? T : void 0
                        };
                    }, R.prototype.resetInitSegment = function(b, T, C, L) {
                        this.pmtParsed = !1, this._pmtId = -1, this._avcTrack = R.createTrack("video", L), this._audioTrack = R.createTrack("audio", L), this._id3Track = R.createTrack("id3", L), this._txtTrack = R.createTrack("text", L), this.aacOverFlow = null, this.aacLastPTS = null, this.avcSample = null, this.audioCodec = T, this.videoCodec = C, this._duration = L;
                    }, R.prototype.resetTimeStamp = function() {}, R.prototype.append = function(b, T, C, L) {
                        var D, N = b.length, M, z, J, H, ie, te = !1;
                        this.contiguous = C;
                        var pe = this.pmtParsed, le = this._avcTrack, ue = this._audioTrack, Q = this._id3Track, Ue = le.pid, rt = ue.pid, it = Q.pid, qe = this._pmtId, Je = le.pesData, Te = ue.pesData, at = Q.pesData, _t = this._parsePAT, nt = this._parsePMT, At = this._parsePES, Lt = this._parseAVCPES.bind(this), ir = this._parseAACPES.bind(this), It = this._parseMPEGPES.bind(this), br = this._parseID3PES.bind(this), Xt = R._syncOffset(b);
                        for(N -= (N + Xt) % 188, D = Xt; D < N; D += 188)if (b[D] === 71) {
                            if (M = !!(b[D + 1] & 64), z = ((b[D + 1] & 31) << 8) + b[D + 2], J = (b[D + 3] & 48) >> 4, J > 1) {
                                if (H = D + 5 + b[D + 4], H === D + 188) continue;
                            } else H = D + 4;
                            switch(z){
                                case Ue:
                                    M && (Je && (ie = At(Je)) && Lt(ie, !1), Je = {
                                        data: [],
                                        size: 0
                                    }), Je && (Je.data.push(b.subarray(H, D + 188)), Je.size += D + 188 - H);
                                    break;
                                case rt:
                                    M && (Te && (ie = At(Te)) && (ue.isAAC ? ir(ie) : It(ie)), Te = {
                                        data: [],
                                        size: 0
                                    }), Te && (Te.data.push(b.subarray(H, D + 188)), Te.size += D + 188 - H);
                                    break;
                                case it:
                                    M && (at && (ie = At(at)) && br(ie), at = {
                                        data: [],
                                        size: 0
                                    }), at && (at.data.push(b.subarray(H, D + 188)), at.size += D + 188 - H);
                                    break;
                                case 0:
                                    M && (H += b[H] + 1), qe = this._pmtId = _t(b, H);
                                    break;
                                case qe:
                                    M && (H += b[H] + 1);
                                    var nr = nt(b, H, this.typeSupported.mpeg === !0 || this.typeSupported.mp3 === !0, this.sampleAes != null);
                                    Ue = nr.avc, Ue > 0 && (le.pid = Ue), rt = nr.audio, rt > 0 && (ue.pid = rt, ue.isAAC = nr.isAAC), it = nr.id3, it > 0 && (Q.pid = it), te && !pe && (p.b.log("reparse from beginning"), te = !1, D = Xt - 188), pe = this.pmtParsed = !0;
                                    break;
                                case 17:
                                case 8191:
                                    break;
                                default:
                                    te = !0;
                                    break;
                            }
                        } else this.observer.trigger(c.a.ERROR, {
                            type: h.b.MEDIA_ERROR,
                            details: h.a.FRAG_PARSING_ERROR,
                            fatal: !1,
                            reason: "TS packet did not start with 0x47"
                        });
                        Je && (ie = At(Je)) ? (Lt(ie, !0), le.pesData = null) : le.pesData = Je, Te && (ie = At(Te)) ? (ue.isAAC ? ir(ie) : It(ie), ue.pesData = null) : (Te && Te.size && p.b.log("last AAC PES packet truncated,might overlap between fragments"), ue.pesData = Te), at && (ie = At(at)) ? (br(ie), Q.pesData = null) : Q.pesData = at, this.sampleAes == null ? this.remuxer.remux(ue, le, Q, this._txtTrack, T, C, L) : this.decryptAndRemux(ue, le, Q, this._txtTrack, T, C, L);
                    }, R.prototype.decryptAndRemux = function(b, T, C, L, D, N, M) {
                        if (b.samples && b.isAAC) {
                            var z = this;
                            this.sampleAes.decryptAacSamples(b.samples, 0, function() {
                                z.decryptAndRemuxAvc(b, T, C, L, D, N, M);
                            });
                        } else this.decryptAndRemuxAvc(b, T, C, L, D, N, M);
                    }, R.prototype.decryptAndRemuxAvc = function(b, T, C, L, D, N, M) {
                        if (T.samples) {
                            var z = this;
                            this.sampleAes.decryptAvcSamples(T.samples, 0, 0, function() {
                                z.remuxer.remux(b, T, C, L, D, N, M);
                            });
                        } else this.remuxer.remux(b, T, C, L, D, N, M);
                    }, R.prototype.destroy = function() {
                        this._initPTS = this._initDTS = void 0, this._duration = 0;
                    }, R.prototype._parsePAT = function(b, T) {
                        return (b[T + 10] & 31) << 8 | b[T + 11];
                    }, R.prototype._parsePMT = function(b, T, C, L) {
                        var D, N, M, z, J = {
                            audio: -1,
                            avc: -1,
                            id3: -1,
                            isAAC: !0
                        };
                        for(D = (b[T + 1] & 15) << 8 | b[T + 2], N = T + 3 + D - 4, M = (b[T + 10] & 15) << 8 | b[T + 11], T += 12 + M; T < N;){
                            switch(z = (b[T + 1] & 31) << 8 | b[T + 2], b[T]){
                                case 207:
                                    if (!L) {
                                        p.b.log("unkown stream type:" + b[T]);
                                        break;
                                    }
                                case 15:
                                    J.audio === -1 && (J.audio = z);
                                    break;
                                case 21:
                                    J.id3 === -1 && (J.id3 = z);
                                    break;
                                case 219:
                                    if (!L) {
                                        p.b.log("unkown stream type:" + b[T]);
                                        break;
                                    }
                                case 27:
                                    J.avc === -1 && (J.avc = z);
                                    break;
                                case 3:
                                case 4:
                                    C ? J.audio === -1 && (J.audio = z, J.isAAC = !1) : p.b.log("MPEG audio found, not supported in this browser for now");
                                    break;
                                case 36:
                                    p.b.warn("HEVC stream type found, not supported for now");
                                    break;
                                default:
                                    p.b.log("unkown stream type:" + b[T]);
                                    break;
                            }
                            T += ((b[T + 3] & 15) << 8 | b[T + 4]) + 5;
                        }
                        return J;
                    }, R.prototype._parsePES = function(b) {
                        var T = 0, C, L, D, N, M, z, J, H, ie, te = b.data;
                        if (!b || b.size === 0) return null;
                        for(; te[0].length < 19 && te.length > 1;){
                            var pe = new Uint8Array(te[0].length + te[1].length);
                            pe.set(te[0]), pe.set(te[1], te[0].length), te[0] = pe, te.splice(1, 1);
                        }
                        if (C = te[0], D = (C[0] << 16) + (C[1] << 8) + C[2], D === 1) {
                            if (N = (C[4] << 8) + C[5], N && N > b.size - 6) return null;
                            L = C[7], L & 192 && (J = (C[9] & 14) * 536870912 + // 1 << 29
                            (C[10] & 255) * 4194304 + // 1 << 22
                            (C[11] & 254) * 16384 + // 1 << 14
                            (C[12] & 255) * 128 + // 1 << 7
                            (C[13] & 254) / 2, J > 4294967295 && (J -= 8589934592), L & 64 ? (H = (C[14] & 14) * 536870912 + // 1 << 29
                            (C[15] & 255) * 4194304 + // 1 << 22
                            (C[16] & 254) * 16384 + // 1 << 14
                            (C[17] & 255) * 128 + // 1 << 7
                            (C[18] & 254) / 2, H > 4294967295 && (H -= 8589934592), J - H > 60 * 9e4 && (p.b.warn(Math.round((J - H) / 9e4) + "s delta between PTS and DTS, align them"), J = H)) : H = J), M = C[8], ie = M + 9, b.size -= ie, z = new Uint8Array(b.size);
                            for(var le = 0, ue = te.length; le < ue; le++){
                                C = te[le];
                                var Q = C.byteLength;
                                if (ie) {
                                    if (ie > Q) {
                                        ie -= Q;
                                        continue;
                                    } else C = C.subarray(ie), Q -= ie, ie = 0;
                                }
                                z.set(C, T), T += Q;
                            }
                            return N && (N -= M + 3), {
                                data: z,
                                pts: J,
                                dts: H,
                                len: N
                            };
                        } else return null;
                    }, R.prototype.pushAccesUnit = function(b, T) {
                        if (b.units.length && b.frame) {
                            var C = T.samples, L = C.length;
                            !this.config.forceKeyFrameOnDiscontinuity || b.key === !0 || T.sps && (L || this.contiguous) ? (b.id = L, C.push(b)) : T.dropped++;
                        }
                        b.debug.length && p.b.log(b.pts + "/" + b.dts + ":" + b.debug);
                    }, R.prototype._parseAVCPES = function(b, T) {
                        var C = this, L = this._avcTrack, D = this._parseAVCNALu(b.data), N, M = this.avcSample, z, J = !1, H, ie = this.pushAccesUnit.bind(this), te = function(le, ue, Q, Ue) {
                            return {
                                key: le,
                                pts: ue,
                                dts: Q,
                                units: [],
                                debug: Ue
                            };
                        };
                        b.data = null, M && D.length && !L.audFound && (ie(M, L), M = this.avcSample = te(!1, b.pts, b.dts, "")), D.forEach(function(pe) {
                            switch(pe.type){
                                case 1:
                                    z = !0, M || (M = C.avcSample = te(!0, b.pts, b.dts, "")), M.frame = !0;
                                    var le = pe.data;
                                    if (J && le.length > 4) {
                                        var ue = new ct(le).readSliceType();
                                        (ue === 2 || ue === 4 || ue === 7 || ue === 9) && (M.key = !0);
                                    }
                                    break;
                                case 5:
                                    z = !0, M || (M = C.avcSample = te(!0, b.pts, b.dts, "")), M.key = !0, M.frame = !0;
                                    break;
                                case 6:
                                    z = !0, N = new ct(C.discardEPB(pe.data)), N.readUByte();
                                    for(var Q = 0, Ue = 0, rt = !1, it = 0; !rt && N.bytesAvailable > 1;){
                                        Q = 0;
                                        do it = N.readUByte(), Q += it;
                                        while (it === 255);
                                        Ue = 0;
                                        do it = N.readUByte(), Ue += it;
                                        while (it === 255);
                                        if (Q === 4 && N.bytesAvailable !== 0) {
                                            rt = !0;
                                            var qe = N.readUByte();
                                            if (qe === 181) {
                                                var Je = N.readUShort();
                                                if (Je === 49) {
                                                    var Te = N.readUInt();
                                                    if (Te === 1195456820) {
                                                        var at = N.readUByte();
                                                        if (at === 3) {
                                                            var _t = N.readUByte(), nt = N.readUByte(), At = 31 & _t, Lt = [
                                                                _t,
                                                                nt
                                                            ];
                                                            for(H = 0; H < At; H++)Lt.push(N.readUByte()), Lt.push(N.readUByte()), Lt.push(N.readUByte());
                                                            C._insertSampleInOrder(C._txtTrack.samples, {
                                                                type: 3,
                                                                pts: b.pts,
                                                                bytes: Lt
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        } else if (Ue < N.bytesAvailable) for(H = 0; H < Ue; H++)N.readUByte();
                                    }
                                    break;
                                case 7:
                                    if (z = !0, J = !0, !L.sps) {
                                        N = new ct(pe.data);
                                        var ir = N.readSPS();
                                        L.width = ir.width, L.height = ir.height, L.pixelRatio = ir.pixelRatio, L.sps = [
                                            pe.data
                                        ], L.duration = C._duration;
                                        var It = pe.data.subarray(1, 4), br = "avc1.";
                                        for(H = 0; H < 3; H++){
                                            var Xt = It[H].toString(16);
                                            Xt.length < 2 && (Xt = "0" + Xt), br += Xt;
                                        }
                                        L.codec = br;
                                    }
                                    break;
                                case 8:
                                    z = !0, L.pps || (L.pps = [
                                        pe.data
                                    ]);
                                    break;
                                case 9:
                                    z = !1, L.audFound = !0, M && ie(M, L), M = C.avcSample = te(!1, b.pts, b.dts, "");
                                    break;
                                case 12:
                                    z = !1;
                                    break;
                                default:
                                    z = !1, M && (M.debug += "unknown NAL " + pe.type + " ");
                                    break;
                            }
                            if (M && z) {
                                var nr = M.units;
                                nr.push(pe);
                            }
                        }), T && M && (ie(M, L), this.avcSample = null);
                    }, R.prototype._insertSampleInOrder = function(b, T) {
                        var C = b.length;
                        if (C > 0) {
                            if (T.pts >= b[C - 1].pts) b.push(T);
                            else for(var L = C - 1; L >= 0; L--)if (T.pts < b[L].pts) {
                                b.splice(L, 0, T);
                                break;
                            }
                        } else b.push(T);
                    }, R.prototype._getLastNalUnit = function() {
                        var b = this.avcSample, T = void 0;
                        if (!b || b.units.length === 0) {
                            var C = this._avcTrack, L = C.samples;
                            b = L[L.length - 1];
                        }
                        if (b) {
                            var D = b.units;
                            T = D[D.length - 1];
                        }
                        return T;
                    }, R.prototype._parseAVCNALu = function(b) {
                        var T = 0, C = b.byteLength, L, D, N = this._avcTrack, M = N.naluState || 0, z = M, J = [], H, ie, te = -1, pe;
                        for(M === -1 && (te = 0, pe = b[0] & 31, M = 0, T = 1); T < C;){
                            if (L = b[T++], !M) {
                                M = L ? 0 : 1;
                                continue;
                            }
                            if (M === 1) {
                                M = L ? 0 : 2;
                                continue;
                            }
                            if (!L) M = 3;
                            else if (L === 1) {
                                if (te >= 0) H = {
                                    data: b.subarray(te, T - M - 1),
                                    type: pe
                                }, J.push(H);
                                else {
                                    var le = this._getLastNalUnit();
                                    if (le && (z && T <= 4 - z && le.state && (le.data = le.data.subarray(0, le.data.byteLength - z)), D = T - M - 1, D > 0)) {
                                        var ue = new Uint8Array(le.data.byteLength + D);
                                        ue.set(le.data, 0), ue.set(b.subarray(0, D), le.data.byteLength), le.data = ue;
                                    }
                                }
                                T < C ? (ie = b[T] & 31, te = T, pe = ie, M = 0) : M = -1;
                            } else M = 0;
                        }
                        if (te >= 0 && M >= 0 && (H = {
                            data: b.subarray(te, C),
                            type: pe,
                            state: M
                        }, J.push(H)), J.length === 0) {
                            var Q = this._getLastNalUnit();
                            if (Q) {
                                var Ue = new Uint8Array(Q.data.byteLength + b.byteLength);
                                Ue.set(Q.data, 0), Ue.set(b, Q.data.byteLength), Q.data = Ue;
                            }
                        }
                        return N.naluState = M, J;
                    }, R.prototype.discardEPB = function(b) {
                        for(var T = b.byteLength, C = [], L = 1, D, N; L < T - 2;)b[L] === 0 && b[L + 1] === 0 && b[L + 2] === 3 ? (C.push(L + 2), L += 2) : L++;
                        if (C.length === 0) return b;
                        D = T - C.length, N = new Uint8Array(D);
                        var M = 0;
                        for(L = 0; L < D; M++, L++)M === C[0] && (M++, C.shift()), N[L] = b[M];
                        return N;
                    }, R.prototype._parseAACPES = function(b) {
                        var T = this._audioTrack, C = b.data, L = b.pts, D = 0, N = this.aacOverFlow, M = this.aacLastPTS, z, J, H, ie, te;
                        if (N) {
                            var pe = new Uint8Array(N.byteLength + C.byteLength);
                            pe.set(N, 0), pe.set(C, N.byteLength), C = pe;
                        }
                        for(H = D, te = C.length; H < te - 1 && !K(C, H); H++);
                        if (H) {
                            var le, ue;
                            if (H < te - 1 ? (le = "AAC PES did not start with ADTS header,offset:" + H, ue = !1) : (le = "no ADTS header found in AAC PES", ue = !0), p.b.warn("parsing error:" + le), this.observer.trigger(c.a.ERROR, {
                                type: h.b.MEDIA_ERROR,
                                details: h.a.FRAG_PARSING_ERROR,
                                fatal: ue,
                                reason: le
                            }), ue) return;
                        }
                        if (Z(T, this.observer, C, H, this.audioCodec), J = 0, z = Y(T.samplerate), N && M) {
                            var Q = M + z;
                            Math.abs(Q - L) > 1 && (p.b.log("AAC: align PTS for overlapping frames by " + Math.round((Q - L) / 90)), L = Q);
                        }
                        for(; H < te;)if (K(C, H) && H + 5 < te) {
                            var Ue = V(T, C, H, L, J);
                            if (Ue) H += Ue.length, ie = Ue.sample.pts, J++;
                            else break;
                        } else H++;
                        H < te ? N = C.subarray(H, te) : N = null, this.aacOverFlow = N, this.aacLastPTS = ie;
                    }, R.prototype._parseMPEGPES = function(b) {
                        for(var T = b.data, C = T.length, L = 0, D = 0, N = b.pts; D < C;)if (we.isHeader(T, D)) {
                            var M = we.appendFrame(this._audioTrack, T, D, N, L);
                            if (M) D += M.length, L++;
                            else break;
                        } else D++;
                    }, R.prototype._parseID3PES = function(b) {
                        this._id3Track.samples.push(b);
                    }, R;
                }(), He = Bt;
                function Pr(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var pt = function() {
                    function R(I, b, T) {
                        Pr(this, R), this.observer = I, this.config = T, this.remuxer = b;
                    }
                    return R.prototype.resetInitSegment = function(b, T, C, L) {
                        this._audioTrack = {
                            container: "audio/mpeg",
                            type: "audio",
                            id: -1,
                            sequenceNumber: 0,
                            isAAC: !1,
                            samples: [],
                            len: 0,
                            manifestCodec: T,
                            duration: L,
                            inputTimeScale: 9e4
                        };
                    }, R.prototype.resetTimeStamp = function() {}, R.probe = function(b) {
                        var T, C, L = q.a.getID3Data(b, 0);
                        if (L && q.a.getTimeStamp(L) !== void 0) {
                            for(T = L.length, C = Math.min(b.length - 1, T + 100); T < C; T++)if (we.probe(b, T)) return p.b.log("MPEG Audio sync word found !"), !0;
                        }
                        return !1;
                    }, R.prototype.append = function(b, T, C, L) {
                        for(var D = q.a.getID3Data(b, 0), N = q.a.getTimeStamp(D), M = N ? 90 * N : T * 9e4, z = D.length, J = b.length, H = 0, ie = 0, te = this._audioTrack, pe = [
                            {
                                pts: M,
                                dts: M,
                                data: D
                            }
                        ]; z < J;)if (we.isHeader(b, z)) {
                            var le = we.appendFrame(te, b, z, M, H);
                            if (le) z += le.length, ie = le.sample.pts, H++;
                            else break;
                        } else q.a.isHeader(b, z) ? (D = q.a.getID3Data(b, z), pe.push({
                            pts: ie,
                            dts: ie,
                            data: D
                        }), z += D.length) : z++;
                        this.remuxer.remux(te, {
                            samples: []
                        }, {
                            samples: pe,
                            inputTimeScale: 9e4
                        }, {
                            samples: []
                        }, T, C, L);
                    }, R.prototype.destroy = function() {}, R;
                }(), tn = pt;
                function dr(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var fr = function() {
                    function R() {
                        dr(this, R);
                    }
                    return R.getSilentFrame = function(b, T) {
                        switch(b){
                            case "mp4a.40.2":
                                if (T === 1) return new Uint8Array([
                                    0,
                                    200,
                                    0,
                                    128,
                                    35,
                                    128
                                ]);
                                if (T === 2) return new Uint8Array([
                                    33,
                                    0,
                                    73,
                                    144,
                                    2,
                                    25,
                                    0,
                                    35,
                                    128
                                ]);
                                if (T === 3) return new Uint8Array([
                                    0,
                                    200,
                                    0,
                                    128,
                                    32,
                                    132,
                                    1,
                                    38,
                                    64,
                                    8,
                                    100,
                                    0,
                                    142
                                ]);
                                if (T === 4) return new Uint8Array([
                                    0,
                                    200,
                                    0,
                                    128,
                                    32,
                                    132,
                                    1,
                                    38,
                                    64,
                                    8,
                                    100,
                                    0,
                                    128,
                                    44,
                                    128,
                                    8,
                                    2,
                                    56
                                ]);
                                if (T === 5) return new Uint8Array([
                                    0,
                                    200,
                                    0,
                                    128,
                                    32,
                                    132,
                                    1,
                                    38,
                                    64,
                                    8,
                                    100,
                                    0,
                                    130,
                                    48,
                                    4,
                                    153,
                                    0,
                                    33,
                                    144,
                                    2,
                                    56
                                ]);
                                if (T === 6) return new Uint8Array([
                                    0,
                                    200,
                                    0,
                                    128,
                                    32,
                                    132,
                                    1,
                                    38,
                                    64,
                                    8,
                                    100,
                                    0,
                                    130,
                                    48,
                                    4,
                                    153,
                                    0,
                                    33,
                                    144,
                                    2,
                                    0,
                                    178,
                                    0,
                                    32,
                                    8,
                                    224
                                ]);
                                break;
                            default:
                                if (T === 1) return new Uint8Array([
                                    1,
                                    64,
                                    34,
                                    128,
                                    163,
                                    78,
                                    230,
                                    128,
                                    186,
                                    8,
                                    0,
                                    0,
                                    0,
                                    28,
                                    6,
                                    241,
                                    193,
                                    10,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    94
                                ]);
                                if (T === 2) return new Uint8Array([
                                    1,
                                    64,
                                    34,
                                    128,
                                    163,
                                    94,
                                    230,
                                    128,
                                    186,
                                    8,
                                    0,
                                    0,
                                    0,
                                    0,
                                    149,
                                    0,
                                    6,
                                    241,
                                    161,
                                    10,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    94
                                ]);
                                if (T === 3) return new Uint8Array([
                                    1,
                                    64,
                                    34,
                                    128,
                                    163,
                                    94,
                                    230,
                                    128,
                                    186,
                                    8,
                                    0,
                                    0,
                                    0,
                                    0,
                                    149,
                                    0,
                                    6,
                                    241,
                                    161,
                                    10,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    90,
                                    94
                                ]);
                                break;
                        }
                        return null;
                    }, R;
                }(), Ft = fr;
                function pr(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var hr = Math.pow(2, 32) - 1, Br = function() {
                    function R() {
                        pr(this, R);
                    }
                    return R.init = function() {
                        R.types = {
                            avc1: [],
                            // codingname
                            avcC: [],
                            btrt: [],
                            dinf: [],
                            dref: [],
                            esds: [],
                            ftyp: [],
                            hdlr: [],
                            mdat: [],
                            mdhd: [],
                            mdia: [],
                            mfhd: [],
                            minf: [],
                            moof: [],
                            moov: [],
                            mp4a: [],
                            ".mp3": [],
                            mvex: [],
                            mvhd: [],
                            pasp: [],
                            sdtp: [],
                            stbl: [],
                            stco: [],
                            stsc: [],
                            stsd: [],
                            stsz: [],
                            stts: [],
                            tfdt: [],
                            tfhd: [],
                            traf: [],
                            trak: [],
                            trun: [],
                            trex: [],
                            tkhd: [],
                            vmhd: [],
                            smhd: []
                        };
                        var b;
                        for(b in R.types)R.types.hasOwnProperty(b) && (R.types[b] = [
                            b.charCodeAt(0),
                            b.charCodeAt(1),
                            b.charCodeAt(2),
                            b.charCodeAt(3)
                        ]);
                        var T = new Uint8Array([
                            0,
                            // version 0
                            0,
                            0,
                            0,
                            // flags
                            0,
                            0,
                            0,
                            0,
                            // pre_defined
                            118,
                            105,
                            100,
                            101,
                            // handler_type: 'vide'
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            86,
                            105,
                            100,
                            101,
                            111,
                            72,
                            97,
                            110,
                            100,
                            108,
                            101,
                            114,
                            0
                        ]), C = new Uint8Array([
                            0,
                            // version 0
                            0,
                            0,
                            0,
                            // flags
                            0,
                            0,
                            0,
                            0,
                            // pre_defined
                            115,
                            111,
                            117,
                            110,
                            // handler_type: 'soun'
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            83,
                            111,
                            117,
                            110,
                            100,
                            72,
                            97,
                            110,
                            100,
                            108,
                            101,
                            114,
                            0
                        ]);
                        R.HDLR_TYPES = {
                            video: T,
                            audio: C
                        };
                        var L = new Uint8Array([
                            0,
                            // version 0
                            0,
                            0,
                            0,
                            // flags
                            0,
                            0,
                            0,
                            1,
                            // entry_count
                            0,
                            0,
                            0,
                            12,
                            // entry_size
                            117,
                            114,
                            108,
                            32,
                            // 'url' type
                            0,
                            // version 0
                            0,
                            0,
                            1
                        ]), D = new Uint8Array([
                            0,
                            // version
                            0,
                            0,
                            0,
                            // flags
                            0,
                            0,
                            0,
                            0
                        ]);
                        R.STTS = R.STSC = R.STCO = D, R.STSZ = new Uint8Array([
                            0,
                            // version
                            0,
                            0,
                            0,
                            // flags
                            0,
                            0,
                            0,
                            0,
                            // sample_size
                            0,
                            0,
                            0,
                            0
                        ]), R.VMHD = new Uint8Array([
                            0,
                            // version
                            0,
                            0,
                            1,
                            // flags
                            0,
                            0,
                            // graphicsmode
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]), R.SMHD = new Uint8Array([
                            0,
                            // version
                            0,
                            0,
                            0,
                            // flags
                            0,
                            0,
                            // balance
                            0,
                            0
                        ]), R.STSD = new Uint8Array([
                            0,
                            // version 0
                            0,
                            0,
                            0,
                            // flags
                            0,
                            0,
                            0,
                            1
                        ]);
                        var N = new Uint8Array([
                            105,
                            115,
                            111,
                            109
                        ]), M = new Uint8Array([
                            97,
                            118,
                            99,
                            49
                        ]), z = new Uint8Array([
                            0,
                            0,
                            0,
                            1
                        ]);
                        R.FTYP = R.box(R.types.ftyp, N, z, N, M), R.DINF = R.box(R.types.dinf, R.box(R.types.dref, L));
                    }, R.box = function(b) {
                        for(var T = Array.prototype.slice.call(arguments, 1), C = 8, L = T.length, D = L, N; L--;)C += T[L].byteLength;
                        for(N = new Uint8Array(C), N[0] = C >> 24 & 255, N[1] = C >> 16 & 255, N[2] = C >> 8 & 255, N[3] = C & 255, N.set(b, 4), L = 0, C = 8; L < D; L++)N.set(T[L], C), C += T[L].byteLength;
                        return N;
                    }, R.hdlr = function(b) {
                        return R.box(R.types.hdlr, R.HDLR_TYPES[b]);
                    }, R.mdat = function(b) {
                        return R.box(R.types.mdat, b);
                    }, R.mdhd = function(b, T) {
                        T *= b;
                        var C = Math.floor(T / (hr + 1)), L = Math.floor(T % (hr + 1));
                        return R.box(R.types.mdhd, new Uint8Array([
                            1,
                            // version 1
                            0,
                            0,
                            0,
                            // flags
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            // creation_time
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            3,
                            // modification_time
                            b >> 24 & 255,
                            b >> 16 & 255,
                            b >> 8 & 255,
                            b & 255,
                            // timescale
                            C >> 24,
                            C >> 16 & 255,
                            C >> 8 & 255,
                            C & 255,
                            L >> 24,
                            L >> 16 & 255,
                            L >> 8 & 255,
                            L & 255,
                            85,
                            196,
                            // 'und' language (undetermined)
                            0,
                            0
                        ]));
                    }, R.mdia = function(b) {
                        return R.box(R.types.mdia, R.mdhd(b.timescale, b.duration), R.hdlr(b.type), R.minf(b));
                    }, R.mfhd = function(b) {
                        return R.box(R.types.mfhd, new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            // flags
                            b >> 24,
                            b >> 16 & 255,
                            b >> 8 & 255,
                            b & 255
                        ]));
                    }, R.minf = function(b) {
                        return b.type === "audio" ? R.box(R.types.minf, R.box(R.types.smhd, R.SMHD), R.DINF, R.stbl(b)) : R.box(R.types.minf, R.box(R.types.vmhd, R.VMHD), R.DINF, R.stbl(b));
                    }, R.moof = function(b, T, C) {
                        return R.box(R.types.moof, R.mfhd(b), R.traf(C, T));
                    }, R.moov = function(b) {
                        for(var T = b.length, C = []; T--;)C[T] = R.trak(b[T]);
                        return R.box.apply(null, [
                            R.types.moov,
                            R.mvhd(b[0].timescale, b[0].duration)
                        ].concat(C).concat(R.mvex(b)));
                    }, R.mvex = function(b) {
                        for(var T = b.length, C = []; T--;)C[T] = R.trex(b[T]);
                        return R.box.apply(null, [
                            R.types.mvex
                        ].concat(C));
                    }, R.mvhd = function(b, T) {
                        T *= b;
                        var C = Math.floor(T / (hr + 1)), L = Math.floor(T % (hr + 1)), D = new Uint8Array([
                            1,
                            // version 1
                            0,
                            0,
                            0,
                            // flags
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            // creation_time
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            3,
                            // modification_time
                            b >> 24 & 255,
                            b >> 16 & 255,
                            b >> 8 & 255,
                            b & 255,
                            // timescale
                            C >> 24,
                            C >> 16 & 255,
                            C >> 8 & 255,
                            C & 255,
                            L >> 24,
                            L >> 16 & 255,
                            L >> 8 & 255,
                            L & 255,
                            0,
                            1,
                            0,
                            0,
                            // 1.0 rate
                            1,
                            0,
                            // 1.0 volume
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            64,
                            0,
                            0,
                            0,
                            // transformation: unity matrix
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            // pre_defined
                            255,
                            255,
                            255,
                            255
                        ]);
                        return R.box(R.types.mvhd, D);
                    }, R.sdtp = function(b) {
                        var T = b.samples || [], C = new Uint8Array(4 + T.length), L, D;
                        for(D = 0; D < T.length; D++)L = T[D].flags, C[D + 4] = L.dependsOn << 4 | L.isDependedOn << 2 | L.hasRedundancy;
                        return R.box(R.types.sdtp, C);
                    }, R.stbl = function(b) {
                        return R.box(R.types.stbl, R.stsd(b), R.box(R.types.stts, R.STTS), R.box(R.types.stsc, R.STSC), R.box(R.types.stsz, R.STSZ), R.box(R.types.stco, R.STCO));
                    }, R.avc1 = function(b) {
                        var T = [], C = [], L, D, N;
                        for(L = 0; L < b.sps.length; L++)D = b.sps[L], N = D.byteLength, T.push(N >>> 8 & 255), T.push(N & 255), T = T.concat(Array.prototype.slice.call(D));
                        for(L = 0; L < b.pps.length; L++)D = b.pps[L], N = D.byteLength, C.push(N >>> 8 & 255), C.push(N & 255), C = C.concat(Array.prototype.slice.call(D));
                        var M = R.box(R.types.avcC, new Uint8Array([
                            1,
                            // version
                            T[3],
                            // profile
                            T[4],
                            // profile compat
                            T[5],
                            // level
                            255,
                            // lengthSizeMinusOne, hard-coded to 4 bytes
                            224 | b.sps.length
                        ].concat(T).concat([
                            b.pps.length
                        ]).concat(C))), z = b.width, J = b.height, H = b.pixelRatio[0], ie = b.pixelRatio[1];
                        return R.box(R.types.avc1, new Uint8Array([
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            1,
                            // data_reference_index
                            0,
                            0,
                            // pre_defined
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            // pre_defined
                            z >> 8 & 255,
                            z & 255,
                            // width
                            J >> 8 & 255,
                            J & 255,
                            // height
                            0,
                            72,
                            0,
                            0,
                            // horizresolution
                            0,
                            72,
                            0,
                            0,
                            // vertresolution
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            1,
                            // frame_count
                            18,
                            100,
                            97,
                            105,
                            108,
                            //dailymotion/hls.js
                            121,
                            109,
                            111,
                            116,
                            105,
                            111,
                            110,
                            47,
                            104,
                            108,
                            115,
                            46,
                            106,
                            115,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            // compressorname
                            0,
                            24,
                            // depth = 24
                            17,
                            17
                        ]), // pre_defined = -1
                        M, R.box(R.types.btrt, new Uint8Array([
                            0,
                            28,
                            156,
                            128,
                            // bufferSizeDB
                            0,
                            45,
                            198,
                            192,
                            // maxBitrate
                            0,
                            45,
                            198,
                            192
                        ])), // avgBitrate
                        R.box(R.types.pasp, new Uint8Array([
                            H >> 24,
                            // hSpacing
                            H >> 16 & 255,
                            H >> 8 & 255,
                            H & 255,
                            ie >> 24,
                            // vSpacing
                            ie >> 16 & 255,
                            ie >> 8 & 255,
                            ie & 255
                        ])));
                    }, R.esds = function(b) {
                        var T = b.config.length;
                        return new Uint8Array([
                            0,
                            // version 0
                            0,
                            0,
                            0,
                            // flags
                            3,
                            // descriptor_type
                            23 + T,
                            // length
                            0,
                            1,
                            //es_id
                            0,
                            // stream_priority
                            4,
                            // descriptor_type
                            15 + T,
                            // length
                            64,
                            //codec : mpeg4_audio
                            21,
                            // stream_type
                            0,
                            0,
                            0,
                            // buffer_size
                            0,
                            0,
                            0,
                            0,
                            // maxBitrate
                            0,
                            0,
                            0,
                            0,
                            // avgBitrate
                            5
                        ].concat([
                            T
                        ]).concat(b.config).concat([
                            6,
                            1,
                            2
                        ]));
                    }, R.mp4a = function(b) {
                        var T = b.samplerate;
                        return R.box(R.types.mp4a, new Uint8Array([
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            1,
                            // data_reference_index
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            b.channelCount,
                            // channelcount
                            0,
                            16,
                            // sampleSize:16bits
                            0,
                            0,
                            0,
                            0,
                            // reserved2
                            T >> 8 & 255,
                            T & 255,
                            //
                            0,
                            0
                        ]), R.box(R.types.esds, R.esds(b)));
                    }, R.mp3 = function(b) {
                        var T = b.samplerate;
                        return R.box(R.types[".mp3"], new Uint8Array([
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            1,
                            // data_reference_index
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            b.channelCount,
                            // channelcount
                            0,
                            16,
                            // sampleSize:16bits
                            0,
                            0,
                            0,
                            0,
                            // reserved2
                            T >> 8 & 255,
                            T & 255,
                            //
                            0,
                            0
                        ]));
                    }, R.stsd = function(b) {
                        return b.type === "audio" ? !b.isAAC && b.codec === "mp3" ? R.box(R.types.stsd, R.STSD, R.mp3(b)) : R.box(R.types.stsd, R.STSD, R.mp4a(b)) : R.box(R.types.stsd, R.STSD, R.avc1(b));
                    }, R.tkhd = function(b) {
                        var T = b.id, C = b.duration * b.timescale, L = b.width, D = b.height, N = Math.floor(C / (hr + 1)), M = Math.floor(C % (hr + 1));
                        return R.box(R.types.tkhd, new Uint8Array([
                            1,
                            // version 1
                            0,
                            0,
                            7,
                            // flags
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            // creation_time
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            3,
                            // modification_time
                            T >> 24 & 255,
                            T >> 16 & 255,
                            T >> 8 & 255,
                            T & 255,
                            // track_ID
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            N >> 24,
                            N >> 16 & 255,
                            N >> 8 & 255,
                            N & 255,
                            M >> 24,
                            M >> 16 & 255,
                            M >> 8 & 255,
                            M & 255,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            // reserved
                            0,
                            0,
                            // layer
                            0,
                            0,
                            // alternate_group
                            0,
                            0,
                            // non-audio track volume
                            0,
                            0,
                            // reserved
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            64,
                            0,
                            0,
                            0,
                            // transformation: unity matrix
                            L >> 8 & 255,
                            L & 255,
                            0,
                            0,
                            // width
                            D >> 8 & 255,
                            D & 255,
                            0,
                            0
                        ]));
                    }, R.traf = function(b, T) {
                        var C = R.sdtp(b), L = b.id, D = Math.floor(T / (hr + 1)), N = Math.floor(T % (hr + 1));
                        return R.box(R.types.traf, R.box(R.types.tfhd, new Uint8Array([
                            0,
                            // version 0
                            0,
                            0,
                            0,
                            // flags
                            L >> 24,
                            L >> 16 & 255,
                            L >> 8 & 255,
                            L & 255
                        ])), R.box(R.types.tfdt, new Uint8Array([
                            1,
                            // version 1
                            0,
                            0,
                            0,
                            // flags
                            D >> 24,
                            D >> 16 & 255,
                            D >> 8 & 255,
                            D & 255,
                            N >> 24,
                            N >> 16 & 255,
                            N >> 8 & 255,
                            N & 255
                        ])), R.trun(b, C.length + 16 + // tfhd
                        20 + // tfdt
                        8 + // traf header
                        16 + // mfhd
                        8 + // moof header
                        8), // mdat header
                        C);
                    }, R.trak = function(b) {
                        return b.duration = b.duration || 4294967295, R.box(R.types.trak, R.tkhd(b), R.mdia(b));
                    }, R.trex = function(b) {
                        var T = b.id;
                        return R.box(R.types.trex, new Uint8Array([
                            0,
                            // version 0
                            0,
                            0,
                            0,
                            // flags
                            T >> 24,
                            T >> 16 & 255,
                            T >> 8 & 255,
                            T & 255,
                            // track_ID
                            0,
                            0,
                            0,
                            1,
                            // default_sample_description_index
                            0,
                            0,
                            0,
                            0,
                            // default_sample_duration
                            0,
                            0,
                            0,
                            0,
                            // default_sample_size
                            0,
                            1,
                            0,
                            1
                        ]));
                    }, R.trun = function(b, T) {
                        var C = b.samples || [], L = C.length, D = 12 + 16 * L, N = new Uint8Array(D), M, z, J, H, ie, te;
                        for(T += 8 + D, N.set([
                            0,
                            // version 0
                            0,
                            15,
                            1,
                            // flags
                            L >>> 24 & 255,
                            L >>> 16 & 255,
                            L >>> 8 & 255,
                            L & 255,
                            // sample_count
                            T >>> 24 & 255,
                            T >>> 16 & 255,
                            T >>> 8 & 255,
                            T & 255
                        ], 0), M = 0; M < L; M++)z = C[M], J = z.duration, H = z.size, ie = z.flags, te = z.cts, N.set([
                            J >>> 24 & 255,
                            J >>> 16 & 255,
                            J >>> 8 & 255,
                            J & 255,
                            // sample_duration
                            H >>> 24 & 255,
                            H >>> 16 & 255,
                            H >>> 8 & 255,
                            H & 255,
                            // sample_size
                            ie.isLeading << 2 | ie.dependsOn,
                            ie.isDependedOn << 6 | ie.hasRedundancy << 4 | ie.paddingValue << 1 | ie.isNonSync,
                            ie.degradPrio & 61440,
                            ie.degradPrio & 15,
                            // sample_flags
                            te >>> 24 & 255,
                            te >>> 16 & 255,
                            te >>> 8 & 255,
                            te & 255
                        ], 12 + 16 * M);
                        return R.box(R.types.trun, N);
                    }, R.initSegment = function(b) {
                        R.types || R.init();
                        var T = R.moov(b), C;
                        return C = new Uint8Array(R.FTYP.byteLength + T.byteLength), C.set(R.FTYP), C.set(T, R.FTYP.byteLength), C;
                    }, R;
                }(), kr = Br;
                function ht(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var Ct = 10000, Sn = function() {
                    function R(I, b, T, C) {
                        ht(this, R), this.observer = I, this.config = b, this.typeSupported = T;
                        var L = navigator.userAgent;
                        this.isSafari = C && C.indexOf("Apple") > -1 && L && !L.match("CriOS"), this.ISGenerated = !1;
                    }
                    return R.prototype.destroy = function() {}, R.prototype.resetTimeStamp = function(b) {
                        this._initPTS = this._initDTS = b;
                    }, R.prototype.resetInitSegment = function() {
                        this.ISGenerated = !1;
                    }, R.prototype.remux = function(b, T, C, L, D, N, M) {
                        if (this.ISGenerated || this.generateIS(b, T, D), this.ISGenerated) {
                            var z = b.samples.length, J = T.samples.length, H = D, ie = D;
                            if (z && J) {
                                var te = (b.samples[0].dts - T.samples[0].dts) / T.inputTimeScale;
                                H += Math.max(0, te), ie += Math.max(0, -te);
                            }
                            if (z) {
                                b.timescale || (p.b.warn("regenerate InitSegment as audio detected"), this.generateIS(b, T, D));
                                var pe = this.remuxAudio(b, H, N, M);
                                if (J) {
                                    var le = void 0;
                                    pe && (le = pe.endPTS - pe.startPTS), T.timescale || (p.b.warn("regenerate InitSegment as video detected"), this.generateIS(b, T, D)), this.remuxVideo(T, ie, N, le, M);
                                }
                            } else {
                                var ue = void 0;
                                J && (ue = this.remuxVideo(T, ie, N, M)), ue && b.codec && this.remuxEmptyAudio(b, H, N, ue);
                            }
                        }
                        C.samples.length && this.remuxID3(C, D), L.samples.length && this.remuxText(L, D), this.observer.trigger(c.a.FRAG_PARSED);
                    }, R.prototype.generateIS = function(b, T, C) {
                        var L = this.observer, D = b.samples, N = T.samples, M = this.typeSupported, z = "audio/mp4", J = {}, H = {
                            tracks: J
                        }, ie = this._initPTS === void 0, te, pe;
                        if (ie && (te = pe = 1 / 0), b.config && D.length && (b.timescale = b.samplerate, p.b.log("audio sampling rate : " + b.samplerate), b.isAAC || (M.mpeg ? (z = "audio/mpeg", b.codec = "") : M.mp3 && (b.codec = "mp3")), J.audio = {
                            container: z,
                            codec: b.codec,
                            initSegment: !b.isAAC && M.mpeg ? new Uint8Array() : kr.initSegment([
                                b
                            ]),
                            metadata: {
                                channelCount: b.channelCount
                            }
                        }, ie && (te = pe = D[0].pts - b.inputTimeScale * C)), T.sps && T.pps && N.length) {
                            var le = T.inputTimeScale;
                            T.timescale = le, J.video = {
                                container: "video/mp4",
                                codec: T.codec,
                                initSegment: kr.initSegment([
                                    T
                                ]),
                                metadata: {
                                    width: T.width,
                                    height: T.height
                                }
                            }, ie && (te = Math.min(te, N[0].pts - le * C), pe = Math.min(pe, N[0].dts - le * C), this.observer.trigger(c.a.INIT_PTS_FOUND, {
                                initPTS: te
                            }));
                        }
                        Object.keys(J).length ? (L.trigger(c.a.FRAG_PARSING_INIT_SEGMENT, H), this.ISGenerated = !0, ie && (this._initPTS = te, this._initDTS = pe)) : L.trigger(c.a.ERROR, {
                            type: h.b.MEDIA_ERROR,
                            details: h.a.FRAG_PARSING_ERROR,
                            fatal: !1,
                            reason: "no audio/video samples found"
                        });
                    }, R.prototype.remuxVideo = function(b, T, C, L, D) {
                        var N = 8, M = b.timescale, z, J, H, ie, te, pe, le, ue = b.samples, Q = [], Ue = ue.length, rt = this._PTSNormalize, it = this._initDTS, qe = this.nextAvcDts, Je = this.isSafari;
                        Je && (C |= ue.length && qe && (D && Math.abs(T - qe / M) < 0.1 || Math.abs(ue[0].pts - qe - it) < M / 5)), C || (qe = T * M), ue.forEach(function(gr) {
                            gr.pts = rt(gr.pts - it, qe), gr.dts = rt(gr.dts - it, qe);
                        }), ue.sort(function(gr, nn) {
                            var zl = gr.dts - nn.dts, Xl = gr.pts - nn.pts;
                            return zl || Xl || gr.id - nn.id;
                        });
                        var Te = ue.reduce(function(gr, nn) {
                            return Math.max(Math.min(gr, nn.pts - nn.dts), -18000);
                        }, 0);
                        if (Te < 0) {
                            p.b.warn("PTS < DTS detected in video samples, shifting DTS by " + Math.round(Te / 90) + " ms to overcome this issue");
                            for(var at = 0; at < ue.length; at++)ue[at].dts += Te;
                        }
                        var _t = ue[0];
                        te = Math.max(_t.dts, 0), ie = Math.max(_t.pts, 0);
                        var nt = Math.round((te - qe) / 90);
                        C && nt && (nt > 1 ? p.b.log("AVC:" + nt + " ms hole between fragments detected,filling it") : nt < -1 && p.b.log("AVC:" + -nt + " ms overlapping between fragments detected"), te = qe, ue[0].dts = te, ie = Math.max(ie - nt, qe), ue[0].pts = ie, p.b.log("Video/PTS/DTS adjusted: " + Math.round(ie / 90) + "/" + Math.round(te / 90) + ",delta:" + nt + " ms")), _t = ue[ue.length - 1], le = Math.max(_t.dts, 0), pe = Math.max(_t.pts, 0, le), Je && (z = Math.round((le - te) / (ue.length - 1)));
                        for(var At = 0, Lt = 0, ir = 0; ir < Ue; ir++){
                            for(var It = ue[ir], br = It.units, Xt = br.length, nr = 0, _i = 0; _i < Xt; _i++)nr += br[_i].data.length;
                            Lt += nr, At += Xt, It.length = nr, Je ? It.dts = te + ir * z : It.dts = Math.max(It.dts, te), It.pts = Math.max(It.pts, It.dts);
                        }
                        var wi = Lt + 4 * At + 8;
                        try {
                            J = new Uint8Array(wi);
                        } catch  {
                            this.observer.trigger(c.a.ERROR, {
                                type: h.b.MUX_ERROR,
                                details: h.a.REMUX_ALLOC_ERROR,
                                fatal: !1,
                                bytes: wi,
                                reason: "fail allocating video mdat " + wi
                            });
                            return;
                        }
                        var Cn = new DataView(J.buffer);
                        Cn.setUint32(0, wi), J.set(kr.types.mdat, 4);
                        for(var Ht = 0; Ht < Ue; Ht++){
                            for(var wt = ue[Ht], Ir = wt.units, Ti = 0, Hr = void 0, Ln = 0, cs = Ir.length; Ln < cs; Ln++){
                                var kn = Ir[Ln], Dn = kn.data, Zr = kn.data.byteLength;
                                Cn.setUint32(N, Zr), N += 4, J.set(Dn, N), N += Zr, Ti += 4 + Zr;
                            }
                            if (Je) Hr = Math.max(0, z * Math.round((wt.pts - wt.dts) / z));
                            else {
                                if (Ht < Ue - 1) z = ue[Ht + 1].dts - wt.dts;
                                else {
                                    var rn = this.config, Si = wt.dts - ue[Ht > 0 ? Ht - 1 : Ht].dts;
                                    if (rn.stretchShortVideoTrack) {
                                        var ds = rn.maxBufferHole, Wr = rn.maxSeekHole, Qu = Math.floor(Math.min(ds, Wr) * M), Ys = (L ? ie + L * M : this.nextAudioPts) - wt.pts;
                                        Ys > Qu ? (z = Ys - Si, z < 0 && (z = Si), p.b.log("It is approximately " + Ys / 90 + " ms to the next segment; using duration " + z / 90 + " ms for the last video frame.")) : z = Si;
                                    } else z = Si;
                                }
                                Hr = Math.round(wt.pts - wt.dts);
                            }
                            Q.push({
                                size: Ti,
                                // constant duration
                                duration: z,
                                cts: Hr,
                                flags: {
                                    isLeading: 0,
                                    isDependedOn: 0,
                                    hasRedundancy: 0,
                                    degradPrio: 0,
                                    dependsOn: wt.key ? 2 : 1,
                                    isNonSync: wt.key ? 0 : 1
                                }
                            });
                        }
                        this.nextAvcDts = le + z;
                        var ec = b.dropped;
                        if (b.len = 0, b.nbNalu = 0, b.dropped = 0, Q.length && navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
                            var Gl = Q[0].flags;
                            Gl.dependsOn = 2, Gl.isNonSync = 0;
                        }
                        b.samples = Q, H = kr.moof(b.sequenceNumber++, te, b), b.samples = [];
                        var ql = {
                            data1: H,
                            data2: J,
                            startPTS: ie / M,
                            endPTS: (pe + z) / M,
                            startDTS: te / M,
                            endDTS: this.nextAvcDts / M,
                            type: "video",
                            nb: Q.length,
                            dropped: ec
                        };
                        return this.observer.trigger(c.a.FRAG_PARSING_DATA, ql), ql;
                    }, R.prototype.remuxAudio = function(b, T, C, L) {
                        var D = b.inputTimeScale, N = b.timescale, M = D / N, z = b.isAAC ? 1024 : 1152, J = z * M, H = this._PTSNormalize, ie = this._initDTS, te = !b.isAAC && this.typeSupported.mpeg, pe, le, ue, Q, Ue, rt, it, qe = b.samples, Je = [], Te = this.nextAudioPts;
                        if (C |= qe.length && Te && (L && Math.abs(T - Te / D) < 0.1 || Math.abs(qe[0].pts - Te - ie) < 20 * J), qe.forEach(function(Wr) {
                            Wr.pts = Wr.dts = H(Wr.pts - ie, T * D);
                        }), qe = qe.filter(function(Wr) {
                            return Wr.pts >= 0;
                        }), qe.length !== 0) {
                            if (C || (L ? Te = T * D : Te = qe[0].pts), b.isAAC) for(var at = this.config.maxAudioFramesDrift, _t = 0, nt = Te; _t < qe.length;){
                                var At = qe[_t], Lt, ir = At.pts;
                                Lt = ir - nt;
                                var It = Math.abs(1e3 * Lt / D);
                                if (Lt <= -at * J) p.b.warn("Dropping 1 audio frame @ " + (nt / D).toFixed(3) + "s due to " + Math.round(It) + " ms overlap."), qe.splice(_t, 1), b.len -= At.unit.length;
                                else if (Lt >= at * J && It < Ct && nt) {
                                    var br = Math.round(Lt / J);
                                    p.b.warn("Injecting " + br + " audio frame @ " + (nt / D).toFixed(3) + "s due to " + Math.round(1e3 * Lt / D) + " ms gap.");
                                    for(var Xt = 0; Xt < br; Xt++){
                                        var nr = Math.max(nt, 0);
                                        ue = Ft.getSilentFrame(b.manifestCodec || b.codec, b.channelCount), ue || (p.b.log("Unable to get silent frame for given audio codec; duplicating last frame instead."), ue = At.unit.subarray()), qe.splice(_t, 0, {
                                            unit: ue,
                                            pts: nr,
                                            dts: nr
                                        }), b.len += ue.length, nt += J, _t++;
                                    }
                                    At.pts = At.dts = nt, nt += J, _t++;
                                } else At.pts = At.dts = nt, nt += J, _t++;
                            }
                            for(var _i = 0, wi = qe.length; _i < wi; _i++){
                                var Cn = qe[_i], Ht = Cn.unit, wt = Cn.pts;
                                if (it !== void 0) le.duration = Math.round((wt - it) / M);
                                else {
                                    var Ir = Math.round(1e3 * (wt - Te) / D), Ti = 0;
                                    if (C && b.isAAC && Ir) {
                                        if (Ir > 0 && Ir < Ct) Ti = Math.round((wt - Te) / J), p.b.log(Ir + " ms hole between AAC samples detected,filling it"), Ti > 0 && (ue = Ft.getSilentFrame(b.manifestCodec || b.codec, b.channelCount), ue || (ue = Ht.subarray()), b.len += Ti * ue.length);
                                        else if (Ir < -12) {
                                            p.b.log("drop overlapping AAC sample, expected/parsed/delta:" + (Te / D).toFixed(3) + "s/" + (wt / D).toFixed(3) + "s/" + -Ir + "ms"), b.len -= Ht.byteLength;
                                            continue;
                                        }
                                        wt = Te;
                                    }
                                    if (rt = wt, b.len > 0) {
                                        var Hr = te ? b.len : b.len + 8;
                                        pe = te ? 0 : 8;
                                        try {
                                            Q = new Uint8Array(Hr);
                                        } catch  {
                                            this.observer.trigger(c.a.ERROR, {
                                                type: h.b.MUX_ERROR,
                                                details: h.a.REMUX_ALLOC_ERROR,
                                                fatal: !1,
                                                bytes: Hr,
                                                reason: "fail allocating audio mdat " + Hr
                                            });
                                            return;
                                        }
                                        if (!te) {
                                            var Ln = new DataView(Q.buffer);
                                            Ln.setUint32(0, Hr), Q.set(kr.types.mdat, 4);
                                        }
                                    } else return;
                                    for(var cs = 0; cs < Ti; cs++)ue = Ft.getSilentFrame(b.manifestCodec || b.codec, b.channelCount), ue || (p.b.log("Unable to get silent frame for given audio codec; duplicating this frame instead."), ue = Ht.subarray()), Q.set(ue, pe), pe += ue.byteLength, le = {
                                        size: ue.byteLength,
                                        cts: 0,
                                        duration: 1024,
                                        flags: {
                                            isLeading: 0,
                                            isDependedOn: 0,
                                            hasRedundancy: 0,
                                            degradPrio: 0,
                                            dependsOn: 1
                                        }
                                    }, Je.push(le);
                                }
                                Q.set(Ht, pe);
                                var kn = Ht.byteLength;
                                pe += kn, le = {
                                    size: kn,
                                    cts: 0,
                                    duration: 0,
                                    flags: {
                                        isLeading: 0,
                                        isDependedOn: 0,
                                        hasRedundancy: 0,
                                        degradPrio: 0,
                                        dependsOn: 1
                                    }
                                }, Je.push(le), it = wt;
                            }
                            var Dn = 0, Zr = Je.length;
                            if (Zr >= 2 && (Dn = Je[Zr - 2].duration, le.duration = Dn), Zr) {
                                this.nextAudioPts = Te = it + M * Dn, b.len = 0, b.samples = Je, te ? Ue = new Uint8Array() : Ue = kr.moof(b.sequenceNumber++, rt / M, b), b.samples = [];
                                var rn = rt / D, Si = Te / D, ds = {
                                    data1: Ue,
                                    data2: Q,
                                    startPTS: rn,
                                    endPTS: Si,
                                    startDTS: rn,
                                    endDTS: Si,
                                    type: "audio",
                                    nb: Zr
                                };
                                return this.observer.trigger(c.a.FRAG_PARSING_DATA, ds), ds;
                            }
                            return null;
                        }
                    }, R.prototype.remuxEmptyAudio = function(b, T, C, L) {
                        var D = b.inputTimeScale, N = b.samplerate ? b.samplerate : D, M = D / N, z = this.nextAudioPts, J = (z !== void 0 ? z : L.startDTS * D) + this._initDTS, H = L.endDTS * D + this._initDTS, ie = 1024, te = M * ie, pe = Math.ceil((H - J) / te), le = Ft.getSilentFrame(b.manifestCodec || b.codec, b.channelCount);
                        if (p.b.warn("remux empty Audio"), !le) {
                            p.b.trace("Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!");
                            return;
                        }
                        for(var ue = [], Q = 0; Q < pe; Q++){
                            var Ue = J + Q * te;
                            ue.push({
                                unit: le,
                                pts: Ue,
                                dts: Ue
                            }), b.len += le.length;
                        }
                        b.samples = ue, this.remuxAudio(b, T, C);
                    }, R.prototype.remuxID3 = function(b, T) {
                        var C = b.samples.length, L, D = b.inputTimeScale, N = this._initPTS, M = this._initDTS;
                        if (C) {
                            for(var z = 0; z < C; z++)L = b.samples[z], L.pts = (L.pts - N) / D, L.dts = (L.dts - M) / D;
                            this.observer.trigger(c.a.FRAG_PARSING_METADATA, {
                                samples: b.samples
                            });
                        }
                        b.samples = [];
                    }, R.prototype.remuxText = function(b, T) {
                        b.samples.sort(function(z, J) {
                            return z.pts - J.pts;
                        });
                        var C = b.samples.length, L, D = b.inputTimeScale, N = this._initPTS;
                        if (C) {
                            for(var M = 0; M < C; M++)L = b.samples[M], L.pts = (L.pts - N) / D;
                            this.observer.trigger(c.a.FRAG_PARSING_USERDATA, {
                                samples: b.samples
                            });
                        }
                        b.samples = [];
                    }, R.prototype._PTSNormalize = function(b, T) {
                        var C;
                        if (T === void 0) return b;
                        for(T < b ? C = -8589934592 : C = 8589934592; Math.abs(b - T) > 4294967296;)b += C;
                        return b;
                    }, R;
                }(), rr = Sn;
                function Wu(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var Yu = function() {
                    function R(I) {
                        Wu(this, R), this.observer = I;
                    }
                    return R.prototype.destroy = function() {}, R.prototype.resetTimeStamp = function() {}, R.prototype.resetInitSegment = function() {}, R.prototype.remux = function(b, T, C, L, D, N, M, z) {
                        var J = this.observer, H = "";
                        b && (H += "audio"), T && (H += "video"), J.trigger(c.a.FRAG_PARSING_DATA, {
                            data1: z,
                            startPTS: D,
                            startDTS: D,
                            type: H,
                            nb: 1,
                            dropped: 0
                        }), J.trigger(c.a.FRAG_PARSED);
                    }, R;
                }(), Zs = Yu;
                function Ju(R, I) {
                    if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
                }
                var Ws = function() {
                    function R(I, b, T, C) {
                        Ju(this, R), this.observer = I, this.typeSupported = b, this.config = T, this.vendor = C;
                    }
                    return R.prototype.destroy = function() {
                        var b = this.demuxer;
                        b && b.destroy();
                    }, R.prototype.push = function(b, T, C, L, D, N, M, z, J, H, ie, te) {
                        if (b.byteLength > 0 && T != null && T.key != null && T.method === "AES-128") {
                            var pe = this.decrypter;
                            pe == null && (pe = this.decrypter = new m.a(this.observer, this.config));
                            var le = this, ue;
                            try {
                                ue = performance.now();
                            } catch  {
                                ue = Date.now();
                            }
                            pe.decrypt(b, T.key.buffer, T.iv.buffer, function(Q) {
                                var Ue;
                                try {
                                    Ue = performance.now();
                                } catch  {
                                    Ue = Date.now();
                                }
                                le.observer.trigger(c.a.FRAG_DECRYPTED, {
                                    stats: {
                                        tstart: ue,
                                        tdecrypt: Ue
                                    }
                                }), le.pushDecrypted(new Uint8Array(Q), T, new Uint8Array(C), L, D, N, M, z, J, H, ie, te);
                            });
                        } else this.pushDecrypted(new Uint8Array(b), T, new Uint8Array(C), L, D, N, M, z, J, H, ie, te);
                    }, R.prototype.pushDecrypted = function(b, T, C, L, D, N, M, z, J, H, ie, te) {
                        var pe = this.demuxer;
                        if (!pe || // in case of continuity change, we might switch from content type (AAC container to TS container for example)
                        // so let's check that current demuxer is still valid
                        M && !this.probe(b)) {
                            for(var le = this.observer, ue = this.typeSupported, Q = this.config, Ue = [
                                {
                                    demux: He,
                                    remux: rr
                                },
                                {
                                    demux: Be,
                                    remux: Zs
                                },
                                {
                                    demux: fe,
                                    remux: rr
                                },
                                {
                                    demux: tn,
                                    remux: rr
                                }
                            ], rt = 0, it = Ue.length; rt < it; rt++){
                                var qe = Ue[rt], Je = qe.demux.probe;
                                if (Je(b)) {
                                    var Te = this.remuxer = new qe.remux(le, Q, ue, this.vendor);
                                    pe = new qe.demux(le, Te, Q, ue), this.probe = Je;
                                    break;
                                }
                            }
                            if (!pe) {
                                le.trigger(c.a.ERROR, {
                                    type: h.b.MEDIA_ERROR,
                                    details: h.a.FRAG_PARSING_ERROR,
                                    fatal: !0,
                                    reason: "no demux matching with content found"
                                });
                                return;
                            }
                            this.demuxer = pe;
                        }
                        var at = this.remuxer;
                        (M || z) && (pe.resetInitSegment(C, L, D, H), at.resetInitSegment()), M && (pe.resetTimeStamp(te), at.resetTimeStamp(te)), typeof pe.setDecryptData == "function" && pe.setDecryptData(T), pe.append(b, N, J, ie);
                    }, R;
                }();
                i.a = Ws;
            },
            /* 8 */ /***/ function(r, i, a) {
                Object.defineProperty(i, "__esModule", {
                    value: !0
                });
                var c = {};
                a.d(c, "newCue", function() {
                    return by;
                });
                var h = a(6), m = /* @__PURE__ */ a.n(h), p = a(1), y = a(2), d = a(0), v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(g) {
                    return typeof g;
                } : function(g) {
                    return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
                };
                function P(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var K = function() {
                    function g(o) {
                        P(this, g), this.hls = o, this.onEvent = this.onEvent.bind(this);
                        for(var l = arguments.length, s = Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)s[u - 1] = arguments[u];
                        this.handledEvents = s, this.useGenericHandler = !0, this.registerListeners();
                    }
                    return g.prototype.destroy = function() {
                        this.unregisterListeners();
                    }, g.prototype.isEventHandler = function() {
                        return v(this.handledEvents) === "object" && this.handledEvents.length && typeof this.onEvent == "function";
                    }, g.prototype.registerListeners = function() {
                        this.isEventHandler() && this.handledEvents.forEach(function(l) {
                            if (l === "hlsEventGeneric") throw new Error("Forbidden event name: " + l);
                            this.hls.on(l, this.onEvent);
                        }, this);
                    }, g.prototype.unregisterListeners = function() {
                        this.isEventHandler() && this.handledEvents.forEach(function(l) {
                            this.hls.off(l, this.onEvent);
                        }, this);
                    }, g.prototype.onEvent = function(l, s) {
                        this.onEventGeneric(l, s);
                    }, g.prototype.onEventGeneric = function(l, s) {
                        var u = function(E, w) {
                            var A = "on" + E.replace("hls", "");
                            if (typeof this[A] != "function") throw new Error("Event " + E + " has no generic handler in this " + this.constructor.name + " class (tried " + A + ")");
                            return this[A].bind(this, w);
                        };
                        try {
                            u.call(this, l, s).call();
                        } catch (f) {
                            d.b.error("internal error happened while processing " + l + ":" + f.message), this.hls.trigger(p.a.ERROR, {
                                type: y.b.OTHER_ERROR,
                                details: y.a.INTERNAL_EXCEPTION,
                                fatal: !1,
                                event: l,
                                err: f
                            });
                        }
                    }, g;
                }(), O = K;
                function Z(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var Y = /^(\d+)x(\d+)$/, X = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g, V = function() {
                    function g(o) {
                        Z(this, g), typeof o == "string" && (o = g.parseAttrList(o));
                        for(var l in o)o.hasOwnProperty(l) && (this[l] = o[l]);
                    }
                    return g.prototype.decimalInteger = function(l) {
                        var s = parseInt(this[l], 10);
                        return s > Number.MAX_SAFE_INTEGER ? 1 / 0 : s;
                    }, g.prototype.hexadecimalInteger = function(l) {
                        if (this[l]) {
                            var s = (this[l] || "0x").slice(2);
                            s = (s.length & 1 ? "0" : "") + s;
                            for(var u = new Uint8Array(s.length / 2), f = 0; f < s.length / 2; f++)u[f] = parseInt(s.slice(f * 2, f * 2 + 2), 16);
                            return u;
                        } else return null;
                    }, g.prototype.hexadecimalIntegerAsNumber = function(l) {
                        var s = parseInt(this[l], 16);
                        return s > Number.MAX_SAFE_INTEGER ? 1 / 0 : s;
                    }, g.prototype.decimalFloatingPoint = function(l) {
                        return parseFloat(this[l]);
                    }, g.prototype.enumeratedString = function(l) {
                        return this[l];
                    }, g.prototype.decimalResolution = function(l) {
                        var s = Y.exec(this[l]);
                        if (s !== null) return {
                            width: parseInt(s[1], 10),
                            height: parseInt(s[2], 10)
                        };
                    }, g.parseAttrList = function(l) {
                        var s, u = {};
                        for(X.lastIndex = 0; (s = X.exec(l)) !== null;){
                            var f = s[2], E = '"';
                            f.indexOf(E) === 0 && f.lastIndexOf(E) === f.length - 1 && (f = f.slice(1, -1)), u[s[1]] = f;
                        }
                        return u;
                    }, g;
                }(), q = V, re = {
                    audio: {
                        a3ds: !0,
                        "ac-3": !0,
                        "ac-4": !0,
                        alac: !0,
                        alaw: !0,
                        dra1: !0,
                        "dts+": !0,
                        "dts-": !0,
                        dtsc: !0,
                        dtse: !0,
                        dtsh: !0,
                        "ec-3": !0,
                        enca: !0,
                        g719: !0,
                        g726: !0,
                        m4ae: !0,
                        mha1: !0,
                        mha2: !0,
                        mhm1: !0,
                        mhm2: !0,
                        mlpa: !0,
                        mp4a: !0,
                        "raw ": !0,
                        Opus: !0,
                        samr: !0,
                        sawb: !0,
                        sawp: !0,
                        sevc: !0,
                        sqcp: !0,
                        ssmv: !0,
                        twos: !0,
                        ulaw: !0
                    },
                    video: {
                        avc1: !0,
                        avc2: !0,
                        avc3: !0,
                        avc4: !0,
                        avcp: !0,
                        drac: !0,
                        dvav: !0,
                        dvhe: !0,
                        encv: !0,
                        hev1: !0,
                        hvc1: !0,
                        mjp2: !0,
                        mp4v: !0,
                        mvc1: !0,
                        mvc2: !0,
                        mvc3: !0,
                        mvc4: !0,
                        resv: !0,
                        rv60: !0,
                        s263: !0,
                        svc1: !0,
                        svc2: !0,
                        "vc-1": !0,
                        vp08: !0,
                        vp09: !0
                    }
                };
                function ne(g, o) {
                    var l = re[o];
                    return !!l && l[g.slice(0, 4)] === !0;
                }
                function fe(g, o) {
                    return MediaSource.isTypeSupported((o || "video") + '/mp4;codecs="' + g + '"');
                }
                var ye = /* @__PURE__ */ function() {
                    function g(o, l) {
                        for(var s = 0; s < l.length; s++){
                            var u = l[s];
                            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
                        }
                    }
                    return function(o, l, s) {
                        return l && g(o.prototype, l), s && g(o, s), o;
                    };
                }();
                function xe(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function De(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                function Be(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var Oe = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g, we = /#EXT-X-MEDIA:(.*)/g, Fe = new RegExp([
                    /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
                    // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
                    /|(?!#)(\S+)/.source,
                    // segment URI, group 3 => the URI (note newline is not eaten)
                    /|#EXT-X-BYTERANGE:*(.+)/.source,
                    // next segment's byterange, group 4 => range spec (x@y)
                    /|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
                    // next segment's program date/time group 5 => the datetime spec
                    /|#.*/.source
                ].join(""), "g"), Xe = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)(.*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/, ct = function() {
                    function g() {
                        Be(this, g), this.method = null, this.key = null, this.iv = null, this._uri = null;
                    }
                    return ye(g, [
                        {
                            key: "uri",
                            get: function() {
                                return !this._uri && this.reluri && (this._uri = m.a.buildAbsoluteURL(this.baseuri, this.reluri, {
                                    alwaysNormalize: !0
                                })), this._uri;
                            }
                        }
                    ]), g;
                }(), Ge = function() {
                    function g() {
                        Be(this, g), this._url = null, this._byteRange = null, this._decryptdata = null, this.tagList = [];
                    }
                    return g.prototype.createInitializationVector = function(l) {
                        for(var s = new Uint8Array(16), u = 12; u < 16; u++)s[u] = l >> 8 * (15 - u) & 255;
                        return s;
                    }, g.prototype.fragmentDecryptdataFromLevelkey = function(l, s) {
                        var u = l;
                        return l && l.method && l.uri && !l.iv && (u = new ct(), u.method = l.method, u.baseuri = l.baseuri, u.reluri = l.reluri, u.iv = this.createInitializationVector(s)), u;
                    }, g.prototype.cloneObj = function(l) {
                        return JSON.parse(JSON.stringify(l));
                    }, ye(g, [
                        {
                            key: "url",
                            get: function() {
                                return !this._url && this.relurl && (this._url = m.a.buildAbsoluteURL(this.baseurl, this.relurl, {
                                    alwaysNormalize: !0
                                })), this._url;
                            },
                            set: function(l) {
                                this._url = l;
                            }
                        },
                        {
                            key: "programDateTime",
                            get: function() {
                                return !this._programDateTime && this.rawProgramDateTime && (this._programDateTime = new Date(Date.parse(this.rawProgramDateTime))), this._programDateTime;
                            }
                        },
                        {
                            key: "byteRange",
                            get: function() {
                                if (!this._byteRange) {
                                    var l = this._byteRange = [];
                                    if (this.rawByteRange) {
                                        var s = this.rawByteRange.split("@", 2);
                                        if (s.length === 1) {
                                            var u = this.lastByteRangeEndOffset;
                                            l[0] = u || 0;
                                        } else l[0] = parseInt(s[1]);
                                        l[1] = parseInt(s[0]) + l[0];
                                    }
                                }
                                return this._byteRange;
                            }
                        },
                        {
                            key: "byteRangeStartOffset",
                            get: function() {
                                return this.byteRange[0];
                            }
                        },
                        {
                            key: "byteRangeEndOffset",
                            get: function() {
                                return this.byteRange[1];
                            }
                        },
                        {
                            key: "decryptdata",
                            get: function() {
                                return this._decryptdata || (this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn)), this._decryptdata;
                            }
                        }
                    ]), g;
                }();
                function tt(g, o) {
                    if (!g) return null;
                    for(var l = null, s = 0; s < g.length; s++){
                        var u = g[s];
                        u.id === o && (l = u);
                    }
                    return l;
                }
                var Rt = function(g) {
                    De(o, g);
                    function o(l) {
                        Be(this, o);
                        var s = xe(this, g.call(this, l, p.a.MANIFEST_LOADING, p.a.LEVEL_LOADING, p.a.AUDIO_TRACK_LOADING, p.a.SUBTITLE_TRACK_LOADING));
                        return s.loaders = {}, s;
                    }
                    return o.prototype.destroy = function() {
                        for(var s in this.loaders){
                            var u = this.loaders[s];
                            u && u.destroy();
                        }
                        this.loaders = {}, O.prototype.destroy.call(this);
                    }, o.prototype.onManifestLoading = function(s) {
                        this.load(s.url, {
                            type: "manifest"
                        });
                    }, o.prototype.onLevelLoading = function(s) {
                        this.load(s.url, {
                            type: "level",
                            level: s.level,
                            id: s.id
                        });
                    }, o.prototype.onAudioTrackLoading = function(s) {
                        this.load(s.url, {
                            type: "audioTrack",
                            id: s.id
                        });
                    }, o.prototype.onSubtitleTrackLoading = function(s) {
                        this.load(s.url, {
                            type: "subtitleTrack",
                            id: s.id
                        });
                    }, o.prototype.load = function(s, u) {
                        var f = this.loaders[u.type];
                        if (f !== void 0) {
                            var E = f.context;
                            if (E && E.url === s) {
                                d.b.trace("playlist request ongoing");
                                return;
                            } else d.b.warn("abort previous loader for type:" + u.type), f.abort();
                        }
                        var w = this.hls.config, A = void 0, S = void 0, k = void 0, B = void 0;
                        u.type === "manifest" ? (A = w.manifestLoadingMaxRetry, S = w.manifestLoadingTimeOut, k = w.manifestLoadingRetryDelay, B = w.manifestLoadingMaxRetryTimeout) : u.type === "level" ? (A = 0, S = w.levelLoadingTimeOut) : (A = w.levelLoadingMaxRetry, S = w.levelLoadingTimeOut, k = w.levelLoadingRetryDelay, B = w.levelLoadingMaxRetryTimeout, d.b.log("loading playlist for " + u.type + " " + (u.level || u.id))), f = this.loaders[u.type] = u.loader = typeof w.pLoader < "u" ? new w.pLoader(w) : new w.loader(w), u.url = s, u.responseType = "";
                        var U = void 0, F = void 0;
                        U = {
                            timeout: S,
                            maxRetry: A,
                            retryDelay: k,
                            maxRetryDelay: B
                        }, F = {
                            onSuccess: this.loadsuccess.bind(this),
                            onError: this.loaderror.bind(this),
                            onTimeout: this.loadtimeout.bind(this)
                        }, f.load(u, U, F);
                    }, o.prototype.resolve = function(s, u) {
                        return m.a.buildAbsoluteURL(u, s, {
                            alwaysNormalize: !0
                        });
                    }, o.prototype.parseMasterPlaylist = function(s, u) {
                        var f = [], E = void 0;
                        Oe.lastIndex = 0;
                        function w(B, U) {
                            [
                                "video",
                                "audio"
                            ].forEach(function(F) {
                                var ee = B.filter(function(ge) {
                                    return ne(ge, F);
                                });
                                if (ee.length) {
                                    var he = ee.filter(function(ge) {
                                        return ge.lastIndexOf("avc1", 0) === 0 || ge.lastIndexOf("mp4a", 0) === 0;
                                    });
                                    U[F + "Codec"] = he.length > 0 ? he[0] : ee[0], B = B.filter(function(ge) {
                                        return ee.indexOf(ge) === -1;
                                    });
                                }
                            }), U.unknownCodecs = B;
                        }
                        for(; (E = Oe.exec(s)) != null;){
                            var A = {}, S = A.attrs = new q(E[1]);
                            A.url = this.resolve(E[2], u);
                            var k = S.decimalResolution("RESOLUTION");
                            k && (A.width = k.width, A.height = k.height), A.bitrate = S.decimalInteger("AVERAGE-BANDWIDTH") || S.decimalInteger("BANDWIDTH"), A.name = S.NAME, w([].concat((S.CODECS || "").split(/[ ,]+/)), A), A.videoCodec && A.videoCodec.indexOf("avc1") !== -1 && (A.videoCodec = this.avc1toavcoti(A.videoCodec)), f.push(A);
                        }
                        return f;
                    }, o.prototype.parseMasterPlaylistMedia = function(s, u, f) {
                        var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], w = void 0, A = [], S = 0;
                        for(we.lastIndex = 0; (w = we.exec(s)) !== null;){
                            var k = {}, B = new q(w[1]);
                            if (B.TYPE === f) {
                                if (k.groupId = B["GROUP-ID"], k.name = B.NAME, k.type = f, k.default = B.DEFAULT === "YES", k.autoselect = B.AUTOSELECT === "YES", k.forced = B.FORCED === "YES", B.URI && (k.url = this.resolve(B.URI, u)), k.lang = B.LANGUAGE, k.name || (k.name = k.lang), E.length) {
                                    var U = tt(E, k.groupId);
                                    k.audioCodec = U ? U.codec : E[0].codec;
                                }
                                k.id = S++, A.push(k);
                            }
                        }
                        return A;
                    }, o.prototype.avc1toavcoti = function(s) {
                        var u, f = s.split(".");
                        return f.length > 2 ? (u = f.shift() + ".", u += parseInt(f.shift()).toString(16), u += ("000" + parseInt(f.shift()).toString(16)).substr(-4)) : u = s, u;
                    }, o.prototype.parseLevelPlaylist = function(s, u, f, E) {
                        var w = 0, A = 0, S = {
                            type: null,
                            version: null,
                            url: u,
                            fragments: [],
                            live: !0,
                            startSN: 0
                        }, k = new ct(), B = 0, U = null, F = new Ge(), ee, he;
                        for(Fe.lastIndex = 0; (ee = Fe.exec(s)) !== null;){
                            var ge = ee[1];
                            if (ge) {
                                F.duration = parseFloat(ge);
                                var be = (" " + ee[2]).slice(1);
                                F.title = be || null, F.tagList.push(be ? [
                                    "INF",
                                    ge,
                                    be
                                ] : [
                                    "INF",
                                    ge
                                ]);
                            } else if (ee[3]) {
                                if (!isNaN(F.duration)) {
                                    var Se = w++;
                                    F.type = E, F.start = A, F.levelkey = k, F.sn = Se, F.level = f, F.cc = B, F.baseurl = u, F.relurl = (" " + ee[3]).slice(1), S.fragments.push(F), U = F, A += F.duration, F = new Ge();
                                }
                            } else if (ee[4]) {
                                if (F.rawByteRange = (" " + ee[4]).slice(1), U) {
                                    var Ce = U.byteRangeEndOffset;
                                    Ce && (F.lastByteRangeEndOffset = Ce);
                                }
                            } else if (ee[5]) F.rawProgramDateTime = (" " + ee[5]).slice(1), F.tagList.push([
                                "PROGRAM-DATE-TIME",
                                F.rawProgramDateTime
                            ]), S.programDateTime === void 0 && (S.programDateTime = new Date(new Date(Date.parse(ee[5])) - 1e3 * A));
                            else {
                                for(ee = ee[0].match(Xe), he = 1; he < ee.length && ee[he] === void 0; he++);
                                var Ie = (" " + ee[he + 1]).slice(1), Ye = (" " + ee[he + 2]).slice(1);
                                switch(ee[he]){
                                    case "#":
                                        F.tagList.push(Ye ? [
                                            Ie,
                                            Ye
                                        ] : [
                                            Ie
                                        ]);
                                        break;
                                    case "PLAYLIST-TYPE":
                                        S.type = Ie.toUpperCase();
                                        break;
                                    case "MEDIA-SEQUENCE":
                                        w = S.startSN = parseInt(Ie);
                                        break;
                                    case "TARGETDURATION":
                                        S.targetduration = parseFloat(Ie);
                                        break;
                                    case "VERSION":
                                        S.version = parseInt(Ie);
                                        break;
                                    case "EXTM3U":
                                        break;
                                    case "ENDLIST":
                                        S.live = !1;
                                        break;
                                    case "DIS":
                                        B++, F.tagList.push([
                                            "DIS"
                                        ]);
                                        break;
                                    case "DISCONTINUITY-SEQ":
                                        B = parseInt(Ie);
                                        break;
                                    case "KEY":
                                        var mt = Ie, Ae = new q(mt), Ut = Ae.enumeratedString("METHOD"), ot = Ae.URI, sn = Ae.hexadecimalInteger("IV");
                                        Ut && (k = new ct(), ot && [
                                            "AES-128",
                                            "SAMPLE-AES"
                                        ].indexOf(Ut) >= 0 && (k.method = Ut, k.baseuri = u, k.reluri = ot, k.key = null, k.iv = sn));
                                        break;
                                    case "START":
                                        var We = Ie, Ne = new q(We), $t = Ne.decimalFloatingPoint("TIME-OFFSET");
                                        isNaN($t) || (S.startTimeOffset = $t);
                                        break;
                                    case "MAP":
                                        var Wl = new q(Ie);
                                        F.relurl = Wl.URI, F.rawByteRange = Wl.BYTERANGE, F.baseurl = u, F.level = f, F.type = E, F.sn = "initSegment", S.initSegment = F, F = new Ge();
                                        break;
                                    default:
                                        d.b.warn("line parsed but not handled: " + ee);
                                        break;
                                }
                            }
                        }
                        return F = U, F && !F.relurl && (S.fragments.pop(), A -= F.duration), S.totalduration = A, S.averagetargetduration = A / S.fragments.length, S.endSN = w - 1, S.startCC = S.fragments[0] ? S.fragments[0].cc : 0, S.endCC = B, S;
                    }, o.prototype.loadsuccess = function(s, u, f) {
                        var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, w = s.data, A = s.url, S = f.type, k = f.id, B = f.level, U = this.hls;
                        if (this.loaders[S] = void 0, (A === void 0 || A.indexOf("data:") === 0) && (A = f.url), u.tload = performance.now(), w.indexOf("#EXTM3U") === 0) {
                            if (w.indexOf("#EXTINF:") > 0) {
                                var F = S !== "audioTrack" && S !== "subtitleTrack", ee = isNaN(B) ? isNaN(k) ? 0 : k : B, he = this.parseLevelPlaylist(w, A, ee, S === "audioTrack" ? "audio" : S === "subtitleTrack" ? "subtitle" : "main");
                                he.tload = u.tload, S === "manifest" && U.trigger(p.a.MANIFEST_LOADED, {
                                    levels: [
                                        {
                                            url: A,
                                            details: he
                                        }
                                    ],
                                    audioTracks: [],
                                    url: A,
                                    stats: u,
                                    networkDetails: E
                                }), u.tparsed = performance.now(), he.targetduration ? F ? U.trigger(p.a.LEVEL_LOADED, {
                                    details: he,
                                    level: B || 0,
                                    id: k || 0,
                                    stats: u,
                                    networkDetails: E
                                }) : S === "audioTrack" ? U.trigger(p.a.AUDIO_TRACK_LOADED, {
                                    details: he,
                                    id: k,
                                    stats: u,
                                    networkDetails: E
                                }) : S === "subtitleTrack" && U.trigger(p.a.SUBTITLE_TRACK_LOADED, {
                                    details: he,
                                    id: k,
                                    stats: u,
                                    networkDetails: E
                                }) : U.trigger(p.a.ERROR, {
                                    type: y.b.NETWORK_ERROR,
                                    details: y.a.MANIFEST_PARSING_ERROR,
                                    fatal: !0,
                                    url: A,
                                    reason: "invalid targetduration",
                                    networkDetails: E
                                });
                            } else {
                                var ge = this.parseMasterPlaylist(w, A);
                                if (ge.length) {
                                    var be = ge.map(function(Ye) {
                                        return {
                                            id: Ye.attrs.AUDIO,
                                            codec: Ye.audioCodec
                                        };
                                    }), Se = this.parseMasterPlaylistMedia(w, A, "AUDIO", be), Ce = this.parseMasterPlaylistMedia(w, A, "SUBTITLES");
                                    if (Se.length) {
                                        var Ie = !1;
                                        Se.forEach(function(Ye) {
                                            Ye.url || (Ie = !0);
                                        }), Ie === !1 && ge[0].audioCodec && !ge[0].attrs.AUDIO && (d.b.log("audio codec signaled in quality level, but no embedded audio track signaled, create one"), Se.unshift({
                                            type: "main",
                                            name: "main"
                                        }));
                                    }
                                    U.trigger(p.a.MANIFEST_LOADED, {
                                        levels: ge,
                                        audioTracks: Se,
                                        subtitles: Ce,
                                        url: A,
                                        stats: u,
                                        networkDetails: E
                                    });
                                } else U.trigger(p.a.ERROR, {
                                    type: y.b.NETWORK_ERROR,
                                    details: y.a.MANIFEST_PARSING_ERROR,
                                    fatal: !0,
                                    url: A,
                                    reason: "no level found in manifest",
                                    networkDetails: E
                                });
                            }
                        } else U.trigger(p.a.ERROR, {
                            type: y.b.NETWORK_ERROR,
                            details: y.a.MANIFEST_PARSING_ERROR,
                            fatal: !0,
                            url: A,
                            reason: "no EXTM3U delimiter",
                            networkDetails: E
                        });
                    }, o.prototype.loaderror = function(s, u) {
                        var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, E, w, A = u.loader;
                        switch(u.type){
                            case "manifest":
                                E = y.a.MANIFEST_LOAD_ERROR, w = !0;
                                break;
                            case "level":
                                E = y.a.LEVEL_LOAD_ERROR, w = !1;
                                break;
                            case "audioTrack":
                                E = y.a.AUDIO_TRACK_LOAD_ERROR, w = !1;
                                break;
                        }
                        A && (A.abort(), this.loaders[u.type] = void 0), this.hls.trigger(p.a.ERROR, {
                            type: y.b.NETWORK_ERROR,
                            details: E,
                            fatal: w,
                            url: A.url,
                            loader: A,
                            response: s,
                            context: u,
                            networkDetails: f
                        });
                    }, o.prototype.loadtimeout = function(s, u) {
                        var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, E, w, A = u.loader;
                        switch(u.type){
                            case "manifest":
                                E = y.a.MANIFEST_LOAD_TIMEOUT, w = !0;
                                break;
                            case "level":
                                E = y.a.LEVEL_LOAD_TIMEOUT, w = !1;
                                break;
                            case "audioTrack":
                                E = y.a.AUDIO_TRACK_LOAD_TIMEOUT, w = !1;
                                break;
                        }
                        A && (A.abort(), this.loaders[u.type] = void 0), this.hls.trigger(p.a.ERROR, {
                            type: y.b.NETWORK_ERROR,
                            details: E,
                            fatal: w,
                            url: A.url,
                            loader: A,
                            context: u,
                            networkDetails: f
                        });
                    }, o;
                }(O), dt = Rt;
                function ft(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function Bt(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function He(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var Pr = function(g) {
                    He(o, g);
                    function o(l) {
                        ft(this, o);
                        var s = Bt(this, g.call(this, l, p.a.FRAG_LOADING));
                        return s.loaders = {}, s;
                    }
                    return o.prototype.destroy = function() {
                        var s = this.loaders;
                        for(var u in s){
                            var f = s[u];
                            f && f.destroy();
                        }
                        this.loaders = {}, O.prototype.destroy.call(this);
                    }, o.prototype.onFragLoading = function(s) {
                        var u = s.frag, f = u.type, E = this.loaders[f], w = this.hls.config;
                        u.loaded = 0, E && (d.b.warn("abort previous fragment loader for type:" + f), E.abort()), E = this.loaders[f] = u.loader = typeof w.fLoader < "u" ? new w.fLoader(w) : new w.loader(w);
                        var A = void 0, S = void 0, k = void 0;
                        A = {
                            url: u.url,
                            frag: u,
                            responseType: "arraybuffer",
                            progressData: !1
                        };
                        var B = u.byteRangeStartOffset, U = u.byteRangeEndOffset;
                        !isNaN(B) && !isNaN(U) && (A.rangeStart = B, A.rangeEnd = U), S = {
                            timeout: w.fragLoadingTimeOut,
                            maxRetry: 0,
                            retryDelay: 0,
                            maxRetryDelay: w.fragLoadingMaxRetryTimeout
                        }, k = {
                            onSuccess: this.loadsuccess.bind(this),
                            onError: this.loaderror.bind(this),
                            onTimeout: this.loadtimeout.bind(this),
                            onProgress: this.loadprogress.bind(this)
                        }, E.load(A, S, k);
                    }, o.prototype.loadsuccess = function(s, u, f) {
                        var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, w = s.data, A = f.frag;
                        A.loader = void 0, this.loaders[A.type] = void 0, this.hls.trigger(p.a.FRAG_LOADED, {
                            payload: w,
                            frag: A,
                            stats: u,
                            networkDetails: E
                        });
                    }, o.prototype.loaderror = function(s, u) {
                        var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, E = u.loader;
                        E && E.abort(), this.loaders[u.type] = void 0, this.hls.trigger(p.a.ERROR, {
                            type: y.b.NETWORK_ERROR,
                            details: y.a.FRAG_LOAD_ERROR,
                            fatal: !1,
                            frag: u.frag,
                            response: s,
                            networkDetails: f
                        });
                    }, o.prototype.loadtimeout = function(s, u) {
                        var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, E = u.loader;
                        E && E.abort(), this.loaders[u.type] = void 0, this.hls.trigger(p.a.ERROR, {
                            type: y.b.NETWORK_ERROR,
                            details: y.a.FRAG_LOAD_TIMEOUT,
                            fatal: !1,
                            frag: u.frag,
                            networkDetails: f
                        });
                    }, o.prototype.loadprogress = function(s, u, f) {
                        var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, w = u.frag;
                        w.loaded = s.loaded, this.hls.trigger(p.a.FRAG_LOAD_PROGRESS, {
                            frag: w,
                            stats: s,
                            networkDetails: E
                        });
                    }, o;
                }(O), pt = Pr;
                function tn(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function dr(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function fr(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var Ft = function(g) {
                    fr(o, g);
                    function o(l) {
                        tn(this, o);
                        var s = dr(this, g.call(this, l, p.a.KEY_LOADING));
                        return s.loaders = {}, s.decryptkey = null, s.decrypturl = null, s;
                    }
                    return o.prototype.destroy = function() {
                        for(var s in this.loaders){
                            var u = this.loaders[s];
                            u && u.destroy();
                        }
                        this.loaders = {}, O.prototype.destroy.call(this);
                    }, o.prototype.onKeyLoading = function(s) {
                        var u = s.frag, f = u.type, E = this.loaders[f], w = u.decryptdata, A = w.uri;
                        if (A !== this.decrypturl || this.decryptkey === null) {
                            var S = this.hls.config;
                            E && (d.b.warn("abort previous key loader for type:" + f), E.abort()), u.loader = this.loaders[f] = new S.loader(S), this.decrypturl = A, this.decryptkey = null;
                            var k = void 0, B = void 0, U = void 0;
                            k = {
                                url: A,
                                frag: u,
                                responseType: "arraybuffer"
                            }, B = {
                                timeout: S.fragLoadingTimeOut,
                                maxRetry: S.fragLoadingMaxRetry,
                                retryDelay: S.fragLoadingRetryDelay,
                                maxRetryDelay: S.fragLoadingMaxRetryTimeout
                            }, U = {
                                onSuccess: this.loadsuccess.bind(this),
                                onError: this.loaderror.bind(this),
                                onTimeout: this.loadtimeout.bind(this)
                            }, u.loader.load(k, B, U);
                        } else this.decryptkey && (w.key = this.decryptkey, this.hls.trigger(p.a.KEY_LOADED, {
                            frag: u
                        }));
                    }, o.prototype.loadsuccess = function(s, u, f) {
                        var E = f.frag;
                        this.decryptkey = E.decryptdata.key = new Uint8Array(s.data), E.loader = void 0, this.loaders[E.type] = void 0, this.hls.trigger(p.a.KEY_LOADED, {
                            frag: E
                        });
                    }, o.prototype.loaderror = function(s, u) {
                        var f = u.frag, E = f.loader;
                        E && E.abort(), this.loaders[u.type] = void 0, this.hls.trigger(p.a.ERROR, {
                            type: y.b.NETWORK_ERROR,
                            details: y.a.KEY_LOAD_ERROR,
                            fatal: !1,
                            frag: f,
                            response: s
                        });
                    }, o.prototype.loadtimeout = function(s, u) {
                        var f = u.frag, E = f.loader;
                        E && E.abort(), this.loaders[u.type] = void 0, this.hls.trigger(p.a.ERROR, {
                            type: y.b.NETWORK_ERROR,
                            details: y.a.KEY_LOAD_TIMEOUT,
                            fatal: !1,
                            frag: f
                        });
                    }, o;
                }(O), pr = Ft, hr = {
                    /**
             * Searches for an item in an array which matches a certain condition.
             * This requires the condition to only match one item in the array,
             * and for the array to be ordered.
             *
             * @param {Array} list The array to search.
             * @param {Function} comparisonFunction
             *      Called and provided a candidate item as the first argument.
             *      Should return:
             *          > -1 if the item should be located at a lower index than the provided item.
             *          > 1 if the item should be located at a higher index than the provided item.
             *          > 0 if the item is the item you're looking for.
             *
             * @return {*} The object if it is found or null otherwise.
             */ search: function(o, l) {
                        for(var s = 0, u = o.length - 1, f = null, E = null; s <= u;){
                            f = (s + u) / 2 | 0, E = o[f];
                            var w = l(E);
                            if (w > 0) s = f + 1;
                            else if (w < 0) u = f - 1;
                            else return E;
                        }
                        return null;
                    }
                }, Br = hr, kr = {
                    isBuffered: function(o, l) {
                        try {
                            if (o) {
                                for(var s = o.buffered, u = 0; u < s.length; u++)if (l >= s.start(u) && l <= s.end(u)) return !0;
                            }
                        } catch  {}
                        return !1;
                    },
                    bufferInfo: function(o, l, s) {
                        try {
                            if (o) {
                                var u = o.buffered, f = [], E;
                                for(E = 0; E < u.length; E++)f.push({
                                    start: u.start(E),
                                    end: u.end(E)
                                });
                                return this.bufferedInfo(f, l, s);
                            }
                        } catch  {}
                        return {
                            len: 0,
                            start: l,
                            end: l,
                            nextStart: void 0
                        };
                    },
                    bufferedInfo: function(o, l, s) {
                        var u = [], f, E, w, A, S;
                        for(o.sort(function(ee, he) {
                            var ge = ee.start - he.start;
                            return ge || he.end - ee.end;
                        }), S = 0; S < o.length; S++){
                            var k = u.length;
                            if (k) {
                                var B = u[k - 1].end;
                                o[S].start - B < s ? o[S].end > B && (u[k - 1].end = o[S].end) : u.push(o[S]);
                            } else u.push(o[S]);
                        }
                        for(S = 0, f = 0, E = w = l; S < u.length; S++){
                            var U = u[S].start, F = u[S].end;
                            if (l + s >= U && l < F) E = U, w = F, f = w - l;
                            else if (l + s < U) {
                                A = U;
                                break;
                            }
                        }
                        return {
                            len: f,
                            start: E,
                            end: w,
                            nextStart: A
                        };
                    }
                }, ht = kr, Ct = a(7), Sn = a(5), rr = /* @__PURE__ */ a.n(Sn), Wu = a(9), Yu = /* @__PURE__ */ a.n(Wu);
                function Zs() {
                    if (typeof window < "u") return window.MediaSource || window.WebKitMediaSource;
                }
                function Ju(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var Ws = Zs(), R = function() {
                    function g(o, l) {
                        Ju(this, g), this.hls = o, this.id = l;
                        var s = this.observer = new rr.a(), u = o.config;
                        s.trigger = function(k) {
                            for(var B = arguments.length, U = Array(B > 1 ? B - 1 : 0), F = 1; F < B; F++)U[F - 1] = arguments[F];
                            s.emit.apply(s, [
                                k,
                                k
                            ].concat(U));
                        }, s.off = function(k) {
                            for(var B = arguments.length, U = Array(B > 1 ? B - 1 : 0), F = 1; F < B; F++)U[F - 1] = arguments[F];
                            s.removeListener.apply(s, [
                                k
                            ].concat(U));
                        };
                        var f = (function(S, k) {
                            k = k || {}, k.frag = this.frag, k.id = this.id, o.trigger(S, k);
                        }).bind(this);
                        s.on(p.a.FRAG_DECRYPTED, f), s.on(p.a.FRAG_PARSING_INIT_SEGMENT, f), s.on(p.a.FRAG_PARSING_DATA, f), s.on(p.a.FRAG_PARSED, f), s.on(p.a.ERROR, f), s.on(p.a.FRAG_PARSING_METADATA, f), s.on(p.a.FRAG_PARSING_USERDATA, f), s.on(p.a.INIT_PTS_FOUND, f);
                        var E = {
                            mp4: Ws.isTypeSupported("video/mp4"),
                            mpeg: Ws.isTypeSupported("audio/mpeg"),
                            mp3: Ws.isTypeSupported('audio/mp4; codecs="mp3"')
                        }, w = navigator.vendor;
                        if (u.enableWorker && typeof Worker < "u") {
                            d.b.log("demuxing in webworker");
                            var A = void 0;
                            try {
                                A = this.w = Yu()(/*require.resolve*/ 10), this.onwmsg = this.onWorkerMessage.bind(this), A.addEventListener("message", this.onwmsg), A.onerror = function(S) {
                                    o.trigger(p.a.ERROR, {
                                        type: y.b.OTHER_ERROR,
                                        details: y.a.INTERNAL_EXCEPTION,
                                        fatal: !0,
                                        event: "demuxerWorker",
                                        err: {
                                            message: S.message + " (" + S.filename + ":" + S.lineno + ")"
                                        }
                                    });
                                }, A.postMessage({
                                    cmd: "init",
                                    typeSupported: E,
                                    vendor: w,
                                    id: l,
                                    config: JSON.stringify(u)
                                });
                            } catch  {
                                d.b.error("error while initializing DemuxerWorker, fallback on DemuxerInline"), A && URL.revokeObjectURL(A.objectURL), this.demuxer = new Ct.a(s, E, u, w), this.w = void 0;
                            }
                        } else this.demuxer = new Ct.a(s, E, u, w);
                    }
                    return g.prototype.destroy = function() {
                        var l = this.w;
                        if (l) l.removeEventListener("message", this.onwmsg), l.terminate(), this.w = null;
                        else {
                            var s = this.demuxer;
                            s && (s.destroy(), this.demuxer = null);
                        }
                        var u = this.observer;
                        u && (u.removeAllListeners(), this.observer = null);
                    }, g.prototype.push = function(l, s, u, f, E, w, A, S) {
                        var k = this.w, B = isNaN(E.startDTS) ? E.start : E.startDTS, U = E.decryptdata, F = this.frag, ee = !(F && E.cc === F.cc), he = !(F && E.level === F.level), ge = F && E.sn === F.sn + 1, be = !he && ge;
                        if (ee && d.b.log(this.id + ":discontinuity detected"), he && d.b.log(this.id + ":switch detected"), this.frag = E, k) k.postMessage({
                            cmd: "demux",
                            data: l,
                            decryptdata: U,
                            initSegment: s,
                            audioCodec: u,
                            videoCodec: f,
                            timeOffset: B,
                            discontinuity: ee,
                            trackSwitch: he,
                            contiguous: be,
                            duration: w,
                            accurateTimeOffset: A,
                            defaultInitPTS: S
                        }, l instanceof ArrayBuffer ? [
                            l
                        ] : []);
                        else {
                            var Se = this.demuxer;
                            Se && Se.push(l, U, s, u, f, B, ee, he, be, w, A, S);
                        }
                    }, g.prototype.onWorkerMessage = function(l) {
                        var s = l.data, u = this.hls;
                        switch(s.event){
                            case "init":
                                URL.revokeObjectURL(this.w.objectURL);
                                break;
                            case p.a.FRAG_PARSING_DATA:
                                s.data.data1 = new Uint8Array(s.data1), s.data2 && (s.data.data2 = new Uint8Array(s.data2));
                            default:
                                s.data = s.data || {}, s.data.frag = this.frag, s.data.id = this.id, u.trigger(s.event, s.data);
                                break;
                        }
                    }, g;
                }(), I = R;
                function b(g, o, l) {
                    var s = g[o], u = g[l], f = u.startPTS;
                    isNaN(f) ? l > o ? u.start = s.start + s.duration : u.start = Math.max(s.start - u.duration, 0) : l > o ? (s.duration = f - s.start, s.duration < 0 && d.b.warn("negative duration computed for frag " + s.sn + ",level " + s.level + ", there should be some duration drift between playlist and fragment!")) : (u.duration = s.start - f, u.duration < 0 && d.b.warn("negative duration computed for frag " + u.sn + ",level " + u.level + ", there should be some duration drift between playlist and fragment!"));
                }
                function T(g, o, l, s, u, f) {
                    var E = l;
                    if (!isNaN(o.startPTS)) {
                        var w = Math.abs(o.startPTS - l);
                        isNaN(o.deltaPTS) ? o.deltaPTS = w : o.deltaPTS = Math.max(w, o.deltaPTS), E = Math.max(l, o.startPTS), l = Math.min(l, o.startPTS), s = Math.max(s, o.endPTS), u = Math.min(u, o.startDTS), f = Math.max(f, o.endDTS);
                    }
                    var A = l - o.start;
                    o.start = o.startPTS = l, o.maxStartPTS = E, o.endPTS = s, o.startDTS = u, o.endDTS = f, o.duration = s - l;
                    var S = o.sn;
                    if (!g || S < g.startSN || S > g.endSN) return 0;
                    var k, B, U;
                    for(k = S - g.startSN, B = g.fragments, B[k] = o, U = k; U > 0; U--)b(B, U, U - 1);
                    for(U = k; U < B.length - 1; U++)b(B, U, U + 1);
                    return g.PTSKnown = !0, A;
                }
                function C(g, o) {
                    var l = Math.max(g.startSN, o.startSN) - o.startSN, s = Math.min(g.endSN, o.endSN) - o.startSN, u = o.startSN - g.startSN, f = g.fragments, E = o.fragments, w = 0, A;
                    if (s < l) {
                        o.PTSKnown = !1;
                        return;
                    }
                    for(var S = l; S <= s; S++){
                        var k = f[u + S], B = E[S];
                        B && k && (w = k.cc - B.cc, isNaN(k.startPTS) || (B.start = B.startPTS = k.startPTS, B.endPTS = k.endPTS, B.duration = k.duration, B.backtracked = k.backtracked, B.dropped = k.dropped, A = B));
                    }
                    if (w) for(d.b.log("discontinuity sliding from playlist, take drift into account"), S = 0; S < E.length; S++)E[S].cc += w;
                    if (A) T(o, A, A.startPTS, A.endPTS, A.startDTS, A.endDTS);
                    else if (u >= 0 && u < f.length) {
                        var U = f[u].start;
                        for(S = 0; S < E.length; S++)E[S].start += U;
                    }
                    o.PTSKnown = g.PTSKnown;
                }
                var L = {
                    toString: function(o) {
                        for(var l = "", s = o.length, u = 0; u < s; u++)l += "[" + o.start(u).toFixed(3) + "," + o.end(u).toFixed(3) + "]";
                        return l;
                    }
                }, D = L;
                function N(g, o) {
                    for(var l = null, s = 0; s < g.length; s += 1){
                        var u = g[s];
                        if (u && u.cc === o) {
                            l = u;
                            break;
                        }
                    }
                    return l;
                }
                function M(g, o) {
                    return Br.search(g, function(l) {
                        return l.cc < o ? 1 : l.cc > o ? -1 : 0;
                    });
                }
                function z(g, o, l) {
                    var s = !1;
                    return o && o.details && l && (l.endCC > l.startCC || g && g.cc < l.startCC) && (s = !0), s;
                }
                function J(g, o) {
                    var l = g.fragments, s = o.fragments;
                    if (!s.length || !l.length) {
                        d.b.log("No fragments to align");
                        return;
                    }
                    var u = N(l, s[0].cc);
                    if (!u || u && !u.startPTS) {
                        d.b.log("No frag in previous level to align on");
                        return;
                    }
                    return u;
                }
                function H(g, o) {
                    o.fragments.forEach(function(l) {
                        if (l) {
                            var s = l.start + g;
                            l.start = l.startPTS = s, l.endPTS = s + l.duration;
                        }
                    }), o.PTSKnown = !0;
                }
                function ie(g, o, l) {
                    if (z(g, o, l)) {
                        var s = J(o.details, l);
                        s && (d.b.log("Adjusting PTS using last level due to CC increase within current level"), H(s.start, l));
                    }
                    if (l.PTSKnown === !1 && o && o.details) {
                        var u = o.details.programDateTime, f = l.programDateTime, E = (f - u) / 1e3 + o.details.fragments[0].start;
                        isNaN(E) || (d.b.log("adjusting PTS using programDateTime delta, sliding:" + E.toFixed(3)), H(E, l));
                    }
                }
                var te = /* @__PURE__ */ function() {
                    function g(o, l) {
                        for(var s = 0; s < l.length; s++){
                            var u = l[s];
                            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
                        }
                    }
                    return function(o, l, s) {
                        return l && g(o.prototype, l), s && g(o, s), o;
                    };
                }();
                function pe(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function le(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function ue(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var Q = {
                    STOPPED: "STOPPED",
                    IDLE: "IDLE",
                    KEY_LOADING: "KEY_LOADING",
                    FRAG_LOADING: "FRAG_LOADING",
                    FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
                    WAITING_LEVEL: "WAITING_LEVEL",
                    PARSING: "PARSING",
                    PARSED: "PARSED",
                    BUFFER_FLUSHING: "BUFFER_FLUSHING",
                    ENDED: "ENDED",
                    ERROR: "ERROR"
                }, Ue = function(g) {
                    ue(o, g);
                    function o(l) {
                        pe(this, o);
                        var s = le(this, g.call(this, l, p.a.MEDIA_ATTACHED, p.a.MEDIA_DETACHING, p.a.MANIFEST_LOADING, p.a.MANIFEST_PARSED, p.a.LEVEL_LOADED, p.a.KEY_LOADED, p.a.FRAG_LOADED, p.a.FRAG_LOAD_EMERGENCY_ABORTED, p.a.FRAG_PARSING_INIT_SEGMENT, p.a.FRAG_PARSING_DATA, p.a.FRAG_PARSED, p.a.ERROR, p.a.AUDIO_TRACK_SWITCHING, p.a.AUDIO_TRACK_SWITCHED, p.a.BUFFER_CREATED, p.a.BUFFER_APPENDED, p.a.BUFFER_FLUSHED));
                        return s.config = l.config, s.audioCodecSwap = !1, s.ticks = 0, s._state = Q.STOPPED, s.ontick = s.tick.bind(s), s;
                    }
                    return o.prototype.destroy = function() {
                        this.stopLoad(), this.timer && (clearInterval(this.timer), this.timer = null), O.prototype.destroy.call(this), this.state = Q.STOPPED;
                    }, o.prototype.startLoad = function(s) {
                        if (this.levels) {
                            var u = this.lastCurrentTime, f = this.hls;
                            if (this.stopLoad(), this.timer || (this.timer = setInterval(this.ontick, 100)), this.level = -1, this.fragLoadError = 0, !this.startFragRequested) {
                                var E = f.startLevel;
                                E === -1 && (E = 0, this.bitrateTest = !0), this.level = f.nextLoadLevel = E, this.loadedmetadata = !1;
                            }
                            u > 0 && s === -1 && (d.b.log("override startPosition with lastCurrentTime @" + u.toFixed(3)), s = u), this.state = Q.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = s, this.tick();
                        } else this.forceStartLoad = !0, this.state = Q.STOPPED;
                    }, o.prototype.stopLoad = function() {
                        var s = this.fragCurrent;
                        s && (s.loader && s.loader.abort(), this.fragCurrent = null), this.fragPrevious = null, this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.state = Q.STOPPED, this.forceStartLoad = !1;
                    }, o.prototype.tick = function() {
                        this.ticks++, this.ticks === 1 && (this.doTick(), this.ticks > 1 && setTimeout(this.tick, 1), this.ticks = 0);
                    }, o.prototype.doTick = function() {
                        switch(this.state){
                            case Q.ERROR:
                                break;
                            case Q.BUFFER_FLUSHING:
                                this.fragLoadError = 0;
                                break;
                            case Q.IDLE:
                                this._doTickIdle();
                                break;
                            case Q.WAITING_LEVEL:
                                var s = this.levels[this.level];
                                s && s.details && (this.state = Q.IDLE);
                                break;
                            case Q.FRAG_LOADING_WAITING_RETRY:
                                var u = performance.now(), f = this.retryDate;
                                (!f || u >= f || this.media && this.media.seeking) && (d.b.log("mediaController: retryDate reached, switch back to IDLE state"), this.state = Q.IDLE);
                                break;
                        }
                        this._checkBuffer(), this._checkFragmentChanged();
                    }, o.prototype._doTickIdle = function() {
                        var s = this.hls, u = s.config, f = this.media;
                        if (!(this.levelLastLoaded === void 0 || !f && (this.startFragRequested || !u.startFragPrefetch))) {
                            var E = void 0;
                            this.loadedmetadata ? E = f.currentTime : E = this.nextLoadPosition;
                            var w = s.nextLoadLevel, A = this.levels[w];
                            if (A) {
                                var S = A.bitrate, k = void 0;
                                S ? k = Math.max(8 * u.maxBufferSize / S, u.maxBufferLength) : k = u.maxBufferLength, k = Math.min(k, u.maxMaxBufferLength);
                                var B = ht.bufferInfo(this.mediaBuffer ? this.mediaBuffer : f, E, u.maxBufferHole), U = B.len;
                                if (!(U >= k)) {
                                    d.b.trace("buffer length of " + U.toFixed(3) + " is below max of " + k.toFixed(3) + ". checking for more payload ..."), this.level = s.nextLoadLevel = w;
                                    var F = A.details;
                                    if (F === void 0 || F.live === !0 && this.levelLastLoaded !== w) {
                                        this.state = Q.WAITING_LEVEL;
                                        return;
                                    }
                                    var ee = this.fragPrevious;
                                    if (!F.live && ee && !ee.backtracked && ee.sn === F.endSN && !B.nextStart) {
                                        var he = Math.min(f.duration, ee.start + ee.duration);
                                        if (he - Math.max(B.end, ee.start) <= Math.max(0.2, ee.duration)) {
                                            var ge = {};
                                            this.altAudio && (ge.type = "video"), this.hls.trigger(p.a.BUFFER_EOS, ge), this.state = Q.ENDED;
                                            return;
                                        }
                                    }
                                    this._fetchPayloadOrEos(E, B, F);
                                }
                            }
                        }
                    }, o.prototype._fetchPayloadOrEos = function(s, u, f) {
                        var E = this.fragPrevious, w = this.level, A = f.fragments, S = A.length;
                        if (S !== 0) {
                            var k = A[0].start, B = A[S - 1].start + A[S - 1].duration, U = u.end, F = void 0;
                            if (f.initSegment && !f.initSegment.data) F = f.initSegment;
                            else if (f.live) {
                                var ee = this.config.initialLiveManifestSize;
                                if (S < ee) {
                                    d.b.warn("Can not start playback of a level, reason: not enough fragments " + S + " < " + ee);
                                    return;
                                }
                                if (F = this._ensureFragmentAtLivePoint(f, U, k, B, E, A, S), F === null) return;
                            } else U < k && (F = A[0]);
                            F || (F = this._findFragment(k, E, S, A, U, B, f)), F && this._loadFragmentOrKey(F, w, f, s, U);
                        }
                    }, o.prototype._ensureFragmentAtLivePoint = function(s, u, f, E, w, A, S) {
                        var k = this.hls.config, B = this.media, U = void 0, F = k.liveMaxLatencyDuration !== void 0 ? k.liveMaxLatencyDuration : k.liveMaxLatencyDurationCount * s.targetduration;
                        if (u < Math.max(f - k.maxFragLookUpTolerance, E - F)) {
                            var ee = this.liveSyncPosition = this.computeLivePosition(f, s);
                            d.b.log("buffer end: " + u.toFixed(3) + " is located too far from the end of live sliding playlist, reset currentTime to : " + ee.toFixed(3)), u = ee, B && B.readyState && B.duration > ee && (B.currentTime = ee), this.nextLoadPosition = ee;
                        }
                        if (s.PTSKnown && u > E && B && B.readyState) return null;
                        if (this.startFragRequested && !s.PTSKnown) {
                            if (w) {
                                var he = w.sn + 1;
                                if (he >= s.startSN && he <= s.endSN) {
                                    var ge = A[he - s.startSN];
                                    w.cc === ge.cc && (U = ge, d.b.log("live playlist, switching playlist, load frag with next SN: " + U.sn));
                                }
                                U || (U = Br.search(A, function(be) {
                                    return w.cc - be.cc;
                                }), U && d.b.log("live playlist, switching playlist, load frag with same CC: " + U.sn));
                            }
                            U || (U = A[Math.min(S - 1, Math.round(S / 2))], d.b.log("live playlist, switching playlist, unknown, load middle frag : " + U.sn));
                        }
                        return U;
                    }, o.prototype._findFragment = function(s, u, f, E, w, A, S) {
                        var k = this.hls.config, B = void 0, U = void 0, F = k.maxFragLookUpTolerance, ee = u ? E[u.sn - E[0].sn + 1] : void 0, he = function(mt) {
                            var Ae = Math.min(F, mt.duration + (mt.deltaPTS ? mt.deltaPTS : 0));
                            return mt.start + mt.duration - Ae <= w ? 1 : mt.start - Ae > w && mt.start ? -1 : 0;
                        };
                        if (w < A ? (w > A - F && (F = 0), ee && !he(ee) ? U = ee : U = Br.search(E, he)) : U = E[f - 1], U) {
                            B = U;
                            var ge = B.sn - S.startSN, be = u && B.level === u.level, Se = E[ge - 1], Ce = E[ge + 1];
                            if (u && B.sn === u.sn) {
                                if (be && !B.backtracked) {
                                    if (B.sn < S.endSN) {
                                        var Ie = u.deltaPTS;
                                        Ie && Ie > k.maxBufferHole && u.dropped && ge ? (B = Se, d.b.warn("SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this"), u.loadCounter--) : (B = Ce, d.b.log("SN just loaded, load next one: " + B.sn));
                                    } else B = null;
                                } else B.backtracked && (Ce && Ce.backtracked ? (d.b.warn("Already backtracked from fragment " + Ce.sn + ", will not backtrack to fragment " + B.sn + ". Loading fragment " + Ce.sn), B = Ce) : (d.b.warn("Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe"), B.dropped = 0, Se ? (Se.loadCounter && Se.loadCounter--, B = Se, B.backtracked = !0) : ge && (B = null)));
                            }
                        }
                        return B;
                    }, o.prototype._loadFragmentOrKey = function(s, u, f, E, w) {
                        var A = this.hls, S = A.config;
                        if (s.decryptdata && s.decryptdata.uri != null && s.decryptdata.key == null) d.b.log("Loading key for " + s.sn + " of [" + f.startSN + " ," + f.endSN + "],level " + u), this.state = Q.KEY_LOADING, A.trigger(p.a.KEY_LOADING, {
                            frag: s
                        });
                        else {
                            if (d.b.log("Loading " + s.sn + " of [" + f.startSN + " ," + f.endSN + "],level " + u + ", currentTime:" + E.toFixed(3) + ",bufferEnd:" + w.toFixed(3)), this.fragLoadIdx !== void 0 ? this.fragLoadIdx++ : this.fragLoadIdx = 0, s.loadCounter) {
                                s.loadCounter++;
                                var k = S.fragLoadingLoopThreshold;
                                if (s.loadCounter > k && Math.abs(this.fragLoadIdx - s.loadIdx) < k) {
                                    A.trigger(p.a.ERROR, {
                                        type: y.b.MEDIA_ERROR,
                                        details: y.a.FRAG_LOOP_LOADING_ERROR,
                                        fatal: !1,
                                        frag: s
                                    });
                                    return;
                                }
                            } else s.loadCounter = 1;
                            s.loadIdx = this.fragLoadIdx, s.autoLevel = A.autoLevelEnabled, s.bitrateTest = this.bitrateTest, this.fragCurrent = s, this.startFragRequested = !0, !isNaN(s.sn) && !s.bitrateTest && (this.nextLoadPosition = s.start + s.duration), A.trigger(p.a.FRAG_LOADING, {
                                frag: s
                            }), this.demuxer || (this.demuxer = new I(A, "main")), this.state = Q.FRAG_LOADING;
                            return;
                        }
                    }, o.prototype.getBufferedFrag = function(s) {
                        return Br.search(this._bufferedFrags, function(u) {
                            return s < u.startPTS ? -1 : s > u.endPTS ? 1 : 0;
                        });
                    }, o.prototype.followingBufferedFrag = function(s) {
                        return s ? this.getBufferedFrag(s.endPTS + 0.5) : null;
                    }, o.prototype._checkFragmentChanged = function() {
                        var s, u, f = this.media;
                        if (f && f.readyState && f.seeking === !1 && (u = f.currentTime, u > f.playbackRate * this.lastCurrentTime && (this.lastCurrentTime = u), ht.isBuffered(f, u) ? s = this.getBufferedFrag(u) : ht.isBuffered(f, u + 0.1) && (s = this.getBufferedFrag(u + 0.1)), s)) {
                            var E = s;
                            if (E !== this.fragPlaying) {
                                this.hls.trigger(p.a.FRAG_CHANGED, {
                                    frag: E
                                });
                                var w = E.level;
                                (!this.fragPlaying || this.fragPlaying.level !== w) && this.hls.trigger(p.a.LEVEL_SWITCHED, {
                                    level: w
                                }), this.fragPlaying = E;
                            }
                        }
                    }, o.prototype.immediateLevelSwitch = function() {
                        if (d.b.log("immediateLevelSwitch"), !this.immediateSwitch) {
                            this.immediateSwitch = !0;
                            var s = this.media, u = void 0;
                            s ? (u = s.paused, s.pause()) : u = !0, this.previouslyPaused = u;
                        }
                        var f = this.fragCurrent;
                        f && f.loader && f.loader.abort(), this.fragCurrent = null, this.fragLoadIdx !== void 0 && (this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                    }, o.prototype.immediateLevelSwitchEnd = function() {
                        var s = this.media;
                        s && s.buffered.length && (this.immediateSwitch = !1, ht.isBuffered(s, s.currentTime) && (s.currentTime -= 1e-4), this.previouslyPaused || s.play());
                    }, o.prototype.nextLevelSwitch = function() {
                        var s = this.media;
                        if (s && s.readyState) {
                            var u = void 0, f = void 0, E = void 0;
                            if (this.fragLoadIdx !== void 0 && (this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold), f = this.getBufferedFrag(s.currentTime), f && f.startPTS > 1 && this.flushMainBuffer(0, f.startPTS - 1), s.paused) u = 0;
                            else {
                                var w = this.hls.nextLoadLevel, A = this.levels[w], S = this.fragLastKbps;
                                S && this.fragCurrent ? u = this.fragCurrent.duration * A.bitrate / (1e3 * S) + 1 : u = 0;
                            }
                            if (E = this.getBufferedFrag(s.currentTime + u), E && (E = this.followingBufferedFrag(E), E)) {
                                var k = this.fragCurrent;
                                k && k.loader && k.loader.abort(), this.fragCurrent = null, this.flushMainBuffer(E.maxStartPTS, Number.POSITIVE_INFINITY);
                            }
                        }
                    }, o.prototype.flushMainBuffer = function(s, u) {
                        this.state = Q.BUFFER_FLUSHING;
                        var f = {
                            startOffset: s,
                            endOffset: u
                        };
                        this.altAudio && (f.type = "video"), this.hls.trigger(p.a.BUFFER_FLUSHING, f);
                    }, o.prototype.onMediaAttached = function(s) {
                        var u = this.media = this.mediaBuffer = s.media;
                        this.onvseeking = this.onMediaSeeking.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), this.onvended = this.onMediaEnded.bind(this), u.addEventListener("seeking", this.onvseeking), u.addEventListener("seeked", this.onvseeked), u.addEventListener("ended", this.onvended);
                        var f = this.config;
                        this.levels && f.autoStartLoad && this.hls.startLoad(f.startPosition);
                    }, o.prototype.onMediaDetaching = function() {
                        var s = this.media;
                        s && s.ended && (d.b.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0);
                        var u = this.levels;
                        u && u.forEach(function(f) {
                            f.details && f.details.fragments.forEach(function(E) {
                                E.loadCounter = void 0, E.backtracked = void 0;
                            });
                        }), s && (s.removeEventListener("seeking", this.onvseeking), s.removeEventListener("seeked", this.onvseeked), s.removeEventListener("ended", this.onvended), this.onvseeking = this.onvseeked = this.onvended = null), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.stopLoad();
                    }, o.prototype.onMediaSeeking = function() {
                        var s = this.media, u = s ? s.currentTime : void 0, f = this.config;
                        isNaN(u) || d.b.log("media seeking to " + u.toFixed(3));
                        var E = this.mediaBuffer ? this.mediaBuffer : s, w = ht.bufferInfo(E, u, this.config.maxBufferHole);
                        if (this.state === Q.FRAG_LOADING) {
                            var A = this.fragCurrent;
                            if (w.len === 0 && A) {
                                var S = f.maxFragLookUpTolerance, k = A.start - S, B = A.start + A.duration + S;
                                u < k || u > B ? (A.loader && (d.b.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), A.loader.abort()), this.fragCurrent = null, this.fragPrevious = null, this.state = Q.IDLE) : d.b.log("seeking outside of buffer but within currently loaded fragment range");
                            }
                        } else this.state === Q.ENDED && (w.len === 0 && (this.fragPrevious = 0), this.state = Q.IDLE);
                        s && (this.lastCurrentTime = u), this.state !== Q.FRAG_LOADING && this.fragLoadIdx !== void 0 && (this.fragLoadIdx += 2 * f.fragLoadingLoopThreshold), this.loadedmetadata || (this.nextLoadPosition = this.startPosition = u), this.tick();
                    }, o.prototype.onMediaSeeked = function() {
                        var s = this.media, u = s ? s.currentTime : void 0;
                        isNaN(u) || d.b.log("media seeked to " + u.toFixed(3)), this.tick();
                    }, o.prototype.onMediaEnded = function() {
                        d.b.log("media ended"), this.startPosition = this.lastCurrentTime = 0;
                    }, o.prototype.onManifestLoading = function() {
                        d.b.log("trigger BUFFER_RESET"), this.hls.trigger(p.a.BUFFER_RESET), this._bufferedFrags = [], this.stalled = !1, this.startPosition = this.lastCurrentTime = 0;
                    }, o.prototype.onManifestParsed = function(s) {
                        var u = !1, f = !1, E;
                        s.levels.forEach(function(A) {
                            E = A.audioCodec, E && (E.indexOf("mp4a.40.2") !== -1 && (u = !0), E.indexOf("mp4a.40.5") !== -1 && (f = !0));
                        }), this.audioCodecSwitch = u && f, this.audioCodecSwitch && d.b.log("both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = s.levels, this.startFragRequested = !1;
                        var w = this.config;
                        (w.autoStartLoad || this.forceStartLoad) && this.hls.startLoad(w.startPosition);
                    }, o.prototype.onLevelLoaded = function(s) {
                        var u = s.details, f = s.level, E = this.levels[this.levelLastLoaded], w = this.levels[f], A = u.totalduration, S = 0;
                        if (d.b.log("level " + f + " loaded [" + u.startSN + "," + u.endSN + "],duration:" + A), u.live) {
                            var k = w.details;
                            k && u.fragments.length > 0 ? (C(k, u), S = u.fragments[0].start, this.liveSyncPosition = this.computeLivePosition(S, k), u.PTSKnown && !isNaN(S) ? d.b.log("live playlist sliding:" + S.toFixed(3)) : (d.b.log("live playlist - outdated PTS, unknown sliding"), ie(this.fragPrevious, E, u))) : (d.b.log("live playlist - first load, unknown sliding"), u.PTSKnown = !1, ie(this.fragPrevious, E, u));
                        } else u.PTSKnown = !1;
                        if (w.details = u, this.levelLastLoaded = f, this.hls.trigger(p.a.LEVEL_UPDATED, {
                            details: u,
                            level: f
                        }), this.startFragRequested === !1) {
                            if (this.startPosition === -1 || this.lastCurrentTime === -1) {
                                var B = u.startTimeOffset;
                                isNaN(B) ? u.live ? (this.startPosition = this.computeLivePosition(S, u), d.b.log("configure startPosition to " + this.startPosition)) : this.startPosition = 0 : (B < 0 && (d.b.log("negative start time offset " + B + ", count from end of last fragment"), B = S + A + B), d.b.log("start time offset found in playlist, adjust startPosition to " + B), this.startPosition = B), this.lastCurrentTime = this.startPosition;
                            }
                            this.nextLoadPosition = this.startPosition;
                        }
                        this.state === Q.WAITING_LEVEL && (this.state = Q.IDLE), this.tick();
                    }, o.prototype.onKeyLoaded = function() {
                        this.state === Q.KEY_LOADING && (this.state = Q.IDLE, this.tick());
                    }, o.prototype.onFragLoaded = function(s) {
                        var u = this.fragCurrent, f = s.frag;
                        if (this.state === Q.FRAG_LOADING && u && f.type === "main" && f.level === u.level && f.sn === u.sn) {
                            var E = s.stats, w = this.levels[u.level], A = w.details;
                            if (d.b.log("Loaded  " + u.sn + " of [" + A.startSN + " ," + A.endSN + "],level " + u.level), this.bitrateTest = !1, this.stats = E, f.bitrateTest === !0 && this.hls.nextLoadLevel) this.state = Q.IDLE, this.startFragRequested = !1, E.tparsed = E.tbuffered = performance.now(), this.hls.trigger(p.a.FRAG_BUFFERED, {
                                stats: E,
                                frag: u,
                                id: "main"
                            }), this.tick();
                            else if (f.sn === "initSegment") this.state = Q.IDLE, E.tparsed = E.tbuffered = performance.now(), A.initSegment.data = s.payload, this.hls.trigger(p.a.FRAG_BUFFERED, {
                                stats: E,
                                frag: u,
                                id: "main"
                            }), this.tick();
                            else {
                                this.state = Q.PARSING;
                                var S = A.totalduration, k = u.level, B = u.sn, U = this.config.defaultAudioCodec || w.audioCodec;
                                this.audioCodecSwap && (d.b.log("swapping playlist audio codec"), U === void 0 && (U = this.lastAudioCodec), U && (U.indexOf("mp4a.40.5") !== -1 ? U = "mp4a.40.2" : U = "mp4a.40.5")), this.pendingBuffering = !0, this.appended = !1, d.b.log("Parsing " + B + " of [" + A.startSN + " ," + A.endSN + "],level " + k + ", cc " + u.cc);
                                var F = this.demuxer;
                                F || (F = this.demuxer = new I(this.hls, "main"));
                                var ee = this.media, he = ee && ee.seeking, ge = !he && (A.PTSKnown || !A.live), be = A.initSegment ? A.initSegment.data : [];
                                F.push(s.payload, be, U, w.videoCodec, u, S, ge, void 0);
                            }
                        }
                        this.fragLoadError = 0;
                    }, o.prototype.onFragParsingInitSegment = function(s) {
                        var u = this.fragCurrent, f = s.frag;
                        if (u && s.id === "main" && f.sn === u.sn && f.level === u.level && this.state === Q.PARSING) {
                            var E = s.tracks, w, A;
                            if (E.audio && this.altAudio && delete E.audio, A = E.audio, A) {
                                var S = this.levels[this.level].audioCodec, k = navigator.userAgent.toLowerCase();
                                S && this.audioCodecSwap && (d.b.log("swapping playlist audio codec"), S.indexOf("mp4a.40.5") !== -1 ? S = "mp4a.40.2" : S = "mp4a.40.5"), this.audioCodecSwitch && A.metadata.channelCount !== 1 && // don't force HE-AAC if firefox
                                k.indexOf("firefox") === -1 && (S = "mp4a.40.5"), k.indexOf("android") !== -1 && A.container !== "audio/mpeg" && (S = "mp4a.40.2", d.b.log("Android: force audio codec to " + S)), A.levelCodec = S, A.id = s.id;
                            }
                            A = E.video, A && (A.levelCodec = this.levels[this.level].videoCodec, A.id = s.id), this.hls.trigger(p.a.BUFFER_CODECS, E);
                            for(w in E){
                                A = E[w], d.b.log("main track:" + w + ",container:" + A.container + ",codecs[level/parsed]=[" + A.levelCodec + "/" + A.codec + "]");
                                var B = A.initSegment;
                                B && (this.appended = !0, this.pendingBuffering = !0, this.hls.trigger(p.a.BUFFER_APPENDING, {
                                    type: w,
                                    data: B,
                                    parent: "main",
                                    content: "initSegment"
                                }));
                            }
                            this.tick();
                        }
                    }, o.prototype.onFragParsingData = function(s) {
                        var u = this, f = this.fragCurrent, E = s.frag;
                        if (f && s.id === "main" && E.sn === f.sn && E.level === f.level && !(s.type === "audio" && this.altAudio) && // filter out main audio if audio track is loaded through audio stream controller
                        this.state === Q.PARSING) {
                            var w = this.levels[this.level], A = f;
                            if (isNaN(s.endPTS) && (s.endPTS = s.startPTS + f.duration, s.endDTS = s.startDTS + f.duration), d.b.log("Parsed " + s.type + ",PTS:[" + s.startPTS.toFixed(3) + "," + s.endPTS.toFixed(3) + "],DTS:[" + s.startDTS.toFixed(3) + "/" + s.endDTS.toFixed(3) + "],nb:" + s.nb + ",dropped:" + (s.dropped || 0)), s.type === "video") {
                                if (A.dropped = s.dropped, A.dropped) {
                                    if (A.backtracked) d.b.warn("Already backtracked on this fragment, appending with the gap");
                                    else {
                                        var S = w.details;
                                        if (S && A.sn === S.startSN) d.b.warn("missing video frame(s) on first frag, appending with gap");
                                        else {
                                            d.b.warn("missing video frame(s), backtracking fragment"), A.backtracked = !0, this.nextLoadPosition = s.startPTS, this.state = Q.IDLE, this.fragPrevious = A, this.tick();
                                            return;
                                        }
                                    }
                                } else A.backtracked = !1;
                            }
                            var k = T(w.details, A, s.startPTS, s.endPTS, s.startDTS, s.endDTS), B = this.hls;
                            B.trigger(p.a.LEVEL_PTS_UPDATED, {
                                details: w.details,
                                level: this.level,
                                drift: k,
                                type: s.type,
                                start: s.startPTS,
                                end: s.endPTS
                            }), [
                                s.data1,
                                s.data2
                            ].forEach(function(U) {
                                U && U.length && u.state === Q.PARSING && (u.appended = !0, u.pendingBuffering = !0, B.trigger(p.a.BUFFER_APPENDING, {
                                    type: s.type,
                                    data: U,
                                    parent: "main",
                                    content: "data"
                                }));
                            }), this.tick();
                        }
                    }, o.prototype.onFragParsed = function(s) {
                        var u = this.fragCurrent, f = s.frag;
                        u && s.id === "main" && f.sn === u.sn && f.level === u.level && this.state === Q.PARSING && (this.stats.tparsed = performance.now(), this.state = Q.PARSED, this._checkAppendedParsed());
                    }, o.prototype.onAudioTrackSwitching = function(s) {
                        var u = !!s.url, f = s.id;
                        if (!u) {
                            if (this.mediaBuffer !== this.media) {
                                d.b.log("switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
                                var E = this.fragCurrent;
                                E.loader && (d.b.log("switching to main audio track, cancel main fragment load"), E.loader.abort()), this.fragCurrent = null, this.fragPrevious = null, this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.state = Q.IDLE;
                            }
                            var w = this.hls;
                            w.trigger(p.a.BUFFER_FLUSHING, {
                                startOffset: 0,
                                endOffset: Number.POSITIVE_INFINITY,
                                type: "audio"
                            }), w.trigger(p.a.AUDIO_TRACK_SWITCHED, {
                                id: f
                            }), this.altAudio = !1;
                        }
                    }, o.prototype.onAudioTrackSwitched = function(s) {
                        var u = s.id, f = !!this.hls.audioTracks[u].url;
                        if (f) {
                            var E = this.videoBuffer;
                            E && this.mediaBuffer !== E && (d.b.log("switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = E);
                        }
                        this.altAudio = f, this.tick();
                    }, o.prototype.onBufferCreated = function(s) {
                        var u = s.tracks, f = void 0, E = void 0, w = !1;
                        for(var A in u){
                            var S = u[A];
                            S.id === "main" ? (E = A, f = S, A === "video" && (this.videoBuffer = u[A].buffer)) : w = !0;
                        }
                        w && f ? (d.b.log("alternate track found, use " + E + ".buffered to schedule main fragment loading"), this.mediaBuffer = f.buffer) : this.mediaBuffer = this.media;
                    }, o.prototype.onBufferAppended = function(s) {
                        if (s.parent === "main") {
                            var u = this.state;
                            (u === Q.PARSING || u === Q.PARSED) && (this.pendingBuffering = s.pending > 0, this._checkAppendedParsed());
                        }
                    }, o.prototype._checkAppendedParsed = function() {
                        if (this.state === Q.PARSED && (!this.appended || !this.pendingBuffering)) {
                            var s = this.fragCurrent;
                            if (s) {
                                var u = this.mediaBuffer ? this.mediaBuffer : this.media;
                                d.b.log("main buffered : " + D.toString(u.buffered));
                                var f = this._bufferedFrags.filter(function(w) {
                                    return ht.isBuffered(u, (w.startPTS + w.endPTS) / 2);
                                });
                                f.push(s), this._bufferedFrags = f.sort(function(w, A) {
                                    return w.startPTS - A.startPTS;
                                }), this.fragPrevious = s;
                                var E = this.stats;
                                E.tbuffered = performance.now(), this.fragLastKbps = Math.round(8 * E.total / (E.tbuffered - E.tfirst)), this.hls.trigger(p.a.FRAG_BUFFERED, {
                                    stats: E,
                                    frag: s,
                                    id: "main"
                                }), this.state = Q.IDLE;
                            }
                            this.tick();
                        }
                    }, o.prototype.onError = function(s) {
                        var u = s.frag || this.fragCurrent;
                        if (!(u && u.type !== "main")) {
                            var f = !!this.media && ht.isBuffered(this.media, this.media.currentTime) && ht.isBuffered(this.media, this.media.currentTime + 0.5);
                            switch(s.details){
                                case y.a.FRAG_LOAD_ERROR:
                                case y.a.FRAG_LOAD_TIMEOUT:
                                case y.a.KEY_LOAD_ERROR:
                                case y.a.KEY_LOAD_TIMEOUT:
                                    if (!s.fatal) {
                                        if (this.fragLoadError + 1 <= this.config.fragLoadingMaxRetry) {
                                            var E = Math.min(Math.pow(2, this.fragLoadError) * this.config.fragLoadingRetryDelay, this.config.fragLoadingMaxRetryTimeout);
                                            u.loadCounter = 0, d.b.warn("mediaController: frag loading failed, retry in " + E + " ms"), this.retryDate = performance.now() + E, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.fragLoadError++, this.state = Q.FRAG_LOADING_WAITING_RETRY;
                                        } else d.b.error("mediaController: " + s.details + " reaches max retry, redispatch as fatal ..."), s.fatal = !0, this.state = Q.ERROR;
                                    }
                                    break;
                                case y.a.FRAG_LOOP_LOADING_ERROR:
                                    s.fatal || (f ? (this._reduceMaxBufferLength(u.duration), this.state = Q.IDLE) : (!u.autoLevel || u.level === 0) && (s.fatal = !0, this.state = Q.ERROR));
                                    break;
                                case y.a.LEVEL_LOAD_ERROR:
                                case y.a.LEVEL_LOAD_TIMEOUT:
                                    this.state !== Q.ERROR && (s.fatal ? (this.state = Q.ERROR, d.b.warn("streamController: " + s.details + ",switch to " + this.state + " state ...")) : !s.levelRetry && this.state === Q.WAITING_LEVEL && (this.state = Q.IDLE));
                                    break;
                                case y.a.BUFFER_FULL_ERROR:
                                    s.parent === "main" && (this.state === Q.PARSING || this.state === Q.PARSED) && (f ? (this._reduceMaxBufferLength(this.config.maxBufferLength), this.state = Q.IDLE) : (d.b.warn("buffer full error also media.currentTime is not buffered, flush everything"), this.fragCurrent = null, this.flushMainBuffer(0, Number.POSITIVE_INFINITY)));
                                    break;
                            }
                        }
                    }, o.prototype._reduceMaxBufferLength = function(s) {
                        var u = this.config;
                        u.maxMaxBufferLength >= s && (u.maxMaxBufferLength /= 2, d.b.warn("main:reduce max buffer length to " + u.maxMaxBufferLength + "s"), this.fragLoadIdx !== void 0 && (this.fragLoadIdx += 2 * u.fragLoadingLoopThreshold));
                    }, o.prototype._checkBuffer = function() {
                        var s = this.media, u = this.config;
                        if (s && s.readyState) {
                            var f = s.currentTime, E = this.mediaBuffer ? this.mediaBuffer : s, w = E.buffered;
                            if (!this.loadedmetadata && w.length) {
                                this.loadedmetadata = !0;
                                var A = s.seeking ? f : this.startPosition, S = ht.isBuffered(E, A), k = w.start(0), B = !S && Math.abs(A - k) < u.maxSeekHole;
                                (f !== A || B) && (d.b.log("target start position:" + A), B && (A = k, d.b.log("target start position not buffered, seek to buffered.start(0) " + A)), d.b.log("adjust currentTime from " + f + " to " + A), s.currentTime = A);
                            } else if (this.immediateSwitch) this.immediateLevelSwitchEnd();
                            else {
                                var U = ht.bufferInfo(s, f, 0), F = !(s.paused || // not playing when media is paused
                                s.ended || // not playing when media is ended
                                s.buffered.length === 0), ee = 0.5, he = f !== this.lastCurrentTime;
                                if (he) this.stallReported && (d.b.warn("playback not stuck anymore @" + f + ", after " + Math.round(performance.now() - this.stalled) + "ms"), this.stallReported = !1), this.stalled = void 0, this.nudgeRetry = 0;
                                else if (F) {
                                    var ge = performance.now(), be = this.hls;
                                    if (!this.stalled) this.stalled = ge, this.stallReported = !1;
                                    else {
                                        var Se = ge - this.stalled, Ce = U.len, Ie = this.nudgeRetry || 0;
                                        if (Ce <= ee && Se > u.lowBufferWatchdogPeriod * 1e3) {
                                            this.stallReported || (this.stallReported = !0, d.b.warn("playback stalling in low buffer @" + f), be.trigger(p.a.ERROR, {
                                                type: y.b.MEDIA_ERROR,
                                                details: y.a.BUFFER_STALLED_ERROR,
                                                fatal: !1,
                                                buffer: Ce
                                            }));
                                            var Ye = U.nextStart, mt = Ye - f;
                                            if (Ye && mt < u.maxSeekHole && mt > 0) {
                                                this.nudgeRetry = ++Ie;
                                                var Ae = Ie * u.nudgeOffset;
                                                d.b.log("adjust currentTime from " + s.currentTime + " to next buffered @ " + Ye + " + nudge " + Ae), s.currentTime = Ye + Ae, this.stalled = void 0, be.trigger(p.a.ERROR, {
                                                    type: y.b.MEDIA_ERROR,
                                                    details: y.a.BUFFER_SEEK_OVER_HOLE,
                                                    fatal: !1,
                                                    hole: Ye + Ae - f
                                                });
                                            }
                                        } else if (Ce > ee && Se > u.highBufferWatchdogPeriod * 1e3) {
                                            if (this.stallReported || (this.stallReported = !0, d.b.warn("playback stalling in high buffer @" + f), be.trigger(p.a.ERROR, {
                                                type: y.b.MEDIA_ERROR,
                                                details: y.a.BUFFER_STALLED_ERROR,
                                                fatal: !1,
                                                buffer: Ce
                                            })), this.stalled = void 0, this.nudgeRetry = ++Ie, Ie < u.nudgeMaxRetry) {
                                                var Ut = s.currentTime, ot = Ut + Ie * u.nudgeOffset;
                                                d.b.log("adjust currentTime from " + Ut + " to " + ot), s.currentTime = ot, be.trigger(p.a.ERROR, {
                                                    type: y.b.MEDIA_ERROR,
                                                    details: y.a.BUFFER_NUDGE_ON_STALL,
                                                    fatal: !1
                                                });
                                            } else d.b.error("still stuck in high buffer @" + f + " after " + u.nudgeMaxRetry + ", raise fatal error"), be.trigger(p.a.ERROR, {
                                                type: y.b.MEDIA_ERROR,
                                                details: y.a.BUFFER_STALLED_ERROR,
                                                fatal: !0
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }, o.prototype.onFragLoadEmergencyAborted = function() {
                        this.state = Q.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tick();
                    }, o.prototype.onBufferFlushed = function() {
                        var s = this.mediaBuffer ? this.mediaBuffer : this.media;
                        this._bufferedFrags = this._bufferedFrags.filter(function(u) {
                            return ht.isBuffered(s, (u.startPTS + u.endPTS) / 2);
                        }), this.fragLoadIdx !== void 0 && (this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold), this.state = Q.IDLE, this.fragPrevious = null;
                    }, o.prototype.swapAudioCodec = function() {
                        this.audioCodecSwap = !this.audioCodecSwap;
                    }, o.prototype.computeLivePosition = function(s, u) {
                        var f = this.config.liveSyncDuration !== void 0 ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * u.targetduration;
                        return s + Math.max(0, u.totalduration - f);
                    }, te(o, [
                        {
                            key: "state",
                            set: function(s) {
                                if (this.state !== s) {
                                    var u = this.state;
                                    this._state = s, d.b.log("main stream:" + u + "->" + s), this.hls.trigger(p.a.STREAM_STATE_TRANSITION, {
                                        previousState: u,
                                        nextState: s
                                    });
                                }
                            },
                            get: function() {
                                return this._state;
                            }
                        },
                        {
                            key: "currentLevel",
                            get: function() {
                                var s = this.media;
                                if (s) {
                                    var u = this.getBufferedFrag(s.currentTime);
                                    if (u) return u.level;
                                }
                                return -1;
                            }
                        },
                        {
                            key: "nextBufferedFrag",
                            get: function() {
                                var s = this.media;
                                return s ? this.followingBufferedFrag(this.getBufferedFrag(s.currentTime)) : null;
                            }
                        },
                        {
                            key: "nextLevel",
                            get: function() {
                                var s = this.nextBufferedFrag;
                                return s ? s.level : -1;
                            }
                        },
                        {
                            key: "liveSyncPosition",
                            get: function() {
                                return this._liveSyncPosition;
                            },
                            set: function(s) {
                                this._liveSyncPosition = s;
                            }
                        }
                    ]), o;
                }(O), rt = Ue, it = /* @__PURE__ */ function() {
                    function g(o, l) {
                        for(var s = 0; s < l.length; s++){
                            var u = l[s];
                            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
                        }
                    }
                    return function(o, l, s) {
                        return l && g(o.prototype, l), s && g(o, s), o;
                    };
                }();
                function qe(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function Je(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function Te(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var at = function(g) {
                    Te(o, g);
                    function o(l) {
                        qe(this, o);
                        var s = Je(this, g.call(this, l, p.a.MANIFEST_LOADED, p.a.LEVEL_LOADED, p.a.FRAG_LOADED, p.a.ERROR));
                        return s.canload = !1, s.currentLevelIndex = null, s.manualLevelIndex = -1, s.timer = null, s;
                    }
                    return o.prototype.destroy = function() {
                        this.cleanTimer(), this.manualLevelIndex = -1;
                    }, o.prototype.cleanTimer = function() {
                        this.timer !== null && (clearTimeout(this.timer), this.timer = null);
                    }, o.prototype.startLoad = function() {
                        var s = this._levels;
                        this.canload = !0, this.levelRetryCount = 0, s && s.forEach(function(u) {
                            u.loadError = 0;
                            var f = u.details;
                            f && f.live && (u.details = void 0);
                        }), this.timer !== null && this.loadLevel();
                    }, o.prototype.stopLoad = function() {
                        this.canload = !1;
                    }, o.prototype.onManifestLoaded = function(s) {
                        var u = [], f = void 0, E = {}, w = null, A = !1, S = !1, k = /chrome|firefox/.test(navigator.userAgent.toLowerCase()), B = [];
                        if (s.levels.forEach(function(F) {
                            F.loadError = 0, F.fragmentError = !1, A = A || !!F.videoCodec, S = S || !!F.audioCodec || !!(F.attrs && F.attrs.AUDIO), k === !0 && F.audioCodec && F.audioCodec.indexOf("mp4a.40.34") !== -1 && (F.audioCodec = void 0), w = E[F.bitrate], w === void 0 ? (F.url = [
                                F.url
                            ], F.urlId = 0, E[F.bitrate] = F, u.push(F)) : w.url.push(F.url);
                        }), A === !0 && S === !0 && (u = u.filter(function(F) {
                            var ee = F.videoCodec;
                            return !!ee;
                        })), u = u.filter(function(F) {
                            var ee = F.audioCodec, he = F.videoCodec;
                            return (!ee || fe(ee)) && (!he || fe(he));
                        }), s.audioTracks && (B = s.audioTracks.filter(function(F) {
                            return !F.audioCodec || fe(F.audioCodec, "audio");
                        })), u.length > 0) {
                            f = u[0].bitrate, u.sort(function(F, ee) {
                                return F.bitrate - ee.bitrate;
                            }), this._levels = u;
                            for(var U = 0; U < u.length; U++)if (u[U].bitrate === f) {
                                this._firstLevel = U, d.b.log("manifest loaded," + u.length + " level(s) found, first bitrate:" + f);
                                break;
                            }
                            this.hls.trigger(p.a.MANIFEST_PARSED, {
                                levels: u,
                                audioTracks: B,
                                firstLevel: this._firstLevel,
                                stats: s.stats,
                                audio: S,
                                video: A,
                                altAudio: B.length > 0
                            });
                        } else this.hls.trigger(p.a.ERROR, {
                            type: y.b.MEDIA_ERROR,
                            details: y.a.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                            fatal: !0,
                            url: this.hls.url,
                            reason: "no level with compatible codecs found in manifest"
                        });
                    }, o.prototype.setLevelInternal = function(s) {
                        var u = this._levels, f = this.hls;
                        if (s >= 0 && s < u.length) {
                            if (this.cleanTimer(), this.currentLevelIndex !== s) {
                                d.b.log("switching to level " + s), this.currentLevelIndex = s;
                                var E = u[s];
                                E.level = s, f.trigger(p.a.LEVEL_SWITCH, E), f.trigger(p.a.LEVEL_SWITCHING, E);
                            }
                            var w = u[s], A = w.details;
                            if (!A || A.live === !0) {
                                var S = w.urlId;
                                f.trigger(p.a.LEVEL_LOADING, {
                                    url: w.url[S],
                                    level: s,
                                    id: S
                                });
                            }
                        } else f.trigger(p.a.ERROR, {
                            type: y.b.OTHER_ERROR,
                            details: y.a.LEVEL_SWITCH_ERROR,
                            level: s,
                            fatal: !1,
                            reason: "invalid level idx"
                        });
                    }, o.prototype.onError = function(s) {
                        if (s.fatal === !0) {
                            s.type === y.b.NETWORK_ERROR && this.cleanTimer();
                            return;
                        }
                        var u = !1, f = !1, E = void 0;
                        switch(s.details){
                            case y.a.FRAG_LOAD_ERROR:
                            case y.a.FRAG_LOAD_TIMEOUT:
                            case y.a.FRAG_LOOP_LOADING_ERROR:
                            case y.a.KEY_LOAD_ERROR:
                            case y.a.KEY_LOAD_TIMEOUT:
                                E = s.frag.level, f = !0;
                                break;
                            case y.a.LEVEL_LOAD_ERROR:
                            case y.a.LEVEL_LOAD_TIMEOUT:
                                E = s.context.level, u = !0;
                                break;
                            case y.a.REMUX_ALLOC_ERROR:
                                E = s.level, u = !0;
                                break;
                        }
                        E !== void 0 && this.recoverLevel(s, E, u, f);
                    }, o.prototype.recoverLevel = function(s, u, f, E) {
                        var w = this, A = this.hls.config, S = s.details, k = this._levels[u], B = void 0, U = void 0, F = void 0;
                        if (k.loadError++, k.fragmentError = E, f === !0) {
                            if (this.levelRetryCount + 1 <= A.levelLoadingMaxRetry) U = Math.min(Math.pow(2, this.levelRetryCount) * A.levelLoadingRetryDelay, A.levelLoadingMaxRetryTimeout), this.timer = setTimeout(function() {
                                return w.loadLevel();
                            }, U), s.levelRetry = !0, this.levelRetryCount++, d.b.warn("level controller, " + S + ", retry in " + U + " ms, current retry count is " + this.levelRetryCount);
                            else {
                                d.b.error("level controller, cannot recover from " + S + " error"), this.currentLevelIndex = null, this.cleanTimer(), s.fatal = !0;
                                return;
                            }
                        }
                        (f === !0 || E === !0) && (B = k.url.length, B > 1 && k.loadError < B ? (d.b.warn("level controller, " + S + " for level " + u + ": switching to redundant stream id " + k.urlId), k.urlId = (k.urlId + 1) % B, k.details = void 0) : this.manualLevelIndex === -1 ? (F = u === 0 ? this._levels.length - 1 : u - 1, d.b.warn("level controller, " + S + ": switch to " + F), this.hls.nextAutoLevel = this.currentLevelIndex = F) : E === !0 && (d.b.warn("level controller, " + S + ": reload a fragment"), this.currentLevelIndex = null));
                    }, o.prototype.onFragLoaded = function(s) {
                        var u = s.frag;
                        if (u !== void 0 && u.type === "main") {
                            var f = this._levels[u.level];
                            f !== void 0 && (f.fragmentError = !1, f.loadError = 0, this.levelRetryCount = 0);
                        }
                    }, o.prototype.onLevelLoaded = function(s) {
                        var u = this, f = s.level;
                        if (f === this.currentLevelIndex) {
                            var E = this._levels[f];
                            E.fragmentError === !1 && (E.loadError = 0, this.levelRetryCount = 0);
                            var w = s.details;
                            if (w.live) {
                                var A = 1e3 * (w.averagetargetduration ? w.averagetargetduration : w.targetduration), S = E.details;
                                S && w.endSN === S.endSN && (A /= 2, d.b.log("same live playlist, reload twice faster")), A -= performance.now() - s.stats.trequest, A = Math.max(1e3, Math.round(A)), d.b.log("live playlist, reload in " + A + " ms"), this.timer = setTimeout(function() {
                                    return u.loadLevel();
                                }, A);
                            } else this.cleanTimer();
                        }
                    }, o.prototype.loadLevel = function() {
                        var s = void 0, u = void 0;
                        this.currentLevelIndex !== null && this.canload === !0 && (s = this._levels[this.currentLevelIndex], s !== void 0 && s.url.length > 0 && (u = s.urlId, this.hls.trigger(p.a.LEVEL_LOADING, {
                            url: s.url[u],
                            level: this.currentLevelIndex,
                            id: u
                        })));
                    }, it(o, [
                        {
                            key: "levels",
                            get: function() {
                                return this._levels;
                            }
                        },
                        {
                            key: "level",
                            get: function() {
                                return this.currentLevelIndex;
                            },
                            set: function(s) {
                                var u = this._levels;
                                u && (s = Math.min(s, u.length - 1), (this.currentLevelIndex !== s || u[s].details === void 0) && this.setLevelInternal(s));
                            }
                        },
                        {
                            key: "manualLevel",
                            get: function() {
                                return this.manualLevelIndex;
                            },
                            set: function(s) {
                                this.manualLevelIndex = s, this._startLevel === void 0 && (this._startLevel = s), s !== -1 && (this.level = s);
                            }
                        },
                        {
                            key: "firstLevel",
                            get: function() {
                                return this._firstLevel;
                            },
                            set: function(s) {
                                this._firstLevel = s;
                            }
                        },
                        {
                            key: "startLevel",
                            get: function() {
                                if (this._startLevel === void 0) {
                                    var s = this.hls.config.startLevel;
                                    return s !== void 0 ? s : this._firstLevel;
                                } else return this._startLevel;
                            },
                            set: function(s) {
                                this._startLevel = s;
                            }
                        },
                        {
                            key: "nextLoadLevel",
                            get: function() {
                                return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
                            },
                            set: function(s) {
                                this.level = s, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = s);
                            }
                        }
                    ]), o;
                }(O), _t = at, nt = a(3);
                function At(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function Lt(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function ir(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var It = function(g) {
                    ir(o, g);
                    function o(l) {
                        At(this, o);
                        var s = Lt(this, g.call(this, l, p.a.MEDIA_ATTACHED, p.a.MEDIA_DETACHING, p.a.FRAG_PARSING_METADATA));
                        return s.id3Track = void 0, s.media = void 0, s;
                    }
                    return o.prototype.destroy = function() {
                        O.prototype.destroy.call(this);
                    }, o.prototype.onMediaAttached = function(s) {
                        this.media = s.media, this.media;
                    }, o.prototype.onMediaDetaching = function() {
                        this.media = void 0;
                    }, o.prototype.onFragParsingMetadata = function(s) {
                        var u = s.frag, f = s.samples;
                        this.id3Track || (this.id3Track = this.media.addTextTrack("metadata", "id3"), this.id3Track.mode = "hidden");
                        for(var E = window.WebKitDataCue || window.VTTCue || window.TextTrackCue, w = 0; w < f.length; w++){
                            var A = nt.a.getID3Frames(f[w].data);
                            if (A) {
                                var S = f[w].pts, k = w < f.length - 1 ? f[w + 1].pts : u.endPTS;
                                S === k && (k += 1e-4);
                                for(var B = 0; B < A.length; B++){
                                    var U = A[B];
                                    if (!nt.a.isTimeStampFrame(U)) {
                                        var F = new E(S, k, "");
                                        F.value = U, this.id3Track.addCue(F);
                                    }
                                }
                            }
                        }
                    }, o;
                }(O), br = It;
                function Xt() {
                    var g = Zs(), o = window.SourceBuffer || window.WebKitSourceBuffer, l = g && typeof g.isTypeSupported == "function" && g.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), s = !o || o.prototype && typeof o.prototype.appendBuffer == "function" && typeof o.prototype.remove == "function";
                    return !!l && !!s;
                }
                function nr(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var _i = function() {
                    function g(o) {
                        nr(this, g), this.alpha_ = o ? Math.exp(Math.log(0.5) / o) : 0, this.estimate_ = 0, this.totalWeight_ = 0;
                    }
                    return g.prototype.sample = function(l, s) {
                        var u = Math.pow(this.alpha_, l);
                        this.estimate_ = s * (1 - u) + u * this.estimate_, this.totalWeight_ += l;
                    }, g.prototype.getTotalWeight = function() {
                        return this.totalWeight_;
                    }, g.prototype.getEstimate = function() {
                        if (this.alpha_) {
                            var l = 1 - Math.pow(this.alpha_, this.totalWeight_);
                            return this.estimate_ / l;
                        } else return this.estimate_;
                    }, g;
                }(), wi = _i;
                function Cn(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var Ht = function() {
                    function g(o, l, s, u) {
                        Cn(this, g), this.hls = o, this.defaultEstimate_ = u, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new wi(l), this.fast_ = new wi(s);
                    }
                    return g.prototype.sample = function(l, s) {
                        l = Math.max(l, this.minDelayMs_);
                        var u = 8e3 * s / l, f = l / 1e3;
                        this.fast_.sample(f, u), this.slow_.sample(f, u);
                    }, g.prototype.canEstimate = function() {
                        var l = this.fast_;
                        return l && l.getTotalWeight() >= this.minWeight_;
                    }, g.prototype.getEstimate = function() {
                        return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
                    }, g.prototype.destroy = function() {}, g;
                }(), wt = Ht, Ir = /* @__PURE__ */ function() {
                    function g(o, l) {
                        for(var s = 0; s < l.length; s++){
                            var u = l[s];
                            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
                        }
                    }
                    return function(o, l, s) {
                        return l && g(o.prototype, l), s && g(o, s), o;
                    };
                }();
                function Ti(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function Hr(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function Ln(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var cs = function(g) {
                    Ln(o, g);
                    function o(l) {
                        Ti(this, o);
                        var s = Hr(this, g.call(this, l, p.a.FRAG_LOADING, p.a.FRAG_LOADED, p.a.FRAG_BUFFERED, p.a.ERROR));
                        return s.lastLoadedFragLevel = 0, s._nextAutoLevel = -1, s.hls = l, s.timer = null, s._bwEstimator = null, s.onCheck = s._abandonRulesCheck.bind(s), s;
                    }
                    return o.prototype.destroy = function() {
                        this.clearTimer(), O.prototype.destroy.call(this);
                    }, o.prototype.onFragLoading = function(s) {
                        var u = s.frag;
                        if (u.type === "main") {
                            if (this.timer || (this.timer = setInterval(this.onCheck, 100)), !this._bwEstimator) {
                                var f = this.hls, E = s.frag.level, w = f.levels[E].details.live, A = f.config, S = void 0, k = void 0;
                                w ? (S = A.abrEwmaFastLive, k = A.abrEwmaSlowLive) : (S = A.abrEwmaFastVoD, k = A.abrEwmaSlowVoD), this._bwEstimator = new wt(f, k, S, A.abrEwmaDefaultEstimate);
                            }
                            this.fragCurrent = u;
                        }
                    }, o.prototype._abandonRulesCheck = function() {
                        var s = this.hls, u = s.media, f = this.fragCurrent, E = f.loader, w = s.minAutoLevel;
                        if (!E || E.stats && E.stats.aborted) {
                            d.b.warn("frag loader destroy or aborted, disarm abandonRules"), this.clearTimer(), this._nextAutoLevel = -1;
                            return;
                        }
                        var A = E.stats;
                        if (u && A && (!u.paused && u.playbackRate !== 0 || !u.readyState) && f.autoLevel && f.level) {
                            var S = performance.now() - A.trequest, k = Math.abs(u.playbackRate);
                            if (S > 500 * f.duration / k) {
                                var B = s.levels, U = Math.max(1, A.bw ? A.bw / 8 : A.loaded * 1e3 / S), F = B[f.level], ee = F.realBitrate ? Math.max(F.realBitrate, F.bitrate) : F.bitrate, he = A.total ? A.total : Math.max(A.loaded, Math.round(f.duration * ee / 8)), ge = u.currentTime, be = (he - A.loaded) / U, Se = (ht.bufferInfo(u, ge, s.config.maxBufferHole).end - ge) / k;
                                if (Se < 2 * f.duration / k && be > Se) {
                                    var Ce = void 0, Ie = void 0;
                                    for(Ie = f.level - 1; Ie > w; Ie--){
                                        var Ye = B[Ie].realBitrate ? Math.max(B[Ie].realBitrate, B[Ie].bitrate) : B[Ie].bitrate;
                                        if (Ce = f.duration * Ye / (6.4 * U), Ce < Se) break;
                                    }
                                    Ce < be && (d.b.warn("loading too slow, abort fragment loading and switch to level " + Ie + ":fragLoadedDelay[" + Ie + "]<fragLoadedDelay[" + (f.level - 1) + "];bufferStarvationDelay:" + Ce.toFixed(1) + "<" + be.toFixed(1) + ":" + Se.toFixed(1)), s.nextLoadLevel = Ie, this._bwEstimator.sample(S, A.loaded), E.abort(), this.clearTimer(), s.trigger(p.a.FRAG_LOAD_EMERGENCY_ABORTED, {
                                        frag: f,
                                        stats: A
                                    }));
                                }
                            }
                        }
                    }, o.prototype.onFragLoaded = function(s) {
                        var u = s.frag;
                        if (u.type === "main" && !isNaN(u.sn)) {
                            if (this.clearTimer(), this.lastLoadedFragLevel = u.level, this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
                                var f = this.hls.levels[u.level], E = (f.loaded ? f.loaded.bytes : 0) + s.stats.loaded, w = (f.loaded ? f.loaded.duration : 0) + s.frag.duration;
                                f.loaded = {
                                    bytes: E,
                                    duration: w
                                }, f.realBitrate = Math.round(8 * E / w);
                            }
                            if (s.frag.bitrateTest) {
                                var A = s.stats;
                                A.tparsed = A.tbuffered = A.tload, this.onFragBuffered(s);
                            }
                        }
                    }, o.prototype.onFragBuffered = function(s) {
                        var u = s.stats, f = s.frag;
                        if (u.aborted !== !0 && f.loadCounter === 1 && f.type === "main" && !isNaN(f.sn) && (!f.bitrateTest || u.tload === u.tbuffered)) {
                            var E = u.tparsed - u.trequest;
                            d.b.log("latency/loading/parsing/append/kbps:" + Math.round(u.tfirst - u.trequest) + "/" + Math.round(u.tload - u.tfirst) + "/" + Math.round(u.tparsed - u.tload) + "/" + Math.round(u.tbuffered - u.tparsed) + "/" + Math.round(8 * u.loaded / (u.tbuffered - u.trequest))), this._bwEstimator.sample(E, u.loaded), u.bwEstimate = this._bwEstimator.getEstimate(), f.bitrateTest ? this.bitrateTestDelay = E / 1e3 : this.bitrateTestDelay = 0;
                        }
                    }, o.prototype.onError = function(s) {
                        switch(s.details){
                            case y.a.FRAG_LOAD_ERROR:
                            case y.a.FRAG_LOAD_TIMEOUT:
                                this.clearTimer();
                                break;
                        }
                    }, o.prototype.clearTimer = function() {
                        clearInterval(this.timer), this.timer = null;
                    }, o.prototype._findBestLevel = function(s, u, f, E, w, A, S, k, B) {
                        for(var U = w; U >= E; U--){
                            var F = B[U], ee = F.details, he = ee ? ee.totalduration / ee.fragments.length : u, ge = ee ? ee.live : !1, be = void 0;
                            U <= s ? be = S * f : be = k * f;
                            var Se = B[U].realBitrate ? Math.max(B[U].realBitrate, B[U].bitrate) : B[U].bitrate, Ce = Se * he / be;
                            if (d.b.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + U + "/" + Math.round(be) + "/" + Se + "/" + he + "/" + A + "/" + Ce), be > Se && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
                            // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
                            // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that _findBestLevel will return -1
                            (!Ce || ge && !this.bitrateTestDelay || Ce < A)) return U;
                        }
                        return -1;
                    }, Ir(o, [
                        {
                            key: "nextAutoLevel",
                            get: function() {
                                var s = this._nextAutoLevel, u = this._bwEstimator;
                                if (s !== -1 && (!u || !u.canEstimate())) return s;
                                var f = this._nextABRAutoLevel;
                                return s !== -1 && (f = Math.min(s, f)), f;
                            },
                            set: function(s) {
                                this._nextAutoLevel = s;
                            }
                        },
                        {
                            key: "_nextABRAutoLevel",
                            get: function() {
                                var s = this.hls, u = s.maxAutoLevel, f = s.levels, E = s.config, w = s.minAutoLevel, A = s.media, S = this.lastLoadedFragLevel, k = this.fragCurrent ? this.fragCurrent.duration : 0, B = A ? A.currentTime : 0, U = A && A.playbackRate !== 0 ? Math.abs(A.playbackRate) : 1, F = this._bwEstimator ? this._bwEstimator.getEstimate() : E.abrEwmaDefaultEstimate, ee = (ht.bufferInfo(A, B, E.maxBufferHole).end - B) / U, he = this._findBestLevel(S, k, F, w, u, ee, E.abrBandWidthFactor, E.abrBandWidthUpFactor, f);
                                if (he >= 0) return he;
                                d.b.trace("rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering");
                                var ge = k ? Math.min(k, E.maxStarvationDelay) : E.maxStarvationDelay, be = E.abrBandWidthFactor, Se = E.abrBandWidthUpFactor;
                                if (ee === 0) {
                                    var Ce = this.bitrateTestDelay;
                                    if (Ce) {
                                        var Ie = k ? Math.min(k, E.maxLoadingDelay) : E.maxLoadingDelay;
                                        ge = Ie - Ce, d.b.trace("bitrate test took " + Math.round(1e3 * Ce) + "ms, set first fragment max fetchDuration to " + Math.round(1e3 * ge) + " ms"), be = Se = 1;
                                    }
                                }
                                return he = this._findBestLevel(S, k, F, w, u, ee + ge, be, Se, f), Math.max(he, 0);
                            }
                        }
                    ]), o;
                }(O), kn = cs;
                function Dn(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function Zr(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function rn(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var Si = Zs(), ds = function(g) {
                    rn(o, g);
                    function o(l) {
                        Dn(this, o);
                        var s = Zr(this, g.call(this, l, p.a.MEDIA_ATTACHING, p.a.MEDIA_DETACHING, p.a.MANIFEST_PARSED, p.a.BUFFER_RESET, p.a.BUFFER_APPENDING, p.a.BUFFER_CODECS, p.a.BUFFER_EOS, p.a.BUFFER_FLUSHING, p.a.LEVEL_PTS_UPDATED, p.a.LEVEL_UPDATED));
                        return s._msDuration = null, s._levelDuration = null, s._live = null, s._objectUrl = null, s.onsbue = s.onSBUpdateEnd.bind(s), s.onsbe = s.onSBUpdateError.bind(s), s.pendingTracks = {}, s.tracks = {}, s;
                    }
                    return o.prototype.destroy = function() {
                        O.prototype.destroy.call(this);
                    }, o.prototype.onLevelPtsUpdated = function(s) {
                        var u = s.type, f = this.tracks.audio;
                        if (u === "audio" && f && f.container === "audio/mpeg") {
                            var E = this.sourceBuffer.audio, w = Math.abs(E.timestampOffset - s.start);
                            if (w > 0.1) {
                                var A = E.updating;
                                try {
                                    E.abort();
                                } catch (S) {
                                    A = !0, d.b.warn("can not abort audio buffer: " + S);
                                }
                                A ? this.audioTimestampOffset = s.start : (d.b.warn("change mpeg audio timestamp offset from " + E.timestampOffset + " to " + s.start), E.timestampOffset = s.start);
                            }
                        }
                    }, o.prototype.onManifestParsed = function(s) {
                        var u = s.audio, f = s.video || s.levels.length && s.audio, E = 0;
                        s.altAudio && (u || f) && (E = (u ? 1 : 0) + (f ? 1 : 0), d.b.log(E + " sourceBuffer(s) expected")), this.sourceBufferNb = E;
                    }, o.prototype.onMediaAttaching = function(s) {
                        var u = this.media = s.media;
                        if (u) {
                            var f = this.mediaSource = new Si();
                            this.onmso = this.onMediaSourceOpen.bind(this), this.onmse = this.onMediaSourceEnded.bind(this), this.onmsc = this.onMediaSourceClose.bind(this), f.addEventListener("sourceopen", this.onmso), f.addEventListener("sourceended", this.onmse), f.addEventListener("sourceclose", this.onmsc), u.src = URL.createObjectURL(f), this._objectUrl = u.src;
                        }
                    }, o.prototype.onMediaDetaching = function() {
                        d.b.log("media source detaching");
                        var s = this.mediaSource;
                        if (s) {
                            if (s.readyState === "open") try {
                                s.endOfStream();
                            } catch (u) {
                                d.b.warn("onMediaDetaching:" + u.message + " while calling endOfStream");
                            }
                            s.removeEventListener("sourceopen", this.onmso), s.removeEventListener("sourceended", this.onmse), s.removeEventListener("sourceclose", this.onmsc), this.media && (URL.revokeObjectURL(this._objectUrl), this.media.src === this._objectUrl ? (this.media.removeAttribute("src"), this.media.load()) : d.b.warn("media.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.pendingTracks = {}, this.tracks = {}, this.sourceBuffer = {}, this.flushRange = [], this.segments = [], this.appended = 0;
                        }
                        this.onmso = this.onmse = this.onmsc = null, this.hls.trigger(p.a.MEDIA_DETACHED);
                    }, o.prototype.onMediaSourceOpen = function() {
                        d.b.log("media source opened"), this.hls.trigger(p.a.MEDIA_ATTACHED, {
                            media: this.media
                        });
                        var s = this.mediaSource;
                        s && s.removeEventListener("sourceopen", this.onmso), this.checkPendingTracks();
                    }, o.prototype.checkPendingTracks = function() {
                        var s = this.pendingTracks, u = Object.keys(s).length;
                        u && (this.sourceBufferNb <= u || this.sourceBufferNb === 0) && (this.createSourceBuffers(s), this.pendingTracks = {}, this.doAppending());
                    }, o.prototype.onMediaSourceClose = function() {
                        d.b.log("media source closed");
                    }, o.prototype.onMediaSourceEnded = function() {
                        d.b.log("media source ended");
                    }, o.prototype.onSBUpdateEnd = function() {
                        if (this.audioTimestampOffset) {
                            var s = this.sourceBuffer.audio;
                            d.b.warn("change mpeg audio timestamp offset from " + s.timestampOffset + " to " + this.audioTimestampOffset), s.timestampOffset = this.audioTimestampOffset, delete this.audioTimestampOffset;
                        }
                        this._needsFlush && this.doFlush(), this._needsEos && this.checkEos(), this.appending = !1;
                        var u = this.parent, f = this.segments.reduce(function(E, w) {
                            return w.parent === u ? E + 1 : E;
                        }, 0);
                        this.hls.trigger(p.a.BUFFER_APPENDED, {
                            parent: u,
                            pending: f
                        }), this._needsFlush || this.doAppending(), this.updateMediaElementDuration();
                    }, o.prototype.onSBUpdateError = function(s) {
                        d.b.error("sourceBuffer error:", s), this.hls.trigger(p.a.ERROR, {
                            type: y.b.MEDIA_ERROR,
                            details: y.a.BUFFER_APPENDING_ERROR,
                            fatal: !1
                        });
                    }, o.prototype.onBufferReset = function() {
                        var s = this.sourceBuffer;
                        for(var u in s){
                            var f = s[u];
                            try {
                                this.mediaSource.removeSourceBuffer(f), f.removeEventListener("updateend", this.onsbue), f.removeEventListener("error", this.onsbe);
                            } catch  {}
                        }
                        this.sourceBuffer = {}, this.flushRange = [], this.segments = [], this.appended = 0;
                    }, o.prototype.onBufferCodecs = function(s) {
                        if (Object.keys(this.sourceBuffer).length === 0) {
                            for(var u in s)this.pendingTracks[u] = s[u];
                            var f = this.mediaSource;
                            f && f.readyState === "open" && this.checkPendingTracks();
                        }
                    }, o.prototype.createSourceBuffers = function(s) {
                        var u = this.sourceBuffer, f = this.mediaSource;
                        for(var E in s)if (!u[E]) {
                            var w = s[E], A = w.levelCodec || w.codec, S = w.container + ";codecs=" + A;
                            d.b.log("creating sourceBuffer(" + S + ")");
                            try {
                                var k = u[E] = f.addSourceBuffer(S);
                                k.addEventListener("updateend", this.onsbue), k.addEventListener("error", this.onsbe), this.tracks[E] = {
                                    codec: A,
                                    container: w.container
                                }, w.buffer = k;
                            } catch (B) {
                                d.b.error("error while trying to add sourceBuffer:" + B.message), this.hls.trigger(p.a.ERROR, {
                                    type: y.b.MEDIA_ERROR,
                                    details: y.a.BUFFER_ADD_CODEC_ERROR,
                                    fatal: !1,
                                    err: B,
                                    mimeType: S
                                });
                            }
                        }
                        this.hls.trigger(p.a.BUFFER_CREATED, {
                            tracks: s
                        });
                    }, o.prototype.onBufferAppending = function(s) {
                        this._needsFlush || (this.segments ? this.segments.push(s) : this.segments = [
                            s
                        ], this.doAppending());
                    }, o.prototype.onBufferAppendFail = function(s) {
                        d.b.error("sourceBuffer error:", s.event), this.hls.trigger(p.a.ERROR, {
                            type: y.b.MEDIA_ERROR,
                            details: y.a.BUFFER_APPENDING_ERROR,
                            fatal: !1
                        });
                    }, o.prototype.onBufferEos = function(s) {
                        var u = this.sourceBuffer, f = s.type;
                        for(var E in u)(!f || E === f) && (u[E].ended || (u[E].ended = !0, d.b.log(E + " sourceBuffer now EOS")));
                        this.checkEos();
                    }, o.prototype.checkEos = function() {
                        var s = this.sourceBuffer, u = this.mediaSource;
                        if (!u || u.readyState !== "open") {
                            this._needsEos = !1;
                            return;
                        }
                        for(var f in s){
                            var E = s[f];
                            if (!E.ended) return;
                            if (E.updating) {
                                this._needsEos = !0;
                                return;
                            }
                        }
                        d.b.log("all media data available, signal endOfStream() to MediaSource and stop loading fragment");
                        try {
                            u.endOfStream();
                        } catch  {
                            d.b.warn("exception while calling mediaSource.endOfStream()");
                        }
                        this._needsEos = !1;
                    }, o.prototype.onBufferFlushing = function(s) {
                        this.flushRange.push({
                            start: s.startOffset,
                            end: s.endOffset,
                            type: s.type
                        }), this.flushBufferCounter = 0, this.doFlush();
                    }, o.prototype.onLevelUpdated = function(s) {
                        var u = s.details;
                        u.fragments.length > 0 && (this._levelDuration = u.totalduration + u.fragments[0].start, this._live = u.live, this.updateMediaElementDuration());
                    }, o.prototype.updateMediaElementDuration = function() {
                        var s = this.hls.config, u = void 0;
                        if (!(this._levelDuration === null || !this.media || !this.mediaSource || !this.sourceBuffer || this.media.readyState === 0 || this.mediaSource.readyState !== "open")) {
                            for(var f in this.sourceBuffer)if (this.sourceBuffer[f].updating === !0) return;
                            u = this.media.duration, this._msDuration === null && (this._msDuration = this.mediaSource.duration), this._live === !0 && s.liveDurationInfinity === !0 ? (d.b.log("Media Source duration is set to Infinity"), this._msDuration = this.mediaSource.duration = 1 / 0) : (this._levelDuration > this._msDuration && this._levelDuration > u || u === 1 / 0 || isNaN(u)) && (d.b.log("Updating Media Source duration to " + this._levelDuration.toFixed(3)), this._msDuration = this.mediaSource.duration = this._levelDuration);
                        }
                    }, o.prototype.doFlush = function() {
                        for(; this.flushRange.length;){
                            var s = this.flushRange[0];
                            if (this.flushBuffer(s.start, s.end, s.type)) this.flushRange.shift(), this.flushBufferCounter = 0;
                            else {
                                this._needsFlush = !0;
                                return;
                            }
                        }
                        if (this.flushRange.length === 0) {
                            this._needsFlush = !1;
                            var u = 0, f = this.sourceBuffer;
                            try {
                                for(var E in f)u += f[E].buffered.length;
                            } catch  {
                                d.b.error("error while accessing sourceBuffer.buffered");
                            }
                            this.appended = u, this.hls.trigger(p.a.BUFFER_FLUSHED);
                        }
                    }, o.prototype.doAppending = function() {
                        var s = this.hls, u = this.sourceBuffer, f = this.segments;
                        if (Object.keys(u).length) {
                            if (this.media.error) {
                                this.segments = [], d.b.error("trying to append although a media error occured, flush segment and abort");
                                return;
                            }
                            if (this.appending) return;
                            if (f && f.length) {
                                var E = f.shift();
                                try {
                                    var w = E.type, A = u[w];
                                    A ? A.updating ? f.unshift(E) : (A.ended = !1, this.parent = E.parent, A.appendBuffer(E.data), this.appendError = 0, this.appended++, this.appending = !0) : this.onSBUpdateEnd();
                                } catch (k) {
                                    d.b.error("error while trying to append buffer:" + k.message), f.unshift(E);
                                    var S = {
                                        type: y.b.MEDIA_ERROR,
                                        parent: E.parent
                                    };
                                    if (k.code !== 22) {
                                        if (this.appendError ? this.appendError++ : this.appendError = 1, S.details = y.a.BUFFER_APPEND_ERROR, this.appendError > s.config.appendErrorMaxRetry) {
                                            d.b.log("fail " + s.config.appendErrorMaxRetry + " times to append segment in sourceBuffer"), f = [], S.fatal = !0, s.trigger(p.a.ERROR, S);
                                            return;
                                        } else S.fatal = !1, s.trigger(p.a.ERROR, S);
                                    } else {
                                        this.segments = [], S.details = y.a.BUFFER_FULL_ERROR, S.fatal = !1, s.trigger(p.a.ERROR, S);
                                        return;
                                    }
                                }
                            }
                        }
                    }, o.prototype.flushBuffer = function(s, u, f) {
                        var E, w, A, S, k, B, U = this.sourceBuffer;
                        if (Object.keys(U).length) {
                            if (d.b.log("flushBuffer,pos/start/end: " + this.media.currentTime.toFixed(3) + "/" + s + "/" + u), this.flushBufferCounter < this.appended) {
                                for(var F in U)if (!(f && F !== f)) {
                                    if (E = U[F], E.ended = !1, E.updating) return d.b.warn("cannot flush, sb updating in progress"), !1;
                                    try {
                                        for(w = 0; w < E.buffered.length; w++)if (A = E.buffered.start(w), S = E.buffered.end(w), navigator.userAgent.toLowerCase().indexOf("firefox") !== -1 && u === Number.POSITIVE_INFINITY ? (k = s, B = u) : (k = Math.max(A, s), B = Math.min(S, u)), Math.min(B, S) - k > 0.5) return this.flushBufferCounter++, d.b.log("flush " + F + " [" + k + "," + B + "], of [" + A + "," + S + "], pos:" + this.media.currentTime), E.remove(k, B), !1;
                                    } catch  {
                                        d.b.warn("exception while accessing sourcebuffer, it might have been removed from MediaSource");
                                    }
                                }
                            } else d.b.warn("abort flushing too many retries");
                            d.b.log("buffer flushed");
                        }
                        return !0;
                    }, o;
                }(O), Wr = ds, Qu = /* @__PURE__ */ function() {
                    function g(o, l) {
                        for(var s = 0; s < l.length; s++){
                            var u = l[s];
                            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
                        }
                    }
                    return function(o, l, s) {
                        return l && g(o.prototype, l), s && g(o, s), o;
                    };
                }();
                function Ys(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function ec(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function Gl(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var ql = function(g) {
                    Gl(o, g);
                    function o(l) {
                        return Ys(this, o), ec(this, g.call(this, l, p.a.FPS_DROP_LEVEL_CAPPING, p.a.MEDIA_ATTACHING, p.a.MANIFEST_PARSED));
                    }
                    return o.prototype.destroy = function() {
                        this.hls.config.capLevelToPlayerSize && (this.media = this.restrictedLevels = null, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (this.timer = clearInterval(this.timer)));
                    }, o.prototype.onFpsDropLevelCapping = function(s) {
                        o.isLevelAllowed(s.droppedLevel, this.restrictedLevels) && this.restrictedLevels.push(s.droppedLevel);
                    }, o.prototype.onMediaAttaching = function(s) {
                        this.media = s.media instanceof HTMLVideoElement ? s.media : null;
                    }, o.prototype.onManifestParsed = function(s) {
                        var u = this.hls;
                        this.restrictedLevels = [], u.config.capLevelToPlayerSize && (this.autoLevelCapping = Number.POSITIVE_INFINITY, this.levels = s.levels, u.firstLevel = this.getMaxLevel(s.firstLevel), clearInterval(this.timer), this.timer = setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
                    }, o.prototype.detectPlayerSize = function() {
                        if (this.media) {
                            var s = this.levels ? this.levels.length : 0;
                            if (s) {
                                var u = this.hls;
                                u.autoLevelCapping = this.getMaxLevel(s - 1), u.autoLevelCapping > this.autoLevelCapping && u.streamController.nextLevelSwitch(), this.autoLevelCapping = u.autoLevelCapping;
                            }
                        }
                    }, o.prototype.getMaxLevel = function(s) {
                        var u = this;
                        if (!this.levels) return -1;
                        var f = this.levels.filter(function(E, w) {
                            return o.isLevelAllowed(w, u.restrictedLevels) && w <= s;
                        });
                        return o.getMaxLevelByMediaSize(f, this.mediaWidth, this.mediaHeight);
                    }, o.isLevelAllowed = function(s) {
                        var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                        return u.indexOf(s) === -1;
                    }, o.getMaxLevelByMediaSize = function(s, u, f) {
                        if (!s || s && !s.length) return -1;
                        for(var E = function(B, U) {
                            return U ? B.width !== U.width || B.height !== U.height : !0;
                        }, w = s.length - 1, A = 0; A < s.length; A += 1){
                            var S = s[A];
                            if ((S.width >= u || S.height >= f) && E(S, s[A + 1])) {
                                w = A;
                                break;
                            }
                        }
                        return w;
                    }, Qu(o, [
                        {
                            key: "mediaWidth",
                            get: function() {
                                var s = void 0, u = this.media;
                                return u && (s = u.width || u.clientWidth || u.offsetWidth, s *= o.contentScaleFactor), s;
                            }
                        },
                        {
                            key: "mediaHeight",
                            get: function() {
                                var s = void 0, u = this.media;
                                return u && (s = u.height || u.clientHeight || u.offsetHeight, s *= o.contentScaleFactor), s;
                            }
                        }
                    ], [
                        {
                            key: "contentScaleFactor",
                            get: function() {
                                var s = 1;
                                try {
                                    s = window.devicePixelRatio;
                                } catch  {}
                                return s;
                            }
                        }
                    ]), o;
                }(O), gr = ql;
                function nn(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function zl(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function Xl(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var Wm = function(g) {
                    Xl(o, g);
                    function o(l) {
                        return nn(this, o), zl(this, g.call(this, l, p.a.MEDIA_ATTACHING));
                    }
                    return o.prototype.destroy = function() {
                        this.timer && clearInterval(this.timer), this.isVideoPlaybackQualityAvailable = !1;
                    }, o.prototype.onMediaAttaching = function(s) {
                        var u = this.hls.config;
                        if (u.capLevelOnFPSDrop) {
                            var f = this.video = s.media instanceof HTMLVideoElement ? s.media : null;
                            typeof f.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), clearInterval(this.timer), this.timer = setInterval(this.checkFPSInterval.bind(this), u.fpsDroppedMonitoringPeriod);
                        }
                    }, o.prototype.checkFPS = function(s, u, f) {
                        var E = performance.now();
                        if (u) {
                            if (this.lastTime) {
                                var w = E - this.lastTime, A = f - this.lastDroppedFrames, S = u - this.lastDecodedFrames, k = 1e3 * A / w, B = this.hls;
                                if (B.trigger(p.a.FPS_DROP, {
                                    currentDropped: A,
                                    currentDecoded: S,
                                    totalDroppedFrames: f
                                }), k > 0 && A > B.config.fpsDroppedMonitoringThreshold * S) {
                                    var U = B.currentLevel;
                                    d.b.warn("drop FPS ratio greater than max allowed value for currentLevel: " + U), U > 0 && (B.autoLevelCapping === -1 || B.autoLevelCapping >= U) && (U = U - 1, B.trigger(p.a.FPS_DROP_LEVEL_CAPPING, {
                                        level: U,
                                        droppedLevel: B.currentLevel
                                    }), B.autoLevelCapping = U, B.streamController.nextLevelSwitch());
                                }
                            }
                            this.lastTime = E, this.lastDroppedFrames = f, this.lastDecodedFrames = u;
                        }
                    }, o.prototype.checkFPSInterval = function() {
                        var s = this.video;
                        if (s) {
                            if (this.isVideoPlaybackQualityAvailable) {
                                var u = s.getVideoPlaybackQuality();
                                this.checkFPS(s, u.totalVideoFrames, u.droppedVideoFrames);
                            } else this.checkFPS(s, s.webkitDecodedFrameCount, s.webkitDroppedFrameCount);
                        }
                    }, o;
                }(O), Ym = Wm;
                function Jm(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var Qm = function() {
                    function g(o) {
                        Jm(this, g), o && o.xhrSetup && (this.xhrSetup = o.xhrSetup);
                    }
                    return g.prototype.destroy = function() {
                        this.abort(), this.loader = null;
                    }, g.prototype.abort = function() {
                        var l = this.loader;
                        l && l.readyState !== 4 && (this.stats.aborted = !0, l.abort()), window.clearTimeout(this.requestTimeout), this.requestTimeout = null, window.clearTimeout(this.retryTimeout), this.retryTimeout = null;
                    }, g.prototype.load = function(l, s, u) {
                        this.context = l, this.config = s, this.callbacks = u, this.stats = {
                            trequest: performance.now(),
                            retry: 0
                        }, this.retryDelay = s.retryDelay, this.loadInternal();
                    }, g.prototype.loadInternal = function() {
                        var l, s = this.context;
                        l = this.loader = new XMLHttpRequest();
                        var u = this.stats;
                        u.tfirst = 0, u.loaded = 0;
                        var f = this.xhrSetup;
                        try {
                            if (f) try {
                                f(l, s.url);
                            } catch  {
                                l.open("GET", s.url, !0), f(l, s.url);
                            }
                            l.readyState || l.open("GET", s.url, !0);
                        } catch (E) {
                            this.callbacks.onError({
                                code: l.status,
                                text: E.message
                            }, s, l);
                            return;
                        }
                        s.rangeEnd && l.setRequestHeader("Range", "bytes=" + s.rangeStart + "-" + (s.rangeEnd - 1)), l.onreadystatechange = this.readystatechange.bind(this), l.onprogress = this.loadprogress.bind(this), l.responseType = s.responseType, this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout), l.send();
                    }, g.prototype.readystatechange = function(l) {
                        var s = l.currentTarget, u = s.readyState, f = this.stats, E = this.context, w = this.config;
                        if (!f.aborted && u >= 2) {
                            if (window.clearTimeout(this.requestTimeout), f.tfirst === 0 && (f.tfirst = Math.max(performance.now(), f.trequest)), u === 4) {
                                var A = s.status;
                                if (A >= 200 && A < 300) {
                                    f.tload = Math.max(f.tfirst, performance.now());
                                    var S = void 0, k = void 0;
                                    E.responseType === "arraybuffer" ? (S = s.response, k = S.byteLength) : (S = s.responseText, k = S.length), f.loaded = f.total = k;
                                    var B = {
                                        url: s.responseURL,
                                        data: S
                                    };
                                    this.callbacks.onSuccess(B, f, E, s);
                                } else f.retry >= w.maxRetry || A >= 400 && A < 499 ? (d.b.error(A + " while loading " + E.url), this.callbacks.onError({
                                    code: A,
                                    text: s.statusText
                                }, E, s)) : (d.b.warn(A + " while loading " + E.url + ", retrying in " + this.retryDelay + "..."), this.destroy(), this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay), this.retryDelay = Math.min(2 * this.retryDelay, w.maxRetryDelay), f.retry++);
                            } else this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), w.timeout);
                        }
                    }, g.prototype.loadtimeout = function() {
                        d.b.warn("timeout while loading " + this.context.url), this.callbacks.onTimeout(this.stats, this.context, null);
                    }, g.prototype.loadprogress = function(l) {
                        var s = l.currentTarget, u = this.stats;
                        u.loaded = l.loaded, l.lengthComputable && (u.total = l.total);
                        var f = this.callbacks.onProgress;
                        f && f(u, this.context, null, s);
                    }, g;
                }(), ey = Qm, ty = /* @__PURE__ */ function() {
                    function g(o, l) {
                        for(var s = 0; s < l.length; s++){
                            var u = l[s];
                            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
                        }
                    }
                    return function(o, l, s) {
                        return l && g(o.prototype, l), s && g(o, s), o;
                    };
                }();
                function ry(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function iy(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function ny(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var sy = function(g) {
                    ny(o, g);
                    function o(l) {
                        ry(this, o);
                        var s = iy(this, g.call(this, l, p.a.MANIFEST_LOADING, p.a.MANIFEST_PARSED, p.a.AUDIO_TRACK_LOADED, p.a.ERROR));
                        return s.ticks = 0, s.ontick = s.tick.bind(s), s;
                    }
                    return o.prototype.destroy = function() {
                        this.cleanTimer(), O.prototype.destroy.call(this);
                    }, o.prototype.cleanTimer = function() {
                        this.timer && (clearTimeout(this.timer), this.timer = null);
                    }, o.prototype.tick = function() {
                        this.ticks++, this.ticks === 1 && (this.doTick(), this.ticks > 1 && setTimeout(this.tick, 1), this.ticks = 0);
                    }, o.prototype.doTick = function() {
                        this.updateTrack(this.trackId);
                    }, o.prototype.onError = function(s) {
                        s.fatal && s.type === y.b.NETWORK_ERROR && this.cleanTimer();
                    }, o.prototype.onManifestLoading = function() {
                        this.tracks = [], this.trackId = -1;
                    }, o.prototype.onManifestParsed = function(s) {
                        var u = this, f = s.audioTracks || [], E = !1;
                        this.tracks = f, this.hls.trigger(p.a.AUDIO_TRACKS_UPDATED, {
                            audioTracks: f
                        });
                        var w = 0;
                        f.forEach(function(A) {
                            if (A.default && !E) {
                                u.audioTrack = w, E = !0;
                                return;
                            }
                            w++;
                        }), E === !1 && f.length && (d.b.log("no default audio track defined, use first audio track as default"), this.audioTrack = 0);
                    }, o.prototype.onAudioTrackLoaded = function(s) {
                        s.id < this.tracks.length && (d.b.log("audioTrack " + s.id + " loaded"), this.tracks[s.id].details = s.details, s.details.live && !this.timer && (this.timer = setInterval(this.ontick, 1e3 * s.details.targetduration)), !s.details.live && this.timer && this.cleanTimer());
                    }, o.prototype.setAudioTrackInternal = function(s) {
                        if (s >= 0 && s < this.tracks.length) {
                            this.cleanTimer(), this.trackId = s, d.b.log("switching to audioTrack " + s);
                            var u = this.tracks[s], f = this.hls, E = u.type, w = u.url, A = {
                                id: s,
                                type: E,
                                url: w
                            };
                            f.trigger(p.a.AUDIO_TRACK_SWITCH, A), f.trigger(p.a.AUDIO_TRACK_SWITCHING, A);
                            var S = u.details;
                            w && (S === void 0 || S.live === !0) && (d.b.log("(re)loading playlist for audioTrack " + s), f.trigger(p.a.AUDIO_TRACK_LOADING, {
                                url: w,
                                id: s
                            }));
                        }
                    }, o.prototype.updateTrack = function(s) {
                        if (s >= 0 && s < this.tracks.length) {
                            this.cleanTimer(), this.trackId = s, d.b.log("updating audioTrack " + s);
                            var u = this.tracks[s], f = u.url, E = u.details;
                            f && (E === void 0 || E.live === !0) && (d.b.log("(re)loading playlist for audioTrack " + s), this.hls.trigger(p.a.AUDIO_TRACK_LOADING, {
                                url: f,
                                id: s
                            }));
                        }
                    }, ty(o, [
                        {
                            key: "audioTracks",
                            get: function() {
                                return this.tracks;
                            }
                        },
                        {
                            key: "audioTrack",
                            get: function() {
                                return this.trackId;
                            },
                            set: function(s) {
                                (this.trackId !== s || this.tracks[s].details === void 0) && this.setAudioTrackInternal(s);
                            }
                        }
                    ]), o;
                }(O), ay = sy, oy = /* @__PURE__ */ function() {
                    function g(o, l) {
                        for(var s = 0; s < l.length; s++){
                            var u = l[s];
                            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
                        }
                    }
                    return function(o, l, s) {
                        return l && g(o.prototype, l), s && g(o, s), o;
                    };
                }();
                function ly(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function uy(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function cy(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var Ee = {
                    STOPPED: "STOPPED",
                    STARTING: "STARTING",
                    IDLE: "IDLE",
                    PAUSED: "PAUSED",
                    KEY_LOADING: "KEY_LOADING",
                    FRAG_LOADING: "FRAG_LOADING",
                    FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
                    WAITING_TRACK: "WAITING_TRACK",
                    PARSING: "PARSING",
                    PARSED: "PARSED",
                    BUFFER_FLUSHING: "BUFFER_FLUSHING",
                    ENDED: "ENDED",
                    ERROR: "ERROR",
                    WAITING_INIT_PTS: "WAITING_INIT_PTS"
                }, dy = function(g) {
                    cy(o, g);
                    function o(l) {
                        ly(this, o);
                        var s = uy(this, g.call(this, l, p.a.MEDIA_ATTACHED, p.a.MEDIA_DETACHING, p.a.AUDIO_TRACKS_UPDATED, p.a.AUDIO_TRACK_SWITCHING, p.a.AUDIO_TRACK_LOADED, p.a.KEY_LOADED, p.a.FRAG_LOADED, p.a.FRAG_PARSING_INIT_SEGMENT, p.a.FRAG_PARSING_DATA, p.a.FRAG_PARSED, p.a.ERROR, p.a.BUFFER_RESET, p.a.BUFFER_CREATED, p.a.BUFFER_APPENDED, p.a.BUFFER_FLUSHED, p.a.INIT_PTS_FOUND));
                        return s.config = l.config, s.audioCodecSwap = !1, s.ticks = 0, s._state = Ee.STOPPED, s.ontick = s.tick.bind(s), s.initPTS = [], s.waitingFragment = null, s.videoTrackCC = null, s;
                    }
                    return o.prototype.destroy = function() {
                        this.stopLoad(), this.timer && (clearInterval(this.timer), this.timer = null), O.prototype.destroy.call(this), this.state = Ee.STOPPED;
                    }, o.prototype.onInitPtsFound = function(s) {
                        var u = s.id, f = s.frag.cc, E = s.initPTS;
                        u === "main" && (this.initPTS[f] = E, this.videoTrackCC = f, d.b.log("InitPTS for cc:" + f + " found from video track:" + E), this.state === Ee.WAITING_INIT_PTS && this.tick());
                    }, o.prototype.startLoad = function(s) {
                        if (this.tracks) {
                            var u = this.lastCurrentTime;
                            this.stopLoad(), this.timer || (this.timer = setInterval(this.ontick, 100)), this.fragLoadError = 0, u > 0 && s === -1 ? (d.b.log("audio:override startPosition with lastCurrentTime @" + u.toFixed(3)), this.state = Ee.IDLE) : (this.lastCurrentTime = this.startPosition ? this.startPosition : s, this.state = Ee.STARTING), this.nextLoadPosition = this.startPosition = this.lastCurrentTime, this.tick();
                        } else this.startPosition = s, this.state = Ee.STOPPED;
                    }, o.prototype.stopLoad = function() {
                        var s = this.fragCurrent;
                        s && (s.loader && s.loader.abort(), this.fragCurrent = null), this.fragPrevious = null, this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.state = Ee.STOPPED;
                    }, o.prototype.tick = function() {
                        this.ticks++, this.ticks === 1 && (this.doTick(), this.ticks > 1 && setTimeout(this.tick, 1), this.ticks = 0);
                    }, o.prototype.doTick = function() {
                        var s, u, f, E = this.hls, w = E.config;
                        switch(this.state){
                            case Ee.ERROR:
                            case Ee.PAUSED:
                            case Ee.BUFFER_FLUSHING:
                                break;
                            case Ee.STARTING:
                                this.state = Ee.WAITING_TRACK, this.loadedmetadata = !1;
                                break;
                            case Ee.IDLE:
                                var A = this.tracks;
                                if (!A || !this.media && (this.startFragRequested || !w.startFragPrefetch)) break;
                                if (this.loadedmetadata) s = this.media.currentTime;
                                else if (s = this.nextLoadPosition, s === void 0) break;
                                var S = this.mediaBuffer ? this.mediaBuffer : this.media, k = this.videoBuffer ? this.videoBuffer : this.media, B = ht.bufferInfo(S, s, w.maxBufferHole), U = ht.bufferInfo(k, s, w.maxBufferHole), F = B.len, ee = B.end, he = this.fragPrevious, ge = Math.max(w.maxBufferLength, U.len), be = this.audioSwitch, Se = this.trackId;
                                if ((F < ge || be) && Se < A.length) {
                                    if (f = A[Se].details, typeof f > "u") {
                                        this.state = Ee.WAITING_TRACK;
                                        break;
                                    }
                                    if (!be && !f.live && he && he.sn === f.endSN && !B.nextStart && (!this.media.seeking || this.media.duration - ee < he.duration / 2)) {
                                        this.hls.trigger(p.a.BUFFER_EOS, {
                                            type: "audio"
                                        }), this.state = Ee.ENDED;
                                        break;
                                    }
                                    var Ce = f.fragments, Ie = Ce.length, Ye = Ce[0].start, mt = Ce[Ie - 1].start + Ce[Ie - 1].duration, Ae = void 0;
                                    if (be) {
                                        if (f.live && !f.PTSKnown) d.b.log("switching audiotrack, live stream, unknown PTS,load first fragment"), ee = 0;
                                        else if (ee = s, f.PTSKnown && s < Ye) {
                                            if (B.end > Ye || B.nextStart) d.b.log("alt audio track ahead of main track, seek to start of alt audio track"), this.media.currentTime = Ye + 0.05;
                                            else return;
                                        }
                                    }
                                    if (f.initSegment && !f.initSegment.data) Ae = f.initSegment;
                                    else if (ee <= Ye) {
                                        if (Ae = Ce[0], this.videoTrackCC !== null && Ae.cc !== this.videoTrackCC && (Ae = M(Ce, this.videoTrackCC)), f.live && Ae.loadIdx && Ae.loadIdx === this.fragLoadIdx) {
                                            var Ut = B.nextStart ? B.nextStart : Ye;
                                            d.b.log("no alt audio available @currentTime:" + this.media.currentTime + ", seeking @" + (Ut + 0.05)), this.media.currentTime = Ut + 0.05;
                                            return;
                                        }
                                    } else {
                                        var ot = void 0, sn = w.maxFragLookUpTolerance, We = he ? Ce[he.sn - Ce[0].sn + 1] : void 0, Ne = function(Js) {
                                            var Ad = Math.min(sn, Js.duration);
                                            return Js.start + Js.duration - Ad <= ee ? 1 : Js.start - Ad > ee && Js.start ? -1 : 0;
                                        };
                                        ee < mt ? (ee > mt - sn && (sn = 0), We && !Ne(We) ? ot = We : ot = Br.search(Ce, Ne)) : ot = Ce[Ie - 1], ot && (Ae = ot, Ye = ot.start, he && Ae.level === he.level && Ae.sn === he.sn && (Ae.sn < f.endSN ? (Ae = Ce[Ae.sn + 1 - f.startSN], d.b.log("SN just loaded, load next one: " + Ae.sn)) : Ae = null));
                                    }
                                    if (Ae) {
                                        if (Ae.decryptdata && Ae.decryptdata.uri != null && Ae.decryptdata.key == null) d.b.log("Loading key for " + Ae.sn + " of [" + f.startSN + " ," + f.endSN + "],track " + Se), this.state = Ee.KEY_LOADING, E.trigger(p.a.KEY_LOADING, {
                                            frag: Ae
                                        });
                                        else {
                                            if (d.b.log("Loading " + Ae.sn + ", cc: " + Ae.cc + " of [" + f.startSN + " ," + f.endSN + "],track " + Se + ", currentTime:" + s + ",bufferEnd:" + ee.toFixed(3)), this.fragLoadIdx !== void 0 ? this.fragLoadIdx++ : this.fragLoadIdx = 0, Ae.loadCounter) {
                                                Ae.loadCounter++;
                                                var $t = w.fragLoadingLoopThreshold;
                                                if (Ae.loadCounter > $t && Math.abs(this.fragLoadIdx - Ae.loadIdx) < $t) {
                                                    E.trigger(p.a.ERROR, {
                                                        type: y.b.MEDIA_ERROR,
                                                        details: y.a.FRAG_LOOP_LOADING_ERROR,
                                                        fatal: !1,
                                                        frag: Ae
                                                    });
                                                    return;
                                                }
                                            } else Ae.loadCounter = 1;
                                            Ae.loadIdx = this.fragLoadIdx, this.fragCurrent = Ae, this.startFragRequested = !0, isNaN(Ae.sn) || (this.nextLoadPosition = Ae.start + Ae.duration), E.trigger(p.a.FRAG_LOADING, {
                                                frag: Ae
                                            }), this.state = Ee.FRAG_LOADING;
                                        }
                                    }
                                }
                                break;
                            case Ee.WAITING_TRACK:
                                u = this.tracks[this.trackId], u && u.details && (this.state = Ee.IDLE);
                                break;
                            case Ee.FRAG_LOADING_WAITING_RETRY:
                                var Wl = performance.now(), Ed = this.retryDate;
                                S = this.media;
                                var eb = S && S.seeking;
                                (!Ed || Wl >= Ed || eb) && (d.b.log("audioStreamController: retryDate reached, switch back to IDLE state"), this.state = Ee.IDLE);
                                break;
                            case Ee.WAITING_INIT_PTS:
                                var sc = this.videoTrackCC;
                                if (this.initPTS[sc] === void 0) break;
                                var vd = this.waitingFragment;
                                if (vd) {
                                    var Rd = vd.frag.cc;
                                    sc !== Rd ? (u = this.tracks[this.trackId], u.details && u.details.live && (d.b.warn("Waiting fragment CC (" + Rd + ") does not match video track CC (" + sc + ")"), this.waitingFragment = null, this.state = Ee.IDLE)) : (this.state = Ee.FRAG_LOADING, this.onFragLoaded(this.waitingFragment), this.waitingFragment = null);
                                } else this.state = Ee.IDLE;
                                break;
                        }
                    }, o.prototype.onMediaAttached = function(s) {
                        var u = this.media = this.mediaBuffer = s.media;
                        this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), u.addEventListener("seeking", this.onvseeking), u.addEventListener("ended", this.onvended);
                        var f = this.config;
                        this.tracks && f.autoStartLoad && this.startLoad(f.startPosition);
                    }, o.prototype.onMediaDetaching = function() {
                        var s = this.media;
                        s && s.ended && (d.b.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0);
                        var u = this.tracks;
                        u && u.forEach(function(f) {
                            f.details && f.details.fragments.forEach(function(E) {
                                E.loadCounter = void 0;
                            });
                        }), s && (s.removeEventListener("seeking", this.onvseeking), s.removeEventListener("ended", this.onvended), this.onvseeking = this.onvseeked = this.onvended = null), this.media = this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1, this.stopLoad();
                    }, o.prototype.onMediaSeeking = function() {
                        this.state === Ee.ENDED && (this.state = Ee.IDLE), this.media && (this.lastCurrentTime = this.media.currentTime), this.fragLoadIdx !== void 0 && (this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold), this.tick();
                    }, o.prototype.onMediaEnded = function() {
                        this.startPosition = this.lastCurrentTime = 0;
                    }, o.prototype.onAudioTracksUpdated = function(s) {
                        d.b.log("audio tracks updated"), this.tracks = s.audioTracks;
                    }, o.prototype.onAudioTrackSwitching = function(s) {
                        var u = !!s.url;
                        this.trackId = s.id, this.fragCurrent = null, this.state = Ee.PAUSED, this.waitingFragment = null, u ? this.timer || (this.timer = setInterval(this.ontick, 100)) : this.demuxer && (this.demuxer.destroy(), this.demuxer = null), u && (this.audioSwitch = !0, this.state = Ee.IDLE, this.fragLoadIdx !== void 0 && (this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold)), this.tick();
                    }, o.prototype.onAudioTrackLoaded = function(s) {
                        var u = s.details, f = s.id, E = this.tracks[f], w = u.totalduration, A = 0;
                        if (d.b.log("track " + f + " loaded [" + u.startSN + "," + u.endSN + "],duration:" + w), u.live) {
                            var S = E.details;
                            S && u.fragments.length > 0 ? (C(S, u), A = u.fragments[0].start, u.PTSKnown ? d.b.log("live audio playlist sliding:" + A.toFixed(3)) : d.b.log("live audio playlist - outdated PTS, unknown sliding")) : (u.PTSKnown = !1, d.b.log("live audio playlist - first load, unknown sliding"));
                        } else u.PTSKnown = !1;
                        if (E.details = u, !this.startFragRequested) {
                            if (this.startPosition === -1) {
                                var k = u.startTimeOffset;
                                isNaN(k) ? this.startPosition = 0 : (d.b.log("start time offset found in playlist, adjust startPosition to " + k), this.startPosition = k);
                            }
                            this.nextLoadPosition = this.startPosition;
                        }
                        this.state === Ee.WAITING_TRACK && (this.state = Ee.IDLE), this.tick();
                    }, o.prototype.onKeyLoaded = function() {
                        this.state === Ee.KEY_LOADING && (this.state = Ee.IDLE, this.tick());
                    }, o.prototype.onFragLoaded = function(s) {
                        var u = this.fragCurrent, f = s.frag;
                        if (this.state === Ee.FRAG_LOADING && u && f.type === "audio" && f.level === u.level && f.sn === u.sn) {
                            var E = this.tracks[this.trackId], w = E.details, A = w.totalduration, S = u.level, k = u.sn, B = u.cc, U = this.config.defaultAudioCodec || E.audioCodec || "mp4a.40.2", F = this.stats = s.stats;
                            if (k === "initSegment") this.state = Ee.IDLE, F.tparsed = F.tbuffered = performance.now(), w.initSegment.data = s.payload, this.hls.trigger(p.a.FRAG_BUFFERED, {
                                stats: F,
                                frag: u,
                                id: "audio"
                            }), this.tick();
                            else {
                                this.state = Ee.PARSING, this.appended = !1, this.demuxer || (this.demuxer = new I(this.hls, "audio"));
                                var ee = this.initPTS[B], he = w.initSegment ? w.initSegment.data : [];
                                if (w.initSegment || ee !== void 0) {
                                    this.pendingBuffering = !0, d.b.log("Demuxing " + k + " of [" + w.startSN + " ," + w.endSN + "],track " + S);
                                    var ge = !1;
                                    this.demuxer.push(s.payload, he, U, null, u, A, ge, ee);
                                } else d.b.log("unknown video PTS for continuity counter " + B + ", waiting for video PTS before demuxing audio frag " + k + " of [" + w.startSN + " ," + w.endSN + "],track " + S), this.waitingFragment = s, this.state = Ee.WAITING_INIT_PTS;
                            }
                        }
                        this.fragLoadError = 0;
                    }, o.prototype.onFragParsingInitSegment = function(s) {
                        var u = this.fragCurrent, f = s.frag;
                        if (u && s.id === "audio" && f.sn === u.sn && f.level === u.level && this.state === Ee.PARSING) {
                            var E = s.tracks, w = void 0;
                            if (E.video && delete E.video, w = E.audio, w) {
                                w.levelCodec = w.codec, w.id = s.id, this.hls.trigger(p.a.BUFFER_CODECS, E), d.b.log("audio track:audio,container:" + w.container + ",codecs[level/parsed]=[" + w.levelCodec + "/" + w.codec + "]");
                                var A = w.initSegment;
                                if (A) {
                                    var S = {
                                        type: "audio",
                                        data: A,
                                        parent: "audio",
                                        content: "initSegment"
                                    };
                                    this.audioSwitch ? this.pendingData = [
                                        S
                                    ] : (this.appended = !0, this.pendingBuffering = !0, this.hls.trigger(p.a.BUFFER_APPENDING, S));
                                }
                                this.tick();
                            }
                        }
                    }, o.prototype.onFragParsingData = function(s) {
                        var u = this, f = this.fragCurrent, E = s.frag;
                        if (f && s.id === "audio" && s.type === "audio" && E.sn === f.sn && E.level === f.level && this.state === Ee.PARSING) {
                            var w = this.trackId, A = this.tracks[w], S = this.hls;
                            isNaN(s.endPTS) && (s.endPTS = s.startPTS + f.duration, s.endDTS = s.startDTS + f.duration), d.b.log("parsed " + s.type + ",PTS:[" + s.startPTS.toFixed(3) + "," + s.endPTS.toFixed(3) + "],DTS:[" + s.startDTS.toFixed(3) + "/" + s.endDTS.toFixed(3) + "],nb:" + s.nb), T(A.details, f, s.startPTS, s.endPTS);
                            var k = this.audioSwitch, B = this.media, U = !1;
                            if (k && B) {
                                if (B.readyState) {
                                    var F = B.currentTime;
                                    d.b.log("switching audio track : currentTime:" + F), F >= s.startPTS && (d.b.log("switching audio track : flushing all audio"), this.state = Ee.BUFFER_FLUSHING, S.trigger(p.a.BUFFER_FLUSHING, {
                                        startOffset: 0,
                                        endOffset: Number.POSITIVE_INFINITY,
                                        type: "audio"
                                    }), U = !0, this.audioSwitch = !1, S.trigger(p.a.AUDIO_TRACK_SWITCHED, {
                                        id: w
                                    }));
                                } else this.audioSwitch = !1, S.trigger(p.a.AUDIO_TRACK_SWITCHED, {
                                    id: w
                                });
                            }
                            var ee = this.pendingData;
                            this.audioSwitch || ([
                                s.data1,
                                s.data2
                            ].forEach(function(he) {
                                he && he.length && ee.push({
                                    type: s.type,
                                    data: he,
                                    parent: "audio",
                                    content: "data"
                                });
                            }), !U && ee.length && (ee.forEach(function(he) {
                                u.state === Ee.PARSING && (u.pendingBuffering = !0, u.hls.trigger(p.a.BUFFER_APPENDING, he));
                            }), this.pendingData = [], this.appended = !0)), this.tick();
                        }
                    }, o.prototype.onFragParsed = function(s) {
                        var u = this.fragCurrent, f = s.frag;
                        u && s.id === "audio" && f.sn === u.sn && f.level === u.level && this.state === Ee.PARSING && (this.stats.tparsed = performance.now(), this.state = Ee.PARSED, this._checkAppendedParsed());
                    }, o.prototype.onBufferReset = function() {
                        this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
                    }, o.prototype.onBufferCreated = function(s) {
                        var u = s.tracks.audio;
                        u && (this.mediaBuffer = u.buffer, this.loadedmetadata = !0), s.tracks.video && (this.videoBuffer = s.tracks.video.buffer);
                    }, o.prototype.onBufferAppended = function(s) {
                        if (s.parent === "audio") {
                            var u = this.state;
                            (u === Ee.PARSING || u === Ee.PARSED) && (this.pendingBuffering = s.pending > 0, this._checkAppendedParsed());
                        }
                    }, o.prototype._checkAppendedParsed = function() {
                        if (this.state === Ee.PARSED && (!this.appended || !this.pendingBuffering)) {
                            var s = this.fragCurrent, u = this.stats, f = this.hls;
                            if (s) {
                                this.fragPrevious = s, u.tbuffered = performance.now(), f.trigger(p.a.FRAG_BUFFERED, {
                                    stats: u,
                                    frag: s,
                                    id: "audio"
                                });
                                var E = this.mediaBuffer ? this.mediaBuffer : this.media;
                                d.b.log("audio buffered : " + D.toString(E.buffered)), this.audioSwitch && this.appended && (this.audioSwitch = !1, f.trigger(p.a.AUDIO_TRACK_SWITCHED, {
                                    id: this.trackId
                                })), this.state = Ee.IDLE;
                            }
                            this.tick();
                        }
                    }, o.prototype.onError = function(s) {
                        var u = s.frag;
                        if (!(u && u.type !== "audio")) switch(s.details){
                            case y.a.FRAG_LOAD_ERROR:
                            case y.a.FRAG_LOAD_TIMEOUT:
                                if (!s.fatal) {
                                    var f = this.fragLoadError;
                                    f ? f++ : f = 1;
                                    var E = this.config;
                                    if (f <= E.fragLoadingMaxRetry) {
                                        this.fragLoadError = f, u.loadCounter = 0;
                                        var w = Math.min(Math.pow(2, f - 1) * E.fragLoadingRetryDelay, E.fragLoadingMaxRetryTimeout);
                                        d.b.warn("audioStreamController: frag loading failed, retry in " + w + " ms"), this.retryDate = performance.now() + w, this.state = Ee.FRAG_LOADING_WAITING_RETRY;
                                    } else d.b.error("audioStreamController: " + s.details + " reaches max retry, redispatch as fatal ..."), s.fatal = !0, this.state = Ee.ERROR;
                                }
                                break;
                            case y.a.FRAG_LOOP_LOADING_ERROR:
                            case y.a.AUDIO_TRACK_LOAD_ERROR:
                            case y.a.AUDIO_TRACK_LOAD_TIMEOUT:
                            case y.a.KEY_LOAD_ERROR:
                            case y.a.KEY_LOAD_TIMEOUT:
                                this.state !== Ee.ERROR && (this.state = s.fatal ? Ee.ERROR : Ee.IDLE, d.b.warn("audioStreamController: " + s.details + " while loading frag,switch to " + this.state + " state ..."));
                                break;
                            case y.a.BUFFER_FULL_ERROR:
                                if (s.parent === "audio" && (this.state === Ee.PARSING || this.state === Ee.PARSED)) {
                                    var A = this.mediaBuffer, S = this.media.currentTime, k = A && ht.isBuffered(A, S) && ht.isBuffered(A, S + 0.5);
                                    if (k) {
                                        var B = this.config;
                                        B.maxMaxBufferLength >= B.maxBufferLength && (B.maxMaxBufferLength /= 2, d.b.warn("audio:reduce max buffer length to " + B.maxMaxBufferLength + "s"), this.fragLoadIdx += 2 * B.fragLoadingLoopThreshold), this.state = Ee.IDLE;
                                    } else d.b.warn("buffer full error also media.currentTime is not buffered, flush audio buffer"), this.fragCurrent = null, this.state = Ee.BUFFER_FLUSHING, this.hls.trigger(p.a.BUFFER_FLUSHING, {
                                        startOffset: 0,
                                        endOffset: Number.POSITIVE_INFINITY,
                                        type: "audio"
                                    });
                                }
                                break;
                        }
                    }, o.prototype.onBufferFlushed = function() {
                        var s = this, u = this.pendingData;
                        u && u.length ? (d.b.log("appending pending audio data on Buffer Flushed"), u.forEach(function(f) {
                            s.hls.trigger(p.a.BUFFER_APPENDING, f);
                        }), this.appended = !0, this.pendingData = [], this.state = Ee.PARSED) : (this.state = Ee.IDLE, this.fragPrevious = null, this.tick());
                    }, oy(o, [
                        {
                            key: "state",
                            set: function(s) {
                                if (this.state !== s) {
                                    var u = this.state;
                                    this._state = s, d.b.log("audio stream:" + u + "->" + s);
                                }
                            },
                            get: function() {
                                return this._state;
                            }
                        }
                    ]), o;
                }(O), fy = dy, ld = function() {
                    if (typeof window < "u" && window.VTTCue) return window.VTTCue;
                    var g = "auto", o = {
                        "": !0,
                        lr: !0,
                        rl: !0
                    }, l = {
                        start: !0,
                        middle: !0,
                        end: !0,
                        left: !0,
                        right: !0
                    };
                    function s(w) {
                        if (typeof w != "string") return !1;
                        var A = o[w.toLowerCase()];
                        return A ? w.toLowerCase() : !1;
                    }
                    function u(w) {
                        if (typeof w != "string") return !1;
                        var A = l[w.toLowerCase()];
                        return A ? w.toLowerCase() : !1;
                    }
                    function f(w) {
                        for(var A = 1; A < arguments.length; A++){
                            var S = arguments[A];
                            for(var k in S)w[k] = S[k];
                        }
                        return w;
                    }
                    function E(w, A, S) {
                        var k = this, B = function() {
                            if (!(typeof navigator > "u")) return /MSIE\s8\.0/.test(navigator.userAgent);
                        }(), U = {};
                        B ? k = document.createElement("custom") : U.enumerable = !0, k.hasBeenReset = !1;
                        var F = "", ee = !1, he = w, ge = A, be = S, Se = null, Ce = "", Ie = !0, Ye = "auto", mt = "start", Ae = 50, Ut = "middle", ot = 50, sn = "middle";
                        if (Object.defineProperty(k, "id", f({}, U, {
                            get: function() {
                                return F;
                            },
                            set: function(Ne) {
                                F = "" + Ne;
                            }
                        })), Object.defineProperty(k, "pauseOnExit", f({}, U, {
                            get: function() {
                                return ee;
                            },
                            set: function(Ne) {
                                ee = !!Ne;
                            }
                        })), Object.defineProperty(k, "startTime", f({}, U, {
                            get: function() {
                                return he;
                            },
                            set: function(Ne) {
                                if (typeof Ne != "number") throw new TypeError("Start time must be set to a number.");
                                he = Ne, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "endTime", f({}, U, {
                            get: function() {
                                return ge;
                            },
                            set: function(Ne) {
                                if (typeof Ne != "number") throw new TypeError("End time must be set to a number.");
                                ge = Ne, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "text", f({}, U, {
                            get: function() {
                                return be;
                            },
                            set: function(Ne) {
                                be = "" + Ne, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "region", f({}, U, {
                            get: function() {
                                return Se;
                            },
                            set: function(Ne) {
                                Se = Ne, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "vertical", f({}, U, {
                            get: function() {
                                return Ce;
                            },
                            set: function(Ne) {
                                var $t = s(Ne);
                                if ($t === !1) throw new SyntaxError("An invalid or illegal string was specified.");
                                Ce = $t, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "snapToLines", f({}, U, {
                            get: function() {
                                return Ie;
                            },
                            set: function(Ne) {
                                Ie = !!Ne, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "line", f({}, U, {
                            get: function() {
                                return Ye;
                            },
                            set: function(Ne) {
                                if (typeof Ne != "number" && Ne !== g) throw new SyntaxError("An invalid number or illegal string was specified.");
                                Ye = Ne, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "lineAlign", f({}, U, {
                            get: function() {
                                return mt;
                            },
                            set: function(Ne) {
                                var $t = u(Ne);
                                if (!$t) throw new SyntaxError("An invalid or illegal string was specified.");
                                mt = $t, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "position", f({}, U, {
                            get: function() {
                                return Ae;
                            },
                            set: function(Ne) {
                                if (Ne < 0 || Ne > 100) throw new Error("Position must be between 0 and 100.");
                                Ae = Ne, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "positionAlign", f({}, U, {
                            get: function() {
                                return Ut;
                            },
                            set: function(Ne) {
                                var $t = u(Ne);
                                if (!$t) throw new SyntaxError("An invalid or illegal string was specified.");
                                Ut = $t, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "size", f({}, U, {
                            get: function() {
                                return ot;
                            },
                            set: function(Ne) {
                                if (Ne < 0 || Ne > 100) throw new Error("Size must be between 0 and 100.");
                                ot = Ne, this.hasBeenReset = !0;
                            }
                        })), Object.defineProperty(k, "align", f({}, U, {
                            get: function() {
                                return sn;
                            },
                            set: function(Ne) {
                                var $t = u(Ne);
                                if (!$t) throw new SyntaxError("An invalid or illegal string was specified.");
                                sn = $t, this.hasBeenReset = !0;
                            }
                        })), k.displayState = void 0, B) return k;
                    }
                    return E.prototype.getCueAsHTML = function() {
                        var w = window.WebVTT;
                        return w.convertCueToDOMTree(window, this.text);
                    }, E;
                }(), py = function() {
                    return {
                        decode: function(l) {
                            if (!l) return "";
                            if (typeof l != "string") throw new Error("Error - expected string data.");
                            return decodeURIComponent(encodeURIComponent(l));
                        }
                    };
                };
                function ud() {
                    this.window = window, this.state = "INITIAL", this.buffer = "", this.decoder = new py(), this.regionList = [];
                }
                function hy(g) {
                    function o(s, u, f, E) {
                        return (s | 0) * 3600 + (u | 0) * 60 + (f | 0) + (E | 0) / 1e3;
                    }
                    var l = g.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
                    return l ? l[3] ? o(l[1], l[2], l[3].replace(":", ""), l[4]) : l[1] > 59 ? o(l[1], l[2], 0, l[4]) : o(0, l[1], l[2], l[4]) : null;
                }
                function cd() {
                    this.values = /* @__PURE__ */ Object.create(null);
                }
                cd.prototype = {
                    // Only accept the first assignment to any key.
                    set: function(o, l) {
                        !this.get(o) && l !== "" && (this.values[o] = l);
                    },
                    // Return the value for a key, or a default value.
                    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
                    // a number of possible default values as properties where 'defaultKey' is
                    // the key of the property that will be chosen; otherwise it's assumed to be
                    // a single value.
                    get: function(o, l, s) {
                        return s ? this.has(o) ? this.values[o] : l[s] : this.has(o) ? this.values[o] : l;
                    },
                    // Check whether we have a value for a key.
                    has: function(o) {
                        return o in this.values;
                    },
                    // Accept a setting if its one of the given alternatives.
                    alt: function(o, l, s) {
                        for(var u = 0; u < s.length; ++u)if (l === s[u]) {
                            this.set(o, l);
                            break;
                        }
                    },
                    // Accept a setting if its a valid (signed) integer.
                    integer: function(o, l) {
                        /^-?\d+$/.test(l) && this.set(o, parseInt(l, 10));
                    },
                    // Accept a setting if its a valid percentage.
                    percent: function(o, l) {
                        return l.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (l = parseFloat(l), l >= 0 && l <= 100) ? (this.set(o, l), !0) : !1;
                    }
                };
                function dd(g, o, l, s) {
                    var u = s ? g.split(s) : [
                        g
                    ];
                    for(var f in u)if (typeof u[f] == "string") {
                        var E = u[f].split(l);
                        if (E.length === 2) {
                            var w = E[0], A = E[1];
                            o(w, A);
                        }
                    }
                }
                var tc = new ld(0, 0, 0), Hl = tc.align === "middle" ? "middle" : "center";
                function my(g, o, l) {
                    var s = g;
                    function u() {
                        var w = hy(g);
                        if (w === null) throw new Error("Malformed timestamp: " + s);
                        return g = g.replace(/^[^\sa-zA-Z-]+/, ""), w;
                    }
                    function f(w, A) {
                        var S = new cd();
                        dd(w, function(U, F) {
                            switch(U){
                                case "region":
                                    for(var ee = l.length - 1; ee >= 0; ee--)if (l[ee].id === F) {
                                        S.set(U, l[ee].region);
                                        break;
                                    }
                                    break;
                                case "vertical":
                                    S.alt(U, F, [
                                        "rl",
                                        "lr"
                                    ]);
                                    break;
                                case "line":
                                    var he = F.split(","), ge = he[0];
                                    S.integer(U, ge), S.percent(U, ge) && S.set("snapToLines", !1), S.alt(U, ge, [
                                        "auto"
                                    ]), he.length === 2 && S.alt("lineAlign", he[1], [
                                        "start",
                                        Hl,
                                        "end"
                                    ]);
                                    break;
                                case "position":
                                    he = F.split(","), S.percent(U, he[0]), he.length === 2 && S.alt("positionAlign", he[1], [
                                        "start",
                                        Hl,
                                        "end",
                                        "line-left",
                                        "line-right",
                                        "auto"
                                    ]);
                                    break;
                                case "size":
                                    S.percent(U, F);
                                    break;
                                case "align":
                                    S.alt(U, F, [
                                        "start",
                                        Hl,
                                        "end",
                                        "left",
                                        "right"
                                    ]);
                                    break;
                            }
                        }, /:/, /\s/), A.region = S.get("region", null), A.vertical = S.get("vertical", "");
                        var k = S.get("line", "auto");
                        k === "auto" && tc.line === -1 && (k = -1), A.line = k, A.lineAlign = S.get("lineAlign", "start"), A.snapToLines = S.get("snapToLines", !0), A.size = S.get("size", 100), A.align = S.get("align", Hl);
                        var B = S.get("position", "auto");
                        B === "auto" && tc.position === 50 && (B = A.align === "start" || A.align === "left" ? 0 : A.align === "end" || A.align === "right" ? 100 : 50), A.position = B;
                    }
                    function E() {
                        g = g.replace(/^\s+/, "");
                    }
                    if (E(), o.startTime = u(), E(), g.substr(0, 3) !== "-->") throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + s);
                    g = g.substr(3), E(), o.endTime = u(), E(), f(g, o);
                }
                function fd(g) {
                    return g.replace(/<br(?: \/)?>/gi, `
`);
                }
                ud.prototype = {
                    parse: function(o) {
                        var l = this;
                        o && (l.buffer += l.decoder.decode(o, {
                            stream: !0
                        }));
                        function s() {
                            var S = l.buffer, k = 0;
                            for(S = fd(S); k < S.length && S[k] !== "\r" && S[k] !== `
`;)++k;
                            var B = S.substr(0, k);
                            return S[k] === "\r" && ++k, S[k] === `
` && ++k, l.buffer = S.substr(k), B;
                        }
                        function u(S) {
                            dd(S, function(k, B) {
                                switch(k){
                                    case "Region":
                                        console.log("parse region", B);
                                        break;
                                }
                            }, /:/);
                        }
                        try {
                            var f;
                            if (l.state === "INITIAL") {
                                if (!/\r\n|\n/.test(l.buffer)) return this;
                                f = s();
                                var E = f.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                                if (!E || !E[0]) throw new Error("Malformed WebVTT signature.");
                                l.state = "HEADER";
                            }
                            for(var w = !1; l.buffer;){
                                if (!/\r\n|\n/.test(l.buffer)) return this;
                                switch(w ? w = !1 : f = s(), l.state){
                                    case "HEADER":
                                        /:/.test(f) ? u(f) : f || (l.state = "ID");
                                        continue;
                                    case "NOTE":
                                        f || (l.state = "ID");
                                        continue;
                                    case "ID":
                                        if (/^NOTE($|[ \t])/.test(f)) {
                                            l.state = "NOTE";
                                            break;
                                        }
                                        if (!f) continue;
                                        if (l.cue = new ld(0, 0, ""), l.state = "CUE", f.indexOf("-->") === -1) {
                                            l.cue.id = f;
                                            continue;
                                        }
                                    case "CUE":
                                        try {
                                            my(f, l.cue, l.regionList);
                                        } catch  {
                                            l.cue = null, l.state = "BADCUE";
                                            continue;
                                        }
                                        l.state = "CUETEXT";
                                        continue;
                                    case "CUETEXT":
                                        var A = f.indexOf("-->") !== -1;
                                        if (!f || A && (w = !0)) {
                                            l.oncue && l.oncue(l.cue), l.cue = null, l.state = "ID";
                                            continue;
                                        }
                                        l.cue.text && (l.cue.text += `
`), l.cue.text += f;
                                        continue;
                                    case "BADCUE":
                                        f || (l.state = "ID");
                                        continue;
                                }
                            }
                        } catch  {
                            l.state === "CUETEXT" && l.cue && l.oncue && l.oncue(l.cue), l.cue = null, l.state = l.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
                        }
                        return this;
                    },
                    flush: function() {
                        var o = this;
                        try {
                            if (o.buffer += o.decoder.decode(), (o.cue || o.state === "HEADER") && (o.buffer += `

`, o.parse()), o.state === "INITIAL") throw new Error("Malformed WebVTT signature.");
                        } catch (l) {
                            throw l;
                        }
                        return o.onflush && o.onflush(), this;
                    }
                };
                var yy = ud;
                function by(g, o, l, s) {
                    for(var u, f, E, w, A, S = window.VTTCue || window.TextTrackCue, k = 0; k < s.rows.length; k++)if (u = s.rows[k], E = !0, w = 0, A = "", !u.isEmpty()) {
                        for(var B = 0; B < u.chars.length; B++)u.chars[B].uchar.match(/\s/) && E ? w++ : (A += u.chars[B].uchar, E = !1);
                        u.cueStartTime = o, o === l && (l += 1e-4), f = new S(o, l, fd(A.trim())), w >= 16 ? w-- : w++, navigator.userAgent.match(/Firefox\//) ? f.line = k + 1 : f.line = k > 7 ? k - 2 : k + 1, f.align = "left", f.position = Math.max(0, Math.min(100, 100 * (w / 32) + (navigator.userAgent.match(/Firefox\//) ? 50 : 0))), g.addCue(f);
                    }
                }
                function fs(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var pd = {
                    42: 225,
                    // lowercase a, acute accent
                    92: 233,
                    // lowercase e, acute accent
                    94: 237,
                    // lowercase i, acute accent
                    95: 243,
                    // lowercase o, acute accent
                    96: 250,
                    // lowercase u, acute accent
                    123: 231,
                    // lowercase c with cedilla
                    124: 247,
                    // division symbol
                    125: 209,
                    // uppercase N tilde
                    126: 241,
                    // lowercase n tilde
                    127: 9608,
                    // Full block
                    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
                    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
                    128: 174,
                    // Registered symbol (R)
                    129: 176,
                    // degree sign
                    130: 189,
                    // 1/2 symbol
                    131: 191,
                    // Inverted (open) question mark
                    132: 8482,
                    // Trademark symbol (TM)
                    133: 162,
                    // Cents symbol
                    134: 163,
                    // Pounds sterling
                    135: 9834,
                    // Music 8'th note
                    136: 224,
                    // lowercase a, grave accent
                    137: 32,
                    // transparent space (regular)
                    138: 232,
                    // lowercase e, grave accent
                    139: 226,
                    // lowercase a, circumflex accent
                    140: 234,
                    // lowercase e, circumflex accent
                    141: 238,
                    // lowercase i, circumflex accent
                    142: 244,
                    // lowercase o, circumflex accent
                    143: 251,
                    // lowercase u, circumflex accent
                    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
                    144: 193,
                    // capital letter A with acute
                    145: 201,
                    // capital letter E with acute
                    146: 211,
                    // capital letter O with acute
                    147: 218,
                    // capital letter U with acute
                    148: 220,
                    // capital letter U with diaresis
                    149: 252,
                    // lowercase letter U with diaeresis
                    150: 8216,
                    // opening single quote
                    151: 161,
                    // inverted exclamation mark
                    152: 42,
                    // asterisk
                    153: 8217,
                    // closing single quote
                    154: 9473,
                    // box drawings heavy horizontal
                    155: 169,
                    // copyright sign
                    156: 8480,
                    // Service mark
                    157: 8226,
                    // (round) bullet
                    158: 8220,
                    // Left double quotation mark
                    159: 8221,
                    // Right double quotation mark
                    160: 192,
                    // uppercase A, grave accent
                    161: 194,
                    // uppercase A, circumflex
                    162: 199,
                    // uppercase C with cedilla
                    163: 200,
                    // uppercase E, grave accent
                    164: 202,
                    // uppercase E, circumflex
                    165: 203,
                    // capital letter E with diaresis
                    166: 235,
                    // lowercase letter e with diaresis
                    167: 206,
                    // uppercase I, circumflex
                    168: 207,
                    // uppercase I, with diaresis
                    169: 239,
                    // lowercase i, with diaresis
                    170: 212,
                    // uppercase O, circumflex
                    171: 217,
                    // uppercase U, grave accent
                    172: 249,
                    // lowercase u, grave accent
                    173: 219,
                    // uppercase U, circumflex
                    174: 171,
                    // left-pointing double angle quotation mark
                    175: 187,
                    // right-pointing double angle quotation mark
                    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
                    176: 195,
                    // Uppercase A, tilde
                    177: 227,
                    // Lowercase a, tilde
                    178: 205,
                    // Uppercase I, acute accent
                    179: 204,
                    // Uppercase I, grave accent
                    180: 236,
                    // Lowercase i, grave accent
                    181: 210,
                    // Uppercase O, grave accent
                    182: 242,
                    // Lowercase o, grave accent
                    183: 213,
                    // Uppercase O, tilde
                    184: 245,
                    // Lowercase o, tilde
                    185: 123,
                    // Open curly brace
                    186: 125,
                    // Closing curly brace
                    187: 92,
                    // Backslash
                    188: 94,
                    // Caret
                    189: 95,
                    // Underscore
                    190: 124,
                    // Pipe (vertical line)
                    191: 8764,
                    // Tilde operator
                    192: 196,
                    // Uppercase A, umlaut
                    193: 228,
                    // Lowercase A, umlaut
                    194: 214,
                    // Uppercase O, umlaut
                    195: 246,
                    // Lowercase o, umlaut
                    196: 223,
                    // Esszett (sharp S)
                    197: 165,
                    // Yen symbol
                    198: 164,
                    // Generic currency sign
                    199: 9475,
                    // Box drawings heavy vertical
                    200: 197,
                    // Uppercase A, ring
                    201: 229,
                    // Lowercase A, ring
                    202: 216,
                    // Uppercase O, stroke
                    203: 248,
                    // Lowercase o, strok
                    204: 9487,
                    // Box drawings heavy down and right
                    205: 9491,
                    // Box drawings heavy down and left
                    206: 9495,
                    // Box drawings heavy up and right
                    207: 9499
                }, hd = function(o) {
                    var l = o;
                    return pd.hasOwnProperty(o) && (l = pd[o]), String.fromCharCode(l);
                }, Ur = 15, Ci = 100, gy = {
                    17: 1,
                    18: 3,
                    21: 5,
                    22: 7,
                    23: 9,
                    16: 11,
                    19: 12,
                    20: 14
                }, xy = {
                    17: 2,
                    18: 4,
                    21: 6,
                    22: 8,
                    23: 10,
                    19: 13,
                    20: 15
                }, Ey = {
                    25: 1,
                    26: 3,
                    29: 5,
                    30: 7,
                    31: 9,
                    24: 11,
                    27: 12,
                    28: 14
                }, vy = {
                    25: 2,
                    26: 4,
                    29: 6,
                    30: 8,
                    31: 10,
                    27: 13,
                    28: 15
                }, Ry = [
                    "white",
                    "green",
                    "blue",
                    "cyan",
                    "red",
                    "yellow",
                    "magenta",
                    "black",
                    "transparent"
                ], $e = {
                    verboseFilter: {
                        DATA: 3,
                        DEBUG: 3,
                        INFO: 2,
                        WARNING: 2,
                        TEXT: 1,
                        ERROR: 0
                    },
                    time: null,
                    verboseLevel: 0,
                    // Only write errors
                    setTime: function(o) {
                        this.time = o;
                    },
                    log: function(o, l) {
                        var s = this.verboseFilter[o];
                        this.verboseLevel >= s && console.log(this.time + " [" + o + "] " + l);
                    }
                }, Pn = function(o) {
                    for(var l = [], s = 0; s < o.length; s++)l.push(o[s].toString(16));
                    return l;
                }, md = function() {
                    function g(o, l, s, u, f) {
                        fs(this, g), this.foreground = o || "white", this.underline = l || !1, this.italics = s || !1, this.background = u || "black", this.flash = f || !1;
                    }
                    return g.prototype.reset = function() {
                        this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
                    }, g.prototype.setStyles = function(l) {
                        for(var s = [
                            "foreground",
                            "underline",
                            "italics",
                            "background",
                            "flash"
                        ], u = 0; u < s.length; u++){
                            var f = s[u];
                            l.hasOwnProperty(f) && (this[f] = l[f]);
                        }
                    }, g.prototype.isDefault = function() {
                        return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
                    }, g.prototype.equals = function(l) {
                        return this.foreground === l.foreground && this.underline === l.underline && this.italics === l.italics && this.background === l.background && this.flash === l.flash;
                    }, g.prototype.copy = function(l) {
                        this.foreground = l.foreground, this.underline = l.underline, this.italics = l.italics, this.background = l.background, this.flash = l.flash;
                    }, g.prototype.toString = function() {
                        return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
                    }, g;
                }(), Ay = function() {
                    function g(o, l, s, u, f, E) {
                        fs(this, g), this.uchar = o || " ", this.penState = new md(l, s, u, f, E);
                    }
                    return g.prototype.reset = function() {
                        this.uchar = " ", this.penState.reset();
                    }, g.prototype.setChar = function(l, s) {
                        this.uchar = l, this.penState.copy(s);
                    }, g.prototype.setPenState = function(l) {
                        this.penState.copy(l);
                    }, g.prototype.equals = function(l) {
                        return this.uchar === l.uchar && this.penState.equals(l.penState);
                    }, g.prototype.copy = function(l) {
                        this.uchar = l.uchar, this.penState.copy(l.penState);
                    }, g.prototype.isEmpty = function() {
                        return this.uchar === " " && this.penState.isDefault();
                    }, g;
                }(), _y = function() {
                    function g() {
                        fs(this, g), this.chars = [];
                        for(var o = 0; o < Ci; o++)this.chars.push(new Ay());
                        this.pos = 0, this.currPenState = new md();
                    }
                    return g.prototype.equals = function(l) {
                        for(var s = !0, u = 0; u < Ci; u++)if (!this.chars[u].equals(l.chars[u])) {
                            s = !1;
                            break;
                        }
                        return s;
                    }, g.prototype.copy = function(l) {
                        for(var s = 0; s < Ci; s++)this.chars[s].copy(l.chars[s]);
                    }, g.prototype.isEmpty = function() {
                        for(var l = !0, s = 0; s < Ci; s++)if (!this.chars[s].isEmpty()) {
                            l = !1;
                            break;
                        }
                        return l;
                    }, g.prototype.setCursor = function(l) {
                        this.pos !== l && (this.pos = l), this.pos < 0 ? ($e.log("ERROR", "Negative cursor position " + this.pos), this.pos = 0) : this.pos > Ci && ($e.log("ERROR", "Too large cursor position " + this.pos), this.pos = Ci);
                    }, g.prototype.moveCursor = function(l) {
                        var s = this.pos + l;
                        if (l > 1) for(var u = this.pos + 1; u < s + 1; u++)this.chars[u].setPenState(this.currPenState);
                        this.setCursor(s);
                    }, g.prototype.backSpace = function() {
                        this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
                    }, g.prototype.insertChar = function(l) {
                        l >= 144 && this.backSpace();
                        var s = hd(l);
                        if (this.pos >= Ci) {
                            $e.log("ERROR", "Cannot insert " + l.toString(16) + " (" + s + ") at position " + this.pos + ". Skipping it!");
                            return;
                        }
                        this.chars[this.pos].setChar(s, this.currPenState), this.moveCursor(1);
                    }, g.prototype.clearFromPos = function(l) {
                        var s;
                        for(s = l; s < Ci; s++)this.chars[s].reset();
                    }, g.prototype.clear = function() {
                        this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
                    }, g.prototype.clearToEndOfRow = function() {
                        this.clearFromPos(this.pos);
                    }, g.prototype.getTextString = function() {
                        for(var l = [], s = !0, u = 0; u < Ci; u++){
                            var f = this.chars[u].uchar;
                            f !== " " && (s = !1), l.push(f);
                        }
                        return s ? "" : l.join("");
                    }, g.prototype.setPenStyles = function(l) {
                        this.currPenState.setStyles(l);
                        var s = this.chars[this.pos];
                        s.setPenState(this.currPenState);
                    }, g;
                }(), rc = function() {
                    function g() {
                        fs(this, g), this.rows = [];
                        for(var o = 0; o < Ur; o++)this.rows.push(new _y());
                        this.currRow = Ur - 1, this.nrRollUpRows = null, this.reset();
                    }
                    return g.prototype.reset = function() {
                        for(var l = 0; l < Ur; l++)this.rows[l].clear();
                        this.currRow = Ur - 1;
                    }, g.prototype.equals = function(l) {
                        for(var s = !0, u = 0; u < Ur; u++)if (!this.rows[u].equals(l.rows[u])) {
                            s = !1;
                            break;
                        }
                        return s;
                    }, g.prototype.copy = function(l) {
                        for(var s = 0; s < Ur; s++)this.rows[s].copy(l.rows[s]);
                    }, g.prototype.isEmpty = function() {
                        for(var l = !0, s = 0; s < Ur; s++)if (!this.rows[s].isEmpty()) {
                            l = !1;
                            break;
                        }
                        return l;
                    }, g.prototype.backSpace = function() {
                        var l = this.rows[this.currRow];
                        l.backSpace();
                    }, g.prototype.clearToEndOfRow = function() {
                        var l = this.rows[this.currRow];
                        l.clearToEndOfRow();
                    }, g.prototype.insertChar = function(l) {
                        var s = this.rows[this.currRow];
                        s.insertChar(l);
                    }, g.prototype.setPen = function(l) {
                        var s = this.rows[this.currRow];
                        s.setPenStyles(l);
                    }, g.prototype.moveCursor = function(l) {
                        var s = this.rows[this.currRow];
                        s.moveCursor(l);
                    }, g.prototype.setCursor = function(l) {
                        $e.log("INFO", "setCursor: " + l);
                        var s = this.rows[this.currRow];
                        s.setCursor(l);
                    }, g.prototype.setPAC = function(l) {
                        $e.log("INFO", "pacData = " + JSON.stringify(l));
                        var s = l.row - 1;
                        if (this.nrRollUpRows && s < this.nrRollUpRows - 1 && (s = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== s) {
                            for(var u = 0; u < Ur; u++)this.rows[u].clear();
                            var f = this.currRow + 1 - this.nrRollUpRows, E = this.lastOutputScreen;
                            if (E) {
                                var w = E.rows[f].cueStartTime;
                                if (w && w < $e.time) for(var A = 0; A < this.nrRollUpRows; A++)this.rows[s - this.nrRollUpRows + A + 1].copy(E.rows[f + A]);
                            }
                        }
                        this.currRow = s;
                        var S = this.rows[this.currRow];
                        if (l.indent !== null) {
                            var k = l.indent, B = Math.max(k - 1, 0);
                            S.setCursor(l.indent), l.color = S.chars[B].penState.foreground;
                        }
                        var U = {
                            foreground: l.color,
                            underline: l.underline,
                            italics: l.italics,
                            background: "black",
                            flash: !1
                        };
                        this.setPen(U);
                    }, g.prototype.setBkgData = function(l) {
                        $e.log("INFO", "bkgData = " + JSON.stringify(l)), this.backSpace(), this.setPen(l), this.insertChar(32);
                    }, g.prototype.setRollUpRows = function(l) {
                        this.nrRollUpRows = l;
                    }, g.prototype.rollUp = function() {
                        if (this.nrRollUpRows === null) {
                            $e.log("DEBUG", "roll_up but nrRollUpRows not set yet");
                            return;
                        }
                        $e.log("TEXT", this.getDisplayText());
                        var l = this.currRow + 1 - this.nrRollUpRows, s = this.rows.splice(l, 1)[0];
                        s.clear(), this.rows.splice(this.currRow, 0, s), $e.log("INFO", "Rolling up");
                    }, g.prototype.getDisplayText = function(l) {
                        l = l || !1;
                        for(var s = [], u = "", f = -1, E = 0; E < Ur; E++){
                            var w = this.rows[E].getTextString();
                            w && (f = E + 1, l ? s.push("Row " + f + ": '" + w + "'") : s.push(w.trim()));
                        }
                        return s.length > 0 && (l ? u = "[" + s.join(" | ") + "]" : u = s.join(`
`)), u;
                    }, g.prototype.getTextAndFormat = function() {
                        return this.rows;
                    }, g;
                }(), yd = function() {
                    function g(o, l) {
                        fs(this, g), this.chNr = o, this.outputFilter = l, this.mode = null, this.verbose = 0, this.displayedMemory = new rc(), this.nonDisplayedMemory = new rc(), this.lastOutputScreen = new rc(), this.currRollUpRow = this.displayedMemory.rows[Ur - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
                    }
                    return g.prototype.reset = function() {
                        this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.currRollUpRow = this.displayedMemory.rows[Ur - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.lastCueEndTime = null;
                    }, g.prototype.getHandler = function() {
                        return this.outputFilter;
                    }, g.prototype.setHandler = function(l) {
                        this.outputFilter = l;
                    }, g.prototype.setPAC = function(l) {
                        this.writeScreen.setPAC(l);
                    }, g.prototype.setBkgData = function(l) {
                        this.writeScreen.setBkgData(l);
                    }, g.prototype.setMode = function(l) {
                        l !== this.mode && (this.mode = l, $e.log("INFO", "MODE=" + l), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = l);
                    }, g.prototype.insertChars = function(l) {
                        for(var s = 0; s < l.length; s++)this.writeScreen.insertChar(l[s]);
                        var u = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
                        $e.log("INFO", u + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && ($e.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
                    }, g.prototype.ccRCL = function() {
                        $e.log("INFO", "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
                    }, g.prototype.ccBS = function() {
                        $e.log("INFO", "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
                    }, g.prototype.ccAOF = function() {}, g.prototype.ccAON = function() {}, g.prototype.ccDER = function() {
                        $e.log("INFO", "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
                    }, g.prototype.ccRU = function(l) {
                        $e.log("INFO", "RU(" + l + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(l);
                    }, g.prototype.ccFON = function() {
                        $e.log("INFO", "FON - Flash On"), this.writeScreen.setPen({
                            flash: !0
                        });
                    }, g.prototype.ccRDC = function() {
                        $e.log("INFO", "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
                    }, g.prototype.ccTR = function() {
                        $e.log("INFO", "TR"), this.setMode("MODE_TEXT");
                    }, g.prototype.ccRTD = function() {
                        $e.log("INFO", "RTD"), this.setMode("MODE_TEXT");
                    }, g.prototype.ccEDM = function() {
                        $e.log("INFO", "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
                    }, g.prototype.ccCR = function() {
                        $e.log("CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
                    }, g.prototype.ccENM = function() {
                        $e.log("INFO", "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
                    }, g.prototype.ccEOC = function() {
                        if ($e.log("INFO", "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
                            var l = this.displayedMemory;
                            this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = l, this.writeScreen = this.nonDisplayedMemory, $e.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
                        }
                        this.outputDataUpdate(!0);
                    }, g.prototype.ccTO = function(l) {
                        $e.log("INFO", "TO(" + l + ") - Tab Offset"), this.writeScreen.moveCursor(l);
                    }, g.prototype.ccMIDROW = function(l) {
                        var s = {
                            flash: !1
                        };
                        if (s.underline = l % 2 === 1, s.italics = l >= 46, s.italics) s.foreground = "white";
                        else {
                            var u = Math.floor(l / 2) - 16, f = [
                                "white",
                                "green",
                                "blue",
                                "cyan",
                                "red",
                                "yellow",
                                "magenta"
                            ];
                            s.foreground = f[u];
                        }
                        $e.log("INFO", "MIDROW: " + JSON.stringify(s)), this.writeScreen.setPen(s);
                    }, g.prototype.outputDataUpdate = function() {
                        var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, s = $e.time;
                        s !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = s : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue && (this.outputFilter.newCue(this.cueStartTime, s, this.lastOutputScreen), l === !0 && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue()), this.cueStartTime = this.displayedMemory.isEmpty() ? null : s), this.lastOutputScreen.copy(this.displayedMemory));
                    }, g.prototype.cueSplitAtTime = function(l) {
                        this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, l, this.displayedMemory), this.cueStartTime = l));
                    }, g;
                }(), wy = function() {
                    function g(o, l, s) {
                        fs(this, g), this.field = o || 1, this.outputs = [
                            l,
                            s
                        ], this.channels = [
                            new yd(1, l),
                            new yd(2, s)
                        ], this.currChNr = -1, this.lastCmdA = null, this.lastCmdB = null, this.bufferedData = [], this.startTime = null, this.lastTime = null, this.dataCounters = {
                            padding: 0,
                            char: 0,
                            cmd: 0,
                            other: 0
                        };
                    }
                    return g.prototype.getHandler = function(l) {
                        return this.channels[l].getHandler();
                    }, g.prototype.setHandler = function(l, s) {
                        this.channels[l].setHandler(s);
                    }, g.prototype.addData = function(l, s) {
                        var u, f, E, w = !1;
                        this.lastTime = l, $e.setTime(l);
                        for(var A = 0; A < s.length; A += 2){
                            if (f = s[A] & 127, E = s[A + 1] & 127, f === 0 && E === 0) {
                                this.dataCounters.padding += 2;
                                continue;
                            } else $e.log("DATA", "[" + Pn([
                                s[A],
                                s[A + 1]
                            ]) + "] -> (" + Pn([
                                f,
                                E
                            ]) + ")");
                            if (u = this.parseCmd(f, E), u || (u = this.parseMidrow(f, E)), u || (u = this.parsePAC(f, E)), u || (u = this.parseBackgroundAttributes(f, E)), !u && (w = this.parseChars(f, E), w)) {
                                if (this.currChNr && this.currChNr >= 0) {
                                    var S = this.channels[this.currChNr - 1];
                                    S.insertChars(w);
                                } else $e.log("WARNING", "No channel found yet. TEXT-MODE?");
                            }
                            u ? this.dataCounters.cmd += 2 : w ? this.dataCounters.char += 2 : (this.dataCounters.other += 2, $e.log("WARNING", "Couldn't parse cleaned data " + Pn([
                                f,
                                E
                            ]) + " orig: " + Pn([
                                s[A],
                                s[A + 1]
                            ])));
                        }
                    }, g.prototype.parseCmd = function(l, s) {
                        var u = null, f = (l === 20 || l === 28) && 32 <= s && s <= 47, E = (l === 23 || l === 31) && 33 <= s && s <= 35;
                        if (!(f || E)) return !1;
                        if (l === this.lastCmdA && s === this.lastCmdB) return this.lastCmdA = null, this.lastCmdB = null, $e.log("DEBUG", "Repeated command (" + Pn([
                            l,
                            s
                        ]) + ") is dropped"), !0;
                        l === 20 || l === 23 ? u = 1 : u = 2;
                        var w = this.channels[u - 1];
                        return l === 20 || l === 28 ? s === 32 ? w.ccRCL() : s === 33 ? w.ccBS() : s === 34 ? w.ccAOF() : s === 35 ? w.ccAON() : s === 36 ? w.ccDER() : s === 37 ? w.ccRU(2) : s === 38 ? w.ccRU(3) : s === 39 ? w.ccRU(4) : s === 40 ? w.ccFON() : s === 41 ? w.ccRDC() : s === 42 ? w.ccTR() : s === 43 ? w.ccRTD() : s === 44 ? w.ccEDM() : s === 45 ? w.ccCR() : s === 46 ? w.ccENM() : s === 47 && w.ccEOC() : w.ccTO(s - 32), this.lastCmdA = l, this.lastCmdB = s, this.currChNr = u, !0;
                    }, g.prototype.parseMidrow = function(l, s) {
                        var u = null;
                        if ((l === 17 || l === 25) && 32 <= s && s <= 47) {
                            if (l === 17 ? u = 1 : u = 2, u !== this.currChNr) return $e.log("ERROR", "Mismatch channel in midrow parsing"), !1;
                            var f = this.channels[u - 1];
                            return f.ccMIDROW(s), $e.log("DEBUG", "MIDROW (" + Pn([
                                l,
                                s
                            ]) + ")"), !0;
                        }
                        return !1;
                    }, g.prototype.parsePAC = function(l, s) {
                        var u = null, f = null, E = (17 <= l && l <= 23 || 25 <= l && l <= 31) && 64 <= s && s <= 127, w = (l === 16 || l === 24) && 64 <= s && s <= 95;
                        if (!(E || w)) return !1;
                        if (l === this.lastCmdA && s === this.lastCmdB) return this.lastCmdA = null, this.lastCmdB = null, !0;
                        u = l <= 23 ? 1 : 2, 64 <= s && s <= 95 ? f = u === 1 ? gy[l] : Ey[l] : f = u === 1 ? xy[l] : vy[l];
                        var A = this.interpretPAC(f, s), S = this.channels[u - 1];
                        return S.setPAC(A), this.lastCmdA = l, this.lastCmdB = s, this.currChNr = u, !0;
                    }, g.prototype.interpretPAC = function(l, s) {
                        var u = s, f = {
                            color: null,
                            italics: !1,
                            indent: null,
                            underline: !1,
                            row: l
                        };
                        return s > 95 ? u = s - 96 : u = s - 64, f.underline = (u & 1) === 1, u <= 13 ? f.color = [
                            "white",
                            "green",
                            "blue",
                            "cyan",
                            "red",
                            "yellow",
                            "magenta",
                            "white"
                        ][Math.floor(u / 2)] : u <= 15 ? (f.italics = !0, f.color = "white") : f.indent = Math.floor((u - 16) / 2) * 4, f;
                    }, g.prototype.parseChars = function(l, s) {
                        var u = null, f = null, E = null;
                        if (l >= 25 ? (u = 2, E = l - 8) : (u = 1, E = l), 17 <= E && E <= 19) {
                            var w = s;
                            E === 17 ? w = s + 80 : E === 18 ? w = s + 112 : w = s + 144, $e.log("INFO", "Special char '" + hd(w) + "' in channel " + u), f = [
                                w
                            ];
                        } else 32 <= l && l <= 127 && (f = s === 0 ? [
                            l
                        ] : [
                            l,
                            s
                        ]);
                        if (f) {
                            var A = Pn(f);
                            $e.log("DEBUG", "Char codes =  " + A.join(",")), this.lastCmdA = null, this.lastCmdB = null;
                        }
                        return f;
                    }, g.prototype.parseBackgroundAttributes = function(l, s) {
                        var u, f, E, w, A = (l === 16 || l === 24) && 32 <= s && s <= 47, S = (l === 23 || l === 31) && 45 <= s && s <= 47;
                        return A || S ? (u = {}, l === 16 || l === 24 ? (f = Math.floor((s - 32) / 2), u.background = Ry[f], s % 2 === 1 && (u.background = u.background + "_semi")) : s === 45 ? u.background = "transparent" : (u.foreground = "black", s === 47 && (u.underline = !0)), E = l < 24 ? 1 : 2, w = this.channels[E - 1], w.setBkgData(u), this.lastCmdA = null, this.lastCmdB = null, !0) : !1;
                    }, g.prototype.reset = function() {
                        for(var l = 0; l < this.channels.length; l++)this.channels[l] && this.channels[l].reset();
                        this.lastCmdA = null, this.lastCmdB = null;
                    }, g.prototype.cueSplitAtTime = function(l) {
                        for(var s = 0; s < this.channels.length; s++)this.channels[s] && this.channels[s].cueSplitAtTime(l);
                    }, g;
                }(), Ty = wy;
                function Sy(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var Cy = function() {
                    function g(o, l) {
                        Sy(this, g), this.timelineController = o, this.track = l, this.startTime = null, this.endTime = null, this.screen = null;
                    }
                    return g.prototype.dispatchCue = function() {
                        this.startTime !== null && (this.timelineController.addCues("textTrack" + this.track, this.startTime, this.endTime, this.screen), this.startTime = null);
                    }, g.prototype.newCue = function(l, s, u) {
                        (this.startTime === null || this.startTime > l) && (this.startTime = l), this.endTime = s, this.screen = u, this.timelineController.createCaptionsTrack(this.track);
                    }, g;
                }(), bd = Cy, ic = function(o, l, s) {
                    return o.substr(0, l.length) === l;
                }, Ly = function(o) {
                    var l = parseInt(o.substr(-3)), s = parseInt(o.substr(-6, 2)), u = parseInt(o.substr(-9, 2)), f = o.length > 9 ? parseInt(o.substr(0, o.indexOf(":"))) : 0;
                    return isNaN(l) || isNaN(s) || isNaN(u) || isNaN(f) ? -1 : (l += 1e3 * s, l += 60000 * u, l += 3600000 * f, l);
                }, nc = function(o) {
                    for(var l = 5381, s = o.length; s;)l = l * 33 ^ o.charCodeAt(--s);
                    return (l >>> 0).toString();
                }, ky = function(o, l, s) {
                    var u = o[l], f = o[u.prevCC];
                    if (!f || !f.new && u.new) {
                        o.ccOffset = o.presentationOffset = u.start, u.new = !1;
                        return;
                    }
                    for(; f && f.new;)o.ccOffset += u.start - f.start, u.new = !1, u = f, f = o[u.prevCC];
                    o.presentationOffset = s;
                }, Dy = {
                    parse: function(o, l, s, u, f, E) {
                        var w = /\r\n|\n\r|\n|\r/g, A = Object(nt.b)(new Uint8Array(o)).trim().replace(w, `
`).split(`
`), S = "00:00.000", k = 0, B = 0, U = 0, F = [], ee = void 0, he = !0, ge = new yy();
                        ge.oncue = function(be) {
                            var Se = s[u], Ce = s.ccOffset;
                            Se && Se.new && (B !== void 0 ? Ce = s.ccOffset = Se.start : ky(s, u, U)), U && (Ce = U + s.ccOffset - s.presentationOffset), be.startTime += Ce - B, be.endTime += Ce - B, be.id = nc(be.startTime.toString()) + nc(be.endTime.toString()) + nc(be.text), be.text = decodeURIComponent(encodeURIComponent(be.text)), be.endTime > 0 && F.push(be);
                        }, ge.onparsingerror = function(be) {
                            ee = be;
                        }, ge.onflush = function() {
                            if (ee && E) {
                                E(ee);
                                return;
                            }
                            f(F);
                        }, A.forEach(function(be) {
                            if (he) {
                                if (ic(be, "X-TIMESTAMP-MAP=")) {
                                    he = !1, be.substr(16).split(",").forEach(function(Se) {
                                        ic(Se, "LOCAL:") ? S = Se.substr(6) : ic(Se, "MPEGTS:") && (k = parseInt(Se.substr(7)));
                                    });
                                    try {
                                        l = l < 0 ? l + 8589934592 : l, k -= l, B = Ly(S) / 1e3, U = k / 9e4, B === -1 && (ee = new Error("Malformed X-TIMESTAMP-MAP: " + be));
                                    } catch  {
                                        ee = new Error("Malformed X-TIMESTAMP-MAP: " + be);
                                    }
                                    return;
                                } else be === "" && (he = !1);
                            }
                            ge.parse(be + `
`);
                        }), ge.flush();
                    }
                }, Py = Dy;
                function By(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function Iy(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function Uy(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                function Zl(g) {
                    if (g && g.cues) for(; g.cues.length > 0;)g.removeCue(g.cues[0]);
                }
                function Oy(g, o) {
                    return g && g.label === o.name && !(g.textTrack1 || g.textTrack2);
                }
                function Ky(g, o, l, s) {
                    return Math.min(o, s) - Math.max(g, l);
                }
                var My = function(g) {
                    Uy(o, g);
                    function o(l) {
                        By(this, o);
                        var s = Iy(this, g.call(this, l, p.a.MEDIA_ATTACHING, p.a.MEDIA_DETACHING, p.a.FRAG_PARSING_USERDATA, p.a.FRAG_DECRYPTED, p.a.MANIFEST_LOADING, p.a.MANIFEST_LOADED, p.a.FRAG_LOADED, p.a.LEVEL_SWITCHING, p.a.INIT_PTS_FOUND));
                        if (s.hls = l, s.config = l.config, s.enabled = !0, s.Cues = l.config.cueHandler, s.textTracks = [], s.tracks = [], s.unparsedVttFrags = [], s.initPTS = void 0, s.cueRanges = [], s.config.enableCEA708Captions) {
                            var u = new bd(s, 1), f = new bd(s, 2);
                            s.cea608Parser = new Ty(0, u, f);
                        }
                        return s;
                    }
                    return o.prototype.addCues = function(s, u, f, E) {
                        for(var w = this.cueRanges, A = !1, S = w.length; S--;){
                            var k = w[S], B = Ky(k[0], k[1], u, f);
                            if (B >= 0 && (k[0] = Math.min(k[0], u), k[1] = Math.max(k[1], f), A = !0, B / (f - u) > 0.5)) return;
                        }
                        A || w.push([
                            u,
                            f
                        ]), this.Cues.newCue(this[s], u, f, E);
                    }, o.prototype.onInitPtsFound = function(s) {
                        var u = this;
                        typeof this.initPTS > "u" && (this.initPTS = s.initPTS), this.unparsedVttFrags.length && (this.unparsedVttFrags.forEach(function(f) {
                            u.onFragLoaded(f);
                        }), this.unparsedVttFrags = []);
                    }, o.prototype.getExistingTrack = function(s) {
                        var u = this.media;
                        if (u) for(var f = 0; f < u.textTracks.length; f++){
                            var E = u.textTracks[f], w = "textTrack" + s;
                            if (E[w] === !0) return E;
                        }
                        return null;
                    }, o.prototype.sendAddTrackEvent = function(s, u) {
                        var f = null;
                        try {
                            f = new window.Event("addtrack");
                        } catch  {
                            f = document.createEvent("Event"), f.initEvent("addtrack", !1, !1);
                        }
                        f.track = s, u.dispatchEvent(f);
                    }, o.prototype.createCaptionsTrack = function(s) {
                        var u = "textTrack" + s;
                        if (!this[u]) {
                            var f = this.getExistingTrack(s);
                            if (f) this[u] = f, Zl(this[u]), this.sendAddTrackEvent(this[u], this.media);
                            else {
                                var E = this.createTextTrack("captions", this.config["captionsTextTrack" + s + "Label"], this.config.captionsTextTrack1LanguageCode);
                                E && (E[u] = !0, this[u] = E);
                            }
                        }
                    }, o.prototype.createTextTrack = function(s, u, f) {
                        var E = this.media;
                        if (E) return E.addTextTrack(s, u, f);
                    }, o.prototype.destroy = function() {
                        O.prototype.destroy.call(this);
                    }, o.prototype.onMediaAttaching = function(s) {
                        this.media = s.media, this._cleanTracks();
                    }, o.prototype.onMediaDetaching = function() {
                        Zl(this.textTrack1), Zl(this.textTrack2);
                    }, o.prototype.onManifestLoading = function() {
                        this.lastSn = -1, this.prevCC = -1, this.vttCCs = {
                            ccOffset: 0,
                            presentationOffset: 0
                        }, this._cleanTracks();
                    }, o.prototype._cleanTracks = function() {
                        var s = this.media;
                        if (s) {
                            var u = s.textTracks;
                            if (u) for(var f = 0; f < u.length; f++)Zl(u[f]);
                        }
                    }, o.prototype.onManifestLoaded = function(s) {
                        var u = this;
                        if (this.textTracks = [], this.unparsedVttFrags = this.unparsedVttFrags || [], this.initPTS = void 0, this.cueRanges = [], this.config.enableWebVTT) {
                            this.tracks = s.subtitles || [];
                            var f = this.media ? this.media.textTracks : [];
                            this.tracks.forEach(function(E, w) {
                                var A = void 0;
                                if (w < f.length) {
                                    var S = f[w];
                                    Oy(S, E) && (A = S);
                                }
                                A || (A = u.createTextTrack("subtitles", E.name, E.lang)), A.mode = E.default ? "showing" : "hidden", u.textTracks.push(A);
                            });
                        }
                    }, o.prototype.onLevelSwitching = function() {
                        this.enabled = this.hls.currentLevel.closedCaptions !== "NONE";
                    }, o.prototype.onFragLoaded = function(s) {
                        var u = s.frag, f = s.payload;
                        if (u.type === "main") {
                            var E = u.sn;
                            if (E !== this.lastSn + 1) {
                                var w = this.cea608Parser;
                                w && w.reset();
                            }
                            this.lastSn = E;
                        } else if (u.type === "subtitle") {
                            if (f.byteLength) {
                                if (typeof this.initPTS > "u") {
                                    this.unparsedVttFrags.push(s);
                                    return;
                                }
                                var A = u.decryptdata;
                                (A == null || A.key == null || A.method !== "AES-128") && this._parseVTTs(u, f);
                            } else this.hls.trigger(p.a.SUBTITLE_FRAG_PROCESSED, {
                                success: !1,
                                frag: u
                            });
                        }
                    }, o.prototype._parseVTTs = function(s, u) {
                        var f = this.vttCCs;
                        f[s.cc] || (f[s.cc] = {
                            start: s.start,
                            prevCC: this.prevCC,
                            new: !0
                        }, this.prevCC = s.cc);
                        var E = this.textTracks, w = this.hls;
                        Py.parse(u, this.initPTS, f, s.cc, function(A) {
                            var S = E[s.trackId];
                            A.forEach(function(k) {
                                if (!S.cues.getCueById(k.id)) try {
                                    S.addCue(k);
                                } catch  {
                                    var B = new window.TextTrackCue(k.startTime, k.endTime, k.text);
                                    B.id = k.id, S.addCue(B);
                                }
                            }), w.trigger(p.a.SUBTITLE_FRAG_PROCESSED, {
                                success: !0,
                                frag: s
                            });
                        }, function(A) {
                            d.b.log("Failed to parse VTT cue: " + A), w.trigger(p.a.SUBTITLE_FRAG_PROCESSED, {
                                success: !1,
                                frag: s
                            });
                        });
                    }, o.prototype.onFragDecrypted = function(s) {
                        var u = s.payload, f = s.frag;
                        if (f.type === "subtitle") {
                            if (typeof this.initPTS > "u") {
                                this.unparsedVttFrags.push(s);
                                return;
                            }
                            this._parseVTTs(f, u);
                        }
                    }, o.prototype.onFragParsingUserdata = function(s) {
                        if (this.enabled && this.config.enableCEA708Captions) for(var u = 0; u < s.samples.length; u++){
                            var f = this.extractCea608Data(s.samples[u].bytes);
                            this.cea608Parser.addData(s.samples[u].pts, f);
                        }
                    }, o.prototype.extractCea608Data = function(s) {
                        for(var u = s[0] & 31, f = 2, E, w, A, S, k, B = [], U = 0; U < u; U++)E = s[f++], w = 127 & s[f++], A = 127 & s[f++], S = (4 & E) !== 0, k = 3 & E, !(w === 0 && A === 0) && S && k === 0 && (B.push(w), B.push(A));
                        return B;
                    }, o;
                }(O), Ny = My, Vy = /* @__PURE__ */ function() {
                    function g(o, l) {
                        for(var s = 0; s < l.length; s++){
                            var u = l[s];
                            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
                        }
                    }
                    return function(o, l, s) {
                        return l && g(o.prototype, l), s && g(o, s), o;
                    };
                }();
                function jy(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function Fy(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function $y(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                function gd(g) {
                    for(var o = [], l = 0; l < g.length; l++)g[l].kind === "subtitles" && o.push(g[l]);
                    return o;
                }
                var Gy = function(g) {
                    $y(o, g);
                    function o(l) {
                        jy(this, o);
                        var s = Fy(this, g.call(this, l, p.a.MEDIA_ATTACHED, p.a.MEDIA_DETACHING, p.a.MANIFEST_LOADING, p.a.MANIFEST_LOADED, p.a.SUBTITLE_TRACK_LOADED));
                        return s.tracks = [], s.trackId = -1, s.media = void 0, s.subtitleDisplay = !1, s;
                    }
                    return o.prototype._onTextTracksChanged = function() {
                        if (this.media) {
                            for(var s = -1, u = gd(this.media.textTracks), f = 0; f < u.length; f++)u[f].mode === "showing" && (s = f);
                            this.subtitleTrack = s;
                        }
                    }, o.prototype.destroy = function() {
                        O.prototype.destroy.call(this);
                    }, o.prototype.onMediaAttached = function(s) {
                        var u = this;
                        this.media = s.media, this.media && (this.queuedDefaultTrack !== void 0 && (this.subtitleTrack = this.queuedDefaultTrack, delete this.queuedDefaultTrack), this.trackChangeListener = this._onTextTracksChanged.bind(this), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.subtitlePollingInterval = setInterval(function() {
                            u.trackChangeListener();
                        }, 500) : this.media.textTracks.addEventListener("change", this.trackChangeListener));
                    }, o.prototype.onMediaDetaching = function() {
                        this.media && (this.useTextTrackPolling ? clearInterval(this.subtitlePollingInterval) : this.media.textTracks.removeEventListener("change", this.trackChangeListener), this.media = void 0);
                    }, o.prototype.onManifestLoading = function() {
                        this.tracks = [], this.trackId = -1;
                    }, o.prototype.onManifestLoaded = function(s) {
                        var u = this, f = s.subtitles || [];
                        this.tracks = f, this.trackId = -1, this.hls.trigger(p.a.SUBTITLE_TRACKS_UPDATED, {
                            subtitleTracks: f
                        }), f.forEach(function(E) {
                            E.default && (u.media ? u.subtitleTrack = E.id : u.queuedDefaultTrack = E.id);
                        });
                    }, o.prototype.onTick = function() {
                        var s = this.trackId, u = this.tracks[s];
                        if (u) {
                            var f = u.details;
                            (f === void 0 || f.live === !0) && (d.b.log("(re)loading playlist for subtitle track " + s), this.hls.trigger(p.a.SUBTITLE_TRACK_LOADING, {
                                url: u.url,
                                id: s
                            }));
                        }
                    }, o.prototype.onSubtitleTrackLoaded = function(s) {
                        var u = this;
                        s.id < this.tracks.length && (d.b.log("subtitle track " + s.id + " loaded"), this.tracks[s.id].details = s.details, s.details.live && !this.timer && (this.timer = setInterval(function() {
                            u.onTick();
                        }, 1e3 * s.details.targetduration, this)), !s.details.live && this.timer && (clearInterval(this.timer), this.timer = null));
                    }, o.prototype.setSubtitleTrackInternal = function(s) {
                        if (!(s < -1 || s >= this.tracks.length)) {
                            this.timer && (clearInterval(this.timer), this.timer = null);
                            var u = gd(this.media.textTracks);
                            if (this.trackId !== -1 && this.subtitleDisplay && (u[this.trackId].mode = "hidden"), this.trackId = s, d.b.log("switching to subtitle track " + s), this.hls.trigger(p.a.SUBTITLE_TRACK_SWITCH, {
                                id: s
                            }), s !== -1) {
                                var f = this.tracks[s];
                                this.subtitleDisplay && (u[s].mode = "showing");
                                var E = f.details;
                                (E === void 0 || E.live === !0) && (d.b.log("(re)loading playlist for subtitle track " + s), this.hls.trigger(p.a.SUBTITLE_TRACK_LOADING, {
                                    url: f.url,
                                    id: s
                                }));
                            }
                        }
                    }, Vy(o, [
                        {
                            key: "subtitleTracks",
                            get: function() {
                                return this.tracks;
                            }
                        },
                        {
                            key: "subtitleTrack",
                            get: function() {
                                return this.trackId;
                            },
                            set: function(s) {
                                this.trackId !== s && this.setSubtitleTrackInternal(s);
                            }
                        }
                    ]), o;
                }(O), qy = Gy, zy = a(4);
                function Xy(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                function Hy(g, o) {
                    if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return o && (typeof o == "object" || typeof o == "function") ? o : g;
                }
                function Zy(g, o) {
                    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof o);
                    g.prototype = Object.create(o && o.prototype, {
                        constructor: {
                            value: g,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(g, o) : g.__proto__ = o);
                }
                var Yr = {
                    STOPPED: "STOPPED",
                    IDLE: "IDLE",
                    KEY_LOADING: "KEY_LOADING",
                    FRAG_LOADING: "FRAG_LOADING"
                }, Wy = function(g) {
                    Zy(o, g);
                    function o(l) {
                        Xy(this, o);
                        var s = Hy(this, g.call(this, l, p.a.MEDIA_ATTACHED, p.a.ERROR, p.a.KEY_LOADED, p.a.FRAG_LOADED, p.a.SUBTITLE_TRACKS_UPDATED, p.a.SUBTITLE_TRACK_SWITCH, p.a.SUBTITLE_TRACK_LOADED, p.a.SUBTITLE_FRAG_PROCESSED));
                        return s.config = l.config, s.vttFragSNsProcessed = {}, s.vttFragQueues = void 0, s.currentlyProcessing = null, s.state = Yr.STOPPED, s.currentTrackId = -1, s.ticks = 0, s.decrypter = new zy.a(l.observer, l.config), s;
                    }
                    return o.prototype.destroy = function() {
                        O.prototype.destroy.call(this), this.state = Yr.STOPPED;
                    }, o.prototype.clearVttFragQueues = function() {
                        var s = this;
                        this.vttFragQueues = {}, this.tracks.forEach(function(u) {
                            s.vttFragQueues[u.id] = [];
                        });
                    }, o.prototype.nextFrag = function() {
                        if (this.currentlyProcessing === null && this.currentTrackId > -1 && this.vttFragQueues[this.currentTrackId].length) {
                            var s = this.currentlyProcessing = this.vttFragQueues[this.currentTrackId].shift();
                            this.fragCurrent = s, this.hls.trigger(p.a.FRAG_LOADING, {
                                frag: s
                            }), this.state = Yr.FRAG_LOADING;
                        }
                    }, o.prototype.onSubtitleFragProcessed = function(s) {
                        s.success && this.vttFragSNsProcessed[s.frag.trackId].push(s.frag.sn), this.currentlyProcessing = null, this.state = Yr.IDLE, this.nextFrag();
                    }, o.prototype.onMediaAttached = function() {
                        this.state = Yr.IDLE;
                    }, o.prototype.onError = function(s) {
                        var u = s.frag;
                        u && u.type !== "subtitle" || this.currentlyProcessing && (this.currentlyProcessing = null, this.nextFrag());
                    }, o.prototype.tick = function() {
                        var s = this;
                        this.ticks++, this.ticks === 1 && (this.doTick(), this.ticks > 1 && setTimeout(function() {
                            s.tick();
                        }, 1), this.ticks = 0);
                    }, o.prototype.doTick = function() {
                        var s = this;
                        switch(this.state){
                            case Yr.IDLE:
                                var u = this.tracks, f = this.currentTrackId, E = this.vttFragSNsProcessed[f], w = this.vttFragQueues[f], A = this.currentlyProcessing ? this.currentlyProcessing.sn : -1, S = function(F) {
                                    return E.indexOf(F.sn) > -1;
                                }, k = function(F) {
                                    return w.some(function(ee) {
                                        return ee.sn === F.sn;
                                    });
                                };
                                if (!u) break;
                                var B;
                                if (f < u.length && (B = u[f].details), typeof B > "u") break;
                                B.fragments.forEach(function(U) {
                                    S(U) || U.sn === A || k(U) || (U.decryptdata && U.decryptdata.uri != null && U.decryptdata.key == null ? (d.b.log("Loading key for " + U.sn), s.state = Yr.KEY_LOADING, s.hls.trigger(p.a.KEY_LOADING, {
                                        frag: U
                                    })) : (U.trackId = f, w.push(U), s.nextFrag()));
                                });
                        }
                    }, o.prototype.onSubtitleTracksUpdated = function(s) {
                        var u = this;
                        d.b.log("subtitle tracks updated"), this.tracks = s.subtitleTracks, this.clearVttFragQueues(), this.vttFragSNsProcessed = {}, this.tracks.forEach(function(f) {
                            u.vttFragSNsProcessed[f.id] = [];
                        });
                    }, o.prototype.onSubtitleTrackSwitch = function(s) {
                        this.currentTrackId = s.id, this.clearVttFragQueues();
                    }, o.prototype.onSubtitleTrackLoaded = function() {
                        this.tick();
                    }, o.prototype.onKeyLoaded = function() {
                        this.state === Yr.KEY_LOADING && (this.state = Yr.IDLE, this.tick());
                    }, o.prototype.onFragLoaded = function(s) {
                        var u = this.fragCurrent, f = s.frag.decryptdata, E = s.frag, w = this.hls;
                        if (this.state === Yr.FRAG_LOADING && u && s.frag.type === "subtitle" && u.sn === s.frag.sn && s.payload.byteLength > 0 && f != null && f.key != null && f.method === "AES-128") {
                            var A;
                            try {
                                A = performance.now();
                            } catch  {
                                A = Date.now();
                            }
                            this.decrypter.decrypt(s.payload, f.key.buffer, f.iv.buffer, function(S) {
                                var k;
                                try {
                                    k = performance.now();
                                } catch  {
                                    k = Date.now();
                                }
                                w.trigger(p.a.FRAG_DECRYPTED, {
                                    frag: E,
                                    payload: S,
                                    stats: {
                                        tstart: A,
                                        tdecrypt: k
                                    }
                                });
                            });
                        }
                    }, o;
                }(O), Yy = Wy, xr = {
                    autoStartLoad: !0,
                    // used by stream-controller
                    startPosition: -1,
                    // used by stream-controller
                    defaultAudioCodec: void 0,
                    // used by stream-controller
                    debug: !1,
                    // used by logger
                    capLevelOnFPSDrop: !1,
                    // used by fps-controller
                    capLevelToPlayerSize: !1,
                    // used by cap-level-controller
                    initialLiveManifestSize: 1,
                    // used by stream-controller
                    maxBufferLength: 30,
                    // used by stream-controller
                    maxBufferSize: 60000000,
                    // used by stream-controller
                    maxBufferHole: 0.5,
                    // used by stream-controller
                    maxSeekHole: 2,
                    // used by stream-controller
                    lowBufferWatchdogPeriod: 0.5,
                    // used by stream-controller
                    highBufferWatchdogPeriod: 3,
                    // used by stream-controller
                    nudgeOffset: 0.1,
                    // used by stream-controller
                    nudgeMaxRetry: 3,
                    // used by stream-controller
                    maxFragLookUpTolerance: 0.25,
                    // used by stream-controller
                    liveSyncDurationCount: 3,
                    // used by stream-controller
                    liveMaxLatencyDurationCount: 1 / 0,
                    // used by stream-controller
                    liveSyncDuration: void 0,
                    // used by stream-controller
                    liveMaxLatencyDuration: void 0,
                    // used by stream-controller
                    liveDurationInfinity: !1,
                    // used by buffer-controller
                    maxMaxBufferLength: 600,
                    // used by stream-controller
                    enableWorker: !0,
                    // used by demuxer
                    enableSoftwareAES: !0,
                    // used by decrypter
                    manifestLoadingTimeOut: 1e4,
                    // used by playlist-loader
                    manifestLoadingMaxRetry: 1,
                    // used by playlist-loader
                    manifestLoadingRetryDelay: 1e3,
                    // used by playlist-loader
                    manifestLoadingMaxRetryTimeout: 64e3,
                    // used by playlist-loader
                    startLevel: void 0,
                    // used by level-controller
                    levelLoadingTimeOut: 1e4,
                    // used by playlist-loader
                    levelLoadingMaxRetry: 4,
                    // used by playlist-loader
                    levelLoadingRetryDelay: 1e3,
                    // used by playlist-loader
                    levelLoadingMaxRetryTimeout: 64e3,
                    // used by playlist-loader
                    fragLoadingTimeOut: 2e4,
                    // used by fragment-loader
                    fragLoadingMaxRetry: 6,
                    // used by fragment-loader
                    fragLoadingRetryDelay: 1e3,
                    // used by fragment-loader
                    fragLoadingMaxRetryTimeout: 64e3,
                    // used by fragment-loader
                    fragLoadingLoopThreshold: 3,
                    // used by stream-controller
                    startFragPrefetch: !1,
                    // used by stream-controller
                    fpsDroppedMonitoringPeriod: 5e3,
                    // used by fps-controller
                    fpsDroppedMonitoringThreshold: 0.2,
                    // used by fps-controller
                    appendErrorMaxRetry: 3,
                    // used by buffer-controller
                    loader: ey,
                    //loader: FetchLoader,
                    fLoader: void 0,
                    pLoader: void 0,
                    xhrSetup: void 0,
                    fetchSetup: void 0,
                    abrController: kn,
                    bufferController: Wr,
                    capLevelController: gr,
                    fpsController: Ym,
                    stretchShortVideoTrack: !1,
                    // used by mp4-remuxer
                    maxAudioFramesDrift: 1,
                    // used by mp4-remuxer
                    forceKeyFrameOnDiscontinuity: !0,
                    // used by ts-demuxer
                    abrEwmaFastLive: 3,
                    // used by abr-controller
                    abrEwmaSlowLive: 9,
                    // used by abr-controller
                    abrEwmaFastVoD: 3,
                    // used by abr-controller
                    abrEwmaSlowVoD: 9,
                    // used by abr-controller
                    abrEwmaDefaultEstimate: 5e5,
                    // 500 kbps  // used by abr-controller
                    abrBandWidthFactor: 0.95,
                    // used by abr-controller
                    abrBandWidthUpFactor: 0.7,
                    // used by abr-controller
                    abrMaxWithRealBitrate: !1,
                    // used by abr-controller
                    maxStarvationDelay: 4,
                    // used by abr-controller
                    maxLoadingDelay: 4,
                    // used by abr-controller
                    minAutoBitrate: 0
                };
                xr.subtitleStreamController = Yy, xr.subtitleTrackController = qy, xr.timelineController = Ny, xr.cueHandler = c, xr.enableCEA708Captions = !0, xr.enableWebVTT = !0, xr.captionsTextTrack1Label = "English", xr.captionsTextTrack1LanguageCode = "en", xr.captionsTextTrack2Label = "Spanish", xr.captionsTextTrack2LanguageCode = "es", xr.audioStreamController = fy, xr.audioTrackController = ay;
                var xd = /* @__PURE__ */ function() {
                    function g(o, l) {
                        for(var s = 0; s < l.length; s++){
                            var u = l[s];
                            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
                        }
                    }
                    return function(o, l, s) {
                        return l && g(o.prototype, l), s && g(o, s), o;
                    };
                }();
                function Jy(g, o) {
                    if (!(g instanceof o)) throw new TypeError("Cannot call a class as a function");
                }
                var Qy = function() {
                    g.isSupported = function() {
                        return Xt();
                    }, xd(g, null, [
                        {
                            key: "version",
                            get: function() {
                                return "0.8.9";
                            }
                        },
                        {
                            key: "Events",
                            get: function() {
                                return p.a;
                            }
                        },
                        {
                            key: "ErrorTypes",
                            get: function() {
                                return y.b;
                            }
                        },
                        {
                            key: "ErrorDetails",
                            get: function() {
                                return y.a;
                            }
                        },
                        {
                            key: "DefaultConfig",
                            get: function() {
                                return g.defaultConfig ? g.defaultConfig : xr;
                            },
                            set: function(l) {
                                g.defaultConfig = l;
                            }
                        }
                    ]);
                    function g() {
                        var o = this, l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        Jy(this, g);
                        var s = g.DefaultConfig;
                        if ((l.liveSyncDurationCount || l.liveMaxLatencyDurationCount) && (l.liveSyncDuration || l.liveMaxLatencyDuration)) throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
                        for(var u in s)u in l || (l[u] = s[u]);
                        if (l.liveMaxLatencyDurationCount !== void 0 && l.liveMaxLatencyDurationCount <= l.liveSyncDurationCount) throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
                        if (l.liveMaxLatencyDuration !== void 0 && (l.liveMaxLatencyDuration <= l.liveSyncDuration || l.liveSyncDuration === void 0)) throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
                        Object(d.a)(l.debug), this.config = l, this._autoLevelCapping = -1;
                        var f = this.observer = new rr.a();
                        f.trigger = function(mt) {
                            for(var Ae = arguments.length, Ut = Array(Ae > 1 ? Ae - 1 : 0), ot = 1; ot < Ae; ot++)Ut[ot - 1] = arguments[ot];
                            f.emit.apply(f, [
                                mt,
                                mt
                            ].concat(Ut));
                        }, f.off = function(mt) {
                            for(var Ae = arguments.length, Ut = Array(Ae > 1 ? Ae - 1 : 0), ot = 1; ot < Ae; ot++)Ut[ot - 1] = arguments[ot];
                            f.removeListener.apply(f, [
                                mt
                            ].concat(Ut));
                        }, this.on = f.on.bind(f), this.off = f.off.bind(f), this.trigger = f.trigger.bind(f);
                        var E = this.abrController = new l.abrController(this), w = new l.bufferController(this), A = new l.capLevelController(this), S = new l.fpsController(this), k = new dt(this), B = new pt(this), U = new pr(this), F = new br(this), ee = this.levelController = new _t(this), he = this.streamController = new rt(this), ge = [
                            ee,
                            he
                        ], be = l.audioStreamController;
                        be && ge.push(new be(this)), this.networkControllers = ge;
                        var Se = [
                            k,
                            B,
                            U,
                            E,
                            w,
                            A,
                            S,
                            F
                        ];
                        if (be = l.audioTrackController, be) {
                            var Ce = new be(this);
                            this.audioTrackController = Ce, Se.push(Ce);
                        }
                        if (be = l.subtitleTrackController, be) {
                            var Ie = new be(this);
                            this.subtitleTrackController = Ie, Se.push(Ie);
                        }
                        [
                            l.subtitleStreamController,
                            l.timelineController
                        ].forEach(function(Ye) {
                            Ye && Se.push(new Ye(o));
                        }), this.coreComponents = Se;
                    }
                    return g.prototype.destroy = function() {
                        d.b.log("destroy"), this.trigger(p.a.DESTROYING), this.detachMedia(), this.coreComponents.concat(this.networkControllers).forEach(function(l) {
                            l.destroy();
                        }), this.url = null, this.observer.removeAllListeners(), this._autoLevelCapping = -1;
                    }, g.prototype.attachMedia = function(l) {
                        d.b.log("attachMedia"), this.media = l, this.trigger(p.a.MEDIA_ATTACHING, {
                            media: l
                        });
                    }, g.prototype.detachMedia = function() {
                        d.b.log("detachMedia"), this.trigger(p.a.MEDIA_DETACHING), this.media = null;
                    }, g.prototype.loadSource = function(l) {
                        l = m.a.buildAbsoluteURL(window.location.href, l, {
                            alwaysNormalize: !0
                        }), d.b.log("loadSource:" + l), this.url = l, this.trigger(p.a.MANIFEST_LOADING, {
                            url: l
                        });
                    }, g.prototype.startLoad = function() {
                        var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1;
                        d.b.log("startLoad(" + l + ")"), this.networkControllers.forEach(function(s) {
                            s.startLoad(l);
                        });
                    }, g.prototype.stopLoad = function() {
                        d.b.log("stopLoad"), this.networkControllers.forEach(function(l) {
                            l.stopLoad();
                        });
                    }, g.prototype.swapAudioCodec = function() {
                        d.b.log("swapAudioCodec"), this.streamController.swapAudioCodec();
                    }, g.prototype.recoverMediaError = function() {
                        d.b.log("recoverMediaError");
                        var l = this.media;
                        this.detachMedia(), this.attachMedia(l);
                    }, xd(g, [
                        {
                            key: "levels",
                            get: function() {
                                return this.levelController.levels;
                            }
                        },
                        {
                            key: "currentLevel",
                            get: function() {
                                return this.streamController.currentLevel;
                            },
                            set: function(l) {
                                d.b.log("set currentLevel:" + l), this.loadLevel = l, this.streamController.immediateLevelSwitch();
                            }
                        },
                        {
                            key: "nextLevel",
                            get: function() {
                                return this.streamController.nextLevel;
                            },
                            set: function(l) {
                                d.b.log("set nextLevel:" + l), this.levelController.manualLevel = l, this.streamController.nextLevelSwitch();
                            }
                        },
                        {
                            key: "loadLevel",
                            get: function() {
                                return this.levelController.level;
                            },
                            set: function(l) {
                                d.b.log("set loadLevel:" + l), this.levelController.manualLevel = l;
                            }
                        },
                        {
                            key: "nextLoadLevel",
                            get: function() {
                                return this.levelController.nextLoadLevel;
                            },
                            set: function(l) {
                                this.levelController.nextLoadLevel = l;
                            }
                        },
                        {
                            key: "firstLevel",
                            get: function() {
                                return Math.max(this.levelController.firstLevel, this.minAutoLevel);
                            },
                            set: function(l) {
                                d.b.log("set firstLevel:" + l), this.levelController.firstLevel = l;
                            }
                        },
                        {
                            key: "startLevel",
                            get: function() {
                                return this.levelController.startLevel;
                            },
                            set: function(l) {
                                d.b.log("set startLevel:" + l);
                                var s = this;
                                l !== -1 && (l = Math.max(l, s.minAutoLevel)), s.levelController.startLevel = l;
                            }
                        },
                        {
                            key: "autoLevelCapping",
                            get: function() {
                                return this._autoLevelCapping;
                            },
                            set: function(l) {
                                d.b.log("set autoLevelCapping:" + l), this._autoLevelCapping = l;
                            }
                        },
                        {
                            key: "autoLevelEnabled",
                            get: function() {
                                return this.levelController.manualLevel === -1;
                            }
                        },
                        {
                            key: "manualLevel",
                            get: function() {
                                return this.levelController.manualLevel;
                            }
                        },
                        {
                            key: "minAutoLevel",
                            get: function() {
                                for(var l = this, s = l.levels, u = l.config.minAutoBitrate, f = s ? s.length : 0, E = 0; E < f; E++){
                                    var w = s[E].realBitrate ? Math.max(s[E].realBitrate, s[E].bitrate) : s[E].bitrate;
                                    if (w > u) return E;
                                }
                                return 0;
                            }
                        },
                        {
                            key: "maxAutoLevel",
                            get: function() {
                                var l = this, s = l.levels, u = l.autoLevelCapping, f = void 0;
                                return u === -1 && s && s.length ? f = s.length - 1 : f = u, f;
                            }
                        },
                        {
                            key: "nextAutoLevel",
                            get: function() {
                                var l = this;
                                return Math.min(Math.max(l.abrController.nextAutoLevel, l.minAutoLevel), l.maxAutoLevel);
                            },
                            set: function(l) {
                                var s = this;
                                s.abrController.nextAutoLevel = Math.max(s.minAutoLevel, l);
                            }
                        },
                        {
                            key: "audioTracks",
                            get: function() {
                                var l = this.audioTrackController;
                                return l ? l.audioTracks : [];
                            }
                        },
                        {
                            key: "audioTrack",
                            get: function() {
                                var l = this.audioTrackController;
                                return l ? l.audioTrack : -1;
                            },
                            set: function(l) {
                                var s = this.audioTrackController;
                                s && (s.audioTrack = l);
                            }
                        },
                        {
                            key: "liveSyncPosition",
                            get: function() {
                                return this.streamController.liveSyncPosition;
                            }
                        },
                        {
                            key: "subtitleTracks",
                            get: function() {
                                var l = this.subtitleTrackController;
                                return l ? l.subtitleTracks : [];
                            }
                        },
                        {
                            key: "subtitleTrack",
                            get: function() {
                                var l = this.subtitleTrackController;
                                return l ? l.subtitleTrack : -1;
                            },
                            set: function(l) {
                                var s = this.subtitleTrackController;
                                s && (s.subtitleTrack = l);
                            }
                        },
                        {
                            key: "subtitleDisplay",
                            get: function() {
                                var l = this.subtitleTrackController;
                                return l ? l.subtitleDisplay : !1;
                            },
                            set: function(l) {
                                var s = this.subtitleTrackController;
                                s && (s.subtitleDisplay = l);
                            }
                        }
                    ]), g;
                }();
                i.default = Qy;
            },
            /* 9 */ /***/ function(r, i, a) {
                function c(y) {
                    var d = {};
                    function v(K) {
                        if (d[K]) return d[K].exports;
                        var O = d[K] = {
                            /******/ i: K,
                            /******/ l: !1,
                            /******/ exports: {}
                        };
                        return y[K].call(O.exports, O, O.exports, v), O.l = !0, O.exports;
                    }
                    v.m = y, v.c = d, v.i = function(K) {
                        return K;
                    }, v.d = function(K, O, Z) {
                        v.o(K, O) || Object.defineProperty(K, O, {
                            /******/ configurable: !1,
                            /******/ enumerable: !0,
                            /******/ get: Z
                        });
                    }, v.n = function(K) {
                        var O = K && K.__esModule ? /******/ function() {
                            return K.default;
                        } : /******/ function() {
                            return K;
                        };
                        return v.d(O, "a", O), O;
                    }, v.o = function(K, O) {
                        return Object.prototype.hasOwnProperty.call(K, O);
                    }, v.p = "/", v.oe = function(K) {
                        throw console.error(K), K;
                    };
                    var P = v(v.s = ENTRY_MODULE);
                    return P.default || P;
                }
                function h(y) {
                    return (y + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
                }
                function m(y) {
                    var d = [], v = y.toString(), P = v.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                    if (!P) return d;
                    for(var K = P[1], O = new RegExp("(\\\\n|\\W)" + h(K) + "\\((/\\*.*?\\*/)?s?.*?([\\.|\\-|\\w|/|@]+).*?\\)", "g"), Z; Z = O.exec(v);)d.push(Z[3]);
                    return d;
                }
                function p(y, d) {
                    for(var v = [
                        d
                    ], P = [], K = {}; v.length;){
                        var O = v.pop();
                        if (!(K[O] || !y[O])) {
                            K[O] = !0, P.push(O);
                            var Z = m(y[O]);
                            v = v.concat(Z);
                        }
                    }
                    return P;
                }
                r.exports = function(y, d) {
                    d = d || {};
                    var v = a.m, P = d.all ? Object.keys(v) : p(v, y), K = "(" + c.toString().replace("ENTRY_MODULE", JSON.stringify(y)) + ")({" + P.map(function(V) {
                        return "" + JSON.stringify(V) + ": " + v[V].toString();
                    }).join(",") + "})(self);", O = new window.Blob([
                        K
                    ], {
                        type: "text/javascript"
                    });
                    if (d.bare) return O;
                    var Z = window.URL || window.webkitURL || window.mozURL || window.msURL, Y = Z.createObjectURL(O), X = new window.Worker(Y);
                    return X.objectURL = Y, X;
                };
            },
            /* 10 */ /***/ function(r, i, a) {
                Object.defineProperty(i, "__esModule", {
                    value: !0
                });
                var c = a(7), h = a(1), m = a(0), p = a(5), y = a.n(p), d = function(P) {
                    var K = new y.a();
                    K.trigger = function(Y) {
                        for(var X = arguments.length, V = Array(X > 1 ? X - 1 : 0), q = 1; q < X; q++)V[q - 1] = arguments[q];
                        K.emit.apply(K, [
                            Y,
                            Y
                        ].concat(V));
                    }, K.off = function(Y) {
                        for(var X = arguments.length, V = Array(X > 1 ? X - 1 : 0), q = 1; q < X; q++)V[q - 1] = arguments[q];
                        K.removeListener.apply(K, [
                            Y
                        ].concat(V));
                    };
                    var O = function(Y, X) {
                        P.postMessage({
                            event: Y,
                            data: X
                        });
                    };
                    P.addEventListener("message", function(Z) {
                        var Y = Z.data;
                        switch(Y.cmd){
                            case "init":
                                var X = JSON.parse(Y.config);
                                P.demuxer = new c.a(K, Y.typeSupported, X, Y.vendor);
                                try {
                                    Object(m.a)(X.debug === !0);
                                } catch  {
                                    console.warn("demuxerWorker: unable to enable logs");
                                }
                                O("init", null);
                                break;
                            case "demux":
                                P.demuxer.push(Y.data, Y.decryptdata, Y.initSegment, Y.audioCodec, Y.videoCodec, Y.timeOffset, Y.discontinuity, Y.trackSwitch, Y.contiguous, Y.duration, Y.accurateTimeOffset, Y.defaultInitPTS);
                                break;
                        }
                    }), K.on(h.a.FRAG_DECRYPTED, O), K.on(h.a.FRAG_PARSING_INIT_SEGMENT, O), K.on(h.a.FRAG_PARSED, O), K.on(h.a.ERROR, O), K.on(h.a.FRAG_PARSING_METADATA, O), K.on(h.a.FRAG_PARSING_USERDATA, O), K.on(h.a.INIT_PTS_FOUND, O), K.on(h.a.FRAG_PARSING_DATA, function(Z, Y) {
                        var X = [], V = {
                            event: Z,
                            data: Y
                        };
                        Y.data1 && (V.data1 = Y.data1.buffer, X.push(Y.data1.buffer), delete Y.data1), Y.data2 && (V.data2 = Y.data2.buffer, X.push(Y.data2.buffer), delete Y.data2), P.postMessage(V, X);
                    });
                };
                i.default = d;
            }
        ]).default;
    });
})($aec35899a3c9695e$var$Xm);
var $aec35899a3c9695e$var$mK = $aec35899a3c9695e$var$Xm.exports;
const $aec35899a3c9695e$var$Ec = /* @__PURE__ */ $aec35899a3c9695e$var$Lb($aec35899a3c9695e$var$mK), $aec35899a3c9695e$var$Hm = ({ post: t, reason: e, isRoot: r })=>{
    if (t.$type === "app.bsky.embed.record#viewNotFound" || t.$type === "app.bsky.embed.record#viewBlocked") return null;
    if (t.$type === "app.bsky.graph.defs#listView") return {
        username: t.creator.displayName,
        handle: t.creator.handle,
        avatar: t.creator.avatar,
        text: [
            {
                val: t.description,
                setInnerHtml: !1
            }
        ],
        createdAt: t.indexedAt,
        uri: t.uri,
        images: [],
        card: null,
        replyPost: null,
        isRepost: !1,
        repostBy: null
    };
    const i = t.record.facets || [], a = t.record.text, c = new $aec35899a3c9695e$var$Bc.RichText({
        text: a,
        facets: i
    }), h = [];
    for (const d of c.segments())d.isLink() ? h.push({
        val: `<a href="${d.link?.uri}" target="_blank" rel="noopener" class="text-blue-500 underline">${d.text}</a>`,
        setInnerHtml: !0
    }) : d.isMention() ? h.push({
        val: `<a href="https://bsky.app/profile/${d.mention?.did}" target="_blank" rel="noopener" class="text-blue-500 underline">${d.text}</a>`,
        setInnerHtml: !0
    }) : d.isTag() ? h.push({
        val: `<a href="https://bsky.app/hashtag/${d.tag?.tag}" target="_blank" rel="noopener" class="text-blue-500 underline">${d.text}</a>`,
        setInnerHtml: !0
    }) : h.push({
        val: d.text,
        setInnerHtml: !1
    });
    const m = t.embed?.$type === "app.bsky.embed.record#view" ? t.embed.record : t.embed?.record?.record?.$type === "app.bsky.embed.record#viewRecord" && t.embed.record.record, p = m && {
        ...m,
        record: m.value || m.record,
        embed: (m?.embeds || [])[0]
    }, y = t.author || t.creator;
    return {
        username: y.displayName,
        handle: y.handle,
        avatar: y.avatar,
        // todo fallback
        text: h,
        createdAt: t.record.createdAt,
        uri: t.uri,
        images: [
            ...t.embed?.images || [],
            ...t.embed?.media?.images || [],
            ...[
                t.embed?.media?.external
            ].filter(Boolean).map((d)=>({
                    ...d,
                    alt: d.title,
                    thumb: d.uri
                }))
        ],
        video: t.embed?.$type === "app.bsky.embed.video#view" && t.embed,
        card: t.embed?.$type === "app.bsky.embed.external#view" && t.embed?.external,
        replyPost: r && p && $aec35899a3c9695e$var$Hm({
            post: p,
            reason: {
                $type: "",
                by: {
                    displayName: ""
                }
            },
            isRoot: !1
        }),
        isRepost: e?.$type === "app.bsky.feed.defs#reasonRepost",
        repostBy: e?.by?.displayName
    };
}, $aec35899a3c9695e$var$vc = (t)=>(t.feed || []).map((e)=>$aec35899a3c9695e$var$Hm({
            ...e,
            isRoot: !0
        })), $aec35899a3c9695e$var$Df = (t)=>{
    const e = t.lastIndexOf("/");
    return e !== -1 ? t.substring(e + 1) : t;
}, $aec35899a3c9695e$var$yK = (t)=>{
    const e = /* @__PURE__ */ new Date(), r = 60000, i = r * 60, a = i * 24, c = a * 30, h = a * 365, m = e.getTime() - t.getTime();
    return m < r ? Math.floor(m / 1e3) + "s" : m < i ? Math.floor(m / r) + "m" : m < a ? Math.floor(m / i) + "h" : m < c ? Math.floor(m / a) + "d" : m < h ? Math.floor(m / c) + " mo" : Math.floor(m / h) + " yr";
}, $aec35899a3c9695e$var$bK = async (t, e, r = !1)=>{
    if (!("IntersectionObserver" in window)) {
        console.error("IntersectionObserver not supported");
        return;
    }
    if (!e) {
        console.error("Video element not found");
        return;
    }
    const i = {
        root: null,
        // Viewport is the root by default
        threshold: 0.5
    }, a = async (h, m)=>{
        h.forEach((p)=>{
            if (p.isIntersecting) {
                if ($aec35899a3c9695e$var$Ec.isSupported()) {
                    var y = new $aec35899a3c9695e$var$Ec();
                    y.loadSource(t.playlist), y.attachMedia(e), y.on($aec35899a3c9695e$var$Ec.Events.MANIFEST_PARSED, ()=>{
                        r || e.play();
                    });
                } else e.canPlayType("application/vnd.apple.mpegurl") && (e.src = t.playlist, e.addEventListener("loadedmetadata", ()=>{
                    r || e.play();
                }));
                m.unobserve(e);
            }
        });
    };
    new IntersectionObserver(a, i).observe(e);
};
var $aec35899a3c9695e$var$gK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<article class="p-4 border-b border-slate-300 dark:border-slate-800"><div class="flex gap-2"><div class="w-full max-w-[calc(100%-70px)]"><div class="flex items-center"><a class="text-ellipsis overflow-hidden whitespace-nowrap hover:underline dark:text-white"><span class="font-bold dark:text-white"></span><span> </span><span class="text-slate-500 dark:text-slate-400 text-sm">@</span></a><span class="text-slate-500 dark:text-slate-400 text-sm"><span class=mx-1>\xb7</span><a class=hover:underline></a></span></div><p class="whitespace-pre-wrap dark:text-white">'), $aec35899a3c9695e$var$xK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<p class="flex gap-1 items-center ml-10 text-slate-600 dark:text-slate-400"><svg viewBox="0 0 576 512"height=16 width=16 tabindex=-1 class=mr-1><path fill=currentColor d="M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"></path></svg><span class="text-sm text-slate-500 font-semibold">Reposted by '), $aec35899a3c9695e$var$EK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<img alt="profile picture"class="w-14 h-14 rounded-full">'), $aec35899a3c9695e$var$vK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<img alt="profile picture"class="w-4 h-4 mr-1 rounded-full">'), $aec35899a3c9695e$var$Pf = /* @__PURE__ */ $aec35899a3c9695e$var$qt("<span>"), $aec35899a3c9695e$var$RK = /* @__PURE__ */ $aec35899a3c9695e$var$qt("<div>"), $aec35899a3c9695e$var$AK = /* @__PURE__ */ $aec35899a3c9695e$var$qt("<a><img class=rounded-md>"), $aec35899a3c9695e$var$_K = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<div class="mt-4 w-full"><video width=100% class="rounded-md w-full h-full object-cover"preload=none>'), $aec35899a3c9695e$var$wK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<a target=_blank rel=noopener class="mt-4 rounded-md border border-slate-300 block"><div class=p-3><p class="text-slate-500 dark:text-slate-400 text-sm"></p><p class="font-bold dark:text-white mb-1"></p><p class="whitespace-pre-wrap dark:text-white">'), $aec35899a3c9695e$var$TK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<img class=rounded-t-md alt="Post Thumbnail">'), $aec35899a3c9695e$var$SK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<a target=_blank rel=noopener class="mt-4 rounded-md border border-slate-300 block">');
const $aec35899a3c9695e$var$Zm = ({ linkTarget: t = "_self", post: e, handleModalContent: r, isCard: i = !1, dateFormat: a, disableImages: c, disableVideos: h, disableAutoplay: m })=>{
    let p;
    return $aec35899a3c9695e$var$hb(()=>{
        !h && e.video && e.video.cid && $aec35899a3c9695e$var$bK(e.video, p, m);
    }), (()=>{
        var y = $aec35899a3c9695e$var$gK(), d = y.firstChild, v = d.firstChild, P = v.firstChild, K = P.firstChild, O = K.firstChild, Z = O.nextSibling, Y = Z.nextSibling;
        Y.firstChild;
        var X = K.nextSibling, V = X.firstChild, q = V.nextSibling, re = P.nextSibling;
        return $aec35899a3c9695e$var$st(y, (()=>{
            var ne = $aec35899a3c9695e$var$Kr(()=>!!e.isRepost);
            return ()=>ne() && (()=>{
                    var fe = $aec35899a3c9695e$var$xK(), ye = fe.firstChild, xe = ye.nextSibling;
                    return xe.firstChild, $aec35899a3c9695e$var$st(xe, ()=>e.repostBy, null), fe;
                })();
        })(), d), $aec35899a3c9695e$var$st(d, !i && (()=>{
            var ne = $aec35899a3c9695e$var$EK();
            return $aec35899a3c9695e$var$Er(()=>$aec35899a3c9695e$var$kt(ne, "src", e.avatar)), ne;
        })(), v), $aec35899a3c9695e$var$st(P, i && (()=>{
            var ne = $aec35899a3c9695e$var$vK();
            return $aec35899a3c9695e$var$Er(()=>$aec35899a3c9695e$var$kt(ne, "src", e.avatar)), ne;
        })(), K), $aec35899a3c9695e$var$kt(K, "target", t), $aec35899a3c9695e$var$kt(K, "rel", t === "_blank" ? "noopeener" : ""), $aec35899a3c9695e$var$st(O, ()=>e.username), $aec35899a3c9695e$var$st(Y, ()=>e.handle, null), $aec35899a3c9695e$var$kt(q, "target", t), $aec35899a3c9695e$var$kt(q, "rel", t === "_blank" ? "noopeener" : ""), $aec35899a3c9695e$var$st(q, (()=>{
            var ne = $aec35899a3c9695e$var$Kr(()=>!!(a && a.type === "absolute"));
            return ()=>ne() ? new Date(e.createdAt).toLocaleDateString(a.locale, a.options) : $aec35899a3c9695e$var$yK(new Date(e.createdAt));
        })()), $aec35899a3c9695e$var$st(re, ()=>e.text.map((ne)=>ne.setInnerHtml ? (()=>{
                    var fe = $aec35899a3c9695e$var$Pf();
                    return $aec35899a3c9695e$var$Er(()=>fe.innerHTML = ne.val), fe;
                })() : (()=>{
                    var fe = $aec35899a3c9695e$var$Pf();
                    return $aec35899a3c9695e$var$st(fe, ()=>ne.val), fe;
                })())), $aec35899a3c9695e$var$st(v, (()=>{
            var ne = $aec35899a3c9695e$var$Kr(()=>!c && e.images.length > 0);
            return ()=>ne() && (()=>{
                    var fe = $aec35899a3c9695e$var$RK();
                    return $aec35899a3c9695e$var$st(fe, ()=>e.images.map((ye)=>(()=>{
                                var xe = $aec35899a3c9695e$var$AK(), De = xe.firstChild;
                                return xe.$$click = (Be)=>r(Be, ye), $aec35899a3c9695e$var$kt(xe, "target", t), $aec35899a3c9695e$var$kt(xe, "rel", t === "_blank" ? "noopeener" : ""), $aec35899a3c9695e$var$Er((Be)=>{
                                    var Oe = `https://bsky.app/profile/${e.handle}/post/${$aec35899a3c9695e$var$Df(e.uri)}`, we = ye.thumb, Fe = ye.alt;
                                    return Oe !== Be.e && $aec35899a3c9695e$var$kt(xe, "href", Be.e = Oe), we !== Be.t && $aec35899a3c9695e$var$kt(De, "src", Be.t = we), Fe !== Be.a && $aec35899a3c9695e$var$kt(De, "alt", Be.a = Fe), Be;
                                }, {
                                    e: void 0,
                                    t: void 0,
                                    a: void 0
                                }), xe;
                            })())), $aec35899a3c9695e$var$Er(()=>$aec35899a3c9695e$var$zf(fe, e.images.length > 1 ? "mt-4 grid grid-cols-2 gap-2" : "mt-4")), fe;
                })();
        })(), null), $aec35899a3c9695e$var$st(v, (()=>{
            var ne = $aec35899a3c9695e$var$Kr(()=>!!(!h && e.video));
            return ()=>ne() && (()=>{
                    var fe = $aec35899a3c9695e$var$_K(), ye = fe.firstChild, xe = p;
                    return typeof xe == "function" ? $aec35899a3c9695e$var$Ac(xe, ye) : p = ye, ye.autoplay = !1, ye.controls = !0, ye.muted = !0, $aec35899a3c9695e$var$Er(()=>$aec35899a3c9695e$var$kt(ye, "poster", e.video.thumbnail)), fe;
                })();
        })(), null), $aec35899a3c9695e$var$st(v, (()=>{
            var ne = $aec35899a3c9695e$var$Kr(()=>!!e.card);
            return ()=>ne() && (()=>{
                    var fe = $aec35899a3c9695e$var$wK(), ye = fe.firstChild, xe = ye.firstChild, De = xe.nextSibling, Be = De.nextSibling;
                    return $aec35899a3c9695e$var$st(fe, (()=>{
                        var Oe = $aec35899a3c9695e$var$Kr(()=>!!(e.card.thumb && !c));
                        return ()=>Oe() && (()=>{
                                var we = $aec35899a3c9695e$var$TK();
                                return $aec35899a3c9695e$var$Er(()=>$aec35899a3c9695e$var$kt(we, "src", e.card.thumb)), we;
                            })();
                    })(), ye), $aec35899a3c9695e$var$st(xe, ()=>new URL(e.card.uri).hostname), $aec35899a3c9695e$var$st(De, ()=>e.card.title), $aec35899a3c9695e$var$st(Be, ()=>e.card.description), $aec35899a3c9695e$var$Er(()=>$aec35899a3c9695e$var$kt(fe, "href", e.card.uri)), fe;
                })();
        })(), null), $aec35899a3c9695e$var$st(v, (()=>{
            var ne = $aec35899a3c9695e$var$Kr(()=>!!e.replyPost);
            return ()=>ne() && (()=>{
                    var fe = $aec35899a3c9695e$var$SK();
                    return $aec35899a3c9695e$var$st(fe, $aec35899a3c9695e$var$Gf($aec35899a3c9695e$var$Zm, $aec35899a3c9695e$var$vb({
                        linkTarget: t,
                        handleModalContent: r,
                        disableImages: c,
                        disableVideos: h,
                        disableAutoplay: m
                    }, {
                        get post () {
                            return e.replyPost;
                        },
                        isCard: !0
                    }))), $aec35899a3c9695e$var$Er(()=>$aec35899a3c9695e$var$kt(fe, "href", e.card.uri)), fe;
                })();
        })(), null), $aec35899a3c9695e$var$Er((ne)=>{
            var fe = `https://bsky.app/profile/${e.handle}`, ye = `https://bsky.app/profile/${e.handle}/post/${$aec35899a3c9695e$var$Df(e.uri)}`;
            return fe !== ne.e && $aec35899a3c9695e$var$kt(K, "href", ne.e = fe), ye !== ne.t && $aec35899a3c9695e$var$kt(q, "href", ne.t = ye), ne;
        }, {
            e: void 0,
            t: void 0
        }), y;
    })();
};
$aec35899a3c9695e$var$qf([
    "click"
]);
var $aec35899a3c9695e$var$CK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<section><dialog class="backdrop:bg-gray-800 backdrop:opacity-90"><form class="fixed top-5 right-5"><button type=submit aria-label=close formmethod=dialog formnovalidate class="bg-gray-900 rounded-full w-10 h-10 text-white flex items-center justify-center">X</button></form><img src=""alt=""class=max-h-[90vh]>'), $aec35899a3c9695e$var$Bf = /* @__PURE__ */ $aec35899a3c9695e$var$qt("<style>"), $aec35899a3c9695e$var$LK = /* @__PURE__ */ $aec35899a3c9695e$var$qt("<link rel=stylesheet>"), $aec35899a3c9695e$var$kK = /* @__PURE__ */ $aec35899a3c9695e$var$qt("<div class=w-full>"), $aec35899a3c9695e$var$DK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<article class="w-full flex gap-2 p-4 border-b border-slate-300 dark:border-slate-800 animate-pulse"><div class="bg-slate-200 w-14 h-14 rounded-full dark:bg-slate-800"></div><div class="flex-1 space-y-2 py-1"><div class="grid grid-cols-4 gap-4"><div class="h-2 bg-slate-200 rounded col-span-2 dark:bg-slate-800"></div></div><div class="h-2 bg-slate-200 rounded dark:bg-slate-800"></div><div class="h-2 bg-slate-200 rounded dark:bg-slate-800"></div><div class="h-2 bg-slate-200 rounded dark:bg-slate-800">'), $aec35899a3c9695e$var$PK = /* @__PURE__ */ $aec35899a3c9695e$var$qt('<div class="mt-8 mb-16"><button id=bsky-load-more class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Load More Posts');
const $aec35899a3c9695e$var$BK = ({ username: t, feed: e, limit: r = 10, mode: i = "", linkTarget: a = "_self", linkImage: c = !1, customStyles: h = "", customStylesFile: m, disableStyles: p = !1, search: y, loadMore: d = !1, dateFormat: v, disableImages: P = !1, disableVideos: K = !1, disableAutoplay: O = !1 })=>{
    let Z = null, Y = null;
    const [X, V] = $aec35899a3c9695e$var$ia(!1), [q, re] = $aec35899a3c9695e$var$ia([]), [ne] = $aec35899a3c9695e$var$ia(r), [fe, ye] = $aec35899a3c9695e$var$ia(void 0);
    $aec35899a3c9695e$var$Mf(()=>{
        V(!0), xe();
    }, [
        t,
        e,
        y,
        ne
    ]);
    const xe = async (we)=>{
        t ? $aec35899a3c9695e$var$xc.app.bsky.feed.getAuthorFeed({
            limit: ne(),
            actor: t,
            filter: "posts_no_replies",
            cursor: we
        }).then(({ success: Fe, data: Xe })=>{
            if (Fe) {
                const ct = $aec35899a3c9695e$var$vc(Xe);
                Oe(ct), V(!1), ye(Xe.cursor);
            }
        }) : e ? $aec35899a3c9695e$var$xc.app.bsky.feed.getFeed({
            limit: ne(),
            feed: e,
            cursor: we
        }).then(({ success: Fe, data: Xe })=>{
            if (Fe) {
                const ct = $aec35899a3c9695e$var$vc(Xe);
                Oe(ct), V(!1), ye(Xe.cursor);
            }
        }) : y && $aec35899a3c9695e$var$xc.app.bsky.feed.searchPosts({
            limit: ne(),
            q: y,
            cursor: we
        }).then(({ success: Fe, data: Xe })=>{
            if (Fe) {
                const ct = {
                    ...Xe,
                    feed: Xe.posts.map((tt)=>({
                            post: tt
                        }))
                }, Ge = $aec35899a3c9695e$var$vc(ct);
                Oe(Ge), V(!1), ye(Xe.cursor);
            }
        });
    }, De = (we, Fe)=>{
        !c && Z && Y && (we.preventDefault(), Y.src = Fe.fullsize, Y.alt = Fe.alt, Z.showModal());
    }, Be = ()=>{
        V(!0), xe(fe());
    }, Oe = (we)=>{
        const Fe = [
            ...q(),
            ...we
        ];
        re(Fe);
    };
    return [
        !p && (()=>{
            var we = $aec35899a3c9695e$var$Bf();
            return $aec35899a3c9695e$var$st(we, $aec35899a3c9695e$var$Cb), we;
        })(),
        h && (()=>{
            var we = $aec35899a3c9695e$var$Bf();
            return $aec35899a3c9695e$var$st(we, h), we;
        })(),
        m && (()=>{
            var we = $aec35899a3c9695e$var$LK();
            return $aec35899a3c9695e$var$kt(we, "href", m), we;
        })(),
        (()=>{
            var we = $aec35899a3c9695e$var$CK(), Fe = we.firstChild, Xe = Fe.firstChild, ct = Xe.nextSibling;
            return $aec35899a3c9695e$var$zf(we, `${i} max-w-screen-sm mx-auto flex flex-col items-center`), $aec35899a3c9695e$var$st(we, (()=>{
                var Ge = $aec35899a3c9695e$var$Kr(()=>q().length > 0);
                return ()=>Ge() && q().map((tt, Rt)=>(()=>{
                            var dt = $aec35899a3c9695e$var$kK();
                            return $aec35899a3c9695e$var$kt(dt, "id", `post-${Rt}`), $aec35899a3c9695e$var$st(dt, $aec35899a3c9695e$var$Gf($aec35899a3c9695e$var$Zm, {
                                post: tt,
                                handleModalContent: De,
                                linkTarget: a,
                                dateFormat: v,
                                disableImages: P,
                                disableVideos: K,
                                disableAutoplay: O
                            })), dt;
                        })());
            })(), Fe), $aec35899a3c9695e$var$st(we, (()=>{
                var Ge = $aec35899a3c9695e$var$Kr(()=>!!X());
                return ()=>Ge() && Array.from(Array(r)).map(()=>$aec35899a3c9695e$var$DK());
            })(), Fe), $aec35899a3c9695e$var$Ac((Ge)=>Z = Ge, Fe), $aec35899a3c9695e$var$Ac((Ge)=>Y = Ge, ct), $aec35899a3c9695e$var$st(we, (()=>{
                var Ge = $aec35899a3c9695e$var$Kr(()=>!!(d && fe()));
                return ()=>Ge() && (()=>{
                        var tt = $aec35899a3c9695e$var$PK(), Rt = tt.firstChild;
                        return Rt.$$click = Be, tt;
                    })();
            })(), null), we;
        })()
    ];
};
$aec35899a3c9695e$var$qf([
    "click"
]);
$aec35899a3c9695e$var$Sb("bsky-embed", {
    username: "",
    feed: "",
    limit: 10,
    mode: "",
    linkTarget: "_self",
    linkImage: !1,
    customStyles: "",
    customStylesFile: "",
    disableStyles: !1,
    search: "",
    loadMore: !1,
    disableAutoplay: !1,
    disableImages: !1,
    disableVideos: !1,
    dateFormat: {}
}, $aec35899a3c9695e$var$BK);


const $54b47fc030b7b21e$var$menu = new (0, $e9dd36436aec3b21$export$591ca0244c9dfcd4)(document.getElementById('Menu'));
const $54b47fc030b7b21e$var$navButtons = document.querySelectorAll('#nav-buttons button');
console.log($54b47fc030b7b21e$var$navButtons);
function $54b47fc030b7b21e$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
$54b47fc030b7b21e$var$navButtons.forEach((button)=>{
    button.addEventListener('click', async ()=>{
        await $54b47fc030b7b21e$var$menu.hide();
        await $54b47fc030b7b21e$var$sleep(300); // Wait for the menu to close
        const targetId = button.dataset.nav;
        const targetSection = document.getElementById(targetId);
        if (targetSection) targetSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
});


//# sourceMappingURL=peoplesoutreach.org.bab92e9c.js.map
